// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: `${string}://${string}` | (string & {});
};

/**
 * A2aAgentCardV1
 */
export type A2aAgentCardV1 = {
  name: SanitizedStr;
  description: SanitizedStr | null;
  iconUrl: SanitizedStr | null;
  /**
   * Version
   */
  version: "1.0";
  /**
   * Supportedinterfaces
   */
  supportedInterfaces: Array<A2aAgentInterfaceV1>;
  capabilities: A2aCurrentCapabilitiesV1;
  /**
   * Securityschemes
   */
  securitySchemes: {
    [key in SanitizedStr]?: A2aSecuritySchemeV1;
  };
  /**
   * Securityrequirements
   */
  securityRequirements: Array<A2aSecurityRequirementV1>;
  /**
   * Skills
   */
  skills: Array<A2aSkillV1>;
  /**
   * Defaultinputmodes
   */
  defaultInputModes: Array<SanitizedStr>;
  /**
   * Defaultoutputmodes
   */
  defaultOutputModes: Array<SanitizedStr>;
};

/**
 * A2aAgentInterfaceV1
 */
export type A2aAgentInterfaceV1 = {
  url: SanitizedStr;
  protocolBinding: SanitizedStr;
  protocolVersion: SanitizedStr;
};

/**
 * A2aAgentV1
 */
export type A2aAgentV1 = {
  /**
   * Key
   */
  key: string;
  /**
   * Name
   */
  name: string;
  agent_card_url: NonEmptyStr;
};

/**
 * A2aAuthorizationCodeOAuthFlowV1
 */
export type A2aAuthorizationCodeOAuthFlowV1 = {
  authorizationUrl: SanitizedStr;
  tokenUrl: SanitizedStr;
  refreshUrl: SanitizedStr | null;
  /**
   * Scopes
   */
  scopes: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Pkcerequired
   */
  pkceRequired: boolean;
};

/**
 * A2aCapabilitiesV1
 */
export type A2aCapabilitiesV1 = {
  /**
   * Streaming
   */
  streaming: boolean;
  /**
   * Pushnotifications
   */
  pushNotifications: boolean;
  /**
   * Statetransitionhistory
   */
  stateTransitionHistory: boolean;
};

/**
 * A2aConfigV1
 */
export type A2aConfigV1 = {
  /**
   * Name
   */
  name: string | null;
  /**
   * Description
   */
  description: string | null;
  /**
   * Icon Url
   */
  icon_url: string | null;
  /**
   * Skills
   */
  skills: Array<A2aSkillV1> | null;
};

/**
 * A2aCurrentCapabilitiesV1
 */
export type A2aCurrentCapabilitiesV1 = {
  /**
   * Streaming
   */
  streaming: boolean;
  /**
   * Pushnotifications
   */
  pushNotifications: boolean;
  /**
   * Extendedagentcard
   */
  extendedAgentCard: boolean;
};

/**
 * A2aLegacyAgentCardV1
 */
export type A2aLegacyAgentCardV1 = {
  name: SanitizedStr;
  description: SanitizedStr | null;
  url: SanitizedStr;
  iconUrl: SanitizedStr | null;
  /**
   * Version
   */
  version: "1.0";
  /**
   * Protocolversion
   */
  protocolVersion: "0.3";
  /**
   * Preferredtransport
   */
  preferredTransport: "JSONRPC";
  /**
   * Supportsauthenticatedextendedcard
   */
  supportsAuthenticatedExtendedCard: boolean;
  capabilities: A2aCapabilitiesV1;
  /**
   * Securityschemes
   */
  securitySchemes: {
    [key in SanitizedStr]?: A2aLegacyOAuth2SecuritySchemeV1;
  };
  /**
   * Security
   */
  security: Array<{
    [key in SanitizedStr]?: Array<SanitizedStr>;
  }>;
  /**
   * Skills
   */
  skills: Array<A2aSkillV1>;
  /**
   * Defaultinputmodes
   */
  defaultInputModes: Array<SanitizedStr>;
  /**
   * Defaultoutputmodes
   */
  defaultOutputModes: Array<SanitizedStr>;
};

/**
 * A2aLegacyOAuth2SecuritySchemeV1
 */
export type A2aLegacyOAuth2SecuritySchemeV1 = {
  /**
   * Type
   */
  type: "oauth2";
  description: SanitizedStr | null;
  flows: A2aOAuthFlowsV1;
  oauth2MetadataUrl: SanitizedStr;
};

/**
 * A2aOAuth2SecuritySchemeV1
 */
export type A2aOAuth2SecuritySchemeV1 = {
  description: SanitizedStr | null;
  flows: A2aOAuthFlowsV1;
  oauth2MetadataUrl: SanitizedStr;
};

/**
 * A2aOAuthFlowsV1
 */
export type A2aOAuthFlowsV1 = {
  authorizationCode: A2aAuthorizationCodeOAuthFlowV1;
};

/**
 * A2aSecurityRequirementV1
 */
export type A2aSecurityRequirementV1 = {
  /**
   * Schemes
   */
  schemes: {
    [key in SanitizedStr]?: A2aStringListV1;
  };
};

/**
 * A2aSecuritySchemeV1
 */
export type A2aSecuritySchemeV1 = {
  oauth2SecurityScheme: A2aOAuth2SecuritySchemeV1;
};

/**
 * A2aSkillV1
 */
export type A2aSkillV1 = {
  id: SanitizedStr;
  name: SanitizedStr;
  description: SanitizedStr | null;
  /**
   * Tags
   */
  tags: Array<SanitizedStr>;
  /**
   * Examples
   */
  examples: Array<SanitizedStr>;
  /**
   * Inputmodes
   */
  inputModes: Array<SanitizedStr>;
  /**
   * Outputmodes
   */
  outputModes: Array<SanitizedStr>;
};

/**
 * A2aStringListV1
 */
export type A2aStringListV1 = {
  /**
   * List
   */
  list: Array<SanitizedStr>;
};

/**
 * AddConfluenceCommentParamsV1
 */
export type AddConfluenceCommentParamsV1 = {
  /**
   * Body
   */
  body: Array<ConfluenceAdfV1>;
};

/**
 * AddSecretVersionParamsV1
 */
export type AddSecretVersionParamsV1 = {
  /**
   * Value
   */
  value: string;
  /**
   * Description
   */
  description: string;
};

/**
 * AddSecretVersionParamsV2
 */
export type AddSecretVersionParamsV2 = {
  /**
   * Description
   */
  description: string;
  /**
   * Value
   */
  value:
    | ({
        kind: "GENERIC";
      } & GenericSecretValueParamsV1)
    | ({
        kind: "API_KEY";
      } & ApiKeySecretValueParamsV1)
    | ({
        kind: "OAUTH";
      } & OauthSecretValueParamsV1);
};

/**
 * AdfBlockquoteNodeV1
 */
export type AdfBlockquoteNodeV1Input = {
  /**
   * Kind
   */
  kind: "blockquote";
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Input>;
};

/**
 * AdfBlockquoteNodeV1
 */
export type AdfBlockquoteNodeV1Output = {
  /**
   * Kind
   */
  kind: "blockquote";
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Output>;
};

/**
 * AdfBorderMarkAttrsV1
 */
export type AdfBorderMarkAttrsV1 = {
  /**
   * Size
   */
  size: number;
  /**
   * Color
   */
  color: string;
};

/**
 * AdfBorderMarkV1
 */
export type AdfBorderMarkV1 = {
  /**
   * Kind
   */
  kind: "border";
  attrs: AdfBorderMarkAttrsV1;
};

/**
 * AdfBulletListNodeV1
 */
export type AdfBulletListNodeV1Input = {
  /**
   * Kind
   */
  kind: "bulletList";
  /**
   * Content
   */
  content?: Array<AdfListItemNodeV1Input>;
};

/**
 * AdfBulletListNodeV1
 */
export type AdfBulletListNodeV1Output = {
  /**
   * Kind
   */
  kind: "bulletList";
  /**
   * Content
   */
  content?: Array<AdfListItemNodeV1Output>;
};

/**
 * AdfCodeBlockAttrsV1
 */
export type AdfCodeBlockAttrsV1 = {
  /**
   * Language
   */
  language?: string | null;
};

/**
 * AdfCodeBlockNodeV1
 */
export type AdfCodeBlockNodeV1Input = {
  /**
   * Kind
   */
  kind: "codeBlock";
  attrs?: AdfCodeBlockAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<AdfInlineNodeV1Input>;
};

/**
 * AdfCodeBlockNodeV1
 */
export type AdfCodeBlockNodeV1Output = {
  /**
   * Kind
   */
  kind: "codeBlock";
  attrs?: AdfCodeBlockAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<AdfInlineNodeV1Output>;
};

/**
 * AdfCodeMarkV1
 */
export type AdfCodeMarkV1 = {
  /**
   * Kind
   */
  kind: "code";
};

/**
 * AdfDateAttrsV1
 */
export type AdfDateAttrsV1 = {
  /**
   * Timestamp
   */
  timestamp: string;
};

/**
 * AdfDateNodeV1
 */
export type AdfDateNodeV1 = {
  /**
   * Kind
   */
  kind: "date";
  attrs: AdfDateAttrsV1;
};

/**
 * AdfEmMarkV1
 */
export type AdfEmMarkV1 = {
  /**
   * Kind
   */
  kind: "em";
};

/**
 * AdfEmojiAttrsV1
 */
export type AdfEmojiAttrsV1 = {
  /**
   * Shortname
   */
  shortName: string;
  /**
   * Id
   */
  id?: string | null;
  /**
   * Text
   */
  text?: string | null;
};

/**
 * AdfEmojiNodeV1
 */
export type AdfEmojiNodeV1 = {
  /**
   * Kind
   */
  kind: "emoji";
  attrs: AdfEmojiAttrsV1;
};

/**
 * AdfExpandAttrsV1
 */
export type AdfExpandAttrsV1 = {
  /**
   * Title
   */
  title?: string | null;
};

/**
 * AdfExpandNodeV1
 */
export type AdfExpandNodeV1Input = {
  /**
   * Kind
   */
  kind: "expand";
  attrs?: AdfExpandAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Input>;
};

/**
 * AdfExpandNodeV1
 */
export type AdfExpandNodeV1Output = {
  /**
   * Kind
   */
  kind: "expand";
  attrs?: AdfExpandAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Output>;
};

/**
 * AdfHardBreakNodeV1
 */
export type AdfHardBreakNodeV1 = {
  /**
   * Kind
   */
  kind: "hardBreak";
};

/**
 * AdfHeadingAttrsV1
 */
export type AdfHeadingAttrsV1 = {
  /**
   * Level
   */
  level: number;
};

/**
 * AdfHeadingNodeV1
 */
export type AdfHeadingNodeV1Input = {
  /**
   * Kind
   */
  kind: "heading";
  attrs: AdfHeadingAttrsV1;
  /**
   * Content
   */
  content?: Array<AdfInlineNodeV1Input>;
};

/**
 * AdfHeadingNodeV1
 */
export type AdfHeadingNodeV1Output = {
  /**
   * Kind
   */
  kind: "heading";
  attrs: AdfHeadingAttrsV1;
  /**
   * Content
   */
  content?: Array<AdfInlineNodeV1Output>;
};

/**
 * AdfInlineCardAttrsV1
 */
export type AdfInlineCardAttrsV1Input = {
  /**
   * Url
   */
  url?: string | null;
  data?: JsonInput | null;
};

/**
 * AdfInlineCardAttrsV1
 */
export type AdfInlineCardAttrsV1Output = {
  /**
   * Url
   */
  url?: string | null;
  data?: JsonOutput | null;
};

/**
 * AdfInlineCardNodeV1
 */
export type AdfInlineCardNodeV1Input = {
  /**
   * Kind
   */
  kind: "inlineCard";
  attrs: AdfInlineCardAttrsV1Input;
};

/**
 * AdfInlineCardNodeV1
 */
export type AdfInlineCardNodeV1Output = {
  /**
   * Kind
   */
  kind: "inlineCard";
  attrs: AdfInlineCardAttrsV1Output;
};

export type AdfInlineNodeV1Input = AdfKnownInlineNodeV1Input | AdfUnknownNodeV1;

export type AdfInlineNodeV1Output =
  | AdfKnownInlineNodeV1Output
  | AdfUnknownNodeV1;

export type AdfKnownInlineNodeV1Input =
  | ({
      kind: "text";
    } & AdfTextNodeV1)
  | ({
      kind: "hardBreak";
    } & AdfHardBreakNodeV1)
  | ({
      kind: "mention";
    } & AdfMentionNodeV1)
  | ({
      kind: "emoji";
    } & AdfEmojiNodeV1)
  | ({
      kind: "date";
    } & AdfDateNodeV1)
  | ({
      kind: "status";
    } & AdfStatusNodeV1)
  | ({
      kind: "inlineCard";
    } & AdfInlineCardNodeV1Input)
  | ({
      kind: "mediaInline";
    } & AdfMediaInlineNodeV1);

export type AdfKnownInlineNodeV1Output =
  | ({
      kind: "text";
    } & AdfTextNodeV1)
  | ({
      kind: "hardBreak";
    } & AdfHardBreakNodeV1)
  | ({
      kind: "mention";
    } & AdfMentionNodeV1)
  | ({
      kind: "emoji";
    } & AdfEmojiNodeV1)
  | ({
      kind: "date";
    } & AdfDateNodeV1)
  | ({
      kind: "status";
    } & AdfStatusNodeV1)
  | ({
      kind: "inlineCard";
    } & AdfInlineCardNodeV1Output)
  | ({
      kind: "mediaInline";
    } & AdfMediaInlineNodeV1);

export type AdfKnownMarkV1 =
  | ({
      kind: "link";
    } & AdfLinkMarkV1)
  | ({
      kind: "em";
    } & AdfEmMarkV1)
  | ({
      kind: "strong";
    } & AdfStrongMarkV1)
  | ({
      kind: "code";
    } & AdfCodeMarkV1)
  | ({
      kind: "strike";
    } & AdfStrikeMarkV1)
  | ({
      kind: "subsup";
    } & AdfSubsupMarkV1)
  | ({
      kind: "underline";
    } & AdfUnderlineMarkV1)
  | ({
      kind: "textColor";
    } & AdfTextColorMarkV1)
  | ({
      kind: "border";
    } & AdfBorderMarkV1);

export type AdfKnownReadNodeV1Input =
  | ({
      kind: "paragraph";
    } & AdfParagraphNodeV1Input)
  | ({
      kind: "heading";
    } & AdfHeadingNodeV1Input)
  | ({
      kind: "blockquote";
    } & AdfBlockquoteNodeV1Input)
  | ({
      kind: "bulletList";
    } & AdfBulletListNodeV1Input)
  | ({
      kind: "orderedList";
    } & AdfOrderedListNodeV1Input)
  | ({
      kind: "listItem";
    } & AdfListItemNodeV1Input)
  | ({
      kind: "codeBlock";
    } & AdfCodeBlockNodeV1Input)
  | ({
      kind: "panel";
    } & AdfPanelNodeV1Input)
  | ({
      kind: "expand";
    } & AdfExpandNodeV1Input)
  | ({
      kind: "nestedExpand";
    } & AdfNestedExpandNodeV1Input)
  | ({
      kind: "rule";
    } & AdfRuleNodeV1)
  | ({
      kind: "table";
    } & AdfTableNodeV1Input)
  | ({
      kind: "tableRow";
    } & AdfTableRowNodeV1Input)
  | ({
      kind: "tableCell";
    } & AdfTableCellNodeV1Input)
  | ({
      kind: "tableHeader";
    } & AdfTableHeaderNodeV1Input)
  | ({
      kind: "mediaSingle";
    } & AdfMediaSingleNodeV1)
  | ({
      kind: "mediaGroup";
    } & AdfMediaGroupNodeV1)
  | ({
      kind: "media";
    } & AdfMediaNodeV1);

export type AdfKnownReadNodeV1Output =
  | ({
      kind: "paragraph";
    } & AdfParagraphNodeV1Output)
  | ({
      kind: "heading";
    } & AdfHeadingNodeV1Output)
  | ({
      kind: "blockquote";
    } & AdfBlockquoteNodeV1Output)
  | ({
      kind: "bulletList";
    } & AdfBulletListNodeV1Output)
  | ({
      kind: "orderedList";
    } & AdfOrderedListNodeV1Output)
  | ({
      kind: "listItem";
    } & AdfListItemNodeV1Output)
  | ({
      kind: "codeBlock";
    } & AdfCodeBlockNodeV1Output)
  | ({
      kind: "panel";
    } & AdfPanelNodeV1Output)
  | ({
      kind: "expand";
    } & AdfExpandNodeV1Output)
  | ({
      kind: "nestedExpand";
    } & AdfNestedExpandNodeV1Output)
  | ({
      kind: "rule";
    } & AdfRuleNodeV1)
  | ({
      kind: "table";
    } & AdfTableNodeV1Output)
  | ({
      kind: "tableRow";
    } & AdfTableRowNodeV1Output)
  | ({
      kind: "tableCell";
    } & AdfTableCellNodeV1Output)
  | ({
      kind: "tableHeader";
    } & AdfTableHeaderNodeV1Output)
  | ({
      kind: "mediaSingle";
    } & AdfMediaSingleNodeV1)
  | ({
      kind: "mediaGroup";
    } & AdfMediaGroupNodeV1)
  | ({
      kind: "media";
    } & AdfMediaNodeV1);

export type AdfKnownTableCellV1Input =
  | ({
      kind: "tableCell";
    } & AdfTableCellNodeV1Input)
  | ({
      kind: "tableHeader";
    } & AdfTableHeaderNodeV1Input);

export type AdfKnownTableCellV1Output =
  | ({
      kind: "tableCell";
    } & AdfTableCellNodeV1Output)
  | ({
      kind: "tableHeader";
    } & AdfTableHeaderNodeV1Output);

/**
 * AdfLinkMarkAttrsV1
 */
export type AdfLinkMarkAttrsV1 = {
  /**
   * Href
   */
  href: string;
  /**
   * Title
   */
  title?: string | null;
};

/**
 * AdfLinkMarkV1
 */
export type AdfLinkMarkV1 = {
  /**
   * Kind
   */
  kind: "link";
  attrs: AdfLinkMarkAttrsV1;
};

/**
 * AdfListItemNodeV1
 */
export type AdfListItemNodeV1Input = {
  /**
   * Kind
   */
  kind: "listItem";
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Input>;
};

/**
 * AdfListItemNodeV1
 */
export type AdfListItemNodeV1Output = {
  /**
   * Kind
   */
  kind: "listItem";
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Output>;
};

export type AdfMarkV1 = AdfKnownMarkV1 | AdfUnknownMarkV1;

/**
 * AdfMediaAttrsV1
 */
export type AdfMediaAttrsV1 = {
  /**
   * Type
   */
  type: string;
  /**
   * Id
   */
  id?: string | null;
  /**
   * Collection
   */
  collection?: string | null;
  /**
   * Width
   */
  width?: number | null;
  /**
   * Height
   */
  height?: number | null;
  /**
   * Url
   */
  url?: string | null;
  /**
   * Alt
   */
  alt?: string | null;
};

/**
 * AdfMediaGroupNodeV1
 */
export type AdfMediaGroupNodeV1 = {
  /**
   * Kind
   */
  kind: "mediaGroup";
  /**
   * Content
   */
  content?: Array<AdfMediaNodeV1>;
};

/**
 * AdfMediaInlineNodeV1
 */
export type AdfMediaInlineNodeV1 = {
  /**
   * Kind
   */
  kind: "mediaInline";
  attrs: AdfMediaAttrsV1;
};

/**
 * AdfMediaNodeV1
 */
export type AdfMediaNodeV1 = {
  /**
   * Kind
   */
  kind: "media";
  attrs: AdfMediaAttrsV1;
};

/**
 * AdfMediaSingleAttrsV1
 */
export type AdfMediaSingleAttrsV1 = {
  /**
   * Layout
   */
  layout?: string | null;
  /**
   * Width
   */
  width?: number | null;
};

/**
 * AdfMediaSingleNodeV1
 */
export type AdfMediaSingleNodeV1 = {
  /**
   * Kind
   */
  kind: "mediaSingle";
  attrs?: AdfMediaSingleAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<AdfMediaNodeV1>;
};

/**
 * AdfMentionAttrsV1
 */
export type AdfMentionAttrsV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Text
   */
  text?: string | null;
  /**
   * Usertype
   */
  userType?: string | null;
  /**
   * Accesslevel
   */
  accessLevel?: string | null;
};

/**
 * AdfMentionNodeV1
 */
export type AdfMentionNodeV1 = {
  /**
   * Kind
   */
  kind: "mention";
  attrs: AdfMentionAttrsV1;
};

/**
 * AdfNestedExpandNodeV1
 */
export type AdfNestedExpandNodeV1Input = {
  /**
   * Kind
   */
  kind: "nestedExpand";
  attrs?: AdfExpandAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Input>;
};

/**
 * AdfNestedExpandNodeV1
 */
export type AdfNestedExpandNodeV1Output = {
  /**
   * Kind
   */
  kind: "nestedExpand";
  attrs?: AdfExpandAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Output>;
};

/**
 * AdfOrderedListAttrsV1
 */
export type AdfOrderedListAttrsV1 = {
  /**
   * Order
   */
  order?: number | null;
};

/**
 * AdfOrderedListNodeV1
 */
export type AdfOrderedListNodeV1Input = {
  /**
   * Kind
   */
  kind: "orderedList";
  attrs?: AdfOrderedListAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<AdfListItemNodeV1Input>;
};

/**
 * AdfOrderedListNodeV1
 */
export type AdfOrderedListNodeV1Output = {
  /**
   * Kind
   */
  kind: "orderedList";
  attrs?: AdfOrderedListAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<AdfListItemNodeV1Output>;
};

/**
 * AdfPanelAttrsV1
 */
export type AdfPanelAttrsV1 = {
  /**
   * Paneltype
   */
  panelType: string;
};

/**
 * AdfPanelNodeV1
 */
export type AdfPanelNodeV1Input = {
  /**
   * Kind
   */
  kind: "panel";
  attrs: AdfPanelAttrsV1;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Input>;
};

/**
 * AdfPanelNodeV1
 */
export type AdfPanelNodeV1Output = {
  /**
   * Kind
   */
  kind: "panel";
  attrs: AdfPanelAttrsV1;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Output>;
};

/**
 * AdfParagraphNodeV1
 */
export type AdfParagraphNodeV1Input = {
  /**
   * Kind
   */
  kind: "paragraph";
  /**
   * Content
   */
  content?: Array<AdfInlineNodeV1Input>;
};

/**
 * AdfParagraphNodeV1
 */
export type AdfParagraphNodeV1Output = {
  /**
   * Kind
   */
  kind: "paragraph";
  /**
   * Content
   */
  content?: Array<AdfInlineNodeV1Output>;
};

/**
 * AdfRuleNodeV1
 */
export type AdfRuleNodeV1 = {
  /**
   * Kind
   */
  kind: "rule";
};

/**
 * AdfStatusAttrsV1
 */
export type AdfStatusAttrsV1 = {
  /**
   * Text
   */
  text: string;
  /**
   * Color
   */
  color: string;
  /**
   * Localid
   */
  localId?: string | null;
  /**
   * Style
   */
  style?: string | null;
};

/**
 * AdfStatusNodeV1
 */
export type AdfStatusNodeV1 = {
  /**
   * Kind
   */
  kind: "status";
  attrs: AdfStatusAttrsV1;
};

/**
 * AdfStrikeMarkV1
 */
export type AdfStrikeMarkV1 = {
  /**
   * Kind
   */
  kind: "strike";
};

/**
 * AdfStrongMarkV1
 */
export type AdfStrongMarkV1 = {
  /**
   * Kind
   */
  kind: "strong";
};

/**
 * AdfSubsupMarkAttrsV1
 */
export type AdfSubsupMarkAttrsV1 = {
  type: ConfluenceAdfSubsupTypeV1;
};

/**
 * AdfSubsupMarkV1
 */
export type AdfSubsupMarkV1 = {
  /**
   * Kind
   */
  kind: "subsup";
  attrs: AdfSubsupMarkAttrsV1;
};

/**
 * AdfTableAttrsV1
 */
export type AdfTableAttrsV1 = {
  /**
   * Isnumbercolumnenabled
   */
  isNumberColumnEnabled?: boolean | null;
  /**
   * Layout
   */
  layout?: string | null;
  /**
   * Width
   */
  width?: number | null;
};

/**
 * AdfTableCellAttrsV1
 */
export type AdfTableCellAttrsV1 = {
  /**
   * Colspan
   */
  colspan?: number | null;
  /**
   * Rowspan
   */
  rowspan?: number | null;
  /**
   * Colwidth
   */
  colwidth?: Array<number> | null;
  /**
   * Background
   */
  background?: string | null;
};

/**
 * AdfTableCellNodeV1
 */
export type AdfTableCellNodeV1Input = {
  /**
   * Kind
   */
  kind: "tableCell";
  attrs?: AdfTableCellAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Input>;
};

/**
 * AdfTableCellNodeV1
 */
export type AdfTableCellNodeV1Output = {
  /**
   * Kind
   */
  kind: "tableCell";
  attrs?: AdfTableCellAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Output>;
};

export type AdfTableCellV1Input = AdfKnownTableCellV1Input | AdfUnknownNodeV1;

export type AdfTableCellV1Output = AdfKnownTableCellV1Output | AdfUnknownNodeV1;

/**
 * AdfTableHeaderNodeV1
 */
export type AdfTableHeaderNodeV1Input = {
  /**
   * Kind
   */
  kind: "tableHeader";
  attrs?: AdfTableCellAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Input>;
};

/**
 * AdfTableHeaderNodeV1
 */
export type AdfTableHeaderNodeV1Output = {
  /**
   * Kind
   */
  kind: "tableHeader";
  attrs?: AdfTableCellAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<ConfluenceReadAdfV1Output>;
};

/**
 * AdfTableNodeV1
 */
export type AdfTableNodeV1Input = {
  /**
   * Kind
   */
  kind: "table";
  attrs?: AdfTableAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<AdfTableRowNodeV1Input>;
};

/**
 * AdfTableNodeV1
 */
export type AdfTableNodeV1Output = {
  /**
   * Kind
   */
  kind: "table";
  attrs?: AdfTableAttrsV1 | null;
  /**
   * Content
   */
  content?: Array<AdfTableRowNodeV1Output>;
};

/**
 * AdfTableRowNodeV1
 */
export type AdfTableRowNodeV1Input = {
  /**
   * Kind
   */
  kind: "tableRow";
  /**
   * Content
   */
  content?: Array<AdfTableCellV1Input>;
};

/**
 * AdfTableRowNodeV1
 */
export type AdfTableRowNodeV1Output = {
  /**
   * Kind
   */
  kind: "tableRow";
  /**
   * Content
   */
  content?: Array<AdfTableCellV1Output>;
};

/**
 * AdfTextColorMarkAttrsV1
 */
export type AdfTextColorMarkAttrsV1 = {
  /**
   * Color
   */
  color: string;
};

/**
 * AdfTextColorMarkV1
 */
export type AdfTextColorMarkV1 = {
  /**
   * Kind
   */
  kind: "textColor";
  attrs: AdfTextColorMarkAttrsV1;
};

/**
 * AdfTextNodeV1
 */
export type AdfTextNodeV1 = {
  /**
   * Kind
   */
  kind: "text";
  /**
   * Text
   */
  text: string;
  /**
   * Marks
   */
  marks?: Array<AdfMarkV1>;
};

/**
 * AdfUnderlineMarkV1
 */
export type AdfUnderlineMarkV1 = {
  /**
   * Kind
   */
  kind: "underline";
};

/**
 * AdfUnknownMarkV1
 */
export type AdfUnknownMarkV1 = {
  /**
   * Kind
   */
  kind: string;
  [key: string]: unknown;
};

/**
 * AdfUnknownNodeV1
 */
export type AdfUnknownNodeV1 = {
  /**
   * Kind
   */
  kind: string;
  [key: string]: unknown;
};

/**
 * AgentProdEvalItemV1
 */
export type AgentProdEvalItemV1 = {
  /**
   * Kind
   */
  kind: "agent";
  finalized_conversation: FinalizedConversationFullV1;
  inference: AgentSessionInferenceV1;
  agent_session: AgentSessionFullV1;
  inference_datapoint: InferenceDatapointFullV1;
};

/**
 * AgentSessionFullV1
 */
export type AgentSessionFullV1 = {
  /**
   * Agent Session Id
   */
  agent_session_id: number;
  /**
   * Agent Key
   */
  agent_key: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * User Id
   */
  user_id: number;
  /**
   * Workspace Id
   */
  workspace_id: number;
  /**
   * Title
   */
  title: string | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  trace: AgentTraceV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * AgentSessionInferenceV1
 */
export type AgentSessionInferenceV1 = {
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Agent Session Id
   */
  agent_session_id: number;
  /**
   * Previous Trace Entry Id
   */
  previous_trace_entry_id: number;
  /**
   * Conversation External Id
   */
  conversation_external_id: string;
  /**
   * Message External Id
   */
  message_external_id: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * AgentSessionInferenceWithConversationsV1
 */
export type AgentSessionInferenceWithConversationsV1 = {
  /**
   * Kind
   */
  kind: "agent";
  inference: AgentSessionInferenceV1;
  agent_session: AgentSessionFullV1;
  finalized_conversation: FinalizedConversationFullV1;
};

export type AgentSessionUserFilterV1 = number | "me";

/**
 * AgentSessionV1
 */
export type AgentSessionV1 = {
  /**
   * Agent Session Id
   */
  agent_session_id: number;
  /**
   * Agent Key
   */
  agent_key: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Title
   */
  title: string | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Workspace Id
   */
  workspace_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * AgentTraceEntryMessageV1
 */
export type AgentTraceEntryMessageV1 = {
  /**
   * Kind
   */
  kind: "message";
  /**
   * Id
   */
  id: number;
  /**
   * Role
   */
  role: string;
  /**
   * Content Blocks
   */
  content_blocks: Array<AgentTraceMessageContentBlockV1>;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * AgentTraceEntryTurnEndV1
 */
export type AgentTraceEntryTurnEndV1 = {
  /**
   * Kind
   */
  kind: "turn_end";
  /**
   * Id
   */
  id: number;
  /**
   * Created At
   */
  created_at: Date;
};

export type AgentTraceEntryV1 =
  | AgentTraceEntryMessageV1
  | AgentTraceEntryTurnEndV1;

export type AgentTraceMessageContentBlockV1 =
  | AgentTraceMessageTextContentBlockV1
  | AgentTraceMessageReasoningContentBlockV1
  | AgentTraceMessageToolCallContentBlockV1
  | AgentTraceMessageToolCallResultContentBlockV1
  | AgentTraceMessageFileContentBlockV1
  | AgentTraceMessageUiContextContentBlockV1
  | AgentTraceMessageKbCitationContentBlockV1;

/**
 * AgentTraceMessageFileContentBlockV1
 */
export type AgentTraceMessageFileContentBlockV1 = {
  /**
   * Kind
   */
  kind: "file";
  /**
   * Uri
   */
  uri: string;
};

/**
 * AgentTraceMessageKbCitationContentBlockV1
 */
export type AgentTraceMessageKbCitationContentBlockV1 = {
  /**
   * Kind
   */
  kind: "kb_citation";
  /**
   * Source Object Article Id
   */
  source_object_article_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * AgentTraceMessageReasoningContentBlockV1
 */
export type AgentTraceMessageReasoningContentBlockV1 = {
  /**
   * Kind
   */
  kind: "reasoning";
  /**
   * Text
   */
  text: string;
  /**
   * Signature
   */
  signature: string | null;
};

/**
 * AgentTraceMessageTextContentBlockV1
 */
export type AgentTraceMessageTextContentBlockV1 = {
  /**
   * Kind
   */
  kind: "text";
  /**
   * Text
   */
  text: string;
};

/**
 * AgentTraceMessageToolCallContentBlockV1
 */
export type AgentTraceMessageToolCallContentBlockV1 = {
  /**
   * Kind
   */
  kind: "tool_call";
  /**
   * Tool Call Id
   */
  tool_call_id: string;
  /**
   * Tool Name
   */
  tool_name: string;
  /**
   * Tool Call Args
   */
  tool_call_args: {
    [key: string]: JsonOutput;
  };
};

/**
 * AgentTraceMessageToolCallResultContentBlockV1
 */
export type AgentTraceMessageToolCallResultContentBlockV1 = {
  /**
   * Kind
   */
  kind: "tool_call_result";
  /**
   * Tool Call Id
   */
  tool_call_id: string;
  /**
   * Tool Name
   */
  tool_name: string;
  /**
   * Tool Call Result
   */
  tool_call_result: {
    [key: string]: JsonOutput;
  };
};

/**
 * AgentTraceMessageUiContextContentBlockV1
 */
export type AgentTraceMessageUiContextContentBlockV1 = {
  /**
   * Kind
   */
  kind: "ui_context";
  /**
   * Context
   */
  context: {
    [key: string]: string;
  };
};

/**
 * AgentTraceV1
 */
export type AgentTraceV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Entries
   */
  entries: Array<AgentTraceEntryV1>;
  /**
   * Metadata
   *
   * Deprecated. Use AgentSessionFullV1.metadata instead.
   *
   * @deprecated
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * AgentUsageDataPointV1
 */
export type AgentUsageDataPointV1 = {
  /**
   * Bucket Start
   */
  bucket_start: Date;
  /**
   * Conversation Count
   */
  conversation_count: number;
  /**
   * User Message Count
   */
  user_message_count: number;
};

/**
 * AgentUsageStatsResponseV1
 */
export type AgentUsageStatsResponseV1 = {
  time_bucket: TimeBucketV1;
  total: AgentUsageTotalV1;
  /**
   * Agents
   */
  agents: Array<AgentUsageV1>;
};

/**
 * AgentUsageTotalV1
 */
export type AgentUsageTotalV1 = {
  /**
   * Conversation Count
   */
  conversation_count: number;
  /**
   * User Message Count
   */
  user_message_count: number;
};

/**
 * AgentUsageV1
 */
export type AgentUsageV1 = {
  /**
   * Agent Key
   */
  agent_key: string;
  total: AgentUsageTotalV1;
  /**
   * Data
   */
  data: Array<AgentUsageDataPointV1>;
  /**
   * Users
   */
  users: Array<AgentUserUsageV1>;
};

/**
 * AgentUserUsageV1
 */
export type AgentUserUsageV1 = {
  user: UserFullV1;
  total: AgentUsageTotalV1;
  /**
   * Data
   */
  data: Array<AgentUsageDataPointV1>;
};

/**
 * AgentV1
 */
export type AgentV1 = {
  /**
   * Key
   */
  key: string;
  /**
   * Name
   */
  name: string;
  a2a_config?: A2aConfigV1 | null;
};

/**
 * AmendEvidenceV1
 */
export type AmendEvidenceV1 = {
  /**
   * Datapoint Ids
   */
  datapoint_ids?: Array<number> | Missing;
  /**
   * Kanonical Datapoint Ids
   */
  kanonical_datapoint_ids?: Array<number> | Missing;
};

/**
 * AnalyticsChartsV1
 */
export type AnalyticsChartsV1 = {
  /**
   * Charts
   */
  charts: Array<ChartSummaryV1>;
};

/**
 * ApiKeyFullV1
 */
export type ApiKeyFullV1 = {
  /**
   * Id
   */
  id: number;
  created_by_user: UserFullV1;
  acts_as_user: UserFullV1;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Preview Prefix
   */
  preview_prefix: string;
  /**
   * Last Used At
   */
  last_used_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ApiKeySecretPlainValueV2
 */
export type ApiKeySecretPlainValueV2 = {
  /**
   * Kind
   */
  kind: "API_KEY";
  /**
   * Header Key
   */
  header_key: string;
  /**
   * Api Key
   */
  api_key: string;
  /**
   * Base Url
   */
  base_url: string;
};

/**
 * ApiKeySecretV1
 */
export type ApiKeySecretV1 = {
  api_key: ApiKeyV1;
  /**
   * Secret
   */
  secret: string;
};

/**
 * ApiKeySecretValueParamsV1
 */
export type ApiKeySecretValueParamsV1 = {
  /**
   * Kind
   */
  kind: "API_KEY";
  /**
   * Header Key
   */
  header_key: string;
  /**
   * Api Key
   */
  api_key: string;
  /**
   * Base Url
   */
  base_url: string;
};

/**
 * ApiKeyV1
 */
export type ApiKeyV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Acts As User Id
   */
  acts_as_user_id: number;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Preview Prefix
   */
  preview_prefix: string;
  /**
   * Last Used At
   */
  last_used_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * AppendConversationMessagesPayloadV1
 */
export type AppendConversationMessagesPayloadV1 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Messages
   */
  messages: Array<ConversationMessageV1>;
};

/**
 * AppendFinalizedConversationMessagesPayloadV1
 */
export type AppendFinalizedConversationMessagesPayloadV1 = {
  /**
   * Model Messages
   */
  model_messages: Array<CreateConversationMessageV1>;
  /**
   * View Messages
   */
  view_messages?: Array<CreateConversationMessageV1> | Missing;
};

/**
 * AppendInferenceConversationMessagesPayloadV1
 */
export type AppendInferenceConversationMessagesPayloadV1 = {
  /**
   * Task Id
   *
   * Unique identifier of the task.
   */
  task_id: number;
  /**
   * Messages
   *
   * The messages to append.
   */
  messages: Array<CreateConversationMessageV1>;
};

/**
 * ArticleByExternalIdRefV1
 */
export type ArticleByExternalIdRefV1 = {
  /**
   * Kind
   */
  kind: "external_id";
  /**
   * Source Object Article External Id
   */
  source_object_article_external_id: string;
};

/**
 * ArticleByObjectIdRefV1
 */
export type ArticleByObjectIdRefV1 = {
  /**
   * Kind
   */
  kind: "object_id";
  /**
   * Source Object Article Id
   */
  source_object_article_id: number;
};

/**
 * ArticleLineRangeCommentThreadFullV1
 */
export type ArticleLineRangeCommentThreadFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Object Article Id
   */
  object_article_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
  thread: CommentThreadFullV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ArticleLineRangeCommentThreadV1
 */
export type ArticleLineRangeCommentThreadV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Object Article Id
   */
  object_article_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ArticlePermissionV1
 */
export const ArticlePermissionV1 = {
  INHERIT: "inherit",
  BLOCKED: "blocked",
} as const;

/**
 * ArticlePermissionV1
 */
export type ArticlePermissionV1 =
  (typeof ArticlePermissionV1)[keyof typeof ArticlePermissionV1];

export type ArticleSearchContentV1 =
  | ({
      kind: "VISIBLE";
    } & VisibleArticleContentV1)
  | ({
      kind: "REDACTED";
    } & RedactedArticleContentV1);

/**
 * ArticleTagV1
 */
export type ArticleTagV1 = {
  /**
   * Key
   */
  key: string;
  /**
   * Value
   */
  value: string;
};

/**
 * ArticleV1
 */
export type ArticleV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * ArticleV1DiffSnapshotV2
 */
export type ArticleV1DiffSnapshotV2 = {
  /**
   * Object Article Id
   */
  object_article_id: number;
  /**
   * Title
   */
  title: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Verified
   */
  verified: boolean;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: JsonOutput;
  };
};

/**
 * AspectRatioV1
 */
export type AspectRatioV1 = {
  /**
   * Width
   */
  width: number;
  /**
   * Height
   */
  height: number;
};

/**
 * AttachEvidenceV2
 */
export type AttachEvidenceV2 = {
  /**
   * Datapoint Ids
   */
  datapoint_ids?: Array<number> | Missing;
  /**
   * Kanonical Datapoint Ids
   */
  kanonical_datapoint_ids?: Array<number> | Missing;
};

/**
 * AttachmentMediaTypeV1
 */
export const AttachmentMediaTypeV1 = {
  APPLICATION_PDF: "application/pdf",
  TEXT_PLAIN: "text/plain",
  APPLICATION_JSON: "application/json",
  TEXT_MARKDOWN: "text/markdown",
  TEXT_CSV: "text/csv",
  TEXT_HTML: "text/html",
  APPLICATION_XML: "application/xml",
  IMAGE_PNG: "image/png",
  IMAGE_JPEG: "image/jpeg",
  IMAGE_WEBP: "image/webp",
} as const;

/**
 * AttachmentMediaTypeV1
 */
export type AttachmentMediaTypeV1 =
  (typeof AttachmentMediaTypeV1)[keyof typeof AttachmentMediaTypeV1];

/**
 * BackfillIndexRequestV1
 */
export type BackfillIndexRequestV1 = {
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
};

/**
 * BackfillIndexResponseV1
 */
export type BackfillIndexResponseV1 = {
  [key: string]: unknown;
};

/**
 * BackgroundTaskErrorResponseV1
 */
export type BackgroundTaskErrorResponseV1 = {
  [key: string]: unknown;
};

/**
 * BarChartContentSeriesV1
 */
export type BarChartContentSeriesV1 = {
  label: SanitizedStr;
  /**
   * Values
   */
  values: Array<number>;
};

/**
 * BarChartContentV1
 */
export type BarChartContentV1 = {
  /**
   * Kind
   */
  kind: "BAR";
  /**
   * Stacked
   */
  stacked: boolean;
  /**
   * Reference Lines
   */
  reference_lines: Array<ReferenceLineV1>;
  y_axis_title: SanitizedStr;
  /**
   * X Axis Labels
   */
  x_axis_labels: XAxisLabelsDateV1 | XAxisLabelsTextV1;
  /**
   * Series
   */
  series: Array<BarChartContentSeriesV1>;
  color_scale?: ColorScaleV1 | null;
  time_bucket: TimeBucketV1;
};

/**
 * Body_salesforce_oauth_token_v1__api_public_v1_salesforce_oauth_token__tenant_id__post
 */
export type BodySalesforceOauthTokenV1ApiPublicV1SalesforceOauthTokenTenantIdPost =
  {
    /**
     * Grant Type
     */
    grant_type: string;
    /**
     * Client Id
     */
    client_id: string;
    /**
     * Client Secret
     */
    client_secret: string;
  };

/**
 * Body_slack_upload_files_v2__api_slack_v2_tenants__tenant_id__actions_files_upload_post
 */
export type BodySlackUploadFilesV2ApiSlackV2TenantsTenantIdActionsFilesUploadPost =
  {
    /**
     * Files
     */
    files: Array<Blob | File>;
    /**
     * Channel Id
     */
    channel_id?: string | null;
    /**
     * Thread Ts
     */
    thread_ts?: string | null;
    /**
     * Channels
     */
    channels?: Array<string> | null;
    /**
     * Initial Comment
     */
    initial_comment?: string | null;
    /**
     * Snippet Type
     */
    snippet_type?: string | null;
    /**
     * Title
     */
    title?: string | null;
  };

/**
 * Body_teams_upload_icon_v1__api_teams_v1_tenants__tenant_id__icons_post
 */
export type BodyTeamsUploadIconV1ApiTeamsV1TenantsTenantIdIconsPost = {
  /**
   * File
   */
  file: Blob | File;
};

/**
 * BrandingLogoUploadUrlRequestV1
 */
export type BrandingLogoUploadUrlRequestV1 = {
  content_type: ImageContentTypeV1;
};

/**
 * BrandingLogoUploadUrlResponseV1
 */
export type BrandingLogoUploadUrlResponseV1 = {
  upload_url: SanitizedStr;
};

/**
 * BrandingV1
 */
export type BrandingV1 = {
  logo_url: SanitizedStr | null;
};

/**
 * CalibrationFeedbackConversationFullV1
 */
export type CalibrationFeedbackConversationFullV1 = {
  /**
   * Messages
   */
  messages: Array<CalibrationFeedbackConversationMessageFullV1>;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
};

export type CalibrationFeedbackConversationMessageContentBlockV1 =
  | CalibrationFeedbackConversationMessageTextContentBlockV1
  | CalibrationFeedbackConversationMessageReasoningContentBlockV1
  | CalibrationFeedbackConversationMessageToolCallContentBlockV1
  | CalibrationFeedbackConversationMessageToolCallResultContentBlockV1
  | CalibrationFeedbackConversationMessageFileContentBlockV1;

/**
 * CalibrationFeedbackConversationMessageFileContentBlockV1
 */
export type CalibrationFeedbackConversationMessageFileContentBlockV1 = {
  /**
   * Kind
   */
  kind: "file";
  /**
   * Uri
   */
  uri: string;
};

/**
 * CalibrationFeedbackConversationMessageFullV1
 */
export type CalibrationFeedbackConversationMessageFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Role
   */
  role: string;
  /**
   * Content Blocks
   */
  content_blocks: Array<CalibrationFeedbackConversationMessageContentBlockV1>;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackConversationMessageKbCitationFullV1
 */
export type CalibrationFeedbackConversationMessageKbCitationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Kb Name
   */
  kb_name: string;
  /**
   * Section Id
   */
  section_id: number;
  /**
   * Source Object Article Id
   */
  source_object_article_id: number;
  /**
   * Section Version Id
   *
   * @deprecated
   */
  section_version_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * CalibrationFeedbackConversationMessageReasoningContentBlockV1
 */
export type CalibrationFeedbackConversationMessageReasoningContentBlockV1 = {
  /**
   * Kind
   */
  kind: "reasoning";
  /**
   * Text
   */
  text: string;
  /**
   * Signature
   */
  signature: string | null;
};

/**
 * CalibrationFeedbackConversationMessageTextContentBlockV1
 */
export type CalibrationFeedbackConversationMessageTextContentBlockV1 = {
  /**
   * Kind
   */
  kind: "text";
  /**
   * Text
   */
  text: string;
  /**
   * Kb Citations
   */
  kb_citations: Array<CalibrationFeedbackConversationMessageKbCitationFullV1>;
};

/**
 * CalibrationFeedbackConversationMessageToolCallContentBlockV1
 */
export type CalibrationFeedbackConversationMessageToolCallContentBlockV1 = {
  /**
   * Kind
   */
  kind: "tool_call";
  /**
   * Tool Call Id
   */
  tool_call_id: string;
  /**
   * Tool Name
   */
  tool_name: string;
  tool_call_args: CalibrationFeedbackConversationToolCallArgsV1 | null;
};

/**
 * CalibrationFeedbackConversationMessageToolCallResultContentBlockV1
 */
export type CalibrationFeedbackConversationMessageToolCallResultContentBlockV1 =
  {
    /**
     * Kind
     */
    kind: "tool_call_result";
    /**
     * Tool Call Id
     */
    tool_call_id: string;
    /**
     * Tool Name
     */
    tool_name: string;
    tool_call_result: CalibrationFeedbackConversationToolCallResultV1 | null;
  };

export type CalibrationFeedbackConversationToolCallArgsV1 = {
  [key: string]: JsonOutput;
};

export type CalibrationFeedbackConversationToolCallResultV1 = {
  [key: string]: JsonOutput;
};

/**
 * CalibrationFeedbackDimensionFullV1
 */
export type CalibrationFeedbackDimensionFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Values
   */
  values: Array<CalibrationFeedbackDimensionValueV1>;
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackDimensionV1
 */
export type CalibrationFeedbackDimensionV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackDimensionValueV1
 */
export type CalibrationFeedbackDimensionValueV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Dimension Id
   */
  dimension_id: number;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Order By
   */
  order_by: number;
  reasoning_request: CalibrationFeedbackReasoningRequestV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackInferenceDatapointFullV1
 */
export type CalibrationFeedbackInferenceDatapointFullV1 = {
  /**
   * Id
   */
  id: number;
  input: CalibrationFeedbackConversationFullV1;
  output: CalibrationFeedbackConversationFullV1;
  predicted_output: CalibrationFeedbackConversationFullV1;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackInferenceDatapointV1
 */
export type CalibrationFeedbackInferenceDatapointV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Input Id
   */
  input_id: number;
  /**
   * Output Id
   */
  output_id: number;
  /**
   * Predicted Output Id
   */
  predicted_output_id: number;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackQueueItemFullV1
 */
export type CalibrationFeedbackQueueItemFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Title
   */
  title: string;
  inference_datapoint: CalibrationFeedbackInferenceDatapointFullV1;
  reasoning_request: CalibrationFeedbackReasoningRequestV1;
  /**
   * Show Ground Truth
   */
  show_ground_truth: boolean;
  status: CalibrationFeedbackQueueItemStatusV1;
  verdict: CalibrationFeedbackVerdictWithDimensionsV1 | null;
  my_verdict: CalibrationFeedbackVerdictWithDimensionsV1 | null;
  /**
   * Dimensions
   */
  dimensions: Array<CalibrationFeedbackDimensionFullV1>;
  /**
   * Order By
   */
  order_by: number;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackQueueItemStatusV1
 */
export const CalibrationFeedbackQueueItemStatusV1 = {
  PENDING: "PENDING",
  COMPLETE: "COMPLETE",
} as const;

/**
 * CalibrationFeedbackQueueItemStatusV1
 */
export type CalibrationFeedbackQueueItemStatusV1 =
  (typeof CalibrationFeedbackQueueItemStatusV1)[keyof typeof CalibrationFeedbackQueueItemStatusV1];

/**
 * CalibrationFeedbackQueueItemV1
 */
export type CalibrationFeedbackQueueItemV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Title
   */
  title: string;
  /**
   * Inference Datapoint Id
   */
  inference_datapoint_id: number;
  reasoning_request: CalibrationFeedbackReasoningRequestV1;
  /**
   * Show Ground Truth
   */
  show_ground_truth: boolean;
  status: CalibrationFeedbackQueueItemStatusV1;
  /**
   * Verdict Id
   */
  verdict_id: number | null;
  /**
   * Order By
   */
  order_by: number;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackReasoningRequestV1
 */
export const CalibrationFeedbackReasoningRequestV1 = {
  NONE: "NONE",
  OPTIONAL: "OPTIONAL",
  REQUIRED: "REQUIRED",
} as const;

/**
 * CalibrationFeedbackReasoningRequestV1
 */
export type CalibrationFeedbackReasoningRequestV1 =
  (typeof CalibrationFeedbackReasoningRequestV1)[keyof typeof CalibrationFeedbackReasoningRequestV1];

/**
 * CalibrationFeedbackTagKeyV1
 */
export type CalibrationFeedbackTagKeyV1 = {
  /**
   * Key
   */
  key: string;
  /**
   * Values
   */
  values: Array<CalibrationFeedbackTagValueV1>;
};

/**
 * CalibrationFeedbackTagValueV1
 */
export type CalibrationFeedbackTagValueV1 = {
  /**
   * Value
   */
  value: string;
  /**
   * Count
   */
  count: number;
};

/**
 * CalibrationFeedbackVerdictDimensionV1
 */
export type CalibrationFeedbackVerdictDimensionV1 = {
  /**
   * Id
   */
  id: number;
  dimension: CalibrationFeedbackDimensionV1;
  value: CalibrationFeedbackDimensionValueV1;
};

/**
 * CalibrationFeedbackVerdictFullV1
 */
export type CalibrationFeedbackVerdictFullV1 = {
  /**
   * Id
   */
  id: number;
  inference_datapoint: CalibrationFeedbackInferenceDatapointFullV1;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Reasoning
   */
  reasoning: string | null;
  /**
   * Dimensions
   */
  dimensions: Array<CalibrationFeedbackVerdictDimensionV1>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackVerdictV1
 */
export type CalibrationFeedbackVerdictV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Inference Datapoint Id
   */
  inference_datapoint_id: number;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Reasoning
   */
  reasoning: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CalibrationFeedbackVerdictWithDimensionsV1
 */
export type CalibrationFeedbackVerdictWithDimensionsV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Inference Datapoint Id
   */
  inference_datapoint_id: number;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Reasoning
   */
  reasoning: string | null;
  /**
   * Dimensions
   */
  dimensions: Array<CalibrationFeedbackVerdictDimensionV1>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CapabilitiesV1
 */
export type CapabilitiesV1 = {
  /**
   * Copilot Enabled
   */
  copilot_enabled: boolean;
  /**
   * Review Agent Enabled
   */
  review_agent_enabled: boolean;
  /**
   * Integrations Enabled
   */
  integrations_enabled: boolean;
  /**
   * Access Control Enabled
   */
  access_control_enabled: boolean;
  /**
   * Task Agents Enabled
   */
  task_agents_enabled: boolean;
  /**
   * Copilot Attachments Enabled
   */
  copilot_attachments_enabled: boolean;
  /**
   * Customer Logo Enabled
   */
  customer_logo_enabled: boolean;
};

/**
 * ChangeCountsResponseV2
 */
export type ChangeCountsResponseV2 = {
  state_counts: ChangeStateCountsV2;
};

/**
 * ChangeRequestFullSortV1
 */
export const ChangeRequestFullSortV1 = {
  EVIDENCE_COUNT_DESC: "evidence_count:desc",
  EVIDENCE_COUNT_ASC: "evidence_count:asc",
  CREATED_AT_DESC: "created_at:desc",
  CREATED_AT_ASC: "created_at:asc",
  UPDATED_AT_DESC: "updated_at:desc",
  UPDATED_AT_ASC: "updated_at:asc",
  RELEVANCE_DESC: "relevance:desc",
} as const;

/**
 * ChangeRequestFullSortV1
 */
export type ChangeRequestFullSortV1 =
  (typeof ChangeRequestFullSortV1)[keyof typeof ChangeRequestFullSortV1];

/**
 * ChangeRequestFullV1
 */
export type ChangeRequestFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Status
   */
  status:
    | ({
        kind: "OPEN";
      } & ChangeRequestStatusOpenFullV1)
    | ({
        kind: "PUBLISHED";
      } & ChangeRequestStatusPublishedFullV1)
    | ({
        kind: "REJECTED";
      } & ChangeRequestStatusRejectedFullV1)
    | ({
        kind: "CLOSED";
      } & ChangeRequestStatusClosedFullV1);
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * From Branch
   */
  from_branch: string;
  /**
   * From Branch Head Commit Id
   */
  from_branch_head_commit_id: number;
  /**
   * To Branch
   */
  to_branch: string;
  /**
   * Title
   */
  title: string;
  /**
   * Description
   */
  description: string;
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Assignees
   */
  assignees: Array<UserFullV1>;
  created_by: UserFullV1;
  /**
   * Evidence Count
   */
  evidence_count: number;
  /**
   * Lines Added
   */
  lines_added: number;
  /**
   * Lines Removed
   */
  lines_removed: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ChangeRequestLineRangeCommentThreadFullV1
 */
export type ChangeRequestLineRangeCommentThreadFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Change Request Id
   */
  change_request_id: number;
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Object Article Id
   */
  object_article_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
  /**
   * Comments
   */
  comments: Array<CommentFullV1>;
  resolved: ChangeRequestLineRangeCommentThreadResolvedV1 | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ChangeRequestLineRangeCommentThreadResolvedV1
 */
export type ChangeRequestLineRangeCommentThreadResolvedV1 = {
  resolved_by: UserFullV1;
  /**
   * Resolved At
   */
  resolved_at: Date;
};

/**
 * ChangeRequestLineRangeCommentThreadV1
 */
export type ChangeRequestLineRangeCommentThreadV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Change Request Id
   */
  change_request_id: number;
  /**
   * Object Article Id
   */
  object_article_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ChangeRequestReferenceLineV1
 */
export type ChangeRequestReferenceLineV1 = {
  /**
   * Kind
   */
  kind: "CHANGE_REQUEST";
  /**
   * Id
   */
  id: number;
  /**
   * Date
   */
  date: Date;
  title: SanitizedStr;
  /**
   * Evidence Count
   */
  evidence_count: number;
  /**
   * Lines Added
   */
  lines_added: number;
  /**
   * Lines Removed
   */
  lines_removed: number;
};

export type ChangeRequestSearchContentV1 =
  | ({
      kind: "VISIBLE";
    } & VisibleChangeRequestContentV1)
  | ({
      kind: "REDACTED";
    } & RedactedChangeRequestContentV1);

/**
 * ChangeRequestSortV1
 */
export const ChangeRequestSortV1 = {
  CREATED_AT_DESC: "created_at:desc",
  CREATED_AT_ASC: "created_at:asc",
  UPDATED_AT_DESC: "updated_at:desc",
  UPDATED_AT_ASC: "updated_at:asc",
} as const;

/**
 * ChangeRequestSortV1
 */
export type ChangeRequestSortV1 =
  (typeof ChangeRequestSortV1)[keyof typeof ChangeRequestSortV1];

/**
 * ChangeRequestStatusClosedFullV1
 */
export type ChangeRequestStatusClosedFullV1 = {
  /**
   * Kind
   */
  kind: "CLOSED";
  by_user: UserFullV1;
  /**
   * From Branch Close Commit Id
   */
  from_branch_close_commit_id: number;
  /**
   * To Branch Close Commit Id
   */
  to_branch_close_commit_id: number;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * ChangeRequestStatusKindV1
 */
export const ChangeRequestStatusKindV1 = {
  OPEN: "OPEN",
  PUBLISHED: "PUBLISHED",
  REJECTED: "REJECTED",
  CLOSED: "CLOSED",
} as const;

/**
 * ChangeRequestStatusKindV1
 */
export type ChangeRequestStatusKindV1 =
  (typeof ChangeRequestStatusKindV1)[keyof typeof ChangeRequestStatusKindV1];

/**
 * ChangeRequestStatusOpenFullV1
 */
export type ChangeRequestStatusOpenFullV1 = {
  /**
   * Kind
   */
  kind: "OPEN";
  by_user: UserFullV1;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * ChangeRequestStatusPublishedFullV1
 */
export type ChangeRequestStatusPublishedFullV1 = {
  /**
   * Kind
   */
  kind: "PUBLISHED";
  by_user: UserFullV1;
  /**
   * From Branch Publish Commit Id
   */
  from_branch_publish_commit_id: number;
  /**
   * To Branch Publish Commit Id
   */
  to_branch_publish_commit_id: number;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * ChangeRequestStatusRejectedFullV1
 */
export type ChangeRequestStatusRejectedFullV1 = {
  /**
   * Kind
   */
  kind: "REJECTED";
  by_user: UserFullV1;
  /**
   * From Branch Reject Commit Id
   */
  from_branch_reject_commit_id: number;
  /**
   * To Branch Reject Commit Id
   */
  to_branch_reject_commit_id: number;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * ChangeRequestV1
 */
export type ChangeRequestV1 = {
  /**
   * Id
   */
  id: number;
  status_kind: ChangeRequestStatusKindV1;
  /**
   * From Branch
   */
  from_branch: number;
  /**
   * To Branch
   */
  to_branch: number;
  /**
   * Title
   */
  title: string;
  /**
   * Created By
   */
  created_by: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ChangeStateCountsV2
 */
export type ChangeStateCountsV2 = {
  /**
   * Open
   */
  open: number;
  /**
   * Published
   */
  published: number;
  /**
   * Rejected
   */
  rejected: number;
  /**
   * Closed
   */
  closed: number;
};

/**
 * ChangeUsersResponseV2
 */
export type ChangeUsersResponseV2 = {
  /**
   * Actions By User Over Time
   */
  actions_by_user_over_time: Array<UserActivitySeriesV2>;
  /**
   * Total Actions By User
   */
  total_actions_by_user: Array<UserActionsTotalV2>;
};

export type ChartContentV1 =
  | ({
      kind: "BAR";
    } & BarChartContentV1)
  | ({
      kind: "LINE";
    } & LineChartContentV1)
  | ({
      kind: "SINGLE_STAT";
    } & SingleStatContentV1)
  | ({
      kind: "SANKEY";
    } & SankeyChartContentV1)
  | ({
      kind: "JUDGE_SINGLE_STAT";
    } & JudgeSingleStatContentV1)
  | ({
      kind: "JUDGE_PERCENTAGE";
    } & JudgePercentageContentV1)
  | ({
      kind: "JUDGE_PERCENTAGE_PROGRESS_BAR";
    } & JudgePercentageProgressBarContentV1)
  | ({
      kind: "JUDGE_SERIES";
    } & JudgeSeriesContentV1)
  | ({
      kind: "JUDGE_BAR";
    } & JudgeBarContentV1)
  | ({
      kind: "JUDGE_GAUGE";
    } & JudgeGaugeContentV1);

/**
 * ChartKind
 */
export const ChartKind = {
  BAR: "BAR",
  LINE: "LINE",
  SINGLE_STAT: "SINGLE_STAT",
  SANKEY: "SANKEY",
  SECTION_CHANGE: "SECTION_CHANGE",
  JUDGE_SINGLE_STAT: "JUDGE_SINGLE_STAT",
  JUDGE_PERCENTAGE: "JUDGE_PERCENTAGE",
  JUDGE_PERCENTAGE_PROGRESS_BAR: "JUDGE_PERCENTAGE_PROGRESS_BAR",
  JUDGE_SERIES: "JUDGE_SERIES",
  JUDGE_BAR: "JUDGE_BAR",
  JUDGE_GAUGE: "JUDGE_GAUGE",
} as const;

/**
 * ChartKind
 */
export type ChartKind = (typeof ChartKind)[keyof typeof ChartKind];

/**
 * ChartSeriesModeV1
 */
export const ChartSeriesModeV1 = { BAR: "BAR", LINE: "LINE" } as const;

/**
 * ChartSeriesModeV1
 */
export type ChartSeriesModeV1 =
  (typeof ChartSeriesModeV1)[keyof typeof ChartSeriesModeV1];

/**
 * ChartSummaryV1
 */
export type ChartSummaryV1 = {
  chart_key: SanitizedStr;
  kind: ChartKind;
  title: SanitizedStr;
  description: SanitizedStr | null;
  /**
   * Span
   */
  span: number;
  aspect_ratio: AspectRatioV1 | null;
  /**
   * Private
   */
  private: boolean;
};

export type CitationArticleRefV1 =
  | ({
      kind: "object_id";
    } & ArticleByObjectIdRefV1)
  | ({
      kind: "external_id";
    } & ArticleByExternalIdRefV1);

/**
 * ColorScaleV1
 */
export const ColorScaleV1 = {
  SUCCESS_TO_DANGER: "SUCCESS_TO_DANGER",
  DANGER_TO_SUCCESS: "DANGER_TO_SUCCESS",
  COOL_TO_WARM: "COOL_TO_WARM",
  WARM_TO_COOL: "WARM_TO_COOL",
} as const;

/**
 * ColorScaleV1
 */
export type ColorScaleV1 = (typeof ColorScaleV1)[keyof typeof ColorScaleV1];

/**
 * ColorV1
 */
export const ColorV1 = {
  MUTED: "MUTED",
  GREEN: "GREEN",
  YELLOW: "YELLOW",
  RED: "RED",
  ORANGE: "ORANGE",
  DARK: "DARK",
} as const;

/**
 * ColorV1
 */
export type ColorV1 = (typeof ColorV1)[keyof typeof ColorV1];

/**
 * CommentFullV1
 */
export type CommentFullV1 = {
  /**
   * Id
   */
  id: number;
  user: UserFullV1;
  /**
   * Content
   */
  content: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CommentThreadFullV1
 */
export type CommentThreadFullV1 = {
  /**
   * Comments
   */
  comments: Array<CommentFullV1>;
  resolved: CommentThreadResolvedV1 | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * CommentThreadResolvedV1
 */
export type CommentThreadResolvedV1 = {
  resolved_by: UserFullV1;
  /**
   * Resolved At
   */
  resolved_at: Date;
};

/**
 * CommentV1
 */
export type CommentV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * User Id
   */
  user_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ConfluenceAdfSubsupTypeV1
 */
export const ConfluenceAdfSubsupTypeV1 = { SUB: "sub", SUP: "sup" } as const;

/**
 * ConfluenceAdfSubsupTypeV1
 */
export type ConfluenceAdfSubsupTypeV1 =
  (typeof ConfluenceAdfSubsupTypeV1)[keyof typeof ConfluenceAdfSubsupTypeV1];

export type ConfluenceAdfV1 =
  | ({
      kind: "paragraph";
    } & AdfParagraphNodeV1Input)
  | ({
      kind: "heading";
    } & AdfHeadingNodeV1Input)
  | ({
      kind: "blockquote";
    } & AdfBlockquoteNodeV1Input)
  | ({
      kind: "bulletList";
    } & AdfBulletListNodeV1Input)
  | ({
      kind: "orderedList";
    } & AdfOrderedListNodeV1Input)
  | ({
      kind: "listItem";
    } & AdfListItemNodeV1Input)
  | ({
      kind: "codeBlock";
    } & AdfCodeBlockNodeV1Input)
  | ({
      kind: "panel";
    } & AdfPanelNodeV1Input)
  | ({
      kind: "expand";
    } & AdfExpandNodeV1Input)
  | ({
      kind: "nestedExpand";
    } & AdfNestedExpandNodeV1Input)
  | ({
      kind: "rule";
    } & AdfRuleNodeV1)
  | ({
      kind: "table";
    } & AdfTableNodeV1Input)
  | ({
      kind: "tableRow";
    } & AdfTableRowNodeV1Input)
  | ({
      kind: "tableCell";
    } & AdfTableCellNodeV1Input)
  | ({
      kind: "tableHeader";
    } & AdfTableHeaderNodeV1Input)
  | ({
      kind: "mediaSingle";
    } & AdfMediaSingleNodeV1)
  | ({
      kind: "mediaGroup";
    } & AdfMediaGroupNodeV1)
  | ({
      kind: "media";
    } & AdfMediaNodeV1);

/**
 * ConfluenceAttachmentContentV1
 */
export type ConfluenceAttachmentContentV1 = {
  /**
   * Attachment Id
   */
  attachment_id: string;
  /**
   * Content
   */
  content: string;
  /**
   * Mime Type
   */
  mime_type: string;
};

/**
 * ConfluenceAttachmentV1
 */
export type ConfluenceAttachmentV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * File Id
   */
  file_id: string;
  /**
   * Title
   */
  title: string;
  /**
   * Mime Type
   */
  mime_type: string;
  /**
   * File Size
   */
  file_size: number | null;
};

/**
 * ConfluenceCallbackPayloadV1
 */
export type ConfluenceCallbackPayloadV1 = {
  /**
   * Code
   */
  code: string;
  /**
   * State
   */
  state: string;
};

export type ConfluenceCheckConnectionResponseV1 =
  | ({
      status: "connected";
    } & ConfluenceConnectedV1)
  | ({
      status: "disconnected";
    } & ConfluenceDisconnectedV1);

/**
 * ConfluenceCommentV1
 */
export type ConfluenceCommentV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Page Id
   */
  page_id: string;
  /**
   * Representation
   */
  representation: string;
  /**
   * Body
   */
  body: Array<ConfluenceReadAdfV1Output>;
  /**
   * Created At
   */
  created_at: Date | null;
};

/**
 * ConfluenceConnectResponseV1
 */
export type ConfluenceConnectResponseV1 = {
  /**
   * Authorization Url
   */
  authorization_url: string;
};

/**
 * ConfluenceConnectedV1
 */
export type ConfluenceConnectedV1 = {
  /**
   * Status
   */
  status: "connected";
  /**
   * Connected
   */
  connected: boolean;
  /**
   * Granted Scopes
   */
  granted_scopes: Array<ConfluenceOauthScope>;
  /**
   * Missing Scopes
   */
  missing_scopes: Array<ConfluenceOauthScope>;
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * ConfluenceDisconnectedV1
 */
export type ConfluenceDisconnectedV1 = {
  /**
   * Status
   */
  status: "disconnected";
  /**
   * Connected
   */
  connected: boolean;
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * ConfluenceLabelV1
 */
export type ConfluenceLabelV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Prefix
   */
  prefix: string | null;
};

/**
 * ConfluenceOauthScope
 */
export const ConfluenceOauthScope = {
  READ_SPACE_CONFLUENCE: "read:space:confluence",
  READ_PAGE_CONFLUENCE: "read:page:confluence",
  WRITE_PAGE_CONFLUENCE: "write:page:confluence",
  READ_COMMENT_CONFLUENCE: "read:comment:confluence",
  WRITE_COMMENT_CONFLUENCE: "write:comment:confluence",
  READ_ATTACHMENT_CONFLUENCE: "read:attachment:confluence",
} as const;

/**
 * ConfluenceOauthScope
 */
export type ConfluenceOauthScope =
  (typeof ConfluenceOauthScope)[keyof typeof ConfluenceOauthScope];

/**
 * ConfluenceOauthScopesResponseV1
 */
export type ConfluenceOauthScopesResponseV1 = {
  /**
   * Scopes
   */
  scopes: Array<ConfluenceOauthScope>;
};

/**
 * ConfluencePageContentV1
 */
export type ConfluencePageContentV1 = {
  /**
   * Page Id
   */
  page_id: string;
  /**
   * Title
   */
  title: string;
  /**
   * Version
   */
  version: number;
  /**
   * Representation
   */
  representation: string;
  /**
   * Body
   */
  body: Array<ConfluenceReadAdfV1Output>;
};

/**
 * ConfluencePageV1
 */
export type ConfluencePageV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Title
   */
  title: string;
  /**
   * Space Id
   */
  space_id: string;
  /**
   * Status
   */
  status: string;
  /**
   * Version
   */
  version: number;
  /**
   * Url
   */
  url: string;
  /**
   * Created At
   */
  created_at: Date | null;
  /**
   * Parent Id
   */
  parent_id: string | null;
};

export type ConfluenceReadAdfV1Input =
  | AdfKnownReadNodeV1Input
  | AdfUnknownNodeV1;

export type ConfluenceReadAdfV1Output =
  | AdfKnownReadNodeV1Output
  | AdfUnknownNodeV1;

/**
 * ConfluenceSpaceV1
 */
export type ConfluenceSpaceV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Key
   */
  key: string;
  /**
   * Name
   */
  name: string;
  /**
   * Type
   */
  type: string;
};

/**
 * ConfluenceTenantFullV1
 */
export type ConfluenceTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Scopes
   */
  scopes: Array<ConfluenceOauthScope>;
  /**
   * Client Id
   */
  client_id: string | null;
  /**
   * Has Tokens
   */
  has_tokens: boolean;
  /**
   * Cloud Id
   */
  cloud_id: string | null;
  /**
   * Redirect Uri
   */
  redirect_uri: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ConfluenceTenantV1
 */
export type ConfluenceTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ConversationFeedbackLabelOnlyV1
 */
export type ConversationFeedbackLabelOnlyV1 = {
  /**
   * Task Id
   *
   * The ID of the task for which the feedback is being provided.
   */
  task_id: number;
  /**
   * Conversation Id
   *
   * The Edra ID of the conversation for which the feedback is being provided.
   */
  conversation_id?: number | Missing;
  /**
   * Message Id
   *
   * The message ID for which the feedback is being provided.
   */
  message_id?: number | Missing;
  /**
   * Message External Id
   *
   * The external message ID for which the feedback is being provided.
   */
  message_external_id?: string | Missing;
  /**
   * Inference Id
   *
   * The id of the inference for which the feedback is being provided.
   */
  inference_id?: number | Missing;
  /**
   * Created At
   *
   * The timestamp of when the feedback was created.
   */
  created_at?: Date | Missing;
  /**
   * Metadata
   *
   * Additional metadata associated with the feedback.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Tags associated with the feedback.
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Feedback label.
   */
  label: ConversationFeedbackLabelV1;
};

/**
 * ConversationFeedbackLabelTextV1
 */
export type ConversationFeedbackLabelTextV1 = {
  /**
   * Task Id
   *
   * The ID of the task for which the feedback is being provided.
   */
  task_id: number;
  /**
   * Conversation Id
   *
   * The Edra ID of the conversation for which the feedback is being provided.
   */
  conversation_id?: number | Missing;
  /**
   * Message Id
   *
   * The message ID for which the feedback is being provided.
   */
  message_id?: number | Missing;
  /**
   * Message External Id
   *
   * The external message ID for which the feedback is being provided.
   */
  message_external_id?: string | Missing;
  /**
   * Inference Id
   *
   * The id of the inference for which the feedback is being provided.
   */
  inference_id?: number | Missing;
  /**
   * Created At
   *
   * The timestamp of when the feedback was created.
   */
  created_at?: Date | Missing;
  /**
   * Metadata
   *
   * Additional metadata associated with the feedback.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Tags associated with the feedback.
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Feedback label.
   */
  label: ConversationFeedbackLabelV1;
  /**
   * Additional text feedback.
   */
  feedback_text: SanitizedStr;
};

/**
 * ConversationFeedbackLabelV1
 */
export const ConversationFeedbackLabelV1 = {
  CORRECT: "correct",
  INCORRECT: "incorrect",
} as const;

/**
 * ConversationFeedbackLabelV1
 */
export type ConversationFeedbackLabelV1 =
  (typeof ConversationFeedbackLabelV1)[keyof typeof ConversationFeedbackLabelV1];

/**
 * ConversationFeedbackTextV1
 */
export type ConversationFeedbackTextV1 = {
  /**
   * Task Id
   *
   * The ID of the task for which the feedback is being provided.
   */
  task_id: number;
  /**
   * Conversation Id
   *
   * The Edra ID of the conversation for which the feedback is being provided.
   */
  conversation_id?: number | Missing;
  /**
   * Message Id
   *
   * The message ID for which the feedback is being provided.
   */
  message_id?: number | Missing;
  /**
   * Message External Id
   *
   * The external message ID for which the feedback is being provided.
   */
  message_external_id?: string | Missing;
  /**
   * Inference Id
   *
   * The id of the inference for which the feedback is being provided.
   */
  inference_id?: number | Missing;
  /**
   * Created At
   *
   * The timestamp of when the feedback was created.
   */
  created_at?: Date | Missing;
  /**
   * Metadata
   *
   * Additional metadata associated with the feedback.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Tags associated with the feedback.
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Additional text feedback.
   */
  feedback_text: SanitizedStr;
};

export type ConversationFeedbackV1 =
  | ConversationFeedbackLabelOnlyV1
  | ConversationFeedbackTextV1
  | ConversationFeedbackLabelTextV1;

/**
 * ConversationFullV1
 */
export type ConversationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Messages
   */
  messages: Array<ConversationMessageFullV1>;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Metadata
   */
  metadata: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
};

/**
 * ConversationFullV2
 */
export type ConversationFullV2 = {
  /**
   * Messages
   */
  messages: Array<ConversationMessageFullV2>;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
};

/**
 * ConversationInferenceCitationV1
 */
export type ConversationInferenceCitationV1 = {
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Kb Name
   */
  kb_name: string;
  /**
   * Section Id
   */
  section_id: number;
  /**
   * Section Number
   */
  section_number: string;
  /**
   * Document Id
   */
  document_id: number;
  /**
   * Line Start
   *
   * The line number of the start of the citation
   */
  line_start: number;
  /**
   * Line End
   *
   * The line number of the end of the citation
   */
  line_end: number;
};

/**
 * ConversationInferenceResponseV1
 */
export type ConversationInferenceResponseV1 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Conversation Id
   */
  conversation_id: number;
  /**
   * Conversation External Id
   */
  conversation_external_id: string;
  /**
   * Inference Id
   */
  inference_id: number;
  output: SanitizedStr;
  /**
   * Citations
   */
  citations?: Array<ConversationInferenceCitationV1> | null;
  /**
   * Reasoning
   */
  reasoning?: string | null;
};

/**
 * ConversationInferenceResponseV2
 */
export type ConversationInferenceResponseV2 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Conversation External Id
   */
  conversation_external_id: string;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Output Messages
   */
  output_messages: Array<ConversationMessageFullV2>;
  /**
   * Reasoning
   */
  reasoning: string;
  confidence: InferenceConfidenceV1 | null;
};

/**
 * ConversationInferenceWithFinalizedConversationV1
 */
export type ConversationInferenceWithFinalizedConversationV1 = {
  /**
   * Kind
   */
  kind: "conversation";
  inference: InferenceConversationInferenceFullV1;
  finalized_conversation: FinalizedConversationFullV1;
};

export type ConversationMessageContentBlockV1 =
  | ConversationMessageTextContentBlockV1
  | ConversationMessageReasoningContentBlockV1
  | ConversationMessageToolCallContentBlockV1
  | ConversationMessageToolCallResultContentBlockV1
  | ConversationMessageFileContentBlockV1;

/**
 * ConversationMessageFileContentBlockV1
 */
export type ConversationMessageFileContentBlockV1 = {
  /**
   * Kind
   */
  kind: "file";
  /**
   * Uri
   */
  uri: string;
};

/**
 * ConversationMessageFullV1
 */
export type ConversationMessageFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Content
   */
  content: string;
  /**
   * Role
   */
  role: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  inference: InferenceFullV1 | null;
};

/**
 * ConversationMessageFullV2
 */
export type ConversationMessageFullV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Role
   */
  role: string;
  /**
   * Content Blocks
   */
  content_blocks: Array<ConversationMessageContentBlockV1>;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ConversationMessageKbCitationFullV1
 */
export type ConversationMessageKbCitationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Kb Name
   */
  kb_name: string;
  /**
   * Section Number
   */
  section_number: string;
  /**
   * Section Id
   */
  section_id: number;
  /**
   * Source Object Article Id
   */
  source_object_article_id: number;
  /**
   * Section Version Id
   *
   * @deprecated
   */
  section_version_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * ConversationMessageReasoningContentBlockV1
 */
export type ConversationMessageReasoningContentBlockV1 = {
  /**
   * Kind
   */
  kind: "reasoning";
  /**
   * Text
   */
  text: string;
  /**
   * Signature
   */
  signature: string | null;
};

export const ConversationMessageRoleV1Field = {
  USER: "user",
  ASSISTANT: "assistant",
  EDRA_USER: "edra_user",
  EDRA_ASSISTANT: "edra_assistant",
} as const;

export type ConversationMessageRoleV1Field =
  (typeof ConversationMessageRoleV1Field)[keyof typeof ConversationMessageRoleV1Field];

/**
 * ConversationMessageTextContentBlockV1
 */
export type ConversationMessageTextContentBlockV1 = {
  /**
   * Kind
   */
  kind: "text";
  /**
   * Text
   */
  text: string;
  /**
   * Kb Citations
   */
  kb_citations: Array<ConversationMessageKbCitationFullV1>;
};

/**
 * ConversationMessageToolCallContentBlockV1
 */
export type ConversationMessageToolCallContentBlockV1 = {
  /**
   * Kind
   */
  kind: "tool_call";
  /**
   * Tool Call Id
   */
  tool_call_id: string;
  /**
   * Tool Name
   */
  tool_name: string;
  tool_call_args: ToolCallArgsV1 | null;
};

/**
 * ConversationMessageToolCallResultContentBlockV1
 */
export type ConversationMessageToolCallResultContentBlockV1 = {
  /**
   * Kind
   */
  kind: "tool_call_result";
  /**
   * Tool Call Id
   */
  tool_call_id: string;
  /**
   * Tool Name
   */
  tool_name: string;
  tool_call_result: ToolCallResultV1 | null;
};

/**
 * ConversationMessageV1
 */
export type ConversationMessageV1 = {
  /**
   * Content
   *
   * The message content.
   */
  content: string;
  /**
   * The role of the message sender.
   */
  role: ConversationMessageRoleV1Field;
  /**
   * Message Id
   *
   * The unique identifier of the message.
   */
  message_id?: string | Missing;
  /**
   * Created At
   *
   * The timestamp of when the message was created.
   */
  created_at?: Date | Missing;
  /**
   * Metadata
   *
   * Additional metadata associated with the message, used during inference.
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   *
   * Message tags.
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * ConversationProdEvalItemV1
 */
export type ConversationProdEvalItemV1 = {
  /**
   * Kind
   */
  kind: "conversation";
  finalized_conversation: FinalizedConversationFullV1;
  inference: InferenceConversationInferenceFullV1;
  inference_datapoint: InferenceDatapointFullV1;
};

/**
 * ConversationSourceV1
 */
export type ConversationSourceV1 = {
  /**
   * Kind
   */
  kind: "conversation";
  /**
   * Conversation Id
   */
  conversation_id: number;
};

/**
 * CreateAgentSessionInferenceParamsV1
 */
export type CreateAgentSessionInferenceParamsV1 = {
  /**
   * Previous Trace Entry Id
   */
  previous_trace_entry_id: number;
  /**
   * Conversation External Id
   */
  conversation_external_id: string;
  /**
   * Message External Id
   */
  message_external_id: string;
};

/**
 * CreateAgentSessionV1
 */
export type CreateAgentSessionV1 = {
  /**
   * Agent Key
   */
  agent_key: string;
  /**
   * External Id
   */
  external_id?: string | null;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
};

export type CreateAgentTraceMessageContentBlockV1 =
  | AgentTraceMessageTextContentBlockV1
  | AgentTraceMessageFileContentBlockV1
  | AgentTraceMessageUiContextContentBlockV1;

/**
 * CreateAgentTraceMessageV1
 */
export type CreateAgentTraceMessageV1 = {
  /**
   * Role
   *
   * The role of the message sender.
   */
  role: string;
  /**
   * Content Blocks
   *
   * The content blocks of the message.
   */
  content_blocks: Array<CreateAgentTraceMessageContentBlockV1>;
  /**
   * Metadata
   *
   * Additional metadata associated with the message.
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * CreateApiKeyParamsV1
 */
export type CreateApiKeyParamsV1 = {
  /**
   * Display Name
   */
  display_name: string;
};

/**
 * CreateArticleLineRangeCommentThreadCommentParamsV1
 */
export type CreateArticleLineRangeCommentThreadCommentParamsV1 = {
  content: SanitizedStr;
};

/**
 * CreateArticleLineRangeCommentThreadParamsV1
 */
export type CreateArticleLineRangeCommentThreadParamsV1 = {
  /**
   * Object Article Id
   */
  object_article_id: number;
  line_range: LineRangeV1;
  comment: SanitizedStr;
};

/**
 * CreateBotUserParamsV1
 */
export type CreateBotUserParamsV1 = {
  /**
   * Name
   */
  name: string;
};

export type CreateCalibrationFeedbackConversationMessageContentBlockV1 =
  | CreateCalibrationFeedbackConversationMessageTextContentBlockV1
  | CreateCalibrationFeedbackConversationMessageFileContentBlockV1;

/**
 * CreateCalibrationFeedbackConversationMessageContentBlocksV1
 */
export type CreateCalibrationFeedbackConversationMessageContentBlocksV1 = {
  /**
   * External Id
   */
  external_id?: string | Missing;
  /**
   * Role
   */
  role: string;
  /**
   * Content Blocks
   */
  content_blocks: Array<CreateCalibrationFeedbackConversationMessageContentBlockV1>;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at?: Date | Missing;
};

/**
 * CreateCalibrationFeedbackConversationMessageContentV1
 */
export type CreateCalibrationFeedbackConversationMessageContentV1 = {
  /**
   * External Id
   */
  external_id?: string | Missing;
  /**
   * Role
   */
  role: string;
  /**
   * Content
   */
  content: string;
  /**
   * Kb Citations
   */
  kb_citations?: Array<CreateCalibrationFeedbackConversationMessageKbCitationV1>;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at?: Date | Missing;
};

/**
 * CreateCalibrationFeedbackConversationMessageFileContentBlockV1
 */
export type CreateCalibrationFeedbackConversationMessageFileContentBlockV1 = {
  /**
   * Kind
   */
  kind: "file";
  /**
   * Uri
   */
  uri: string;
};

/**
 * CreateCalibrationFeedbackConversationMessageKbCitationV1
 */
export type CreateCalibrationFeedbackConversationMessageKbCitationV1 = {
  /**
   * Source Object Article Id
   */
  source_object_article_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * CreateCalibrationFeedbackConversationMessageTextContentBlockV1
 */
export type CreateCalibrationFeedbackConversationMessageTextContentBlockV1 = {
  /**
   * Kind
   */
  kind: "text";
  /**
   * Text
   */
  text: string;
  /**
   * Kb Citations
   */
  kb_citations?: Array<CreateCalibrationFeedbackConversationMessageKbCitationV1>;
};

export type CreateCalibrationFeedbackConversationMessageV1 =
  | CreateCalibrationFeedbackConversationMessageContentBlocksV1
  | CreateCalibrationFeedbackConversationMessageContentV1;

/**
 * CreateCalibrationFeedbackDimensionParamsV1
 */
export type CreateCalibrationFeedbackDimensionParamsV1 = {
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Values
   */
  values: Array<CreateCalibrationFeedbackDimensionValueParamsV1>;
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * CreateCalibrationFeedbackDimensionValueParamsV1
 */
export type CreateCalibrationFeedbackDimensionValueParamsV1 = {
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Order By
   */
  order_by: number;
  reasoning_request: CalibrationFeedbackReasoningRequestV1;
};

/**
 * CreateCalibrationFeedbackInferenceDatapointParamsV1
 */
export type CreateCalibrationFeedbackInferenceDatapointParamsV1 = {
  /**
   * Input
   */
  input: Array<CreateCalibrationFeedbackConversationMessageV1>;
  /**
   * Output
   */
  output: Array<CreateCalibrationFeedbackConversationMessageV1>;
  /**
   * Predicted Output
   */
  predicted_output: Array<CreateCalibrationFeedbackConversationMessageV1>;
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * CreateCalibrationFeedbackInferenceDatapointsParamsV1
 */
export type CreateCalibrationFeedbackInferenceDatapointsParamsV1 = {
  /**
   * Items
   */
  items: Array<CreateCalibrationFeedbackInferenceDatapointParamsV1>;
};

/**
 * CreateCalibrationFeedbackInferenceDatapointsResultV1
 */
export type CreateCalibrationFeedbackInferenceDatapointsResultV1 = {
  /**
   * Inference Datapoints
   */
  inference_datapoints: Array<CalibrationFeedbackInferenceDatapointV1>;
};

/**
 * CreateCalibrationFeedbackQueueItemParamsV1
 */
export type CreateCalibrationFeedbackQueueItemParamsV1 = {
  /**
   * Inference Datapoint Id
   */
  inference_datapoint_id: number;
  /**
   * Title
   */
  title: string;
  /**
   * Dimension Ids
   */
  dimension_ids: Array<number>;
  reasoning_request: CalibrationFeedbackReasoningRequestV1;
  /**
   * Show Ground Truth
   */
  show_ground_truth?: boolean;
  /**
   * Order By
   */
  order_by?: number | null;
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * CreateCalibrationFeedbackQueueItemsParamsV1
 */
export type CreateCalibrationFeedbackQueueItemsParamsV1 = {
  /**
   * Items
   */
  items: Array<CreateCalibrationFeedbackQueueItemParamsV1>;
};

/**
 * CreateCalibrationFeedbackQueueItemsResultV1
 */
export type CreateCalibrationFeedbackQueueItemsResultV1 = {
  /**
   * Queue Items
   */
  queue_items: Array<CalibrationFeedbackQueueItemV1>;
};

/**
 * CreateCalibrationFeedbackVerdictDimensionParamsV1
 */
export type CreateCalibrationFeedbackVerdictDimensionParamsV1 = {
  /**
   * Dimension Value Id
   */
  dimension_value_id: number;
};

/**
 * CreateCalibrationFeedbackVerdictParamsV1
 */
export type CreateCalibrationFeedbackVerdictParamsV1 = {
  /**
   * Inference Datapoint Id
   */
  inference_datapoint_id: number;
  /**
   * Queue Item Id
   */
  queue_item_id?: number | null;
  /**
   * Reasoning
   */
  reasoning?: string | null;
  /**
   * Dimensions
   */
  dimensions: Array<CreateCalibrationFeedbackVerdictDimensionParamsV1>;
};

/**
 * CreateChangeRequestLineRangeCommentThreadCommentParamsV1
 */
export type CreateChangeRequestLineRangeCommentThreadCommentParamsV1 = {
  content: SanitizedStr;
};

/**
 * CreateChangeRequestLineRangeCommentThreadParamsV1
 */
export type CreateChangeRequestLineRangeCommentThreadParamsV1 = {
  /**
   * Change Request Id
   */
  change_request_id: number;
  /**
   * Commit Id
   */
  commit_id: number;
  /**
   * Path
   */
  path: string;
  line_range: LineRangeV1;
  comment: SanitizedStr;
};

/**
 * CreateChangeRequestParamsV1
 */
export type CreateChangeRequestParamsV1 = {
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * From Branch
   */
  from_branch: string;
  /**
   * To Branch
   */
  to_branch: string;
  /**
   * Title
   */
  title: string;
  /**
   * Description
   */
  description: string;
};

/**
 * CreateConfluencePageParamsV1
 */
export type CreateConfluencePageParamsV1 = {
  /**
   * Space Id
   */
  space_id: string;
  /**
   * Title
   */
  title: string;
  /**
   * Body
   */
  body: Array<ConfluenceAdfV1>;
  /**
   * Parent Id
   */
  parent_id?: string | null;
};

/**
 * CreateConfluenceTenantParamsV1
 */
export type CreateConfluenceTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Scopes
   */
  scopes?: Array<ConfluenceOauthScope> | null;
};

/**
 * CreateConversationFeedbackResponseV2
 */
export type CreateConversationFeedbackResponseV2 = {
  /**
   * Id
   *
   * The ID of the created feedback.
   */
  id: number;
  /**
   * Task Id
   *
   * The ID of the task for which the feedback was provided.
   */
  task_id: number;
  /**
   * Created At
   *
   * The timestamp of when the feedback was recorded.
   */
  created_at: Date;
  /**
   * External Created At
   *
   * The caller-supplied timestamp of when the feedback was given.
   */
  external_created_at: Date | null;
};

export type CreateConversationMessageContentBlockV1 =
  | CreateConversationMessageTextContentBlockV1
  | CreateConversationMessageFileContentBlockV1;

/**
 * CreateConversationMessageContentBlocksV1
 */
export type CreateConversationMessageContentBlocksV1 = {
  /**
   * External Id
   */
  external_id?: string | Missing;
  /**
   * Role
   */
  role: string;
  /**
   * Content Blocks
   */
  content_blocks: Array<CreateConversationMessageContentBlockV1>;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at?: Date | Missing;
};

/**
 * CreateConversationMessageContentV1
 */
export type CreateConversationMessageContentV1 = {
  /**
   * External Id
   */
  external_id?: string | Missing;
  /**
   * Role
   */
  role: string;
  /**
   * Content
   */
  content: string;
  /**
   * Kb Citations
   */
  kb_citations?: Array<CreateConversationMessageKbCitationV1>;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at?: Date | Missing;
};

/**
 * CreateConversationMessageFileContentBlockV1
 */
export type CreateConversationMessageFileContentBlockV1 = {
  /**
   * Kind
   */
  kind: "file";
  /**
   * Uri
   */
  uri: string;
};

/**
 * CreateConversationMessageKbCitationV1
 */
export type CreateConversationMessageKbCitationV1 = {
  /**
   * Source Object Article Id
   */
  source_object_article_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * CreateConversationMessageTextContentBlockV1
 */
export type CreateConversationMessageTextContentBlockV1 = {
  /**
   * Kind
   */
  kind: "text";
  /**
   * Text
   */
  text: string;
  /**
   * Kb Citations
   */
  kb_citations?: Array<CreateConversationMessageKbCitationV1>;
};

/**
 * CreateConversationMessageV1
 */
export type CreateConversationMessageV1 =
  | CreateConversationMessageContentBlocksV1
  | CreateConversationMessageContentV1;

/**
 * CreateDataDumpConversationRequestV1
 */
export type CreateDataDumpConversationRequestV1 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Messages
   */
  messages: Array<CreateConversationMessageV1>;
  /**
   * External Created At
   */
  external_created_at?: Date | Missing;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateDatapointsDatapointV3
 */
export type CreateDatapointsDatapointV3 = {
  model: DatapointExtractedInputOutputV2;
  view?: DatapointExtractedInputOutputV2 | null;
  /**
   * External Created At
   */
  external_created_at?: Date | null;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateDatapointsItemV3
 */
export type CreateDatapointsItemV3 = {
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Datapoints
   */
  datapoints: Array<CreateDatapointsDatapointV3>;
};

/**
 * CreateDatapointsRequestV3
 */
export type CreateDatapointsRequestV3 = {
  /**
   * Items
   */
  items: Array<CreateDatapointsItemV3>;
};

/**
 * CreateDatapointsResponseItemV3
 */
export type CreateDatapointsResponseItemV3 = {
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
};

/**
 * CreateDatapointsResponseV3
 */
export type CreateDatapointsResponseV3 = {
  /**
   * Items
   */
  items: Array<CreateDatapointsResponseItemV3>;
};

/**
 * CreateEntraProposedActionParamsV1
 */
export type CreateEntraProposedActionParamsV1 = {
  action: EntraProposedActionSpecV1;
  /**
   * Rationale
   */
  rationale: string;
};

/**
 * CreateEntraTenantParamsV1
 */
export type CreateEntraTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Directory Tenant Id
   */
  directory_tenant_id: string;
};

/**
 * CreateExternalInferenceCitationV1
 */
export type CreateExternalInferenceCitationV1 = {
  /**
   * Content Block Position
   */
  content_block_position: number;
  article: CitationArticleRefV1;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * CreateExternalInferenceFinalizedConversationItemV1
 */
export type CreateExternalInferenceFinalizedConversationItemV1 = {
  /**
   * Kind
   */
  kind: "finalized_conversation";
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  /**
   * Message Id
   */
  message_id: number;
  /**
   * External Created At
   */
  external_created_at?: Date | Missing;
  /**
   * Citations
   */
  citations?: Array<CreateExternalInferenceCitationV1>;
};

/**
 * CreateExternalInferenceInlineItemV1
 */
export type CreateExternalInferenceInlineItemV1 = {
  /**
   * Kind
   */
  kind: "inline";
  /**
   * Input Messages
   */
  input_messages?: Array<CreateConversationMessageV1>;
  /**
   * Output Messages
   */
  output_messages: Array<CreateConversationMessageV1>;
  /**
   * External Created At
   */
  external_created_at?: Date | Missing;
};

/**
 * CreateExternalInferencesParamsV1
 */
export type CreateExternalInferencesParamsV1 = {
  /**
   * Items
   */
  items: Array<
    | CreateExternalInferenceFinalizedConversationItemV1
    | CreateExternalInferenceInlineItemV1
  >;
};

/**
 * CreateExternalInferencesResponseV1
 */
export type CreateExternalInferencesResponseV1 = {
  /**
   * External Inferences
   */
  external_inferences: Array<ExternalInferenceV1>;
};

/**
 * CreateFeedbackLabelParamsV1
 */
export type CreateFeedbackLabelParamsV1 = {
  label: SanitizedStr;
};

/**
 * CreateFinalizedConversationConversationV2
 */
export type CreateFinalizedConversationConversationV2 = {
  /**
   * Messages
   */
  messages: Array<CreateConversationMessageV1>;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateFinalizedConversationRequestV2
 */
export type CreateFinalizedConversationRequestV2 = {
  /**
   * Finalized Conversations
   */
  finalized_conversations: Array<CreateFinalizedConversationV2>;
};

/**
 * CreateFinalizedConversationResponseV2
 */
export type CreateFinalizedConversationResponseV2 = {
  /**
   * Finalized Conversations
   */
  finalized_conversations: Array<FinalizedConversationV1>;
};

/**
 * CreateFinalizedConversationV2
 */
export type CreateFinalizedConversationV2 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * External Url
   */
  external_url?: string | null;
  /**
   * Title
   */
  title?: string | null;
  model: CreateFinalizedConversationConversationV2;
  /**
   * View
   */
  view?: CreateFinalizedConversationConversationV2 | Missing;
  /**
   * External Created At
   */
  external_created_at?: Date | Missing;
};

/**
 * CreateFreshserviceArticleParamsV1
 */
export type CreateFreshserviceArticleParamsV1 = {
  /**
   * Folder Id
   */
  folder_id: number;
  title: SanitizedStr;
  description: SanitizedStr;
  status: FreshserviceArticleStatusV1;
};

/**
 * CreateFreshserviceFolderParamsV1
 */
export type CreateFreshserviceFolderParamsV1 = {
  /**
   * Category Id
   */
  category_id: number;
  name: NonEmptyStr;
  description?: SanitizedStr | null;
};

/**
 * CreateFreshserviceTenantParamsV1
 */
export type CreateFreshserviceTenantParamsV1 = {
  tenant_name: NonEmptyStr;
  domain: NonEmptyStr;
};

/**
 * CreateFreshserviceTicketParamsV1
 */
export type CreateFreshserviceTicketParamsV1 = {
  subject: SanitizedStr;
  description: SanitizedStr;
  email: SanitizedStr;
  impact: FreshserviceTicketImpactV1;
  urgency: FreshserviceTicketUrgencyV1;
  status: FreshserviceTicketStatusV1;
  /**
   * Tags
   */
  tags?: Array<SanitizedStr> | null;
};

/**
 * CreateHubSpotTenantParamsV1
 */
export type CreateHubSpotTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
};

/**
 * CreateInferenceDatapointParamsV2
 */
export type CreateInferenceDatapointParamsV2 = {
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  model: DatapointExtractedInputOutputV2;
  view: DatapointExtractedInputOutputV2;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateInferenceDatapointsDequeueByDagsterRunV1
 */
export type CreateInferenceDatapointsDequeueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * CreateInferenceDatapointsDequeueByIdsV1
 */
export type CreateInferenceDatapointsDequeueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Inference Ids
   */
  inference_ids: Array<number>;
};

/**
 * CreateInferenceDatapointsDequeueRequestV1
 */
export type CreateInferenceDatapointsDequeueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & CreateInferenceDatapointsDequeueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & CreateInferenceDatapointsDequeueByDagsterRunV1);
};

/**
 * CreateInferenceDatapointsDequeueResponseV1
 */
export type CreateInferenceDatapointsDequeueResponseV1 = {
  /**
   * Dequeued Inference Ids
   */
  dequeued_inference_ids: Array<number>;
};

/**
 * CreateInferenceDatapointsEnqueueByDagsterRunV1
 */
export type CreateInferenceDatapointsEnqueueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * CreateInferenceDatapointsEnqueueByIdsV1
 */
export type CreateInferenceDatapointsEnqueueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Inference Ids
   */
  inference_ids: Array<number>;
};

/**
 * CreateInferenceDatapointsEnqueueRequestV1
 */
export type CreateInferenceDatapointsEnqueueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & CreateInferenceDatapointsEnqueueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & CreateInferenceDatapointsEnqueueByDagsterRunV1);
};

/**
 * CreateInferenceDatapointsEnqueueResponseV1
 */
export type CreateInferenceDatapointsEnqueueResponseV1 = {
  /**
   * Enqueued Inference Ids
   */
  enqueued_inference_ids: Array<number>;
};

export type CreateInferenceDatapointsInputItemV1 =
  | ({
      kind: "conversation";
    } & ConversationInferenceWithFinalizedConversationV1)
  | ({
      kind: "agent";
    } & AgentSessionInferenceWithConversationsV1);

/**
 * CreateInferenceDatapointsInputRequestV1
 */
export type CreateInferenceDatapointsInputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Max Processing Time
   */
  max_processing_time?: string | Missing;
};

/**
 * CreateInferenceDatapointsInputResponseV1
 */
export type CreateInferenceDatapointsInputResponseV1 = {
  /**
   * Items
   */
  items: Array<CreateInferenceDatapointsInputItemV1>;
};

/**
 * CreateInferenceDatapointsOutputDatapointV1
 */
export type CreateInferenceDatapointsOutputDatapointV1 = {
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  model: DatapointExtractedInputOutputV2;
  view?: DatapointExtractedInputOutputV2 | null;
  /**
   * Metadata
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateInferenceDatapointsOutputItemV1
 */
export type CreateInferenceDatapointsOutputItemV1 = {
  /**
   * Inference Id
   */
  inference_id: number;
  datapoint: CreateInferenceDatapointsOutputDatapointV1;
};

/**
 * CreateInferenceDatapointsOutputRequestV1
 */
export type CreateInferenceDatapointsOutputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Items
   */
  items: Array<CreateInferenceDatapointsOutputItemV1>;
};

/**
 * CreateInferenceDatapointsOutputResponseV1
 */
export type CreateInferenceDatapointsOutputResponseV1 = {
  /**
   * Inference Datapoint Ids
   */
  inference_datapoint_ids: Array<number>;
};

/**
 * CreateInferenceFeedbackLabelParamsV1
 */
export type CreateInferenceFeedbackLabelParamsV1 = {
  label: SanitizedStr;
};

/**
 * CreateInferenceFeedbackParamsV1
 */
export type CreateInferenceFeedbackParamsV1 = {
  /**
   * Feedback Label Id
   */
  feedback_label_id: number;
  feedback_note?: SanitizedStr | null;
};

/**
 * CreateInvitationParamsV1
 */
export type CreateInvitationParamsV1 = {
  /**
   * Email
   */
  email: string;
  role: InviteRoleV1;
  /**
   * Team Ids
   */
  team_ids: Array<number>;
};

/**
 * CreateJiraTenantParamsV1
 */
export type CreateJiraTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Base Url
   */
  base_url: string;
  /**
   * Installation Id
   */
  installation_id: string;
  /**
   * Action Api Path
   */
  action_api_path: string;
  /**
   * Api Key
   */
  api_key: string;
  /**
   * Webhook Secret
   */
  webhook_secret: string;
};

/**
 * CreateJudgeKindOrdinalV2
 */
export type CreateJudgeKindOrdinalV2 = {
  /**
   * Values
   */
  values: Array<CreateJudgeOrdinalValueV2>;
};

/**
 * CreateJudgeOrdinalValueV2
 */
export type CreateJudgeOrdinalValueV2 = {
  /**
   * Key
   */
  key: string;
  /**
   * Display Name
   */
  display_name: string;
};

/**
 * CreateJudgeParamsV1
 */
export type CreateJudgeParamsV1 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Name
   */
  name: string;
};

/**
 * CreateJudgeParamsV2
 */
export type CreateJudgeParamsV2 = {
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Display Name
   */
  display_name: string;
  kind: CreateJudgeKindOrdinalV2;
};

/**
 * CreateJudgementItemV2
 */
export type CreateJudgementItemV2 = {
  /**
   * Inference Conversation Inference Id
   */
  inference_conversation_inference_id: number;
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Reasoning
   */
  reasoning: string | null;
  /**
   * Ordinal Value
   */
  ordinal_value: string;
};

/**
 * CreateJudgementItemV3
 */
export type CreateJudgementItemV3 = {
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Reasoning
   */
  reasoning: string | null;
  /**
   * Ordinal Value
   */
  ordinal_value: string;
};

/**
 * CreateJudgementsParamsV2
 */
export type CreateJudgementsParamsV2 = {
  /**
   * Items
   */
  items: Array<CreateJudgementItemV2>;
};

/**
 * CreateJudgementsParamsV3
 */
export type CreateJudgementsParamsV3 = {
  /**
   * Items
   */
  items: Array<CreateJudgementItemV3>;
};

/**
 * CreateJudgementsResultV3
 */
export type CreateJudgementsResultV3 = {
  /**
   * Judgements
   */
  judgements: Array<JudgementV3>;
};

/**
 * CreateJudgesJudgeV2
 */
export type CreateJudgesJudgeV2 = {
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Display Name
   */
  display_name: string;
  kind: CreateJudgesKindOrdinalV2;
};

/**
 * CreateJudgesKindOrdinalV2
 */
export type CreateJudgesKindOrdinalV2 = {
  /**
   * Values
   */
  values: Array<CreateJudgesOrdinalValueV2>;
};

/**
 * CreateJudgesOrdinalValueV2
 */
export type CreateJudgesOrdinalValueV2 = {
  /**
   * Key
   */
  key: string;
  /**
   * Display Name
   */
  display_name: string;
};

/**
 * CreateJudgesParamsV2
 */
export type CreateJudgesParamsV2 = {
  /**
   * Items
   */
  items: Array<CreateJudgesJudgeV2>;
};

/**
 * CreateKanonicalDatapointV2
 */
export type CreateKanonicalDatapointV2 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Title
   */
  title?: string | null;
  /**
   * Summary
   */
  summary?: string | null;
  model: CreateKanonicalInputOutputV2;
  view?: CreateKanonicalInputOutputV2 | null;
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateKanonicalDatapointsRequestV2
 */
export type CreateKanonicalDatapointsRequestV2 = {
  /**
   * Items
   */
  items: Array<CreateKanonicalDatapointV2>;
};

/**
 * CreateKanonicalDatapointsResponseItemV2
 */
export type CreateKanonicalDatapointsResponseItemV2 = {
  /**
   * Kanonical Datapoint Id
   */
  kanonical_datapoint_id: number;
};

/**
 * CreateKanonicalDatapointsResponseV2
 */
export type CreateKanonicalDatapointsResponseV2 = {
  /**
   * Items
   */
  items: Array<CreateKanonicalDatapointsResponseItemV2>;
};

/**
 * CreateKanonicalInputOutputV2
 */
export type CreateKanonicalInputOutputV2 = {
  kanonical_input: CreateKanonicalMessagesV2;
  kanonical_output: CreateKanonicalMessagesV2;
};

/**
 * CreateKanonicalMessagesV2
 */
export type CreateKanonicalMessagesV2 = {
  /**
   * Messages
   */
  messages: Array<CreateConversationMessageV1>;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateKbAccessRequestParamsV1
 */
export type CreateKbAccessRequestParamsV1 = {
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Article Id
   */
  article_id?: number | null;
  message?: SanitizedStr | null;
};

/**
 * CreateKbIngestionFileItemV1
 */
export type CreateKbIngestionFileItemV1 = {
  s3_uri: SanitizedStr;
  version_id: SanitizedStr;
};

/**
 * CreateKbIngestionFilesParamsV1
 */
export type CreateKbIngestionFilesParamsV1 = {
  /**
   * Items
   */
  items: Array<CreateKbIngestionFileItemV1>;
};

/**
 * CreateKnowledgeBaseParamsV2
 */
export type CreateKnowledgeBaseParamsV2 = {
  /**
   * Name
   */
  name: string;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Id
   */
  external_id?: string | null;
};

/**
 * CreateMachineUserApiKeyParamsV1
 */
export type CreateMachineUserApiKeyParamsV1 = {
  /**
   * Display Name
   */
  display_name: string;
};

/**
 * CreateMachineUserParamsV1
 */
export type CreateMachineUserParamsV1 = {
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Team Ids
   */
  team_ids: Array<number>;
};

/**
 * CreateNotionBlocksParamsV1
 */
export type CreateNotionBlocksParamsV1 = {
  /**
   * Children
   */
  children: Array<NotionBlockInputV1>;
  /**
   * After
   */
  after?: string | null;
};

/**
 * CreateNotionBlocksResponseV1
 */
export type CreateNotionBlocksResponseV1 = {
  /**
   * Blocks
   */
  blocks?: Array<NotionBlockV1>;
};

/**
 * CreateNotionPageParamsV1
 */
export type CreateNotionPageParamsV1 = {
  parent_kind: NotionParentKindV1;
  /**
   * Parent Id
   */
  parent_id: string;
  /**
   * Title
   */
  title: string;
  /**
   * Children
   */
  children?: Array<NotionBlockInputV1> | null;
};

/**
 * CreateNotionTenantParamsV1
 */
export type CreateNotionTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
};

/**
 * CreateOAuthApplicationParamsV1
 */
export type CreateOAuthApplicationParamsV1 = {
  /**
   * Name
   */
  name: string;
  provider: OAuthApplicationProviderV1;
  /**
   * Redirect Uris
   */
  redirect_uris?: Array<string>;
};

/**
 * CreateOutlookSubscriptionsParamsV2
 */
export type CreateOutlookSubscriptionsParamsV2 = {
  /**
   * User Id
   *
   * Microsoft user ID (email or GUID)
   */
  user_id: string;
  /**
   * Folders
   */
  folders: Array<string>;
};

/**
 * CreateOutlookSubscriptionsResponseV2
 */
export type CreateOutlookSubscriptionsResponseV2 = {
  /**
   * User Id
   */
  user_id: string;
  /**
   * Subscriptions
   */
  subscriptions: Array<CreateOutlookSubscriptionsSubscriptionSuccessV2>;
};

/**
 * CreateOutlookSubscriptionsSubscriptionSuccessV2
 */
export type CreateOutlookSubscriptionsSubscriptionSuccessV2 = {
  /**
   * Folder
   */
  folder: string;
  /**
   * Subscription Id
   */
  subscription_id: string;
  /**
   * Expiration Date Time
   */
  expiration_date_time: Date;
};

/**
 * CreatePlainTenantParamsV1
 */
export type CreatePlainTenantParamsV1 = {
  /**
   * Name
   */
  name: string;
  /**
   * Permissions
   */
  permissions: Array<PlainPermissionV1>;
};

/**
 * CreateProdEvalsDequeueByDagsterRunV1
 */
export type CreateProdEvalsDequeueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * CreateProdEvalsDequeueByIdsV1
 */
export type CreateProdEvalsDequeueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Inference Datapoint Ids
   */
  inference_datapoint_ids: Array<number>;
};

/**
 * CreateProdEvalsDequeueRequestV1
 */
export type CreateProdEvalsDequeueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & CreateProdEvalsDequeueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & CreateProdEvalsDequeueByDagsterRunV1);
};

/**
 * CreateProdEvalsDequeueResponseV1
 */
export type CreateProdEvalsDequeueResponseV1 = {
  /**
   * Dequeued Inference Datapoint Ids
   */
  dequeued_inference_datapoint_ids: Array<number>;
};

/**
 * CreateProdEvalsEnqueueByDagsterRunV1
 */
export type CreateProdEvalsEnqueueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * CreateProdEvalsEnqueueByIdsV1
 */
export type CreateProdEvalsEnqueueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Inference Datapoint Ids
   */
  inference_datapoint_ids: Array<number>;
};

/**
 * CreateProdEvalsEnqueueRequestV1
 */
export type CreateProdEvalsEnqueueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & CreateProdEvalsEnqueueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & CreateProdEvalsEnqueueByDagsterRunV1);
};

/**
 * CreateProdEvalsEnqueueResponseV1
 */
export type CreateProdEvalsEnqueueResponseV1 = {
  /**
   * Enqueued Inference Datapoint Ids
   */
  enqueued_inference_datapoint_ids: Array<number>;
};

export type CreateProdEvalsInputItemV1 =
  | ({
      kind: "conversation";
    } & ConversationProdEvalItemV1)
  | ({
      kind: "agent";
    } & AgentProdEvalItemV1);

/**
 * CreateProdEvalsInputRequestV1
 */
export type CreateProdEvalsInputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Max Processing Time
   */
  max_processing_time?: string | Missing;
};

/**
 * CreateProdEvalsInputResponseV1
 */
export type CreateProdEvalsInputResponseV1 = {
  /**
   * Items
   */
  items: Array<CreateProdEvalsInputItemV1>;
};

/**
 * CreateProdEvalsOutputItemV1
 */
export type CreateProdEvalsOutputItemV1 = {
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Inference Datapoint Id
   */
  inference_datapoint_id: number;
  /**
   * Judgements
   */
  judgements: Array<CreateProdEvalsOutputJudgementV1>;
};

/**
 * CreateProdEvalsOutputJudgementV1
 */
export type CreateProdEvalsOutputJudgementV1 = {
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Category
   */
  category: string;
  /**
   * Reasoning
   */
  reasoning: string;
};

/**
 * CreateProdEvalsOutputRequestV1
 */
export type CreateProdEvalsOutputRequestV1 = {
  /**
   * Task Id
   */
  task_id: number;
  dagster_run_id: NonEmptyStr;
  /**
   * Items
   */
  items: Array<CreateProdEvalsOutputItemV1>;
};

/**
 * CreateProdEvalsOutputResponseV1
 */
export type CreateProdEvalsOutputResponseV1 = {
  /**
   * Judgements
   */
  judgements: Array<JudgementV2>;
};

/**
 * CreatePromptParamsV1
 */
export type CreatePromptParamsV1 = {
  template: SanitizedStr;
  input_schema: JsonSchemaV1Input;
  output_schema: JsonSchemaV1Input;
  kind: PromptKind;
};

/**
 * CreateSalesforceArticleParamsV1
 */
export type CreateSalesforceArticleParamsV1 = {
  /**
   * Title
   */
  title: string;
  /**
   * Summary
   */
  summary: string;
  /**
   * Language
   */
  language: string;
};

/**
 * CreateSalesforceCaseCommentParamsV1
 */
export type CreateSalesforceCaseCommentParamsV1 = {
  /**
   * Body
   */
  body: string;
  /**
   * Is Published
   */
  is_published?: boolean;
};

/**
 * CreateSalesforceCaseEmailDraftParamsV1
 */
export type CreateSalesforceCaseEmailDraftParamsV1 = {
  /**
   * To
   */
  to: Array<string>;
  /**
   * Subject
   */
  subject: string;
  /**
   * Body
   */
  body: string;
  /**
   * Cc
   */
  cc?: Array<string>;
  /**
   * Bcc
   */
  bcc?: Array<string>;
  /**
   * Sender Address
   */
  sender_address?: string | null;
};

/**
 * CreateSalesforceCaseParamsV1
 */
export type CreateSalesforceCaseParamsV1 = {
  /**
   * Subject
   */
  subject: string;
  /**
   * Description
   */
  description?: string | null;
  /**
   * Status
   */
  status?: string | null;
  /**
   * Priority
   */
  priority?: string | null;
  /**
   * Origin
   */
  origin?: string | null;
  /**
   * Type
   */
  type?: string | null;
  /**
   * Reason
   */
  reason?: string | null;
  /**
   * Is Escalated
   */
  is_escalated?: boolean | null;
  /**
   * Parent Id
   */
  parent_id?: string | null;
  /**
   * Record Type Id
   */
  record_type_id?: string | null;
  /**
   * Contact Id
   */
  contact_id?: string | null;
  /**
   * Account Id
   */
  account_id?: string | null;
  /**
   * Supplied Name
   */
  supplied_name?: string | null;
  /**
   * Supplied Email
   */
  supplied_email?: string | null;
  /**
   * Supplied Phone
   */
  supplied_phone?: string | null;
  /**
   * Supplied Company
   */
  supplied_company?: string | null;
  /**
   * Custom Fields
   */
  custom_fields?: {
    [key: string]: JsonInput;
  } | null;
};

/**
 * CreateSalesforceTenantParamsV1
 */
export type CreateSalesforceTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
};

/**
 * CreateSecretParamsV1
 */
export type CreateSecretParamsV1 = {
  /**
   * Name
   */
  name: string;
  /**
   * Value
   */
  value: string;
  /**
   * Description
   */
  description: string;
  /**
   * Version Description
   */
  version_description: string;
};

/**
 * CreateSecretParamsV2
 */
export type CreateSecretParamsV2 = {
  /**
   * Name
   */
  name: string;
  /**
   * Description
   */
  description: string;
  /**
   * Version Description
   */
  version_description: string;
  /**
   * Value
   */
  value:
    | ({
        kind: "GENERIC";
      } & GenericSecretValueParamsV1)
    | ({
        kind: "API_KEY";
      } & ApiKeySecretValueParamsV1)
    | ({
        kind: "OAUTH";
      } & OauthSecretValueParamsV1);
};

/**
 * CreateServiceNowArticleV1
 */
export type CreateServiceNowArticleV1 = {
  knowledge_base_sys_id: SanitizedStr;
  short_description?: SanitizedStr | null;
  text?: SanitizedStr | null;
};

/**
 * CreateServiceNowKnowledgeBaseV1
 */
export type CreateServiceNowKnowledgeBaseV1 = {
  title: SanitizedStr;
  description?: SanitizedStr | null;
};

/**
 * CreateSharepointFolderScopeParamsV1
 */
export type CreateSharepointFolderScopeParamsV1 = {
  /**
   * Site Id
   */
  site_id: string;
  /**
   * Drive Id
   */
  drive_id: string;
  /**
   * Root Item Id
   */
  root_item_id: string;
  /**
   * Display Path
   */
  display_path: string;
  /**
   * Display Name
   */
  display_name: string;
};

/**
 * CreateSharepointItemUploadSessionParamsV1
 */
export type CreateSharepointItemUploadSessionParamsV1 = {
  /**
   * Name
   */
  name: string;
};

/**
 * CreateSharepointSiteParamsV1
 */
export type CreateSharepointSiteParamsV1 = {
  /**
   * Site Url
   */
  site_url: string;
};

/**
 * CreateSharepointTenantParamsV1
 */
export type CreateSharepointTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Azure Tenant Id
   */
  azure_tenant_id: string;
  auth_kind: SharepointAuthKindV1;
};

/**
 * CreateSimulationDatapointConversationsV1
 */
export type CreateSimulationDatapointConversationsV1 = {
  /**
   * Model
   */
  model: Array<CreateConversationMessageV1>;
  /**
   * View
   */
  view: Array<CreateConversationMessageV1>;
};

/**
 * CreateSimulationDatapointParamsV1
 */
export type CreateSimulationDatapointParamsV1 = {
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  extracted_input: CreateSimulationDatapointConversationsV1;
  extracted_output: CreateSimulationDatapointConversationsV1;
  /**
   * External Created At
   */
  external_created_at?: Date | null;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateSimulationDatapointsParamsV1
 */
export type CreateSimulationDatapointsParamsV1 = {
  /**
   * Items
   */
  items: Array<CreateSimulationDatapointParamsV1>;
};

/**
 * CreateSimulationDatapointsResultV1
 */
export type CreateSimulationDatapointsResultV1 = {
  /**
   * Datapoints
   */
  datapoints: Array<SimulationDatapointV1>;
};

/**
 * CreateSimulationResultJudgementBatchItemV1
 */
export type CreateSimulationResultJudgementBatchItemV1 = {
  /**
   * Simulation Result Id
   */
  simulation_result_id: number;
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Ordinal Value
   */
  ordinal_value: string;
  /**
   * Reasoning
   */
  reasoning?: string | null;
  /**
   * External Created At
   */
  external_created_at?: Date | null;
};

/**
 * CreateSimulationResultJudgementItemV1
 */
export type CreateSimulationResultJudgementItemV1 = {
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Ordinal Value
   */
  ordinal_value: string;
  /**
   * Reasoning
   */
  reasoning?: string | null;
  /**
   * External Created At
   */
  external_created_at?: Date | null;
};

/**
 * CreateSimulationResultJudgementsBatchParamsV1
 */
export type CreateSimulationResultJudgementsBatchParamsV1 = {
  /**
   * Items
   */
  items: Array<CreateSimulationResultJudgementBatchItemV1>;
};

/**
 * CreateSimulationResultJudgementsBatchResultV1
 */
export type CreateSimulationResultJudgementsBatchResultV1 = {
  /**
   * Judgements
   */
  judgements: Array<SimulationResultJudgementV1>;
};

/**
 * CreateSimulationResultJudgementsParamsV1
 */
export type CreateSimulationResultJudgementsParamsV1 = {
  /**
   * Items
   */
  items: Array<CreateSimulationResultJudgementItemV1>;
};

/**
 * CreateSimulationResultJudgementsResultV1
 */
export type CreateSimulationResultJudgementsResultV1 = {
  /**
   * Judgements
   */
  judgements: Array<SimulationResultJudgementV1>;
};

/**
 * CreateSimulationResultParamsV1
 */
export type CreateSimulationResultParamsV1 = {
  /**
   * Commit Id
   */
  commit_id: number;
  /**
   * Simulation Datapoint Id
   */
  simulation_datapoint_id: number;
  output: SimulationResultOutputV1;
  /**
   * External Created At
   */
  external_created_at?: Date | null;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * CreateSimulationResultsParamsV1
 */
export type CreateSimulationResultsParamsV1 = {
  /**
   * Items
   */
  items: Array<CreateSimulationResultParamsV1>;
};

/**
 * CreateSimulationResultsResultV1
 */
export type CreateSimulationResultsResultV1 = {
  /**
   * Results
   */
  results: Array<SimulationResultV1>;
};

/**
 * CreateSlackTenantParamsV1
 */
export type CreateSlackTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Description
   */
  description?: string | null;
  /**
   * Background Color
   */
  background_color?: string | null;
  /**
   * Scopes
   */
  scopes?: Array<SlackOauthScope> | null;
};

/**
 * CreateStatefulInferenceConversationInferencePayloadV1
 *
 * Run inference on a stateful conversation.
 *
 * Appends the provided messages to the conversation identified by
 * ``external_id`` and runs inference on the full conversation
 * history.  When no matching conversation exists a new one is
 * created.
 */
export type CreateStatefulInferenceConversationInferencePayloadV1 = {
  /**
   * Task Id
   *
   * Unique identifier of the task.
   */
  task_id: number;
  /**
   * Messages
   *
   * One or more messages to append before running inference.
   */
  messages?: CreateConversationMessageV1 | Array<CreateConversationMessageV1>;
  /**
   * Created At
   *
   * The timestamp of when the conversation was created.
   */
  created_at?: Date | Missing | null;
  /**
   * Added Metadata
   *
   * Metadata keys to add or update on the conversation.
   */
  added_metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Removed Metadata
   *
   * Metadata keys to remove from the conversation.
   */
  removed_metadata?: Array<SanitizedStr>;
  /**
   * Added Tags
   *
   * Tags to add or update on the conversation.
   */
  added_tags?: {
    [key: string]: string;
  };
  /**
   * Removed Tags
   *
   * Tag keys to remove from the conversation.
   */
  removed_tags?: Array<string>;
  /**
   * The inference mode to use.
   */
  mode?: InferenceModeV1;
};

/**
 * CreateStatelessConversationInferenceV1
 *
 * A conversation between a user and an assistant.
 */
export type CreateStatelessConversationInferenceV1 = {
  /**
   * Task Id
   *
   * Unique identifier of the task being used.
   */
  task_id: number;
  /**
   * Messages
   *
   * The messages in the conversation.
   */
  messages: Array<ConversationMessageV1>;
  /**
   * Created At
   *
   * The timestamp of when the conversation was created.
   */
  created_at?: Date | Missing;
  /**
   * Metadata
   *
   * Additional metadata associated with the conversation, used during inference.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Conversation tags.
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * The inference mode to use.
   */
  mode?: InferenceModeV1;
};

/**
 * CreateStatelessInferenceConversationInferencePayloadV1
 *
 * Create a stateless conversation inference.
 */
export type CreateStatelessInferenceConversationInferencePayloadV1 = {
  /**
   * Task Id
   *
   * Unique identifier of the task.
   */
  task_id: number;
  /**
   * Messages
   *
   * The messages in the conversation.
   */
  messages: Array<CreateConversationMessageV1>;
  /**
   * Created At
   *
   * The timestamp of when the conversation was created.
   */
  created_at?: Date | Missing;
  /**
   * Added Metadata
   *
   * Metadata keys to add or update on the conversation.
   */
  added_metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Removed Metadata
   *
   * Metadata keys to remove from the conversation.
   */
  removed_metadata?: Array<SanitizedStr>;
  /**
   * Added Tags
   *
   * Tags to add or update on the conversation.
   */
  added_tags?: {
    [key: string]: string;
  };
  /**
   * Removed Tags
   *
   * Tag keys to remove from the conversation.
   */
  removed_tags?: Array<string>;
  /**
   * The inference mode to use.
   */
  mode?: InferenceModeV1;
};

/**
 * CreateSupportIngestionFileItemV1
 */
export type CreateSupportIngestionFileItemV1 = {
  s3_uri: SanitizedStr;
  version_id: SanitizedStr;
};

/**
 * CreateSupportIngestionFilesParamsV1
 */
export type CreateSupportIngestionFilesParamsV1 = {
  /**
   * Items
   */
  items: Array<CreateSupportIngestionFileItemV1>;
};

/**
 * CreateTaskParamsV2
 */
export type CreateTaskParamsV2 = {
  /**
   * Name
   */
  name: string;
  /**
   * Task Template
   */
  task_template: string;
};

/**
 * CreateTeamParamsV1
 */
export type CreateTeamParamsV1 = {
  /**
   * Name
   */
  name: string;
};

/**
 * CreateTeamsTenantParamsV1
 */
export type CreateTeamsTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name: string;
};

/**
 * CreateWorkClaimParamsV1
 */
export type CreateWorkClaimParamsV1 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Key
   */
  key: string;
  /**
   * Retry Window Seconds
   */
  retry_window_seconds: number;
};

/**
 * CreateWorkClaimResponseV1
 */
export type CreateWorkClaimResponseV1 = {
  claim: WorkClaimV1 | null;
};

/**
 * CreateWorkEventParamsV1
 */
export type CreateWorkEventParamsV1 = {
  /**
   * Stream Id
   */
  stream_id: string;
  /**
   * Event Type
   */
  event_type: string;
  /**
   * Payload
   */
  payload: {
    [key: string]: JsonInput;
  };
  /**
   * Caused By Event Id
   */
  caused_by_event_id?: number | null;
  /**
   * Repo Ids
   */
  repo_ids?: Array<number>;
  /**
   * Git Object Ids
   */
  git_object_ids?: Array<number>;
};

/**
 * CreateWorkflowAnalyticsEventRequestV1
 */
export type CreateWorkflowAnalyticsEventRequestV1 = {
  /**
   * Event Name
   */
  event_name: string;
  /**
   * Idempotency Key
   */
  idempotency_key: string;
  /**
   * Additional Fields
   */
  additional_fields: {
    [key: string]: JsonInput;
  };
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * CreateWorkflowAnalyticsEventResponseV1
 */
export type CreateWorkflowAnalyticsEventResponseV1 = {
  /**
   * Id
   */
  id: number;
};

/**
 * CursorPageV1[ConfluenceAttachmentV1]
 */
export type CursorPageV1ConfluenceAttachmentV1 = {
  /**
   * Items
   */
  items: Array<ConfluenceAttachmentV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[ConfluenceCommentV1]
 */
export type CursorPageV1ConfluenceCommentV1 = {
  /**
   * Items
   */
  items: Array<ConfluenceCommentV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[ConfluenceLabelV1]
 */
export type CursorPageV1ConfluenceLabelV1 = {
  /**
   * Items
   */
  items: Array<ConfluenceLabelV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[ConfluencePageV1]
 */
export type CursorPageV1ConfluencePageV1 = {
  /**
   * Items
   */
  items: Array<ConfluencePageV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[ConfluenceSpaceV1]
 */
export type CursorPageV1ConfluenceSpaceV1 = {
  /**
   * Items
   */
  items: Array<ConfluenceSpaceV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[NotionCommentV1]
 */
export type CursorPageV1NotionCommentV1 = {
  /**
   * Items
   */
  items: Array<NotionCommentV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[NotionDatabaseV1]
 */
export type CursorPageV1NotionDatabaseV1 = {
  /**
   * Items
   */
  items: Array<NotionDatabaseV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[NotionPageV1]
 */
export type CursorPageV1NotionPageV1 = {
  /**
   * Items
   */
  items: Array<NotionPageV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[PlainCompanyV1]
 */
export type CursorPageV1PlainCompanyV1 = {
  /**
   * Items
   */
  items: Array<PlainCompanyV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[PlainCustomerGroupV1]
 */
export type CursorPageV1PlainCustomerGroupV1 = {
  /**
   * Items
   */
  items: Array<PlainCustomerGroupV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[PlainCustomerTenantV1]
 */
export type CursorPageV1PlainCustomerTenantV1 = {
  /**
   * Items
   */
  items: Array<PlainCustomerTenantV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[PlainCustomerV1]
 */
export type CursorPageV1PlainCustomerV1 = {
  /**
   * Items
   */
  items: Array<PlainCustomerV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[PlainThreadV1]
 */
export type CursorPageV1PlainThreadV1 = {
  /**
   * Items
   */
  items: Array<PlainThreadV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[PlainTimelineEntryV1]
 */
export type CursorPageV1PlainTimelineEntryV1 = {
  /**
   * Items
   */
  items: Array<PlainTimelineEntryV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[SharepointDriveItemV1]
 */
export type CursorPageV1SharepointDriveItemV1 = {
  /**
   * Items
   */
  items: Array<SharepointDriveItemV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[SharepointDriveV1]
 */
export type CursorPageV1SharepointDriveV1 = {
  /**
   * Items
   */
  items: Array<SharepointDriveV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[SimulationCompareV1]
 */
export type CursorPageV1SimulationCompareV1 = {
  /**
   * Items
   */
  items: Array<SimulationCompareV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[SimulationRunV1]
 */
export type CursorPageV1SimulationRunV1 = {
  /**
   * Items
   */
  items: Array<SimulationRunV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * CursorPageV1[WorkEventFullV1]
 */
export type CursorPageV1WorkEventFullV1 = {
  /**
   * Items
   */
  items: Array<WorkEventFullV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * DataDumpConversationFullV1
 */
export type DataDumpConversationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  conversation: ConversationFullV2;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * DataDumpConversationV1
 */
export type DataDumpConversationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * DatapointEvidenceV1
 */
export type DatapointEvidenceV1 = {
  datapoint: DatapointFullV3;
  finalized_conversation: FinalizedConversationFullV2;
};

/**
 * DatapointExtractedInputOutputFullV1
 */
export type DatapointExtractedInputOutputFullV1 = {
  extracted_input: ExtractedMessagesAndSpansFullV1;
  extracted_output: ExtractedMessagesAndSpansFullV1;
};

/**
 * DatapointExtractedInputOutputFullV2
 */
export type DatapointExtractedInputOutputFullV2 = {
  extracted_input: ExtractedConversationFullV2;
  extracted_output: ExtractedConversationFullV2;
};

/**
 * DatapointExtractedInputOutputV2
 */
export type DatapointExtractedInputOutputV2 = {
  extracted_input: ExtractedConversationV2;
  extracted_output: ExtractedConversationV2;
};

/**
 * DatapointFullV3
 */
export type DatapointFullV3 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  model: DatapointExtractedInputOutputFullV2;
  view: DatapointExtractedInputOutputFullV2;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * DatapointV2
 */
export type DatapointV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * DebugFgaTupleV1
 */
export type DebugFgaTupleV1 = {
  user: SanitizedStr;
  relation: SanitizedStr;
  object: SanitizedStr;
};

/**
 * DebugOpenFgaCheckParamsV1
 */
export type DebugOpenFgaCheckParamsV1 = {
  user: SanitizedStr;
  relation: SanitizedStr;
  object: SanitizedStr;
};

/**
 * DebugOpenFgaCheckResultV1
 */
export type DebugOpenFgaCheckResultV1 = {
  /**
   * Allowed
   */
  allowed: boolean;
};

/**
 * DebugOpenFgaReadParamsV1
 */
export type DebugOpenFgaReadParamsV1 = {
  user?: SanitizedStr | null;
  relation?: SanitizedStr | null;
  object?: SanitizedStr | null;
};

/**
 * DebugOpenFgaReadResultV1
 */
export type DebugOpenFgaReadResultV1 = {
  /**
   * Tuples
   */
  tuples?: Array<DebugFgaTupleV1>;
};

/**
 * DebugOpenFgaWriteParamsV1
 */
export type DebugOpenFgaWriteParamsV1 = {
  /**
   * Writes
   */
  writes?: Array<DebugFgaTupleV1>;
  /**
   * Deletes
   */
  deletes?: Array<DebugFgaTupleV1>;
};

/**
 * DebugOpenFgaWriteResultV1
 */
export type DebugOpenFgaWriteResultV1 = {
  /**
   * Written
   */
  written: number;
  /**
   * Deleted
   */
  deleted: number;
};

/**
 * DebugReaderPoolCheckV1
 */
export type DebugReaderPoolCheckV1 = {
  /**
   * Article Count
   */
  article_count: number;
};

/**
 * DeleteSubscriptionResponseV2
 */
export type DeleteSubscriptionResponseV2 = {
  /**
   * Deleted Subscription Id
   */
  deleted_subscription_id: string;
};

export type DiffEntryV2 =
  | ({
      kind: "article_v1_added";
    } & GitDiffEntryArticleV1AddedV2)
  | ({
      kind: "article_v1_modified";
    } & GitDiffEntryArticleV1ModifiedV2)
  | ({
      kind: "article_v1_removed";
    } & GitDiffEntryArticleV1RemovedV2)
  | ({
      kind: "blob_added";
    } & GitDiffEntryBlobAddedV2)
  | ({
      kind: "blob_modified";
    } & GitDiffEntryBlobModifiedV2)
  | ({
      kind: "blob_removed";
    } & GitDiffEntryBlobRemovedV2)
  | ({
      kind: "moved";
    } & GitDiffEntryMovedV2)
  | ({
      kind: "reordered";
    } & GitDiffEntryReorderedV2);

/**
 * EdraAccessGrantResultV1
 */
export const EdraAccessGrantResultV1 = {
  CREATED: "created",
  MEMBER_ADDED: "member_added",
  ALREADY_INVITED: "already_invited",
  ALREADY_MEMBER: "already_member",
} as const;

/**
 * EdraAccessGrantResultV1
 */
export type EdraAccessGrantResultV1 =
  (typeof EdraAccessGrantResultV1)[keyof typeof EdraAccessGrantResultV1];

/**
 * EdraAccessGrantV1
 */
export type EdraAccessGrantV1 = {
  /**
   * Org Id
   */
  org_id: number;
  result: EdraAccessGrantResultV1;
  /**
   * Invitation Id
   */
  invitation_id?: number | null;
};

/**
 * EdraAccessRemovalResultV1
 */
export const EdraAccessRemovalResultV1 = {
  INVITATION_REVOKED: "invitation_revoked",
  MEMBERSHIP_REMOVED: "membership_removed",
  NO_ACCESS: "no_access",
} as const;

/**
 * EdraAccessRemovalResultV1
 */
export type EdraAccessRemovalResultV1 =
  (typeof EdraAccessRemovalResultV1)[keyof typeof EdraAccessRemovalResultV1];

/**
 * EdraAccessRemovalV1
 */
export type EdraAccessRemovalV1 = {
  /**
   * Org Id
   */
  org_id: number;
  result: EdraAccessRemovalResultV1;
};

/**
 * EdraAccessRoleChangeV1
 */
export type EdraAccessRoleChangeV1 = {
  /**
   * Org Id
   */
  org_id: number;
  role_before?: EdraAccessRoleV1 | null;
  role_after: EdraAccessRoleV1;
};

/**
 * EdraAccessRoleParamsV1
 */
export type EdraAccessRoleParamsV1 = {
  role: EdraAccessRoleV1;
  /**
   * Email
   */
  email?: string | null;
};

/**
 * EdraAccessRoleV1
 */
export const EdraAccessRoleV1 = { MEMBER: "member", ADMIN: "admin" } as const;

/**
 * EdraAccessRoleV1
 */
export type EdraAccessRoleV1 =
  (typeof EdraAccessRoleV1)[keyof typeof EdraAccessRoleV1];

/**
 * EdraAccessStateV1
 */
export const EdraAccessStateV1 = {
  HAS_ACCESS: "has_access",
  NO_ACCESS: "no_access",
} as const;

/**
 * EdraAccessStateV1
 */
export type EdraAccessStateV1 =
  (typeof EdraAccessStateV1)[keyof typeof EdraAccessStateV1];

/**
 * EdraAccessV1
 */
export type EdraAccessV1 = {
  /**
   * Org Id
   */
  org_id: number;
  access: EdraAccessStateV1;
  role?: EdraAccessRoleV1 | null;
  /**
   * Invitation Pending
   */
  invitation_pending?: boolean;
  /**
   * Invitation Id
   */
  invitation_id?: number | null;
};

/**
 * EmailNotificationSettingV1
 */
export type EmailNotificationSettingV1 = {
  [key: string]: unknown;
};

/**
 * EmbedDatapointsRequestV1
 */
export type EmbedDatapointsRequestV1 = {
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
};

/**
 * EmbedDatapointsResponseV1
 */
export type EmbedDatapointsResponseV1 = {
  [key: string]: unknown;
};

/**
 * EmbedResponseV2
 */
export type EmbedResponseV2 = {
  [key: string]: unknown;
};

/**
 * EmbeddingSearchParamsV1
 */
export type EmbeddingSearchParamsV1 = {
  ref: NonEmptyStr;
  query: SanitizedStr;
  /**
   * Top K
   */
  top_k?: number;
};

/**
 * EmbeddingSearchResponseV1
 */
export type EmbeddingSearchResponseV1 = {
  /**
   * Sources
   */
  sources: Array<EmbeddingSearchSourceV1>;
};

/**
 * EmbeddingSearchSourceV1
 */
export type EmbeddingSearchSourceV1 = {
  /**
   * Path
   */
  path: string;
  article: GitArticleV1;
};

/**
 * EntraAddGroupMemberActionV1
 */
export type EntraAddGroupMemberActionV1 = {
  /**
   * Kind
   */
  kind: "add_group_member";
  /**
   * Group Id
   */
  group_id: string;
  /**
   * User Id
   */
  user_id: string;
};

/**
 * EntraAssignLicenseActionV1
 */
export type EntraAssignLicenseActionV1 = {
  /**
   * Kind
   */
  kind: "assign_license";
  /**
   * User Id
   */
  user_id: string;
  /**
   * Sku Id
   */
  sku_id: string;
  /**
   * Disabled Plan Ids
   */
  disabled_plan_ids?: Array<string>;
};

/**
 * EntraCallerIdentityV1
 */
export type EntraCallerIdentityV1 = {
  /**
   * Object Id
   */
  object_id: string;
  /**
   * User Principal Name
   */
  user_principal_name: string;
  /**
   * Mail
   */
  mail: string | null;
  /**
   * Proxy Addresses
   */
  proxy_addresses: Array<string>;
  /**
   * User Type
   */
  user_type: string | null;
  /**
   * Routable Email
   */
  routable_email: string | null;
};

/**
 * EntraCallerTokenModeV1
 */
export const EntraCallerTokenModeV1 = {
  ON_BEHALF_OF: "on_behalf_of",
  FORWARD_GRAPH_TOKEN: "forward_graph_token",
} as const;

/**
 * EntraCallerTokenModeV1
 */
export type EntraCallerTokenModeV1 =
  (typeof EntraCallerTokenModeV1)[keyof typeof EntraCallerTokenModeV1];

/**
 * EntraCapabilityCheckV1
 */
export type EntraCapabilityCheckV1 = {
  capability: EntraCapabilityV1;
  /**
   * Accepted Role Sets
   */
  accepted_role_sets: Array<Array<string>>;
  /**
   * Granted
   */
  granted: boolean;
};

/**
 * EntraCapabilityV1
 */
export const EntraCapabilityV1 = {
  READ_USERS: "read_users",
  READ_GROUPS: "read_groups",
  READ_LICENSES: "read_licenses",
  READ_ORGANIZATION: "read_organization",
  READ_SIGN_IN_ACTIVITY: "read_sign_in_activity",
  READ_DIRECTORY_ROLES: "read_directory_roles",
  WRITE_GROUP_MEMBERS: "write_group_members",
  WRITE_USER_ACCOUNT_ENABLED: "write_user_account_enabled",
  WRITE_USER_MANAGER: "write_user_manager",
  WRITE_LICENSES: "write_licenses",
  DELETE_USERS: "delete_users",
} as const;

/**
 * EntraCapabilityV1
 */
export type EntraCapabilityV1 =
  (typeof EntraCapabilityV1)[keyof typeof EntraCapabilityV1];

/**
 * EntraCertificateCredentialsParamsV1
 */
export type EntraCertificateCredentialsParamsV1 = {
  /**
   * Kind
   */
  kind: "certificate";
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Certificate Private Key Pem
   */
  certificate_private_key_pem: string;
  /**
   * Certificate Thumbprint
   */
  certificate_thumbprint: string;
  /**
   * Expires At
   */
  expires_at?: Date | null;
};

export type EntraCheckConnectionResponseV1 =
  | ({
      status: "connected";
    } & EntraConnectedV1)
  | ({
      status: "disconnected";
    } & EntraDisconnectedV1);

/**
 * EntraClientSecretCredentialsParamsV1
 */
export type EntraClientSecretCredentialsParamsV1 = {
  /**
   * Kind
   */
  kind: "client_secret";
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
  /**
   * Expires At
   */
  expires_at?: Date | null;
};

/**
 * EntraConnectedV1
 */
export type EntraConnectedV1 = {
  /**
   * Status
   */
  status: "connected";
  organization: EntraOrganizationV1;
};

/**
 * EntraCredentialKindV1
 */
export const EntraCredentialKindV1 = {
  CLIENT_SECRET: "client_secret",
  CERTIFICATE: "certificate",
} as const;

/**
 * EntraCredentialKindV1
 */
export type EntraCredentialKindV1 =
  (typeof EntraCredentialKindV1)[keyof typeof EntraCredentialKindV1];

/**
 * EntraDeleteUserActionV1
 */
export type EntraDeleteUserActionV1 = {
  /**
   * Kind
   */
  kind: "delete_user";
  /**
   * User Id
   */
  user_id: string;
};

/**
 * EntraDirectoryObjectPageV1
 */
export type EntraDirectoryObjectPageV1 = {
  /**
   * Items
   */
  items: Array<EntraDirectoryObjectV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * EntraDirectoryObjectV1
 */
export type EntraDirectoryObjectV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Object Type
   */
  object_type: string;
  /**
   * Display Name
   */
  display_name: string | null;
  /**
   * User Principal Name
   */
  user_principal_name: string | null;
};

/**
 * EntraDirectoryRoleV1
 */
export type EntraDirectoryRoleV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Display Name
   */
  display_name: string | null;
  /**
   * Description
   */
  description: string | null;
  /**
   * Role Template Id
   */
  role_template_id: string | null;
};

/**
 * EntraDirectoryRolesV1
 */
export type EntraDirectoryRolesV1 = {
  /**
   * Items
   */
  items: Array<EntraDirectoryRoleV1>;
};

/**
 * EntraDisableUserActionV1
 */
export type EntraDisableUserActionV1 = {
  /**
   * Kind
   */
  kind: "disable_user";
  /**
   * User Id
   */
  user_id: string;
  /**
   * Revoke Sessions
   */
  revoke_sessions?: boolean;
};

/**
 * EntraDisconnectedV1
 */
export type EntraDisconnectedV1 = {
  /**
   * Status
   */
  status: "disconnected";
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * EntraGroupKindV1
 */
export const EntraGroupKindV1 = {
  MICROSOFT_365: "microsoft_365",
  SECURITY: "security",
  MAIL_ENABLED_SECURITY: "mail_enabled_security",
  DISTRIBUTION: "distribution",
} as const;

/**
 * EntraGroupKindV1
 */
export type EntraGroupKindV1 =
  (typeof EntraGroupKindV1)[keyof typeof EntraGroupKindV1];

/**
 * EntraGroupMembershipKindV1
 */
export const EntraGroupMembershipKindV1 = {
  ASSIGNED: "assigned",
  DYNAMIC: "dynamic",
} as const;

/**
 * EntraGroupMembershipKindV1
 */
export type EntraGroupMembershipKindV1 =
  (typeof EntraGroupMembershipKindV1)[keyof typeof EntraGroupMembershipKindV1];

/**
 * EntraGroupPageV1
 */
export type EntraGroupPageV1 = {
  /**
   * Items
   */
  items: Array<EntraGroupV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * EntraGroupV1
 */
export type EntraGroupV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Display Name
   */
  display_name: string | null;
  /**
   * Description
   */
  description: string | null;
  /**
   * Mail
   */
  mail: string | null;
  group_kind: EntraGroupKindV1;
  membership_kind: EntraGroupMembershipKindV1;
  /**
   * Membership Rule
   */
  membership_rule: string | null;
  /**
   * Membership Rule Processing State
   */
  membership_rule_processing_state: string | null;
};

/**
 * EntraLicenseDetailV1
 */
export type EntraLicenseDetailV1 = {
  /**
   * Sku Id
   */
  sku_id: string;
  /**
   * Sku Part Number
   */
  sku_part_number: string | null;
  /**
   * Service Plans
   */
  service_plans: Array<EntraServicePlanV1>;
};

/**
 * EntraLicenseDetailsV1
 */
export type EntraLicenseDetailsV1 = {
  /**
   * Items
   */
  items: Array<EntraLicenseDetailV1>;
};

/**
 * EntraOrganizationV1
 */
export type EntraOrganizationV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Display Name
   */
  display_name: string | null;
};

/**
 * EntraPermissionPreflightV1
 */
export type EntraPermissionPreflightV1 = {
  /**
   * Granted Roles
   */
  granted_roles: Array<string>;
  /**
   * Checks
   */
  checks: Array<EntraCapabilityCheckV1>;
};

/**
 * EntraProposedActionExecutedV1
 */
export type EntraProposedActionExecutedV1 = {
  /**
   * Status
   */
  status: "executed";
  /**
   * Decided By User Id
   */
  decided_by_user_id: number;
  /**
   * Decided At
   */
  decided_at: Date;
  /**
   * Settled At
   */
  settled_at: Date;
};

/**
 * EntraProposedActionExecutingV1
 */
export type EntraProposedActionExecutingV1 = {
  /**
   * Status
   */
  status: "executing";
  /**
   * Decided By User Id
   */
  decided_by_user_id: number;
  /**
   * Decided At
   */
  decided_at: Date;
};

/**
 * EntraProposedActionFailedV1
 */
export type EntraProposedActionFailedV1 = {
  /**
   * Status
   */
  status: "failed";
  /**
   * Decided By User Id
   */
  decided_by_user_id: number;
  /**
   * Decided At
   */
  decided_at: Date;
  /**
   * Settled At
   */
  settled_at: Date;
  /**
   * Failure Status
   */
  failure_status: number;
  /**
   * Failure Detail
   */
  failure_detail: string | null;
};

/**
 * EntraProposedActionProposedV1
 */
export type EntraProposedActionProposedV1 = {
  /**
   * Status
   */
  status: "proposed";
};

/**
 * EntraProposedActionRejectedV1
 */
export type EntraProposedActionRejectedV1 = {
  /**
   * Status
   */
  status: "rejected";
  /**
   * Decided By User Id
   */
  decided_by_user_id: number;
  /**
   * Decided At
   */
  decided_at: Date;
  /**
   * Decision Note
   */
  decision_note: string | null;
};

export type EntraProposedActionSpecV1 =
  | ({
      kind: "add_group_member";
    } & EntraAddGroupMemberActionV1)
  | ({
      kind: "remove_group_member";
    } & EntraRemoveGroupMemberActionV1)
  | ({
      kind: "disable_user";
    } & EntraDisableUserActionV1)
  | ({
      kind: "delete_user";
    } & EntraDeleteUserActionV1)
  | ({
      kind: "assign_license";
    } & EntraAssignLicenseActionV1)
  | ({
      kind: "remove_license";
    } & EntraRemoveLicenseActionV1)
  | ({
      kind: "set_manager";
    } & EntraSetManagerActionV1);

export type EntraProposedActionStatusV1 =
  | ({
      status: "proposed";
    } & EntraProposedActionProposedV1)
  | ({
      status: "executing";
    } & EntraProposedActionExecutingV1)
  | ({
      status: "executed";
    } & EntraProposedActionExecutedV1)
  | ({
      status: "failed";
    } & EntraProposedActionFailedV1)
  | ({
      status: "rejected";
    } & EntraProposedActionRejectedV1);

/**
 * EntraProposedActionV1
 */
export type EntraProposedActionV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Id
   */
  tenant_id: number;
  action: EntraProposedActionSpecV1;
  /**
   * Rationale
   */
  rationale: string;
  /**
   * Proposed By User Id
   */
  proposed_by_user_id: number | null;
  /**
   * Workflow Run Id
   */
  workflow_run_id: number | null;
  status: EntraProposedActionStatusV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * EntraRemoveGroupMemberActionV1
 */
export type EntraRemoveGroupMemberActionV1 = {
  /**
   * Kind
   */
  kind: "remove_group_member";
  /**
   * Group Id
   */
  group_id: string;
  /**
   * User Id
   */
  user_id: string;
};

/**
 * EntraRemoveLicenseActionV1
 */
export type EntraRemoveLicenseActionV1 = {
  /**
   * Kind
   */
  kind: "remove_license";
  /**
   * User Id
   */
  user_id: string;
  /**
   * Sku Id
   */
  sku_id: string;
};

/**
 * EntraServicePlanV1
 */
export type EntraServicePlanV1 = {
  /**
   * Service Plan Id
   */
  service_plan_id: string;
  /**
   * Service Plan Name
   */
  service_plan_name: string | null;
  /**
   * Provisioning Status
   */
  provisioning_status: string | null;
  /**
   * Applies To
   */
  applies_to: string | null;
};

/**
 * EntraSetManagerActionV1
 */
export type EntraSetManagerActionV1 = {
  /**
   * Kind
   */
  kind: "set_manager";
  /**
   * User Id
   */
  user_id: string;
  /**
   * Manager Id
   */
  manager_id: string;
};

/**
 * EntraSignInStateV1
 */
export type EntraSignInStateV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Account Enabled
   */
  account_enabled: boolean | null;
  /**
   * On Premises Sync Enabled
   */
  on_premises_sync_enabled: boolean | null;
  /**
   * Last Sign In At
   */
  last_sign_in_at: Date | null;
  /**
   * Last Non Interactive Sign In At
   */
  last_non_interactive_sign_in_at: Date | null;
};

/**
 * EntraSubscribedSkuV1
 */
export type EntraSubscribedSkuV1 = {
  /**
   * Sku Id
   */
  sku_id: string;
  /**
   * Sku Part Number
   */
  sku_part_number: string | null;
  /**
   * Capability Status
   */
  capability_status: string | null;
  /**
   * Consumed Units
   */
  consumed_units: number;
  /**
   * Enabled Units
   */
  enabled_units: number;
  /**
   * Suspended Units
   */
  suspended_units: number;
  /**
   * Warning Units
   */
  warning_units: number;
  /**
   * Service Plans
   */
  service_plans: Array<EntraServicePlanV1>;
};

/**
 * EntraSubscribedSkusV1
 */
export type EntraSubscribedSkusV1 = {
  /**
   * Items
   */
  items: Array<EntraSubscribedSkuV1>;
};

export type EntraTenantCredentialsParamsV1 =
  | ({
      kind: "client_secret";
    } & EntraClientSecretCredentialsParamsV1)
  | ({
      kind: "certificate";
    } & EntraCertificateCredentialsParamsV1);

/**
 * EntraTenantCredentialsSummaryV1
 */
export type EntraTenantCredentialsSummaryV1 = {
  kind: EntraCredentialKindV1;
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Certificate Thumbprint
   */
  certificate_thumbprint: string | null;
  /**
   * Expires At
   */
  expires_at: Date | null;
};

/**
 * EntraTenantFullV1
 */
export type EntraTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Directory Tenant Id
   */
  directory_tenant_id: string;
  caller_token_mode: EntraCallerTokenModeV1 | null;
  /**
   * Administrative Unit Object Id
   */
  administrative_unit_object_id: string | null;
  /**
   * Scope Group Object Ids
   */
  scope_group_object_ids: Array<string>;
  /**
   * Created By User Id
   */
  created_by_user_id: number | null;
  credentials: EntraTenantCredentialsSummaryV1 | null;
  /**
   * Has Credentials
   */
  has_credentials: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * EntraTenantV1
 */
export type EntraTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Directory Tenant Id
   */
  directory_tenant_id: string;
  caller_token_mode: EntraCallerTokenModeV1 | null;
  /**
   * Administrative Unit Object Id
   */
  administrative_unit_object_id: string | null;
  /**
   * Created By User Id
   */
  created_by_user_id: number | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * EntraUserManagerV1
 */
export type EntraUserManagerV1 = {
  manager: EntraUserV1 | null;
};

/**
 * EntraUserPageV1
 */
export type EntraUserPageV1 = {
  /**
   * Items
   */
  items: Array<EntraUserV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * EntraUserV1
 */
export type EntraUserV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * User Principal Name
   */
  user_principal_name: string;
  /**
   * Mail
   */
  mail: string | null;
  /**
   * Display Name
   */
  display_name: string | null;
  /**
   * Employee Id
   */
  employee_id: string | null;
  /**
   * Department
   */
  department: string | null;
  /**
   * Job Title
   */
  job_title: string | null;
  /**
   * User Type
   */
  user_type: string | null;
  /**
   * Account Enabled
   */
  account_enabled: boolean | null;
  /**
   * On Premises Sync Enabled
   */
  on_premises_sync_enabled: boolean | null;
};

/**
 * EvalJudgeV1
 */
export type EvalJudgeV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * EvalKindV1
 */
export const EvalKindV1 = {
  STRICT_COMPARISON: "STRICT_COMPARISON",
  LLM_JUDGE: "LLM_JUDGE",
} as const;

/**
 * EvalKindV1
 */
export type EvalKindV1 = (typeof EvalKindV1)[keyof typeof EvalKindV1];

/**
 * EvaluatedInferenceDatapointV1
 */
export type EvaluatedInferenceDatapointV1 = {
  /**
   * Id
   */
  id: number;
  finalized_conversation: FinalizedConversationFullV1;
  inference: EvaluatedInferenceFullV1;
  /**
   * Judgements
   */
  judgements: Array<JudgementFullV2>;
};

export type EvaluatedInferenceFullV1 =
  | ({
      kind: "conversation";
    } & InferenceConversationInferenceFullV1)
  | ({
      kind: "external";
    } & ExternalInferenceFullV1);

/**
 * EventSourceNotificationSettingsV1
 */
export type EventSourceNotificationSettingsV1 = {
  slack: SlackNotificationSettingV1 | null;
  email: EmailNotificationSettingV1 | null;
};

/**
 * EvidenceV2
 */
export type EvidenceV2 = {
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
  /**
   * Kanonical Datapoint Ids
   */
  kanonical_datapoint_ids: Array<number>;
};

/**
 * ExternalInferenceCitationV1
 */
export type ExternalInferenceCitationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Content Block Position
   */
  content_block_position: number;
  /**
   * Source Object Article Id
   */
  source_object_article_id: number;
  /**
   * Source Object Article External Id
   */
  source_object_article_external_id: string | null;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * ExternalInferenceFullV1
 */
export type ExternalInferenceFullV1 = {
  /**
   * Kind
   */
  kind: "external";
  /**
   * Inference Id
   */
  inference_id: number;
  source: ExternalInferenceSourceV1;
  /**
   * Output Messages
   */
  output_messages: Array<ConversationMessageFullV2>;
  /**
   * Citations
   */
  citations: Array<ExternalInferenceCitationV1>;
  /**
   * External Created At
   */
  external_created_at: Date;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

export type ExternalInferenceSourceV1 =
  | ({
      kind: "finalized_conversation";
    } & FinalizedConversationSourceV1)
  | ({
      kind: "conversation";
    } & ConversationSourceV1);

/**
 * ExternalInferenceV1
 */
export type ExternalInferenceV1 = {
  /**
   * Inference Id
   */
  inference_id: number;
  source: ExternalInferenceSourceV1;
  /**
   * Citations
   */
  citations: Array<ExternalInferenceCitationV1>;
  /**
   * External Created At
   */
  external_created_at: Date;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ExtractDataDumpConversationsDequeueByDagsterRunV1
 */
export type ExtractDataDumpConversationsDequeueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * ExtractDataDumpConversationsDequeueByIdsV1
 */
export type ExtractDataDumpConversationsDequeueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * File Ids
   */
  file_ids: Array<number>;
};

/**
 * ExtractDataDumpConversationsDequeueRequestV1
 */
export type ExtractDataDumpConversationsDequeueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & ExtractDataDumpConversationsDequeueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & ExtractDataDumpConversationsDequeueByDagsterRunV1);
};

/**
 * ExtractDataDumpConversationsDequeueResponseV1
 */
export type ExtractDataDumpConversationsDequeueResponseV1 = {
  /**
   * Dequeued File Ids
   */
  dequeued_file_ids: Array<number>;
};

/**
 * ExtractDataDumpConversationsEnqueueByDagsterRunV1
 */
export type ExtractDataDumpConversationsEnqueueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * ExtractDataDumpConversationsEnqueueByIdsV1
 */
export type ExtractDataDumpConversationsEnqueueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * File Ids
   */
  file_ids: Array<number>;
};

/**
 * ExtractDataDumpConversationsEnqueueRequestV1
 */
export type ExtractDataDumpConversationsEnqueueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & ExtractDataDumpConversationsEnqueueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & ExtractDataDumpConversationsEnqueueByDagsterRunV1);
};

/**
 * ExtractDataDumpConversationsEnqueueResponseV1
 */
export type ExtractDataDumpConversationsEnqueueResponseV1 = {
  /**
   * Enqueued File Ids
   */
  enqueued_file_ids: Array<number>;
};

/**
 * ExtractDataDumpConversationsInputRequestV1
 */
export type ExtractDataDumpConversationsInputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Max Processing Time
   */
  max_processing_time?: string | Missing;
};

/**
 * ExtractDataDumpConversationsInputResponseV1
 */
export type ExtractDataDumpConversationsInputResponseV1 = {
  /**
   * Items
   */
  items: Array<IngestionFileV1>;
};

/**
 * ExtractDataDumpConversationsOutputRequestV1
 */
export type ExtractDataDumpConversationsOutputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Processed Uris
   */
  processed_uris: Array<SanitizedStr>;
  /**
   * Conversations
   */
  conversations: Array<CreateDataDumpConversationRequestV1>;
};

/**
 * ExtractDataDumpConversationsOutputResponseV1
 */
export type ExtractDataDumpConversationsOutputResponseV1 = {
  /**
   * Processed Count
   */
  processed_count: number;
  /**
   * Unprocessed Count
   */
  unprocessed_count: number;
};

/**
 * ExtractDatapointsDequeueByDagsterRunV1
 */
export type ExtractDatapointsDequeueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * ExtractDatapointsDequeueByIdsV1
 */
export type ExtractDatapointsDequeueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Finalized Conversation Ids
   */
  finalized_conversation_ids: Array<number>;
};

/**
 * ExtractDatapointsDequeueRequestV1
 */
export type ExtractDatapointsDequeueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & ExtractDatapointsDequeueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & ExtractDatapointsDequeueByDagsterRunV1);
};

/**
 * ExtractDatapointsDequeueResponseV1
 */
export type ExtractDatapointsDequeueResponseV1 = {
  /**
   * Dequeued Finalized Conversation Ids
   */
  dequeued_finalized_conversation_ids: Array<number>;
};

/**
 * ExtractDatapointsEnqueueByDagsterRunV1
 */
export type ExtractDatapointsEnqueueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * ExtractDatapointsEnqueueByIdsV1
 */
export type ExtractDatapointsEnqueueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Finalized Conversation Ids
   */
  finalized_conversation_ids: Array<number>;
};

/**
 * ExtractDatapointsEnqueueRequestV1
 */
export type ExtractDatapointsEnqueueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & ExtractDatapointsEnqueueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & ExtractDatapointsEnqueueByDagsterRunV1);
};

/**
 * ExtractDatapointsEnqueueResponseV1
 */
export type ExtractDatapointsEnqueueResponseV1 = {
  /**
   * Enqueued Finalized Conversation Ids
   */
  enqueued_finalized_conversation_ids: Array<number>;
};

/**
 * ExtractDatapointsInputItemV1
 */
export type ExtractDatapointsInputItemV1 = {
  finalized_conversation: FinalizedConversationFullV2;
  /**
   * Existing Datapoints
   */
  existing_datapoints: Array<DatapointFullV3>;
};

/**
 * ExtractDatapointsInputRequestV1
 */
export type ExtractDatapointsInputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Max Processing Time
   */
  max_processing_time?: string | Missing;
};

/**
 * ExtractDatapointsInputResponseV1
 */
export type ExtractDatapointsInputResponseV1 = {
  /**
   * Items
   */
  items: Array<ExtractDatapointsInputItemV1>;
};

/**
 * ExtractDatapointsOutputItemV1
 */
export type ExtractDatapointsOutputItemV1 = {
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  /**
   * Create Datapoints
   */
  create_datapoints: Array<CreateDatapointsDatapointV3>;
};

/**
 * ExtractDatapointsOutputRequestV1
 */
export type ExtractDatapointsOutputRequestV1 = {
  /**
   * Task Id
   */
  task_id: number;
  dagster_run_id: NonEmptyStr;
  /**
   * Items
   */
  items: Array<ExtractDatapointsOutputItemV1>;
};

/**
 * ExtractDatapointsOutputResponseV1
 */
export type ExtractDatapointsOutputResponseV1 = {
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
};

/**
 * ExtractIncomingKnowledgeBasesDequeueByDagsterRunV1
 */
export type ExtractIncomingKnowledgeBasesDequeueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * ExtractIncomingKnowledgeBasesDequeueByIdsV1
 */
export type ExtractIncomingKnowledgeBasesDequeueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * File Ids
   */
  file_ids: Array<number>;
};

/**
 * ExtractIncomingKnowledgeBasesDequeueRequestV1
 */
export type ExtractIncomingKnowledgeBasesDequeueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & ExtractIncomingKnowledgeBasesDequeueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & ExtractIncomingKnowledgeBasesDequeueByDagsterRunV1);
};

/**
 * ExtractIncomingKnowledgeBasesDequeueResponseV1
 */
export type ExtractIncomingKnowledgeBasesDequeueResponseV1 = {
  /**
   * Dequeued File Ids
   */
  dequeued_file_ids: Array<number>;
};

/**
 * ExtractIncomingKnowledgeBasesEnqueueByDagsterRunV1
 */
export type ExtractIncomingKnowledgeBasesEnqueueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * ExtractIncomingKnowledgeBasesEnqueueByIdsV1
 */
export type ExtractIncomingKnowledgeBasesEnqueueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * File Ids
   */
  file_ids: Array<number>;
};

/**
 * ExtractIncomingKnowledgeBasesEnqueueRequestV1
 */
export type ExtractIncomingKnowledgeBasesEnqueueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & ExtractIncomingKnowledgeBasesEnqueueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & ExtractIncomingKnowledgeBasesEnqueueByDagsterRunV1);
};

/**
 * ExtractIncomingKnowledgeBasesEnqueueResponseV1
 */
export type ExtractIncomingKnowledgeBasesEnqueueResponseV1 = {
  /**
   * Enqueued File Ids
   */
  enqueued_file_ids: Array<number>;
};

/**
 * ExtractIncomingKnowledgeBasesInputRequestV1
 */
export type ExtractIncomingKnowledgeBasesInputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Max Processing Time
   */
  max_processing_time?: string | Missing;
};

/**
 * ExtractIncomingKnowledgeBasesInputResponseV1
 */
export type ExtractIncomingKnowledgeBasesInputResponseV1 = {
  /**
   * Items
   */
  items: Array<IngestionFileV1>;
};

/**
 * ExtractIncomingKnowledgeBasesOutputRequestV1
 */
export type ExtractIncomingKnowledgeBasesOutputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Processed Ingestion File Ids
   */
  processed_ingestion_file_ids: Array<number>;
  /**
   * Known Incoming Kbs
   */
  known_incoming_kbs: Array<KnownIncomingKbV1>;
  /**
   * Unknown Incoming Kbs
   */
  unknown_incoming_kbs: Array<UnknownIncomingKbV1>;
};

/**
 * ExtractIncomingKnowledgeBasesOutputResponseV1
 */
export type ExtractIncomingKnowledgeBasesOutputResponseV1 = {
  /**
   * Processed Count
   */
  processed_count: number;
  /**
   * Unprocessed Count
   */
  unprocessed_count: number;
  /**
   * Unknown Kb Ids
   */
  unknown_kb_ids: Array<number>;
};

/**
 * ExtractedConversationFullV2
 */
export type ExtractedConversationFullV2 = {
  conversation: ConversationFullV2;
  /**
   * Finalized Conversation Spans
   */
  finalized_conversation_spans: Array<ExtractedConversationSpanV1>;
};

/**
 * ExtractedConversationSpanV1
 */
export type ExtractedConversationSpanV1 = {
  /**
   * Message Index
   */
  message_index: number;
  /**
   * Start Index
   */
  start_index: number;
  /**
   * End Index
   */
  end_index: number;
};

/**
 * ExtractedConversationV2
 */
export type ExtractedConversationV2 = {
  /**
   * Messages
   */
  messages: Array<CreateConversationMessageV1>;
  /**
   * Finalized Conversation Spans
   */
  finalized_conversation_spans: Array<ExtractedConversationSpanV1>;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * ExtractedInputOutputSpansV1
 */
export type ExtractedInputOutputSpansV1 = {
  /**
   * Extracted Input
   */
  extracted_input?: Array<ExtractedConversationSpanV1>;
  /**
   * Extracted Output
   */
  extracted_output?: Array<ExtractedConversationSpanV1>;
};

/**
 * ExtractedMessagesAndSpansFullV1
 */
export type ExtractedMessagesAndSpansFullV1 = {
  /**
   * Messages
   */
  messages: Array<ConversationMessageV1>;
  /**
   * Finalized Conversation Spans
   */
  finalized_conversation_spans: Array<ExtractedConversationSpanV1>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
};

/**
 * FailedWorkflowRunV1
 */
export type FailedWorkflowRunV1 = {
  /**
   * Kind
   */
  kind: "FAILED";
  /**
   * Failed At
   */
  failed_at: Date;
};

/**
 * FinalizeConversationsDequeueByDagsterRunV1
 */
export type FinalizeConversationsDequeueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * FinalizeConversationsDequeueByIdsV1
 */
export type FinalizeConversationsDequeueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Data Dump Conversation Ids
   */
  data_dump_conversation_ids?: Array<number>;
  /**
   * Inference Conversation Ids
   */
  inference_conversation_ids?: Array<number>;
};

/**
 * FinalizeConversationsDequeueRequestV1
 */
export type FinalizeConversationsDequeueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & FinalizeConversationsDequeueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & FinalizeConversationsDequeueByDagsterRunV1);
};

/**
 * FinalizeConversationsDequeueResponseV1
 */
export type FinalizeConversationsDequeueResponseV1 = {
  /**
   * Dequeued Data Dump Conversation Ids
   */
  dequeued_data_dump_conversation_ids: Array<number>;
  /**
   * Dequeued Inference Conversation Ids
   */
  dequeued_inference_conversation_ids: Array<number>;
};

/**
 * FinalizeConversationsEnqueueByDagsterRunV1
 */
export type FinalizeConversationsEnqueueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * FinalizeConversationsEnqueueByIdsV1
 */
export type FinalizeConversationsEnqueueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Data Dump Conversation Ids
   */
  data_dump_conversation_ids?: Array<number>;
  /**
   * Inference Conversation Ids
   */
  inference_conversation_ids?: Array<number>;
};

/**
 * FinalizeConversationsEnqueueRequestV1
 */
export type FinalizeConversationsEnqueueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & FinalizeConversationsEnqueueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & FinalizeConversationsEnqueueByDagsterRunV1);
};

/**
 * FinalizeConversationsEnqueueResponseV1
 */
export type FinalizeConversationsEnqueueResponseV1 = {
  /**
   * Enqueued Data Dump Conversation Ids
   */
  enqueued_data_dump_conversation_ids: Array<number>;
  /**
   * Enqueued Inference Conversation Ids
   */
  enqueued_inference_conversation_ids: Array<number>;
};

/**
 * FinalizeConversationsInputInferenceConversationV1
 */
export type FinalizeConversationsInputInferenceConversationV1 = {
  /**
   * Inference Conversation Id
   */
  inference_conversation_id: number;
  /**
   * Inference Conversation Inference Ids
   */
  inference_conversation_inference_ids: Array<number>;
};

/**
 * FinalizeConversationsInputItemV1
 */
export type FinalizeConversationsInputItemV1 = {
  /**
   * External Id
   */
  external_id: string;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number | null;
  /**
   * Data Dump Conversation Ids
   */
  data_dump_conversation_ids: Array<number>;
  /**
   * Inference Conversations
   */
  inference_conversations: Array<FinalizeConversationsInputInferenceConversationV1>;
};

/**
 * FinalizeConversationsInputRequestV1
 */
export type FinalizeConversationsInputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Max Processing Time
   */
  max_processing_time?: string | Missing;
};

/**
 * FinalizeConversationsInputResponseV1
 */
export type FinalizeConversationsInputResponseV1 = {
  /**
   * Items
   */
  items: Array<FinalizeConversationsInputItemV1>;
};

/**
 * FinalizeConversationsOutputRequestV1
 */
export type FinalizeConversationsOutputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Creates
   */
  creates: Array<CreateFinalizedConversationV2>;
  /**
   * Updates
   */
  updates: Array<UpdateFinalizedConversationV1>;
};

/**
 * FinalizeConversationsOutputResponseV1
 */
export type FinalizeConversationsOutputResponseV1 = {
  /**
   * Finalized Conversations
   */
  finalized_conversations: Array<FinalizedConversationV1>;
};

/**
 * FinalizedConversationConversationFullV1
 */
export type FinalizedConversationConversationFullV1 = {
  /**
   * Messages
   */
  messages: Array<FinalizedConversationMessageFullV1>;
};

/**
 * FinalizedConversationFullV1
 */
export type FinalizedConversationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * External Url
   */
  external_url: string | null;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Title
   */
  title: string | null;
  model: FinalizedConversationConversationFullV1;
  view: FinalizedConversationConversationFullV1;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * FinalizedConversationFullV2
 */
export type FinalizedConversationFullV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * External Url
   */
  external_url: string | null;
  /**
   * Title
   */
  title: string | null;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  model: ConversationFullV2;
  view: ConversationFullV2;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * FinalizedConversationMessageFullV1
 */
export type FinalizedConversationMessageFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Content
   */
  content: string;
  /**
   * Role
   */
  role: string;
  /**
   * Message Order
   */
  message_order: number;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
};

/**
 * FinalizedConversationMessageV1
 */
export type FinalizedConversationMessageV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Role
   */
  role: string;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
};

/**
 * FinalizedConversationSourceV1
 */
export type FinalizedConversationSourceV1 = {
  /**
   * Kind
   */
  kind: "finalized_conversation";
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  /**
   * Message Id
   */
  message_id: number;
};

/**
 * FinalizedConversationV1
 */
export type FinalizedConversationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * External Url
   */
  external_url: string | null;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Title
   */
  title: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * FinetuneKnowedgeBasesKnowledgeBaseV1
 */
export type FinetuneKnowedgeBasesKnowledgeBaseV1 = {
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Incoming Branch
   */
  incoming_branch: string | null;
};

/**
 * FinetuneKnowledgeBasesCreateChangeRequestV1
 */
export type FinetuneKnowledgeBasesCreateChangeRequestV1 = {
  /**
   * New Branch Name
   */
  new_branch_name: string;
  /**
   * Commits
   */
  commits: Array<FinetuneKnowledgeBasesGitCommitV1>;
  /**
   * Title
   */
  title: string;
  /**
   * Description
   */
  description: string;
  /**
   * Auto Merge
   */
  auto_merge?: boolean;
};

/**
 * FinetuneKnowledgeBasesDequeueByDagsterRunV1
 */
export type FinetuneKnowledgeBasesDequeueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * FinetuneKnowledgeBasesDequeueByIdsV1
 */
export type FinetuneKnowledgeBasesDequeueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Task Ids
   */
  task_ids: Array<number>;
};

/**
 * FinetuneKnowledgeBasesDequeueRequestV1
 */
export type FinetuneKnowledgeBasesDequeueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & FinetuneKnowledgeBasesDequeueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & FinetuneKnowledgeBasesDequeueByDagsterRunV1);
};

/**
 * FinetuneKnowledgeBasesDequeueResponseV1
 */
export type FinetuneKnowledgeBasesDequeueResponseV1 = {
  /**
   * Dequeued Task Ids
   */
  dequeued_task_ids: Array<number>;
};

/**
 * FinetuneKnowledgeBasesEnqueueByDagsterRunV1
 */
export type FinetuneKnowledgeBasesEnqueueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * FinetuneKnowledgeBasesEnqueueByIdsV1
 */
export type FinetuneKnowledgeBasesEnqueueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Task Ids
   */
  task_ids: Array<number>;
};

/**
 * FinetuneKnowledgeBasesEnqueueRequestV1
 */
export type FinetuneKnowledgeBasesEnqueueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & FinetuneKnowledgeBasesEnqueueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & FinetuneKnowledgeBasesEnqueueByDagsterRunV1);
};

/**
 * FinetuneKnowledgeBasesEnqueueResponseV1
 */
export type FinetuneKnowledgeBasesEnqueueResponseV1 = {
  /**
   * Enqueued Task Ids
   */
  enqueued_task_ids: Array<number>;
};

/**
 * FinetuneKnowledgeBasesGitCommitV1
 */
export type FinetuneKnowledgeBasesGitCommitV1 = {
  /**
   * Message
   */
  message: string;
  /**
   * Patches
   */
  patches: Array<GitPatchV2>;
  evidence: AttachEvidenceV2;
  /**
   * Created At
   */
  created_at?: Date | Missing;
};

/**
 * FinetuneKnowledgeBasesInputRequestV1
 */
export type FinetuneKnowledgeBasesInputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Sufficiency Threshold
   */
  sufficiency_threshold?: number | Missing;
  /**
   * Max Processing Time
   */
  max_processing_time?: string | Missing;
};

/**
 * FinetuneKnowledgeBasesInputResponseV1
 */
export type FinetuneKnowledgeBasesInputResponseV1 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Knowledge Bases
   */
  knowledge_bases: Array<FinetuneKnowedgeBasesKnowledgeBaseV1>;
  /**
   * Unassigned Kanonical Datapoint Ids
   */
  unassigned_kanonical_datapoint_ids: Array<number>;
};

/**
 * FinetuneKnowledgeBasesOutputRequestV1
 */
export type FinetuneKnowledgeBasesOutputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Finetune Updates
   */
  finetune_updates: Array<FinetuneKnowledgeBasesUpdatesV1>;
};

/**
 * FinetuneKnowledgeBasesOutputResponseV1
 */
export type FinetuneKnowledgeBasesOutputResponseV1 = {
  [key: string]: unknown;
};

/**
 * FinetuneKnowledgeBasesUpdatesV1
 */
export type FinetuneKnowledgeBasesUpdatesV1 = {
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Change Requests To Close
   */
  change_requests_to_close: Array<number>;
  /**
   * Change Requests To Open
   */
  change_requests_to_open: Array<FinetuneKnowledgeBasesCreateChangeRequestV1>;
};

/**
 * FreshserviceAddNoteToTicketParamsV1
 */
export type FreshserviceAddNoteToTicketParamsV1 = {
  body: SanitizedStr;
  /**
   * Private
   */
  private?: boolean;
};

/**
 * FreshserviceAgentPageV1
 */
export type FreshserviceAgentPageV1 = {
  /**
   * Agents
   */
  agents: Array<FreshserviceAgentV1>;
  /**
   * Page
   */
  page: number;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * FreshserviceAgentV1
 */
export type FreshserviceAgentV1 = {
  /**
   * Id
   */
  id: number;
  first_name: SanitizedStr | null;
  last_name: SanitizedStr | null;
  email: SanitizedStr | null;
};

/**
 * FreshserviceArticleListV1
 */
export type FreshserviceArticleListV1 = {
  /**
   * Articles
   */
  articles: Array<FreshserviceArticleV1>;
};

/**
 * FreshserviceArticleStatusV1
 */
export const FreshserviceArticleStatusV1 = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  UNKNOWN: "UNKNOWN",
} as const;

/**
 * FreshserviceArticleStatusV1
 */
export type FreshserviceArticleStatusV1 =
  (typeof FreshserviceArticleStatusV1)[keyof typeof FreshserviceArticleStatusV1];

/**
 * FreshserviceArticleV1
 */
export type FreshserviceArticleV1 = {
  /**
   * Id
   */
  id: number;
  title: SanitizedStr;
  description: SanitizedStr;
  /**
   * Folder Id
   */
  folder_id: number;
  /**
   * Category Id
   */
  category_id: number | null;
  status: FreshserviceArticleStatusV1;
};

/**
 * FreshserviceCategoryListV1
 */
export type FreshserviceCategoryListV1 = {
  /**
   * Categories
   */
  categories: Array<FreshserviceCategoryV1>;
};

/**
 * FreshserviceCategoryV1
 */
export type FreshserviceCategoryV1 = {
  /**
   * Id
   */
  id: number;
  name: NonEmptyStr;
  description: SanitizedStr | null;
};

/**
 * FreshserviceCheckConnectionResponseV1
 */
export type FreshserviceCheckConnectionResponseV1 = {
  /**
   * Connected
   */
  connected: boolean;
  detail?: SanitizedStr | null;
};

/**
 * FreshserviceConversationListV1
 */
export type FreshserviceConversationListV1 = {
  /**
   * Conversations
   */
  conversations: Array<FreshserviceConversationV1>;
};

/**
 * FreshserviceConversationV1
 */
export type FreshserviceConversationV1 = {
  /**
   * Id
   */
  id: number;
  body: SanitizedStr;
  /**
   * Incoming
   */
  incoming: boolean;
  /**
   * Private
   */
  private: boolean;
  /**
   * User Id
   */
  user_id: number | null;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * FreshserviceFolderListV1
 */
export type FreshserviceFolderListV1 = {
  /**
   * Folders
   */
  folders: Array<FreshserviceFolderV1>;
};

/**
 * FreshserviceFolderV1
 */
export type FreshserviceFolderV1 = {
  /**
   * Id
   */
  id: number;
  name: NonEmptyStr;
  /**
   * Category Id
   */
  category_id: number;
  description: SanitizedStr | null;
};

/**
 * FreshserviceProvisionWebhookResponseV1
 */
export type FreshserviceProvisionWebhookResponseV1 = {
  webhook_secret: NonEmptyStr;
  webhook_auth_header: SanitizedStr;
};

/**
 * FreshserviceReplyToTicketParamsV1
 */
export type FreshserviceReplyToTicketParamsV1 = {
  body: SanitizedStr;
};

/**
 * FreshserviceRequesterPageV1
 */
export type FreshserviceRequesterPageV1 = {
  /**
   * Requesters
   */
  requesters: Array<FreshserviceRequesterV1>;
  /**
   * Page
   */
  page: number;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * FreshserviceRequesterV1
 */
export type FreshserviceRequesterV1 = {
  /**
   * Id
   */
  id: number;
  first_name: SanitizedStr | null;
  last_name: SanitizedStr | null;
  email: SanitizedStr | null;
};

/**
 * FreshserviceTenantFullV1
 */
export type FreshserviceTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  tenant_name: NonEmptyStr;
  domain: NonEmptyStr;
  status: FreshserviceTenantStatusV1;
  /**
   * Credentials Configured
   */
  credentials_configured: boolean;
  /**
   * Webhook Verification Enabled
   */
  webhook_verification_enabled: boolean;
  webhook_ingest_url: SanitizedStr;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * FreshserviceTenantStatusV1
 */
export const FreshserviceTenantStatusV1 = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
} as const;

/**
 * FreshserviceTenantStatusV1
 */
export type FreshserviceTenantStatusV1 =
  (typeof FreshserviceTenantStatusV1)[keyof typeof FreshserviceTenantStatusV1];

/**
 * FreshserviceTenantV1
 */
export type FreshserviceTenantV1 = {
  /**
   * Id
   */
  id: number;
  tenant_name: NonEmptyStr;
  domain: NonEmptyStr;
  status: FreshserviceTenantStatusV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * FreshserviceTicketImpactV1
 */
export const FreshserviceTicketImpactV1 = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
} as const;

/**
 * FreshserviceTicketImpactV1
 */
export type FreshserviceTicketImpactV1 =
  (typeof FreshserviceTicketImpactV1)[keyof typeof FreshserviceTicketImpactV1];

/**
 * FreshserviceTicketPageV1
 */
export type FreshserviceTicketPageV1 = {
  /**
   * Tickets
   */
  tickets: Array<FreshserviceTicketV1>;
  /**
   * Page
   */
  page: number;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * FreshserviceTicketPriorityV1
 */
export const FreshserviceTicketPriorityV1 = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
  URGENT: "URGENT",
} as const;

/**
 * FreshserviceTicketPriorityV1
 */
export type FreshserviceTicketPriorityV1 =
  (typeof FreshserviceTicketPriorityV1)[keyof typeof FreshserviceTicketPriorityV1];

/**
 * FreshserviceTicketStatusV1
 */
export const FreshserviceTicketStatusV1 = {
  OPEN: "OPEN",
  PENDING: "PENDING",
  RESOLVED: "RESOLVED",
  CLOSED: "CLOSED",
  UNKNOWN: "UNKNOWN",
} as const;

/**
 * FreshserviceTicketStatusV1
 */
export type FreshserviceTicketStatusV1 =
  (typeof FreshserviceTicketStatusV1)[keyof typeof FreshserviceTicketStatusV1];

/**
 * FreshserviceTicketUrgencyV1
 */
export const FreshserviceTicketUrgencyV1 = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
} as const;

/**
 * FreshserviceTicketUrgencyV1
 */
export type FreshserviceTicketUrgencyV1 =
  (typeof FreshserviceTicketUrgencyV1)[keyof typeof FreshserviceTicketUrgencyV1];

/**
 * FreshserviceTicketV1
 */
export type FreshserviceTicketV1 = {
  /**
   * Id
   */
  id: number;
  subject: SanitizedStr;
  description: SanitizedStr;
  status: FreshserviceTicketStatusV1;
  priority: FreshserviceTicketPriorityV1;
  /**
   * Requester Id
   */
  requester_id: number | null;
  /**
   * Responder Id
   */
  responder_id: number | null;
  /**
   * Group Id
   */
  group_id: number | null;
  ticket_type: SanitizedStr | null;
  /**
   * Tags
   */
  tags: Array<SanitizedStr>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * FreshserviceWebhookResponseV1
 */
export type FreshserviceWebhookResponseV1 = {
  /**
   * Received
   */
  received?: boolean;
};

/**
 * FrontendConfigV1
 */
export type FrontendConfigV1 = {
  capabilities: CapabilitiesV1;
};

/**
 * FullEvaluatedInferenceDatapointV1
 */
export type FullEvaluatedInferenceDatapointV1 = {
  inference_datapoint: InferenceDatapointFullV2;
  inference: EvaluatedInferenceFullV1;
  /**
   * Judgements
   */
  judgements: Array<JudgementFullV2>;
  finalized_conversation: FinalizedConversationFullV2;
};

/**
 * FullEvaluatedInferenceDatapointsSearchByArticleV1
 */
export type FullEvaluatedInferenceDatapointsSearchByArticleV1 = {
  /**
   * Kind
   */
  kind: "article";
  /**
   * Article Id
   */
  article_id: number;
};

/**
 * FullEvaluatedInferenceDatapointsSearchByKnowledgeBaseV1
 */
export type FullEvaluatedInferenceDatapointsSearchByKnowledgeBaseV1 = {
  /**
   * Kind
   */
  kind: "knowledge_base";
  /**
   * Kb Id
   */
  kb_id: number;
};

/**
 * FullEvaluatedInferenceDatapointsSearchByPathV1
 */
export type FullEvaluatedInferenceDatapointsSearchByPathV1 = {
  /**
   * Kind
   */
  kind: "path";
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Path
   */
  path: string;
};

export type FullEvaluatedInferenceDatapointsSearchByV1 =
  | ({
      kind: "article";
    } & FullEvaluatedInferenceDatapointsSearchByArticleV1)
  | ({
      kind: "path";
    } & FullEvaluatedInferenceDatapointsSearchByPathV1)
  | ({
      kind: "knowledge_base";
    } & FullEvaluatedInferenceDatapointsSearchByKnowledgeBaseV1);

/**
 * GenericSecretPlainValueV2
 */
export type GenericSecretPlainValueV2 = {
  /**
   * Kind
   */
  kind: "GENERIC";
  /**
   * Value
   */
  value: string;
};

/**
 * GenericSecretValueParamsV1
 */
export type GenericSecretValueParamsV1 = {
  /**
   * Kind
   */
  kind: "GENERIC";
  /**
   * Value
   */
  value: string;
};

/**
 * GetA2aAgentsResponseV1
 */
export type GetA2aAgentsResponseV1 = {
  /**
   * Agents
   */
  agents: Array<A2aAgentV1>;
};

/**
 * GetAgentsResponseV1
 */
export type GetAgentsResponseV1 = {
  /**
   * Agents
   */
  agents: Array<AgentV1>;
};

/**
 * GetAnalyticsChartContentResponseV1
 */
export type GetAnalyticsChartContentResponseV1 = {
  chart_key: SanitizedStr;
  title: SanitizedStr;
  description: SanitizedStr | null;
  /**
   * Span
   */
  span: number;
  aspect_ratio: AspectRatioV1 | null;
  data: ChartContentV1;
};

/**
 * GetArticleTagsKeyV1
 */
export type GetArticleTagsKeyV1 = {
  /**
   * Key
   */
  key: string;
  /**
   * Values
   */
  values: Array<GetArticleTagsValueV1>;
};

/**
 * GetArticleTagsValueV1
 */
export type GetArticleTagsValueV1 = {
  /**
   * Value
   */
  value: string;
  /**
   * Count
   */
  count: number;
};

/**
 * GetChangeRequestPossibleAssigneesResponseV1
 */
export type GetChangeRequestPossibleAssigneesResponseV1 = {
  /**
   * Possible Assignees
   */
  possible_assignees: Array<UserFullV1>;
};

/**
 * GetChangeRequestTagsKeyV1
 */
export type GetChangeRequestTagsKeyV1 = {
  /**
   * Key
   */
  key: string;
  /**
   * Values
   */
  values: Array<GetChangeRequestTagsValueV1>;
};

/**
 * GetChangeRequestTagsValueV1
 */
export type GetChangeRequestTagsValueV1 = {
  /**
   * Value
   */
  value: string;
  /**
   * Count
   */
  count: number;
};

/**
 * GetEmbeddingSummaryResponseV2
 */
export type GetEmbeddingSummaryResponseV2 = {
  /**
   * Num Articles
   */
  num_articles: number;
  /**
   * Num Open Ai Embeddings
   */
  num_open_ai_embeddings: number;
};

/**
 * GetMcpToolsetsResponseV1
 */
export type GetMcpToolsetsResponseV1 = {
  /**
   * Toolsets
   */
  toolsets: Array<McpToolsetV1>;
};

/**
 * GetMyKbAccessRequestResultV1
 */
export type GetMyKbAccessRequestResultV1 = {
  request: KbAccessRequestV1 | null;
};

/**
 * GetObjectArticleV1ResponseV1
 */
export type GetObjectArticleV1ResponseV1 = {
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Object Id
   */
  object_id: number;
  /**
   * Title
   */
  title: string;
  /**
   * Content
   */
  content: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Verified
   */
  verified: boolean;
  metadata: Metadata;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * GetPromptsResponseV1
 */
export type GetPromptsResponseV1 = {
  /**
   * Items
   */
  items: Array<PromptV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * GetRequesterTeamsResultV1
 */
export type GetRequesterTeamsResultV1 = {
  /**
   * Team Ids
   */
  team_ids: Array<number>;
};

/**
 * GetRolesResultV1
 */
export type GetRolesResultV1 = {
  /**
   * Roles
   */
  roles: Array<RoleV1>;
};

/**
 * GetTeamArticlePermissionsResultV1
 */
export type GetTeamArticlePermissionsResultV1 = {
  /**
   * Permissions By Article
   */
  permissions_by_article: {
    [key: string]: ArticlePermissionV1;
  };
};

/**
 * GetTeamKbAssignmentsResultV1
 */
export type GetTeamKbAssignmentsResultV1 = {
  /**
   * Assignments
   */
  assignments: Array<TeamKbAssignmentV1>;
};

/**
 * GetTeamsWithAccessResultV1
 */
export type GetTeamsWithAccessResultV1 = {
  /**
   * Team Ids
   */
  team_ids: Array<number>;
};

/**
 * GitAmendParamsV1
 */
export type GitAmendParamsV1 = {
  /**
   * Expected Head Id
   */
  expected_head_id: number;
  /**
   * Message
   */
  message?: string | Missing;
  /**
   * Patches
   */
  patches?: Array<GitPatchV2>;
  /**
   * Evidence
   */
  evidence?: AmendEvidenceV1 | Missing;
};

/**
 * GitObjectArticleV1SchemaV1
 */
export type GitArticleV1 = {
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Object Id
   */
  object_id: number;
  /**
   * Title
   */
  title: string;
  /**
   * Content
   */
  content: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Verified
   */
  verified: boolean;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: JsonOutput;
  };
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * GitBlobV2
 */
export type GitBlobV2 = {
  /**
   * Content
   */
  content: string;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * GitBranchCreateParamsV2
 */
export type GitBranchCreateParamsV2 = {
  /**
   * Name
   */
  name: string;
  from_commitish: GitCommitishV1Parse;
};

/**
 * GitBranchUpdateParamsV1
 */
export type GitBranchUpdateParamsV1 = {
  /**
   * Name
   */
  name?: string | Missing;
};

/**
 * GitBranchV2
 */
export type GitBranchV2 = {
  /**
   * Name
   */
  name: string;
  /**
   * Commit Id
   */
  commit_id: number;
  /**
   * Created By
   */
  created_by: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * GitCherryPickConflictErrorV1
 */
export type GitCherryPickConflictErrorV1 = {
  /**
   * Kind
   */
  kind?: "conflict";
  incoming_commit: GitCommitV2;
  base_commit: GitCommitV2;
  /**
   * Conflicts
   */
  conflicts: Array<GitConflictV1>;
};

export type GitCherryPickErrorV1 =
  | ({
      kind: "conflict";
    } & GitCherryPickConflictErrorV1)
  | ({
      kind: "stale_head";
    } & GitCherryPickStaleHeadErrorV1);

/**
 * GitCherryPickParamsV1
 */
export type GitCherryPickParamsV1 = {
  /**
   * Commit Id
   */
  commit_id: number;
  /**
   * Expected Head Id
   */
  expected_head_id: number;
};

/**
 * GitCherryPickStaleHeadErrorV1
 */
export type GitCherryPickStaleHeadErrorV1 = {
  /**
   * Kind
   */
  kind?: "stale_head";
  /**
   * Detail
   */
  detail: string;
};

/**
 * GitCommitAuthorV1
 */
export type GitCommitAuthorV1 = {
  /**
   * Name
   */
  name: string;
  /**
   * Email
   */
  email: string;
};

/**
 * GitCommitParamsV2
 */
export type GitCommitParamsV2 = {
  /**
   * Message
   */
  message: string;
  /**
   * Patches
   */
  patches: Array<GitPatchV2>;
  /**
   * Expected Head Id
   */
  expected_head_id: number;
  evidence: AttachEvidenceV2;
  /**
   * Created At
   */
  created_at?: Date | Missing;
};

/**
 * GitCommitV2
 */
export type GitCommitV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Message
   */
  message: string;
  /**
   * Created At
   */
  created_at: Date;
};

export type GitCommitishV1Parse = number | string;

/**
 * GitConflictCodeV1
 */
export const GitConflictCodeV1 = {
  BOTH_MODIFIED: "both_modified",
  DIVERGING_RENAMED: "diverging_renamed",
  CONVERGING_RENAMED: "converging_renamed",
  CONVERGING_FILE_TREE: "converging_file_tree",
  MODIFIED_RENAMED: "modified_renamed",
  ADDED_RENAMED: "added_renamed",
  BOTH_ADDED: "both_added",
  MODIFIED_DELETED: "modified_deleted",
} as const;

/**
 * GitConflictCodeV1
 */
export type GitConflictCodeV1 =
  (typeof GitConflictCodeV1)[keyof typeof GitConflictCodeV1];

/**
 * GitConflictV1
 */
export type GitConflictV1 = {
  /**
   * Path
   */
  path: string;
  conflict_code: GitConflictCodeV1;
  /**
   * Message
   */
  message: string;
  /**
   * Onto Diff
   */
  onto_diff: Array<DiffEntryV2>;
  /**
   * Incoming Diff
   */
  incoming_diff: Array<DiffEntryV2>;
};

/**
 * GitDiffBlameEntryArticleV1AddedV1
 */
export type GitDiffBlameEntryArticleV1AddedV1 = {
  /**
   * Kind
   */
  kind: "article_v1_added";
  /**
   * Path
   */
  path: string;
  /**
   * Article Id
   */
  article_id: number;
  article: ArticleV1DiffSnapshotV2;
  /**
   * Content Hunks
   */
  content_hunks: Array<GitDiffBlameHunkV1>;
};

/**
 * GitDiffBlameEntryArticleV1ModifiedV1
 */
export type GitDiffBlameEntryArticleV1ModifiedV1 = {
  /**
   * Kind
   */
  kind: "article_v1_modified";
  /**
   * Path
   */
  path: string;
  /**
   * Article Id
   */
  article_id: number;
  before: ArticleV1DiffSnapshotV2;
  after: ArticleV1DiffSnapshotV2;
  /**
   * Content Hunks
   */
  content_hunks: Array<GitDiffBlameHunkV1>;
};

/**
 * GitDiffBlameEntryArticleV1RemovedV1
 */
export type GitDiffBlameEntryArticleV1RemovedV1 = {
  /**
   * Kind
   */
  kind: "article_v1_removed";
  /**
   * Path
   */
  path: string;
  /**
   * Article Id
   */
  article_id: number;
  article: ArticleV1DiffSnapshotV2;
  /**
   * Content Hunks
   */
  content_hunks: Array<GitDiffBlameHunkV1>;
};

/**
 * GitDiffBlameEntryBlobAddedV1
 */
export type GitDiffBlameEntryBlobAddedV1 = {
  /**
   * Kind
   */
  kind: "blob_added";
  /**
   * Path
   */
  path: string;
  /**
   * Content Hunks
   */
  content_hunks: Array<GitDiffBlameHunkV1>;
};

/**
 * GitDiffBlameEntryBlobModifiedV1
 */
export type GitDiffBlameEntryBlobModifiedV1 = {
  /**
   * Kind
   */
  kind: "blob_modified";
  /**
   * Path
   */
  path: string;
  /**
   * Content Hunks
   */
  content_hunks: Array<GitDiffBlameHunkV1>;
};

/**
 * GitDiffBlameEntryBlobRemovedV1
 */
export type GitDiffBlameEntryBlobRemovedV1 = {
  /**
   * Kind
   */
  kind: "blob_removed";
  /**
   * Path
   */
  path: string;
  /**
   * Content Hunks
   */
  content_hunks: Array<GitDiffBlameHunkV1>;
};

export type GitDiffBlameEntryV1 =
  | ({
      kind: "article_v1_added";
    } & GitDiffBlameEntryArticleV1AddedV1)
  | ({
      kind: "article_v1_modified";
    } & GitDiffBlameEntryArticleV1ModifiedV1)
  | ({
      kind: "article_v1_removed";
    } & GitDiffBlameEntryArticleV1RemovedV1)
  | ({
      kind: "blob_added";
    } & GitDiffBlameEntryBlobAddedV1)
  | ({
      kind: "blob_modified";
    } & GitDiffBlameEntryBlobModifiedV1)
  | ({
      kind: "blob_removed";
    } & GitDiffBlameEntryBlobRemovedV1)
  | ({
      kind: "reordered";
    } & GitDiffEntryReorderedV2);

/**
 * GitDiffBlameHunkV1
 */
export type GitDiffBlameHunkV1 = {
  /**
   * Before Start
   */
  before_start: number;
  /**
   * Before Count
   */
  before_count: number;
  /**
   * After Start
   */
  after_start: number;
  /**
   * After Count
   */
  after_count: number;
  /**
   * Lines
   */
  lines: Array<GitDiffBlameLineV1>;
  /**
   * Evidence Count
   */
  evidence_count: number;
};

/**
 * GitDiffBlameLineV1
 */
export type GitDiffBlameLineV1 = {
  /**
   * Text
   */
  text: string;
  /**
   * Commit Id
   */
  commit_id: number;
};

/**
 * GitDiffBlameResponseV1
 */
export type GitDiffBlameResponseV1 = {
  /**
   * Common Ancestor Commit Id
   */
  common_ancestor_commit_id: number;
  /**
   * From Commit Id
   */
  from_commit_id: number;
  /**
   * To Commit Id
   */
  to_commit_id: number;
  /**
   * Diff
   */
  diff: Array<GitDiffBlameEntryV1>;
};

/**
 * GitDiffEntryArticleV1AddedV2
 */
export type GitDiffEntryArticleV1AddedV2 = {
  /**
   * Kind
   */
  kind: "article_v1_added";
  /**
   * Path
   */
  path: string;
  /**
   * Article Id
   */
  article_id: number;
  article: ArticleV1DiffSnapshotV2;
  /**
   * Content Hunks
   */
  content_hunks: Array<GitDiffHunkV2>;
};

/**
 * GitDiffEntryArticleV1ModifiedV2
 */
export type GitDiffEntryArticleV1ModifiedV2 = {
  /**
   * Kind
   */
  kind: "article_v1_modified";
  /**
   * Path
   */
  path: string;
  /**
   * Article Id
   */
  article_id: number;
  before: ArticleV1DiffSnapshotV2;
  after: ArticleV1DiffSnapshotV2;
  /**
   * Content Hunks
   */
  content_hunks: Array<GitDiffHunkV2>;
};

/**
 * GitDiffEntryArticleV1RemovedV2
 */
export type GitDiffEntryArticleV1RemovedV2 = {
  /**
   * Kind
   */
  kind: "article_v1_removed";
  /**
   * Path
   */
  path: string;
  /**
   * Article Id
   */
  article_id: number;
  article: ArticleV1DiffSnapshotV2;
};

/**
 * GitDiffEntryBlobAddedV2
 */
export type GitDiffEntryBlobAddedV2 = {
  /**
   * Kind
   */
  kind: "blob_added";
  /**
   * Path
   */
  path: string;
  /**
   * Diff Hunks
   */
  diff_hunks: Array<GitDiffHunkV2>;
};

/**
 * GitDiffEntryBlobModifiedV2
 */
export type GitDiffEntryBlobModifiedV2 = {
  /**
   * Kind
   */
  kind: "blob_modified";
  /**
   * Path
   */
  path: string;
  /**
   * Diff Hunks
   */
  diff_hunks: Array<GitDiffHunkV2>;
};

/**
 * GitDiffEntryBlobRemovedV2
 */
export type GitDiffEntryBlobRemovedV2 = {
  /**
   * Kind
   */
  kind: "blob_removed";
  /**
   * Path
   */
  path: string;
};

/**
 * GitDiffEntryMovedV2
 */
export type GitDiffEntryMovedV2 = {
  /**
   * Kind
   */
  kind: "moved";
  /**
   * From Path
   */
  from_path: string;
  /**
   * To Path
   */
  to_path: string;
  /**
   * Diff Hunks
   */
  diff_hunks: Array<GitDiffHunkV2>;
  article: MovedArticleV1DiffV2 | null;
};

/**
 * GitDiffEntryReorderedV2
 */
export type GitDiffEntryReorderedV2 = {
  /**
   * Kind
   */
  kind: "reordered";
  /**
   * Path
   */
  path: string;
};

/**
 * GitDiffHunkV2
 */
export type GitDiffHunkV2 = {
  /**
   * Before Start
   */
  before_start: number;
  /**
   * Before Count
   */
  before_count: number;
  /**
   * After Start
   */
  after_start: number;
  /**
   * After Count
   */
  after_count: number;
  /**
   * Lines
   */
  lines: Array<string>;
};

/**
 * GitDiffResponseV2
 */
export type GitDiffResponseV2 = {
  /**
   * From Commit Id
   */
  from_commit_id: number;
  /**
   * To Commit Id
   */
  to_commit_id: number;
  /**
   * Diff
   */
  diff: Array<DiffEntryV2>;
};

/**
 * GitLogCommitV2
 */
export type GitLogCommitV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Parent Ids
   */
  parent_ids: Array<number>;
  /**
   * Message
   */
  message: string;
  /**
   * Authors
   */
  authors: Array<number | GitCommitAuthorV1>;
  /**
   * Evidence Count
   */
  evidence_count: number;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * GitLogV2
 */
export type GitLogV2 = {
  /**
   * Commits
   */
  commits: Array<GitLogCommitV2>;
  /**
   * Users
   */
  users: {
    [key: string]: UserFullV1;
  };
};

/**
 * GitLsTreeResponseV2
 */
export type GitLsTreeResponseV2 = {
  /**
   * Commit Id
   */
  commit_id: number;
  /**
   * Entries
   */
  entries: Array<GitTreeEntryV2>;
};

/**
 * GitMergeV2
 */
export type GitMergeV2 = {
  source_commitish: GitCommitishV1Parse;
};

/**
 * GitObjectArticleV1SchemaV1
 */
export type GitObjectArticleV1SchemaV1 = {
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Object Id
   */
  object_id: number;
  /**
   * Title
   */
  title: string;
  /**
   * Content
   */
  content: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Verified
   */
  verified: boolean;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: JsonOutput;
  };
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * GitPatchAddArticleV1SchemaV2
 */
export type GitPatchAddArticleV1SchemaV2 = {
  /**
   * Kind
   */
  kind: "add_article_v1";
  /**
   * Path
   */
  path: string;
  /**
   * Title
   */
  title: string;
  /**
   * Content
   */
  content: string;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: JsonInput;
  };
  /**
   * Verified
   */
  verified?: boolean;
  /**
   * External Id
   */
  external_id?: string | null;
  /**
   * Index Text
   */
  index_text?: string | Missing;
  /**
   * After
   */
  after: string | null;
};

/**
 * GitPatchAddBlobV2
 */
export type GitPatchAddBlobV2 = {
  /**
   * Kind
   */
  kind: "add_blob";
  /**
   * Path
   */
  path: string;
  /**
   * Content
   */
  content: string;
  /**
   * After
   */
  after: string | null;
};

/**
 * GitPatchMoveV2
 */
export type GitPatchMoveV2 = {
  /**
   * Kind
   */
  kind: "move";
  /**
   * Source Path
   */
  source_path: string;
  /**
   * Dest Path
   */
  dest_path: string;
};

/**
 * GitPatchRemoveV2
 */
export type GitPatchRemoveV2 = {
  /**
   * Kind
   */
  kind: "remove";
  /**
   * Path
   */
  path: string;
};

/**
 * GitPatchReorderV2
 */
export type GitPatchReorderV2 = {
  /**
   * Kind
   */
  kind: "reorder";
  /**
   * Path
   */
  path: string;
  /**
   * After
   */
  after: string | null;
};

/**
 * GitPatchUpdateArticleV1SchemaV2
 */
export type GitPatchUpdateArticleV1SchemaV2 = {
  /**
   * Kind
   */
  kind: "update_article_v1";
  /**
   * Path
   */
  path: string;
  /**
   * Title
   */
  title?: string | Missing;
  /**
   * Content
   */
  content?: string | Missing;
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: JsonInput;
      }
    | Missing;
  /**
   * Verified
   */
  verified?: boolean | Missing;
  /**
   * External Id
   */
  external_id?: string | Missing | null;
  /**
   * Index Text
   */
  index_text?: string | Missing;
};

/**
 * GitPatchUpdateBlobV2
 */
export type GitPatchUpdateBlobV2 = {
  /**
   * Kind
   */
  kind: "update_blob";
  /**
   * Path
   */
  path: string;
  /**
   * Content
   */
  content: string;
};

export type GitPatchV2 =
  | ({
      kind: "add_article_v1";
    } & GitPatchAddArticleV1SchemaV2)
  | ({
      kind: "add_blob";
    } & GitPatchAddBlobV2)
  | ({
      kind: "update_article_v1";
    } & GitPatchUpdateArticleV1SchemaV2)
  | ({
      kind: "update_blob";
    } & GitPatchUpdateBlobV2)
  | ({
      kind: "remove";
    } & GitPatchRemoveV2)
  | ({
      kind: "move";
    } & GitPatchMoveV2)
  | ({
      kind: "reorder";
    } & GitPatchReorderV2);

/**
 * GitRebaseConflictErrorV1
 */
export type GitRebaseConflictErrorV1 = {
  incoming_commit: GitCommitV2;
  base_commit: GitCommitV2;
  /**
   * Conflicts
   */
  conflicts: Array<GitConflictV1>;
};

/**
 * GitRebasePreviewResultV1
 */
export type GitRebasePreviewResultV1 = {
  error: GitRebaseConflictErrorV1 | null;
};

/**
 * GitRebaseV2
 */
export type GitRebaseV2 = {
  onto_commitish: GitCommitishV1Parse;
};

/**
 * GitShowArticleV1
 */
export type GitShowArticleV1 = {
  /**
   * Path
   */
  path: string;
  object_article: GitObjectArticleV1SchemaV1;
  /**
   * Tags
   */
  tags: Array<ArticleTagV1>;
};

/**
 * GitShowV2
 */
export type GitShowV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Parent Ids
   */
  parent_ids: Array<number>;
  /**
   * Message
   */
  message: string;
  evidence: EvidenceV2;
  /**
   * Diff
   */
  diff: Array<DiffEntryV2>;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * GitTreeEntryArticleV1SchemaV2
 */
export type GitTreeEntryArticleV1SchemaV2 = {
  /**
   * Kind
   */
  kind: "article_v1";
  /**
   * Name
   */
  name: string;
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Object Article Id
   */
  object_article_id: number;
  /**
   * Title
   */
  title: string;
  /**
   * Verified
   */
  verified: boolean;
};

/**
 * GitTreeEntryBlobV2
 */
export type GitTreeEntryBlobV2 = {
  /**
   * Kind
   */
  kind: "blob";
  /**
   * Name
   */
  name: string;
};

/**
 * GitTreeEntryTreeV2
 */
export type GitTreeEntryTreeV2 = {
  /**
   * Kind
   */
  kind: "tree";
  /**
   * Name
   */
  name: string;
  /**
   * Entries
   */
  entries: Array<GitTreeEntryV2>;
};

export type GitTreeEntryV2 =
  | GitTreeEntryArticleV1SchemaV2
  | GitTreeEntryBlobV2
  | GitTreeEntryTreeV2;

/**
 * GrantSharepointSiteParamsV1
 */
export type GrantSharepointSiteParamsV1 = {
  /**
   * Site Url
   */
  site_url: string;
};

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
  /**
   * Detail
   */
  detail?: Array<ValidationError>;
};

/**
 * HubSpotAddNoteParamsV2
 */
export type HubSpotAddNoteParamsV2 = {
  /**
   * Ticket Id
   */
  ticket_id: string;
  /**
   * Body
   */
  body: string;
  /**
   * Owner Id
   */
  owner_id?: string | null;
  /**
   * Idempotency Key
   */
  idempotency_key?: string | null;
};

/**
 * HubSpotAddNoteResponseV2
 */
export type HubSpotAddNoteResponseV2 = {
  note?: HubSpotNoteV1 | null;
  /**
   * Deduplicated
   */
  deduplicated?: boolean;
};

/**
 * HubSpotAttachmentRefV1
 */
export type HubSpotAttachmentRefV1 = {
  /**
   * File Id
   */
  file_id: string | null;
  /**
   * Type
   */
  type: string | null;
  /**
   * File Usage Type
   */
  file_usage_type: string | null;
  /**
   * Url
   */
  url: string | null;
  /**
   * Expires At
   */
  expires_at: string | null;
};

/**
 * HubSpotCheckConnectionResponseV1
 */
export type HubSpotCheckConnectionResponseV1 = {
  /**
   * Connected
   */
  connected: boolean;
  /**
   * Portal Id
   */
  portal_id?: string | null;
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * HubSpotCompanyFullV1
 */
export type HubSpotCompanyFullV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Archived
   */
  archived: boolean;
  /**
   * Created At
   */
  created_at: string;
  /**
   * Updated At
   */
  updated_at: string;
  /**
   * Extra Properties
   */
  extra_properties: {
    [key: string]: JsonOutput;
  };
};

/**
 * HubSpotCreateThreadOnTicketParamsV1
 */
export type HubSpotCreateThreadOnTicketParamsV1 = {
  /**
   * Tenant Id
   */
  tenant_id: number;
  /**
   * Ticket Id
   */
  ticket_id: string;
  /**
   * Channel Id
   */
  channel_id: string;
  /**
   * Actor Id
   */
  actor_id: string;
  /**
   * Body
   */
  body: string;
  /**
   * Idempotency Key
   */
  idempotency_key?: string | null;
};

/**
 * HubSpotGetAttachmentContentResponseV1
 */
export type HubSpotGetAttachmentContentResponseV1 = {
  /**
   * File Id
   */
  file_id: string;
  /**
   * Content
   */
  content: string;
  /**
   * Mime Type
   */
  mime_type: string;
  /**
   * Name
   */
  name: string | null;
  /**
   * Size
   */
  size: number | null;
};

/**
 * HubSpotGetAttachmentMetadataResponseV1
 */
export type HubSpotGetAttachmentMetadataResponseV1 = {
  /**
   * File Id
   */
  file_id: string;
  /**
   * Name
   */
  name: string | null;
  /**
   * Mime Type
   */
  mime_type: string;
  /**
   * Size
   */
  size: number | null;
  /**
   * Extension
   */
  extension: string | null;
};

/**
 * HubSpotIngestResponseV1
 */
export type HubSpotIngestResponseV1 = {
  /**
   * Workflow Run Ids
   */
  workflow_run_ids: Array<number>;
};

/**
 * HubSpotManifestLastDownloadV1
 */
export type HubSpotManifestLastDownloadV1 = {
  /**
   * Manifest Platform Version
   */
  manifest_platform_version: string;
  /**
   * Edra Manifest Version
   */
  edra_manifest_version: number;
  /**
   * Downloaded At
   */
  downloaded_at: Date;
};

/**
 * HubSpotNoteV1
 */
export type HubSpotNoteV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Body
   */
  body: string | null;
  /**
   * Timestamp
   */
  timestamp: string | null;
  /**
   * Owner Id
   */
  owner_id: string | null;
  /**
   * Archived
   */
  archived: boolean;
  /**
   * Created At
   */
  created_at: string;
  /**
   * Updated At
   */
  updated_at: string;
  /**
   * Extra Properties
   */
  extra_properties: {
    [key: string]: JsonOutput;
  };
  /**
   * Attachments
   */
  attachments: Array<HubSpotAttachmentRefV1>;
};

/**
 * HubSpotReplyToThreadParamsV1
 */
export type HubSpotReplyToThreadParamsV1 = {
  /**
   * Tenant Id
   */
  tenant_id: number;
  /**
   * Thread Id
   */
  thread_id: string;
  /**
   * Body
   */
  body: string;
  /**
   * Sender Actor Id
   */
  sender_actor_id: string;
  channel?: HubSpotSendChannelV1 | null;
  /**
   * Idempotency Key
   */
  idempotency_key?: string | null;
};

/**
 * HubSpotSendChannelV1
 */
export type HubSpotSendChannelV1 = {
  /**
   * Channel Id
   */
  channel_id: string;
  /**
   * Channel Account Id
   */
  channel_account_id: string;
};

/**
 * HubSpotSetTicketOwnerParamsV1
 */
export type HubSpotSetTicketOwnerParamsV1 = {
  /**
   * Ticket Id
   */
  ticket_id: string;
  /**
   * Owner Id
   */
  owner_id: string | null;
};

/**
 * HubSpotSetTicketStatusParamsV1
 */
export type HubSpotSetTicketStatusParamsV1 = {
  /**
   * Ticket Id
   */
  ticket_id: string;
  /**
   * Status
   */
  status: string;
};

/**
 * HubSpotTenantCredentialsV1
 */
export type HubSpotTenantCredentialsV1 = {
  /**
   * Client Id
   */
  client_id: string;
};

/**
 * HubSpotTenantFullV1
 */
export type HubSpotTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  credentials: HubSpotTenantCredentialsV1 | null;
  installation: HubSpotTenantInstallationV1 | null;
  /**
   * Webhook Ingest Url
   */
  webhook_ingest_url: string;
  manifest_last_download: HubSpotManifestLastDownloadV1 | null;
  /**
   * Manifest Platform Version Out Of Date
   */
  manifest_platform_version_out_of_date: boolean;
  /**
   * Edra Manifest Version Out Of Date
   */
  edra_manifest_version_out_of_date: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * HubSpotTenantInstallationV1
 */
export type HubSpotTenantInstallationV1 = {
  /**
   * External App Id
   */
  external_app_id: string;
  /**
   * External Portal Id
   */
  external_portal_id: string;
};

/**
 * HubSpotTenantV1
 */
export type HubSpotTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Webhook Ingest Url
   */
  webhook_ingest_url: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * HubSpotThreadMessageStatusV1
 */
export type HubSpotThreadMessageStatusV1 = {
  /**
   * Status Type
   */
  status_type: string | null;
};

/**
 * HubSpotThreadMessageV1
 */
export type HubSpotThreadMessageV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Type
   */
  type: string | null;
  /**
   * Body
   */
  body: string | null;
  /**
   * Created At
   */
  created_at: string | null;
  /**
   * Updated At
   */
  updated_at: string | null;
  /**
   * Sender Actor Id
   */
  sender_actor_id: string | null;
  /**
   * Direction
   */
  direction: string | null;
  status: HubSpotThreadMessageStatusV1 | null;
  /**
   * Archived
   */
  archived: boolean;
  raw: JsonOutput;
  /**
   * Attachments
   */
  attachments: Array<HubSpotAttachmentRefV1>;
};

/**
 * HubSpotThreadV1
 */
export type HubSpotThreadV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Associated Ticket Id
   */
  associated_ticket_id: string | null;
};

/**
 * HubSpotTicketFullV1
 */
export type HubSpotTicketFullV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Subject
   */
  subject: string | null;
  /**
   * Content
   */
  content: string | null;
  /**
   * Status
   */
  status: string | null;
  /**
   * Priority
   */
  priority: string | null;
  /**
   * Owner Id
   */
  owner_id: string | null;
  /**
   * Pipeline
   */
  pipeline: string | null;
  /**
   * Archived
   */
  archived: boolean;
  /**
   * Created At
   */
  created_at: string;
  /**
   * Updated At
   */
  updated_at: string;
  /**
   * Extra Properties
   */
  extra_properties: {
    [key: string]: JsonOutput;
  };
};

/**
 * HubSpotTicketPageV1
 */
export type HubSpotTicketPageV1 = {
  /**
   * Tickets
   */
  tickets: Array<HubSpotTicketV1>;
  /**
   * After Cursor
   */
  after_cursor: string | null;
};

/**
 * HubSpotTicketV1
 */
export type HubSpotTicketV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Subject
   */
  subject: string | null;
  /**
   * Content
   */
  content: string | null;
  /**
   * Status
   */
  status: string | null;
  /**
   * Priority
   */
  priority: string | null;
  /**
   * Owner Id
   */
  owner_id: string | null;
  /**
   * Archived
   */
  archived: boolean;
  /**
   * Created At
   */
  created_at: string;
  /**
   * Updated At
   */
  updated_at: string;
};

/**
 * HubSpotUpdateNoteParamsV1
 */
export type HubSpotUpdateNoteParamsV1 = {
  /**
   * Tenant Id
   */
  tenant_id: number;
  /**
   * Note Id
   */
  note_id: string;
  /**
   * Body
   */
  body: string;
};

/**
 * HubSpotUpdateTicketPropertiesParamsV1
 */
export type HubSpotUpdateTicketPropertiesParamsV1 = {
  /**
   * Ticket Id
   */
  ticket_id: string;
  /**
   * Properties
   */
  properties: {
    [key: string]: string;
  };
};

/**
 * HybridSearchParamsV1
 */
export type HybridSearchParamsV1 = {
  ref: NonEmptyStr;
  query: SanitizedStr;
  /**
   * Top K
   */
  top_k?: number;
};

/**
 * HybridSearchResponseV1
 */
export type HybridSearchResponseV1 = {
  /**
   * Sources
   */
  sources: Array<HybridSearchSourceV1>;
};

/**
 * HybridSearchSourceV1
 */
export type HybridSearchSourceV1 = {
  /**
   * Path
   */
  path: string;
  article: GitArticleV1;
};

/**
 * ImageContentTypeV1
 */
export const ImageContentTypeV1 = {
  IMAGE_PNG: "image/png",
  IMAGE_JPEG: "image/jpeg",
  IMAGE_WEBP: "image/webp",
  IMAGE_GIF: "image/gif",
} as const;

/**
 * ImageContentTypeV1
 */
export type ImageContentTypeV1 =
  (typeof ImageContentTypeV1)[keyof typeof ImageContentTypeV1];

/**
 * ImageUploadUrlRequestV1
 */
export type ImageUploadUrlRequestV1 = {
  filename: SanitizedStr;
  content_type: ImageContentTypeV1;
};

/**
 * ImageUploadUrlResponseV1
 */
export type ImageUploadUrlResponseV1 = {
  upload_url: SanitizedStr;
  uri: SanitizedStr;
  /**
   * File Path
   */
  file_path: string;
  full_path: SanitizedStr;
};

/**
 * IndexTextResponseV2
 */
export type IndexTextResponseV2 = {
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Index Text
   */
  index_text: string;
};

/**
 * InferenceCitationV1
 */
export type InferenceCitationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Datapoint Id
   */
  datapoint_id: number;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Section Id
   */
  section_id: number;
  /**
   * Document Id
   */
  document_id: number;
  /**
   * Output Id
   */
  output_id: number;
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Kb Name
   */
  kb_name: string;
  /**
   * Section Number
   */
  section_number: string;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * InferenceConfidenceV1
 */
export const InferenceConfidenceV1 = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
} as const;

/**
 * InferenceConfidenceV1
 */
export type InferenceConfidenceV1 =
  (typeof InferenceConfidenceV1)[keyof typeof InferenceConfidenceV1];

/**
 * InferenceConversationFullV1
 */
export type InferenceConversationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Task Id
   */
  task_id: number;
  conversation: ConversationFullV2;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceConversationInferenceFullV1
 */
export type InferenceConversationInferenceFullV1 = {
  /**
   * Kind
   */
  kind: "conversation";
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Conversation External Id
   */
  conversation_external_id: string;
  input_conversation: ConversationFullV2;
  /**
   * Output Messages
   */
  output_messages: Array<ConversationMessageFullV2>;
  /**
   * Reasoning
   */
  reasoning: string;
  confidence: InferenceConfidenceV1 | null;
  raw_output: JsonOutput | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceConversationInferenceV1
 */
export type InferenceConversationInferenceV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Conversation External Id
   */
  conversation_external_id: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceConversationV1
 */
export type InferenceConversationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceDatapointFullV1
 */
export type InferenceDatapointFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  model: DatapointExtractedInputOutputFullV1;
  view: DatapointExtractedInputOutputFullV1 | null;
  /**
   * Metadata
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceDatapointFullV2
 */
export type InferenceDatapointFullV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  model: DatapointExtractedInputOutputFullV2;
  view: DatapointExtractedInputOutputFullV2 | null;
  /**
   * Metadata
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceDatapointSpansV1
 */
export type InferenceDatapointSpansV1 = {
  model: ExtractedInputOutputSpansV1;
  view?: ExtractedInputOutputSpansV1 | null;
};

/**
 * InferenceDatapointV1
 */
export type InferenceDatapointV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceEvalFullV1
 */
export type InferenceEvalFullV1 = {
  /**
   * Id
   */
  id: number;
  kind: EvalKindV1;
  /**
   * Passed
   */
  passed: boolean;
  /**
   * Judge Id
   */
  judge_id: number;
  /**
   * Judge Name
   */
  judge_name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceFeedbackFullV1
 */
export type InferenceFeedbackFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  inference: InferenceFullV1 | null;
  /**
   * Conversation External Id
   */
  conversation_external_id: string | null;
  label: SanitizedStr | null;
  feedback: SanitizedStr | null;
  raw_feedback: JsonOutput;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
};

/**
 * InferenceFeedbackLabelV1
 */
export type InferenceFeedbackLabelV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  label: SanitizedStr;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * InferenceFeedbackV1
 */
export type InferenceFeedbackV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Datapoint Id
   */
  datapoint_id: number | null;
  /**
   * Inference Id
   */
  inference_id: number | null;
  feedback_label: SanitizedStr | null;
  feedback_note: SanitizedStr | null;
  raw_feedback_note: JsonOutput;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * InferenceFullV1
 */
export type InferenceFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Datapoint Id
   */
  datapoint_id: number;
  predicted_output: SanitizedStr;
  raw_output: JsonOutput;
  confidence: InferenceConfidenceV1 | null;
  /**
   * Reasoning
   */
  reasoning: string;
  /**
   * Citations
   */
  citations: Array<InferenceCitationV1>;
  /**
   * Evals
   */
  evals: Array<InferenceEvalFullV1>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InferenceModeV1
 */
export const InferenceModeV1 = { FAST: "fast", SLOW: "slow" } as const;

/**
 * InferenceModeV1
 */
export type InferenceModeV1 =
  (typeof InferenceModeV1)[keyof typeof InferenceModeV1];

/**
 * IngestionFileV1
 */
export type IngestionFileV1 = {
  /**
   * Id
   */
  id: number;
  s3_uri: SanitizedStr;
  version_id: SanitizedStr;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * InvitationFullV1
 */
export type InvitationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Email
   */
  email: string;
  role: InviteRoleV1;
  /**
   * Teams
   */
  teams: Array<TeamV1>;
  created_by_user: UserFullV1;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * InvitationV1
 */
export type InvitationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Email
   */
  email: string;
  role: InviteRoleV1;
  /**
   * Teams
   */
  teams: Array<TeamV1>;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * InviteRoleV1
 */
export const InviteRoleV1 = { MEMBER: "member", ADMIN: "admin" } as const;

/**
 * InviteRoleV1
 */
export type InviteRoleV1 = (typeof InviteRoleV1)[keyof typeof InviteRoleV1];

/**
 * JiraAttachmentV1
 */
export type JiraAttachmentV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Filename
   */
  filename: string;
  author: JiraUserV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Mime Type
   */
  mime_type: string;
};

export type JiraCheckConnectionResponseV1 =
  | ({
      kind: "connected";
    } & JiraConnectedV1)
  | ({
      kind: "disconnected";
    } & JiraDisconnectedV1);

/**
 * JiraCommentV1
 */
export type JiraCommentV1 = {
  /**
   * Id
   */
  id: string;
  author: JiraUserV1;
  /**
   * Body
   */
  body: string;
  /**
   * Is Public
   */
  is_public: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * JiraConnectedV1
 */
export type JiraConnectedV1 = {
  /**
   * Kind
   */
  kind: "connected";
};

/**
 * JiraCustomFieldOptionV1
 */
export type JiraCustomFieldOptionV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Value
   */
  value: string;
};

/**
 * JiraCustomFieldV1
 */
export type JiraCustomFieldV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  value: JsonOutput;
};

/**
 * JiraDisconnectedV1
 */
export type JiraDisconnectedV1 = {
  /**
   * Kind
   */
  kind: "disconnected";
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * JiraGetAttachmentContentResponseV2
 */
export type JiraGetAttachmentContentResponseV2 = {
  /**
   * Attachment Id
   */
  attachment_id: string;
  /**
   * Content
   */
  content: string;
  /**
   * Mime Type
   */
  mime_type: string;
  /**
   * Size
   */
  size: number;
  /**
   * Chunk Index
   */
  chunk_index: number;
  /**
   * Chunk Size
   */
  chunk_size: number;
  /**
   * Chunk Count
   */
  chunk_count: number;
};

/**
 * JiraGetCustomFieldOptionsResponseV1
 */
export type JiraGetCustomFieldOptionsResponseV1 = {
  /**
   * Field Id
   */
  field_id: string;
  /**
   * Options
   */
  options: Array<JiraCustomFieldOptionV1>;
};

/**
 * JiraGetIssuesResponseV1
 */
export type JiraGetIssuesResponseV1 = {
  /**
   * Items
   */
  items: Array<JiraIssueV1>;
  /**
   * Next Page Token
   */
  next_page_token?: string | null;
};

/**
 * JiraHandleWebhookEventResponseV1
 */
export type JiraHandleWebhookEventResponseV1 = {
  /**
   * Workflow Run Ids
   */
  workflow_run_ids: Array<number>;
};

/**
 * JiraHeadingLevelV1
 */
export const JiraHeadingLevelV1 = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
} as const;

/**
 * JiraHeadingLevelV1
 */
export type JiraHeadingLevelV1 =
  (typeof JiraHeadingLevelV1)[keyof typeof JiraHeadingLevelV1];

/**
 * JiraInlineTextLinkV1
 */
export type JiraInlineTextLinkV1 = {
  /**
   * Kind
   */
  kind: "LINK";
  /**
   * Text
   */
  text: string;
  /**
   * Href
   */
  href: string;
};

/**
 * JiraInlineTextV1
 */
export type JiraInlineTextV1 = {
  /**
   * Kind
   */
  kind: "TEXT";
  /**
   * Text
   */
  text: string;
};

export type JiraInlineV1 = JiraInlineTextV1 | JiraInlineTextLinkV1;

/**
 * JiraIssueStatusV1
 */
export type JiraIssueStatusV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Category
   */
  category: string;
};

/**
 * JiraIssueTypeV1
 */
export type JiraIssueTypeV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
};

/**
 * JiraIssueV1
 */
export type JiraIssueV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Key
   */
  key: string;
  /**
   * Summary
   */
  summary: string;
  /**
   * Description
   */
  description: string;
  status: JiraIssueStatusV1;
  issue_type: JiraIssueTypeV1;
  project: JiraProjectV1;
  creator: JiraUserV1;
  reporter: JiraUserV1;
  assignee?: JiraUserV1 | null;
  /**
   * Custom Fields
   */
  custom_fields: Array<JiraCustomFieldV1>;
  /**
   * Comments
   */
  comments: Array<JiraCommentV1>;
  /**
   * Attachments
   */
  attachments: Array<JiraAttachmentV1>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * JiraListTypeV1
 */
export const JiraListTypeV1 = {
  ORDERED: "ordered",
  UNORDERED: "unordered",
} as const;

/**
 * JiraListTypeV1
 */
export type JiraListTypeV1 =
  (typeof JiraListTypeV1)[keyof typeof JiraListTypeV1];

/**
 * JiraPanelTypeV1
 */
export const JiraPanelTypeV1 = {
  INFO: "INFO",
  NOTE: "NOTE",
  TIP: "TIP",
  WARNING: "WARNING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
} as const;

/**
 * JiraPanelTypeV1
 */
export type JiraPanelTypeV1 =
  (typeof JiraPanelTypeV1)[keyof typeof JiraPanelTypeV1];

/**
 * JiraPostCommentRequestV2
 */
export type JiraPostCommentRequestV2 = {
  /**
   * Issue Key
   */
  issue_key: string;
  /**
   * Content
   */
  content: Array<JiraRichTextV1>;
  /**
   * Is Public
   */
  is_public?: boolean;
};

/**
 * JiraPostCommentResponseV2
 */
export type JiraPostCommentResponseV2 = {
  /**
   * Jira Status Code
   */
  jira_status_code: number;
};

/**
 * JiraProjectV1
 */
export type JiraProjectV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Type
   */
  type: string;
  /**
   * Key
   */
  key: string;
};

/**
 * JiraRichTextCodeBlockV1
 */
export type JiraRichTextCodeBlockV1 = {
  /**
   * Kind
   */
  kind?: "CODE_BLOCK";
  /**
   * Content
   */
  content: string;
  /**
   * Language
   */
  language: string;
};

/**
 * JiraRichTextExpandV1
 */
export type JiraRichTextExpandV1 = {
  /**
   * Kind
   */
  kind: "EXPAND";
  /**
   * Content
   */
  content: Array<JiraRichTextParagraphV1 | JiraRichTextHeadingV1>;
};

/**
 * JiraRichTextHeadingV1
 */
export type JiraRichTextHeadingV1 = {
  /**
   * Kind
   */
  kind: "HEADING";
  /**
   * Content
   */
  content: Array<JiraInlineV1> | string;
  level: JiraHeadingLevelV1;
};

/**
 * JiraRichTextListV1
 */
export type JiraRichTextListV1 = {
  /**
   * Kind
   */
  kind: "LIST";
  type: JiraListTypeV1;
  /**
   * Items
   */
  items: Array<JiraRichTextParagraphV1>;
};

/**
 * JiraRichTextPanelV1
 */
export type JiraRichTextPanelV1 = {
  /**
   * Kind
   */
  kind: "PANEL";
  type: JiraPanelTypeV1;
  /**
   * Content
   */
  content: Array<JiraRichTextParagraphV1 | JiraRichTextHeadingV1>;
};

/**
 * JiraRichTextParagraphV1
 */
export type JiraRichTextParagraphV1 = {
  /**
   * Kind
   */
  kind: "PARAGRAPH";
  /**
   * Content
   */
  content: Array<JiraInlineV1> | string;
};

/**
 * JiraRichTextQuoteV1
 */
export type JiraRichTextQuoteV1 = {
  /**
   * Kind
   */
  kind: "QUOTE";
  /**
   * Content
   */
  content: Array<JiraInlineV1> | string;
};

/**
 * JiraRichTextRuleV1
 */
export type JiraRichTextRuleV1 = {
  /**
   * Kind
   */
  kind: "RULE";
};

export type JiraRichTextV1 =
  | JiraRichTextParagraphV1
  | JiraRichTextHeadingV1
  | JiraRichTextListV1
  | JiraRichTextQuoteV1
  | JiraRichTextCodeBlockV1
  | JiraRichTextPanelV1
  | JiraRichTextExpandV1
  | JiraRichTextRuleV1;

/**
 * JiraSetCustomFieldRequestV1
 */
export type JiraSetCustomFieldRequestV1 = {
  /**
   * Issue Key
   */
  issue_key: string;
  /**
   * Field Id
   */
  field_id: string;
  value: JsonInput;
};

/**
 * JiraSetCustomFieldResponseV1
 */
export type JiraSetCustomFieldResponseV1 = {
  [key: string]: unknown;
};

/**
 * JiraTenantConfigV1
 */
export type JiraTenantConfigV1 = {
  /**
   * Base Url
   */
  base_url: string;
  /**
   * Installation Id
   */
  installation_id: string;
  /**
   * Action Api Path
   */
  action_api_path: string;
  /**
   * Has Api Key
   */
  has_api_key: boolean;
  /**
   * Has Webhook Secret
   */
  has_webhook_secret: boolean;
};

/**
 * JiraTenantFullV1
 */
export type JiraTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  config: JiraTenantConfigV1 | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JiraTenantV1
 */
export type JiraTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JiraUpdateIssueLabelsRequestV1
 */
export type JiraUpdateIssueLabelsRequestV1 = {
  /**
   * Issue Key
   */
  issue_key: string;
  /**
   * Add Labels
   */
  add_labels?: Array<string>;
  /**
   * Remove Labels
   */
  remove_labels?: Array<string>;
};

/**
 * JiraUpdateIssueLabelsResponseV1
 */
export type JiraUpdateIssueLabelsResponseV1 = {
  [key: string]: unknown;
};

/**
 * JiraUserAccountTypeV1
 */
export const JiraUserAccountTypeV1 = {
  ATLASSIAN: "atlassian",
  APP: "app",
  CUSTOMER: "customer",
  UNKNOWN: "unknown",
} as const;

/**
 * JiraUserAccountTypeV1
 */
export type JiraUserAccountTypeV1 =
  (typeof JiraUserAccountTypeV1)[keyof typeof JiraUserAccountTypeV1];

/**
 * JiraUserV1
 */
export type JiraUserV1 = {
  /**
   * Account Id
   */
  account_id: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Email Address
   */
  email_address: string | null;
  account_type?: JiraUserAccountTypeV1 | null;
};

export type JsonInput =
  | number
  | number
  | string
  | boolean
  | Array<JsonInput>
  | {
      [key: string]: JsonInput;
    }
  | null;

export type JsonOutput =
  | number
  | number
  | string
  | boolean
  | Array<JsonOutput>
  | {
      [key: string]: JsonOutput;
    }
  | null;

/**
 * JsonSchemaV1
 */
export type JsonSchemaV1Input = {
  type: SanitizedStr;
  /**
   * Properties
   */
  properties: {
    [key in SanitizedStr]?: JsonInput;
  };
  /**
   * Required
   */
  required: Array<SanitizedStr>;
  /**
   * $Defs
   */
  $defs?:
    | {
        [key in SanitizedStr]?: JsonInput;
      }
    | null;
};

/**
 * JsonSchemaV1
 */
export type JsonSchemaV1Output = {
  type: SanitizedStr;
  /**
   * Properties
   */
  properties: {
    [key in SanitizedStr]?: JsonOutput;
  };
  /**
   * Required
   */
  required: Array<SanitizedStr>;
  /**
   * $Defs
   */
  $defs?:
    | {
        [key in SanitizedStr]?: JsonOutput;
      }
    | null;
};

/**
 * JudgeBarContentV1
 */
export type JudgeBarContentV1 = {
  /**
   * Kind
   */
  kind: "JUDGE_BAR";
  judge_name: SanitizedStr;
  /**
   * Values
   */
  values: Array<JudgeBarValueV1>;
  orientation: OrientationV1;
  /**
   * Color Scale
   */
  color_scale?: ColorScaleV1 | Array<ColorV1> | null;
  time_bucket: TimeBucketV1;
};

/**
 * JudgeBarValueV1
 */
export type JudgeBarValueV1 = {
  label: SanitizedStr;
  /**
   * Value
   */
  value: number;
};

/**
 * JudgeBucket
 */
export type JudgeBucket = {
  /**
   * Passed
   */
  passed: number;
  /**
   * Total
   */
  total: number;
};

/**
 * JudgeColorScale
 */
export const JudgeColorScale = {
  SUCCESS_TO_DANGER: "SUCCESS_TO_DANGER",
  DANGER_TO_SUCCESS: "DANGER_TO_SUCCESS",
  COOL_TO_WARM: "COOL_TO_WARM",
  WARM_TO_COOL: "WARM_TO_COOL",
} as const;

/**
 * JudgeColorScale
 */
export type JudgeColorScale =
  (typeof JudgeColorScale)[keyof typeof JudgeColorScale];

/**
 * JudgeFilterOptionV1
 */
export type JudgeFilterOptionV1 = {
  judge: JudgeV2;
  /**
   * Values
   */
  values: Array<JudgementOrdinalValueV2>;
};

/**
 * JudgeFullV2
 */
export type JudgeFullV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Display Name
   */
  display_name: string;
  color_scale: JudgeColorScale | null;
  /**
   * Ordinal Values
   */
  ordinal_values: Array<JudgeOrdinalV2>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JudgeGaugeContentV1
 */
export type JudgeGaugeContentV1 = {
  /**
   * Kind
   */
  kind: "JUDGE_GAUGE";
  judge_name: SanitizedStr;
  result: JudgeBucket;
  /**
   * Segments
   */
  segments: Array<JudgeGaugeSegmentV1>;
};

/**
 * JudgeGaugeSegmentV1
 */
export type JudgeGaugeSegmentV1 = {
  /**
   * Start
   */
  start: number;
  /**
   * End
   */
  end: number;
  label?: SanitizedStr | null;
  color?: ColorV1 | null;
};

/**
 * JudgeOrdinalV2
 */
export type JudgeOrdinalV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Key
   */
  key: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * JudgePercentageContentV1
 */
export type JudgePercentageContentV1 = {
  /**
   * Kind
   */
  kind: "JUDGE_PERCENTAGE";
  judge_name: SanitizedStr;
  result: JudgeBucket;
  /**
   * Display Progress
   */
  display_progress: boolean;
};

/**
 * JudgePercentageProgressBarContentV1
 */
export type JudgePercentageProgressBarContentV1 = {
  /**
   * Kind
   */
  kind: "JUDGE_PERCENTAGE_PROGRESS_BAR";
  judge_name: SanitizedStr;
  result: JudgeBucket;
  previous_result: JudgeBucket | null;
  /**
   * Target
   */
  target?: number | null;
  /**
   * Series
   */
  series: Array<JudgeBucket>;
  x_axis_labels: XAxisLabelsDateV1;
  time_bucket: TimeBucketV1;
};

/**
 * JudgeSeriesContentV1
 */
export type JudgeSeriesContentV1 = {
  /**
   * Kind
   */
  kind: "JUDGE_SERIES";
  judge_name: SanitizedStr;
  /**
   * Stacked
   */
  stacked: boolean;
  mode: ChartSeriesModeV1;
  /**
   * Series
   */
  series: Array<JudgeSeriesV1>;
  /**
   * Reference Lines
   */
  reference_lines: Array<ReferenceLineV1>;
  /**
   * X Axis Labels
   */
  x_axis_labels: XAxisLabelsDateV1 | XAxisLabelsTextV1;
  /**
   * Color Scale
   */
  color_scale?: ColorScaleV1 | Array<ColorV1> | null;
  time_bucket: TimeBucketV1;
};

/**
 * JudgeSeriesV1
 */
export type JudgeSeriesV1 = {
  label: SanitizedStr;
  /**
   * Values
   */
  values: Array<number>;
};

/**
 * JudgeSingleStatContentV1
 */
export type JudgeSingleStatContentV1 = {
  /**
   * Kind
   */
  kind: "JUDGE_SINGLE_STAT";
  judge_name: SanitizedStr;
  /**
   * Value
   */
  value: number;
  /**
   * Previous Value
   */
  previous_value?: number | null;
};

/**
 * JudgeV2
 */
export type JudgeV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Judge Key
   */
  judge_key: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JudgementFilterOptionsParamsV1
 */
export type JudgementFilterOptionsParamsV1 = {
  search_by: FullEvaluatedInferenceDatapointsSearchByV1;
  visibility?: VisibilityFilterV1;
};

/**
 * JudgementFilterOptionsResultV1
 */
export type JudgementFilterOptionsResultV1 = {
  /**
   * Judges
   */
  judges: Array<JudgeFilterOptionV1>;
};

/**
 * JudgementFullAgentV3
 */
export type JudgementFullAgentV3 = {
  /**
   * Kind
   */
  kind: "agent";
  /**
   * Id
   */
  id: number;
  judge: JudgeV2;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Reasoning
   */
  reasoning: string | null;
  value: JudgementOrdinalValueV2;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JudgementFullExternalV3
 */
export type JudgementFullExternalV3 = {
  /**
   * Kind
   */
  kind: "external";
  /**
   * Id
   */
  id: number;
  judge: JudgeV2;
  /**
   * Inference Id
   */
  inference_id: number;
  source: ExternalInferenceSourceV1;
  /**
   * Finalized Conversation Id
   *
   * @deprecated
   */
  finalized_conversation_id: number | null;
  /**
   * Message Id
   *
   * @deprecated
   */
  message_id: number | null;
  /**
   * Reasoning
   */
  reasoning: string | null;
  value: JudgementOrdinalValueV2;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JudgementFullPlatformV3
 */
export type JudgementFullPlatformV3 = {
  /**
   * Kind
   */
  kind: "platform";
  /**
   * Id
   */
  id: number;
  judge: JudgeV2;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Inference Conversation Inference Id
   *
   * @deprecated
   */
  inference_conversation_inference_id: number;
  /**
   * Reasoning
   */
  reasoning: string | null;
  value: JudgementOrdinalValueV2;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JudgementFullV2
 */
export type JudgementFullV2 = {
  /**
   * Id
   */
  id: number;
  judge: JudgeV2;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Inference Conversation Inference Id
   *
   * @deprecated
   */
  inference_conversation_inference_id: number;
  /**
   * Reasoning
   */
  reasoning: string | null;
  value: JudgementOrdinalValueV2;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

export type JudgementFullV3 =
  | ({
      kind: "platform";
    } & JudgementFullPlatformV3)
  | ({
      kind: "external";
    } & JudgementFullExternalV3)
  | ({
      kind: "agent";
    } & JudgementFullAgentV3);

/**
 * JudgementOrdinalValueV2
 */
export type JudgementOrdinalValueV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Key
   */
  key: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Position
   */
  position: number;
  /**
   * Total Items
   */
  total_items: number;
  color_scale: ColorScaleV1 | null;
};

/**
 * JudgementV2
 */
export type JudgementV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Reasoning
   */
  reasoning: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JudgementV3
 */
export type JudgementV3 = {
  /**
   * Id
   */
  id: number;
  /**
   * Inference Id
   */
  inference_id: number;
  /**
   * Reasoning
   */
  reasoning: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * JudgementValueFilterV1
 */
export type JudgementValueFilterV1 = {
  /**
   * Judge Id
   */
  judge_id: number;
  /**
   * Value Keys
   */
  value_keys: Array<SanitizedStr>;
};

/**
 * KanonicalDatapointFullV2
 */
export type KanonicalDatapointFullV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Title
   */
  title: string | null;
  /**
   * Summary
   */
  summary: string | null;
  model: KanonicalInputOutputFullV2;
  view: KanonicalInputOutputFullV2;
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * KanonicalDatapointV1
 */
export type KanonicalDatapointV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * KanonicalInputOutputFullV2
 */
export type KanonicalInputOutputFullV2 = {
  kanonical_input: KanonicalMessagesFullV2;
  kanonical_output: KanonicalMessagesFullV2;
};

/**
 * KanonicalMessagesFullV2
 */
export type KanonicalMessagesFullV2 = {
  /**
   * Messages
   */
  messages: Array<ConversationMessageFullV2>;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * KanonicalizeDatapointsDequeueByDagsterRunV1
 */
export type KanonicalizeDatapointsDequeueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * KanonicalizeDatapointsDequeueByIdsV1
 */
export type KanonicalizeDatapointsDequeueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
};

/**
 * KanonicalizeDatapointsDequeueRequestV1
 */
export type KanonicalizeDatapointsDequeueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & KanonicalizeDatapointsDequeueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & KanonicalizeDatapointsDequeueByDagsterRunV1);
};

/**
 * KanonicalizeDatapointsDequeueResponseV1
 */
export type KanonicalizeDatapointsDequeueResponseV1 = {
  /**
   * Dequeued Datapoint Ids
   */
  dequeued_datapoint_ids: Array<number>;
};

/**
 * KanonicalizeDatapointsEnqueueByDagsterRunV1
 */
export type KanonicalizeDatapointsEnqueueByDagsterRunV1 = {
  /**
   * Kind
   */
  kind: "by_dagster_run";
  dagster_run_id: NonEmptyStr;
};

/**
 * KanonicalizeDatapointsEnqueueByIdsV1
 */
export type KanonicalizeDatapointsEnqueueByIdsV1 = {
  /**
   * Kind
   */
  kind: "by_ids";
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
};

/**
 * KanonicalizeDatapointsEnqueueRequestV1
 */
export type KanonicalizeDatapointsEnqueueRequestV1 = {
  /**
   * Select By
   */
  select_by:
    | ({
        kind: "by_ids";
      } & KanonicalizeDatapointsEnqueueByIdsV1)
    | ({
        kind: "by_dagster_run";
      } & KanonicalizeDatapointsEnqueueByDagsterRunV1);
};

/**
 * KanonicalizeDatapointsEnqueueResponseV1
 */
export type KanonicalizeDatapointsEnqueueResponseV1 = {
  /**
   * Enqueued Datapoint Ids
   */
  enqueued_datapoint_ids: Array<number>;
};

/**
 * KanonicalizeDatapointsInputRequestV1
 */
export type KanonicalizeDatapointsInputRequestV1 = {
  dagster_run_id: NonEmptyStr;
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Max Processing Time
   */
  max_processing_time?: string | Missing;
  /**
   * Sufficiency Threshold
   */
  sufficiency_threshold?: number | Missing;
};

/**
 * KanonicalizeDatapointsInputResponseV1
 */
export type KanonicalizeDatapointsInputResponseV1 = {
  /**
   * Insufficient Kanonical Datapoint Ids
   */
  insufficient_kanonical_datapoint_ids: Array<number>;
  /**
   * Unassigned Datapoint Ids
   */
  unassigned_datapoint_ids: Array<number>;
};

/**
 * KanonicalizeDatapointsOutputCreateV1
 */
export type KanonicalizeDatapointsOutputCreateV1 = {
  /**
   * Datapoint Ids
   */
  datapoint_ids: Array<number>;
  /**
   * Title
   */
  title?: string | null;
  /**
   * Summary
   */
  summary?: string | null;
  model: CreateKanonicalInputOutputV2;
  view?: CreateKanonicalInputOutputV2 | null;
  /**
   * Metadata
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * KanonicalizeDatapointsOutputRequestV1
 */
export type KanonicalizeDatapointsOutputRequestV1 = {
  /**
   * Task Id
   */
  task_id: number;
  dagster_run_id: NonEmptyStr;
  /**
   * New Kanonical Datapoints
   */
  new_kanonical_datapoints: Array<KanonicalizeDatapointsOutputCreateV1>;
  /**
   * Updated Kanonical Datapoints
   */
  updated_kanonical_datapoints: Array<KanonicalizeDatapointsOutputUpdateV1>;
};

/**
 * KanonicalizeDatapointsOutputResponseV1
 */
export type KanonicalizeDatapointsOutputResponseV1 = {
  /**
   * Created Kanonical Datapoint Ids
   */
  created_kanonical_datapoint_ids: Array<number>;
  /**
   * Updated Kanonical Datapoint Ids
   */
  updated_kanonical_datapoint_ids: Array<number>;
};

/**
 * KanonicalizeDatapointsOutputUpdateV1
 */
export type KanonicalizeDatapointsOutputUpdateV1 = {
  /**
   * Kanonical Datapoint Id
   */
  kanonical_datapoint_id: number;
  update: UpdateKanonicalDatapointV1;
};

/**
 * KbAccessRequestFullV1
 */
export type KbAccessRequestFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Org Id
   */
  org_id: number;
  /**
   * Article Id
   */
  article_id: number | null;
  knowledge_base: KnowledgeBaseV2;
  requester: UserFullV1;
  status: KbAccessRequestStatusV1;
  message: SanitizedStr | null;
  /**
   * Resolved By User Id
   */
  resolved_by_user_id: number | null;
  /**
   * Resolved At
   */
  resolved_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * KbAccessRequestResolutionV1
 */
export const KbAccessRequestResolutionV1 = {
  APPROVED: "approved",
  DENIED: "denied",
} as const;

/**
 * KbAccessRequestResolutionV1
 */
export type KbAccessRequestResolutionV1 =
  (typeof KbAccessRequestResolutionV1)[keyof typeof KbAccessRequestResolutionV1];

/**
 * KbAccessRequestStatusV1
 */
export const KbAccessRequestStatusV1 = {
  PENDING: "pending",
  APPROVED: "approved",
  DENIED: "denied",
} as const;

/**
 * KbAccessRequestStatusV1
 */
export type KbAccessRequestStatusV1 =
  (typeof KbAccessRequestStatusV1)[keyof typeof KbAccessRequestStatusV1];

/**
 * KbAccessRequestV1
 */
export type KbAccessRequestV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Org Id
   */
  org_id: number;
  /**
   * Kb Id
   */
  kb_id: number;
  /**
   * Article Id
   */
  article_id: number | null;
  /**
   * Requester User Id
   */
  requester_user_id: number;
  status: KbAccessRequestStatusV1;
  message: SanitizedStr | null;
  /**
   * Resolved By User Id
   */
  resolved_by_user_id: number | null;
  /**
   * Resolved At
   */
  resolved_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * KbArticleRankOrderV1
 */
export const KbArticleRankOrderV1 = {
  HIGHEST_VALUE: "highest_value",
  LOWEST_VALUE: "lowest_value",
  HIGHEST_VOLUME: "highest_volume",
  LOWEST_VOLUME: "lowest_volume",
} as const;

/**
 * KbArticleRankOrderV1
 */
export type KbArticleRankOrderV1 =
  (typeof KbArticleRankOrderV1)[keyof typeof KbArticleRankOrderV1];

/**
 * KbChildJudgementMetricsResponseV1
 */
export type KbChildJudgementMetricsResponseV1 = {
  /**
   * Children
   */
  children: Array<KbChildJudgementMetricsV1>;
};

/**
 * KbChildJudgementMetricsV1
 */
export type KbChildJudgementMetricsV1 = {
  kind: KbChildKindV1;
  /**
   * Name
   */
  name: string;
  /**
   * Path
   */
  path: string;
  /**
   * Volume
   */
  volume: number;
  /**
   * Value Volumes
   */
  value_volumes: Array<KbJudgementValueVolumeV1>;
};

/**
 * KbChildKindV1
 */
export const KbChildKindV1 = { ARTICLE: "article", TREE: "tree" } as const;

/**
 * KbChildKindV1
 */
export type KbChildKindV1 = (typeof KbChildKindV1)[keyof typeof KbChildKindV1];

/**
 * KbJudgementValueVolumeV1
 */
export type KbJudgementValueVolumeV1 = {
  /**
   * Id
   */
  id: number;
  key: SanitizedStr;
  display_name: SanitizedStr;
  /**
   * Position
   */
  position: number;
  /**
   * Volume
   */
  volume: number;
};

/**
 * KbScopeV1
 */
export const KbScopeV1 = {
  KB_READ: "kb:read",
  KB_PUBLISH: "kb:publish",
} as const;

/**
 * KbScopeV1
 */
export type KbScopeV1 = (typeof KbScopeV1)[keyof typeof KbScopeV1];

/**
 * KbTopArticleJudgementMetricsV1
 */
export type KbTopArticleJudgementMetricsV1 = {
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Object Id
   */
  object_id: number;
  /**
   * Path
   */
  path: string;
  /**
   * Title
   */
  title: string;
  /**
   * Verified
   */
  verified: boolean;
  /**
   * Volume
   */
  volume: number;
  /**
   * Average Value
   */
  average_value: number;
  /**
   * Weighted Value
   */
  weighted_value: number;
  /**
   * Value Volumes
   */
  value_volumes: Array<KbJudgementValueVolumeV1>;
};

/**
 * KnowledgeBaseFullV1
 */
export type KnowledgeBaseFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Task Id
   */
  task_id: number | null;
  /**
   * External Id
   */
  external_id: string | null;
  created_by_user: UserFullV1;
  /**
   * Cr Review Sla Business Days
   */
  cr_review_sla_business_days: number | null;
  /**
   * Article Count
   */
  article_count: number;
  /**
   * Section Count
   */
  section_count: number;
  /**
   * Last Updated At
   */
  last_updated_at: Date;
  last_updated_by_user: UserFullV1 | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

export type KnowledgeBaseSearchContentV1 =
  | ({
      kind: "VISIBLE";
    } & VisibleKnowledgeBaseContentV1)
  | ({
      kind: "REDACTED";
    } & RedactedKnowledgeBaseContentV1);

/**
 * KnowledgeBaseV2
 */
export type KnowledgeBaseV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Task Id
   */
  task_id: number | null;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Cr Review Sla Business Days
   */
  cr_review_sla_business_days: number | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * KnownIncomingKbV1
 */
export type KnownIncomingKbV1 = {
  /**
   * Published Kb Id
   */
  published_kb_id: number;
  /**
   * Patches
   */
  patches: Array<GitPatchV2>;
};

export type LimitFilterV1 = number | "all";

export type LimitV1 = number | "all";

/**
 * LineChartContentSeriesV1
 */
export type LineChartContentSeriesV1 = {
  label: SanitizedStr;
  /**
   * Values
   */
  values: Array<number>;
};

/**
 * LineChartContentV1
 */
export type LineChartContentV1 = {
  /**
   * Kind
   */
  kind: "LINE";
  /**
   * Stacked
   */
  stacked: boolean;
  /**
   * Reference Lines
   */
  reference_lines: Array<ReferenceLineV1>;
  y_axis_title: SanitizedStr;
  /**
   * X Axis Labels
   */
  x_axis_labels: XAxisLabelsDateV1 | XAxisLabelsTextV1;
  /**
   * Series
   */
  series: Array<LineChartContentSeriesV1>;
  color_scale?: ColorScaleV1 | null;
  time_bucket: TimeBucketV1;
};

/**
 * LineRangeV1
 */
export type LineRangeV1 = {
  /**
   * Start
   */
  start: number;
  /**
   * End
   */
  end: number;
};

/**
 * MachineUserFullV1
 */
export type MachineUserFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Organization Id
   */
  organization_id: number;
  /**
   * Team Ids
   */
  team_ids: Array<number>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * MachineUserV1
 */
export type MachineUserV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Organization Id
   */
  organization_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * McpToolsetV1
 */
export type McpToolsetV1 = {
  /**
   * Key
   */
  key: string;
  /**
   * Name
   */
  name: string;
  endpoint_url: SanitizedStr;
};

export type Metadata = {
  [key: string]: JsonOutput;
};

/**
 * Missing
 *
 * Sentinel value for missing values.
 */
export const Missing = {
  "70B47E75_0922_4088_9132_BD389B3D4F1C7":
    "70b47e75-0922-4088-9132-bd389b3d4f1c7",
} as const;

/**
 * Missing
 *
 * Sentinel value for missing values.
 */
export type Missing = (typeof Missing)[keyof typeof Missing];

/**
 * MovedArticleV1DiffV2
 */
export type MovedArticleV1DiffV2 = {
  /**
   * Article Id
   */
  article_id: number;
  before: ArticleV1DiffSnapshotV2;
  after: ArticleV1DiffSnapshotV2;
};

export type NonEmptyStr = SanitizedStr;

export type NonEmptyStr09aF32 = SanitizedStr;

/**
 * NotificationSettingsV1
 */
export type NotificationSettingsV1 = {
  change_request_assigned: EventSourceNotificationSettingsV1 | null;
  comment_mention: EventSourceNotificationSettingsV1 | null;
};

/**
 * NotionAnnotationsV1
 */
export type NotionAnnotationsV1 = {
  /**
   * Bold
   */
  bold?: boolean;
  /**
   * Italic
   */
  italic?: boolean;
  /**
   * Strikethrough
   */
  strikethrough?: boolean;
  /**
   * Underline
   */
  underline?: boolean;
  /**
   * Code
   */
  code?: boolean;
  /**
   * Color
   */
  color: string;
};

export type NotionBlockInputV1 =
  | ({
      kind: "paragraph";
    } & NotionParagraphBlockInputV1)
  | ({
      kind: "heading_1";
    } & NotionHeading1BlockInputV1)
  | ({
      kind: "heading_2";
    } & NotionHeading2BlockInputV1)
  | ({
      kind: "heading_3";
    } & NotionHeading3BlockInputV1)
  | ({
      kind: "bulleted_list_item";
    } & NotionBulletedListItemBlockInputV1)
  | ({
      kind: "numbered_list_item";
    } & NotionNumberedListItemBlockInputV1)
  | ({
      kind: "to_do";
    } & NotionToDoBlockInputV1)
  | ({
      kind: "toggle";
    } & NotionToggleBlockInputV1)
  | ({
      kind: "quote";
    } & NotionQuoteBlockInputV1)
  | ({
      kind: "callout";
    } & NotionCalloutBlockInputV1)
  | ({
      kind: "code";
    } & NotionCodeBlockInputV1)
  | ({
      kind: "divider";
    } & NotionDividerBlockInputV1)
  | ({
      kind: "equation";
    } & NotionEquationBlockInputV1)
  | ({
      kind: "bookmark";
    } & NotionBookmarkBlockInputV1)
  | ({
      kind: "embed";
    } & NotionEmbedBlockInputV1)
  | ({
      kind: "link_preview";
    } & NotionLinkPreviewBlockInputV1)
  | ({
      kind: "image";
    } & NotionImageBlockInputV1)
  | ({
      kind: "video";
    } & NotionVideoBlockInputV1)
  | ({
      kind: "file";
    } & NotionFileBlockInputV1);

export type NotionBlockV1 = NotionKnownBlockV1 | NotionUnsupportedBlockV1;

/**
 * NotionBookmarkBlockInputV1
 */
export type NotionBookmarkBlockInputV1 = {
  /**
   * Kind
   */
  kind: "bookmark";
  bookmark: NotionBookmarkContentInputV1;
};

/**
 * NotionBookmarkBlockV1
 */
export type NotionBookmarkBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "bookmark";
  bookmark: NotionBookmarkContentV1;
};

/**
 * NotionBookmarkContentInputV1
 */
export type NotionBookmarkContentInputV1 = {
  /**
   * Url
   */
  url: string;
  /**
   * Caption
   */
  caption?: Array<NotionRichTextInputV1>;
};

/**
 * NotionBookmarkContentV1
 */
export type NotionBookmarkContentV1 = {
  /**
   * Url
   */
  url: string;
  /**
   * Caption
   */
  caption?: Array<NotionRichTextV1>;
};

/**
 * NotionBreadcrumbBlockV1
 */
export type NotionBreadcrumbBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "breadcrumb";
  breadcrumb: NotionEmptyContentV1;
};

/**
 * NotionBulletedListItemBlockInputV1
 */
export type NotionBulletedListItemBlockInputV1 = {
  /**
   * Kind
   */
  kind: "bulleted_list_item";
  bulleted_list_item: NotionRichTextContentInputV1;
};

/**
 * NotionBulletedListItemBlockV1
 */
export type NotionBulletedListItemBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "bulleted_list_item";
  bulleted_list_item: NotionRichTextContentV1;
};

/**
 * NotionCallbackPayloadV1
 */
export type NotionCallbackPayloadV1 = {
  /**
   * Code
   */
  code: string;
};

/**
 * NotionCalloutBlockInputV1
 */
export type NotionCalloutBlockInputV1 = {
  /**
   * Kind
   */
  kind: "callout";
  callout: NotionCalloutContentInputV1;
};

/**
 * NotionCalloutBlockV1
 */
export type NotionCalloutBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "callout";
  callout: NotionCalloutContentV1;
};

/**
 * NotionCalloutContentInputV1
 */
export type NotionCalloutContentInputV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextInputV1>;
  /**
   * Color
   */
  color?: string | null;
  icon?: NotionIconInputV1 | null;
};

/**
 * NotionCalloutContentV1
 */
export type NotionCalloutContentV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextV1>;
  /**
   * Color
   */
  color: string;
  icon?: NotionIconV1 | null;
};

/**
 * NotionCheckConnectionResponseV1
 */
export type NotionCheckConnectionResponseV1 = {
  /**
   * Connected
   */
  connected: boolean;
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * NotionChildDatabaseBlockV1
 */
export type NotionChildDatabaseBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "child_database";
  child_database: NotionChildPageContentV1;
};

/**
 * NotionChildPageBlockV1
 */
export type NotionChildPageBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "child_page";
  child_page: NotionChildPageContentV1;
};

/**
 * NotionChildPageContentV1
 */
export type NotionChildPageContentV1 = {
  /**
   * Title
   */
  title: string;
};

/**
 * NotionCodeBlockInputV1
 */
export type NotionCodeBlockInputV1 = {
  /**
   * Kind
   */
  kind: "code";
  code: NotionCodeContentInputV1;
};

/**
 * NotionCodeBlockV1
 */
export type NotionCodeBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "code";
  code: NotionCodeContentV1;
};

/**
 * NotionCodeContentInputV1
 */
export type NotionCodeContentInputV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextInputV1>;
  /**
   * Caption
   */
  caption?: Array<NotionRichTextInputV1>;
  /**
   * Language
   */
  language: string;
};

/**
 * NotionCodeContentV1
 */
export type NotionCodeContentV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextV1>;
  /**
   * Caption
   */
  caption?: Array<NotionRichTextV1>;
  /**
   * Language
   */
  language: string;
};

/**
 * NotionColumnBlockV1
 */
export type NotionColumnBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "column";
  column: NotionEmptyContentV1;
};

/**
 * NotionColumnListBlockV1
 */
export type NotionColumnListBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "column_list";
  column_list: NotionEmptyContentV1;
};

/**
 * NotionCommentV1
 */
export type NotionCommentV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Discussion Id
   */
  discussion_id: string;
  /**
   * Parent Id
   */
  parent_id: string | null;
  /**
   * Created By Id
   */
  created_by_id: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Rich Text
   */
  rich_text: Array<NotionRichTextV1>;
};

/**
 * NotionConnectResponseV1
 */
export type NotionConnectResponseV1 = {
  /**
   * Authorization Url
   */
  authorization_url: string;
};

/**
 * NotionDatabaseV1
 */
export type NotionDatabaseV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Title
   */
  title: string;
  parent_kind: NotionParentKindV1;
  /**
   * Parent Id
   */
  parent_id: string | null;
  /**
   * Url
   */
  url: string;
  /**
   * Archived
   */
  archived: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * NotionDividerBlockInputV1
 */
export type NotionDividerBlockInputV1 = {
  /**
   * Kind
   */
  kind: "divider";
  divider?: NotionEmptyInputV1;
};

/**
 * NotionDividerBlockV1
 */
export type NotionDividerBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "divider";
  divider: NotionEmptyContentV1;
};

/**
 * NotionEmbedBlockInputV1
 */
export type NotionEmbedBlockInputV1 = {
  /**
   * Kind
   */
  kind: "embed";
  embed: NotionLinkPreviewContentInputV1;
};

/**
 * NotionEmbedBlockV1
 */
export type NotionEmbedBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "embed";
  embed: NotionLinkPreviewContentV1;
};

/**
 * NotionEmojiIconInputV1
 */
export type NotionEmojiIconInputV1 = {
  /**
   * Kind
   */
  kind: "emoji";
  /**
   * Emoji
   */
  emoji: string;
};

/**
 * NotionEmojiIconV1
 */
export type NotionEmojiIconV1 = {
  /**
   * Kind
   */
  kind: "emoji";
  /**
   * Emoji
   */
  emoji: string;
};

/**
 * NotionEmptyContentV1
 */
export type NotionEmptyContentV1 = {
  [key: string]: unknown;
};

/**
 * NotionEmptyInputV1
 */
export type NotionEmptyInputV1 = {
  [key: string]: unknown;
};

/**
 * NotionEquationBlockInputV1
 */
export type NotionEquationBlockInputV1 = {
  /**
   * Kind
   */
  kind: "equation";
  equation: NotionEquationContentInputV1;
};

/**
 * NotionEquationBlockV1
 */
export type NotionEquationBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "equation";
  equation: NotionEquationContentV1;
};

/**
 * NotionEquationContentInputV1
 */
export type NotionEquationContentInputV1 = {
  /**
   * Expression
   */
  expression: string;
};

/**
 * NotionEquationContentV1
 */
export type NotionEquationContentV1 = {
  /**
   * Expression
   */
  expression: string;
};

/**
 * NotionExternalFileInputV1
 */
export type NotionExternalFileInputV1 = {
  /**
   * Url
   */
  url: string;
};

/**
 * NotionExternalFileObjectV1
 */
export type NotionExternalFileObjectV1 = {
  /**
   * Kind
   */
  kind: "external";
  external: NotionExternalFileV1;
  /**
   * Caption
   */
  caption?: Array<NotionRichTextV1>;
  /**
   * Name
   */
  name?: string | null;
};

/**
 * NotionExternalFileV1
 */
export type NotionExternalFileV1 = {
  /**
   * Url
   */
  url: string;
};

/**
 * NotionExternalIconInputV1
 */
export type NotionExternalIconInputV1 = {
  /**
   * Kind
   */
  kind: "external";
  external: NotionExternalFileInputV1;
};

/**
 * NotionExternalIconV1
 */
export type NotionExternalIconV1 = {
  /**
   * Kind
   */
  kind: "external";
  external: NotionExternalFileV1;
};

/**
 * NotionFileBlockInputV1
 */
export type NotionFileBlockInputV1 = {
  /**
   * Kind
   */
  kind: "file";
  file: NotionFileObjectInputV1;
};

/**
 * NotionFileBlockV1
 */
export type NotionFileBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "file";
  file: NotionFileObjectV1;
};

/**
 * NotionFileObjectInputV1
 */
export type NotionFileObjectInputV1 = {
  /**
   * Type
   */
  type?: "external";
  external: NotionExternalFileInputV1;
  /**
   * Caption
   */
  caption?: Array<NotionRichTextInputV1>;
};

export type NotionFileObjectV1 =
  | ({
      kind: "external";
    } & NotionExternalFileObjectV1)
  | ({
      kind: "file";
    } & NotionHostedFileObjectV1);

/**
 * NotionHeading1BlockInputV1
 */
export type NotionHeading1BlockInputV1 = {
  /**
   * Kind
   */
  kind: "heading_1";
  heading_1: NotionHeadingContentInputV1;
};

/**
 * NotionHeading1BlockV1
 */
export type NotionHeading1BlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "heading_1";
  heading_1: NotionHeadingContentV1;
};

/**
 * NotionHeading2BlockInputV1
 */
export type NotionHeading2BlockInputV1 = {
  /**
   * Kind
   */
  kind: "heading_2";
  heading_2: NotionHeadingContentInputV1;
};

/**
 * NotionHeading2BlockV1
 */
export type NotionHeading2BlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "heading_2";
  heading_2: NotionHeadingContentV1;
};

/**
 * NotionHeading3BlockInputV1
 */
export type NotionHeading3BlockInputV1 = {
  /**
   * Kind
   */
  kind: "heading_3";
  heading_3: NotionHeadingContentInputV1;
};

/**
 * NotionHeading3BlockV1
 */
export type NotionHeading3BlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "heading_3";
  heading_3: NotionHeadingContentV1;
};

/**
 * NotionHeadingContentInputV1
 */
export type NotionHeadingContentInputV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextInputV1>;
  /**
   * Color
   */
  color?: string | null;
  /**
   * Is Toggleable
   */
  is_toggleable?: boolean;
};

/**
 * NotionHeadingContentV1
 */
export type NotionHeadingContentV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextV1>;
  /**
   * Color
   */
  color: string;
  /**
   * Is Toggleable
   */
  is_toggleable?: boolean;
};

/**
 * NotionHostedFileObjectV1
 */
export type NotionHostedFileObjectV1 = {
  /**
   * Kind
   */
  kind: "file";
  file: NotionHostedFileV1;
  /**
   * Caption
   */
  caption?: Array<NotionRichTextV1>;
  /**
   * Name
   */
  name?: string | null;
};

/**
 * NotionHostedFileV1
 */
export type NotionHostedFileV1 = {
  /**
   * Url
   */
  url: string;
  /**
   * Expiry Time
   */
  expiry_time?: Date | null;
};

/**
 * NotionHostedIconV1
 */
export type NotionHostedIconV1 = {
  /**
   * Kind
   */
  kind: "file";
  file: NotionHostedFileV1;
};

export type NotionIconInputV1 =
  | ({
      kind: "emoji";
    } & NotionEmojiIconInputV1)
  | ({
      kind: "external";
    } & NotionExternalIconInputV1);

export type NotionIconV1 =
  | ({
      kind: "emoji";
    } & NotionEmojiIconV1)
  | ({
      kind: "external";
    } & NotionExternalIconV1)
  | ({
      kind: "file";
    } & NotionHostedIconV1);

/**
 * NotionImageBlockInputV1
 */
export type NotionImageBlockInputV1 = {
  /**
   * Kind
   */
  kind: "image";
  image: NotionFileObjectInputV1;
};

/**
 * NotionImageBlockV1
 */
export type NotionImageBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "image";
  image: NotionFileObjectV1;
};

/**
 * NotionIngestResponseV1
 */
export type NotionIngestResponseV1 = {
  /**
   * Received
   */
  received?: boolean;
};

export type NotionKnownBlockV1 =
  | ({
      kind: "paragraph";
    } & NotionParagraphBlockV1)
  | ({
      kind: "heading_1";
    } & NotionHeading1BlockV1)
  | ({
      kind: "heading_2";
    } & NotionHeading2BlockV1)
  | ({
      kind: "heading_3";
    } & NotionHeading3BlockV1)
  | ({
      kind: "bulleted_list_item";
    } & NotionBulletedListItemBlockV1)
  | ({
      kind: "numbered_list_item";
    } & NotionNumberedListItemBlockV1)
  | ({
      kind: "to_do";
    } & NotionToDoBlockV1)
  | ({
      kind: "toggle";
    } & NotionToggleBlockV1)
  | ({
      kind: "quote";
    } & NotionQuoteBlockV1)
  | ({
      kind: "callout";
    } & NotionCalloutBlockV1)
  | ({
      kind: "code";
    } & NotionCodeBlockV1)
  | ({
      kind: "divider";
    } & NotionDividerBlockV1)
  | ({
      kind: "child_page";
    } & NotionChildPageBlockV1)
  | ({
      kind: "child_database";
    } & NotionChildDatabaseBlockV1)
  | ({
      kind: "equation";
    } & NotionEquationBlockV1)
  | ({
      kind: "bookmark";
    } & NotionBookmarkBlockV1)
  | ({
      kind: "embed";
    } & NotionEmbedBlockV1)
  | ({
      kind: "link_preview";
    } & NotionLinkPreviewBlockV1)
  | ({
      kind: "image";
    } & NotionImageBlockV1)
  | ({
      kind: "video";
    } & NotionVideoBlockV1)
  | ({
      kind: "file";
    } & NotionFileBlockV1)
  | ({
      kind: "pdf";
    } & NotionPdfBlockV1)
  | ({
      kind: "table";
    } & NotionTableBlockV1)
  | ({
      kind: "table_row";
    } & NotionTableRowBlockV1)
  | ({
      kind: "column_list";
    } & NotionColumnListBlockV1)
  | ({
      kind: "column";
    } & NotionColumnBlockV1)
  | ({
      kind: "table_of_contents";
    } & NotionTableOfContentsBlockV1)
  | ({
      kind: "breadcrumb";
    } & NotionBreadcrumbBlockV1)
  | ({
      kind: "synced_block";
    } & NotionSyncedBlockBlockV1);

/**
 * NotionLinkInputV1
 */
export type NotionLinkInputV1 = {
  /**
   * Url
   */
  url: string;
};

/**
 * NotionLinkPreviewBlockInputV1
 */
export type NotionLinkPreviewBlockInputV1 = {
  /**
   * Kind
   */
  kind: "link_preview";
  link_preview: NotionLinkPreviewContentInputV1;
};

/**
 * NotionLinkPreviewBlockV1
 */
export type NotionLinkPreviewBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "link_preview";
  link_preview: NotionLinkPreviewContentV1;
};

/**
 * NotionLinkPreviewContentInputV1
 */
export type NotionLinkPreviewContentInputV1 = {
  /**
   * Url
   */
  url: string;
};

/**
 * NotionLinkPreviewContentV1
 */
export type NotionLinkPreviewContentV1 = {
  /**
   * Url
   */
  url: string;
};

/**
 * NotionNumberedListItemBlockInputV1
 */
export type NotionNumberedListItemBlockInputV1 = {
  /**
   * Kind
   */
  kind: "numbered_list_item";
  numbered_list_item: NotionRichTextContentInputV1;
};

/**
 * NotionNumberedListItemBlockV1
 */
export type NotionNumberedListItemBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "numbered_list_item";
  numbered_list_item: NotionRichTextContentV1;
};

/**
 * NotionPageContentV1
 */
export type NotionPageContentV1 = {
  /**
   * Page Id
   */
  page_id: string;
  /**
   * Blocks
   */
  blocks: Array<NotionBlockV1>;
};

/**
 * NotionPageV1
 */
export type NotionPageV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Title
   */
  title: string;
  parent_kind: NotionParentKindV1;
  /**
   * Parent Id
   */
  parent_id: string | null;
  /**
   * Url
   */
  url: string;
  /**
   * Archived
   */
  archived: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * NotionParagraphBlockInputV1
 */
export type NotionParagraphBlockInputV1 = {
  /**
   * Kind
   */
  kind: "paragraph";
  paragraph: NotionRichTextContentInputV1;
};

/**
 * NotionParagraphBlockV1
 */
export type NotionParagraphBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "paragraph";
  paragraph: NotionRichTextContentV1;
};

/**
 * NotionParentKindV1
 */
export const NotionParentKindV1 = {
  PAGE: "page",
  DATABASE: "database",
  WORKSPACE: "workspace",
} as const;

/**
 * NotionParentKindV1
 */
export type NotionParentKindV1 =
  (typeof NotionParentKindV1)[keyof typeof NotionParentKindV1];

/**
 * NotionPdfBlockV1
 */
export type NotionPdfBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "pdf";
  pdf: NotionFileObjectV1;
};

/**
 * NotionQuoteBlockInputV1
 */
export type NotionQuoteBlockInputV1 = {
  /**
   * Kind
   */
  kind: "quote";
  quote: NotionRichTextContentInputV1;
};

/**
 * NotionQuoteBlockV1
 */
export type NotionQuoteBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "quote";
  quote: NotionRichTextContentV1;
};

/**
 * NotionRichTextContentInputV1
 */
export type NotionRichTextContentInputV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextInputV1>;
  /**
   * Color
   */
  color?: string | null;
};

/**
 * NotionRichTextContentV1
 */
export type NotionRichTextContentV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextV1>;
  /**
   * Color
   */
  color: string;
};

/**
 * NotionRichTextInputV1
 */
export type NotionRichTextInputV1 = {
  text: NotionTextInputV1;
  annotations?: NotionAnnotationsV1 | null;
};

/**
 * NotionRichTextV1
 */
export type NotionRichTextV1 = {
  /**
   * Plain Text
   */
  plain_text: string;
  /**
   * Href
   */
  href?: string | null;
  annotations?: NotionAnnotationsV1 | null;
};

/**
 * NotionSyncedBlockBlockV1
 */
export type NotionSyncedBlockBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "synced_block";
  synced_block: NotionSyncedBlockContentV1;
};

/**
 * NotionSyncedBlockContentV1
 */
export type NotionSyncedBlockContentV1 = {
  synced_from?: NotionSyncedFromV1 | null;
};

/**
 * NotionSyncedFromKindV1
 */
export const NotionSyncedFromKindV1 = { BLOCK_ID: "block_id" } as const;

/**
 * NotionSyncedFromKindV1
 */
export type NotionSyncedFromKindV1 =
  (typeof NotionSyncedFromKindV1)[keyof typeof NotionSyncedFromKindV1];

/**
 * NotionSyncedFromV1
 */
export type NotionSyncedFromV1 = {
  kind: NotionSyncedFromKindV1;
  /**
   * Block Id
   */
  block_id: string;
};

/**
 * NotionTableBlockV1
 */
export type NotionTableBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "table";
  table: NotionTableContentV1;
};

/**
 * NotionTableContentV1
 */
export type NotionTableContentV1 = {
  /**
   * Table Width
   */
  table_width: number;
  /**
   * Has Column Header
   */
  has_column_header?: boolean;
  /**
   * Has Row Header
   */
  has_row_header?: boolean;
};

/**
 * NotionTableOfContentsBlockV1
 */
export type NotionTableOfContentsBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "table_of_contents";
  table_of_contents: NotionTableOfContentsContentV1;
};

/**
 * NotionTableOfContentsContentV1
 */
export type NotionTableOfContentsContentV1 = {
  /**
   * Color
   */
  color: string;
};

/**
 * NotionTableRowBlockV1
 */
export type NotionTableRowBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "table_row";
  table_row: NotionTableRowContentV1;
};

/**
 * NotionTableRowContentV1
 */
export type NotionTableRowContentV1 = {
  /**
   * Cells
   */
  cells?: Array<Array<NotionRichTextV1>>;
};

/**
 * NotionTenantFullV1
 */
export type NotionTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Has Tokens
   */
  has_tokens: boolean;
  /**
   * Workspace Name
   */
  workspace_name: string | null;
  /**
   * Redirect Uri
   */
  redirect_uri: string;
  /**
   * Webhook Url
   */
  webhook_url: string;
  /**
   * Webhook Configured
   */
  webhook_configured: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * NotionTenantV1
 */
export type NotionTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * NotionTextInputV1
 */
export type NotionTextInputV1 = {
  /**
   * Content
   */
  content: string;
  link?: NotionLinkInputV1 | null;
};

/**
 * NotionToDoBlockInputV1
 */
export type NotionToDoBlockInputV1 = {
  /**
   * Kind
   */
  kind: "to_do";
  to_do: NotionToDoContentInputV1;
};

/**
 * NotionToDoBlockV1
 */
export type NotionToDoBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "to_do";
  to_do: NotionToDoContentV1;
};

/**
 * NotionToDoContentInputV1
 */
export type NotionToDoContentInputV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextInputV1>;
  /**
   * Color
   */
  color?: string | null;
  /**
   * Checked
   */
  checked?: boolean;
};

/**
 * NotionToDoContentV1
 */
export type NotionToDoContentV1 = {
  /**
   * Rich Text
   */
  rich_text?: Array<NotionRichTextV1>;
  /**
   * Color
   */
  color: string;
  /**
   * Checked
   */
  checked?: boolean;
};

/**
 * NotionToggleBlockInputV1
 */
export type NotionToggleBlockInputV1 = {
  /**
   * Kind
   */
  kind: "toggle";
  toggle: NotionRichTextContentInputV1;
};

/**
 * NotionToggleBlockV1
 */
export type NotionToggleBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "toggle";
  toggle: NotionRichTextContentV1;
};

/**
 * NotionUnsupportedBlockV1
 */
export type NotionUnsupportedBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: string;
  [key: string]: unknown;
};

/**
 * NotionVideoBlockInputV1
 */
export type NotionVideoBlockInputV1 = {
  /**
   * Kind
   */
  kind: "video";
  video: NotionFileObjectInputV1;
};

/**
 * NotionVideoBlockV1
 */
export type NotionVideoBlockV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Has Children
   */
  has_children?: boolean;
  /**
   * Archived
   */
  archived?: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Kind
   */
  kind: "video";
  video: NotionFileObjectV1;
};

/**
 * NotionWebhookVerificationTokenV1
 */
export type NotionWebhookVerificationTokenV1 = {
  /**
   * Verification Token
   */
  verification_token: string;
};

/**
 * OAuthApplicationFullV1
 */
export type OAuthApplicationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Client Id
   */
  client_id: string;
  provider: OAuthApplicationProviderV1;
  /**
   * Redirect Uris
   */
  redirect_uris: Array<string>;
  /**
   * Scopes
   */
  scopes: Array<string>;
  /**
   * Discovery Url
   */
  discovery_url: string;
  /**
   * Authorize Url
   */
  authorize_url: string;
  /**
   * Token Fetch Url
   */
  token_fetch_url: string;
  /**
   * User Info Url
   */
  user_info_url: string;
  /**
   * Token Introspection Url
   */
  token_introspection_url: string;
  created_by_user: UserFullV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * OAuthApplicationProviderV1
 */
export const OAuthApplicationProviderV1 = {
  GOOGLE_GEMINI_MCP: "GOOGLE_GEMINI_MCP",
  GOOGLE_GEMINI_A2A: "GOOGLE_GEMINI_A2A",
  ANTHROPIC_CLAUDE_MCP: "ANTHROPIC_CLAUDE_MCP",
  OPENAI_MCP: "OPENAI_MCP",
  CUSTOM: "CUSTOM",
  CUSTOM_MCP: "CUSTOM_MCP",
  CUSTOM_A2A: "CUSTOM_A2A",
} as const;

/**
 * OAuthApplicationProviderV1
 */
export type OAuthApplicationProviderV1 =
  (typeof OAuthApplicationProviderV1)[keyof typeof OAuthApplicationProviderV1];

/**
 * OAuthApplicationSecretV1
 */
export type OAuthApplicationSecretV1 = {
  oauth_application: OAuthApplicationFullV1;
  /**
   * Client Secret
   */
  client_secret: string;
};

/**
 * OAuthApplicationV1
 */
export type OAuthApplicationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Client Id
   */
  client_id: string;
  provider: OAuthApplicationProviderV1;
  /**
   * Discovery Url
   */
  discovery_url: string;
  /**
   * Authorize Url
   */
  authorize_url: string;
  /**
   * Token Fetch Url
   */
  token_fetch_url: string;
  /**
   * User Info Url
   */
  user_info_url: string;
  /**
   * Token Introspection Url
   */
  token_introspection_url: string;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * OAuthAuthorizationServerMetadataV1
 */
export type OAuthAuthorizationServerMetadataV1 = {
  /**
   * Issuer
   */
  issuer: string;
  /**
   * Authorization Endpoint
   */
  authorization_endpoint: string;
  /**
   * Token Endpoint
   */
  token_endpoint: string;
  /**
   * Scopes Supported
   */
  scopes_supported: Array<string>;
  /**
   * Response Types Supported
   */
  response_types_supported: Array<OAuthResponseTypeV1>;
  /**
   * Grant Types Supported
   */
  grant_types_supported: Array<OAuthGrantTypeV1>;
  /**
   * Code Challenge Methods Supported
   */
  code_challenge_methods_supported: Array<OAuthCodeChallengeMethodV1>;
  /**
   * Token Endpoint Auth Methods Supported
   */
  token_endpoint_auth_methods_supported: Array<OAuthTokenEndpointAuthMethodV1>;
};

/**
 * OAuthBearerMethodV1
 */
export const OAuthBearerMethodV1 = { HEADER: "header" } as const;

/**
 * OAuthBearerMethodV1
 */
export type OAuthBearerMethodV1 =
  (typeof OAuthBearerMethodV1)[keyof typeof OAuthBearerMethodV1];

/**
 * OAuthCodeChallengeMethodV1
 */
export const OAuthCodeChallengeMethodV1 = { S256: "S256" } as const;

/**
 * OAuthCodeChallengeMethodV1
 */
export type OAuthCodeChallengeMethodV1 =
  (typeof OAuthCodeChallengeMethodV1)[keyof typeof OAuthCodeChallengeMethodV1];

/**
 * OAuthGrantTypeV1
 */
export const OAuthGrantTypeV1 = {
  AUTHORIZATION_CODE: "authorization_code",
  REFRESH_TOKEN: "refresh_token",
} as const;

/**
 * OAuthGrantTypeV1
 */
export type OAuthGrantTypeV1 =
  (typeof OAuthGrantTypeV1)[keyof typeof OAuthGrantTypeV1];

/**
 * OAuthProtectedResourceMetadataV1
 */
export type OAuthProtectedResourceMetadataV1 = {
  /**
   * Resource
   */
  resource: string;
  /**
   * Authorization Servers
   */
  authorization_servers: Array<string>;
  /**
   * Scopes Supported
   */
  scopes_supported: Array<string>;
  /**
   * Bearer Methods Supported
   */
  bearer_methods_supported: Array<OAuthBearerMethodV1>;
};

/**
 * OAuthResponseTypeV1
 */
export const OAuthResponseTypeV1 = { CODE: "code" } as const;

/**
 * OAuthResponseTypeV1
 */
export type OAuthResponseTypeV1 =
  (typeof OAuthResponseTypeV1)[keyof typeof OAuthResponseTypeV1];

/**
 * OAuthTokenEndpointAuthMethodV1
 */
export const OAuthTokenEndpointAuthMethodV1 = {
  CLIENT_SECRET_BASIC: "client_secret_basic",
  CLIENT_SECRET_POST: "client_secret_post",
} as const;

/**
 * OAuthTokenEndpointAuthMethodV1
 */
export type OAuthTokenEndpointAuthMethodV1 =
  (typeof OAuthTokenEndpointAuthMethodV1)[keyof typeof OAuthTokenEndpointAuthMethodV1];

/**
 * OauthSecretPlainValueV2
 */
export type OauthSecretPlainValueV2 = {
  /**
   * Kind
   */
  kind: "OAUTH";
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
  /**
   * Authorize Url
   */
  authorize_url: string;
  /**
   * Token Url
   */
  token_url: string;
};

/**
 * OauthSecretValueParamsV1
 */
export type OauthSecretValueParamsV1 = {
  /**
   * Kind
   */
  kind: "OAUTH";
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
  /**
   * Authorize Url
   */
  authorize_url: string;
  /**
   * Token Url
   */
  token_url: string;
};

/**
 * OrgMemberRoleChangeV1
 */
export type OrgMemberRoleChangeV1 = {
  /**
   * Org Id
   */
  org_id: number;
  /**
   * User Id
   */
  user_id: number;
  role_before: EdraAccessRoleV1;
  role_after: EdraAccessRoleV1;
};

/**
 * OrgMemberRoleV1
 */
export const OrgMemberRoleV1 = { MEMBER: "member", ADMIN: "admin" } as const;

/**
 * OrgMemberRoleV1
 */
export type OrgMemberRoleV1 =
  (typeof OrgMemberRoleV1)[keyof typeof OrgMemberRoleV1];

/**
 * OrgMemberV1
 */
export type OrgMemberV1 = {
  /**
   * User Id
   */
  user_id: number;
  /**
   * Organization Id
   */
  organization_id: number;
  role: OrgMemberRoleV1;
  /**
   * First Name
   */
  first_name: string | null;
  /**
   * Last Name
   */
  last_name: string | null;
  /**
   * Email
   */
  email: string | null;
  /**
   * Avatar Url
   */
  avatar_url: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * OrgMembershipChangeV1
 */
export type OrgMembershipChangeV1 = {
  /**
   * Org Id
   */
  org_id: number;
  /**
   * User Id
   */
  user_id: number;
  result: OrgMembershipResultV1;
};

/**
 * OrgMembershipResultV1
 */
export const OrgMembershipResultV1 = {
  CREATED: "created",
  ALREADY_MEMBER: "already_member",
} as const;

/**
 * OrgMembershipResultV1
 */
export type OrgMembershipResultV1 =
  (typeof OrgMembershipResultV1)[keyof typeof OrgMembershipResultV1];

/**
 * OrgMembershipRoleV1
 */
export const OrgMembershipRoleV1 = {
  MEMBER: "MEMBER",
  ADMIN: "ADMIN",
} as const;

/**
 * OrgMembershipRoleV1
 */
export type OrgMembershipRoleV1 =
  (typeof OrgMembershipRoleV1)[keyof typeof OrgMembershipRoleV1];

/**
 * OrganizationFullV1
 */
export type OrganizationFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Member Ids
   */
  member_ids: Array<number>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * OrganizationV1
 */
export type OrganizationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Slug
   */
  slug: string | null;
  /**
   * Logo Url
   */
  logo_url: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * OrientationV1
 */
export const OrientationV1 = {
  HORIZONTAL: "HORIZONTAL",
  VERTICAL: "VERTICAL",
} as const;

/**
 * OrientationV1
 */
export type OrientationV1 = (typeof OrientationV1)[keyof typeof OrientationV1];

/**
 * OutlookAddEmailAttachmentParamsV1
 */
export type OutlookAddEmailAttachmentParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Name
   *
   * Attachment filename
   */
  name: string;
  /**
   * Content Base64
   *
   * Base64-encoded attachment content
   */
  content_base64: string;
  /**
   * Content Type
   *
   * MIME type
   */
  content_type?: string | null;
};

/**
 * OutlookAddEmailAttachmentResponseV1
 */
export type OutlookAddEmailAttachmentResponseV1 = {
  /**
   * Attachment Id
   */
  attachment_id: string;
};

/**
 * OutlookComposeResponseV1
 */
export type OutlookComposeResponseV1 = {
  /**
   * Message Id
   */
  message_id: string;
  /**
   * Is Draft
   */
  is_draft: boolean;
};

/**
 * OutlookCopyEmailParamsV1
 */
export type OutlookCopyEmailParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Destination Folder Id
   *
   * ID of destination folder
   */
  destination_folder_id: string;
};

/**
 * OutlookCopyEmailResponseV1
 */
export type OutlookCopyEmailResponseV1 = {
  /**
   * New Message Id
   */
  new_message_id: string;
  /**
   * Destination Folder Id
   */
  destination_folder_id: string;
};

/**
 * OutlookCreateDraftParamsV1
 */
export type OutlookCreateDraftParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Subject
   *
   * Email subject
   */
  subject: string;
  /**
   * Content Html
   *
   * HTML content
   */
  content_html: string;
  /**
   * To
   *
   * Recipients
   */
  to: Array<string>;
  /**
   * From Address
   *
   * Sender address override
   */
  from_address?: string | null;
  /**
   * Cc
   *
   * CC recipients
   */
  cc?: Array<string>;
  /**
   * Bcc
   *
   * BCC recipients
   */
  bcc?: Array<string>;
  /**
   * Categories
   *
   * Categories to apply
   */
  categories?: Array<string>;
  /**
   * Importance level
   */
  importance?: OutlookEmailImportanceV1;
};

/**
 * OutlookDeleteEmailParamsV1
 */
export type OutlookDeleteEmailParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
};

/**
 * OutlookDeleteEmailResponseV1
 */
export type OutlookDeleteEmailResponseV1 = {
  /**
   * Success
   */
  success: boolean;
};

/**
 * OutlookEmailImportanceV1
 */
export const OutlookEmailImportanceV1 = {
  LOW: "LOW",
  NORMAL: "NORMAL",
  HIGH: "HIGH",
} as const;

/**
 * OutlookEmailImportanceV1
 */
export type OutlookEmailImportanceV1 =
  (typeof OutlookEmailImportanceV1)[keyof typeof OutlookEmailImportanceV1];

/**
 * OutlookFileAttachmentResponseV1
 */
export type OutlookFileAttachmentResponseV1 = {
  /**
   * Kind
   */
  kind: "file";
  /**
   * Attachment Id
   */
  attachment_id: string;
  /**
   * Name
   */
  name: string | null;
  /**
   * Content Type
   */
  content_type: string | null;
  /**
   * Content Base64
   */
  content_base64: string | null;
  /**
   * Size
   */
  size: number | null;
};

/**
 * OutlookForwardEmailParamsV1
 */
export type OutlookForwardEmailParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * To
   *
   * Recipients to forward to
   */
  to: Array<string>;
  /**
   * Content Html
   *
   * Optional HTML content
   */
  content_html?: string | null;
  /**
   * Is Draft
   *
   * Create as draft if true
   */
  is_draft?: boolean;
  /**
   * Cc
   *
   * CC recipients
   */
  cc?: Array<string>;
  /**
   * Bcc
   *
   * BCC recipients
   */
  bcc?: Array<string>;
  /**
   * Categories
   *
   * Categories to apply
   */
  categories?: Array<string>;
};

/**
 * OutlookGetEmailAttachmentParamsV1
 */
export type OutlookGetEmailAttachmentParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Attachment Id
   *
   * Attachment ID to retrieve
   */
  attachment_id: string;
};

export type OutlookGetEmailAttachmentResponseV1 =
  | OutlookFileAttachmentResponseV1
  | OutlookItemAttachmentResponseV1
  | OutlookReferenceAttachmentResponseV1;

/**
 * OutlookItemAttachmentResponseV1
 */
export type OutlookItemAttachmentResponseV1 = {
  /**
   * Kind
   */
  kind: "item";
  /**
   * Attachment Id
   */
  attachment_id: string;
  /**
   * Name
   */
  name: string | null;
  /**
   * Content Type
   */
  content_type: string | null;
  /**
   * Size
   */
  size: number | null;
};

/**
 * OutlookMarkEmailReadParamsV1
 */
export type OutlookMarkEmailReadParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Is Read
   *
   * True for read, False for unread
   */
  is_read?: boolean;
};

/**
 * OutlookModifyResponseV1
 */
export type OutlookModifyResponseV1 = {
  /**
   * Message Id
   */
  message_id: string;
};

/**
 * OutlookMoveEmailParamsV1
 */
export type OutlookMoveEmailParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Destination Folder Id
   *
   * ID of destination folder
   */
  destination_folder_id: string;
};

/**
 * OutlookMoveEmailResponseV1
 */
export type OutlookMoveEmailResponseV1 = {
  /**
   * New Message Id
   */
  new_message_id: string;
  /**
   * Destination Folder Id
   */
  destination_folder_id: string;
};

/**
 * OutlookReferenceAttachmentResponseV1
 */
export type OutlookReferenceAttachmentResponseV1 = {
  /**
   * Kind
   */
  kind: "reference";
  /**
   * Attachment Id
   */
  attachment_id: string;
  /**
   * Name
   */
  name: string | null;
  /**
   * Content Type
   */
  content_type: string | null;
  /**
   * Size
   */
  size: number | null;
};

/**
 * OutlookRemoveEmailAttachmentParamsV1
 */
export type OutlookRemoveEmailAttachmentParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Attachment Id
   *
   * Attachment ID to remove
   */
  attachment_id: string;
};

/**
 * OutlookRemoveEmailAttachmentResponseV1
 */
export type OutlookRemoveEmailAttachmentResponseV1 = {
  /**
   * Success
   */
  success: boolean;
};

/**
 * OutlookReplyEmailParamsV1
 */
export type OutlookReplyEmailParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Content Html
   *
   * HTML content of reply
   */
  content_html: string;
  /**
   * Reply All
   *
   * Reply to all recipients
   */
  reply_all?: boolean;
  /**
   * Is Draft
   *
   * Create as draft if true
   */
  is_draft?: boolean;
  /**
   * From Address
   *
   * Sender address override
   */
  from_address?: string | null;
  /**
   * Cc
   *
   * CC recipients
   */
  cc?: Array<string>;
  /**
   * Bcc
   *
   * BCC recipients
   */
  bcc?: Array<string>;
  /**
   * Categories
   *
   * Categories to apply to reply
   */
  categories?: Array<string>;
};

/**
 * OutlookSendEmailParamsV1
 */
export type OutlookSendEmailParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
};

/**
 * OutlookSendEmailResponseV1
 */
export type OutlookSendEmailResponseV1 = {
  /**
   * Success
   */
  success: boolean;
};

/**
 * OutlookSetEmailCategoriesParamsV1
 */
export type OutlookSetEmailCategoriesParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Added Categories
   *
   * Categories to add
   */
  added_categories?: Array<string>;
  /**
   * Removed Categories
   *
   * Categories to remove
   */
  removed_categories?: Array<string>;
};

/**
 * OutlookSetEmailFlagParamsV1
 */
export type OutlookSetEmailFlagParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  flag_status?: OutlookSetEmailFlagStatusV1;
  /**
   * Due Date
   */
  due_date?: Date | null;
  /**
   * Start Date
   */
  start_date?: Date | null;
  /**
   * Completed Date
   */
  completed_date?: Date | null;
};

/**
 * OutlookSetEmailFlagStatusV1
 */
export const OutlookSetEmailFlagStatusV1 = {
  NOT_FLAGGED: "NOT_FLAGGED",
  FLAGGED: "FLAGGED",
  COMPLETE: "COMPLETE",
} as const;

/**
 * OutlookSetEmailFlagStatusV1
 */
export type OutlookSetEmailFlagStatusV1 =
  (typeof OutlookSetEmailFlagStatusV1)[keyof typeof OutlookSetEmailFlagStatusV1];

/**
 * OutlookSetEmailImportanceParamsV1
 */
export type OutlookSetEmailImportanceParamsV1 = {
  /**
   * User Id
   *
   * Microsoft user ID
   */
  user_id: string;
  /**
   * Message Id
   *
   * Message ID to act on
   */
  message_id: string;
  /**
   * Importance level to set
   */
  importance: OutlookEmailImportanceV1;
};

/**
 * OutlookSubscriptionV1
 */
export type OutlookSubscriptionV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Outlook Subscription Id
   */
  outlook_subscription_id: string;
  /**
   * User Id
   */
  user_id: string;
  /**
   * Folder
   */
  folder: string;
  /**
   * Expires At
   */
  expires_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * PageV1[AgentSessionFullV1]
 */
export type PageV1AgentSessionFullV1 = {
  /**
   * Items
   */
  items: Array<AgentSessionFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[AgentSessionV1]
 */
export type PageV1AgentSessionV1 = {
  /**
   * Items
   */
  items: Array<AgentSessionV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[ApiKeyFullV1]
 */
export type PageV1ApiKeyFullV1 = {
  /**
   * Items
   */
  items: Array<ApiKeyFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[ApiKeyV1]
 */
export type PageV1ApiKeyV1 = {
  /**
   * Items
   */
  items: Array<ApiKeyV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CalibrationFeedbackDimensionFullV1]
 */
export type PageV1CalibrationFeedbackDimensionFullV1 = {
  /**
   * Items
   */
  items: Array<CalibrationFeedbackDimensionFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CalibrationFeedbackDimensionV1]
 */
export type PageV1CalibrationFeedbackDimensionV1 = {
  /**
   * Items
   */
  items: Array<CalibrationFeedbackDimensionV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CalibrationFeedbackInferenceDatapointV1]
 */
export type PageV1CalibrationFeedbackInferenceDatapointV1 = {
  /**
   * Items
   */
  items: Array<CalibrationFeedbackInferenceDatapointV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CalibrationFeedbackQueueItemFullV1]
 */
export type PageV1CalibrationFeedbackQueueItemFullV1 = {
  /**
   * Items
   */
  items: Array<CalibrationFeedbackQueueItemFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CalibrationFeedbackQueueItemV1]
 */
export type PageV1CalibrationFeedbackQueueItemV1 = {
  /**
   * Items
   */
  items: Array<CalibrationFeedbackQueueItemV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CalibrationFeedbackTagKeyV1]
 */
export type PageV1CalibrationFeedbackTagKeyV1 = {
  /**
   * Items
   */
  items: Array<CalibrationFeedbackTagKeyV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CalibrationFeedbackVerdictFullV1]
 */
export type PageV1CalibrationFeedbackVerdictFullV1 = {
  /**
   * Items
   */
  items: Array<CalibrationFeedbackVerdictFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CalibrationFeedbackVerdictV1]
 */
export type PageV1CalibrationFeedbackVerdictV1 = {
  /**
   * Items
   */
  items: Array<CalibrationFeedbackVerdictV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[ChangeRequestFullV1]
 */
export type PageV1ChangeRequestFullV1 = {
  /**
   * Items
   */
  items: Array<ChangeRequestFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[ChangeRequestV1]
 */
export type PageV1ChangeRequestV1 = {
  /**
   * Items
   */
  items: Array<ChangeRequestV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[CommentFullV1]
 */
export type PageV1CommentFullV1 = {
  /**
   * Items
   */
  items: Array<CommentFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[ConfluenceTenantV1]
 */
export type PageV1ConfluenceTenantV1 = {
  /**
   * Items
   */
  items: Array<ConfluenceTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[DataDumpConversationFullV1]
 */
export type PageV1DataDumpConversationFullV1 = {
  /**
   * Items
   */
  items: Array<DataDumpConversationFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[DataDumpConversationV1]
 */
export type PageV1DataDumpConversationV1 = {
  /**
   * Items
   */
  items: Array<DataDumpConversationV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[DatapointEvidenceV1]
 */
export type PageV1DatapointEvidenceV1 = {
  /**
   * Items
   */
  items: Array<DatapointEvidenceV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[DatapointFullV3]
 */
export type PageV1DatapointFullV3 = {
  /**
   * Items
   */
  items: Array<DatapointFullV3>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[EntraProposedActionV1]
 */
export type PageV1EntraProposedActionV1 = {
  /**
   * Items
   */
  items: Array<EntraProposedActionV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[EntraTenantFullV1]
 */
export type PageV1EntraTenantFullV1 = {
  /**
   * Items
   */
  items: Array<EntraTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[EntraTenantV1]
 */
export type PageV1EntraTenantV1 = {
  /**
   * Items
   */
  items: Array<EntraTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[EvalJudgeV1]
 */
export type PageV1EvalJudgeV1 = {
  /**
   * Items
   */
  items: Array<EvalJudgeV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[FinalizedConversationFullV2]
 */
export type PageV1FinalizedConversationFullV2 = {
  /**
   * Items
   */
  items: Array<FinalizedConversationFullV2>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[FinalizedConversationV1]
 */
export type PageV1FinalizedConversationV1 = {
  /**
   * Items
   */
  items: Array<FinalizedConversationV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[GetArticleTagsKeyV1]
 */
export type PageV1GetArticleTagsKeyV1 = {
  /**
   * Items
   */
  items: Array<GetArticleTagsKeyV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[GetChangeRequestTagsKeyV1]
 */
export type PageV1GetChangeRequestTagsKeyV1 = {
  /**
   * Items
   */
  items: Array<GetChangeRequestTagsKeyV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[GitBranchV2]
 */
export type PageV1GitBranchV2 = {
  /**
   * Items
   */
  items: Array<GitBranchV2>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[HubSpotNoteV1]
 */
export type PageV1HubSpotNoteV1 = {
  /**
   * Items
   */
  items: Array<HubSpotNoteV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[HubSpotTenantFullV1]
 */
export type PageV1HubSpotTenantFullV1 = {
  /**
   * Items
   */
  items: Array<HubSpotTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[HubSpotTenantV1]
 */
export type PageV1HubSpotTenantV1 = {
  /**
   * Items
   */
  items: Array<HubSpotTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[HubSpotThreadMessageV1]
 */
export type PageV1HubSpotThreadMessageV1 = {
  /**
   * Items
   */
  items: Array<HubSpotThreadMessageV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[InferenceConversationFullV1]
 */
export type PageV1InferenceConversationFullV1 = {
  /**
   * Items
   */
  items: Array<InferenceConversationFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[InferenceConversationInferenceFullV1]
 */
export type PageV1InferenceConversationInferenceFullV1 = {
  /**
   * Items
   */
  items: Array<InferenceConversationInferenceFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[InferenceConversationV1]
 */
export type PageV1InferenceConversationV1 = {
  /**
   * Items
   */
  items: Array<InferenceConversationV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[InvitationFullV1]
 */
export type PageV1InvitationFullV1 = {
  /**
   * Items
   */
  items: Array<InvitationFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[InvitationV1]
 */
export type PageV1InvitationV1 = {
  /**
   * Items
   */
  items: Array<InvitationV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[JiraTenantFullV1]
 */
export type PageV1JiraTenantFullV1 = {
  /**
   * Items
   */
  items: Array<JiraTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[JiraTenantV1]
 */
export type PageV1JiraTenantV1 = {
  /**
   * Items
   */
  items: Array<JiraTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[JudgeV2]
 */
export type PageV1JudgeV2 = {
  /**
   * Items
   */
  items: Array<JudgeV2>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[JudgementFullV2]
 */
export type PageV1JudgementFullV2 = {
  /**
   * Items
   */
  items: Array<JudgementFullV2>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[JudgementFullV3]
 */
export type PageV1JudgementFullV3 = {
  /**
   * Items
   */
  items: Array<JudgementFullV3>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[KanonicalDatapointFullV2]
 */
export type PageV1KanonicalDatapointFullV2 = {
  /**
   * Items
   */
  items: Array<KanonicalDatapointFullV2>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[KnowledgeBaseFullV1]
 */
export type PageV1KnowledgeBaseFullV1 = {
  /**
   * Items
   */
  items: Array<KnowledgeBaseFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[KnowledgeBaseV2]
 */
export type PageV1KnowledgeBaseV2 = {
  /**
   * Items
   */
  items: Array<KnowledgeBaseV2>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[MachineUserV1]
 */
export type PageV1MachineUserV1 = {
  /**
   * Items
   */
  items: Array<MachineUserV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[NotionTenantV1]
 */
export type PageV1NotionTenantV1 = {
  /**
   * Items
   */
  items: Array<NotionTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[OAuthApplicationFullV1]
 */
export type PageV1OAuthApplicationFullV1 = {
  /**
   * Items
   */
  items: Array<OAuthApplicationFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[OAuthApplicationV1]
 */
export type PageV1OAuthApplicationV1 = {
  /**
   * Items
   */
  items: Array<OAuthApplicationV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[OrgMemberV1]
 */
export type PageV1OrgMemberV1 = {
  /**
   * Items
   */
  items: Array<OrgMemberV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[OrganizationV1]
 */
export type PageV1OrganizationV1 = {
  /**
   * Items
   */
  items: Array<OrganizationV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[OutlookSubscriptionV1]
 */
export type PageV1OutlookSubscriptionV1 = {
  /**
   * Items
   */
  items: Array<OutlookSubscriptionV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[PlainTenantFullV1]
 */
export type PageV1PlainTenantFullV1 = {
  /**
   * Items
   */
  items: Array<PlainTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[PlainTenantV1]
 */
export type PageV1PlainTenantV1 = {
  /**
   * Items
   */
  items: Array<PlainTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SalesforceTenantFullV1]
 */
export type PageV1SalesforceTenantFullV1 = {
  /**
   * Items
   */
  items: Array<SalesforceTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SalesforceTenantV1]
 */
export type PageV1SalesforceTenantV1 = {
  /**
   * Items
   */
  items: Array<SalesforceTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SearchResultV1]
 */
export type PageV1SearchResultV1 = {
  /**
   * Items
   */
  items: Array<SearchResultV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SecretFullV1]
 */
export type PageV1SecretFullV1 = {
  /**
   * Items
   */
  items: Array<SecretFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SecretV1]
 */
export type PageV1SecretV1 = {
  /**
   * Items
   */
  items: Array<SecretV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SharepointTenantFullV1]
 */
export type PageV1SharepointTenantFullV1 = {
  /**
   * Items
   */
  items: Array<SharepointTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SharepointTenantV1]
 */
export type PageV1SharepointTenantV1 = {
  /**
   * Items
   */
  items: Array<SharepointTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SlackTenantFullV1]
 */
export type PageV1SlackTenantFullV1 = {
  /**
   * Items
   */
  items: Array<SlackTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[SlackTenantV1]
 */
export type PageV1SlackTenantV1 = {
  /**
   * Items
   */
  items: Array<SlackTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[TaskV2]
 */
export type PageV1TaskV2 = {
  /**
   * Items
   */
  items: Array<TaskV2>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[TeamV1]
 */
export type PageV1TeamV1 = {
  /**
   * Items
   */
  items: Array<TeamV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[TeamsEndCustomerInstallV1]
 */
export type PageV1TeamsEndCustomerInstallV1 = {
  /**
   * Items
   */
  items: Array<TeamsEndCustomerInstallV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[TeamsTenantFullV1]
 */
export type PageV1TeamsTenantFullV1 = {
  /**
   * Items
   */
  items: Array<TeamsTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[TeamsTenantV1]
 */
export type PageV1TeamsTenantV1 = {
  /**
   * Items
   */
  items: Array<TeamsTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[UserFullV1]
 */
export type PageV1UserFullV1 = {
  /**
   * Items
   */
  items: Array<UserFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[WorkflowAnalyticsEventV1]
 */
export type PageV1WorkflowAnalyticsEventV1 = {
  /**
   * Items
   */
  items: Array<WorkflowAnalyticsEventV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[WorkflowRunFullV1]
 */
export type PageV1WorkflowRunFullV1 = {
  /**
   * Items
   */
  items: Array<WorkflowRunFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV1[WorkflowV1]
 */
export type PageV1WorkflowV1 = {
  /**
   * Items
   */
  items: Array<WorkflowV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[AgentSessionInferenceV1]
 */
export type PageV2AgentSessionInferenceV1 = {
  /**
   * Items
   */
  items: Array<AgentSessionInferenceV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ArticleLineRangeCommentThreadFullV1]
 */
export type PageV2ArticleLineRangeCommentThreadFullV1 = {
  /**
   * Items
   */
  items: Array<ArticleLineRangeCommentThreadFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ChangeRequestLineRangeCommentThreadFullV1]
 */
export type PageV2ChangeRequestLineRangeCommentThreadFullV1 = {
  /**
   * Items
   */
  items: Array<ChangeRequestLineRangeCommentThreadFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ConversationFullV1]
 */
export type PageV2ConversationFullV1 = {
  /**
   * Items
   */
  items: Array<ConversationFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[EvaluatedInferenceDatapointV1]
 */
export type PageV2EvaluatedInferenceDatapointV1 = {
  /**
   * Items
   */
  items: Array<EvaluatedInferenceDatapointV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ExternalInferenceV1]
 */
export type PageV2ExternalInferenceV1 = {
  /**
   * Items
   */
  items: Array<ExternalInferenceV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[FreshserviceTenantFullV1]
 */
export type PageV2FreshserviceTenantFullV1 = {
  /**
   * Items
   */
  items: Array<FreshserviceTenantFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[FreshserviceTenantV1]
 */
export type PageV2FreshserviceTenantV1 = {
  /**
   * Items
   */
  items: Array<FreshserviceTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[FullEvaluatedInferenceDatapointV1]
 */
export type PageV2FullEvaluatedInferenceDatapointV1 = {
  /**
   * Items
   */
  items: Array<FullEvaluatedInferenceDatapointV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[InferenceDatapointFullV1]
 */
export type PageV2InferenceDatapointFullV1 = {
  /**
   * Items
   */
  items: Array<InferenceDatapointFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[InferenceFeedbackFullV1]
 */
export type PageV2InferenceFeedbackFullV1 = {
  /**
   * Items
   */
  items: Array<InferenceFeedbackFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[KbAccessRequestFullV1]
 */
export type PageV2KbAccessRequestFullV1 = {
  /**
   * Items
   */
  items: Array<KbAccessRequestFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[KbTopArticleJudgementMetricsV1]
 */
export type PageV2KbTopArticleJudgementMetricsV1 = {
  /**
   * Items
   */
  items: Array<KbTopArticleJudgementMetricsV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[KnowledgeBaseV2]
 */
export type PageV2KnowledgeBaseV2 = {
  /**
   * Items
   */
  items: Array<KnowledgeBaseV2>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowApprovalV1]
 */
export type PageV2ServiceNowApprovalV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowApprovalV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowAttachmentV1]
 */
export type PageV2ServiceNowAttachmentV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowAttachmentV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowCatalogItemV1]
 */
export type PageV2ServiceNowCatalogItemV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowCatalogItemV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowCatalogVariableValueV1]
 */
export type PageV2ServiceNowCatalogVariableValueV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowCatalogVariableValueV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowKbArticleV1]
 */
export type PageV2ServiceNowKbArticleV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowKbArticleV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowKbKnowledgeBaseV1]
 */
export type PageV2ServiceNowKbKnowledgeBaseV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowKbKnowledgeBaseV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowRecordV1]
 */
export type PageV2ServiceNowRecordV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowRecordV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowRequestItemV1]
 */
export type PageV2ServiceNowRequestItemV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowRequestItemV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowTagV1]
 */
export type PageV2ServiceNowTagV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowTagV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowTaskV1]
 */
export type PageV2ServiceNowTaskV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowTaskV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowTenantV1]
 */
export type PageV2ServiceNowTenantV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowTicketV1]
 */
export type PageV2ServiceNowTicketV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowTicketV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ServiceNowUserGroupV1]
 */
export type PageV2ServiceNowUserGroupV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowUserGroupV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[SimulationDatapointFullV1]
 */
export type PageV2SimulationDatapointFullV1 = {
  /**
   * Items
   */
  items: Array<SimulationDatapointFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[SimulationDatapointV1]
 */
export type PageV2SimulationDatapointV1 = {
  /**
   * Items
   */
  items: Array<SimulationDatapointV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[SimulationResultFullV1]
 */
export type PageV2SimulationResultFullV1 = {
  /**
   * Items
   */
  items: Array<SimulationResultFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[SimulationResultJudgementFullV1]
 */
export type PageV2SimulationResultJudgementFullV1 = {
  /**
   * Items
   */
  items: Array<SimulationResultJudgementFullV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[SimulationResultV1]
 */
export type PageV2SimulationResultV1 = {
  /**
   * Items
   */
  items: Array<SimulationResultV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[WorkspaceV1]
 */
export type PageV2WorkspaceV1 = {
  /**
   * Items
   */
  items: Array<WorkspaceV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PageV2[ZendeskTenantV1]
 */
export type PageV2ZendeskTenantV1 = {
  /**
   * Items
   */
  items: Array<ZendeskTenantV1>;
  /**
   * Offset
   */
  offset: number;
  /**
   * Limit
   */
  limit: number | null;
  /**
   * Total
   */
  total: number;
};

/**
 * PatchArticleRequestV1
 */
export type PatchArticleRequestV1 = {
  /**
   * Added Tags
   */
  added_tags?: {
    [key: string]: string;
  };
  /**
   * Removed Tags
   */
  removed_tags?: Array<string>;
};

/**
 * PatchCommitRequestV1
 */
export type PatchCommitRequestV1 = {
  /**
   * Added Datapoint Ids
   */
  added_datapoint_ids?: Array<number>;
  /**
   * Removed Datapoint Ids
   */
  removed_datapoint_ids?: Array<number>;
  /**
   * Added Kanonical Datapoint Ids
   */
  added_kanonical_datapoint_ids?: Array<number>;
  /**
   * Removed Kanonical Datapoint Ids
   */
  removed_kanonical_datapoint_ids?: Array<number>;
};

/**
 * PatchJudgeParamsV2
 */
export type PatchJudgeParamsV2 = {
  /**
   * Display Name
   */
  display_name?: string | Missing;
};

/**
 * PatchKnowledgeBaseParamsV3
 */
export type PatchKnowledgeBaseParamsV3 = {
  /**
   * Name
   */
  name?: string | Missing;
  /**
   * External Id
   */
  external_id?: string | Missing | null;
  /**
   * Task Id
   */
  task_id?: number | Missing | null;
  /**
   * Position
   */
  position?: PatchKnowledgeBasePositionAfterV3 | Missing;
};

/**
 * PatchKnowledgeBasePositionAfterV3
 */
export type PatchKnowledgeBasePositionAfterV3 = {
  /**
   * After Kb Id
   */
  after_kb_id: number | null;
};

/**
 * PatchKnowledgeBaseReviewSlaParamsV3
 */
export type PatchKnowledgeBaseReviewSlaParamsV3 = {
  /**
   * Cr Review Sla Business Days
   */
  cr_review_sla_business_days: number | null;
};

/**
 * PatchSharepointTenantParamsV1
 */
export type PatchSharepointTenantParamsV1 = {
  /**
   * Credentials
   */
  credentials?: SharepointTenantCredentialsParamsV1 | Missing;
};

/**
 * PendingWorkflowRunV1
 */
export type PendingWorkflowRunV1 = {
  /**
   * Kind
   */
  kind: "PENDING";
};

export type PlainActorV1 =
  | ({
      kind: "USER";
    } & PlainUserActorV1)
  | ({
      kind: "CUSTOMER";
    } & PlainCustomerActorV1)
  | ({
      kind: "MACHINE_USER";
    } & PlainMachineUserActorV1)
  | ({
      kind: "DELETED_CUSTOMER";
    } & PlainDeletedCustomerActorV1)
  | ({
      kind: "SYSTEM";
    } & PlainSystemActorV1);

/**
 * PlainAddCustomerToGroupsParamsV1
 */
export type PlainAddCustomerToGroupsParamsV1 = {
  /**
   * Customer Group Ids
   */
  customer_group_ids: Array<string>;
};

/**
 * PlainAddCustomerToPlainTenantsParamsV1
 */
export type PlainAddCustomerToPlainTenantsParamsV1 = {
  /**
   * Plain Tenant Ids
   */
  plain_tenant_ids: Array<string>;
};

/**
 * PlainAddThreadLabelsParamsV1
 */
export type PlainAddThreadLabelsParamsV1 = {
  /**
   * Label Type Ids
   */
  label_type_ids: Array<string>;
};

/**
 * PlainAgentHandedOffV1
 */
export type PlainAgentHandedOffV1 = {
  /**
   * Kind
   */
  kind: "HANDED_OFF";
  /**
   * Reason
   */
  reason: string | null;
};

/**
 * PlainAgentHandledV1
 */
export type PlainAgentHandledV1 = {
  /**
   * Kind
   */
  kind: "HANDLED";
};

/**
 * PlainAgentInProgressV1
 */
export type PlainAgentInProgressV1 = {
  /**
   * Kind
   */
  kind: "IN_PROGRESS";
};

/**
 * PlainApiCredentialsConfiguredV1
 */
export type PlainApiCredentialsConfiguredV1 = {
  /**
   * Kind
   */
  kind: "CONFIGURED";
  /**
   * Plain Machine User Id
   */
  plain_machine_user_id: string;
};

/**
 * PlainApiCredentialsNotConfiguredV1
 */
export type PlainApiCredentialsNotConfiguredV1 = {
  /**
   * Kind
   */
  kind: "NOT_CONFIGURED";
};

/**
 * PlainApiCredentialsParamsV1
 */
export type PlainApiCredentialsParamsV1 = {
  /**
   * Machine User Id
   */
  machine_user_id: string;
  /**
   * Api Key
   */
  api_key: string;
};

export type PlainApiCredentialsV1 =
  | ({
      kind: "CONFIGURED";
    } & PlainApiCredentialsConfiguredV1)
  | ({
      kind: "NOT_CONFIGURED";
    } & PlainApiCredentialsNotConfiguredV1);

export type PlainAssignThreadParamsV1 =
  | ({
      kind: "USER";
    } & PlainThreadUserAssigneeV1)
  | ({
      kind: "MACHINE_USER";
    } & PlainThreadMachineUserAssigneeV1);

/**
 * PlainAssignmentTransitionedTimelineEntryV1
 */
export type PlainAssignmentTransitionedTimelineEntryV1 = {
  /**
   * Kind
   */
  kind: "ASSIGNMENT_TRANSITIONED";
  previous_assignee: PlainActorV1 | null;
  next_assignee: PlainActorV1 | null;
};

/**
 * PlainChangeThreadPriorityParamsV1
 */
export type PlainChangeThreadPriorityParamsV1 = {
  /**
   * Priority
   */
  priority: number;
};

/**
 * PlainChatTimelineEntryV1
 */
export type PlainChatTimelineEntryV1 = {
  /**
   * Kind
   */
  kind: "CHAT";
  /**
   * Text
   */
  text: string | null;
};

/**
 * PlainCheckConnectionResponseV1
 */
export type PlainCheckConnectionResponseV1 = {
  /**
   * Connected
   */
  connected: boolean;
  /**
   * Detail
   */
  detail?: string | null;
  /**
   * Missing Permissions
   */
  missing_permissions?: Array<PlainPermissionV1>;
};

/**
 * PlainCompanyV1
 */
export type PlainCompanyV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Domain Name
   */
  domain_name: string;
};

/**
 * PlainCreateNoteParamsV1
 */
export type PlainCreateNoteParamsV1 = {
  /**
   * Text
   */
  text: string;
};

/**
 * PlainCreateThreadParamsV1
 */
export type PlainCreateThreadParamsV1 = {
  /**
   * Customer Id
   */
  customer_id: string;
  /**
   * Title
   */
  title: string;
  /**
   * Description
   */
  description?: string | null;
  /**
   * Label Type Ids
   */
  label_type_ids?: Array<string>;
  /**
   * Priority
   */
  priority?: number | null;
};

/**
 * PlainCustomTimelineEntryV1
 */
export type PlainCustomTimelineEntryV1 = {
  /**
   * Kind
   */
  kind: "CUSTOM";
  /**
   * Title
   */
  title: string | null;
};

/**
 * PlainCustomerActorV1
 */
export type PlainCustomerActorV1 = {
  /**
   * Kind
   */
  kind: "CUSTOMER";
  /**
   * Id
   */
  id: string | null;
  /**
   * Full Name
   */
  full_name: string | null;
};

/**
 * PlainCustomerGroupV1
 */
export type PlainCustomerGroupV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Key
   */
  key: string;
};

/**
 * PlainCustomerTenantV1
 */
export type PlainCustomerTenantV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * External Id
   */
  external_id: string;
};

/**
 * PlainCustomerV1
 */
export type PlainCustomerV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Full Name
   */
  full_name: string;
  /**
   * Short Name
   */
  short_name: string | null;
  /**
   * Email
   */
  email: string;
  /**
   * Email Is Verified
   */
  email_is_verified: boolean;
  /**
   * Company Id
   */
  company_id: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * PlainDeletedCustomerActorV1
 */
export type PlainDeletedCustomerActorV1 = {
  /**
   * Kind
   */
  kind: "DELETED_CUSTOMER";
  /**
   * Id
   */
  id: string | null;
};

/**
 * PlainEmailTimelineEntryV1
 */
export type PlainEmailTimelineEntryV1 = {
  /**
   * Kind
   */
  kind: "EMAIL";
  /**
   * Text
   */
  text: string | null;
  /**
   * Subject
   */
  subject: string | null;
  /**
   * From Email
   */
  from_email: string | null;
  /**
   * To Email
   */
  to_email: string | null;
};

/**
 * PlainIngestResponseV1
 */
export type PlainIngestResponseV1 = {
  /**
   * Workflow Run Ids
   */
  workflow_run_ids?: Array<number>;
};

/**
 * PlainLabelV1
 */
export type PlainLabelV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Label Type Id
   */
  label_type_id: string;
  /**
   * Label Type Name
   */
  label_type_name: string;
};

/**
 * PlainLabelsChangedTimelineEntryV1
 */
export type PlainLabelsChangedTimelineEntryV1 = {
  /**
   * Kind
   */
  kind: "LABELS_CHANGED";
  /**
   * Previous Labels
   */
  previous_labels: Array<PlainLabelV1>;
  /**
   * Next Labels
   */
  next_labels: Array<PlainLabelV1>;
};

/**
 * PlainMachineUserActorV1
 */
export type PlainMachineUserActorV1 = {
  /**
   * Kind
   */
  kind: "MACHINE_USER";
  /**
   * Id
   */
  id: string | null;
  /**
   * Full Name
   */
  full_name: string | null;
};

/**
 * PlainMessageSourceV1
 */
export const PlainMessageSourceV1 = {
  CHAT: "CHAT",
  EMAIL: "EMAIL",
  API: "API",
  SLACK: "SLACK",
  MS_TEAMS: "MS_TEAMS",
  DISCORD: "DISCORD",
  INTERNAL: "INTERNAL",
} as const;

/**
 * PlainMessageSourceV1
 */
export type PlainMessageSourceV1 =
  (typeof PlainMessageSourceV1)[keyof typeof PlainMessageSourceV1];

/**
 * PlainNoteTimelineEntryV1
 */
export type PlainNoteTimelineEntryV1 = {
  /**
   * Kind
   */
  kind: "NOTE";
  /**
   * Text
   */
  text: string | null;
};

/**
 * PlainNoteV1
 */
export type PlainNoteV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Text
   */
  text: string;
  /**
   * Customer Id
   */
  customer_id: string;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * PlainOtherTimelineEntryV1
 */
export type PlainOtherTimelineEntryV1 = {
  /**
   * Kind
   */
  kind: "OTHER";
  /**
   * Entry Type
   */
  entry_type: string;
};

/**
 * PlainPermissionV1
 */
export const PlainPermissionV1 = {
  AGENT_APPROVAL_RESOLVE: "agentApproval:resolve",
  AGENT_SESSION_CREATE: "agentSession:create",
  AGENT_SESSION_READ: "agentSession:read",
  AGENT_SESSION_UPDATE: "agentSession:update",
  AGENT_TOOL_CONNECTION_CREATE: "agentToolConnection:create",
  AGENT_TOOL_CONNECTION_DELETE: "agentToolConnection:delete",
  AGENT_TOOL_CONNECTION_READ: "agentToolConnection:read",
  AGENT_TOOL_CONNECTION_UPDATE: "agentToolConnection:update",
  AI_FEATURE_FEEDBACK_CREATE: "aiFeatureFeedback:create",
  AI_FEATURE_FEEDBACK_READ: "aiFeatureFeedback:read",
  AI_TONE_RULE_CREATE: "aiToneRule:create",
  AI_TONE_RULE_DELETE: "aiToneRule:delete",
  AI_TONE_RULE_EDIT: "aiToneRule:edit",
  AI_TONE_RULE_READ: "aiToneRule:read",
  ATTACHMENT_COPY: "attachment:copy",
  ATTACHMENT_CREATE: "attachment:create",
  ATTACHMENT_DOWNLOAD: "attachment:download",
  ATTACHMENT_EDIT: "attachment:edit",
  ATTACHMENT_READ: "attachment:read",
  CHAT_CREATE: "chat:create",
  COMPANY_CREATE: "company:create",
  COMPANY_DELETE: "company:delete",
  COMPANY_EDIT: "company:edit",
  COMPANY_READ: "company:read",
  COMPANY_SEARCH: "company:search",
  CONNECTED_DISCORD_CHANNEL_EDIT: "connectedDiscordChannel:edit",
  CONNECTED_DISCORD_CHANNEL_READ: "connectedDiscordChannel:read",
  CONNECTED_MS_TEAMS_CHANNEL_EDIT: "connectedMSTeamsChannel:edit",
  CONNECTED_MS_TEAMS_CHANNEL_READ: "connectedMSTeamsChannel:read",
  CUSTOMER_CREATE: "customer:create",
  CUSTOMER_DELETE: "customer:delete",
  CUSTOMER_EDIT: "customer:edit",
  CUSTOMER_IMPERSONATE: "customer:impersonate",
  CUSTOMER_READ: "customer:read",
  CUSTOMER_SEARCH: "customer:search",
  CUSTOMER_CARD_CONFIG_API_DETAILS_EDIT: "customerCardConfigApiDetails:edit",
  CUSTOMER_CARD_CONFIG_API_DETAILS_READ: "customerCardConfigApiDetails:read",
  CUSTOMER_CARD_INSTANCE_READ: "customerCardInstance:read",
  CUSTOMER_CARD_INSTANCE_RELOAD: "customerCardInstance:reload",
  CUSTOMER_EMAIL_CREATE: "customerEmail:create",
  CUSTOMER_EMAIL_EDIT: "customerEmail:edit",
  CUSTOMER_EMAIL_READ: "customerEmail:read",
  CUSTOMER_EVENT_CREATE: "customerEvent:create",
  CUSTOMER_GROUP_CREATE: "customerGroup:create",
  CUSTOMER_GROUP_DELETE: "customerGroup:delete",
  CUSTOMER_GROUP_EDIT: "customerGroup:edit",
  CUSTOMER_GROUP_READ: "customerGroup:read",
  CUSTOMER_GROUP_MEMBERSHIP_CREATE: "customerGroupMembership:create",
  CUSTOMER_GROUP_MEMBERSHIP_DELETE: "customerGroupMembership:delete",
  CUSTOMER_GROUP_MEMBERSHIP_READ: "customerGroupMembership:read",
  CUSTOMER_SURVEY_CREATE: "customerSurvey:create",
  CUSTOMER_SURVEY_DELETE: "customerSurvey:delete",
  CUSTOMER_SURVEY_EDIT: "customerSurvey:edit",
  CUSTOMER_SURVEY_READ: "customerSurvey:read",
  CUSTOMER_TENANT_MEMBERSHIP_CREATE: "customerTenantMembership:create",
  CUSTOMER_TENANT_MEMBERSHIP_DELETE: "customerTenantMembership:delete",
  CUSTOMER_TENANT_MEMBERSHIP_READ: "customerTenantMembership:read",
  DISCORD_USER_AUTH_INTEGRATION_CREATE: "discordUserAuthIntegration:create",
  DISCORD_USER_AUTH_INTEGRATION_DELETE: "discordUserAuthIntegration:delete",
  DISCORD_USER_AUTH_INTEGRATION_READ: "discordUserAuthIntegration:read",
  EMAIL_CREATE: "email:create",
  EMAIL_EDIT: "email:edit",
  EMAIL_READ: "email:read",
  ESCALATION_PATH_CREATE: "escalationPath:create",
  ESCALATION_PATH_DELETE: "escalationPath:delete",
  ESCALATION_PATH_EDIT: "escalationPath:edit",
  ESCALATION_PATH_EXECUTE: "escalationPath:execute",
  ESCALATION_PATH_READ: "escalationPath:read",
  FAVORITE_PAGE_CREATE: "favoritePage:create",
  FAVORITE_PAGE_DELETE: "favoritePage:delete",
  FAVORITE_PAGE_READ: "favoritePage:read",
  GITHUB_USER_AUTH_INTEGRATION_CREATE: "githubUserAuthIntegration:create",
  GITHUB_USER_AUTH_INTEGRATION_DELETE: "githubUserAuthIntegration:delete",
  GITHUB_USER_AUTH_INTEGRATION_READ: "githubUserAuthIntegration:read",
  HELP_CENTER_CREATE: "helpCenter:create",
  HELP_CENTER_DELETE: "helpCenter:delete",
  HELP_CENTER_EDIT: "helpCenter:edit",
  HELP_CENTER_READ: "helpCenter:read",
  HELP_CENTER_ARTICLE_CREATE: "helpCenterArticle:create",
  HELP_CENTER_ARTICLE_DELETE: "helpCenterArticle:delete",
  HELP_CENTER_ARTICLE_EDIT: "helpCenterArticle:edit",
  HELP_CENTER_ARTICLE_READ: "helpCenterArticle:read",
  HELP_CENTER_ARTICLE_GROUP_CREATE: "helpCenterArticleGroup:create",
  HELP_CENTER_ARTICLE_GROUP_DELETE: "helpCenterArticleGroup:delete",
  HELP_CENTER_ARTICLE_GROUP_EDIT: "helpCenterArticleGroup:edit",
  HELP_CENTER_ARTICLE_GROUP_READ: "helpCenterArticleGroup:read",
  IMPORT_CREATE: "import:create",
  IMPORT_DELETE: "import:delete",
  IMPORT_EDIT: "import:edit",
  IMPORT_READ: "import:read",
  INDEXED_DOCUMENT_CREATE: "indexedDocument:create",
  INDEXED_DOCUMENT_DELETE: "indexedDocument:delete",
  INDEXED_DOCUMENT_READ: "indexedDocument:read",
  KNOWLEDGE_GAP_CREATE: "knowledgeGap:create",
  KNOWLEDGE_GAP_EDIT: "knowledgeGap:edit",
  KNOWLEDGE_GAP_READ: "knowledgeGap:read",
  KNOWLEDGE_GAP_SIGNAL_CREATE: "knowledgeGapSignal:create",
  KNOWLEDGE_GAP_SIGNAL_EDIT: "knowledgeGapSignal:edit",
  KNOWLEDGE_GAP_SIGNAL_READ: "knowledgeGapSignal:read",
  KNOWLEDGE_SOURCE_CREATE: "knowledgeSource:create",
  KNOWLEDGE_SOURCE_DELETE: "knowledgeSource:delete",
  KNOWLEDGE_SOURCE_READ: "knowledgeSource:read",
  LABEL_CREATE: "label:create",
  LABEL_DELETE: "label:delete",
  LABEL_READ: "label:read",
  LABEL_TYPE_CREATE: "labelType:create",
  LABEL_TYPE_EDIT: "labelType:edit",
  LABEL_TYPE_READ: "labelType:read",
  MACHINE_USER_CREATE: "machineUser:create",
  MACHINE_USER_DELETE: "machineUser:delete",
  MACHINE_USER_EDIT: "machineUser:edit",
  MACHINE_USER_READ: "machineUser:read",
  METRICS_AGENT_READ: "metricsAgent:read",
  NOTE_CREATE: "note:create",
  NOTE_DELETE: "note:delete",
  NOTE_READ: "note:read",
  NOTE_UPDATE: "note:update",
  SERVICE_LEVEL_AGREEMENT_CREATE: "serviceLevelAgreement:create",
  SERVICE_LEVEL_AGREEMENT_DELETE: "serviceLevelAgreement:delete",
  SERVICE_LEVEL_AGREEMENT_EDIT: "serviceLevelAgreement:edit",
  SERVICE_LEVEL_AGREEMENT_READ: "serviceLevelAgreement:read",
  SIDEKICK_ATTIO_INTEGRATION_READ: "sidekickAttioIntegration:read",
  SIDEKICK_ATTIO_INTEGRATION_UPDATE: "sidekickAttioIntegration:update",
  SIDEKICK_CUSTOM_SKILL_CREATE: "sidekickCustomSkill:create",
  SIDEKICK_CUSTOM_SKILL_DELETE: "sidekickCustomSkill:delete",
  SIDEKICK_CUSTOM_SKILL_EDIT: "sidekickCustomSkill:edit",
  SIDEKICK_CUSTOM_SKILL_READ: "sidekickCustomSkill:read",
  SIDEKICK_DATADOG_INTEGRATION_READ: "sidekickDatadogIntegration:read",
  SIDEKICK_DATADOG_INTEGRATION_UPDATE: "sidekickDatadogIntegration:update",
  SIDEKICK_GITHUB_INTEGRATION_READ: "sidekickGithubIntegration:read",
  SIDEKICK_GITHUB_INTEGRATION_UPDATE: "sidekickGithubIntegration:update",
  SIDEKICK_GRAFANA_INTEGRATION_READ: "sidekickGrafanaIntegration:read",
  SIDEKICK_GRAFANA_INTEGRATION_UPDATE: "sidekickGrafanaIntegration:update",
  SIDEKICK_GRAIN_INTEGRATION_READ: "sidekickGrainIntegration:read",
  SIDEKICK_GRAIN_INTEGRATION_UPDATE: "sidekickGrainIntegration:update",
  SIDEKICK_GRANOLA_INTEGRATION_READ: "sidekickGranolaIntegration:read",
  SIDEKICK_GRANOLA_INTEGRATION_UPDATE: "sidekickGranolaIntegration:update",
  SIDEKICK_HUBSPOT_INTEGRATION_READ: "sidekickHubspotIntegration:read",
  SIDEKICK_HUBSPOT_INTEGRATION_UPDATE: "sidekickHubspotIntegration:update",
  SIDEKICK_INCIDENTIO_INTEGRATION_READ: "sidekickIncidentioIntegration:read",
  SIDEKICK_INCIDENTIO_INTEGRATION_UPDATE:
    "sidekickIncidentioIntegration:update",
  SIDEKICK_JIRA_INTEGRATION_READ: "sidekickJiraIntegration:read",
  SIDEKICK_JIRA_INTEGRATION_UPDATE: "sidekickJiraIntegration:update",
  SIDEKICK_LAUNCHDARKLY_INTEGRATION_READ:
    "sidekickLaunchdarklyIntegration:read",
  SIDEKICK_LAUNCHDARKLY_INTEGRATION_UPDATE:
    "sidekickLaunchdarklyIntegration:update",
  SIDEKICK_LINEAR_INTEGRATION_READ: "sidekickLinearIntegration:read",
  SIDEKICK_LINEAR_INTEGRATION_UPDATE: "sidekickLinearIntegration:update",
  SIDEKICK_MCP_SERVER_READ: "sidekickMcpServer:read",
  SIDEKICK_MCP_SERVER_UPDATE: "sidekickMcpServer:update",
  SIDEKICK_NOTION_INTEGRATION_READ: "sidekickNotionIntegration:read",
  SIDEKICK_NOTION_INTEGRATION_UPDATE: "sidekickNotionIntegration:update",
  SIDEKICK_POSTHOG_INTEGRATION_READ: "sidekickPosthogIntegration:read",
  SIDEKICK_POSTHOG_INTEGRATION_UPDATE: "sidekickPosthogIntegration:update",
  SIDEKICK_SENTRY_INTEGRATION_READ: "sidekickSentryIntegration:read",
  SIDEKICK_SENTRY_INTEGRATION_UPDATE: "sidekickSentryIntegration:update",
  SIDEKICK_SETTINGS_READ: "sidekickSettings:read",
  SIDEKICK_SETTINGS_UPDATE: "sidekickSettings:update",
  SLACK_USER_READ: "slackUser:read",
  SUGGESTED_LABEL_TYPE_CREATE: "suggestedLabelType:create",
  SUGGESTED_LABEL_TYPE_READ: "suggestedLabelType:read",
  TASK_CREATE: "task:create",
  TASK_DELETE: "task:delete",
  TASK_EDIT: "task:edit",
  TASK_READ: "task:read",
  TENANT_CREATE: "tenant:create",
  TENANT_DELETE: "tenant:delete",
  TENANT_EDIT: "tenant:edit",
  TENANT_READ: "tenant:read",
  TENANT_SEARCH: "tenant:search",
  TENANT_FIELD_CREATE: "tenantField:create",
  TENANT_FIELD_DELETE: "tenantField:delete",
  TENANT_FIELD_READ: "tenantField:read",
  TENANT_FIELD_UPDATE: "tenantField:update",
  TENANT_FIELD_SCHEMA_CREATE: "tenantFieldSchema:create",
  TENANT_FIELD_SCHEMA_DELETE: "tenantFieldSchema:delete",
  TENANT_FIELD_SCHEMA_READ: "tenantFieldSchema:read",
  TENANT_FIELD_SCHEMA_UPDATE: "tenantFieldSchema:update",
  THREAD_ASSIGN: "thread:assign",
  THREAD_CREATE: "thread:create",
  THREAD_DELETE: "thread:delete",
  THREAD_EDIT: "thread:edit",
  THREAD_IMPORT: "thread:import",
  THREAD_LOCK: "thread:lock",
  THREAD_READ: "thread:read",
  THREAD_REPLY: "thread:reply",
  THREAD_SEARCH: "thread:search",
  THREAD_UNASSIGN: "thread:unassign",
  THREAD_ACTIVITY_READ: "threadActivity:read",
  THREAD_EVENT_CREATE: "threadEvent:create",
  THREAD_FIELD_CREATE: "threadField:create",
  THREAD_FIELD_DELETE: "threadField:delete",
  THREAD_FIELD_READ: "threadField:read",
  THREAD_FIELD_UPDATE: "threadField:update",
  THREAD_FIELD_SCHEMA_CREATE: "threadFieldSchema:create",
  THREAD_FIELD_SCHEMA_DELETE: "threadFieldSchema:delete",
  THREAD_FIELD_SCHEMA_EDIT: "threadFieldSchema:edit",
  THREAD_FIELD_SCHEMA_READ: "threadFieldSchema:read",
  THREAD_LINK_CREATE: "threadLink:create",
  THREAD_LINK_DELETE: "threadLink:delete",
  THREAD_LINK_EDIT: "threadLink:edit",
  THREAD_LINK_READ: "threadLink:read",
  THREAD_LINK_CANDIDATE_SEARCH: "threadLinkCandidate:search",
  TIER_CREATE: "tier:create",
  TIER_DELETE: "tier:delete",
  TIER_EDIT: "tier:edit",
  TIER_READ: "tier:read",
  TIER_MEMBERSHIP_CREATE: "tierMembership:create",
  TIER_MEMBERSHIP_DELETE: "tierMembership:delete",
  TIER_MEMBERSHIP_READ: "tierMembership:read",
  TIMELINE_CREATE: "timeline:create",
  TIMELINE_EDIT: "timeline:edit",
  TIMELINE_READ: "timeline:read",
  USER_DELETE: "user:delete",
  USER_EDIT: "user:edit",
  USER_READ: "user:read",
  USER_AVATAR_EDIT: "userAvatar:edit",
  USER_STATUS_EDIT: "userStatus:edit",
  USER_WORKING_HOURS_EDIT: "userWorkingHours:edit",
  USER_WORKING_HOURS_READ: "userWorkingHours:read",
  WORKSPACE_DELETE: "workspace:delete",
  WORKSPACE_EDIT: "workspace:edit",
  WORKSPACE_READ: "workspace:read",
  WORKSPACE_CURSOR_INTEGRATION_CREATE: "workspaceCursorIntegration:create",
  WORKSPACE_CURSOR_INTEGRATION_DELETE: "workspaceCursorIntegration:delete",
  WORKSPACE_CURSOR_INTEGRATION_READ: "workspaceCursorIntegration:read",
  WORKSPACE_DISCORD_CHANNEL_INTEGRATION_CREATE:
    "workspaceDiscordChannelIntegration:create",
  WORKSPACE_DISCORD_CHANNEL_INTEGRATION_DELETE:
    "workspaceDiscordChannelIntegration:delete",
  WORKSPACE_DISCORD_CHANNEL_INTEGRATION_READ:
    "workspaceDiscordChannelIntegration:read",
  WORKSPACE_FILE_CREATE: "workspaceFile:create",
  WORKSPACE_FILE_DELETE: "workspaceFile:delete",
  WORKSPACE_FILE_DOWNLOAD: "workspaceFile:download",
  WORKSPACE_FILE_READ: "workspaceFile:read",
  WORKSPACE_LINEAR_INTEGRATION_CREATE: "workspaceLinearIntegration:create",
  WORKSPACE_LINEAR_INTEGRATION_DELETE: "workspaceLinearIntegration:delete",
  WORKSPACE_LINEAR_INTEGRATION_READ: "workspaceLinearIntegration:read",
  WORKSPACE_SLACK_SIDEKICK_INTEGRATION_CREATE:
    "workspaceSlackSidekickIntegration:create",
  WORKSPACE_SLACK_SIDEKICK_INTEGRATION_DELETE:
    "workspaceSlackSidekickIntegration:delete",
  WORKSPACE_SLACK_SIDEKICK_INTEGRATION_READ:
    "workspaceSlackSidekickIntegration:read",
  WORKSPACE_SLACK_SIDEKICK_INTEGRATION_UPDATE:
    "workspaceSlackSidekickIntegration:update",
} as const;

/**
 * PlainPermissionV1
 */
export type PlainPermissionV1 =
  (typeof PlainPermissionV1)[keyof typeof PlainPermissionV1];

/**
 * PlainRemoveThreadLabelsParamsV1
 */
export type PlainRemoveThreadLabelsParamsV1 = {
  /**
   * Label Ids
   */
  label_ids: Array<string>;
};

/**
 * PlainSendMessageParamsV1
 */
export type PlainSendMessageParamsV1 = {
  /**
   * Text
   */
  text: string;
};

/**
 * PlainSetCustomerCompanyParamsV1
 */
export type PlainSetCustomerCompanyParamsV1 = {
  /**
   * Company Id
   */
  company_id: string;
};

/**
 * PlainSlaAchievedV1
 */
export type PlainSlaAchievedV1 = {
  /**
   * Kind
   */
  kind: "ACHIEVED";
  /**
   * Achieved At
   */
  achieved_at: Date;
};

/**
 * PlainSlaBreachedV1
 */
export type PlainSlaBreachedV1 = {
  /**
   * Kind
   */
  kind: "BREACHED";
  /**
   * Breached At
   */
  breached_at: Date;
  /**
   * Completed At
   */
  completed_at: Date;
};

/**
 * PlainSlaBreachingV1
 */
export type PlainSlaBreachingV1 = {
  /**
   * Kind
   */
  kind: "BREACHING";
  /**
   * Breached At
   */
  breached_at: Date;
};

/**
 * PlainSlaCancelledV1
 */
export type PlainSlaCancelledV1 = {
  /**
   * Kind
   */
  kind: "CANCELLED";
  /**
   * Cancelled At
   */
  cancelled_at: Date;
};

/**
 * PlainSlaImminentBreachV1
 */
export type PlainSlaImminentBreachV1 = {
  /**
   * Kind
   */
  kind: "IMMINENT_BREACH";
  /**
   * Breaching At
   */
  breaching_at: Date;
};

/**
 * PlainSlaPendingV1
 */
export type PlainSlaPendingV1 = {
  /**
   * Kind
   */
  kind: "PENDING";
  /**
   * Breaching At
   */
  breaching_at: Date;
};

/**
 * PlainSlaStatusSummaryV1
 */
export type PlainSlaStatusSummaryV1 = {
  first_response_time: PlainSlaStatusV1 | null;
  next_response_time: PlainSlaStatusV1 | null;
};

export type PlainSlaStatusV1 =
  | ({
      kind: "PENDING";
    } & PlainSlaPendingV1)
  | ({
      kind: "IMMINENT_BREACH";
    } & PlainSlaImminentBreachV1)
  | ({
      kind: "BREACHING";
    } & PlainSlaBreachingV1)
  | ({
      kind: "ACHIEVED";
    } & PlainSlaAchievedV1)
  | ({
      kind: "BREACHED";
    } & PlainSlaBreachedV1)
  | ({
      kind: "CANCELLED";
    } & PlainSlaCancelledV1);

/**
 * PlainSnoozeThreadParamsV1
 */
export type PlainSnoozeThreadParamsV1 = {
  /**
   * Duration Seconds
   */
  duration_seconds: number;
};

/**
 * PlainStatusTransitionedTimelineEntryV1
 */
export type PlainStatusTransitionedTimelineEntryV1 = {
  /**
   * Kind
   */
  kind: "STATUS_TRANSITIONED";
  previous_status: PlainThreadStatusV1 | null;
  next_status: PlainThreadStatusV1 | null;
};

/**
 * PlainSurveyResponseV1
 */
export type PlainSurveyResponseV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Survey Id
   */
  survey_id: string | null;
  sentiment: PlainSurveySentimentV1 | null;
  /**
   * Rating
   */
  rating: number | null;
  /**
   * Comment
   */
  comment: string | null;
  /**
   * Responded At
   */
  responded_at: Date | null;
};

/**
 * PlainSurveySentimentV1
 */
export const PlainSurveySentimentV1 = {
  POSITIVE: "POSITIVE",
  NEGATIVE: "NEGATIVE",
  NEUTRAL: "NEUTRAL",
} as const;

/**
 * PlainSurveySentimentV1
 */
export type PlainSurveySentimentV1 =
  (typeof PlainSurveySentimentV1)[keyof typeof PlainSurveySentimentV1];

/**
 * PlainSystemActorV1
 */
export type PlainSystemActorV1 = {
  /**
   * Kind
   */
  kind: "SYSTEM";
  /**
   * Id
   */
  id: string | null;
};

/**
 * PlainTenantFullV1
 */
export type PlainTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Plain Workspace Id
   */
  plain_workspace_id: string | null;
  /**
   * Permissions
   */
  permissions: Array<PlainPermissionV1>;
  /**
   * Webhook Ingest Url
   */
  webhook_ingest_url: string;
  api_credentials: PlainApiCredentialsV1;
  webhook_credentials: PlainWebhookCredentialsV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * PlainTenantV1
 */
export type PlainTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Plain Workspace Id
   */
  plain_workspace_id: string | null;
  /**
   * Permissions
   */
  permissions: Array<PlainPermissionV1>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

export type PlainThreadAgentStateV1 =
  | ({
      kind: "IN_PROGRESS";
    } & PlainAgentInProgressV1)
  | ({
      kind: "HANDED_OFF";
    } & PlainAgentHandedOffV1)
  | ({
      kind: "HANDLED";
    } & PlainAgentHandledV1);

/**
 * PlainThreadAgentStatusV1
 */
export const PlainThreadAgentStatusV1 = {
  IN_PROGRESS: "IN_PROGRESS",
  HANDLED: "HANDLED",
  HANDED_OFF: "HANDED_OFF",
} as const;

/**
 * PlainThreadAgentStatusV1
 */
export type PlainThreadAgentStatusV1 =
  (typeof PlainThreadAgentStatusV1)[keyof typeof PlainThreadAgentStatusV1];

/**
 * PlainThreadChannelV1
 */
export const PlainThreadChannelV1 = {
  EMAIL: "EMAIL",
  SLACK: "SLACK",
  CHAT: "CHAT",
  API: "API",
  MS_TEAMS: "MS_TEAMS",
  DISCORD: "DISCORD",
  IMPORT: "IMPORT",
  INTERNAL: "INTERNAL",
} as const;

/**
 * PlainThreadChannelV1
 */
export type PlainThreadChannelV1 =
  (typeof PlainThreadChannelV1)[keyof typeof PlainThreadChannelV1];

/**
 * PlainThreadFieldBoolV1
 */
export type PlainThreadFieldBoolV1 = {
  /**
   * Kind
   */
  kind: "BOOL";
  /**
   * Boolean Value
   */
  boolean_value: boolean | null;
};

/**
 * PlainThreadFieldCurrencyV1
 */
export type PlainThreadFieldCurrencyV1 = {
  /**
   * Kind
   */
  kind: "CURRENCY";
};

/**
 * PlainThreadFieldDateV1
 */
export type PlainThreadFieldDateV1 = {
  /**
   * Kind
   */
  kind: "DATE";
  /**
   * Date Value
   */
  date_value: Date | null;
};

/**
 * PlainThreadFieldEnumV1
 */
export type PlainThreadFieldEnumV1 = {
  /**
   * Kind
   */
  kind: "ENUM";
  /**
   * String Value
   */
  string_value: string | null;
};

/**
 * PlainThreadFieldNumberV1
 */
export type PlainThreadFieldNumberV1 = {
  /**
   * Kind
   */
  kind: "NUMBER";
  /**
   * Number Value
   */
  number_value: number | null;
};

/**
 * PlainThreadFieldStringV1
 */
export type PlainThreadFieldStringV1 = {
  /**
   * Kind
   */
  kind: "STRING";
  /**
   * String Value
   */
  string_value: string | null;
};

/**
 * PlainThreadFieldV1
 */
export type PlainThreadFieldV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Key
   */
  key: string;
  /**
   * Is Ai Generated
   */
  is_ai_generated: boolean;
  value: PlainThreadFieldValueV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

export type PlainThreadFieldValueV1 =
  | ({
      kind: "STRING";
    } & PlainThreadFieldStringV1)
  | ({
      kind: "BOOL";
    } & PlainThreadFieldBoolV1)
  | ({
      kind: "ENUM";
    } & PlainThreadFieldEnumV1)
  | ({
      kind: "NUMBER";
    } & PlainThreadFieldNumberV1)
  | ({
      kind: "CURRENCY";
    } & PlainThreadFieldCurrencyV1)
  | ({
      kind: "DATE";
    } & PlainThreadFieldDateV1);

/**
 * PlainThreadFullV1
 */
export type PlainThreadFullV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Ref
   */
  ref: string;
  /**
   * Title
   */
  title: string;
  /**
   * Description
   */
  description: string | null;
  /**
   * Preview Text
   */
  preview_text: string | null;
  /**
   * External Id
   */
  external_id: string | null;
  /**
   * Priority
   */
  priority: number;
  channel: PlainThreadChannelV1;
  status: PlainThreadStatusV1;
  /**
   * Status Changed At
   */
  status_changed_at: Date;
  status_changed_by: PlainActorV1;
  agent_state: PlainThreadAgentStateV1 | null;
  /**
   * Agent State Updated At
   */
  agent_state_updated_at: Date | null;
  agent_state_updated_by: PlainActorV1 | null;
  customer: PlainCustomerV1;
  plain_tenant: PlainCustomerTenantV1 | null;
  tier: PlainTierV1 | null;
  /**
   * Labels
   */
  labels: Array<PlainLabelV1>;
  /**
   * Thread Fields
   */
  thread_fields: Array<PlainThreadFieldV1>;
  assigned_to: PlainActorV1 | null;
  /**
   * Assigned At
   */
  assigned_at: Date | null;
  /**
   * Additional Assignees
   */
  additional_assignees: Array<PlainActorV1>;
  /**
   * Participants
   */
  participants: Array<PlainActorV1>;
  /**
   * Support Email Addresses
   */
  support_email_addresses: Array<string>;
  first_inbound_message: PlainThreadMessageInfoV1 | null;
  first_outbound_message: PlainThreadMessageInfoV1 | null;
  last_inbound_message: PlainThreadMessageInfoV1 | null;
  last_outbound_message: PlainThreadMessageInfoV1 | null;
  sla_status: PlainSlaStatusSummaryV1;
  survey_response: PlainSurveyResponseV1 | null;
  /**
   * Timeline
   */
  timeline: Array<PlainTimelineEntryV1>;
  /**
   * Locked At
   */
  locked_at: Date | null;
  locked_by: PlainActorV1 | null;
  /**
   * Imported At
   */
  imported_at: Date | null;
  imported_by: PlainActorV1 | null;
  /**
   * Created At
   */
  created_at: Date;
  created_by: PlainActorV1;
  /**
   * Updated At
   */
  updated_at: Date;
  updated_by: PlainActorV1;
};

/**
 * PlainThreadMachineUserAssigneeV1
 */
export type PlainThreadMachineUserAssigneeV1 = {
  /**
   * Kind
   */
  kind: "MACHINE_USER";
  /**
   * Machine User Id
   */
  machine_user_id: string;
};

/**
 * PlainThreadMessageInfoV1
 */
export type PlainThreadMessageInfoV1 = {
  /**
   * Timestamp
   */
  timestamp: Date;
  source: PlainMessageSourceV1;
};

/**
 * PlainThreadStatusV1
 */
export const PlainThreadStatusV1 = {
  TODO: "TODO",
  SNOOZED: "SNOOZED",
  DONE: "DONE",
} as const;

/**
 * PlainThreadStatusV1
 */
export type PlainThreadStatusV1 =
  (typeof PlainThreadStatusV1)[keyof typeof PlainThreadStatusV1];

/**
 * PlainThreadUserAssigneeV1
 */
export type PlainThreadUserAssigneeV1 = {
  /**
   * Kind
   */
  kind: "USER";
  /**
   * User Id
   */
  user_id: string;
};

/**
 * PlainThreadV1
 */
export type PlainThreadV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Ref
   */
  ref: string;
  /**
   * Title
   */
  title: string;
  status: PlainThreadStatusV1;
  /**
   * Priority
   */
  priority: number;
  /**
   * Customer Id
   */
  customer_id: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * PlainTierV1
 */
export type PlainTierV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * External Id
   */
  external_id: string | null;
};

export type PlainTimelineEntryDetailV1 =
  | ({
      kind: "EMAIL";
    } & PlainEmailTimelineEntryV1)
  | ({
      kind: "CHAT";
    } & PlainChatTimelineEntryV1)
  | ({
      kind: "NOTE";
    } & PlainNoteTimelineEntryV1)
  | ({
      kind: "STATUS_TRANSITIONED";
    } & PlainStatusTransitionedTimelineEntryV1)
  | ({
      kind: "ASSIGNMENT_TRANSITIONED";
    } & PlainAssignmentTransitionedTimelineEntryV1)
  | ({
      kind: "LABELS_CHANGED";
    } & PlainLabelsChangedTimelineEntryV1)
  | ({
      kind: "CUSTOM";
    } & PlainCustomTimelineEntryV1)
  | ({
      kind: "OTHER";
    } & PlainOtherTimelineEntryV1);

/**
 * PlainTimelineEntryV1
 */
export type PlainTimelineEntryV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Thread Id
   */
  thread_id: string;
  /**
   * Customer Id
   */
  customer_id: string;
  /**
   * Timestamp
   */
  timestamp: Date;
  actor: PlainActorV1;
  /**
   * Llm Text
   */
  llm_text: string | null;
  detail: PlainTimelineEntryDetailV1;
};

/**
 * PlainUpdateThreadAgentStatusParamsV1
 */
export type PlainUpdateThreadAgentStatusParamsV1 = {
  agent_status: PlainThreadAgentStatusV1;
};

/**
 * PlainUpsertCompanyParamsV1
 */
export type PlainUpsertCompanyParamsV1 = {
  /**
   * Name
   */
  name: string;
  /**
   * Domain Name
   */
  domain_name: string;
};

/**
 * PlainUpsertCustomerParamsV1
 */
export type PlainUpsertCustomerParamsV1 = {
  /**
   * Email
   */
  email: string;
  /**
   * Full Name
   */
  full_name: string;
  /**
   * Short Name
   */
  short_name?: string | null;
  /**
   * External Id
   */
  external_id?: string | null;
};

/**
 * PlainUpsertPlainTenantParamsV1
 */
export type PlainUpsertPlainTenantParamsV1 = {
  /**
   * Name
   */
  name: string;
  /**
   * External Id
   */
  external_id: string;
};

/**
 * PlainUpsertThreadFieldParamsV1
 */
export type PlainUpsertThreadFieldParamsV1 = {
  /**
   * String Value
   */
  string_value: string;
};

/**
 * PlainUserActorV1
 */
export type PlainUserActorV1 = {
  /**
   * Kind
   */
  kind: "USER";
  /**
   * Id
   */
  id: string | null;
  /**
   * Full Name
   */
  full_name: string | null;
};

/**
 * PlainWebhookCredentialsConfiguredV1
 */
export type PlainWebhookCredentialsConfiguredV1 = {
  /**
   * Kind
   */
  kind: "CONFIGURED";
};

/**
 * PlainWebhookCredentialsNotConfiguredV1
 */
export type PlainWebhookCredentialsNotConfiguredV1 = {
  /**
   * Kind
   */
  kind: "NOT_CONFIGURED";
};

/**
 * PlainWebhookCredentialsParamsV1
 */
export type PlainWebhookCredentialsParamsV1 = {
  /**
   * Signing Secret
   */
  signing_secret: string;
};

export type PlainWebhookCredentialsV1 =
  | ({
      kind: "CONFIGURED";
    } & PlainWebhookCredentialsConfiguredV1)
  | ({
      kind: "NOT_CONFIGURED";
    } & PlainWebhookCredentialsNotConfiguredV1);

/**
 * PromptKind
 */
export const PromptKind = {
  INFERENCE: "INFERENCE",
  CHUNKING: "CHUNKING",
  INDEX_TEXT: "INDEX_TEXT",
} as const;

/**
 * PromptKind
 */
export type PromptKind = (typeof PromptKind)[keyof typeof PromptKind];

/**
 * PromptV1
 */
export type PromptV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Task Id
   */
  task_id: number;
  kind: PromptKind;
  template: SanitizedStr;
  input_schema: JsonSchemaV1Output;
  output_schema: JsonSchemaV1Output;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * RedactedArticleContentV1
 */
export type RedactedArticleContentV1 = {
  /**
   * Kind
   */
  kind?: "REDACTED";
};

/**
 * RedactedChangeRequestContentV1
 */
export type RedactedChangeRequestContentV1 = {
  /**
   * Kind
   */
  kind?: "REDACTED";
};

/**
 * RedactedKnowledgeBaseContentV1
 */
export type RedactedKnowledgeBaseContentV1 = {
  /**
   * Kind
   */
  kind?: "REDACTED";
};

export type ReferenceLineV1 =
  | ({
      kind: "SECTION_CHANGE";
    } & SectionChangeReferenceLineV1)
  | ({
      kind: "CHANGE_REQUEST";
    } & ChangeRequestReferenceLineV1);

/**
 * RegexSearchArticlesParamsV1
 */
export type RegexSearchArticlesParamsV1 = {
  ref: NonEmptyStr;
  /**
   * Pattern
   */
  pattern: string;
};

/**
 * RegexSearchArticlesResponseV1
 */
export type RegexSearchArticlesResponseV1 = {
  /**
   * Sources
   */
  sources: Array<RegexSearchArticlesSourceV1>;
};

/**
 * RegexSearchArticlesSourceV1
 */
export type RegexSearchArticlesSourceV1 = {
  /**
   * Path
   */
  path: string;
  article: GitArticleV1;
  /**
   * Matched Content
   */
  matched_content: boolean;
  /**
   * Matched Title
   */
  matched_title: boolean;
};

/**
 * RegexSearchDatapointQueryV1
 */
export type RegexSearchDatapointQueryV1 = {
  /**
   * Pattern
   */
  pattern: string;
  /**
   * K
   */
  k?: number;
  /**
   * Task Id
   */
  task_id?: number | null;
  visibility?: VisibilityV1;
  /**
   * Datapoint Ids Any
   */
  datapoint_ids_any?: Array<number> | null;
  /**
   * Commit Ids Any
   */
  commit_ids_any?: Array<number> | null;
  /**
   * Kanonical Datapoint Ids Any
   */
  kanonical_datapoint_ids_any?: Array<number> | null;
};

/**
 * RegexSearchDatapointsRequestV1
 */
export type RegexSearchDatapointsRequestV1 = {
  query: RegexSearchDatapointQueryV1;
};

/**
 * RegexSearchDatapointsResponseV1
 */
export type RegexSearchDatapointsResponseV1 = {
  /**
   * Results
   */
  results: Array<DatapointFullV3>;
};

/**
 * RejectEntraProposedActionParamsV1
 */
export type RejectEntraProposedActionParamsV1 = {
  /**
   * Decision Note
   */
  decision_note?: string | null;
};

/**
 * ResolveEntraCallerParamsV1
 */
export type ResolveEntraCallerParamsV1 = {
  /**
   * Token
   */
  token: string;
};

/**
 * ResolveKbAccessRequestParamsV1
 */
export type ResolveKbAccessRequestParamsV1 = {
  resolution: KbAccessRequestResolutionV1;
};

/**
 * RoleV1
 */
export type RoleV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Scopes
   */
  scopes: Array<KbScopeV1>;
};

/**
 * RunningWorkflowRunV1
 */
export type RunningWorkflowRunV1 = {
  /**
   * Kind
   */
  kind: "RUNNING";
  /**
   * Started At
   */
  started_at: Date;
};

/**
 * SalesforceAccountPageV1
 */
export type SalesforceAccountPageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceAccountV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * SalesforceAccountV1
 */
export type SalesforceAccountV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
};

/**
 * SalesforceArticlePageV1
 */
export type SalesforceArticlePageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceArticleV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * SalesforceArticleStatusV1
 */
export const SalesforceArticleStatusV1 = {
  DRAFT: "draft",
  PUBLISHED: "published",
  ARCHIVED: "archived",
} as const;

/**
 * SalesforceArticleStatusV1
 */
export type SalesforceArticleStatusV1 =
  (typeof SalesforceArticleStatusV1)[keyof typeof SalesforceArticleStatusV1];

/**
 * SalesforceArticleV1
 */
export type SalesforceArticleV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Master Id
   */
  master_id: string;
  /**
   * Title
   */
  title: string;
  /**
   * Slug
   */
  slug: string;
  /**
   * Summary
   */
  summary: string;
  status: SalesforceArticleStatusV1;
};

/**
 * SalesforceCallbackPayloadV1
 */
export type SalesforceCallbackPayloadV1 = {
  /**
   * Code
   */
  code: string;
  /**
   * State
   */
  state: string;
};

/**
 * SalesforceCaseCommentV1
 */
export type SalesforceCaseCommentV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Kind
   */
  kind: "comment";
  /**
   * Body
   */
  body: string | null;
  /**
   * Author
   */
  author: string | null;
  /**
   * Is Published
   */
  is_published: boolean | null;
  /**
   * Created At
   */
  created_at: Date | null;
};

/**
 * SalesforceCaseEmailV1
 */
export type SalesforceCaseEmailV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Kind
   */
  kind: "email";
  /**
   * Body
   */
  body: string | null;
  /**
   * Author
   */
  author: string | null;
  /**
   * Subject
   */
  subject: string | null;
  /**
   * Is Inbound
   */
  is_inbound: boolean | null;
  /**
   * Created At
   */
  created_at: Date | null;
};

/**
 * SalesforceCaseMessagePageV1
 */
export type SalesforceCaseMessagePageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceCaseMessageV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

export type SalesforceCaseMessageV1 =
  | ({
      kind: "comment";
    } & SalesforceCaseCommentV1)
  | ({
      kind: "email";
    } & SalesforceCaseEmailV1);

/**
 * SalesforceCasePageV1
 */
export type SalesforceCasePageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceCaseV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * SalesforceCaseV1
 */
export type SalesforceCaseV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Case Number
   */
  case_number: string | null;
  /**
   * Subject
   */
  subject: string | null;
  /**
   * Description
   */
  description: string | null;
  /**
   * Status
   */
  status: string | null;
  /**
   * Priority
   */
  priority: string | null;
  /**
   * Origin
   */
  origin: string | null;
  /**
   * Type
   */
  type: string | null;
  /**
   * Reason
   */
  reason: string | null;
  /**
   * Is Escalated
   */
  is_escalated: boolean | null;
  /**
   * Is Closed
   */
  is_closed: boolean | null;
  /**
   * Parent Id
   */
  parent_id: string | null;
  /**
   * Record Type Id
   */
  record_type_id: string | null;
  /**
   * Owner Id
   */
  owner_id: string | null;
  /**
   * Contact Id
   */
  contact_id: string | null;
  /**
   * Account Id
   */
  account_id: string | null;
  /**
   * Owner Name
   */
  owner_name: string | null;
  /**
   * Account Name
   */
  account_name: string | null;
  /**
   * Contact Name
   */
  contact_name: string | null;
  /**
   * Contact Email
   */
  contact_email: string | null;
  /**
   * Created By Name
   */
  created_by_name: string | null;
  /**
   * Supplied Name
   */
  supplied_name: string | null;
  /**
   * Supplied Email
   */
  supplied_email: string | null;
  /**
   * Supplied Phone
   */
  supplied_phone: string | null;
  /**
   * Supplied Company
   */
  supplied_company: string | null;
  /**
   * Entitlement Id
   */
  entitlement_id: string | null;
  /**
   * Sla Started At
   */
  sla_started_at: Date | null;
  /**
   * Sla Exited At
   */
  sla_exited_at: Date | null;
  /**
   * Custom Fields
   */
  custom_fields: {
    [key: string]: JsonOutput;
  };
  /**
   * Closed At
   */
  closed_at: Date | null;
  /**
   * Created At
   */
  created_at: Date | null;
  /**
   * Updated At
   */
  updated_at: Date | null;
};

export type SalesforceCheckConnectionResponseV1 =
  | ({
      status: "connected";
    } & SalesforceConnectedV1)
  | ({
      status: "disconnected";
    } & SalesforceDisconnectedV1);

/**
 * SalesforceCheckReadyResponseV1
 */
export type SalesforceCheckReadyResponseV1 = {
  /**
   * Ready
   */
  ready: boolean;
};

/**
 * SalesforceConnectResponseV1
 */
export type SalesforceConnectResponseV1 = {
  /**
   * Authorization Url
   */
  authorization_url: string;
};

/**
 * SalesforceConnectedV1
 */
export type SalesforceConnectedV1 = {
  /**
   * Status
   */
  status: "connected";
  user: SalesforceUserInfoV1;
};

/**
 * SalesforceContactPageV1
 */
export type SalesforceContactPageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceContactV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * SalesforceContactV1
 */
export type SalesforceContactV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Email
   */
  email: string | null;
  /**
   * Phone
   */
  phone: string | null;
};

/**
 * SalesforceDefaultLanguageV1
 */
export type SalesforceDefaultLanguageV1 = {
  /**
   * Language
   */
  language: string;
};

/**
 * SalesforceDisconnectedV1
 */
export type SalesforceDisconnectedV1 = {
  /**
   * Status
   */
  status: "disconnected";
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * SalesforceEntitlementPageV1
 */
export type SalesforceEntitlementPageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceEntitlementV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * SalesforceEntitlementV1
 */
export type SalesforceEntitlementV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Start At
   */
  start_at: Date | null;
  /**
   * End At
   */
  end_at: Date | null;
};

/**
 * SalesforceIngestAckV1
 */
export type SalesforceIngestAckV1 = {
  /**
   * Accepted
   */
  accepted: boolean;
};

/**
 * SalesforceIngestClientCredentialsV1
 */
export type SalesforceIngestClientCredentialsV1 = {
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
  /**
   * Identity Provider Url
   */
  identity_provider_url: string;
  /**
   * Ingest Url
   */
  ingest_url: string;
};

/**
 * SalesforceIngestClientV1
 */
export type SalesforceIngestClientV1 = {
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Label
   */
  label: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * SalesforceOAuthRedirectUriV1
 */
export type SalesforceOAuthRedirectUriV1 = {
  /**
   * Redirect Uri
   */
  redirect_uri: string;
};

/**
 * SalesforceOAuthTokenResponseV1
 */
export type SalesforceOAuthTokenResponseV1 = {
  /**
   * Access Token
   */
  access_token: string;
  /**
   * Token Type
   */
  token_type: "Bearer";
  /**
   * Expires At
   */
  expires_at: Date;
};

/**
 * SalesforceQueuePageV1
 */
export type SalesforceQueuePageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceQueueV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * SalesforceQueueV1
 */
export type SalesforceQueueV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
};

/**
 * SalesforceRecordTypePageV1
 */
export type SalesforceRecordTypePageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceRecordTypeV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * SalesforceRecordTypeV1
 */
export type SalesforceRecordTypeV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Developer Name
   */
  developer_name: string;
};

/**
 * SalesforceTenantFullV1
 */
export type SalesforceTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Redirect Uri
   */
  redirect_uri: string;
  /**
   * Case Comment Created By Id
   */
  case_comment_created_by_id: string | null;
  /**
   * Client Id
   */
  client_id: string | null;
  /**
   * Has Credentials
   */
  has_credentials: boolean;
  /**
   * Has Tokens
   */
  has_tokens: boolean;
  ingest_client: SalesforceIngestClientV1 | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SalesforceTenantV1
 */
export type SalesforceTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * External Id
   */
  external_id: string;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Redirect Uri
   */
  redirect_uri: string;
  /**
   * Case Comment Created By Id
   */
  case_comment_created_by_id: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SalesforceUserInfoV1
 */
export type SalesforceUserInfoV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Email
   */
  email: string;
};

/**
 * SalesforceUserPageV1
 */
export type SalesforceUserPageV1 = {
  /**
   * Items
   */
  items: Array<SalesforceUserV1>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
  /**
   * Has More
   */
  has_more: boolean;
};

/**
 * SalesforceUserV1
 */
export type SalesforceUserV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Email
   */
  email: string | null;
  /**
   * Is Active
   */
  is_active: boolean;
};

export type SanitizedStr = string;

export type SanitizedStr09aF32 = string;

export type SanitizedStrRN = string;

export type SanitizedStrAZ09AZ09061AZ09 = string;

export type SanitizedStrAZAZ09079 = string;

export type SanitizedStrAZAZ09079AZAZ0907904 = string;

/**
 * SankeyChartContentV1
 */
export type SankeyChartContentV1 = {
  /**
   * Kind
   */
  kind: "SANKEY";
  /**
   * Links
   */
  links: Array<SankeyContentLinkV1>;
  /**
   * Show Node Counts
   */
  show_node_counts: boolean;
};

/**
 * SankeyContentLinkV1
 */
export type SankeyContentLinkV1 = {
  source: SanitizedStr;
  target: SanitizedStr;
  /**
   * Value
   */
  value: number;
};

/**
 * SearchDatapointEvidenceRequestV1
 */
export type SearchDatapointEvidenceRequestV1 = {
  query: SearchDatapointQueryV1;
};

/**
 * SearchDatapointEvidenceResponseV1
 */
export type SearchDatapointEvidenceResponseV1 = {
  /**
   * Results
   */
  results: Array<DatapointEvidenceV1>;
};

/**
 * SearchDatapointQueryV1
 */
export type SearchDatapointQueryV1 = {
  /**
   * Text
   */
  text: string;
  /**
   * K
   */
  k?: number;
  strategy?: SearchDatapointStrategyV1;
  /**
   * Task Id
   */
  task_id?: number | null;
  visibility?: VisibilityV1;
  /**
   * Datapoint Ids Any
   */
  datapoint_ids_any?: Array<number> | null;
  /**
   * Commit Ids Any
   */
  commit_ids_any?: Array<number> | null;
  /**
   * Kanonical Datapoint Ids Any
   */
  kanonical_datapoint_ids_any?: Array<number> | null;
};

/**
 * SearchDatapointStrategyV1
 */
export const SearchDatapointStrategyV1 = {
  KEYWORD: "keyword",
  EMBEDDING: "embedding",
  HYBRID: "hybrid",
} as const;

/**
 * SearchDatapointStrategyV1
 */
export type SearchDatapointStrategyV1 =
  (typeof SearchDatapointStrategyV1)[keyof typeof SearchDatapointStrategyV1];

/**
 * SearchDatapointsRequestV1
 */
export type SearchDatapointsRequestV1 = {
  query: SearchDatapointQueryV1;
};

/**
 * SearchDatapointsResponseV1
 */
export type SearchDatapointsResponseV1 = {
  /**
   * Results
   */
  results: Array<DatapointFullV3>;
};

/**
 * SearchEntityKindV1
 */
export const SearchEntityKindV1 = {
  ARTICLE_V1: "ARTICLE_V1",
  CHANGE_REQUEST_V1: "CHANGE_REQUEST_V1",
  KNOWLEDGE_BASE_V1: "KNOWLEDGE_BASE_V1",
} as const;

/**
 * SearchEntityKindV1
 */
export type SearchEntityKindV1 =
  (typeof SearchEntityKindV1)[keyof typeof SearchEntityKindV1];

/**
 * SearchFullEvaluatedInferenceDatapointsParamsV1
 */
export type SearchFullEvaluatedInferenceDatapointsParamsV1 = {
  search_by?: FullEvaluatedInferenceDatapointsSearchByV1 | null;
  /**
   * Task Id
   */
  task_id?: number | null;
  /**
   * Judgement Value Filters
   */
  judgement_value_filters?: Array<JudgementValueFilterV1> | null;
  /**
   * Created After
   */
  created_after?: Date | null;
  /**
   * Created Before
   */
  created_before?: Date | null;
  /**
   * Offset
   */
  offset?: number;
  limit?: LimitFilterV1;
  visibility?: VisibilityFilterV1;
};

/**
 * SearchReindexParamsV1
 */
export type SearchReindexParamsV1 = {
  /**
   * Repository Ids
   */
  repository_ids?: Array<number> | null;
  /**
   * Entity Kinds
   */
  entity_kinds?: Array<SearchEntityKindV1> | null;
};

/**
 * SearchReindexResultV1
 */
export type SearchReindexResultV1 = {
  /**
   * Published
   */
  published: number;
};

/**
 * SearchResultArticleV1
 */
export type SearchResultArticleV1 = {
  /**
   * Entity Kind
   */
  entity_kind?: "ARTICLE_V1";
  /**
   * Article Id
   */
  article_id: number;
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Score
   */
  score: number;
  content: ArticleSearchContentV1;
};

/**
 * SearchResultChangeRequestV1
 */
export type SearchResultChangeRequestV1 = {
  /**
   * Entity Kind
   */
  entity_kind?: "CHANGE_REQUEST_V1";
  /**
   * Change Request Id
   */
  change_request_id: number;
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Score
   */
  score: number;
  content: ChangeRequestSearchContentV1;
};

/**
 * SearchResultKnowledgeBaseV1
 */
export type SearchResultKnowledgeBaseV1 = {
  /**
   * Entity Kind
   */
  entity_kind?: "KNOWLEDGE_BASE_V1";
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Score
   */
  score: number;
  content: KnowledgeBaseSearchContentV1;
};

export type SearchResultV1 =
  | ({
      entity_kind: "ARTICLE_V1";
    } & SearchResultArticleV1)
  | ({
      entity_kind: "CHANGE_REQUEST_V1";
    } & SearchResultChangeRequestV1)
  | ({
      entity_kind: "KNOWLEDGE_BASE_V1";
    } & SearchResultKnowledgeBaseV1);

/**
 * SearchSnippetSpanV1
 */
export type SearchSnippetSpanV1 = {
  /**
   * Start Index
   */
  start_index: number;
  /**
   * End Index
   */
  end_index: number;
};

/**
 * SearchSnippetV1
 */
export type SearchSnippetV1 = {
  /**
   * Text
   */
  text: string;
  /**
   * Spans
   */
  spans: Array<SearchSnippetSpanV1>;
};

/**
 * SecretFullV1
 */
export type SecretFullV1 = {
  /**
   * Id
   */
  id: number;
  kind: SecretKindV1;
  /**
   * Name
   */
  name: string;
  /**
   * Description
   */
  description: string;
  /**
   * Versions
   */
  versions: Array<SecretVersionFullV1>;
  created_by_user: UserFullV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SecretKindV1
 */
export const SecretKindV1 = {
  GENERIC: "GENERIC",
  API_KEY: "API_KEY",
  OAUTH: "OAUTH",
} as const;

/**
 * SecretKindV1
 */
export type SecretKindV1 = (typeof SecretKindV1)[keyof typeof SecretKindV1];

/**
 * SecretV1
 */
export type SecretV1 = {
  /**
   * Id
   */
  id: number;
  kind: SecretKindV1;
  /**
   * Name
   */
  name: string;
  /**
   * Description
   */
  description: string;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SecretValueV1
 */
export type SecretValueV1 = {
  /**
   * Name
   */
  name: string;
  /**
   * Version
   */
  version: number;
  /**
   * Value
   */
  value: string;
};

/**
 * SecretValueV2
 */
export type SecretValueV2 = {
  /**
   * Name
   */
  name: string;
  /**
   * Version
   */
  version: number;
  /**
   * Value
   */
  value:
    | ({
        kind: "GENERIC";
      } & GenericSecretPlainValueV2)
    | ({
        kind: "API_KEY";
      } & ApiKeySecretPlainValueV2)
    | ({
        kind: "OAUTH";
      } & OauthSecretPlainValueV2);
};

/**
 * SecretVersionFullV1
 */
export type SecretVersionFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Secret Id
   */
  secret_id: number;
  /**
   * Version
   */
  version: number;
  /**
   * Description
   */
  description: string;
  created_by_user: UserFullV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SecretVersionV1
 */
export type SecretVersionV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Secret Id
   */
  secret_id: number;
  /**
   * Version
   */
  version: number;
  /**
   * Description
   */
  description: string;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SectionChangeReferenceLineV1
 */
export type SectionChangeReferenceLineV1 = {
  /**
   * Kind
   */
  kind: "SECTION_CHANGE";
  /**
   * Id
   */
  id: number;
  /**
   * Date
   */
  date: Date;
  title: SanitizedStr;
  /**
   * Evidence Count
   */
  evidence_count: number;
  /**
   * Lines Added
   */
  lines_added: number;
  /**
   * Lines Removed
   */
  lines_removed: number;
};

/**
 * SendAgentSessionMessageResponseV1
 */
export type SendAgentSessionMessageResponseV1 = {
  /**
   * Entry Id
   */
  entry_id: number;
};

/**
 * SendAgentSessionMessageSyncResponseV1
 */
export type SendAgentSessionMessageSyncResponseV1 = {
  /**
   * Entry Id
   */
  entry_id: number;
};

/**
 * SendAgentSessionMessageSyncV1
 */
export type SendAgentSessionMessageSyncV1 = {
  message: CreateAgentTraceMessageV1;
};

/**
 * SendAgentSessionMessageV1
 */
export type SendAgentSessionMessageV1 = {
  message: CreateAgentTraceMessageV1;
};

/**
 * SendSalesforceCaseEmailParamsV1
 */
export type SendSalesforceCaseEmailParamsV1 = {
  /**
   * To
   */
  to: Array<string>;
  /**
   * Subject
   */
  subject: string;
  /**
   * Body
   */
  body: string;
  /**
   * Cc
   */
  cc?: Array<string>;
  /**
   * Bcc
   */
  bcc?: Array<string>;
  /**
   * Sender Address
   */
  sender_address?: string | null;
  /**
   * Thread With Case
   */
  thread_with_case?: boolean;
};

/**
 * ServiceNowAddAttachmentRequestV1
 */
export type ServiceNowAddAttachmentRequestV1 = {
  ticket_type: ServiceNowTicketTypeV1;
  sys_id: SanitizedStr;
  file_name: SanitizedStr;
  content_base64: SanitizedStr;
  content_type?: SanitizedStr | null;
};

/**
 * ServiceNowAddAttachmentResponseV1
 */
export type ServiceNowAddAttachmentResponseV1 = {
  attachment_sys_id: SanitizedStr;
  file_name: SanitizedStr;
  /**
   * Size Bytes
   */
  size_bytes: number;
};

/**
 * ServiceNowAddRecordAttachmentRequestV1
 */
export type ServiceNowAddRecordAttachmentRequestV1 = {
  table: SanitizedStrAZAZ09079;
  id: SanitizedStr;
  file_name: SanitizedStr;
  content_base64: SanitizedStr;
  content_type?: SanitizedStr | null;
};

/**
 * ServiceNowAggregateGroupV1
 */
export type ServiceNowAggregateGroupV1 = {
  /**
   * Count
   */
  count: number;
  /**
   * Fields
   */
  fields: Array<ServiceNowRecordFieldV1>;
};

/**
 * ServiceNowAggregateRecordsV1
 */
export type ServiceNowAggregateRecordsV1 = {
  /**
   * ServiceNow table name to count over, for example incident or sc_req_item. Any table the integration account can read; a refused table returns the provider's status.
   */
  table: ServiceNowTableName;
  /**
   * Conditions and free-text keywords with the same grammar as the records search; order_by is ignored. Omit to count every record the account can see.
   */
  query?: ServiceNowQueryV1;
  /**
   * Group By
   *
   * Columns to group the count by, each dot-walked at most four levels. Empty gives a single total. Each group carries its columns as stored value plus display value, for example a state code with its label.
   */
  group_by?: Array<SanitizedStrAZAZ09079AZAZ0907904>;
};

/**
 * ServiceNowAggregateV1
 */
export type ServiceNowAggregateV1 = {
  /**
   * Total
   */
  total: number;
  /**
   * Groups
   */
  groups: Array<ServiceNowAggregateGroupV1>;
  /**
   * Groups Complete
   *
   * True when the group counts add up to total. False means ServiceNow capped the number of groups it returned, so groups is a partial list; narrow the query or group by a lower-cardinality column.
   */
  groups_complete: boolean;
};

/**
 * ServiceNowApprovalStateChoicesV1
 */
export type ServiceNowApprovalStateChoicesV1 = {
  /**
   * Choices
   */
  choices: Array<ServiceNowChoiceV1>;
};

/**
 * ServiceNowApprovalV1
 */
export type ServiceNowApprovalV1 = {
  sys_id: SanitizedStr;
  request_item: ServiceNowDisplayFieldV1;
  approver: ServiceNowDisplayFieldV1;
  group: ServiceNowDisplayFieldV1;
  state: ServiceNowDisplayFieldV1;
  comments: SanitizedStr;
  due_date: SanitizedStr;
  /**
   * Order
   */
  order: number | null;
  created_at: SanitizedStr;
  updated_at: SanitizedStr;
};

/**
 * ServiceNowAssignmentGroupByIdV1
 */
export type ServiceNowAssignmentGroupByIdV1 = {
  /**
   * Kind
   */
  kind: "id";
  id: SanitizedStr;
};

/**
 * ServiceNowAssignmentGroupByNameV1
 */
export type ServiceNowAssignmentGroupByNameV1 = {
  /**
   * Kind
   */
  kind: "name";
  name: SanitizedStr;
};

export type ServiceNowAssignmentGroupRefV1 =
  | ({
      kind: "id";
    } & ServiceNowAssignmentGroupByIdV1)
  | ({
      kind: "name";
    } & ServiceNowAssignmentGroupByNameV1);

/**
 * ServiceNowAttachTagRequestV1
 */
export type ServiceNowAttachTagRequestV1 = {
  tag_sys_id: SanitizedStr;
  record_table: SanitizedStr;
  record_sys_id: SanitizedStr;
};

/**
 * ServiceNowAttachTagResponseV1
 */
export type ServiceNowAttachTagResponseV1 = {
  /**
   * Status Code
   */
  status_code: number;
};

/**
 * ServiceNowAttachmentV1
 */
export type ServiceNowAttachmentV1 = {
  sys_id: SanitizedStr;
  file_name: SanitizedStr;
  content_type: SanitizedStr;
  /**
   * Size Bytes
   */
  size_bytes: number;
  created_at: SanitizedStr;
  download_url: SanitizedStr;
};

/**
 * ServiceNowAuthKindV1
 */
export const ServiceNowAuthKindV1 = { BASIC: "BASIC", OAUTH: "OAUTH" } as const;

/**
 * ServiceNowAuthKindV1
 */
export type ServiceNowAuthKindV1 =
  (typeof ServiceNowAuthKindV1)[keyof typeof ServiceNowAuthKindV1];

/**
 * ServiceNowBatchCreateV1
 */
export type ServiceNowBatchCreateV1 = {
  /**
   * Kind
   */
  kind: "create";
  id: SanitizedStr;
  table: SanitizedStrAZAZ09079;
  /**
   * Fields
   */
  fields: Array<ServiceNowRecordFieldInputV1>;
  /**
   * Input Display Values
   */
  input_display_values?: boolean;
};

/**
 * ServiceNowBatchItemResultV1
 */
export type ServiceNowBatchItemResultV1 = {
  id: SanitizedStr;
  /**
   * Status Code
   */
  status_code: number;
  /**
   * Records
   */
  records: Array<ServiceNowRecordV1>;
  error?: SanitizedStr | null;
};

export type ServiceNowBatchItemV1 =
  | ({
      kind: "read";
    } & ServiceNowBatchReadV1)
  | ({
      kind: "create";
    } & ServiceNowBatchCreateV1)
  | ({
      kind: "update";
    } & ServiceNowBatchUpdateV1);

/**
 * ServiceNowBatchReadV1
 */
export type ServiceNowBatchReadV1 = {
  /**
   * Kind
   */
  kind: "read";
  id: SanitizedStr;
  table: SanitizedStrAZAZ09079;
  query?: ServiceNowQueryV1;
  /**
   * Fields
   */
  fields?: Array<SanitizedStrAZAZ09079AZAZ0907904> | null;
  /**
   * Offset
   */
  offset?: number;
  /**
   * Limit
   */
  limit?: number;
};

/**
 * ServiceNowBatchRequestV1
 */
export type ServiceNowBatchRequestV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowBatchItemV1>;
};

/**
 * ServiceNowBatchResultV1
 */
export type ServiceNowBatchResultV1 = {
  /**
   * Items
   */
  items: Array<ServiceNowBatchItemResultV1>;
};

/**
 * ServiceNowBatchUpdateV1
 */
export type ServiceNowBatchUpdateV1 = {
  /**
   * Kind
   */
  kind: "update";
  id: SanitizedStr;
  table: SanitizedStrAZAZ09079;
  record_id: SanitizedStr;
  /**
   * Fields
   */
  fields: Array<ServiceNowRecordFieldInputV1>;
  /**
   * Input Display Values
   */
  input_display_values?: boolean;
};

/**
 * The integration account's cart, as the cart_id get-cart returns.
 */
export type ServiceNowCartIdV1Input = SanitizedStr09aF32;

/**
 * The integration account's cart, as the cart_id get-cart returns.
 */
export type ServiceNowCartIdV1Output = string;

/**
 * ServiceNowCartItemV1
 */
export type ServiceNowCartItemV1 = {
  cart_item_id: SanitizedStr;
  catalog_item_sys_id: SanitizedStr;
  name: SanitizedStr;
  /**
   * Quantity
   */
  quantity: number;
  order_guide_sys_id: SanitizedStr | null;
  /**
   * Variables
   */
  variables: Array<ServiceNowCartItemVariableV1>;
};

/**
 * ServiceNowCartItemVariableV1
 */
export type ServiceNowCartItemVariableV1 = {
  name: SanitizedStr;
  value: SanitizedStr | null;
};

/**
 * ServiceNowCartV1
 */
export type ServiceNowCartV1 = {
  cart_id: ServiceNowCartIdV1Output;
  /**
   * Items
   */
  items: Array<ServiceNowCartItemV1>;
};

/**
 * ServiceNowCatalogItemFullV1
 */
export type ServiceNowCatalogItemFullV1 = {
  sys_id: SanitizedStr;
  name: SanitizedStr;
  short_description: SanitizedStr | null;
  description: SanitizedStr;
  category: ServiceNowDisplayFieldV1 | null;
  /**
   * Active
   */
  active: boolean;
  /**
   * Variables
   */
  variables: Array<ServiceNowCatalogItemVariableV1>;
  sys_class_name?: SanitizedStr | null;
  table_name?: SanitizedStr | null;
  picture_url?: SanitizedStr | null;
};

/**
 * Caller-chosen 32-character lower-case hex id for one catalog item being ordered, the id Employee Center generates for its cart item. Files for the item are staged under it and the order names it again.
 */
export type ServiceNowCatalogItemGuidV1 = SanitizedStr09aF32;

/**
 * ServiceNowCatalogItemV1
 */
export type ServiceNowCatalogItemV1 = {
  sys_id: SanitizedStr;
  name: SanitizedStr;
  short_description: SanitizedStr | null;
  sys_class_name?: SanitizedStr | null;
  table_name?: SanitizedStr | null;
  picture_url?: SanitizedStr | null;
};

/**
 * ServiceNowCatalogItemVariableChoiceV1
 */
export type ServiceNowCatalogItemVariableChoiceV1 = {
  value: SanitizedStr;
  label: SanitizedStr;
  /**
   * Index
   */
  index: number | null;
};

/**
 * ServiceNowCatalogItemVariableV1
 */
export type ServiceNowCatalogItemVariableV1 = {
  id: SanitizedStr;
  name: SanitizedStr;
  label: SanitizedStr;
  type: ServiceNowVariableType | null;
  order: ServiceNowVariableOrder | null;
  /**
   * Mandatory
   */
  mandatory: boolean;
  /**
   * Choices
   */
  choices: Array<ServiceNowCatalogItemVariableChoiceV1> | null;
  friendly_type?: SanitizedStr | null;
  display_type?: SanitizedStr | null;
  variable_set?: ServiceNowDisplayFieldV1 | null;
  reference_qualifier?: SanitizedStr | null;
  reference_table?: SanitizedStr | null;
  list_table?: SanitizedStr | null;
  lookup_table?: SanitizedStr | null;
  attributes?: SanitizedStr | null;
  default_value?: SanitizedStr | null;
  /**
   * Read Only
   */
  read_only?: boolean;
};

/**
 * ServiceNowCatalogLookupConfigurationChangedV1
 */
export type ServiceNowCatalogLookupConfigurationChangedV1 = {
  /**
   * Kind
   */
  kind: "configuration_changed";
  message: SanitizedStr;
};

export type ServiceNowCatalogSysIdV1Input = SanitizedStr09aF32;

export type ServiceNowCatalogSysIdV1Output = string;

export const ServiceNowCatalogValueMatchV1 = {
  CONTAINS: "contains",
  EXACT_VALUE: "exact_value",
} as const;

export type ServiceNowCatalogValueMatchV1 =
  (typeof ServiceNowCatalogValueMatchV1)[keyof typeof ServiceNowCatalogValueMatchV1];

/**
 * ServiceNowCatalogVariableLookupMetadataV1
 */
export type ServiceNowCatalogVariableLookupMetadataV1 = {
  value_field: SanitizedStr;
  /**
   * Search Fields
   */
  search_fields: Array<SanitizedStr>;
  configuration_fingerprint: SanitizedStr;
  /**
   * Dependencies
   */
  dependencies?: Array<SanitizedStr>;
};

/**
 * ServiceNowCatalogVariableValueV1
 */
export type ServiceNowCatalogVariableValueV1 = {
  value: SanitizedStr;
  label: SanitizedStr;
  /**
   * Columns
   */
  columns: {
    [key in SanitizedStr]?: SanitizedStr;
  };
};

/**
 * ServiceNowCatalogVariableValuesConflictV1
 */
export type ServiceNowCatalogVariableValuesConflictV1 = {
  /**
   * Detail
   */
  detail: ServiceNowCatalogLookupConfigurationChangedV1 | SanitizedStr;
};

/**
 * ServiceNowChangeApprovalStateRequestV1
 */
export type ServiceNowChangeApprovalStateRequestV1 = {
  approval_sys_id: SanitizedStr;
  state: SanitizedStr;
};

/**
 * ServiceNowChangeApprovalStateResponseV1
 */
export type ServiceNowChangeApprovalStateResponseV1 = {
  /**
   * Status Code
   */
  status_code: number;
};

/**
 * ServiceNowChangeAssignmentGroupRequestV1
 */
export type ServiceNowChangeAssignmentGroupRequestV1 = {
  /**
   * Tenant Id
   */
  tenant_id: number;
  ticket_type: ServiceNowTicketTypeV1;
  sys_id: SanitizedStr;
  assignment_group: ServiceNowAssignmentGroupRefV1;
};

/**
 * ServiceNowChangeAssignmentGroupResponseV1
 */
export type ServiceNowChangeAssignmentGroupResponseV1 = {
  /**
   * Status Code
   */
  status_code: number;
};

/**
 * ServiceNowChangeIncidentStateRequestV1
 */
export type ServiceNowChangeIncidentStateRequestV1 = {
  /**
   * Tenant Id
   */
  tenant_id: number;
  sys_id: SanitizedStr;
  state: ServiceNowStateRefV1;
};

/**
 * ServiceNowChangeIncidentStateResponseV1
 */
export type ServiceNowChangeIncidentStateResponseV1 = {
  /**
   * Status Code
   */
  status_code: number;
};

/**
 * ServiceNowChangeRequestItemStateRequestV2
 */
export type ServiceNowChangeRequestItemStateRequestV2 = {
  request_item_sys_id: SanitizedStr;
  state: ServiceNowStateRefV1;
};

/**
 * ServiceNowChangeRequestItemStateResponseV2
 */
export type ServiceNowChangeRequestItemStateResponseV2 = {
  /**
   * Status Code
   */
  status_code: number;
};

/**
 * ServiceNowChangeRequestStateRequestV2
 */
export type ServiceNowChangeRequestStateRequestV2 = {
  sys_id: SanitizedStr;
  state: ServiceNowStateRefV1;
};

/**
 * ServiceNowChangeRequestStateResponseV2
 */
export type ServiceNowChangeRequestStateResponseV2 = {
  /**
   * Status Code
   */
  status_code: number;
};

/**
 * ServiceNowChangeTaskStateRequestV2
 */
export type ServiceNowChangeTaskStateRequestV2 = {
  task_sys_id: SanitizedStr;
  state: ServiceNowStateRefV1;
};

/**
 * ServiceNowChangeTaskStateResponseV2
 */
export type ServiceNowChangeTaskStateResponseV2 = {
  /**
   * Status Code
   */
  status_code: number;
};

/**
 * ServiceNowCheckoutOrderGuideForeignCartItemsV1
 */
export type ServiceNowCheckoutOrderGuideForeignCartItemsV1 = {
  /**
   * Kind
   */
  kind: "foreign_cart_items";
  cart: ServiceNowCartV1;
};

/**
 * ServiceNowCheckoutOrderGuideItemV1
 */
export type ServiceNowCheckoutOrderGuideItemV1 = {
  /**
   * The selected item's catalog item id, as evaluate-order-guide returned it.
   */
  catalog_item_sys_id: ServiceNowCatalogSysIdV1Input;
  /**
   * Quantity
   *
   * How many of this item to order; 1 when omitted.
   */
  quantity?: number;
  /**
   * Variables
   *
   * This item's answers keyed by variable name, not label or id, with choice values rather than display text. The names are the item variables evaluate-order-guide returned for this item. Omitted means no answers.
   */
  variables?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
};

/**
 * ServiceNowCheckoutOrderGuideRequestCreatedV1
 */
export type ServiceNowCheckoutOrderGuideRequestCreatedV1 = {
  /**
   * Kind
   */
  kind: "request_created";
  request_sys_id: SanitizedStr;
  request_number: SanitizedStr;
  /**
   * The new request's requested_for read back straight after creation, or why that read failed. Asynchronous instance rules may still change requested_for afterwards, so read the request again before relying on it.
   */
  requested_for: ServiceNowRequestedForReadbackV1;
};

export type ServiceNowCheckoutOrderGuideResultV1 =
  | ({
      kind: "request_created";
    } & ServiceNowCheckoutOrderGuideRequestCreatedV1)
  | ({
      kind: "selection_changed";
    } & ServiceNowCheckoutOrderGuideSelectionChangedV1)
  | ({
      kind: "foreign_cart_items";
    } & ServiceNowCheckoutOrderGuideForeignCartItemsV1)
  | ({
      kind: "uncertain";
    } & ServiceNowCheckoutOrderGuideUncertainV1);

/**
 * ServiceNowCheckoutOrderGuideSelectionChangedV1
 */
export type ServiceNowCheckoutOrderGuideSelectionChangedV1 = {
  /**
   * Kind
   */
  kind: "selection_changed";
  /**
   * Items
   */
  items: Array<ServiceNowOrderGuideItemV1>;
};

/**
 * ServiceNowCheckoutOrderGuideUncertainV1
 */
export type ServiceNowCheckoutOrderGuideUncertainV1 = {
  /**
   * Kind
   */
  kind: "uncertain";
  reason: SanitizedStr;
};

/**
 * ServiceNowCheckoutOrderGuideV1
 */
export type ServiceNowCheckoutOrderGuideV1 = {
  /**
   * The order guide evaluated with evaluate-order-guide.
   */
  order_guide_sys_id: ServiceNowCatalogSysIdV1Input;
  /**
   * Guide Variables
   *
   * The guide's own answers, as sent to evaluate-order-guide. The checkout evaluates the guide again with them and proceeds only if ServiceNow still selects exactly the items listed.
   */
  guide_variables?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Items
   *
   * Every selected item with its quantity and variable answers.
   */
  items: Array<ServiceNowCheckoutOrderGuideItemV1>;
  /**
   * sys_user the request is for. Written to the integration account's cart before every checkout, since the cart keeps the previous requester's value otherwise; ServiceNow copies it to the new request. The guide endpoints refuse a different recipient per item, so set the recipient on each item's own requested-for variable too.
   */
  requested_for_sys_id: ServiceNowCatalogSysIdV1Input;
};

/**
 * ServiceNowChoiceV1
 */
export type ServiceNowChoiceV1 = {
  value: SanitizedStr;
  label: SanitizedStr;
};

export type ServiceNowColumnName = SanitizedStrAZAZ09079AZAZ0907904;

/**
 * ServiceNowCommentFetchStrategyV1
 */
export const ServiceNowCommentFetchStrategyV1 = {
  JOURNAL_FIELD: "JOURNAL_FIELD",
  DISPLAY_VALUE: "DISPLAY_VALUE",
} as const;

/**
 * ServiceNowCommentFetchStrategyV1
 */
export type ServiceNowCommentFetchStrategyV1 =
  (typeof ServiceNowCommentFetchStrategyV1)[keyof typeof ServiceNowCommentFetchStrategyV1];

/**
 * ServiceNowCommentTypeV1
 */
export const ServiceNowCommentTypeV1 = {
  WORK_NOTE: "work_note",
  COMMENT: "comment",
} as const;

/**
 * ServiceNowCommentTypeV1
 */
export type ServiceNowCommentTypeV1 =
  (typeof ServiceNowCommentTypeV1)[keyof typeof ServiceNowCommentTypeV1];

/**
 * ServiceNowCommentV1
 */
export type ServiceNowCommentV1 = {
  type: ServiceNowCommentTypeV1;
  value: SanitizedStr;
  created_on: SanitizedStr;
  created_by: SanitizedStr;
};

export type ServiceNowCreateAuthV1 =
  | ({
      kind: "basic";
    } & ServiceNowCreateBasicAuthV1)
  | ({
      kind: "oauth";
    } & ServiceNowCreateOAuthV1);

/**
 * ServiceNowCreateBasicAuthV1
 */
export type ServiceNowCreateBasicAuthV1 = {
  /**
   * Kind
   */
  kind: "basic";
  username: SanitizedStr;
  password: SanitizedStr;
};

/**
 * ServiceNowCreateCatalogRequestResultV1
 */
export type ServiceNowCreateCatalogRequestResultV1 = {
  request_sys_id: SanitizedStr;
  request_number: SanitizedStr;
  request_item_sys_id: SanitizedStr;
  request_item_number: SanitizedStr;
};

/**
 * ServiceNowCreateCatalogRequestV1
 */
export type ServiceNowCreateCatalogRequestV1 = {
  catalog_item_sys_id: SanitizedStr;
  requested_for_sys_id: SanitizedStr;
  /**
   * Variables
   */
  variables?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Sysparm Quantity
   */
  sysparm_quantity?: number;
  /**
   * Sysparm No Validation
   *
   * Skip the provider static mandatory-variable precheck. Enable only after the caller has evaluated and validated all applicable form requirements. Provider support is instance-dependent.
   */
  sysparm_no_validation?: boolean;
  /**
   * The item_guid the order's attachment-variable files were staged under with stage-catalog-attachment. Forwarded to order_now as sysparm_item_guid so ServiceNow can associate the staged files with the new request item. Omit when the order carries no staged file.
   */
  item_guid?: ServiceNowCatalogItemGuidV1 | null;
  /**
   * Tag Sys Ids
   */
  tag_sys_ids?: Array<SanitizedStr>;
};

/**
 * ServiceNowCreateChangeTaskV1
 */
export type ServiceNowCreateChangeTaskV1 = {
  /**
   * Fields
   */
  fields: Array<ServiceNowRecordFieldInputV1>;
};

export type ServiceNowCreateChangeV1 =
  | ({
      kind: "standard";
    } & ServiceNowStandardChangeV1)
  | ({
      kind: "normal";
    } & ServiceNowNormalChangeV1)
  | ({
      kind: "emergency";
    } & ServiceNowEmergencyChangeV1);

/**
 * ServiceNowCreateIncidentResultV1
 */
export type ServiceNowCreateIncidentResultV1 = {
  sys_id: SanitizedStr;
  number: SanitizedStr;
  assignment_group: ServiceNowDisplayFieldV1;
  category: SanitizedStr;
  subcategory: SanitizedStr;
  cmdb_ci: ServiceNowDisplayFieldV1;
  business_service: ServiceNowDisplayFieldV1;
  state: ServiceNowDisplayFieldV1;
  caller_id: ServiceNowDisplayFieldV1;
  contact_type: SanitizedStr;
  origin: ServiceNowCreatedIncidentOriginV1;
  /**
   * Watch List
   */
  watch_list: Array<ServiceNowDisplayFieldV1>;
};

/**
 * ServiceNowCreateIncidentV1
 */
export type ServiceNowCreateIncidentV1 = {
  short_description: NonEmptyStr;
  description: NonEmptyStr;
  caller_id?: NonEmptyStr | null;
  contact_type?: NonEmptyStr | null;
  assignment_group?: NonEmptyStr | null;
  category?: NonEmptyStr | null;
  subcategory?: NonEmptyStr | null;
  cmdb_ci?: NonEmptyStr | null;
  business_service?: NonEmptyStr | null;
  urgency?: ServiceNowUrgencyV1 | null;
  impact?: ServiceNowImpactV1 | null;
  origin?: ServiceNowIncidentOriginV1 | null;
  /**
   * Watch List
   */
  watch_list?: Array<NonEmptyStr> | null;
};

/**
 * ServiceNowCreateOAuthV1
 */
export type ServiceNowCreateOAuthV1 = {
  /**
   * Kind
   */
  kind: "oauth";
  client_id: SanitizedStr;
  client_secret: SanitizedStr;
};

/**
 * ServiceNowCreateRecordV1
 */
export type ServiceNowCreateRecordV1 = {
  table: SanitizedStrAZAZ09079;
  /**
   * Fields
   */
  fields: Array<ServiceNowRecordFieldInputV1>;
  /**
   * Input Display Values
   */
  input_display_values?: boolean;
};

/**
 * ServiceNowCreateTagV1
 */
export type ServiceNowCreateTagV1 = {
  name: SanitizedStr;
  color?: SanitizedStr | null;
  description?: SanitizedStr | null;
};

/**
 * ServiceNowCreateTenantV1
 */
export type ServiceNowCreateTenantV1 = {
  instance_name: SanitizedStr;
  service_now_instance_url: SanitizedStr;
  auth: ServiceNowCreateAuthV1;
};

/**
 * ServiceNowCreatedIncidentOriginV1
 */
export type ServiceNowCreatedIncidentOriginV1 = {
  table: SanitizedStr;
  id: ServiceNowDisplayFieldV1;
};

/**
 * ServiceNowDeleteStagedCatalogAttachmentRequestV1
 */
export type ServiceNowDeleteStagedCatalogAttachmentRequestV1 = {
  attachment_sys_id: SanitizedStr09aF32;
  item_guid: ServiceNowCatalogItemGuidV1;
};

/**
 * ServiceNowDisplayFieldV1
 */
export type ServiceNowDisplayFieldV1 = {
  value: SanitizedStr;
  display: SanitizedStr;
};

/**
 * ServiceNowEmergencyChangeV1
 */
export type ServiceNowEmergencyChangeV1 = {
  /**
   * Kind
   */
  kind: "emergency";
  /**
   * Fields
   */
  fields?: Array<ServiceNowRecordFieldInputV1>;
};

/**
 * ServiceNowEmptyCartRequestV1
 */
export type ServiceNowEmptyCartRequestV1 = {
  cart_id: ServiceNowCartIdV1Input;
};

/**
 * ServiceNowEvaluateOrderGuideForeignCartItemsV1
 */
export type ServiceNowEvaluateOrderGuideForeignCartItemsV1 = {
  /**
   * Kind
   */
  kind: "foreign_cart_items";
  cart: ServiceNowCartV1;
};

export type ServiceNowEvaluateOrderGuideResultV1 =
  | ({
      kind: "selected";
    } & ServiceNowEvaluateOrderGuideSelectedV1)
  | ({
      kind: "foreign_cart_items";
    } & ServiceNowEvaluateOrderGuideForeignCartItemsV1);

/**
 * ServiceNowEvaluateOrderGuideSelectedV1
 */
export type ServiceNowEvaluateOrderGuideSelectedV1 = {
  /**
   * Kind
   */
  kind: "selected";
  /**
   * Items
   */
  items: Array<ServiceNowOrderGuideItemV1>;
};

/**
 * ServiceNowEvaluateOrderGuideV1
 */
export type ServiceNowEvaluateOrderGuideV1 = {
  /**
   * The order guide's catalog item id (sc_cat_item_guide), as get-catalog-item or a catalog search returns it.
   */
  order_guide_sys_id: ServiceNowCatalogSysIdV1Input;
  /**
   * Variables
   *
   * The guide's own answers keyed by variable name, not label or id, with choice values rather than display text. The names are the order guide's variables as get-catalog-item returns them. Omitted means no answers.
   */
  variables?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
};

/**
 * ServiceNowFormVariableResolutionStatusV1
 */
export const ServiceNowFormVariableResolutionStatusV1 = {
  OK: "OK",
  NOT_APPLICABLE: "NOT_APPLICABLE",
  DEFINITION_MISSING: "DEFINITION_MISSING",
  REFERENCE_MISSING: "REFERENCE_MISSING",
} as const;

/**
 * ServiceNowFormVariableResolutionStatusV1
 */
export type ServiceNowFormVariableResolutionStatusV1 =
  (typeof ServiceNowFormVariableResolutionStatusV1)[keyof typeof ServiceNowFormVariableResolutionStatusV1];

/**
 * ServiceNowFormVariableV1
 */
export type ServiceNowFormVariableV1 = {
  name: SanitizedStr | null;
  label: SanitizedStr | null;
  type: SanitizedStr | null;
  /**
   * Order
   */
  order: number | null;
  raw_value: SanitizedStr | null;
  display_value: SanitizedStr | null;
  reference_table: SanitizedStr | null;
  list_table?: SanitizedStr | null;
  lookup_table?: SanitizedStr | null;
  resolution_status: ServiceNowFormVariableResolutionStatusV1;
};

/**
 * ServiceNowGetAttachmentContentResponseV1
 */
export type ServiceNowGetAttachmentContentResponseV1 = {
  attachment_sys_id: NonEmptyStr;
  file_name: SanitizedStr;
  content_type: SanitizedStr;
  /**
   * Size Bytes
   */
  size_bytes: number;
  content_base64: SanitizedStr;
};

/**
 * ServiceNowImpactV1
 */
export const ServiceNowImpactV1 = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
} as const;

/**
 * ServiceNowImpactV1
 */
export type ServiceNowImpactV1 =
  (typeof ServiceNowImpactV1)[keyof typeof ServiceNowImpactV1];

/**
 * ServiceNowIncidentOriginV1
 */
export type ServiceNowIncidentOriginV1 = {
  table: NonEmptyStr;
  id: NonEmptyStr;
};

/**
 * ServiceNowIncidentStateChoicesV1
 */
export type ServiceNowIncidentStateChoicesV1 = {
  /**
   * Choices
   */
  choices: Array<ServiceNowChoiceV1>;
};

/**
 * ServiceNowIncidentV1
 */
export type ServiceNowIncidentV1 = {
  /**
   * Kind
   */
  kind: "incident";
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  description: SanitizedStr;
  state: ServiceNowDisplayFieldV1;
  priority: ServiceNowDisplayFieldV1;
  urgency: ServiceNowDisplayFieldV1;
  impact: ServiceNowDisplayFieldV1;
  category: SanitizedStr;
  subcategory: SanitizedStr;
  cmdb_ci: ServiceNowDisplayFieldV1;
  business_service: ServiceNowDisplayFieldV1;
  assignment_group: ServiceNowDisplayFieldV1;
  assigned_to: ServiceNowDisplayFieldV1;
  opened_by: ServiceNowDisplayFieldV1;
  caller_id: ServiceNowDisplayFieldV1;
  contact_type: SanitizedStr;
  approval: ServiceNowDisplayFieldV1;
  resolved_by: ServiceNowDisplayFieldV1;
  resolved_at: SanitizedStr;
  closed_by: ServiceNowDisplayFieldV1;
  closed_at: SanitizedStr;
  close_code: SanitizedStr;
  close_notes: SanitizedStr;
  /**
   * @deprecated
   */
  sys_created_on: SanitizedStr;
  /**
   * @deprecated
   */
  sys_updated_on: SanitizedStr;
  created_at: SanitizedStr;
  updated_at: SanitizedStr;
  /**
   * Comments
   */
  comments: Array<ServiceNowCommentV1>;
};

/**
 * ServiceNowKbArticleFullV1
 */
export type ServiceNowKbArticleFullV1 = {
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  text: SanitizedStr;
  workflow_state: SanitizedStr;
  version: SanitizedStr;
  knowledge_base_sys_id: SanitizedStr;
};

/**
 * ServiceNowKbArticleV1
 */
export type ServiceNowKbArticleV1 = {
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  workflow_state: SanitizedStr;
  version: SanitizedStr;
  knowledge_base_sys_id: SanitizedStr;
};

/**
 * ServiceNowKbKnowledgeBaseV1
 */
export type ServiceNowKbKnowledgeBaseV1 = {
  sys_id: SanitizedStr;
  /**
   * Sys Created On
   */
  sys_created_on: Date;
  sys_created_by: SanitizedStr;
  title: SanitizedStr;
  description: SanitizedStr;
  /**
   * Active
   */
  active: boolean;
};

/**
 * ServiceNowNormalChangeV1
 */
export type ServiceNowNormalChangeV1 = {
  /**
   * Kind
   */
  kind: "normal";
  /**
   * Fields
   */
  fields?: Array<ServiceNowRecordFieldInputV1>;
};

/**
 * ServiceNowOrderGuideItemV1
 */
export type ServiceNowOrderGuideItemV1 = {
  catalog_item_sys_id: ServiceNowCatalogSysIdV1Output;
  name: SanitizedStr;
  /**
   * Quantity
   */
  quantity: number;
  /**
   * Variables
   */
  variables: Array<ServiceNowOrderGuideItemVariableV1>;
};

/**
 * ServiceNowOrderGuideItemVariableV1
 */
export type ServiceNowOrderGuideItemVariableV1 = {
  name: SanitizedStr;
  label: SanitizedStr | null;
  value: SanitizedStr | null;
  display_value: SanitizedStr | null;
  /**
   * Mandatory
   */
  mandatory: boolean | null;
};

/**
 * ServiceNowQueryConditionV1
 */
export type ServiceNowQueryConditionV1 = {
  /**
   * Column to test, dot-walked at most four levels (manager.email).
   */
  field: ServiceNowColumnName;
  /**
   * Comparison. contains and not_contains match a substring; starts_with and ends_with match a prefix or suffix; in and not_in take a comma-separated list; between takes two values joined by @; same_as, not_same_as and the *_field operators compare against another column named in value; relative_* take a ServiceNow relative-time value such as 5@dayofweek@ago; instance_of tests a record's class. is_empty, is_not_empty, anything and empty_string take no value.
   */
  operator: ServiceNowQueryOperatorV1;
  /**
   * Value as ServiceNow stores it: a sys_id for a reference, a code for a choice, YYYY-MM-DD HH:MM:SS for a date-time. Cannot contain ^; values starting with javascript: are rejected.
   */
  value?: ServiceNowQueryValue;
  /**
   * How this condition attaches to the ones before it. and narrows the result; or widens the condition immediately before it, so a, b, or-c reads a AND (b OR c); new_query starts an independent alternative whose matches are added to the result. The first condition must use and.
   */
  join?: ServiceNowQueryJoinV1;
};

/**
 * ServiceNowQueryJoinV1
 */
export const ServiceNowQueryJoinV1 = {
  AND: "and",
  OR: "or",
  NEW_QUERY: "new_query",
} as const;

/**
 * ServiceNowQueryJoinV1
 */
export type ServiceNowQueryJoinV1 =
  (typeof ServiceNowQueryJoinV1)[keyof typeof ServiceNowQueryJoinV1];

/**
 * ServiceNowQueryOperatorV1
 */
export const ServiceNowQueryOperatorV1 = {
  EQUALS: "equals",
  NOT_EQUALS: "not_equals",
  IN: "in",
  NOT_IN: "not_in",
  CONTAINS: "contains",
  NOT_CONTAINS: "not_contains",
  STARTS_WITH: "starts_with",
  ENDS_WITH: "ends_with",
  IS_EMPTY: "is_empty",
  IS_NOT_EMPTY: "is_not_empty",
  GREATER_THAN: "greater_than",
  GREATER_OR_EQUAL: "greater_or_equal",
  LESS_THAN: "less_than",
  LESS_OR_EQUAL: "less_or_equal",
  BETWEEN: "between",
  SAME_AS: "same_as",
  NOT_SAME_AS: "not_same_as",
  ANYTHING: "anything",
  EMPTY_STRING: "empty_string",
  ON: "on",
  NOT_ON: "not_on",
  RELATIVE_GREATER_THAN: "relative_greater_than",
  RELATIVE_LESS_THAN: "relative_less_than",
  RELATIVE_GREATER_OR_EQUAL: "relative_greater_or_equal",
  RELATIVE_LESS_OR_EQUAL: "relative_less_or_equal",
  RELATIVE_EQUALS: "relative_equals",
  GREATER_THAN_FIELD: "greater_than_field",
  LESS_THAN_FIELD: "less_than_field",
  GREATER_OR_EQUAL_FIELD: "greater_or_equal_field",
  LESS_OR_EQUAL_FIELD: "less_or_equal_field",
  INSTANCE_OF: "instance_of",
} as const;

/**
 * ServiceNowQueryOperatorV1
 */
export type ServiceNowQueryOperatorV1 =
  (typeof ServiceNowQueryOperatorV1)[keyof typeof ServiceNowQueryOperatorV1];

/**
 * ServiceNowQueryOrderV1
 */
export type ServiceNowQueryOrderV1 = {
  field: SanitizedStrAZAZ09079AZAZ0907904;
  /**
   * Descending
   */
  descending?: boolean;
};

/**
 * ServiceNowQueryV1
 */
export type ServiceNowQueryV1 = {
  /**
   * Free-text search over the table's text-indexed columns, applied together with the conditions.
   */
  keywords?: SanitizedStrRN | null;
  /**
   * Conditions
   *
   * Conditions in order, joined as each one's join says. An empty list matches every record the integration account can see.
   */
  conditions?: Array<ServiceNowQueryConditionV1>;
  /**
   * Order By
   *
   * Sort order, first entry outermost. Empty sorts by sys_id so pages are stable.
   */
  order_by?: Array<ServiceNowQueryOrderV1>;
};

export type ServiceNowQueryValue = SanitizedStrRN;

/**
 * ServiceNowRecordFieldInputV1
 */
export type ServiceNowRecordFieldInputV1 = {
  name: SanitizedStrAZAZ09079AZAZ0907904;
  value: SanitizedStr;
};

/**
 * ServiceNowRecordFieldV1
 */
export type ServiceNowRecordFieldV1 = {
  name: SanitizedStr;
  value: SanitizedStr;
  display: SanitizedStr;
};

/**
 * ServiceNowRecordV1
 */
export type ServiceNowRecordV1 = {
  id: SanitizedStr;
  /**
   * Fields
   */
  fields: Array<ServiceNowRecordFieldV1>;
};

/**
 * ServiceNowReplyRequestV1
 */
export type ServiceNowReplyRequestV1 = {
  /**
   * Tenant Id
   */
  tenant_id: number;
  ticket_type: ServiceNowTicketTypeV1;
  sys_id: SanitizedStr;
  body: SanitizedStr;
  visibility: ServiceNowVisibilityV1;
};

/**
 * ServiceNowReplyResponseV1
 */
export type ServiceNowReplyResponseV1 = {
  /**
   * Status Code
   */
  status_code: number;
};

/**
 * ServiceNowReplyTenantNestedRequestV1
 */
export type ServiceNowReplyTenantNestedRequestV1 = {
  ticket_type: ServiceNowTicketTypeV1;
  sys_id: SanitizedStr;
  body: SanitizedStr;
  visibility: ServiceNowVisibilityV1;
};

/**
 * ServiceNowRequestFullV1
 */
export type ServiceNowRequestFullV1 = {
  /**
   * Kind
   */
  kind: "request";
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  description: SanitizedStr;
  state: ServiceNowDisplayFieldV1;
  request_state: ServiceNowDisplayFieldV1;
  stage: ServiceNowDisplayFieldV1;
  priority: ServiceNowDisplayFieldV1;
  urgency: ServiceNowDisplayFieldV1;
  impact: ServiceNowDisplayFieldV1;
  assignment_group: ServiceNowDisplayFieldV1;
  assigned_to: ServiceNowDisplayFieldV1;
  opened_by: ServiceNowDisplayFieldV1;
  contact_type: SanitizedStr;
  requested_for: ServiceNowDisplayFieldV1;
  approval: ServiceNowDisplayFieldV1;
  special_instructions: SanitizedStr;
  closed_by: ServiceNowDisplayFieldV1;
  closed_at: SanitizedStr;
  close_notes: SanitizedStr;
  /**
   * @deprecated
   */
  sys_created_on: SanitizedStr;
  /**
   * @deprecated
   */
  sys_updated_on: SanitizedStr;
  created_at: SanitizedStr;
  updated_at: SanitizedStr;
  /**
   * Comments
   */
  comments: Array<ServiceNowCommentV1>;
  /**
   * Request Items
   */
  request_items: Array<ServiceNowRequestItemV1>;
};

/**
 * ServiceNowRequestItemFullV1
 */
export type ServiceNowRequestItemFullV1 = {
  /**
   * Kind
   */
  kind: "request_item";
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  description: SanitizedStr;
  state: ServiceNowDisplayFieldV1;
  stage: ServiceNowDisplayFieldV1;
  priority: ServiceNowDisplayFieldV1;
  urgency: ServiceNowDisplayFieldV1;
  impact: ServiceNowDisplayFieldV1;
  assignment_group: ServiceNowDisplayFieldV1;
  assigned_to: ServiceNowDisplayFieldV1;
  opened_by: ServiceNowDisplayFieldV1;
  contact_type: SanitizedStr;
  requested_for: ServiceNowDisplayFieldV1;
  approval: ServiceNowDisplayFieldV1;
  catalogue_item: ServiceNowDisplayFieldV1;
  closed_by: ServiceNowDisplayFieldV1;
  closed_at: SanitizedStr;
  close_notes: SanitizedStr;
  request: ServiceNowRequestV1;
  /**
   * @deprecated
   */
  sys_created_on: SanitizedStr;
  /**
   * @deprecated
   */
  sys_updated_on: SanitizedStr;
  created_at: SanitizedStr;
  updated_at: SanitizedStr;
  /**
   * Comments
   */
  comments: Array<ServiceNowCommentV1>;
  /**
   * Form Variables
   */
  form_variables: Array<ServiceNowFormVariableV1>;
};

/**
 * ServiceNowRequestItemV1
 */
export type ServiceNowRequestItemV1 = {
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  description: SanitizedStr;
  state: ServiceNowDisplayFieldV1;
  stage: ServiceNowDisplayFieldV1;
  priority: ServiceNowDisplayFieldV1;
  urgency: ServiceNowDisplayFieldV1;
  impact: ServiceNowDisplayFieldV1;
  assignment_group: ServiceNowDisplayFieldV1;
  assigned_to: ServiceNowDisplayFieldV1;
  opened_by: ServiceNowDisplayFieldV1;
  contact_type: SanitizedStr;
  requested_for: ServiceNowDisplayFieldV1;
  approval: ServiceNowDisplayFieldV1;
  catalogue_item: ServiceNowDisplayFieldV1;
  closed_by: ServiceNowDisplayFieldV1;
  closed_at: SanitizedStr;
  close_notes: SanitizedStr;
  /**
   * @deprecated
   */
  sys_created_on: SanitizedStr;
  /**
   * @deprecated
   */
  sys_updated_on: SanitizedStr;
  created_at: SanitizedStr;
  updated_at: SanitizedStr;
  /**
   * Comments
   */
  comments: Array<ServiceNowCommentV1>;
  /**
   * Form Variables
   */
  form_variables: Array<ServiceNowFormVariableV1>;
};

/**
 * ServiceNowRequestV1
 */
export type ServiceNowRequestV1 = {
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  description: SanitizedStr;
  state: ServiceNowDisplayFieldV1;
  request_state: ServiceNowDisplayFieldV1;
  stage: ServiceNowDisplayFieldV1;
  priority: ServiceNowDisplayFieldV1;
  urgency: ServiceNowDisplayFieldV1;
  impact: ServiceNowDisplayFieldV1;
  assignment_group: ServiceNowDisplayFieldV1;
  assigned_to: ServiceNowDisplayFieldV1;
  opened_by: ServiceNowDisplayFieldV1;
  contact_type: SanitizedStr;
  requested_for: ServiceNowDisplayFieldV1;
  approval: ServiceNowDisplayFieldV1;
  special_instructions: SanitizedStr;
  closed_by: ServiceNowDisplayFieldV1;
  closed_at: SanitizedStr;
  close_notes: SanitizedStr;
  /**
   * @deprecated
   */
  sys_created_on: SanitizedStr;
  /**
   * @deprecated
   */
  sys_updated_on: SanitizedStr;
  created_at: SanitizedStr;
  updated_at: SanitizedStr;
};

/**
 * ServiceNowRequestedForReadV1
 */
export type ServiceNowRequestedForReadV1 = {
  /**
   * Kind
   */
  kind: "read";
  /**
   * The requested_for saved on the new request, or null when the request has none.
   */
  saved_sys_id: SanitizedStr | null;
  /**
   * Matches
   *
   * Whether saved_sys_id equals the requested_for_sys_id that was asked for.
   */
  matches: boolean;
};

export type ServiceNowRequestedForReadbackV1 =
  | ({
      kind: "read";
    } & ServiceNowRequestedForReadV1)
  | ({
      kind: "unread";
    } & ServiceNowRequestedForUnreadV1);

/**
 * ServiceNowRequestedForUnreadV1
 */
export type ServiceNowRequestedForUnreadV1 = {
  /**
   * Kind
   */
  kind: "unread";
  /**
   * Why the new request could not be read back. The request exists; only its requested_for is unknown.
   */
  reason: SanitizedStr;
};

/**
 * ServiceNowSearchRecordsV1
 */
export type ServiceNowSearchRecordsV1 = {
  /**
   * ServiceNow table name, for example cmn_cost_center or catalog_ui_policy. Any table the integration account can read; ServiceNow's ACLs decide what comes back, and a refused table or field returns the provider's status.
   */
  table: ServiceNowTableName;
  /**
   * Conditions, free-text keywords and sort order. Omit to read every record the account can see, ordered by sys_id.
   */
  query?: ServiceNowQueryV1;
  /**
   * Fields
   *
   * Columns to return, each dot-walked at most four levels (manager.email); sys_id is always included. Omit for every readable column. A requested column absent from a returned row is rejected with 422 rather than silently omitted.
   */
  fields?: Array<SanitizedStrAZAZ09079AZAZ0907904> | null;
  /**
   * Offset
   *
   * Zero-based offset into the matching records. To continue, add the returned item count to offset and call again until offset reaches total; offset equal to total is an empty terminal page.
   */
  offset?: number;
  /**
   * Maximum records in this page. Pass all for every remaining record in one response, which ServiceNow itself caps at its instance maximum (10,000 by default). The response total says how many records match in all.
   */
  limit?: LimitFilterV1;
};

/**
 * ServiceNowSetupTenantResponseV1
 */
export type ServiceNowSetupTenantResponseV1 = {
  status: SanitizedStr;
  /**
   * Tenant Id
   */
  tenant_id: number;
};

/**
 * ServiceNowStageCatalogAttachmentRequestV1
 */
export type ServiceNowStageCatalogAttachmentRequestV1 = {
  item_guid: ServiceNowCatalogItemGuidV1;
  /**
   * Name ServiceNow stores the attachment under, including its extension, for example receipt.pdf.
   */
  file_name: SanitizedStr;
  /**
   * The file's raw bytes as standard base64 (RFC 4648, with padding, no line breaks or data: prefix). Anything else is refused with 422 before ServiceNow is called.
   */
  content_base64: SanitizedStr;
  /**
   * MIME type the file is stored with; application/octet-stream when omitted or null.
   */
  content_type?: SanitizedStr | null;
};

/**
 * ServiceNowStagedCatalogAttachmentV1
 */
export type ServiceNowStagedCatalogAttachmentV1 = {
  attachment_sys_id: SanitizedStr;
  item_guid: SanitizedStr;
  file_name: SanitizedStr;
  /**
   * Size Bytes
   */
  size_bytes: number;
};

/**
 * ServiceNowStandardChangeV1
 */
export type ServiceNowStandardChangeV1 = {
  /**
   * Kind
   */
  kind: "standard";
  template_id: SanitizedStr;
  /**
   * Fields
   */
  fields?: Array<ServiceNowRecordFieldInputV1>;
};

/**
 * ServiceNowStateByLabelV1
 */
export type ServiceNowStateByLabelV1 = {
  /**
   * Kind
   */
  kind: "label";
  label: SanitizedStr;
};

/**
 * ServiceNowStateByValueV1
 */
export type ServiceNowStateByValueV1 = {
  /**
   * Kind
   */
  kind: "value";
  value: SanitizedStr;
};

export type ServiceNowStateRefV1 =
  | ({
      kind: "value";
    } & ServiceNowStateByValueV1)
  | ({
      kind: "label";
    } & ServiceNowStateByLabelV1);

/**
 * ServiceNowSubmitRecordProducerResultV1
 */
export type ServiceNowSubmitRecordProducerResultV1 = {
  record_table: SanitizedStr;
  record_id: SanitizedStr;
  record_number: SanitizedStr;
};

/**
 * ServiceNowSubmitRecordProducerV1
 */
export type ServiceNowSubmitRecordProducerV1 = {
  producer_id: SanitizedStr;
  /**
   * Variables
   */
  variables?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
};

export type ServiceNowTableName = SanitizedStrAZAZ09079;

/**
 * ServiceNowTagV1
 */
export type ServiceNowTagV1 = {
  sys_id: SanitizedStr;
  name: SanitizedStr;
  color: SanitizedStr;
  description: SanitizedStr;
};

/**
 * ServiceNowTaskV1
 */
export type ServiceNowTaskV1 = {
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  description: SanitizedStr;
  state: ServiceNowDisplayFieldV1;
  priority: ServiceNowDisplayFieldV1;
  assignment_group: ServiceNowDisplayFieldV1;
  assigned_to: ServiceNowDisplayFieldV1;
  opened_by: ServiceNowDisplayFieldV1;
  request_item: ServiceNowDisplayFieldV1;
  closed_by: ServiceNowDisplayFieldV1;
  closed_at: SanitizedStr;
  close_notes: SanitizedStr;
  created_at: SanitizedStr;
  updated_at: SanitizedStr;
};

/**
 * ServiceNowTenantFullV1
 */
export type ServiceNowTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  instance_name: SanitizedStr;
  service_now_instance_url: SanitizedStr;
  auth_kind: ServiceNowAuthKindV1;
  status: ServiceNowTenantStatusV1;
  comment_fetch_strategy: ServiceNowCommentFetchStrategyV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ServiceNowTenantStatusV1
 */
export const ServiceNowTenantStatusV1 = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
} as const;

/**
 * ServiceNowTenantStatusV1
 */
export type ServiceNowTenantStatusV1 =
  (typeof ServiceNowTenantStatusV1)[keyof typeof ServiceNowTenantStatusV1];

/**
 * ServiceNowTenantV1
 */
export type ServiceNowTenantV1 = {
  /**
   * Id
   */
  id: number;
  instance_name: SanitizedStr;
  service_now_instance_url: SanitizedStr;
  status: ServiceNowTenantStatusV1;
  comment_fetch_strategy: ServiceNowCommentFetchStrategyV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

export type ServiceNowTicketFullV1 =
  | ({
      kind: "incident";
    } & ServiceNowIncidentV1)
  | ({
      kind: "request";
    } & ServiceNowRequestFullV1)
  | ({
      kind: "request_item";
    } & ServiceNowRequestItemFullV1);

/**
 * ServiceNowTicketTypeV1
 */
export const ServiceNowTicketTypeV1 = {
  INCIDENT: "incident",
  REQUEST: "request",
  REQUEST_ITEM: "request_item",
} as const;

/**
 * ServiceNowTicketTypeV1
 */
export type ServiceNowTicketTypeV1 =
  (typeof ServiceNowTicketTypeV1)[keyof typeof ServiceNowTicketTypeV1];

/**
 * ServiceNowTicketV1
 */
export type ServiceNowTicketV1 = {
  kind: ServiceNowTicketTypeV1;
  sys_id: SanitizedStr;
  number: SanitizedStr;
  short_description: SanitizedStr;
  state: ServiceNowDisplayFieldV1;
  priority: ServiceNowDisplayFieldV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  catalogue_item?: ServiceNowDisplayFieldV1 | null;
};

/**
 * ServiceNowUpdateChangeV1
 */
export type ServiceNowUpdateChangeV1 = {
  /**
   * Fields
   */
  fields: Array<ServiceNowRecordFieldInputV1>;
};

/**
 * ServiceNowUpdateRecordV1
 */
export type ServiceNowUpdateRecordV1 = {
  table: SanitizedStrAZAZ09079;
  /**
   * Fields
   */
  fields: Array<ServiceNowRecordFieldInputV1>;
  /**
   * Input Display Values
   */
  input_display_values?: boolean;
};

/**
 * ServiceNowUrgencyV1
 */
export const ServiceNowUrgencyV1 = {
  HIGH: "high",
  MEDIUM: "medium",
  LOW: "low",
} as const;

/**
 * ServiceNowUrgencyV1
 */
export type ServiceNowUrgencyV1 =
  (typeof ServiceNowUrgencyV1)[keyof typeof ServiceNowUrgencyV1];

/**
 * ServiceNowUserGroupV1
 */
export type ServiceNowUserGroupV1 = {
  id: SanitizedStr;
  name: SanitizedStr;
  /**
   * Active
   */
  active: boolean;
  type: ServiceNowDisplayFieldV1;
};

/**
 * ServiceNowUserProfileV1
 */
export type ServiceNowUserProfileV1 = {
  id: NonEmptyStr;
  name: SanitizedStr;
  email: NonEmptyStr | null;
  /**
   * Active
   */
  active: boolean;
  user_name: SanitizedStr;
  title: SanitizedStr;
  manager: ServiceNowDisplayFieldV1 | null;
  department: ServiceNowDisplayFieldV1 | null;
  location: ServiceNowDisplayFieldV1 | null;
  cost_center: ServiceNowDisplayFieldV1 | null;
  company: ServiceNowDisplayFieldV1 | null;
};

/**
 * ServiceNowUserV1
 */
export type ServiceNowUserV1 = {
  id: NonEmptyStr;
  name: SanitizedStr;
  email: NonEmptyStr;
  /**
   * Active
   */
  active: boolean;
};

/**
 * ServiceNowUsersV1
 */
export type ServiceNowUsersV1 = {
  /**
   * Users
   */
  users: Array<ServiceNowUserV1>;
};

export type ServiceNowVariableOrder = number;

export type ServiceNowVariableType = number | string;

/**
 * ServiceNowVisibilityV1
 */
export const ServiceNowVisibilityV1 = {
  PUBLIC: "public",
  INTERNAL: "internal",
} as const;

/**
 * ServiceNowVisibilityV1
 */
export type ServiceNowVisibilityV1 =
  (typeof ServiceNowVisibilityV1)[keyof typeof ServiceNowVisibilityV1];

/**
 * ServiceNowWebhookResponseV1
 */
export type ServiceNowWebhookResponseV1 = {
  delivery_id: SanitizedStr;
};

/**
 * SetOrgMemberRoleParamsV1
 */
export type SetOrgMemberRoleParamsV1 = {
  /**
   * Org Id
   */
  org_id: number;
  role: EdraAccessRoleV1;
  /**
   * Email
   */
  email?: string | null;
};

/**
 * SetOrgMembershipParamsV1
 */
export type SetOrgMembershipParamsV1 = {
  /**
   * Org Id
   */
  org_id: number;
  /**
   * Email
   */
  email?: string | null;
};

/**
 * SetTeamArticlePermissionParamsV1
 */
export type SetTeamArticlePermissionParamsV1 = {
  permission: ArticlePermissionV1;
};

/**
 * SetTeamArticlePermissionResultV1
 */
export type SetTeamArticlePermissionResultV1 = {
  permission: ArticlePermissionV1;
};

/**
 * SetTeamArticlePermissionsParamsV1
 */
export type SetTeamArticlePermissionsParamsV1 = {
  /**
   * Permissions
   */
  permissions: {
    [key: string]: ArticlePermissionV1;
  };
};

/**
 * SetTeamArticlePermissionsResultV1
 */
export type SetTeamArticlePermissionsResultV1 = {
  /**
   * Permissions
   */
  permissions: {
    [key: string]: ArticlePermissionV1;
  };
};

/**
 * SetTeamKbRoleParamsV1
 */
export type SetTeamKbRoleParamsV1 = {
  /**
   * Role Id
   */
  role_id: number | null;
};

/**
 * SetTeamKbRoleResultV1
 */
export type SetTeamKbRoleResultV1 = {
  assignment: TeamKbAssignmentV1 | null;
};

/**
 * SetValkeyValueParamsV1
 */
export type SetValkeyValueParamsV1 = {
  value: SanitizedStr;
  /**
   * Ttl Seconds
   */
  ttl_seconds?: number | null;
};

/**
 * SharepointAdminAccessResultV1
 */
export type SharepointAdminAccessResultV1 = {
  /**
   * Whether the access token Edra just minted carries the Sites.FullControl.All application role.
   */
  access: SharepointAdminAccessV1;
};

export type SharepointAdminAccessV1 =
  | ({
      kind: "ELEVATED";
    } & SharepointElevatedV1)
  | ({
      kind: "NOT_ELEVATED";
    } & SharepointNotElevatedV1);

/**
 * SharepointAuthKindV1
 */
export const SharepointAuthKindV1 = { S2S: "S2S", OAUTH: "OAUTH" } as const;

/**
 * SharepointAuthKindV1
 */
export type SharepointAuthKindV1 =
  (typeof SharepointAuthKindV1)[keyof typeof SharepointAuthKindV1];

/**
 * SharepointAuthenticationFailedV1
 */
export type SharepointAuthenticationFailedV1 = {
  /**
   * Kind
   */
  kind?: "AUTHENTICATION_FAILED";
  /**
   * Message
   */
  message: string;
};

/**
 * SharepointCallbackParamsV1
 */
export type SharepointCallbackParamsV1 = {
  /**
   * Code
   */
  code: string;
  /**
   * State
   */
  state: string;
};

/**
 * SharepointCheckAccessResultV1
 */
export type SharepointCheckAccessResultV1 = {
  /**
   * Sites
   */
  sites: Array<SharepointSiteAccessV1>;
  /**
   * Folder Scopes
   */
  folder_scopes: Array<SharepointFolderScopeAccessV1>;
};

/**
 * SharepointCheckConnectionResultV1
 */
export type SharepointCheckConnectionResultV1 = {
  status: SharepointConnectionStatusV1;
};

/**
 * SharepointConnectResponseV1
 */
export type SharepointConnectResponseV1 = {
  /**
   * Authorization Url
   */
  authorization_url: string;
};

/**
 * SharepointConnectedV1
 */
export type SharepointConnectedV1 = {
  /**
   * Kind
   */
  kind?: "CONNECTED";
  /**
   * Reachable Site Ids
   */
  reachable_site_ids: Array<string>;
};

export type SharepointConnectionStatusV1 =
  | ({
      kind: "CREDENTIALS_MISSING";
    } & SharepointCredentialsMissingV1)
  | ({
      kind: "AUTHENTICATION_FAILED";
    } & SharepointAuthenticationFailedV1)
  | ({
      kind: "NO_SITE_REACHABLE";
    } & SharepointNoSiteReachableV1)
  | ({
      kind: "CONNECTED";
    } & SharepointConnectedV1);

/**
 * SharepointCredentialsMissingV1
 */
export type SharepointCredentialsMissingV1 = {
  /**
   * Kind
   */
  kind?: "CREDENTIALS_MISSING";
  /**
   * Message
   */
  message: string;
};

/**
 * SharepointCredentialsStateV1
 */
export type SharepointCredentialsStateV1 = {
  /**
   * Client Id
   */
  client_id: string | null;
  /**
   * Has Client Secret
   */
  has_client_secret: boolean;
  /**
   * Has Tokens
   */
  has_tokens: boolean;
};

/**
 * SharepointDownloadUrlV1
 */
export type SharepointDownloadUrlV1 = {
  /**
   * Item Id
   */
  item_id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Mime Type
   */
  mime_type: string | null;
  /**
   * Size
   */
  size: number;
  /**
   * Etag
   */
  etag: string | null;
  /**
   * Ctag
   */
  ctag: string | null;
  /**
   * Download Url
   */
  download_url: string;
  /**
   * Expires At
   */
  expires_at: Date;
};

/**
 * SharepointDriveItemV1
 */
export type SharepointDriveItemV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Drive Id
   */
  drive_id: string;
  /**
   * Parent Item Id
   */
  parent_item_id: string | null;
  kind: SharepointItemKindV1;
  /**
   * Mime Type
   */
  mime_type: string | null;
  /**
   * Child Count
   */
  child_count: number | null;
  /**
   * Is Shortcut
   *
   * A shortcut points into another drive, so it is refused at authorise time and on every content action. A picker should show it as unselectable rather than let it be chosen.
   */
  is_shortcut: boolean;
  /**
   * Size
   */
  size: number;
  /**
   * Etag
   */
  etag: string | null;
  /**
   * Ctag
   */
  ctag: string | null;
  /**
   * Last Modified Date Time
   */
  last_modified_date_time: Date;
};

/**
 * SharepointDriveV1
 */
export type SharepointDriveV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Drive Type
   */
  drive_type: string;
  /**
   * Root Item Id
   */
  root_item_id: string;
};

/**
 * SharepointElevatedV1
 */
export type SharepointElevatedV1 = {
  /**
   * Kind
   */
  kind?: "ELEVATED";
};

/**
 * SharepointFolderScopeAccessV1
 */
export type SharepointFolderScopeAccessV1 = {
  /**
   * Folder Scope Id
   */
  folder_scope_id: number;
  /**
   * Site Id
   */
  site_id: string;
  /**
   * Drive Id
   */
  drive_id: string;
  /**
   * Root Item Id
   */
  root_item_id: string;
  /**
   * Display Path
   */
  display_path: string;
  /**
   * Path
   *
   * Where the scoped folder lives right now, read from Graph during this probe. Null when the folder could not be reached, and when the scoped folder is the drive root.
   */
  path: string | null;
  reachability: SharepointReachabilityV1;
};

/**
 * SharepointFolderScopeV1
 */
export type SharepointFolderScopeV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Granted Site Id
   */
  granted_site_id: number;
  /**
   * Site Id
   */
  site_id: string;
  /**
   * Drive Id
   */
  drive_id: string;
  /**
   * Root Item Id
   */
  root_item_id: string;
  /**
   * Display Path
   */
  display_path: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * SharepointFolderScopesResultV1
 */
export type SharepointFolderScopesResultV1 = {
  /**
   * Folder Scopes
   */
  folder_scopes: Array<SharepointFolderScopeV1>;
};

/**
 * SharepointGrantedSiteV1
 */
export type SharepointGrantedSiteV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Site Id
   */
  site_id: string;
  /**
   * Site Url
   */
  site_url: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * SharepointItemKindV1
 */
export const SharepointItemKindV1 = { FILE: "FILE", FOLDER: "FOLDER" } as const;

/**
 * SharepointItemKindV1
 */
export type SharepointItemKindV1 =
  (typeof SharepointItemKindV1)[keyof typeof SharepointItemKindV1];

/**
 * SharepointNoSiteReachableV1
 */
export type SharepointNoSiteReachableV1 = {
  /**
   * Kind
   */
  kind?: "NO_SITE_REACHABLE";
  /**
   * Message
   */
  message: string;
};

/**
 * SharepointNotElevatedV1
 */
export type SharepointNotElevatedV1 = {
  /**
   * Kind
   */
  kind?: "NOT_ELEVATED";
};

export type SharepointReachabilityV1 =
  | ({
      kind: "REACHABLE";
    } & SharepointReachableV1)
  | ({
      kind: "UNREACHABLE";
    } & SharepointUnreachableV1);

/**
 * SharepointReachableV1
 */
export type SharepointReachableV1 = {
  /**
   * Kind
   */
  kind?: "REACHABLE";
};

/**
 * SharepointSiteAccessV1
 */
export type SharepointSiteAccessV1 = {
  /**
   * Granted Site Id
   */
  granted_site_id: number;
  /**
   * Site Id
   */
  site_id: string;
  /**
   * Display Name
   */
  display_name: string;
  reachability: SharepointReachabilityV1;
};

/**
 * SharepointSitesResultV1
 */
export type SharepointSitesResultV1 = {
  /**
   * Sites
   */
  sites: Array<SharepointGrantedSiteV1>;
};

/**
 * SharepointTenantCredentialsParamsV1
 */
export type SharepointTenantCredentialsParamsV1 = {
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
};

/**
 * SharepointTenantFullV1
 */
export type SharepointTenantFullV1 = {
  tenant: SharepointTenantV1;
  credentials: SharepointCredentialsStateV1;
  /**
   * Granted Sites
   */
  granted_sites: Array<SharepointGrantedSiteV1>;
  /**
   * Folder Scopes
   */
  folder_scopes: Array<SharepointFolderScopeV1>;
};

/**
 * SharepointTenantV1
 */
export type SharepointTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Azure Tenant Id
   */
  azure_tenant_id: string;
  auth_kind: SharepointAuthKindV1;
  /**
   * Connected At
   */
  connected_at: Date | null;
  /**
   * Redirect Uri
   *
   * The redirect URI this backend sends to Microsoft Entra, and so the one the admin must register against the app. Null for an app-only tenant, which runs no OAuth flow.
   */
  redirect_uri: string | null;
  /**
   * Created By User Id
   */
  created_by_user_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SharepointUnreachableV1
 */
export type SharepointUnreachableV1 = {
  /**
   * Kind
   */
  kind?: "UNREACHABLE";
  /**
   * Status
   */
  status: number;
  /**
   * Detail
   */
  detail: string | null;
};

/**
 * SharepointUploadSessionV1
 */
export type SharepointUploadSessionV1 = {
  /**
   * Upload Url
   *
   * A bearer capability this backend cannot revoke. Bytes go straight to Microsoft, so the resulting etag and ctag arrive in Graph's response to the final chunk rather than from this endpoint.
   */
  upload_url: string;
  /**
   * Expires At
   */
  expires_at: Date;
};

/**
 * SharepointWriteReceiptV1
 */
export type SharepointWriteReceiptV1 = {
  /**
   * Item Id
   */
  item_id: string;
  /**
   * Name
   */
  name: string | null;
  /**
   * Etag
   *
   * Load-bearing, not informational: the caller records the tag it wrote and skips the change carrying it on the next listing, which is what stops a write made through this connector from starting a sync loop.
   */
  etag: string | null;
  /**
   * Ctag
   *
   * Load-bearing, not informational: the caller records the tag it wrote and skips the change carrying it on the next listing, which is what stops a write made through this connector from starting a sync loop.
   */
  ctag: string | null;
};

/**
 * SimulationBranchBreakdownStatsV1
 */
export type SimulationBranchBreakdownStatsV1 = {
  /**
   * Repository Id
   */
  repository_id: number;
  branch: NonEmptyStr;
  /**
   * Commits
   */
  commits: Array<SimulationBranchCommitBreakdownV1>;
};

/**
 * SimulationBranchCommitBreakdownV1
 */
export type SimulationBranchCommitBreakdownV1 = {
  /**
   * Commit Id
   */
  commit_id: number;
  /**
   * Commit Message
   */
  commit_message: string;
  /**
   * Commit Created At
   */
  commit_created_at: Date;
  /**
   * Result Count
   */
  result_count: number;
  /**
   * Judgement Count
   */
  judgement_count: number;
  /**
   * Judges
   */
  judges: Array<SimulationBranchJudgeBreakdownV1>;
};

/**
 * SimulationBranchJudgeBreakdownV1
 */
export type SimulationBranchJudgeBreakdownV1 = {
  judge: JudgeV2;
  /**
   * Total
   */
  total: number;
  /**
   * Buckets
   */
  buckets: Array<SimulationRunVerdictBucketV1>;
};

/**
 * SimulationCommitsV1
 */
export type SimulationCommitsV1 = {
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Commit Ids
   */
  commit_ids: Array<number>;
};

/**
 * SimulationCompareJudgeSummaryV1
 */
export type SimulationCompareJudgeSummaryV1 = {
  judge: JudgeV2;
  base: SimulationJudgeSummaryV1 | null;
  compare: SimulationJudgeSummaryV1 | null;
  /**
   * Improved
   */
  improved: number;
  /**
   * Regressed
   */
  regressed: number;
  /**
   * Unchanged
   */
  unchanged: number;
};

/**
 * SimulationCompareSummaryV1
 */
export type SimulationCompareSummaryV1 = {
  /**
   * Judges
   */
  judges: Array<SimulationCompareJudgeSummaryV1>;
};

/**
 * SimulationCompareV1
 */
export type SimulationCompareV1 = {
  datapoint: SimulationDatapointFullV1;
  base: SimulationResultWithJudgementsV1 | null;
  compare: SimulationResultWithJudgementsV1 | null;
  /**
   * Changed
   */
  changed: boolean;
};

/**
 * SimulationDatapointExtractedInputOutputFullV1
 */
export type SimulationDatapointExtractedInputOutputFullV1 = {
  extracted_input: ConversationFullV2;
  extracted_output: ConversationFullV2;
};

/**
 * SimulationDatapointFullV1
 */
export type SimulationDatapointFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  model: SimulationDatapointExtractedInputOutputFullV1;
  view: SimulationDatapointExtractedInputOutputFullV1;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SimulationDatapointV1
 */
export type SimulationDatapointV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SimulationJudgeSummaryV1
 */
export type SimulationJudgeSummaryV1 = {
  judge: JudgeV2;
  /**
   * Total
   */
  total: number;
  /**
   * Buckets
   */
  buckets: Array<SimulationRunVerdictBucketV1>;
};

/**
 * SimulationResultCitationV1
 */
export type SimulationResultCitationV1 = {
  /**
   * Source Object Article Id
   */
  source_object_article_id: number;
  /**
   * Line Start
   */
  line_start: number;
  /**
   * Line End
   */
  line_end: number;
};

/**
 * SimulationResultContentBlockV1
 */
export type SimulationResultContentBlockV1 = {
  /**
   * Text
   */
  text: string;
  /**
   * Citations
   */
  citations: Array<SimulationResultCitationV1>;
};

/**
 * SimulationResultFullV1
 */
export type SimulationResultFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Commit Id
   */
  commit_id: number;
  /**
   * Simulation Datapoint Id
   */
  simulation_datapoint_id: number;
  output: SimulationResultOutputFullV1;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Tags
   */
  tags: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SimulationResultJudgementFullV1
 */
export type SimulationResultJudgementFullV1 = {
  judgement: SimulationResultJudgementV1;
  result: SimulationResultFullV1;
  datapoint: SimulationDatapointFullV1;
};

/**
 * SimulationResultJudgementV1
 */
export type SimulationResultJudgementV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Simulation Result Id
   */
  simulation_result_id: number;
  judge: JudgeV2;
  value: JudgementOrdinalValueV2;
  /**
   * Reasoning
   */
  reasoning: string | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SimulationResultOutputFullV1
 */
export type SimulationResultOutputFullV1 = {
  /**
   * Output Messages
   */
  output_messages: Array<ConversationMessageFullV2>;
  /**
   * Reasoning
   */
  reasoning: string;
  confidence: InferenceConfidenceV1 | null;
  raw_json: JsonOutput;
  /**
   * Output Metadata
   */
  output_metadata: {
    [key: string]: string;
  };
};

/**
 * SimulationResultOutputV1
 */
export type SimulationResultOutputV1 = {
  /**
   * Content Blocks
   */
  content_blocks: Array<SimulationResultContentBlockV1>;
  /**
   * Reasoning
   */
  reasoning: string;
  raw_json: JsonInput;
  /**
   * Output Metadata
   */
  output_metadata: {
    [key: string]: string;
  };
};

/**
 * SimulationResultV1
 */
export type SimulationResultV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Commit Id
   */
  commit_id: number;
  /**
   * Simulation Datapoint Id
   */
  simulation_datapoint_id: number;
  /**
   * External Created At
   */
  external_created_at: Date | null;
  /**
   * Metadata
   */
  metadata: {
    [key: string]: string;
  };
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SimulationResultWithJudgementsV1
 */
export type SimulationResultWithJudgementsV1 = {
  result: SimulationResultFullV1;
  /**
   * Judgements By Judge Key
   */
  judgements_by_judge_key: {
    [key: string]: SimulationResultJudgementV1;
  };
};

/**
 * SimulationRunV1
 */
export type SimulationRunV1 = {
  datapoint: SimulationDatapointFullV1;
  result: SimulationResultWithJudgementsV1;
};

/**
 * SimulationRunVerdictBucketV1
 */
export type SimulationRunVerdictBucketV1 = {
  value: JudgementOrdinalValueV2;
  /**
   * Count
   */
  count: number;
};

/**
 * SingleStatContentV1
 */
export type SingleStatContentV1 = {
  /**
   * Kind
   */
  kind: "SINGLE_STAT";
  suffix?: SanitizedStr | null;
  /**
   * Decimal Places
   */
  decimal_places: number;
  /**
   * Value
   */
  value: number;
  /**
   * Previous Value
   */
  previous_value?: number | null;
};

/**
 * SlackAddReactionRequestV2
 */
export type SlackAddReactionRequestV2 = {
  /**
   * Channel
   */
  channel: string;
  /**
   * Ts
   */
  ts: string;
  /**
   * Name
   */
  name: string;
};

/**
 * SlackAddReactionResponseV2
 */
export type SlackAddReactionResponseV2 = {
  /**
   * Slack Status Code
   */
  slack_status_code: number;
};

/**
 * SlackAppManifestV1
 */
export type SlackAppManifestV1 = {
  display_information: SlackManifestDisplayInformationV1;
  features: SlackManifestFeaturesV1;
  oauth_config: SlackManifestOauthConfigV1;
  settings: SlackManifestSettingsV1;
};

/**
 * SlackAttachmentColorAliasV1
 */
export const SlackAttachmentColorAliasV1 = {
  GOOD: "good",
  WARNING: "warning",
  DANGER: "danger",
} as const;

/**
 * SlackAttachmentColorAliasV1
 */
export type SlackAttachmentColorAliasV1 =
  (typeof SlackAttachmentColorAliasV1)[keyof typeof SlackAttachmentColorAliasV1];

/**
 * SlackAttachmentV1
 */
export type SlackAttachmentV1 = {
  /**
   * Color
   */
  color?: string | SlackAttachmentColorAliasV1 | null;
  /**
   * Notification Text
   */
  notification_text?: string | null;
  /**
   * Blocks
   */
  blocks?: Array<{
    [key: string]: JsonInput;
  }> | null;
};

/**
 * SlackCallbackPayloadV1
 */
export type SlackCallbackPayloadV1 = {
  /**
   * Code
   */
  code: string;
  /**
   * State
   */
  state: string;
};

/**
 * SlackChannelMessageV2
 */
export type SlackChannelMessageV2 = {
  /**
   * Ts
   */
  ts: string;
  /**
   * User Id
   */
  user_id: string | null;
  /**
   * Text
   */
  text: string;
};

export type SlackCheckConnectionResponseV1 =
  | ({
      status: "connected";
    } & SlackConnectedV1)
  | ({
      status: "disconnected";
    } & SlackDisconnectedV1);

/**
 * SlackConnectResponseV1
 */
export type SlackConnectResponseV1 = {
  /**
   * Authorization Url
   */
  authorization_url: string;
};

/**
 * SlackConnectedV1
 */
export type SlackConnectedV1 = {
  /**
   * Status
   */
  status: "connected";
  /**
   * Granted Scopes
   */
  granted_scopes: Array<SlackOauthScope>;
  /**
   * Missing Scopes
   */
  missing_scopes: Array<SlackOauthScope>;
};

/**
 * SlackDirectMessageDestinationV1
 */
export type SlackDirectMessageDestinationV1 = {
  /**
   * Kind
   */
  kind: "direct_message";
};

/**
 * SlackDisconnectedV1
 */
export type SlackDisconnectedV1 = {
  /**
   * Status
   */
  status: "disconnected";
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * SlackFileModeV1
 */
export const SlackFileModeV1 = {
  HOSTED: "hosted",
  EXTERNAL: "external",
  SNIPPET: "snippet",
  POST: "post",
} as const;

/**
 * SlackFileModeV1
 */
export type SlackFileModeV1 =
  (typeof SlackFileModeV1)[keyof typeof SlackFileModeV1];

/**
 * SlackFileV1
 */
export type SlackFileV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Created
   */
  created: number;
  /**
   * Timestamp
   */
  timestamp: number;
  /**
   * Name
   */
  name: string;
  /**
   * Title
   */
  title: string;
  /**
   * Mimetype
   */
  mimetype: string;
  /**
   * Pretty Type
   */
  pretty_type: string;
  /**
   * User
   */
  user: string;
  mode: SlackFileModeV1;
  /**
   * Editable
   */
  editable: boolean;
  /**
   * Is External
   */
  is_external: boolean;
  /**
   * External Type
   */
  external_type: string;
  /**
   * Size
   */
  size: number;
};

/**
 * SlackGetChannelMessagesResponseV2
 */
export type SlackGetChannelMessagesResponseV2 = {
  /**
   * Messages
   */
  messages: Array<SlackChannelMessageV2>;
};

/**
 * SlackGetReactionsMessageV2
 */
export type SlackGetReactionsMessageV2 = {
  /**
   * Ts
   */
  ts: string;
  /**
   * Thread Ts
   */
  thread_ts: string | null;
  /**
   * User
   */
  user: string | null;
  /**
   * Bot Id
   */
  bot_id: string | null;
  /**
   * Team
   */
  team: string | null;
  /**
   * Text
   */
  text: string | null;
  /**
   * Permalink
   */
  permalink: string | null;
  /**
   * Reactions
   */
  reactions: Array<SlackReactionV2>;
};

/**
 * SlackGetReactionsResponseV2
 */
export type SlackGetReactionsResponseV2 = {
  /**
   * Channel
   */
  channel: string;
  message: SlackGetReactionsMessageV2;
};

/**
 * SlackGetUserGroupUsersResponseV1
 */
export type SlackGetUserGroupUsersResponseV1 = {
  /**
   * Users
   */
  users: Array<string>;
};

/**
 * SlackGetUserGroupsResponseV1
 */
export type SlackGetUserGroupsResponseV1 = {
  /**
   * User Groups
   */
  user_groups: Array<SlackUserGroupV1>;
};

/**
 * SlackGetUserInfoResponseV2
 */
export type SlackGetUserInfoResponseV2 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Real Name
   */
  real_name: string | null;
  /**
   * Is Bot
   */
  is_bot: boolean;
};

/**
 * SlackListUsersResponseV2
 */
export type SlackListUsersResponseV2 = {
  /**
   * Users
   */
  users: Array<SlackListUsersUserV2>;
  /**
   * Next Cursor
   */
  next_cursor: string | null;
};

/**
 * SlackListUsersUserV2
 */
export type SlackListUsersUserV2 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Real Name
   */
  real_name: string | null;
  /**
   * Is Bot
   */
  is_bot: boolean;
};

/**
 * SlackManifestAgentActionV1
 */
export type SlackManifestAgentActionV1 = {
  /**
   * Name
   */
  name: string;
  /**
   * Description
   */
  description: string;
};

/**
 * SlackManifestAgentSuggestedPromptV1
 */
export type SlackManifestAgentSuggestedPromptV1 = {
  /**
   * Title
   */
  title: string;
  /**
   * Message
   */
  message: string;
};

export type SlackManifestAgentViewV1 = {
  [key: string]: JsonOutput;
};

/**
 * SlackManifestAppHomeV1
 */
export type SlackManifestAppHomeV1 = {
  /**
   * Home Tab Enabled
   */
  home_tab_enabled: boolean;
  /**
   * Messages Tab Enabled
   */
  messages_tab_enabled: boolean;
  /**
   * Messages Tab Read Only Enabled
   */
  messages_tab_read_only_enabled: boolean;
};

/**
 * SlackManifestBotUserV1
 */
export type SlackManifestBotUserV1 = {
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Always Online
   */
  always_online?: boolean;
};

/**
 * SlackManifestDisplayInformationV1
 */
export type SlackManifestDisplayInformationV1 = {
  /**
   * Name
   */
  name: string;
  /**
   * Description
   */
  description: string;
  /**
   * Background Color
   */
  background_color: string;
};

/**
 * SlackManifestEventSubscriptionsV1
 */
export type SlackManifestEventSubscriptionsV1 = {
  /**
   * Request Url
   */
  request_url: string;
  /**
   * Bot Events
   */
  bot_events: Array<string>;
};

export type SlackManifestFeaturesV1 = {
  [key: string]: JsonOutput;
};

/**
 * SlackManifestInteractivityV1
 */
export type SlackManifestInteractivityV1 = {
  /**
   * Is Enabled
   */
  is_enabled: boolean;
  /**
   * Request Url
   */
  request_url: string;
};

/**
 * SlackManifestOauthConfigV1
 */
export type SlackManifestOauthConfigV1 = {
  /**
   * Redirect Urls
   */
  redirect_urls: Array<string>;
  scopes: SlackManifestScopesV1;
  /**
   * Pkce Enabled
   */
  pkce_enabled: boolean;
};

/**
 * SlackManifestScopesV1
 */
export type SlackManifestScopesV1 = {
  /**
   * Bot
   */
  bot: Array<SlackOauthScope>;
};

/**
 * SlackManifestSettingsV1
 */
export type SlackManifestSettingsV1 = {
  event_subscriptions: SlackManifestEventSubscriptionsV1;
  interactivity: SlackManifestInteractivityV1;
  /**
   * Org Deploy Enabled
   */
  org_deploy_enabled: boolean;
  /**
   * Socket Mode Enabled
   */
  socket_mode_enabled: boolean;
  /**
   * Token Rotation Enabled
   */
  token_rotation_enabled: boolean;
  /**
   * Is Mcp Enabled
   */
  is_mcp_enabled: boolean;
};

/**
 * SlackMessageMetadataV1
 */
export type SlackMessageMetadataV1 = {
  /**
   * Event Type
   */
  event_type: string;
  /**
   * Event Payload
   */
  event_payload: {
    [key: string]: JsonInput;
  };
};

export type SlackNotificationDestinationV1 = SlackDirectMessageDestinationV1;

/**
 * SlackNotificationSettingV1
 */
export type SlackNotificationSettingV1 = {
  /**
   * Slack Tenant Id
   */
  slack_tenant_id: number;
  destination: SlackNotificationDestinationV1;
};

/**
 * SlackOauthScope
 */
export const SlackOauthScope = {
  APP_MENTIONS_READ: "app_mentions:read",
  ASSISTANT_WRITE: "assistant:write",
  CHANNELS_HISTORY: "channels:history",
  CHANNELS_MANAGE: "channels:manage",
  CHANNELS_WRITE_TOPIC: "channels:write.topic",
  CHAT_WRITE: "chat:write",
  FILES_READ: "files:read",
  FILES_WRITE: "files:write",
  GROUPS_HISTORY: "groups:history",
  GROUPS_READ: "groups:read",
  GROUPS_WRITE: "groups:write",
  GROUPS_WRITE_TOPIC: "groups:write.topic",
  IM_HISTORY: "im:history",
  IM_READ: "im:read",
  IM_WRITE: "im:write",
  IM_WRITE_TOPIC: "im:write.topic",
  LINKS_READ: "links:read",
  MPIM_HISTORY: "mpim:history",
  MPIM_READ: "mpim:read",
  REACTIONS_READ: "reactions:read",
  REACTIONS_WRITE: "reactions:write",
  USERS_READ: "users:read",
  USERS_READ_EMAIL: "users:read.email",
  USERGROUPS_READ: "usergroups:read",
  USERGROUPS_WRITE: "usergroups:write",
} as const;

/**
 * SlackOauthScope
 */
export type SlackOauthScope =
  (typeof SlackOauthScope)[keyof typeof SlackOauthScope];

/**
 * SlackOauthScopesResponseV1
 */
export type SlackOauthScopesResponseV1 = {
  /**
   * Scopes
   */
  scopes: Array<SlackOauthScope>;
};

/**
 * SlackOpenViewRequestV1
 */
export type SlackOpenViewRequestV1 = {
  /**
   * Trigger Id
   */
  trigger_id: string;
  /**
   * View
   */
  view: {
    [key: string]: JsonInput;
  };
};

/**
 * SlackOpenViewResponseV1
 */
export type SlackOpenViewResponseV1 = {
  /**
   * Slack Status Code
   */
  slack_status_code: number;
};

/**
 * SlackParseModeV1
 */
export const SlackParseModeV1 = { FULL: "full", NONE: "none" } as const;

/**
 * SlackParseModeV1
 */
export type SlackParseModeV1 =
  (typeof SlackParseModeV1)[keyof typeof SlackParseModeV1];

/**
 * SlackPostChatMessageRequestV2
 */
export type SlackPostChatMessageRequestV2 = {
  /**
   * Channel
   */
  channel: string;
  /**
   * Text
   */
  text: string;
  /**
   * Thread Ts
   */
  thread_ts?: string | null;
  /**
   * Blocks
   */
  blocks?:
    | string
    | Array<{
        [key: string]: JsonInput;
      }>
    | null;
  /**
   * Unfurl Links
   */
  unfurl_links?: boolean | null;
  /**
   * Unfurl Media
   */
  unfurl_media?: boolean | null;
  /**
   * Reply Broadcast
   */
  reply_broadcast?: boolean | null;
  /**
   * Attachments
   */
  attachments?: Array<SlackAttachmentV1> | null;
  /**
   * Mrkdwn
   */
  mrkdwn?: boolean | null;
  /**
   * Link Names
   */
  link_names?: boolean | null;
  parse?: SlackParseModeV1 | null;
  metadata?: SlackMessageMetadataV1 | null;
};

/**
 * SlackPostChatMessageResponseV2
 */
export type SlackPostChatMessageResponseV2 = {
  /**
   * Slack Status Code
   */
  slack_status_code: number;
  /**
   * Ts
   */
  ts: string;
  /**
   * Channel
   */
  channel?: string | null;
  /**
   * Thread Ts
   */
  thread_ts?: string | null;
};

/**
 * SlackPublishHomeViewRequestV1
 */
export type SlackPublishHomeViewRequestV1 = {
  /**
   * User Id
   */
  user_id: string;
  /**
   * View
   */
  view: {
    [key: string]: JsonInput;
  };
};

/**
 * SlackPublishHomeViewResponseV1
 */
export type SlackPublishHomeViewResponseV1 = {
  /**
   * Slack Status Code
   */
  slack_status_code: number;
};

/**
 * SlackPushViewRequestV1
 */
export type SlackPushViewRequestV1 = {
  /**
   * Trigger Id
   */
  trigger_id: string;
  /**
   * View
   */
  view: {
    [key: string]: JsonInput;
  };
};

/**
 * SlackPushViewResponseV1
 */
export type SlackPushViewResponseV1 = {
  /**
   * Slack Status Code
   */
  slack_status_code: number;
};

/**
 * SlackReactionV2
 */
export type SlackReactionV2 = {
  /**
   * Name
   */
  name: string;
  /**
   * Users
   */
  users: Array<string>;
  /**
   * Count
   */
  count: number;
};

/**
 * SlackReceiveEventAckResponseV2
 */
export type SlackReceiveEventAckResponseV2 = {
  [key: string]: unknown;
};

/**
 * SlackReceiveEventChallengeResponseV2
 */
export type SlackReceiveEventChallengeResponseV2 = {
  /**
   * Challenge
   */
  challenge: string;
};

export type SlackReceiveEventResponseV2 =
  | SlackReceiveEventChallengeResponseV2
  | SlackReceiveEventAckResponseV2;

/**
 * SlackReceiveInteractivityAckResponseV2
 */
export type SlackReceiveInteractivityAckResponseV2 = {
  [key: string]: unknown;
};

/**
 * SlackSetAssistantStatusRequestV2
 */
export type SlackSetAssistantStatusRequestV2 = {
  /**
   * Channel Id
   */
  channel_id: string;
  /**
   * Thread Ts
   */
  thread_ts: string;
  /**
   * Status
   */
  status: string;
  /**
   * Loading Messages
   */
  loading_messages?: Array<string> | null;
};

/**
 * SlackSetAssistantStatusResponseV2
 */
export type SlackSetAssistantStatusResponseV2 = {
  [key: string]: unknown;
};

/**
 * SlackSetAssistantTitleRequestV1
 */
export type SlackSetAssistantTitleRequestV1 = {
  /**
   * Channel Id
   */
  channel_id: string;
  /**
   * Thread Ts
   */
  thread_ts: string;
  /**
   * Title
   */
  title: string;
};

/**
 * SlackSetAssistantTitleResponseV1
 */
export type SlackSetAssistantTitleResponseV1 = {
  [key: string]: unknown;
};

/**
 * SlackSetChannelDescriptionRequestV2
 */
export type SlackSetChannelDescriptionRequestV2 = {
  /**
   * Channel
   */
  channel: string;
  /**
   * Description
   */
  description: string;
};

/**
 * SlackSetChannelDescriptionResponseV2
 */
export type SlackSetChannelDescriptionResponseV2 = {
  [key: string]: unknown;
};

/**
 * SlackSetChannelTopicRequestV2
 */
export type SlackSetChannelTopicRequestV2 = {
  /**
   * Channel
   */
  channel: string;
  /**
   * Topic
   */
  topic: string;
};

/**
 * SlackSetChannelTopicResponseV2
 */
export type SlackSetChannelTopicResponseV2 = {
  [key: string]: unknown;
};

/**
 * SlackSetSuggestedPromptsRequestV1
 */
export type SlackSetSuggestedPromptsRequestV1 = {
  /**
   * Channel Id
   */
  channel_id: string;
  /**
   * Thread Ts
   */
  thread_ts: string;
  /**
   * Prompts
   */
  prompts: Array<SlackSuggestedPromptV1>;
  /**
   * Title
   */
  title?: string | null;
};

/**
 * SlackSetSuggestedPromptsResponseV1
 */
export type SlackSetSuggestedPromptsResponseV1 = {
  [key: string]: unknown;
};

/**
 * SlackSnippetType
 */
export const SlackSnippetType = {
  DIFF: "diff",
  TEXT: "text",
  MARKDOWN: "markdown",
  PYTHON: "python",
  JAVASCRIPT: "javascript",
  TYPESCRIPT: "typescript",
  SQL: "sql",
  JSON: "json",
  YAML: "yaml",
  BASH: "bash",
} as const;

/**
 * SlackSnippetType
 */
export type SlackSnippetType =
  (typeof SlackSnippetType)[keyof typeof SlackSnippetType];

/**
 * SlackSuggestedPromptV1
 */
export type SlackSuggestedPromptV1 = {
  /**
   * Title
   */
  title: string;
  /**
   * Message
   */
  message: string;
};

/**
 * SlackTenantFullV1
 */
export type SlackTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Description
   */
  description: string | null;
  /**
   * Background Color
   */
  background_color: string | null;
  /**
   * Scopes
   */
  scopes: Array<SlackOauthScope>;
  /**
   * App Id
   */
  app_id: string | null;
  /**
   * Client Id
   */
  client_id: string | null;
  /**
   * Has Credentials
   */
  has_credentials: boolean;
  /**
   * Has Tokens
   */
  has_tokens: boolean;
  /**
   * Team Id
   */
  team_id: string | null;
  /**
   * Enterprise Id
   */
  enterprise_id: string | null;
  /**
   * Is Enterprise Install
   */
  is_enterprise_install: boolean;
  /**
   * Redirect Uri
   */
  redirect_uri: string;
  /**
   * Event Request Url
   */
  event_request_url: string;
  /**
   * Last Event Received At
   */
  last_event_received_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SlackTenantV1
 */
export type SlackTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * Description
   */
  description: string | null;
  /**
   * Background Color
   */
  background_color: string | null;
  /**
   * Last Event Received At
   */
  last_event_received_at: Date | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * SlackUpdateChatMessageRequestV2
 */
export type SlackUpdateChatMessageRequestV2 = {
  /**
   * Channel
   */
  channel: string;
  /**
   * Ts
   */
  ts: string;
  /**
   * Text
   */
  text: string;
  /**
   * Blocks
   */
  blocks?:
    | string
    | Array<{
        [key: string]: JsonInput;
      }>
    | null;
  metadata?: SlackMessageMetadataV1 | null;
};

/**
 * SlackUpdateChatMessageResponseV2
 */
export type SlackUpdateChatMessageResponseV2 = {
  /**
   * Slack Status Code
   */
  slack_status_code: number;
};

/**
 * SlackUpdateUserGroupRequestV1
 */
export type SlackUpdateUserGroupRequestV1 = {
  /**
   * Usergroup Id
   */
  usergroup_id: string;
  /**
   * Name
   */
  name?: string | null;
  /**
   * Handle
   */
  handle?: string | null;
  /**
   * Description
   */
  description?: string | null;
};

/**
 * SlackUpdateUserGroupUsersRequestV1
 */
export type SlackUpdateUserGroupUsersRequestV1 = {
  /**
   * Usergroup Id
   */
  usergroup_id: string;
  /**
   * Users
   */
  users: Array<string>;
};

/**
 * SlackUpdateViewRequestV1
 */
export type SlackUpdateViewRequestV1 = {
  /**
   * View
   */
  view: {
    [key: string]: JsonInput;
  };
  /**
   * View Id
   */
  view_id?: string | null;
  /**
   * External Id
   */
  external_id?: string | null;
  /**
   * Hash
   */
  hash?: string | null;
};

/**
 * SlackUpdateViewResponseV1
 */
export type SlackUpdateViewResponseV1 = {
  /**
   * Slack Status Code
   */
  slack_status_code: number;
};

/**
 * SlackUploadContentRequestV2
 */
export type SlackUploadContentRequestV2 = {
  /**
   * Content
   */
  content: string;
  /**
   * Filename
   */
  filename: string;
  /**
   * Channel Id
   */
  channel_id: string;
  snippet_type?: SlackSnippetType | null;
  /**
   * Title
   */
  title?: string | null;
  /**
   * Thread Ts
   */
  thread_ts?: string | null;
  /**
   * Initial Comment
   */
  initial_comment?: string | null;
};

/**
 * SlackUploadFilesResponseV2
 */
export type SlackUploadFilesResponseV2 = {
  /**
   * Slack Status Code
   */
  slack_status_code: number;
  /**
   * Files
   */
  files: Array<SlackFileV1>;
};

/**
 * SlackUserGroupV1
 */
export type SlackUserGroupV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Handle
   */
  handle: string;
  /**
   * Description
   */
  description: string;
  /**
   * Is External
   */
  is_external: boolean;
  /**
   * Member Count
   */
  member_count: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * StatefulConversationMessageV1
 *
 * A message in a conversation.
 */
export type StatefulConversationMessageV1 = {
  /**
   * Content
   *
   * The message content.
   */
  content: string;
  /**
   * The role of the message sender.
   */
  role: ConversationMessageRoleV1Field;
  /**
   * Message Id
   *
   * The unique identifier of the message.
   */
  message_id?: string | Missing;
  /**
   * Created At
   *
   * The timestamp of when the message was created.
   */
  created_at?: Date | Missing;
  /**
   * Metadata
   *
   * Additional metadata associated with the message, used during inference.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Message tags.
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * StatefulInferencePayloadV1
 *
 * Run inference on a stateful conversation.
 *
 * Appends the provided messages to the conversation identified by
 * `external_id` and runs inference on the full conversation history.
 * When no matching conversation exists, a new one is created.
 */
export type StatefulInferencePayloadV1 = {
  /**
   * Task Id
   *
   * Unique identifier of the task being used.
   */
  task_id: number;
  /**
   * Message
   *
   * One or more messages to append to the conversation before running inference. Accepts a single message or a list of messages. Defaults to an empty list, which runs inference on the existing conversation without appending new messages.
   */
  message?:
    | StatefulConversationMessageV1
    | Array<StatefulConversationMessageV1>;
  /**
   * Metadata
   *
   * Additional metadata associated with the conversation, used during inference.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Conversation tags.
   */
  tags?: {
    [key: string]: string;
  };
  /**
   * The inference mode to use.
   */
  mode?: InferenceModeV1;
};

/**
 * StopAgentSessionResponseV1
 */
export type StopAgentSessionResponseV1 = {
  [key: string]: unknown;
};

/**
 * SucceededWorkflowRunV1
 */
export type SucceededWorkflowRunV1 = {
  /**
   * Kind
   */
  kind: "SUCCEEDED";
  /**
   * Succeeded At
   */
  succeeded_at: Date;
};

/**
 * SyncArticlesToOpenFgaResultV1
 */
export type SyncArticlesToOpenFgaResultV1 = {
  /**
   * Kbs Scanned
   */
  kbs_scanned: number;
  /**
   * Tuples Written
   */
  tuples_written: number;
};

/**
 * SyncJudgesResultV1
 */
export type SyncJudgesResultV1 = {
  /**
   * Judges
   */
  judges: Array<JudgeV2>;
};

/**
 * SyncKbOwnersResultV1
 */
export type SyncKbOwnersResultV1 = {
  /**
   * Synced
   */
  synced: number;
  /**
   * Total
   */
  total: number;
};

export type TagFilterV1 = SanitizedStr;

/**
 * TaskFullV2
 */
export type TaskFullV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Task Template
   */
  task_template: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * TaskV2
 */
export type TaskV2 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * TeamFullV1
 */
export type TeamFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Member Ids
   */
  member_ids: Array<number>;
  /**
   * Members
   */
  members: Array<UserFullV1>;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * TeamKbAssignmentV1
 */
export type TeamKbAssignmentV1 = {
  /**
   * Kb Id
   */
  kb_id: number;
  role: RoleV1;
};

/**
 * TeamV1
 */
export type TeamV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
};

/**
 * TeamsAdaptiveCardV1
 */
export type TeamsAdaptiveCardV1 = {
  /**
   * Payload
   */
  payload: {
    [key: string]: JsonInput;
  };
};

export type TeamsBotCredentialsResponseV1 =
  | ({
      bot_app_type: "SINGLE_TENANT";
    } & TeamsSingleTenantBotCredentialsResponseV1)
  | ({
      bot_app_type: "USER_ASSIGNED_MANAGED_IDENTITY";
    } & TeamsUserAssignedManagedIdentityBotCredentialsResponseV1);

export type TeamsBotCredentialsV1 =
  | ({
      bot_app_type: "SINGLE_TENANT";
    } & TeamsSingleTenantBotCredentialsV1)
  | ({
      bot_app_type: "USER_ASSIGNED_MANAGED_IDENTITY";
    } & TeamsUserAssignedManagedIdentityBotCredentialsV1);

/**
 * TeamsCheckConnectionResponseV1
 */
export type TeamsCheckConnectionResponseV1 = {
  /**
   * Connected
   */
  connected: boolean;
  /**
   * Detail
   */
  detail?: string | null;
};

/**
 * TeamsConversationActivityRefV1
 */
export type TeamsConversationActivityRefV1 = {
  /**
   * Activity Id
   */
  activity_id: string;
  /**
   * Activity Type
   */
  activity_type: string;
  /**
   * Timestamp
   */
  timestamp: string | null;
  /**
   * From Id
   */
  from_id: string | null;
  /**
   * From Name
   */
  from_name: string | null;
  /**
   * Text
   */
  text: string | null;
};

/**
 * TeamsConversationMemberV1
 */
export type TeamsConversationMemberV1 = {
  /**
   * Id
   */
  id: string;
  /**
   * Aad Object Id
   */
  aad_object_id: string | null;
  /**
   * Name
   */
  name: string | null;
  /**
   * Email
   */
  email: string | null;
  /**
   * User Principal Name
   */
  user_principal_name: string | null;
};

/**
 * TeamsDeleteMessageRequestV1
 */
export type TeamsDeleteMessageRequestV1 = {
  /**
   * Conversation Id
   */
  conversation_id: string;
  /**
   * Service Url
   */
  service_url: string;
  /**
   * Activity Id
   */
  activity_id: string;
};

/**
 * TeamsDeleteMessageResponseV1
 */
export type TeamsDeleteMessageResponseV1 = {
  [key: string]: unknown;
};

/**
 * TeamsDownloadFileRequestV1
 */
export type TeamsDownloadFileRequestV1 = {
  /**
   * File Id
   */
  file_id: string;
  /**
   * Download Url
   */
  download_url: string;
};

/**
 * TeamsEndCustomerInstallV1
 */
export type TeamsEndCustomerInstallV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Teams Tenant Id
   */
  teams_tenant_id: number;
  /**
   * M365 Tenant Id
   */
  m365_tenant_id: string;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * TeamsGetConversationMemberRequestV1
 */
export type TeamsGetConversationMemberRequestV1 = {
  /**
   * Conversation Id
   */
  conversation_id: string;
  /**
   * Service Url
   */
  service_url: string;
  /**
   * Member Id
   */
  member_id: string;
};

/**
 * TeamsGetConversationMemberResponseV1
 */
export type TeamsGetConversationMemberResponseV1 = {
  member: TeamsConversationMemberV1;
};

/**
 * TeamsIconKindV1
 */
export const TeamsIconKindV1 = { COLOR: "color", OUTLINE: "outline" } as const;

/**
 * TeamsIconKindV1
 */
export type TeamsIconKindV1 =
  (typeof TeamsIconKindV1)[keyof typeof TeamsIconKindV1];

/**
 * TeamsJwksKeyV1
 */
export type TeamsJwksKeyV1 = {
  /**
   * Kty
   */
  kty?: "RSA";
  /**
   * Use
   */
  use?: "sig";
  /**
   * Alg
   */
  alg?: "RS256";
  /**
   * Kid
   */
  kid: string;
  /**
   * N
   */
  n: string;
  /**
   * E
   */
  e: string;
};

/**
 * TeamsJwksV1
 */
export type TeamsJwksV1 = {
  /**
   * Keys
   */
  keys: Array<TeamsJwksKeyV1>;
};

/**
 * TeamsListConversationActivitiesRequestV1
 */
export type TeamsListConversationActivitiesRequestV1 = {
  /**
   * Conversation Id
   */
  conversation_id: string;
  /**
   * Service Url
   */
  service_url: string;
  /**
   * Continuation Token
   */
  continuation_token?: string | null;
};

/**
 * TeamsListConversationActivitiesResponseV1
 */
export type TeamsListConversationActivitiesResponseV1 = {
  /**
   * Activities
   */
  activities: Array<TeamsConversationActivityRefV1>;
  /**
   * Continuation Token
   */
  continuation_token: string | null;
};

/**
 * TeamsListConversationMembersRequestV1
 */
export type TeamsListConversationMembersRequestV1 = {
  /**
   * Conversation Id
   */
  conversation_id: string;
  /**
   * Service Url
   */
  service_url: string;
  /**
   * Continuation Token
   */
  continuation_token?: string | null;
  /**
   * Page Size
   */
  page_size?: number | null;
};

/**
 * TeamsListConversationMembersResponseV1
 */
export type TeamsListConversationMembersResponseV1 = {
  /**
   * Members
   */
  members: Array<TeamsConversationMemberV1>;
  /**
   * Continuation Token
   */
  continuation_token: string | null;
};

/**
 * TeamsManifestLastDownloadV1
 */
export type TeamsManifestLastDownloadV1 = {
  /**
   * Manifest Revision
   */
  manifest_revision: number;
  /**
   * Manifest Schema Version
   */
  manifest_schema_version: string;
  /**
   * Edra Manifest Version
   */
  edra_manifest_version: number;
  /**
   * Downloaded At
   */
  downloaded_at: Date;
};

/**
 * TeamsMentionV1
 */
export type TeamsMentionV1 = {
  /**
   * Aad Object Id
   */
  aad_object_id?: string | null;
  /**
   * Name
   */
  name: string;
  /**
   * Mri
   */
  mri?: string | null;
};

/**
 * TeamsOidcFederationSetupV1
 */
export type TeamsOidcFederationSetupV1 = {
  /**
   * Issuer Url
   */
  issuer_url: string;
  /**
   * Subject
   */
  subject?: "edra-teams-bot";
  /**
   * Audience
   */
  audience?: "api://AzureADTokenExchange";
};

/**
 * TeamsOpenIdConfigurationV1
 */
export type TeamsOpenIdConfigurationV1 = {
  /**
   * Issuer
   */
  issuer: string;
  /**
   * Jwks Uri
   */
  jwks_uri: string;
  /**
   * Response Types Supported
   */
  response_types_supported?: Array<string>;
  /**
   * Subject Types Supported
   */
  subject_types_supported?: Array<string>;
  /**
   * Id Token Signing Alg Values Supported
   */
  id_token_signing_alg_values_supported?: Array<string>;
};

/**
 * TeamsPostMessageRequestV1
 */
export type TeamsPostMessageRequestV1 = {
  /**
   * Conversation Id
   */
  conversation_id: string;
  /**
   * Service Url
   */
  service_url: string;
  /**
   * Text Markdown
   */
  text_markdown?: string | null;
  adaptive_card?: TeamsAdaptiveCardV1 | null;
  /**
   * Mentions
   */
  mentions?: Array<TeamsMentionV1>;
  /**
   * Reply To Activity Id
   */
  reply_to_activity_id?: string | null;
};

/**
 * TeamsPostMessageResponseV1
 */
export type TeamsPostMessageResponseV1 = {
  /**
   * Activity Id
   */
  activity_id: string | null;
};

/**
 * TeamsReceiveMessageResponseV1
 */
export type TeamsReceiveMessageResponseV1 = {
  /**
   * Statuscode
   */
  statusCode?: number | null;
  /**
   * Type
   */
  type?: string | null;
  /**
   * Value
   */
  value?: {
    [key: string]: JsonOutput;
  } | null;
  /**
   * Task
   */
  task?: {
    [key: string]: JsonOutput;
  } | null;
};

/**
 * TeamsSendProactiveMessageRequestV1
 */
export type TeamsSendProactiveMessageRequestV1 = {
  /**
   * Conversation Id
   */
  conversation_id: string;
  /**
   * Text Markdown
   */
  text_markdown?: string | null;
  adaptive_card?: TeamsAdaptiveCardV1 | null;
  /**
   * Mentions
   */
  mentions?: Array<TeamsMentionV1>;
};

/**
 * TeamsSendProactiveMessageResponseV1
 */
export type TeamsSendProactiveMessageResponseV1 = {
  /**
   * Activity Id
   */
  activity_id: string | null;
};

/**
 * TeamsSingleTenantBotCredentialsResponseV1
 */
export type TeamsSingleTenantBotCredentialsResponseV1 = {
  /**
   * Bot App Type
   */
  bot_app_type?: "SINGLE_TENANT";
  /**
   * Bot App Id
   */
  bot_app_id: string;
  /**
   * Bot Tenant Id
   */
  bot_tenant_id: string;
  /**
   * Bot App Secret Expires At
   */
  bot_app_secret_expires_at: Date;
};

/**
 * TeamsSingleTenantBotCredentialsV1
 */
export type TeamsSingleTenantBotCredentialsV1 = {
  /**
   * Bot App Type
   */
  bot_app_type: "SINGLE_TENANT";
  /**
   * Bot App Id
   */
  bot_app_id: string;
  /**
   * Bot Tenant Id
   */
  bot_tenant_id: string;
  /**
   * Bot App Secret
   */
  bot_app_secret: string;
  /**
   * Bot App Secret Expires At
   */
  bot_app_secret_expires_at: Date;
};

/**
 * TeamsTenantFullV1
 */
export type TeamsTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * External Manifest Id
   */
  external_manifest_id: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Description
   */
  description: string | null;
  /**
   * Developer Name
   */
  developer_name: string | null;
  /**
   * Developer Website Url
   */
  developer_website_url: string | null;
  /**
   * Privacy Url
   */
  privacy_url: string | null;
  /**
   * Terms Url
   */
  terms_url: string | null;
  credentials: TeamsBotCredentialsResponseV1 | null;
  /**
   * Messaging Endpoint Url
   */
  messaging_endpoint_url: string;
  oidc_federation_setup: TeamsOidcFederationSetupV1;
  /**
   * Manifest Revision
   */
  manifest_revision: number;
  manifest_last_download: TeamsManifestLastDownloadV1 | null;
  /**
   * Manifest Revision Out Of Date
   */
  manifest_revision_out_of_date: boolean;
  /**
   * Manifest Schema Version Out Of Date
   */
  manifest_schema_version_out_of_date: boolean;
  /**
   * Edra Manifest Version Out Of Date
   */
  edra_manifest_version_out_of_date: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * TeamsTenantV1
 */
export type TeamsTenantV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Tenant Name
   */
  tenant_name: string;
  /**
   * External Manifest Id
   */
  external_manifest_id: string;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Description
   */
  description: string | null;
  /**
   * Developer Name
   */
  developer_name: string | null;
  /**
   * Developer Website Url
   */
  developer_website_url: string | null;
  /**
   * Privacy Url
   */
  privacy_url: string | null;
  /**
   * Terms Url
   */
  terms_url: string | null;
  /**
   * Messaging Endpoint Url
   */
  messaging_endpoint_url: string;
  oidc_federation_setup: TeamsOidcFederationSetupV1;
  /**
   * Manifest Revision
   */
  manifest_revision: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * TeamsUpdateMessageRequestV1
 */
export type TeamsUpdateMessageRequestV1 = {
  /**
   * Conversation Id
   */
  conversation_id: string;
  /**
   * Service Url
   */
  service_url: string;
  /**
   * Activity Id
   */
  activity_id: string;
  /**
   * Text Markdown
   */
  text_markdown?: string | null;
  adaptive_card?: TeamsAdaptiveCardV1 | null;
  /**
   * Mentions
   */
  mentions?: Array<TeamsMentionV1>;
};

/**
 * TeamsUpdateMessageResponseV1
 */
export type TeamsUpdateMessageResponseV1 = {
  [key: string]: unknown;
};

/**
 * TeamsUserAssignedManagedIdentityBotCredentialsResponseV1
 */
export type TeamsUserAssignedManagedIdentityBotCredentialsResponseV1 = {
  /**
   * Bot App Type
   */
  bot_app_type?: "USER_ASSIGNED_MANAGED_IDENTITY";
  /**
   * Bot App Id
   */
  bot_app_id: string;
  /**
   * Bot Tenant Id
   */
  bot_tenant_id: string;
};

/**
 * TeamsUserAssignedManagedIdentityBotCredentialsV1
 */
export type TeamsUserAssignedManagedIdentityBotCredentialsV1 = {
  /**
   * Bot App Type
   */
  bot_app_type: "USER_ASSIGNED_MANAGED_IDENTITY";
  /**
   * Bot App Id
   */
  bot_app_id: string;
  /**
   * Bot Tenant Id
   */
  bot_tenant_id: string;
};

/**
 * TimeBucketV1
 */
export const TimeBucketV1 = {
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
  QUARTER: "QUARTER",
  YEAR: "YEAR",
} as const;

/**
 * TimeBucketV1
 */
export type TimeBucketV1 = (typeof TimeBucketV1)[keyof typeof TimeBucketV1];

export type ToolCallArgsV1 = {
  [key: string]: JsonOutput;
};

export type ToolCallResultV1 = {
  [key: string]: JsonOutput;
};

/**
 * UnknownIncomingKbV1
 */
export type UnknownIncomingKbV1 = {
  /**
   * Task Id
   */
  task_id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Patches
   */
  patches: Array<GitPatchV2>;
};

/**
 * UpdateAgentSessionV1
 */
export type UpdateAgentSessionV1 = {
  /**
   * Title
   */
  title?: string | Missing;
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: string;
      }
    | Missing;
};

/**
 * UpdateApiKeyParamsV1
 */
export type UpdateApiKeyParamsV1 = {
  /**
   * Display Name
   */
  display_name?: string | Missing;
};

/**
 * UpdateArticleLineRangeCommentThreadParamsV1
 */
export type UpdateArticleLineRangeCommentThreadParamsV1 = {
  /**
   * Resolved
   */
  resolved?: boolean | Missing;
};

/**
 * UpdateCalibrationFeedbackVerdictDimensionParamsV1
 */
export type UpdateCalibrationFeedbackVerdictDimensionParamsV1 = {
  /**
   * Dimension Value Id
   */
  dimension_value_id: number;
};

/**
 * UpdateCalibrationFeedbackVerdictParamsV1
 */
export type UpdateCalibrationFeedbackVerdictParamsV1 = {
  /**
   * Queue Item Id
   */
  queue_item_id?: number | null;
  /**
   * Reasoning
   */
  reasoning?: string | Missing | null;
  /**
   * Dimensions
   */
  dimensions?:
    | Array<UpdateCalibrationFeedbackVerdictDimensionParamsV1>
    | Missing;
};

/**
 * UpdateChangeRequestLineRangeCommentThreadParamsV1
 */
export type UpdateChangeRequestLineRangeCommentThreadParamsV1 = {
  /**
   * Resolved
   */
  resolved?: boolean | Missing;
};

/**
 * UpdateChangeRequestParamsV1
 */
export type UpdateChangeRequestParamsV1 = {
  /**
   * From Branch
   */
  from_branch?: string | Missing;
  /**
   * To Branch
   */
  to_branch?: string | Missing;
  /**
   * Title
   */
  title?: string | Missing;
  /**
   * Description
   */
  description?: string | Missing;
  /**
   * Status Kind
   */
  status_kind?: ChangeRequestStatusKindV1 | Missing;
  /**
   * Added Tags
   */
  added_tags?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Removed Tags
   */
  removed_tags?: Array<string> | Missing;
  /**
   * Added Assignees
   */
  added_assignees?: Array<number> | Missing;
  /**
   * Removed Assignees
   */
  removed_assignees?: Array<number> | Missing;
};

/**
 * UpdateCommentParamsV1
 */
export type UpdateCommentParamsV1 = {
  /**
   * Content
   */
  content?: string | Missing;
};

/**
 * UpdateConfluencePageParamsV1
 */
export type UpdateConfluencePageParamsV1 = {
  /**
   * Version Number
   */
  version_number: number;
  /**
   * Title
   */
  title?: string | Missing;
  /**
   * Body
   */
  body?: Array<ConfluenceAdfV1> | Missing;
};

/**
 * UpdateConfluenceTenantCredentialsParamsV1
 */
export type UpdateConfluenceTenantCredentialsParamsV1 = {
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
};

/**
 * UpdateConfluenceTenantParamsV1
 */
export type UpdateConfluenceTenantParamsV1 = {
  /**
   * Credentials
   */
  credentials?: UpdateConfluenceTenantCredentialsParamsV1 | Missing;
  /**
   * Scopes
   */
  scopes?: Array<ConfluenceOauthScope> | Missing;
};

/**
 * UpdateConversationMessageResponseV1
 *
 * A message in a conversation.
 */
export type UpdateConversationMessageResponseV1 = {
  /**
   * Content
   *
   * The message content.
   */
  content: string;
  /**
   * Role
   *
   * The role of the message sender.
   */
  role: string;
  /**
   * Message Id
   *
   * The unique identifier of the message.
   */
  message_id?: string | null;
  /**
   * Created At
   *
   * The timestamp of when the message was created.
   */
  created_at?: Date | null;
  /**
   * Metadata
   *
   * Additional metadata associated with the message, used during inference.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Message tags.
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * UpdateConversationPayloadV1
 *
 * A conversation between a user and an assistant.
 */
export type UpdateConversationPayloadV1 = {
  /**
   * Task Id
   *
   * Unique identifier of the task being used.
   */
  task_id: number;
  /**
   * Messages
   *
   * The messages in the conversation.
   */
  messages: Array<ConversationMessageV1>;
  /**
   * Created At
   *
   * The timestamp of when the conversation was created.
   */
  created_at?: Date | Missing;
  /**
   * Metadata
   *
   * Additional metadata associated with the conversation, used during inference.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Conversation tags.
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * UpdateConversationResponseV1
 */
export type UpdateConversationResponseV1 = {
  /**
   * Task Id
   *
   * Unique identifier of the task being used.
   */
  task_id: number;
  /**
   * Messages
   *
   * The messages in the conversation.
   */
  messages: Array<UpdateConversationMessageResponseV1>;
  /**
   * Created At
   *
   * The timestamp of when the conversation was created.
   */
  created_at?: Date | null;
  /**
   * Metadata
   *
   * Additional metadata associated with the conversation, used during inference.
   */
  metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Tags
   *
   * Conversation tags.
   */
  tags?: {
    [key: string]: string;
  };
};

/**
 * UpdateCurrentUserParamsV1
 */
export type UpdateCurrentUserParamsV1 = {
  /**
   * First Name
   */
  first_name?: string | Missing | null;
  /**
   * Last Name
   */
  last_name?: string | Missing | null;
  /**
   * Avatar Asset Path
   */
  avatar_asset_path?: string | Missing | null;
};

/**
 * UpdateDataDumpConversationParamsV1
 */
export type UpdateDataDumpConversationParamsV1 = {
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Tags
   */
  tags?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * External Created At
   */
  external_created_at?: Date | Missing | null;
};

/**
 * UpdateDatapointV2
 */
export type UpdateDatapointV2 = {
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Tags
   */
  tags?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * External Created At
   */
  external_created_at?: Date | Missing | null;
};

/**
 * UpdateDatapointsResponseV3
 */
export type UpdateDatapointsResponseV3 = {
  /**
   * Datapoints
   */
  datapoints: Array<DatapointV2>;
};

/**
 * UpdateEntraTenantParamsV1
 */
export type UpdateEntraTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name?: string | Missing;
  /**
   * Credentials
   */
  credentials?: EntraTenantCredentialsParamsV1 | Missing;
  /**
   * Caller Token Mode
   */
  caller_token_mode?: EntraCallerTokenModeV1 | Missing | null;
  /**
   * Administrative Unit Object Id
   */
  administrative_unit_object_id?: string | Missing | null;
  /**
   * Scope Group Object Ids
   */
  scope_group_object_ids?: Array<string> | Missing;
};

/**
 * UpdateEventSourceNotificationSettingsV1
 */
export type UpdateEventSourceNotificationSettingsV1 = {
  /**
   * Slack
   */
  slack?: SlackNotificationSettingV1 | Missing | null;
  /**
   * Email
   */
  email?: EmailNotificationSettingV1 | Missing | null;
};

/**
 * UpdateExternalInferenceParamsV1
 */
export type UpdateExternalInferenceParamsV1 = {
  /**
   * Message Id
   */
  message_id?: number | Missing;
  /**
   * External Created At
   */
  external_created_at?: Date | Missing;
  /**
   * Add Citations
   */
  add_citations?: Array<CreateExternalInferenceCitationV1>;
  /**
   * Remove Citation Ids
   */
  remove_citation_ids?: Array<number>;
};

/**
 * UpdateFinalizedConversationConversationV1
 */
export type UpdateFinalizedConversationConversationV1 = {
  /**
   * Added Messages
   */
  added_messages: Array<CreateConversationMessageV1>;
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Tags
   */
  tags?:
    | {
        [key: string]: string;
      }
    | Missing;
};

/**
 * UpdateFinalizedConversationMessageParamsV1
 */
export type UpdateFinalizedConversationMessageParamsV1 = {
  /**
   * External Created At
   */
  external_created_at?: Date | Missing | null;
};

/**
 * UpdateFinalizedConversationParamsV1
 */
export type UpdateFinalizedConversationParamsV1 = {
  /**
   * Title
   */
  title?: string | Missing;
  /**
   * External Url
   */
  external_url?: string | Missing | null;
  /**
   * External Created At
   */
  external_created_at?: Date | Missing;
  /**
   * Model
   */
  model?: UpdateFinalizedConversationConversationV1 | Missing;
  /**
   * View
   */
  view?: UpdateFinalizedConversationConversationV1 | Missing;
};

/**
 * UpdateFinalizedConversationV1
 */
export type UpdateFinalizedConversationV1 = {
  /**
   * Finalized Conversation Id
   */
  finalized_conversation_id: number;
  params: UpdateFinalizedConversationParamsV1;
};

/**
 * UpdateFreshserviceArticleParamsV1
 */
export type UpdateFreshserviceArticleParamsV1 = {
  /**
   * Title
   */
  title?: SanitizedStr | Missing;
  /**
   * Description
   */
  description?: SanitizedStr | Missing;
  /**
   * Status
   */
  status?: FreshserviceArticleStatusV1 | Missing;
};

/**
 * UpdateFreshserviceTenantParamsV1
 */
export type UpdateFreshserviceTenantParamsV1 = {
  /**
   * Api Key
   */
  api_key?: NonEmptyStr | Missing;
  /**
   * Tenant Name
   */
  tenant_name?: NonEmptyStr | Missing;
};

/**
 * UpdateFreshserviceTicketParamsV1
 */
export type UpdateFreshserviceTicketParamsV1 = {
  /**
   * Status
   */
  status?: FreshserviceTicketStatusV1 | Missing;
  /**
   * Impact
   */
  impact?: FreshserviceTicketImpactV1 | Missing;
  /**
   * Urgency
   */
  urgency?: FreshserviceTicketUrgencyV1 | Missing;
  /**
   * Tags
   */
  tags?: Array<SanitizedStr> | Missing;
};

/**
 * UpdateHubSpotTenantCredentialsParamsV1
 */
export type UpdateHubSpotTenantCredentialsParamsV1 = {
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
  /**
   * Access Token
   */
  access_token: string;
};

/**
 * UpdateHubSpotTenantInstallationParamsV1
 */
export type UpdateHubSpotTenantInstallationParamsV1 = {
  /**
   * External App Id
   */
  external_app_id: string;
  /**
   * External Portal Id
   */
  external_portal_id: string;
};

/**
 * UpdateHubSpotTenantParamsV1
 */
export type UpdateHubSpotTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name?: string | Missing;
  /**
   * Credentials
   */
  credentials?: UpdateHubSpotTenantCredentialsParamsV1 | Missing;
  /**
   * Installation
   */
  installation?: UpdateHubSpotTenantInstallationParamsV1 | Missing;
};

/**
 * UpdateIndexTextParamsV2
 */
export type UpdateIndexTextParamsV2 = {
  /**
   * Index Text
   */
  index_text: string;
};

/**
 * UpdateInferenceConversationInferenceParamsV1
 */
export type UpdateInferenceConversationInferenceParamsV1 = {
  /**
   * Added Tags
   */
  added_tags?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Removed Tags
   */
  removed_tags?: Array<string> | Missing;
};

/**
 * UpdateInferenceDatapointParamsV1
 */
export type UpdateInferenceDatapointParamsV1 = {
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Tags
   */
  tags?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Finalized Conversation Spans
   */
  finalized_conversation_spans?: InferenceDatapointSpansV1 | Missing;
};

/**
 * UpdateInvitationParamsV1
 */
export type UpdateInvitationParamsV1 = {
  /**
   * Add Team Ids
   */
  add_team_ids?: Array<number> | Missing;
  /**
   * Remove Team Ids
   */
  remove_team_ids?: Array<number> | Missing;
};

/**
 * UpdateJiraTenantParamsV1
 */
export type UpdateJiraTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name?: string | Missing;
  /**
   * Base Url
   */
  base_url?: string | Missing;
  /**
   * Installation Id
   */
  installation_id?: string | Missing;
  /**
   * Action Api Path
   */
  action_api_path?: string | Missing;
  /**
   * Api Key
   */
  api_key?: string | Missing;
  /**
   * Webhook Secret
   */
  webhook_secret?: string | Missing;
};

/**
 * UpdateJudgeParamsV1
 */
export type UpdateJudgeParamsV1 = {
  /**
   * Name
   */
  name?: string | Missing;
};

/**
 * UpdateKanonicalDatapointV1
 */
export type UpdateKanonicalDatapointV1 = {
  /**
   * Title
   */
  title?: string | Missing | null;
  /**
   * Summary
   */
  summary?: string | Missing | null;
  /**
   * Model
   */
  model?: CreateKanonicalInputOutputV2 | Missing;
  /**
   * View
   */
  view?: CreateKanonicalInputOutputV2 | Missing;
  /**
   * Added Datapoint Ids
   */
  added_datapoint_ids?: Array<number>;
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Tags
   */
  tags?:
    | {
        [key: string]: string;
      }
    | Missing;
};

/**
 * UpdateMachineUserParamsV1
 */
export type UpdateMachineUserParamsV1 = {
  /**
   * Display Name
   */
  display_name?: string | Missing;
  /**
   * Team Ids
   */
  team_ids?: Array<number> | Missing;
};

/**
 * UpdateNotificationSettingsParamsV1
 */
export type UpdateNotificationSettingsParamsV1 = {
  /**
   * Change Request Assigned
   */
  change_request_assigned?:
    | UpdateEventSourceNotificationSettingsV1
    | Missing
    | null;
  /**
   * Comment Mention
   */
  comment_mention?: UpdateEventSourceNotificationSettingsV1 | Missing | null;
};

/**
 * UpdateNotionBlockParamsV1
 */
export type UpdateNotionBlockParamsV1 = {
  block: NotionBlockInputV1;
};

/**
 * UpdateNotionPageParamsV1
 */
export type UpdateNotionPageParamsV1 = {
  /**
   * Title
   */
  title?: string | Missing;
};

/**
 * UpdateOAuthApplicationParamsV1
 */
export type UpdateOAuthApplicationParamsV1 = {
  /**
   * Redirect Uris
   */
  redirect_uris?: Array<string> | Missing;
};

/**
 * UpdateOrgMemberParamsV1
 */
export type UpdateOrgMemberParamsV1 = {
  /**
   * Role
   */
  role?: OrgMemberRoleV1 | Missing;
};

/**
 * UpdateOrganizationParamsV1
 */
export type UpdateOrganizationParamsV1 = {
  /**
   * Name
   */
  name?: string | Missing;
  /**
   * Logo Asset Path
   */
  logo_asset_path?: string | Missing | null;
};

/**
 * UpdatePlainTenantParamsV1
 */
export type UpdatePlainTenantParamsV1 = {
  /**
   * Name
   */
  name?: string | Missing;
  /**
   * Permissions
   */
  permissions?: Array<PlainPermissionV1> | Missing;
  /**
   * Api Credentials
   */
  api_credentials?: PlainApiCredentialsParamsV1 | Missing;
  /**
   * Webhook Credentials
   */
  webhook_credentials?: PlainWebhookCredentialsParamsV1 | Missing;
};

/**
 * UpdateSalesforceArticleParamsV1
 */
export type UpdateSalesforceArticleParamsV1 = {
  /**
   * Title
   */
  title?: string | Missing;
  /**
   * Summary
   */
  summary?: string | Missing;
};

/**
 * UpdateSalesforceCaseParamsV1
 */
export type UpdateSalesforceCaseParamsV1 = {
  /**
   * Subject
   */
  subject?: string | Missing;
  /**
   * Description
   */
  description?: string | Missing;
  /**
   * Status
   */
  status?: string | Missing;
  /**
   * Priority
   */
  priority?: string | Missing;
  /**
   * Origin
   */
  origin?: string | Missing;
  /**
   * Type
   */
  type?: string | Missing;
  /**
   * Reason
   */
  reason?: string | Missing;
  /**
   * Is Escalated
   */
  is_escalated?: boolean | Missing;
  /**
   * Parent Id
   */
  parent_id?: string | Missing;
  /**
   * Record Type Id
   */
  record_type_id?: string | Missing;
  /**
   * Owner Id
   */
  owner_id?: string | Missing;
  /**
   * Contact Id
   */
  contact_id?: string | Missing;
  /**
   * Account Id
   */
  account_id?: string | Missing;
  /**
   * Supplied Name
   */
  supplied_name?: string | Missing;
  /**
   * Supplied Email
   */
  supplied_email?: string | Missing;
  /**
   * Supplied Phone
   */
  supplied_phone?: string | Missing;
  /**
   * Supplied Company
   */
  supplied_company?: string | Missing;
  /**
   * Custom Fields
   */
  custom_fields?:
    | {
        [key: string]: JsonInput;
      }
    | Missing;
};

/**
 * UpdateSalesforceIngestClientParamsV1
 */
export type UpdateSalesforceIngestClientParamsV1 = {
  /**
   * Label
   */
  label: string | null;
};

/**
 * UpdateSalesforceTenantCredentialsParamsV1
 */
export type UpdateSalesforceTenantCredentialsParamsV1 = {
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
};

/**
 * UpdateSalesforceTenantParamsV1
 */
export type UpdateSalesforceTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name?: string | Missing;
  /**
   * Credentials
   */
  credentials?: UpdateSalesforceTenantCredentialsParamsV1 | Missing;
  /**
   * Case Comment Created By Id
   */
  case_comment_created_by_id?: string | Missing | null;
};

/**
 * UpdateSecretParamsV1
 */
export type UpdateSecretParamsV1 = {
  /**
   * Description
   */
  description?: string | Missing;
};

/**
 * UpdateSecretVersionParamsV1
 */
export type UpdateSecretVersionParamsV1 = {
  /**
   * Description
   */
  description?: string | Missing;
};

/**
 * UpdateServiceNowArticleV1
 */
export type UpdateServiceNowArticleV1 = {
  /**
   * Short Description
   */
  short_description?: SanitizedStr | Missing;
  /**
   * Text
   */
  text?: SanitizedStr | Missing;
  /**
   * Knowledge Base Sys Id
   */
  knowledge_base_sys_id?: SanitizedStr | Missing;
};

/**
 * UpdateServiceNowKnowledgeBaseV1
 */
export type UpdateServiceNowKnowledgeBaseV1 = {
  /**
   * Title
   */
  title?: SanitizedStr | Missing;
  /**
   * Description
   */
  description?: SanitizedStr | Missing | null;
  /**
   * Active
   */
  active?: boolean | Missing;
};

/**
 * UpdateSharepointItemParamsV1
 */
export type UpdateSharepointItemParamsV1 = {
  /**
   * Name
   */
  name?: string | Missing;
  /**
   * Parent Item Id
   */
  parent_item_id?: string | Missing;
};

/**
 * UpdateSimulationDatapointParamsV1
 */
export type UpdateSimulationDatapointParamsV1 = {
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Tags
   */
  tags?:
    | {
        [key: string]: string;
      }
    | Missing;
};

/**
 * UpdateSimulationResultParamsV1
 */
export type UpdateSimulationResultParamsV1 = {
  /**
   * Metadata
   */
  metadata?:
    | {
        [key: string]: string;
      }
    | Missing;
  /**
   * Tags
   */
  tags?:
    | {
        [key: string]: string;
      }
    | Missing;
};

/**
 * UpdateSlackTenantCredentialsParamsV1
 */
export type UpdateSlackTenantCredentialsParamsV1 = {
  /**
   * App Id
   */
  app_id: string;
  /**
   * Client Id
   */
  client_id: string;
  /**
   * Client Secret
   */
  client_secret: string;
  /**
   * Signing Secret
   */
  signing_secret: string;
};

/**
 * UpdateSlackTenantParamsV1
 */
export type UpdateSlackTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name?: string | Missing;
  /**
   * Description
   */
  description?: string | Missing;
  /**
   * Background Color
   */
  background_color?: string | Missing;
  /**
   * Credentials
   */
  credentials?: UpdateSlackTenantCredentialsParamsV1 | Missing;
  /**
   * Scopes
   */
  scopes?: Array<SlackOauthScope> | Missing;
};

/**
 * UpdateTaskParamsV2
 */
export type UpdateTaskParamsV2 = {
  /**
   * Name
   */
  name?: string | Missing;
  /**
   * Task Template
   */
  task_template?: string | Missing;
};

/**
 * UpdateTeamParamsV1
 */
export type UpdateTeamParamsV1 = {
  /**
   * Name
   */
  name?: string | Missing;
  /**
   * Add Member Ids
   */
  add_member_ids?: Array<number> | Missing;
  /**
   * Remove Member Ids
   */
  remove_member_ids?: Array<number> | Missing;
};

/**
 * UpdateTeamsTenantParamsV1
 */
export type UpdateTeamsTenantParamsV1 = {
  /**
   * Tenant Name
   */
  tenant_name?: string | Missing;
  /**
   * Display Name
   */
  display_name?: string | Missing;
  /**
   * Description
   */
  description?: string | Missing | null;
  /**
   * Developer Name
   */
  developer_name?: string | Missing | null;
  /**
   * Developer Website Url
   */
  developer_website_url?: string | Missing | null;
  /**
   * Privacy Url
   */
  privacy_url?: string | Missing | null;
  /**
   * Terms Url
   */
  terms_url?: string | Missing | null;
  /**
   * Bot Credentials
   */
  bot_credentials?: TeamsBotCredentialsV1 | Missing;
};

/**
 * UpdateTenantParamsV1
 */
export type UpdateTenantParamsV1 = {
  /**
   * Comment Fetch Strategy
   */
  comment_fetch_strategy?: ServiceNowCommentFetchStrategyV1 | Missing;
};

/**
 * UpdateWorkflowRunRequestV1
 */
export type UpdateWorkflowRunRequestV1 = {
  /**
   * Status
   */
  status?: WorkflowStatusKindV1 | Missing;
};

/**
 * UpdateWorkflowRunResponseV1
 */
export type UpdateWorkflowRunResponseV1 = {
  workflow_run: WorkflowRunV1;
};

/**
 * UploadUrlRequestV1
 */
export type UploadUrlRequestV1 = {
  filename: SanitizedStr;
  content_type: SanitizedStr;
};

/**
 * UploadUrlRequestV2
 */
export type UploadUrlRequestV2 = {
  filename: SanitizedStr;
  content_type: AttachmentMediaTypeV1;
  /**
   * Size
   */
  size: number;
};

/**
 * UploadUrlResponseV1
 */
export type UploadUrlResponseV1 = {
  upload_url: SanitizedStr;
  uri: SanitizedStr;
  file_path: SanitizedStr;
  full_path: SanitizedStr;
};

/**
 * UploadUrlResponseV2
 */
export type UploadUrlResponseV2 = {
  upload_url: SanitizedStr;
  uri: SanitizedStr;
  file_path: SanitizedStr;
  full_path: SanitizedStr;
};

/**
 * UpsertInferenceConversationPayloadV1
 *
 * Upsert a conversation.
 */
export type UpsertInferenceConversationPayloadV1 = {
  /**
   * Task Id
   *
   * Unique identifier of the task.
   */
  task_id: number;
  /**
   * Messages
   *
   * The messages in the conversation.
   */
  messages: Array<CreateConversationMessageV1>;
  /**
   * Created At
   *
   * The timestamp of when the conversation was created.
   */
  created_at?: Date | Missing;
  /**
   * Added Metadata
   *
   * Metadata keys to add or update on the conversation.
   */
  added_metadata?: {
    [key in SanitizedStr]?: SanitizedStr;
  };
  /**
   * Removed Metadata
   *
   * Metadata keys to remove from the conversation.
   */
  removed_metadata?: Array<SanitizedStr>;
  /**
   * Added Tags
   *
   * Tags to add or update on the conversation.
   */
  added_tags?: {
    [key: string]: string;
  };
  /**
   * Removed Tags
   *
   * Tag keys to remove from the conversation.
   */
  removed_tags?: Array<string>;
};

/**
 * UpsertOrganizationParamsV1
 */
export type UpsertOrganizationParamsV1 = {
  /**
   * Name
   */
  name: string;
};

/**
 * UserActionsTotalV2
 */
export type UserActionsTotalV2 = {
  user: UserFullV1;
  /**
   * Total
   */
  total: number;
};

/**
 * UserActivityDataPointV2
 */
export type UserActivityDataPointV2 = {
  /**
   * Week Start
   */
  week_start: Date;
  /**
   * Count
   */
  count: number;
};

/**
 * UserActivitySeriesV2
 */
export type UserActivitySeriesV2 = {
  user: UserFullV1;
  /**
   * Data
   */
  data: Array<UserActivityDataPointV2>;
};

/**
 * UserBotV1
 */
export type UserBotV1 = {
  /**
   * Kind
   */
  kind: "BOT";
  /**
   * Name
   */
  name: string;
  /**
   * Display Name
   */
  display_name: string;
};

/**
 * UserExternalV1
 */
export type UserExternalV1 = {
  /**
   * Kind
   */
  kind: "EXTERNAL";
  /**
   * External Id
   */
  external_id: string;
  /**
   * First Name
   */
  first_name: string | null;
  /**
   * Last Name
   */
  last_name: string | null;
  /**
   * Email
   */
  email: string | null;
  /**
   * Avatar Url
   */
  avatar_url: string | null;
};

/**
 * UserFullV1
 */
export type UserFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Variant
   */
  variant: UserBotV1 | UserExternalV1;
  membership: UserOrgMembershipV1 | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * UserOrgMembershipV1
 */
export type UserOrgMembershipV1 = {
  organization: UserOrganizationV1;
  role: OrgMembershipRoleV1;
};

/**
 * UserOrganizationV1
 */
export type UserOrganizationV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Name
   */
  name: string;
  /**
   * Slug
   */
  slug: string | null;
  /**
   * Logo Url
   */
  logo_url: string | null;
};

/**
 * UserV1
 */
export type UserV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ValidationError
 */
export type ValidationError = {
  /**
   * Location
   */
  loc: Array<string | number>;
  /**
   * Message
   */
  msg: string;
  /**
   * Error Type
   */
  type: string;
  /**
   * Input
   */
  input?: unknown;
  /**
   * Context
   */
  ctx?: {
    [key: string]: unknown;
  };
};

/**
 * ValkeyPingV1
 */
export type ValkeyPingV1 = {
  response: SanitizedStr;
};

/**
 * ValkeyValueV1
 */
export type ValkeyValueV1 = {
  key: SanitizedStr;
  value: SanitizedStr | null;
};

/**
 * VerificationMetricsResponseV2
 */
export type VerificationMetricsResponseV2 = {
  /**
   * Verified Count
   */
  verified_count: number;
  /**
   * Total Count
   */
  total_count: number;
};

/**
 * VisibilityFilterV1
 */
export const VisibilityFilterV1 = {
  ALL: "all",
  ACTIVE: "active",
  DELETED: "deleted",
} as const;

/**
 * VisibilityFilterV1
 */
export type VisibilityFilterV1 =
  (typeof VisibilityFilterV1)[keyof typeof VisibilityFilterV1];

/**
 * VisibilityV1
 */
export const VisibilityV1 = {
  ALL: "all",
  ACTIVE: "active",
  DELETED: "deleted",
} as const;

/**
 * VisibilityV1
 */
export type VisibilityV1 = (typeof VisibilityV1)[keyof typeof VisibilityV1];

/**
 * VisibleArticleContentV1
 */
export type VisibleArticleContentV1 = {
  /**
   * Kind
   */
  kind?: "VISIBLE";
  /**
   * Title
   */
  title: string;
  /**
   * Path
   */
  path: string;
  /**
   * Verified
   */
  verified: boolean;
  snippet: SearchSnippetV1;
};

/**
 * VisibleChangeRequestContentV1
 */
export type VisibleChangeRequestContentV1 = {
  /**
   * Kind
   */
  kind?: "VISIBLE";
  /**
   * Title
   */
  title: string;
  status_kind: ChangeRequestStatusKindV1;
  /**
   * Created By
   */
  created_by: number;
  snippet: SearchSnippetV1;
};

/**
 * VisibleKnowledgeBaseContentV1
 */
export type VisibleKnowledgeBaseContentV1 = {
  /**
   * Kind
   */
  kind?: "VISIBLE";
  /**
   * Name
   */
  name: string;
  /**
   * External Id
   */
  external_id: string | null;
  snippet: SearchSnippetV1;
};

/**
 * WorkClaimStatusV1
 */
export const WorkClaimStatusV1 = {
  PENDING: "PENDING",
  PROCESSED: "PROCESSED",
} as const;

/**
 * WorkClaimStatusV1
 */
export type WorkClaimStatusV1 =
  (typeof WorkClaimStatusV1)[keyof typeof WorkClaimStatusV1];

/**
 * WorkClaimV1
 */
export type WorkClaimV1 = {
  /**
   * Id
   */
  id: number;
  status: WorkClaimStatusV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * WorkEventFullV1
 */
export type WorkEventFullV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Stream Id
   */
  stream_id: string;
  /**
   * Caused By Event Id
   */
  caused_by_event_id: number | null;
  /**
   * Event Type
   */
  event_type: string;
  /**
   * Payload
   */
  payload: {
    [key: string]: JsonOutput;
  };
  /**
   * Repo Ids
   */
  repo_ids: Array<number>;
  /**
   * Git Object Ids
   */
  git_object_ids: Array<number>;
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * WorkEventV1
 */
export type WorkEventV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Stream Id
   */
  stream_id: string;
  /**
   * Caused By Event Id
   */
  caused_by_event_id: number | null;
  /**
   * Event Type
   */
  event_type: string;
  /**
   * Payload
   */
  payload: {
    [key: string]: JsonOutput;
  };
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * WorkflowAnalyticsEventKindV1
 */
export const WorkflowAnalyticsEventKindV1 = {
  CUSTOM: "CUSTOM",
  PLATFORM: "PLATFORM",
} as const;

/**
 * WorkflowAnalyticsEventKindV1
 */
export type WorkflowAnalyticsEventKindV1 =
  (typeof WorkflowAnalyticsEventKindV1)[keyof typeof WorkflowAnalyticsEventKindV1];

/**
 * WorkflowAnalyticsEventV1
 */
export type WorkflowAnalyticsEventV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Workflow Run Id
   */
  workflow_run_id: number;
  /**
   * Event Name
   */
  event_name: string;
  event_type: WorkflowAnalyticsEventKindV1;
  /**
   * Additional Fields
   */
  additional_fields: {
    [key: string]: JsonOutput;
  };
  /**
   * Created At
   */
  created_at: Date;
};

/**
 * WorkflowKindV1
 */
export const WorkflowKindV1 = {
  BROWSER_EXTENSION_SCRAPE_PAGE: "BROWSER_EXTENSION_SCRAPE_PAGE",
  SLACK: "SLACK",
  OUTLOOK_MESSAGE: "OUTLOOK_MESSAGE",
  JIRA_ISSUE: "JIRA_ISSUE",
  SERVICE_NOW_TICKET: "SERVICE_NOW_TICKET",
  ZENDESK_TICKET: "ZENDESK_TICKET",
  HUBSPOT_EVENT: "HUBSPOT_EVENT",
  TEAMS: "TEAMS",
  NOTION: "NOTION",
  SALESFORCE: "SALESFORCE",
  FRESHSERVICE_TICKET: "FRESHSERVICE_TICKET",
  PLAIN: "PLAIN",
  SHAREPOINT: "SHAREPOINT",
  PLATFORM: "PLATFORM",
} as const;

/**
 * WorkflowKindV1
 */
export type WorkflowKindV1 =
  (typeof WorkflowKindV1)[keyof typeof WorkflowKindV1];

/**
 * WorkflowRunFullV1
 */
export type WorkflowRunFullV1 = {
  /**
   * Id
   */
  id: number;
  trigger: WorkflowTriggerV1;
  workflow: WorkflowV1;
  status: WorkflowRunStatusV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

export type WorkflowRunStatusV1 =
  | ({
      kind: "SUCCEEDED";
    } & SucceededWorkflowRunV1)
  | ({
      kind: "FAILED";
    } & FailedWorkflowRunV1)
  | ({
      kind: "PENDING";
    } & PendingWorkflowRunV1)
  | ({
      kind: "RUNNING";
    } & RunningWorkflowRunV1);

/**
 * WorkflowRunV1
 */
export type WorkflowRunV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * WorkflowStatusKindV1
 */
export const WorkflowStatusKindV1 = {
  PENDING: "PENDING",
  RUNNING: "RUNNING",
  FAILED: "FAILED",
  SUCCEEDED: "SUCCEEDED",
} as const;

/**
 * WorkflowStatusKindV1
 */
export type WorkflowStatusKindV1 =
  (typeof WorkflowStatusKindV1)[keyof typeof WorkflowStatusKindV1];

/**
 * WorkflowTriggerV1
 */
export type WorkflowTriggerV1 = {
  /**
   * Id
   */
  id: number;
  kind: WorkflowKindV1;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * WorkflowV1
 */
export type WorkflowV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Display Name
   */
  display_name: string;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * WorkspaceV1
 */
export type WorkspaceV1 = {
  /**
   * Repository Id
   */
  repository_id: number;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * XAxisLabelsDateV1
 */
export type XAxisLabelsDateV1 = {
  /**
   * Type
   */
  type: "date";
  /**
   * Values
   */
  values: Array<Date>;
};

/**
 * XAxisLabelsTextV1
 */
export type XAxisLabelsTextV1 = {
  /**
   * Type
   */
  type: "text";
  /**
   * Values
   */
  values: Array<SanitizedStr>;
};

/**
 * ZendeskArticleAttachmentListV1
 */
export type ZendeskArticleAttachmentListV1 = {
  /**
   * Article Attachments
   */
  article_attachments: Array<ZendeskArticleAttachmentV1>;
};

/**
 * ZendeskArticleAttachmentV1
 */
export type ZendeskArticleAttachmentV1 = {
  /**
   * Id
   */
  id: number;
  /**
   * Article Id
   */
  article_id?: number | null;
  file_name: SanitizedStr;
  display_file_name?: SanitizedStr | null;
  content_url: SanitizedStr;
  content_type?: SanitizedStr | null;
  /**
   * Size
   */
  size?: number | null;
  /**
   * Inline
   */
  inline?: boolean;
  relative_path?: SanitizedStr | null;
};

/**
 * ZendeskArticlePageV1
 */
export type ZendeskArticlePageV1 = {
  /**
   * Articles
   */
  articles: Array<ZendeskArticleV1>;
  /**
   * Has More
   */
  has_more: boolean;
  after_cursor?: SanitizedStr | null;
  before_cursor?: SanitizedStr | null;
};

/**
 * ZendeskArticleV1
 */
export type ZendeskArticleV1 = {
  /**
   * Id
   */
  id: number;
  title: SanitizedStr;
  body?: SanitizedStr | null;
  locale: SanitizedStr;
  /**
   * Section Id
   */
  section_id: number;
  /**
   * Author Id
   */
  author_id: number | null;
  /**
   * Draft
   */
  draft: boolean;
  /**
   * Promoted
   */
  promoted: boolean;
  created_at: SanitizedStr;
  updated_at: SanitizedStr;
  html_url: SanitizedStr;
};

/**
 * ZendeskCallbackPayloadV1
 */
export type ZendeskCallbackPayloadV1 = {
  code: SanitizedStr;
};

/**
 * ZendeskCategoryPageV1
 */
export type ZendeskCategoryPageV1 = {
  /**
   * Categories
   */
  categories: Array<ZendeskCategoryV1>;
  /**
   * Has More
   */
  has_more: boolean;
  after_cursor?: SanitizedStr | null;
  before_cursor?: SanitizedStr | null;
};

/**
 * ZendeskCategoryV1
 */
export type ZendeskCategoryV1 = {
  /**
   * Id
   */
  id: number;
  name: SanitizedStr;
  description: SanitizedStr;
  html_url: SanitizedStr;
};

/**
 * ZendeskCheckConnectionResponseV1
 */
export type ZendeskCheckConnectionResponseV1 = {
  /**
   * Connected
   */
  connected: boolean;
  detail?: SanitizedStr | null;
};

/**
 * ZendeskCommentAttachmentV1
 */
export type ZendeskCommentAttachmentV1 = {
  /**
   * Id
   */
  id: number;
  file_name: SanitizedStr;
  content_url: SanitizedStr;
  content_type?: SanitizedStr | null;
  /**
   * Size
   */
  size?: number | null;
  /**
   * Inline
   */
  inline?: boolean;
  /**
   * Width
   */
  width?: number | null;
  /**
   * Height
   */
  height?: number | null;
};

/**
 * ZendeskConnectResponseV1
 */
export type ZendeskConnectResponseV1 = {
  authorization_url: SanitizedStr;
};

/**
 * ZendeskCreateTenantV1
 */
export type ZendeskCreateTenantV1 = {
  tenant_name: SanitizedStr;
  subdomain: SanitizedStrAZ09AZ09061AZ09;
  client_id: SanitizedStr;
  client_secret: SanitizedStr;
  oauth_auth_method?: ZendeskOAuthAuthMethod;
  /**
   * Comment Author Id
   */
  comment_author_id?: number | null;
};

/**
 * ZendeskGetTicketAttachmentContentResponseV1
 */
export type ZendeskGetTicketAttachmentContentResponseV1 = {
  /**
   * Attachment Id
   */
  attachment_id: number;
  content: SanitizedStr;
  mime_type: SanitizedStr;
};

/**
 * ZendeskIngestResponseV1
 */
export type ZendeskIngestResponseV1 = {
  /**
   * Workflow Run Ids
   */
  workflow_run_ids: Array<number>;
};

/**
 * ZendeskOAuthAuthMethod
 */
export const ZendeskOAuthAuthMethod = {
  PKCE: "PKCE",
  CLIENT: "CLIENT",
  CLIENT_AND_PKCE: "CLIENT_AND_PKCE",
} as const;

/**
 * ZendeskOAuthAuthMethod
 */
export type ZendeskOAuthAuthMethod =
  (typeof ZendeskOAuthAuthMethod)[keyof typeof ZendeskOAuthAuthMethod];

/**
 * ZendeskOAuthRedirectUriV1
 */
export type ZendeskOAuthRedirectUriV1 = {
  redirect_uri: SanitizedStr;
};

/**
 * ZendeskPatchTenantV1
 */
export type ZendeskPatchTenantV1 = {
  /**
   * Comment Author Id
   */
  comment_author_id?: number | Missing | null;
  /**
   * Oauth Auth Method
   */
  oauth_auth_method?: ZendeskOAuthAuthMethod | Missing;
};

/**
 * ZendeskReplyToTicketRequestV1
 */
export type ZendeskReplyToTicketRequestV1 = {
  /**
   * Tenant Id
   */
  tenant_id: number;
  /**
   * Ticket Id
   */
  ticket_id: number;
  body: SanitizedStr;
  /**
   * Public
   */
  public?: boolean;
  idempotency_key?: SanitizedStr | null;
};

/**
 * ZendeskReplyToTicketResponseV1
 */
export type ZendeskReplyToTicketResponseV1 = {
  /**
   * Zendesk Status Code
   */
  zendesk_status_code: number;
  /**
   * Deduplicated
   */
  deduplicated?: boolean;
};

/**
 * ZendeskReplyV1
 */
export type ZendeskReplyV1 = {
  /**
   * Id
   */
  id: number;
  body: SanitizedStr;
  html_body: SanitizedStr | null;
  /**
   * Public
   */
  public: boolean;
  /**
   * Author Id
   */
  author_id: number | null;
  created_at: SanitizedStr;
  /**
   * Attachments
   */
  attachments?: Array<ZendeskCommentAttachmentV1>;
};

/**
 * ZendeskSectionPageV1
 */
export type ZendeskSectionPageV1 = {
  /**
   * Sections
   */
  sections: Array<ZendeskSectionV1>;
  /**
   * Has More
   */
  has_more: boolean;
  after_cursor?: SanitizedStr | null;
  before_cursor?: SanitizedStr | null;
};

/**
 * ZendeskSectionV1
 */
export type ZendeskSectionV1 = {
  /**
   * Id
   */
  id: number;
  name: SanitizedStr;
  /**
   * Category Id
   */
  category_id: number;
  /**
   * Parent Section Id
   */
  parent_section_id?: number | null;
  html_url: SanitizedStr;
};

export type ZendeskSubdomain = SanitizedStrAZ09AZ09061AZ09;

/**
 * ZendeskTenantFullV1
 */
export type ZendeskTenantFullV1 = {
  /**
   * Id
   */
  id: number;
  tenant_name: SanitizedStr;
  subdomain: SanitizedStr;
  client_id: SanitizedStr;
  oauth_auth_method: ZendeskOAuthAuthMethod;
  /**
   * Comment Author Id
   */
  comment_author_id: number | null;
  /**
   * Has Tokens
   */
  has_tokens: boolean;
  /**
   * Has Webhook
   */
  has_webhook: boolean;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ZendeskTenantV1
 */
export type ZendeskTenantV1 = {
  /**
   * Id
   */
  id: number;
  tenant_name: SanitizedStr;
  subdomain: SanitizedStr;
  client_id: SanitizedStr;
  oauth_auth_method: ZendeskOAuthAuthMethod;
  /**
   * Comment Author Id
   */
  comment_author_id: number | null;
  /**
   * Created At
   */
  created_at: Date;
  /**
   * Updated At
   */
  updated_at: Date;
  /**
   * Deleted At
   */
  deleted_at: Date | null;
};

/**
 * ZendeskTicketFullV1
 */
export type ZendeskTicketFullV1 = {
  /**
   * Id
   */
  id: number;
  subject: SanitizedStr;
  status: SanitizedStr;
  priority?: SanitizedStr | null;
  /**
   * Assignee Id
   */
  assignee_id?: number | null;
  /**
   * Requester Id
   */
  requester_id?: number | null;
  /**
   * Submitter Id
   */
  submitter_id?: number | null;
  /**
   * Group Id
   */
  group_id?: number | null;
  /**
   * Organization Id
   */
  organization_id?: number | null;
  /**
   * Brand Id
   */
  brand_id?: number | null;
  /**
   * Form Id
   */
  form_id?: number | null;
  external_id?: SanitizedStr | null;
  type?: SanitizedStr | null;
  /**
   * Is Public
   */
  is_public?: boolean | null;
  /**
   * Tags
   */
  tags?: Array<SanitizedStr>;
  created_at?: SanitizedStr | null;
  updated_at?: SanitizedStr | null;
  /**
   * Replies
   */
  replies: Array<ZendeskReplyV1>;
};

/**
 * ZendeskTicketPageV1
 */
export type ZendeskTicketPageV1 = {
  /**
   * Tickets
   */
  tickets: Array<ZendeskTicketV1>;
  /**
   * Has More
   */
  has_more: boolean;
  after_cursor?: SanitizedStr | null;
  before_cursor?: SanitizedStr | null;
};

/**
 * ZendeskTicketSearchPageV1
 */
export type ZendeskTicketSearchPageV1 = {
  /**
   * Tickets
   */
  tickets: Array<ZendeskTicketSearchResultV1>;
  /**
   * Has More
   */
  has_more: boolean;
  after_cursor: SanitizedStr | null;
};

/**
 * ZendeskTicketSearchResultV1
 */
export type ZendeskTicketSearchResultV1 = {
  /**
   * Id
   */
  id: number;
  subject: SanitizedStr;
  description: SanitizedStr;
  status: SanitizedStr;
  /**
   * Brand Id
   */
  brand_id?: number | null;
  /**
   * Tags
   */
  tags: Array<SanitizedStr>;
  created_at: SanitizedStr | null;
  updated_at: SanitizedStr | null;
};

/**
 * ZendeskTicketSortV1
 */
export const ZendeskTicketSortV1 = {
  ID_ASC: "id:asc",
  ID_DESC: "id:desc",
  CREATED_AT_ASC: "created_at:asc",
  CREATED_AT_DESC: "created_at:desc",
  UPDATED_AT_ASC: "updated_at:asc",
  UPDATED_AT_DESC: "updated_at:desc",
  STATUS_ASC: "status:asc",
  STATUS_DESC: "status:desc",
  PRIORITY_ASC: "priority:asc",
  PRIORITY_DESC: "priority:desc",
  SUBJECT_ASC: "subject:asc",
  SUBJECT_DESC: "subject:desc",
  TYPE_ASC: "type:asc",
  TYPE_DESC: "type:desc",
} as const;

/**
 * ZendeskTicketSortV1
 */
export type ZendeskTicketSortV1 =
  (typeof ZendeskTicketSortV1)[keyof typeof ZendeskTicketSortV1];

/**
 * ZendeskTicketV1
 */
export type ZendeskTicketV1 = {
  /**
   * Id
   */
  id: number;
  subject: SanitizedStr;
  description: SanitizedStr;
  status: SanitizedStr;
  /**
   * Brand Id
   */
  brand_id?: number | null;
};

/**
 * ZendeskUpdateTicketTagsRequestV1
 */
export type ZendeskUpdateTicketTagsRequestV1 = {
  /**
   * Ticket Id
   */
  ticket_id: number;
  /**
   * Additional Tags
   */
  additional_tags?: Array<NonEmptyStr>;
  /**
   * Remove Tags
   */
  remove_tags?: Array<NonEmptyStr>;
};

/**
 * ZendeskUpdateTicketTagsResponseV1
 */
export type ZendeskUpdateTicketTagsResponseV1 = {
  [key: string]: unknown;
};

/**
 * ZendeskUserListV1
 */
export type ZendeskUserListV1 = {
  /**
   * Users
   */
  users: Array<ZendeskUserV1>;
};

/**
 * ZendeskUserV1
 */
export type ZendeskUserV1 = {
  id: SanitizedStr;
  role: SanitizedStr;
};

/**
 * ZendeskWebhookProvisionResponseV1
 */
export type ZendeskWebhookProvisionResponseV1 = {
  webhook_id: SanitizedStr;
};

/**
 * AgentErrorEventV1
 */
export type AgentErrorEventV1 = {
  /**
   * Kind
   */
  kind: "error";
  /**
   * Text
   */
  text: string;
};

/**
 * AgentMessageSocketEventV1
 */
export type AgentMessageSocketEventV1 = {
  /**
   * Kind
   */
  kind: "message";
  /**
   * Message Id
   */
  message_id: number;
  /**
   * Content Blocks
   */
  content_blocks: Array<AgentTraceMessageContentBlockV1>;
};

/**
 * AgentReasoningSocketEventV1
 */
export type AgentReasoningSocketEventV1 = {
  /**
   * Kind
   */
  kind: "reasoning";
  /**
   * Message Id
   */
  message_id: number;
  /**
   * Text
   */
  text: string;
  /**
   * Signature
   */
  signature?: string | null;
};

export type AgentSocketEventV1 =
  | ({
      kind: "status";
    } & AgentStatusEventV1)
  | ({
      kind: "error";
    } & AgentErrorEventV1)
  | ({
      kind: "text";
    } & AgentTextSocketEventV1)
  | ({
      kind: "tool_call";
    } & AgentToolCallSocketEventV1)
  | ({
      kind: "tool_call_result";
    } & AgentToolCallResultSocketEventV1)
  | ({
      kind: "reasoning";
    } & AgentReasoningSocketEventV1)
  | ({
      kind: "title";
    } & AgentTitleSocketEventV1)
  | ({
      kind: "turn_end";
    } & AgentTurnEndEventV1)
  | ({
      kind: "message";
    } & AgentMessageSocketEventV1);

/**
 * AgentStatusEventV1
 */
export type AgentStatusEventV1 = {
  /**
   * Kind
   */
  kind: "status";
  /**
   * Text
   */
  text: string;
};

/**
 * AgentTextSocketEventV1
 */
export type AgentTextSocketEventV1 = {
  /**
   * Kind
   */
  kind: "text";
  /**
   * Message Id
   */
  message_id: number;
  /**
   * Text
   */
  text: string;
  /**
   * Metadata
   */
  metadata?: {
    [key: string]: string;
  };
};

/**
 * AgentTitleSocketEventV1
 */
export type AgentTitleSocketEventV1 = {
  /**
   * Kind
   */
  kind: "title";
  /**
   * Title
   */
  title: string;
};

/**
 * AgentToolCallResultSocketEventV1
 */
export type AgentToolCallResultSocketEventV1 = {
  /**
   * Kind
   */
  kind: "tool_call_result";
  /**
   * Message Id
   */
  message_id: number;
  /**
   * Tool Call Id
   */
  tool_call_id: string;
  /**
   * Tool Name
   */
  tool_name: string;
  /**
   * Tool Call Result
   */
  tool_call_result: {
    [key: string]: Json;
  };
};

/**
 * AgentToolCallSocketEventV1
 */
export type AgentToolCallSocketEventV1 = {
  /**
   * Kind
   */
  kind: "tool_call";
  /**
   * Message Id
   */
  message_id: number;
  /**
   * Tool Call Id
   */
  tool_call_id: string;
  /**
   * Tool Name
   */
  tool_name: string;
  /**
   * Tool Call Args
   */
  tool_call_args: {
    [key: string]: Json;
  };
};

/**
 * AgentTurnEndEventV1
 */
export type AgentTurnEndEventV1 = {
  /**
   * Kind
   */
  kind: "turn_end";
  outcome?: AgentTurnEndOutcomeV1 | null;
};

/**
 * AgentTurnEndOutcomeV1
 */
export const AgentTurnEndOutcomeV1 = {
  FINISHED: "finished",
  MAX_STEPS: "max_steps",
  STOPPED_BY_HOOK: "stopped_by_hook",
  FAILED: "failed",
  INTERRUPTED: "interrupted",
} as const;

/**
 * AgentTurnEndOutcomeV1
 */
export type AgentTurnEndOutcomeV1 =
  (typeof AgentTurnEndOutcomeV1)[keyof typeof AgentTurnEndOutcomeV1];

export type Json =
  | number
  | number
  | string
  | boolean
  | Array<Json>
  | {
      [key: string]: Json;
    }
  | null;

/**
 * WsAgentSocketEventV1
 */
export type WsAgentSocketEventV1 = {
  /**
   * Agent Conversation Id
   */
  agent_conversation_id: number;
  event: AgentSocketEventV1;
};

/**
 * WsErrorEventV1
 */
export type WsErrorEventV1 = {
  /**
   * Type
   */
  type?: "error";
  /**
   * Agent Conversation Id
   */
  agent_conversation_id: number;
};

/**
 * WsJoinFeRoomRequestV1
 */
export type WsJoinFeRoomRequestV1 = {
  /**
   * Agent Conversation Id
   */
  agent_conversation_id: number;
};

/**
 * WsJoinFeRoomResponseV1
 */
export type WsJoinFeRoomResponseV1 = {
  /**
   * Ok
   */
  ok: boolean;
  /**
   * Reason
   */
  reason?: string | null;
};

export type GetApiV1AgentSessionInferenceByAgentSessionIdData = {
  body?: never;
  path: {
    /**
     * Agent Session Id
     */
    agent_session_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
  };
  url: "/api/v1/agent-session-inference/{agent_session_id}";
};

export type GetApiV1AgentSessionInferenceByAgentSessionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AgentSessionInferenceByAgentSessionIdError =
  GetApiV1AgentSessionInferenceByAgentSessionIdErrors[keyof GetApiV1AgentSessionInferenceByAgentSessionIdErrors];

export type GetApiV1AgentSessionInferenceByAgentSessionIdResponses = {
  /**
   * Successful Response
   */
  200: PageV2AgentSessionInferenceV1;
};

export type GetApiV1AgentSessionInferenceByAgentSessionIdResponse =
  GetApiV1AgentSessionInferenceByAgentSessionIdResponses[keyof GetApiV1AgentSessionInferenceByAgentSessionIdResponses];

export type PostApiV1AgentSessionInferenceByAgentSessionIdData = {
  body: CreateAgentSessionInferenceParamsV1;
  path: {
    /**
     * Agent Session Id
     */
    agent_session_id: number;
  };
  query?: never;
  url: "/api/v1/agent-session-inference/{agent_session_id}";
};

export type PostApiV1AgentSessionInferenceByAgentSessionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AgentSessionInferenceByAgentSessionIdError =
  PostApiV1AgentSessionInferenceByAgentSessionIdErrors[keyof PostApiV1AgentSessionInferenceByAgentSessionIdErrors];

export type PostApiV1AgentSessionInferenceByAgentSessionIdResponses = {
  /**
   * Successful Response
   */
  200: AgentSessionInferenceV1;
};

export type PostApiV1AgentSessionInferenceByAgentSessionIdResponse =
  PostApiV1AgentSessionInferenceByAgentSessionIdResponses[keyof PostApiV1AgentSessionInferenceByAgentSessionIdResponses];

export type GetApiV1AgentSessionsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Agent Key
     */
    agent_key?: string | null;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * User Id
     */
    user_id?: AgentSessionUserFilterV1 | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/agent-sessions";
};

export type GetApiV1AgentSessionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AgentSessionsError =
  GetApiV1AgentSessionsErrors[keyof GetApiV1AgentSessionsErrors];

export type GetApiV1AgentSessionsResponses = {
  /**
   * Successful Response
   */
  200: PageV1AgentSessionV1;
};

export type GetApiV1AgentSessionsResponse =
  GetApiV1AgentSessionsResponses[keyof GetApiV1AgentSessionsResponses];

export type PostApiV1AgentSessionsData = {
  body: CreateAgentSessionV1;
  path?: never;
  query?: never;
  url: "/api/v1/agent-sessions";
};

export type PostApiV1AgentSessionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AgentSessionsError =
  PostApiV1AgentSessionsErrors[keyof PostApiV1AgentSessionsErrors];

export type PostApiV1AgentSessionsResponses = {
  /**
   * Successful Response
   */
  200: AgentSessionV1;
};

export type PostApiV1AgentSessionsResponse =
  PostApiV1AgentSessionsResponses[keyof PostApiV1AgentSessionsResponses];

export type GetApiV1FullAgentSessionsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Agent Key
     */
    agent_key?: string | null;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/full-agent-sessions";
};

export type GetApiV1FullAgentSessionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullAgentSessionsError =
  GetApiV1FullAgentSessionsErrors[keyof GetApiV1FullAgentSessionsErrors];

export type GetApiV1FullAgentSessionsResponses = {
  /**
   * Successful Response
   */
  200: PageV1AgentSessionFullV1;
};

export type GetApiV1FullAgentSessionsResponse =
  GetApiV1FullAgentSessionsResponses[keyof GetApiV1FullAgentSessionsResponses];

export type DeleteApiV1AgentSessionsByAgentSessionIdData = {
  body?: never;
  path: {
    /**
     * Agent Session Id
     */
    agent_session_id: number;
  };
  query?: never;
  url: "/api/v1/agent-sessions/{agent_session_id}";
};

export type DeleteApiV1AgentSessionsByAgentSessionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1AgentSessionsByAgentSessionIdError =
  DeleteApiV1AgentSessionsByAgentSessionIdErrors[keyof DeleteApiV1AgentSessionsByAgentSessionIdErrors];

export type DeleteApiV1AgentSessionsByAgentSessionIdResponses = {
  /**
   * Successful Response
   */
  200: AgentSessionV1;
};

export type DeleteApiV1AgentSessionsByAgentSessionIdResponse =
  DeleteApiV1AgentSessionsByAgentSessionIdResponses[keyof DeleteApiV1AgentSessionsByAgentSessionIdResponses];

export type GetApiV1AgentSessionsByAgentSessionIdData = {
  body?: never;
  path: {
    /**
     * Agent Session Id
     */
    agent_session_id: number;
  };
  query?: never;
  url: "/api/v1/agent-sessions/{agent_session_id}";
};

export type GetApiV1AgentSessionsByAgentSessionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AgentSessionsByAgentSessionIdError =
  GetApiV1AgentSessionsByAgentSessionIdErrors[keyof GetApiV1AgentSessionsByAgentSessionIdErrors];

export type GetApiV1AgentSessionsByAgentSessionIdResponses = {
  /**
   * Successful Response
   */
  200: AgentSessionFullV1;
};

export type GetApiV1AgentSessionsByAgentSessionIdResponse =
  GetApiV1AgentSessionsByAgentSessionIdResponses[keyof GetApiV1AgentSessionsByAgentSessionIdResponses];

export type PatchApiV1AgentSessionsByAgentSessionIdData = {
  body: UpdateAgentSessionV1;
  path: {
    /**
     * Agent Session Id
     */
    agent_session_id: number;
  };
  query?: never;
  url: "/api/v1/agent-sessions/{agent_session_id}";
};

export type PatchApiV1AgentSessionsByAgentSessionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1AgentSessionsByAgentSessionIdError =
  PatchApiV1AgentSessionsByAgentSessionIdErrors[keyof PatchApiV1AgentSessionsByAgentSessionIdErrors];

export type PatchApiV1AgentSessionsByAgentSessionIdResponses = {
  /**
   * Successful Response
   */
  200: AgentSessionV1;
};

export type PatchApiV1AgentSessionsByAgentSessionIdResponse =
  PatchApiV1AgentSessionsByAgentSessionIdResponses[keyof PatchApiV1AgentSessionsByAgentSessionIdResponses];

export type GetApiV1FullUserAgentSessionsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Agent Key
     */
    agent_key?: string | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/full-user-agent-sessions";
};

export type GetApiV1FullUserAgentSessionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullUserAgentSessionsError =
  GetApiV1FullUserAgentSessionsErrors[keyof GetApiV1FullUserAgentSessionsErrors];

export type GetApiV1FullUserAgentSessionsResponses = {
  /**
   * Successful Response
   */
  200: PageV1AgentSessionFullV1;
};

export type GetApiV1FullUserAgentSessionsResponse =
  GetApiV1FullUserAgentSessionsResponses[keyof GetApiV1FullUserAgentSessionsResponses];

export type PostApiV1AgentSessionsByAgentSessionIdMessagesData = {
  body: SendAgentSessionMessageV1;
  path: {
    /**
     * Agent Session Id
     */
    agent_session_id: number;
  };
  query?: never;
  url: "/api/v1/agent-sessions/{agent_session_id}/messages";
};

export type PostApiV1AgentSessionsByAgentSessionIdMessagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AgentSessionsByAgentSessionIdMessagesError =
  PostApiV1AgentSessionsByAgentSessionIdMessagesErrors[keyof PostApiV1AgentSessionsByAgentSessionIdMessagesErrors];

export type PostApiV1AgentSessionsByAgentSessionIdMessagesResponses = {
  /**
   * Successful Response
   */
  202: SendAgentSessionMessageResponseV1;
};

export type PostApiV1AgentSessionsByAgentSessionIdMessagesResponse =
  PostApiV1AgentSessionsByAgentSessionIdMessagesResponses[keyof PostApiV1AgentSessionsByAgentSessionIdMessagesResponses];

export type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncData = {
  body: SendAgentSessionMessageSyncV1;
  path: {
    /**
     * Agent Session Id
     */
    agent_session_id: number;
  };
  query?: never;
  url: "/api/v1/agent-sessions/{agent_session_id}/messages/sync";
};

export type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncError =
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncErrors[keyof PostApiV1AgentSessionsByAgentSessionIdMessagesSyncErrors];

export type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponses = {
  /**
   * Successful Response
   */
  200: SendAgentSessionMessageSyncResponseV1;
};

export type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponse =
  PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponses[keyof PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponses];

export type PostApiV1AgentSessionsByAgentSessionIdStopData = {
  body?: never;
  path: {
    /**
     * Agent Session Id
     */
    agent_session_id: number;
  };
  query?: never;
  url: "/api/v1/agent-sessions/{agent_session_id}/stop";
};

export type PostApiV1AgentSessionsByAgentSessionIdStopErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AgentSessionsByAgentSessionIdStopError =
  PostApiV1AgentSessionsByAgentSessionIdStopErrors[keyof PostApiV1AgentSessionsByAgentSessionIdStopErrors];

export type PostApiV1AgentSessionsByAgentSessionIdStopResponses = {
  /**
   * Successful Response
   */
  200: StopAgentSessionResponseV1;
};

export type PostApiV1AgentSessionsByAgentSessionIdStopResponse =
  PostApiV1AgentSessionsByAgentSessionIdStopResponses[keyof PostApiV1AgentSessionsByAgentSessionIdStopResponses];

export type GetApiV1AgentsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/agents";
};

export type GetApiV1AgentsResponses = {
  /**
   * Successful Response
   */
  200: GetAgentsResponseV1;
};

export type GetApiV1AgentsResponse =
  GetApiV1AgentsResponses[keyof GetApiV1AgentsResponses];

export type GetApiV1McpToolsetsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/mcp-toolsets";
};

export type GetApiV1McpToolsetsResponses = {
  /**
   * Successful Response
   */
  200: GetMcpToolsetsResponseV1;
};

export type GetApiV1McpToolsetsResponse =
  GetApiV1McpToolsetsResponses[keyof GetApiV1McpToolsetsResponses];

export type GetApiV1A2aAgentsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/a2a-agents";
};

export type GetApiV1A2aAgentsResponses = {
  /**
   * Successful Response
   */
  200: GetA2aAgentsResponseV1;
};

export type GetApiV1A2aAgentsResponse =
  GetApiV1A2aAgentsResponses[keyof GetApiV1A2aAgentsResponses];

export type GetApiV1AgentsByAgentKeyData = {
  body?: never;
  path: {
    /**
     * Agent Key
     */
    agent_key: string;
  };
  query?: never;
  url: "/api/v1/agents/{agent_key}";
};

export type GetApiV1AgentsByAgentKeyErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AgentsByAgentKeyError =
  GetApiV1AgentsByAgentKeyErrors[keyof GetApiV1AgentsByAgentKeyErrors];

export type GetApiV1AgentsByAgentKeyResponses = {
  /**
   * Successful Response
   */
  200: AgentV1;
};

export type GetApiV1AgentsByAgentKeyResponse =
  GetApiV1AgentsByAgentKeyResponses[keyof GetApiV1AgentsByAgentKeyResponses];

export type GetApiV1AnalyticsSectionsChartsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Kb Id
     */
    kb_id?: number | null;
  };
  url: "/api/v1/analytics/sections/charts";
};

export type GetApiV1AnalyticsSectionsChartsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AnalyticsSectionsChartsError =
  GetApiV1AnalyticsSectionsChartsErrors[keyof GetApiV1AnalyticsSectionsChartsErrors];

export type GetApiV1AnalyticsSectionsChartsResponses = {
  /**
   * Successful Response
   */
  200: AnalyticsChartsV1;
};

export type GetApiV1AnalyticsSectionsChartsResponse =
  GetApiV1AnalyticsSectionsChartsResponses[keyof GetApiV1AnalyticsSectionsChartsResponses];

export type GetApiV1AnalyticsWorkflowsChartsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Workflow Id
     */
    workflow_id?: number | null;
  };
  url: "/api/v1/analytics/workflows/charts";
};

export type GetApiV1AnalyticsWorkflowsChartsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AnalyticsWorkflowsChartsError =
  GetApiV1AnalyticsWorkflowsChartsErrors[keyof GetApiV1AnalyticsWorkflowsChartsErrors];

export type GetApiV1AnalyticsWorkflowsChartsResponses = {
  /**
   * Successful Response
   */
  200: AnalyticsChartsV1;
};

export type GetApiV1AnalyticsWorkflowsChartsResponse =
  GetApiV1AnalyticsWorkflowsChartsResponses[keyof GetApiV1AnalyticsWorkflowsChartsResponses];

export type GetApiV1AnalyticsOverviewsChartsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/analytics/overviews/charts";
};

export type GetApiV1AnalyticsOverviewsChartsResponses = {
  /**
   * Successful Response
   */
  200: AnalyticsChartsV1;
};

export type GetApiV1AnalyticsOverviewsChartsResponse =
  GetApiV1AnalyticsOverviewsChartsResponses[keyof GetApiV1AnalyticsOverviewsChartsResponses];

export type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentData = {
  body?: never;
  path: {
    /**
     * Chart Key
     */
    chart_key: string;
    /**
     * Section Id
     */
    section_id: number;
  };
  query: {
    /**
     * Start Date
     */
    start_date: Date;
    /**
     * End Date
     */
    end_date: Date;
  };
  url: "/api/v1/analytics/sections/{section_id}/charts/{chart_key}/content";
};

export type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentError =
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentErrors[keyof GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentErrors];

export type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponses =
  {
    /**
     * Successful Response
     */
    200: GetAnalyticsChartContentResponseV1;
  };

export type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponse =
  GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponses[keyof GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponses];

export type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentData = {
  body?: never;
  path: {
    /**
     * Chart Key
     */
    chart_key: string;
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query: {
    /**
     * Start Date
     */
    start_date: Date;
    /**
     * End Date
     */
    end_date: Date;
    /**
     * Path
     */
    path: string;
  };
  url: "/api/v1/analytics/trees/{kb_id}/charts/{chart_key}/content";
};

export type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentError =
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentErrors[keyof GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentErrors];

export type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponses = {
  /**
   * Successful Response
   */
  200: GetAnalyticsChartContentResponseV1;
};

export type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponse =
  GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponses[keyof GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponses];

export type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentData = {
  body?: never;
  path: {
    /**
     * Chart Key
     */
    chart_key: string;
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query: {
    /**
     * Start Date
     */
    start_date: Date;
    /**
     * End Date
     */
    end_date: Date;
  };
  url: "/api/v1/analytics/knowledge-bases/{kb_id}/charts/{chart_key}/content";
};

export type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentError =
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentErrors[keyof GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentErrors];

export type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponses =
  {
    /**
     * Successful Response
     */
    200: GetAnalyticsChartContentResponseV1;
  };

export type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponse =
  GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponses[keyof GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponses];

export type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentData =
  {
    body?: never;
    path: {
      /**
       * Chart Key
       */
      chart_key: string;
      /**
       * Workflow Id
       */
      workflow_id: number;
    };
    query: {
      /**
       * Start Date
       */
      start_date: Date;
      /**
       * End Date
       */
      end_date: Date;
    };
    url: "/api/v1/analytics/workflows/{workflow_id}/charts/{chart_key}/content";
  };

export type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentError =
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentErrors[keyof GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentErrors];

export type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponses =
  {
    /**
     * Successful Response
     */
    200: GetAnalyticsChartContentResponseV1;
  };

export type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponse =
  GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponses[keyof GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponses];

export type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentData =
  {
    body?: never;
    path: {
      /**
       * Chart Key
       */
      chart_key: string;
      /**
       * Kb Id
       */
      kb_id: number;
    };
    query: {
      /**
       * Start Date
       */
      start_date: Date;
      /**
       * End Date
       */
      end_date: Date;
    };
    url: "/api/v1/analytics/overviews/knowledge-bases/{kb_id}/charts/{chart_key}/content";
  };

export type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentError =
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentErrors[keyof GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentErrors];

export type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponses =
  {
    /**
     * Successful Response
     */
    200: GetAnalyticsChartContentResponseV1;
  };

export type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponse =
  GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponses[keyof GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponses];

export type PostApiV1ApiKeysData = {
  body: CreateApiKeyParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/api-keys";
};

export type PostApiV1ApiKeysErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ApiKeysError =
  PostApiV1ApiKeysErrors[keyof PostApiV1ApiKeysErrors];

export type PostApiV1ApiKeysResponses = {
  /**
   * Successful Response
   */
  200: ApiKeySecretV1;
};

export type PostApiV1ApiKeysResponse =
  PostApiV1ApiKeysResponses[keyof PostApiV1ApiKeysResponses];

export type GetApiV1FullApiKeysData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/full-api-keys";
};

export type GetApiV1FullApiKeysErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullApiKeysError =
  GetApiV1FullApiKeysErrors[keyof GetApiV1FullApiKeysErrors];

export type GetApiV1FullApiKeysResponses = {
  /**
   * Successful Response
   */
  200: PageV1ApiKeyFullV1;
};

export type GetApiV1FullApiKeysResponse =
  GetApiV1FullApiKeysResponses[keyof GetApiV1FullApiKeysResponses];

export type DeleteApiV1ApiKeysByApiKeyIdData = {
  body?: never;
  path: {
    /**
     * Api Key Id
     */
    api_key_id: number;
  };
  query?: never;
  url: "/api/v1/api-keys/{api_key_id}";
};

export type DeleteApiV1ApiKeysByApiKeyIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ApiKeysByApiKeyIdError =
  DeleteApiV1ApiKeysByApiKeyIdErrors[keyof DeleteApiV1ApiKeysByApiKeyIdErrors];

export type DeleteApiV1ApiKeysByApiKeyIdResponses = {
  /**
   * Successful Response
   */
  200: ApiKeyV1;
};

export type DeleteApiV1ApiKeysByApiKeyIdResponse =
  DeleteApiV1ApiKeysByApiKeyIdResponses[keyof DeleteApiV1ApiKeysByApiKeyIdResponses];

export type PatchApiV1ApiKeysByApiKeyIdData = {
  body: UpdateApiKeyParamsV1;
  path: {
    /**
     * Api Key Id
     */
    api_key_id: number;
  };
  query?: never;
  url: "/api/v1/api-keys/{api_key_id}";
};

export type PatchApiV1ApiKeysByApiKeyIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ApiKeysByApiKeyIdError =
  PatchApiV1ApiKeysByApiKeyIdErrors[keyof PatchApiV1ApiKeysByApiKeyIdErrors];

export type PatchApiV1ApiKeysByApiKeyIdResponses = {
  /**
   * Successful Response
   */
  200: ApiKeyV1;
};

export type PatchApiV1ApiKeysByApiKeyIdResponse =
  PatchApiV1ApiKeysByApiKeyIdResponses[keyof PatchApiV1ApiKeysByApiKeyIdResponses];

export type GetApiV1FullArticleLineRangeCommentThreadsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Article Id
     */
    article_id?: number | null;
    /**
     * Object Article Id
     */
    object_article_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/full-article-line-range-comment-threads";
};

export type GetApiV1FullArticleLineRangeCommentThreadsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullArticleLineRangeCommentThreadsError =
  GetApiV1FullArticleLineRangeCommentThreadsErrors[keyof GetApiV1FullArticleLineRangeCommentThreadsErrors];

export type GetApiV1FullArticleLineRangeCommentThreadsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ArticleLineRangeCommentThreadFullV1;
};

export type GetApiV1FullArticleLineRangeCommentThreadsResponse =
  GetApiV1FullArticleLineRangeCommentThreadsResponses[keyof GetApiV1FullArticleLineRangeCommentThreadsResponses];

export type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdData = {
  body?: never;
  path: {
    /**
     * Thread Id
     */
    thread_id: number;
  };
  query?: never;
  url: "/api/v1/article-line-range-comment-threads/{thread_id}";
};

export type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdError =
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdErrors[keyof DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdErrors];

export type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponses = {
  /**
   * Successful Response
   */
  200: ArticleLineRangeCommentThreadV1;
};

export type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponse =
  DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponses[keyof DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponses];

export type GetApiV1ArticleLineRangeCommentThreadsByThreadIdData = {
  body?: never;
  path: {
    /**
     * Thread Id
     */
    thread_id: number;
  };
  query?: never;
  url: "/api/v1/article-line-range-comment-threads/{thread_id}";
};

export type GetApiV1ArticleLineRangeCommentThreadsByThreadIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ArticleLineRangeCommentThreadsByThreadIdError =
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdErrors[keyof GetApiV1ArticleLineRangeCommentThreadsByThreadIdErrors];

export type GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponses = {
  /**
   * Successful Response
   */
  200: ArticleLineRangeCommentThreadFullV1;
};

export type GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponse =
  GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponses[keyof GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponses];

export type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdData = {
  body: UpdateArticleLineRangeCommentThreadParamsV1;
  path: {
    /**
     * Thread Id
     */
    thread_id: number;
  };
  query?: never;
  url: "/api/v1/article-line-range-comment-threads/{thread_id}";
};

export type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdError =
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdErrors[keyof PatchApiV1ArticleLineRangeCommentThreadsByThreadIdErrors];

export type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponses = {
  /**
   * Successful Response
   */
  200: ArticleLineRangeCommentThreadV1;
};

export type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponse =
  PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponses[keyof PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponses];

export type PostApiV1ArticleLineRangeCommentThreadsData = {
  body: CreateArticleLineRangeCommentThreadParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/article-line-range-comment-threads";
};

export type PostApiV1ArticleLineRangeCommentThreadsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ArticleLineRangeCommentThreadsError =
  PostApiV1ArticleLineRangeCommentThreadsErrors[keyof PostApiV1ArticleLineRangeCommentThreadsErrors];

export type PostApiV1ArticleLineRangeCommentThreadsResponses = {
  /**
   * Successful Response
   */
  200: ArticleLineRangeCommentThreadV1;
};

export type PostApiV1ArticleLineRangeCommentThreadsResponse =
  PostApiV1ArticleLineRangeCommentThreadsResponses[keyof PostApiV1ArticleLineRangeCommentThreadsResponses];

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsData = {
  body: CreateArticleLineRangeCommentThreadCommentParamsV1;
  path: {
    /**
     * Thread Id
     */
    thread_id: number;
  };
  query?: never;
  url: "/api/v1/article-line-range-comment-threads/{thread_id}/comments";
};

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsError =
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsErrors[keyof PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsErrors];

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponses =
  {
    /**
     * Successful Response
     */
    200: ArticleLineRangeCommentThreadV1;
  };

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponse =
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponses[keyof PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponses];

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreData = {
  body?: never;
  path: {
    /**
     * Thread Id
     */
    thread_id: number;
  };
  query?: never;
  url: "/api/v1/article-line-range-comment-threads/{thread_id}/restore";
};

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreError =
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreErrors[keyof PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreErrors];

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: ArticleLineRangeCommentThreadV1;
  };

export type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponse =
  PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponses[keyof PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponses];

export type PostApiV1AttachmentsUploadUrlData = {
  body: UploadUrlRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/attachments/upload-url";
};

export type PostApiV1AttachmentsUploadUrlErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AttachmentsUploadUrlError =
  PostApiV1AttachmentsUploadUrlErrors[keyof PostApiV1AttachmentsUploadUrlErrors];

export type PostApiV1AttachmentsUploadUrlResponses = {
  /**
   * Successful Response
   */
  200: UploadUrlResponseV1;
};

export type PostApiV1AttachmentsUploadUrlResponse =
  PostApiV1AttachmentsUploadUrlResponses[keyof PostApiV1AttachmentsUploadUrlResponses];

export type PostApiV2AttachmentsUploadUrlData = {
  body: UploadUrlRequestV2;
  path?: never;
  query?: never;
  url: "/api/v2/attachments/upload-url";
};

export type PostApiV2AttachmentsUploadUrlErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2AttachmentsUploadUrlError =
  PostApiV2AttachmentsUploadUrlErrors[keyof PostApiV2AttachmentsUploadUrlErrors];

export type PostApiV2AttachmentsUploadUrlResponses = {
  /**
   * Successful Response
   */
  200: UploadUrlResponseV2;
};

export type PostApiV2AttachmentsUploadUrlResponse =
  PostApiV2AttachmentsUploadUrlResponses[keyof PostApiV2AttachmentsUploadUrlResponses];

export type GetApiV1AttachmentsDataByFilePathData = {
  body?: never;
  path: {
    /**
     * File Path
     */
    file_path: string;
  };
  query?: never;
  url: "/api/v1/attachments/data/{file_path}";
};

export type GetApiV1AttachmentsDataByFilePathErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AttachmentsDataByFilePathError =
  GetApiV1AttachmentsDataByFilePathErrors[keyof GetApiV1AttachmentsDataByFilePathErrors];

export type GetApiV1AttachmentsDataByFilePathResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiV2AttachmentsDataByAttachmentIdByFilenameData = {
  body?: never;
  path: {
    /**
     * Attachment Id
     */
    attachment_id: string;
    /**
     * Filename
     */
    filename: string;
  };
  query?: never;
  url: "/api/v2/attachments/data/{attachment_id}/{filename}";
};

export type GetApiV2AttachmentsDataByAttachmentIdByFilenameErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2AttachmentsDataByAttachmentIdByFilenameError =
  GetApiV2AttachmentsDataByAttachmentIdByFilenameErrors[keyof GetApiV2AttachmentsDataByAttachmentIdByFilenameErrors];

export type GetApiV2AttachmentsDataByAttachmentIdByFilenameResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type HeadApiV1AttachmentsMetadataByFilePathData = {
  body?: never;
  path: {
    /**
     * File Path
     */
    file_path: string;
  };
  query?: never;
  url: "/api/v1/attachments/metadata/{file_path}";
};

export type HeadApiV1AttachmentsMetadataByFilePathErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type HeadApiV1AttachmentsMetadataByFilePathError =
  HeadApiV1AttachmentsMetadataByFilePathErrors[keyof HeadApiV1AttachmentsMetadataByFilePathErrors];

export type HeadApiV1AttachmentsMetadataByFilePathResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiV1AuthzOrganizationsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/authz/organizations";
};

export type GetApiV1AuthzOrganizationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsError =
  GetApiV1AuthzOrganizationsErrors[keyof GetApiV1AuthzOrganizationsErrors];

export type GetApiV1AuthzOrganizationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1OrganizationV1;
};

export type GetApiV1AuthzOrganizationsResponse =
  GetApiV1AuthzOrganizationsResponses[keyof GetApiV1AuthzOrganizationsResponses];

export type GetApiV1AuthzOrganizationsByOrgIdData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}";
};

export type GetApiV1AuthzOrganizationsByOrgIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdError =
  GetApiV1AuthzOrganizationsByOrgIdErrors[keyof GetApiV1AuthzOrganizationsByOrgIdErrors];

export type GetApiV1AuthzOrganizationsByOrgIdResponses = {
  /**
   * Successful Response
   */
  200: OrganizationFullV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdResponse =
  GetApiV1AuthzOrganizationsByOrgIdResponses[keyof GetApiV1AuthzOrganizationsByOrgIdResponses];

export type PatchApiV1AuthzOrganizationsByOrgIdData = {
  body: UpdateOrganizationParamsV1;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}";
};

export type PatchApiV1AuthzOrganizationsByOrgIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1AuthzOrganizationsByOrgIdError =
  PatchApiV1AuthzOrganizationsByOrgIdErrors[keyof PatchApiV1AuthzOrganizationsByOrgIdErrors];

export type PatchApiV1AuthzOrganizationsByOrgIdResponses = {
  /**
   * Successful Response
   */
  200: OrganizationV1;
};

export type PatchApiV1AuthzOrganizationsByOrgIdResponse =
  PatchApiV1AuthzOrganizationsByOrgIdResponses[keyof PatchApiV1AuthzOrganizationsByOrgIdResponses];

export type PutApiV1AuthzOrganizationsByExternalIdData = {
  body: UpsertOrganizationParamsV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{external_id}";
};

export type PutApiV1AuthzOrganizationsByExternalIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiV1AuthzOrganizationsByExternalIdError =
  PutApiV1AuthzOrganizationsByExternalIdErrors[keyof PutApiV1AuthzOrganizationsByExternalIdErrors];

export type PutApiV1AuthzOrganizationsByExternalIdResponses = {
  /**
   * Successful Response
   */
  200: OrganizationV1;
};

export type PutApiV1AuthzOrganizationsByExternalIdResponse =
  PutApiV1AuthzOrganizationsByExternalIdResponses[keyof PutApiV1AuthzOrganizationsByExternalIdResponses];

export type GetApiV1AuthzOrganizationsByOrgIdMembersData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/authz/organizations/{org_id}/members";
};

export type GetApiV1AuthzOrganizationsByOrgIdMembersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdMembersError =
  GetApiV1AuthzOrganizationsByOrgIdMembersErrors[keyof GetApiV1AuthzOrganizationsByOrgIdMembersErrors];

export type GetApiV1AuthzOrganizationsByOrgIdMembersResponses = {
  /**
   * Successful Response
   */
  200: PageV1OrgMemberV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdMembersResponse =
  GetApiV1AuthzOrganizationsByOrgIdMembersResponses[keyof GetApiV1AuthzOrganizationsByOrgIdMembersResponses];

export type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * User Id
     */
    user_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/members/{user_id}";
};

export type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdError =
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors[keyof DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors];

export type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses = {
  /**
   * Successful Response
   */
  200: OrgMemberV1;
};

export type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse =
  DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses[keyof DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses];

export type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdData = {
  body: UpdateOrgMemberParamsV1;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * User Id
     */
    user_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/members/{user_id}";
};

export type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdError =
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors[keyof PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors];

export type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses = {
  /**
   * Successful Response
   */
  200: OrgMemberV1;
};

export type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse =
  PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses[keyof PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses];

export type GetApiV1AuthzOrganizationsByOrgIdRolesData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/roles";
};

export type GetApiV1AuthzOrganizationsByOrgIdRolesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdRolesError =
  GetApiV1AuthzOrganizationsByOrgIdRolesErrors[keyof GetApiV1AuthzOrganizationsByOrgIdRolesErrors];

export type GetApiV1AuthzOrganizationsByOrgIdRolesResponses = {
  /**
   * Successful Response
   */
  200: GetRolesResultV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdRolesResponse =
  GetApiV1AuthzOrganizationsByOrgIdRolesResponses[keyof GetApiV1AuthzOrganizationsByOrgIdRolesResponses];

export type GetApiV1AuthzOrganizationsByOrgIdTeamsData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/authz/organizations/{org_id}/teams";
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsError =
  GetApiV1AuthzOrganizationsByOrgIdTeamsErrors[keyof GetApiV1AuthzOrganizationsByOrgIdTeamsErrors];

export type GetApiV1AuthzOrganizationsByOrgIdTeamsResponses = {
  /**
   * Successful Response
   */
  200: PageV1TeamV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsResponse =
  GetApiV1AuthzOrganizationsByOrgIdTeamsResponses[keyof GetApiV1AuthzOrganizationsByOrgIdTeamsResponses];

export type PostApiV1AuthzOrganizationsByOrgIdTeamsData = {
  body: CreateTeamParamsV1;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/teams";
};

export type PostApiV1AuthzOrganizationsByOrgIdTeamsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AuthzOrganizationsByOrgIdTeamsError =
  PostApiV1AuthzOrganizationsByOrgIdTeamsErrors[keyof PostApiV1AuthzOrganizationsByOrgIdTeamsErrors];

export type PostApiV1AuthzOrganizationsByOrgIdTeamsResponses = {
  /**
   * Successful Response
   */
  200: TeamV1;
};

export type PostApiV1AuthzOrganizationsByOrgIdTeamsResponse =
  PostApiV1AuthzOrganizationsByOrgIdTeamsResponses[keyof PostApiV1AuthzOrganizationsByOrgIdTeamsResponses];

export type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * Team Id
     */
    team_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}";
};

export type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError =
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors[keyof DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors];

export type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses = {
  /**
   * Successful Response
   */
  200: TeamV1;
};

export type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse =
  DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses[keyof DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses];

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * Team Id
     */
    team_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}";
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError =
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors[keyof GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors];

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses = {
  /**
   * Successful Response
   */
  200: TeamFullV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse =
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses[keyof GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses];

export type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData = {
  body: UpdateTeamParamsV1;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * Team Id
     */
    team_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}";
};

export type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError =
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors[keyof PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors];

export type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses = {
  /**
   * Successful Response
   */
  200: TeamV1;
};

export type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse =
  PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses[keyof PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses];

export type PostApiV1AuthzSyncArticlesToOpenfgaData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Kb Id
     */
    kb_id?: number | null;
  };
  url: "/api/v1/authz/sync-articles-to-openfga";
};

export type PostApiV1AuthzSyncArticlesToOpenfgaErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AuthzSyncArticlesToOpenfgaError =
  PostApiV1AuthzSyncArticlesToOpenfgaErrors[keyof PostApiV1AuthzSyncArticlesToOpenfgaErrors];

export type PostApiV1AuthzSyncArticlesToOpenfgaResponses = {
  /**
   * Successful Response
   */
  200: SyncArticlesToOpenFgaResultV1;
};

export type PostApiV1AuthzSyncArticlesToOpenfgaResponse =
  PostApiV1AuthzSyncArticlesToOpenfgaResponses[keyof PostApiV1AuthzSyncArticlesToOpenfgaResponses];

export type PostApiV1AuthzKbOwnersSyncData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/authz/kb-owners/sync";
};

export type PostApiV1AuthzKbOwnersSyncResponses = {
  /**
   * Successful Response
   */
  200: SyncKbOwnersResultV1;
};

export type PostApiV1AuthzKbOwnersSyncResponse =
  PostApiV1AuthzKbOwnersSyncResponses[keyof PostApiV1AuthzKbOwnersSyncResponses];

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdData =
  {
    body: SetTeamKbRoleParamsV1;
    path: {
      /**
       * Org Id
       */
      org_id: number;
      /**
       * Team Id
       */
      team_id: number;
      /**
       * Kb Id
       */
      kb_id: number;
    };
    query?: never;
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/knowledge-bases/{kb_id}";
  };

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdError =
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdErrors[keyof PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdErrors];

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponses =
  {
    /**
     * Successful Response
     */
    200: SetTeamKbRoleResultV1;
  };

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponse =
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponses[keyof PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponses];

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * Team Id
     */
    team_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/knowledge-bases";
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesError =
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesErrors[keyof GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesErrors];

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponses =
  {
    /**
     * Successful Response
     */
    200: GetTeamKbAssignmentsResultV1;
  };

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponse =
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponses[keyof GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponses];

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * Team Id
     */
    team_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/articles";
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError =
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors[keyof GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors];

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses = {
  /**
   * Successful Response
   */
  200: GetTeamArticlePermissionsResultV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse =
  GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses[keyof GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses];

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData = {
  body: SetTeamArticlePermissionsParamsV1;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * Team Id
     */
    team_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/articles";
};

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError =
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors[keyof PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors];

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses = {
  /**
   * Successful Response
   */
  200: SetTeamArticlePermissionsResultV1;
};

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse =
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses[keyof PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses];

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdData =
  {
    body: SetTeamArticlePermissionParamsV1;
    path: {
      /**
       * Org Id
       */
      org_id: number;
      /**
       * Team Id
       */
      team_id: number;
      /**
       * Article Id
       */
      article_id: number;
    };
    query?: never;
    url: "/api/v1/authz/organizations/{org_id}/teams/{team_id}/articles/{article_id}";
  };

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdError =
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdErrors[keyof PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdErrors];

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponses =
  {
    /**
     * Successful Response
     */
    200: SetTeamArticlePermissionResultV1;
  };

export type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponse =
  PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponses[keyof PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponses];

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/authz/organizations/{org_id}/invitations";
};

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsError =
  GetApiV1AuthzOrganizationsByOrgIdInvitationsErrors[keyof GetApiV1AuthzOrganizationsByOrgIdInvitationsErrors];

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1InvitationV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsResponse =
  GetApiV1AuthzOrganizationsByOrgIdInvitationsResponses[keyof GetApiV1AuthzOrganizationsByOrgIdInvitationsResponses];

export type PostApiV1AuthzOrganizationsByOrgIdInvitationsData = {
  body: CreateInvitationParamsV1;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/invitations";
};

export type PostApiV1AuthzOrganizationsByOrgIdInvitationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AuthzOrganizationsByOrgIdInvitationsError =
  PostApiV1AuthzOrganizationsByOrgIdInvitationsErrors[keyof PostApiV1AuthzOrganizationsByOrgIdInvitationsErrors];

export type PostApiV1AuthzOrganizationsByOrgIdInvitationsResponses = {
  /**
   * Successful Response
   */
  200: InvitationV1;
};

export type PostApiV1AuthzOrganizationsByOrgIdInvitationsResponse =
  PostApiV1AuthzOrganizationsByOrgIdInvitationsResponses[keyof PostApiV1AuthzOrganizationsByOrgIdInvitationsResponses];

export type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/authz/organizations/{org_id}/full-invitations";
};

export type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsError =
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsErrors[keyof GetApiV1AuthzOrganizationsByOrgIdFullInvitationsErrors];

export type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1InvitationFullV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponse =
  GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponses[keyof GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponses];

export type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData =
  {
    body?: never;
    path: {
      /**
       * Org Id
       */
      org_id: number;
      /**
       * Invitation Id
       */
      invitation_id: number;
    };
    query?: never;
    url: "/api/v1/authz/organizations/{org_id}/invitations/{invitation_id}";
  };

export type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError =
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors[keyof DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors];

export type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses =
  {
    /**
     * Successful Response
     */
    200: InvitationV1;
  };

export type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse =
  DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses[keyof DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses];

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * Invitation Id
     */
    invitation_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/invitations/{invitation_id}";
};

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError =
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors[keyof GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors];

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses =
  {
    /**
     * Successful Response
     */
    200: InvitationFullV1;
  };

export type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse =
  GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses[keyof GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses];

export type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData = {
  body: UpdateInvitationParamsV1;
  path: {
    /**
     * Org Id
     */
    org_id: number;
    /**
     * Invitation Id
     */
    invitation_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/invitations/{invitation_id}";
};

export type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError =
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors[keyof PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors];

export type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses =
  {
    /**
     * Successful Response
     */
    200: InvitationV1;
  };

export type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse =
  PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses[keyof PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses];

export type GetApiV1BrandingData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/branding";
};

export type GetApiV1BrandingResponses = {
  /**
   * Successful Response
   */
  200: BrandingV1;
};

export type GetApiV1BrandingResponse =
  GetApiV1BrandingResponses[keyof GetApiV1BrandingResponses];

export type PostApiV1BrandingLogoUploadUrlData = {
  body: BrandingLogoUploadUrlRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/branding/logo/upload-url";
};

export type PostApiV1BrandingLogoUploadUrlErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1BrandingLogoUploadUrlError =
  PostApiV1BrandingLogoUploadUrlErrors[keyof PostApiV1BrandingLogoUploadUrlErrors];

export type PostApiV1BrandingLogoUploadUrlResponses = {
  /**
   * Successful Response
   */
  200: BrandingLogoUploadUrlResponseV1;
};

export type PostApiV1BrandingLogoUploadUrlResponse =
  PostApiV1BrandingLogoUploadUrlResponses[keyof PostApiV1BrandingLogoUploadUrlResponses];

export type GetApiV1FullChangeRequestLineRangeCommentThreadsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Change Request Id
     */
    change_request_id?: number | null;
    /**
     * Object Article Id
     */
    object_article_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/full-change-request-line-range-comment-threads";
};

export type GetApiV1FullChangeRequestLineRangeCommentThreadsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullChangeRequestLineRangeCommentThreadsError =
  GetApiV1FullChangeRequestLineRangeCommentThreadsErrors[keyof GetApiV1FullChangeRequestLineRangeCommentThreadsErrors];

export type GetApiV1FullChangeRequestLineRangeCommentThreadsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ChangeRequestLineRangeCommentThreadFullV1;
};

export type GetApiV1FullChangeRequestLineRangeCommentThreadsResponse =
  GetApiV1FullChangeRequestLineRangeCommentThreadsResponses[keyof GetApiV1FullChangeRequestLineRangeCommentThreadsResponses];

export type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData = {
  body?: never;
  path: {
    /**
     * Thread Id
     */
    thread_id: number;
  };
  query?: never;
  url: "/api/v1/change-request-line-range-comment-threads/{thread_id}";
};

export type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError =
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors[keyof DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors];

export type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses =
  {
    /**
     * Successful Response
     */
    200: ChangeRequestLineRangeCommentThreadV1;
  };

export type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse =
  DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses[keyof DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses];

export type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData = {
  body?: never;
  path: {
    /**
     * Thread Id
     */
    thread_id: number;
  };
  query?: never;
  url: "/api/v1/change-request-line-range-comment-threads/{thread_id}";
};

export type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError =
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors[keyof GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors];

export type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses = {
  /**
   * Successful Response
   */
  200: ChangeRequestLineRangeCommentThreadFullV1;
};

export type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse =
  GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses[keyof GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses];

export type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData = {
  body: UpdateChangeRequestLineRangeCommentThreadParamsV1;
  path: {
    /**
     * Thread Id
     */
    thread_id: number;
  };
  query?: never;
  url: "/api/v1/change-request-line-range-comment-threads/{thread_id}";
};

export type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError =
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors[keyof PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors];

export type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses =
  {
    /**
     * Successful Response
     */
    200: ChangeRequestLineRangeCommentThreadV1;
  };

export type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse =
  PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses[keyof PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses];

export type PostApiV1ChangeRequestLineRangeCommentThreadsData = {
  body: CreateChangeRequestLineRangeCommentThreadParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/change-request-line-range-comment-threads";
};

export type PostApiV1ChangeRequestLineRangeCommentThreadsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ChangeRequestLineRangeCommentThreadsError =
  PostApiV1ChangeRequestLineRangeCommentThreadsErrors[keyof PostApiV1ChangeRequestLineRangeCommentThreadsErrors];

export type PostApiV1ChangeRequestLineRangeCommentThreadsResponses = {
  /**
   * Successful Response
   */
  200: ChangeRequestLineRangeCommentThreadV1;
};

export type PostApiV1ChangeRequestLineRangeCommentThreadsResponse =
  PostApiV1ChangeRequestLineRangeCommentThreadsResponses[keyof PostApiV1ChangeRequestLineRangeCommentThreadsResponses];

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsData =
  {
    body: CreateChangeRequestLineRangeCommentThreadCommentParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: number;
    };
    query?: never;
    url: "/api/v1/change-request-line-range-comment-threads/{thread_id}/comments";
  };

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsError =
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsErrors[keyof PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsErrors];

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponses =
  {
    /**
     * Successful Response
     */
    200: ChangeRequestLineRangeCommentThreadV1;
  };

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponse =
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponses[keyof PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponses];

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreData =
  {
    body?: never;
    path: {
      /**
       * Thread Id
       */
      thread_id: number;
    };
    query?: never;
    url: "/api/v1/change-request-line-range-comment-threads/{thread_id}/restore";
  };

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreError =
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreErrors[keyof PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreErrors];

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: ChangeRequestLineRangeCommentThreadV1;
  };

export type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponse =
  PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponses[keyof PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponses];

export type GetApiV1ChangeRequestTagsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Kb Id
     */
    kb_id?: number | null;
    /**
     * Change Request Id
     */
    change_request_id?: number | null;
    /**
     * Key
     */
    key?: string | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/change-request-tags";
};

export type GetApiV1ChangeRequestTagsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ChangeRequestTagsError =
  GetApiV1ChangeRequestTagsErrors[keyof GetApiV1ChangeRequestTagsErrors];

export type GetApiV1ChangeRequestTagsResponses = {
  /**
   * Successful Response
   */
  200: PageV1GetChangeRequestTagsKeyV1;
};

export type GetApiV1ChangeRequestTagsResponse =
  GetApiV1ChangeRequestTagsResponses[keyof GetApiV1ChangeRequestTagsResponses];

export type GetApiV1ChangeRequestsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Kb Id
     */
    kb_id?: number | null;
    /**
     * From Branch
     */
    from_branch?: string | null;
    /**
     * To Branch
     */
    to_branch?: string | null;
    /**
     * Created By
     */
    created_by?: number | null;
    /**
     * Status Kind
     */
    status_kind?: Array<ChangeRequestStatusKindV1> | null;
    visibility?: VisibilityV1;
    /**
     * Sort By
     */
    sort_by?: ChangeRequestSortV1 | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/change-requests";
};

export type GetApiV1ChangeRequestsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ChangeRequestsError =
  GetApiV1ChangeRequestsErrors[keyof GetApiV1ChangeRequestsErrors];

export type GetApiV1ChangeRequestsResponses = {
  /**
   * Successful Response
   */
  200: PageV1ChangeRequestV1;
};

export type GetApiV1ChangeRequestsResponse =
  GetApiV1ChangeRequestsResponses[keyof GetApiV1ChangeRequestsResponses];

export type PostApiV1ChangeRequestsData = {
  body: CreateChangeRequestParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/change-requests";
};

export type PostApiV1ChangeRequestsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ChangeRequestsError =
  PostApiV1ChangeRequestsErrors[keyof PostApiV1ChangeRequestsErrors];

export type PostApiV1ChangeRequestsResponses = {
  /**
   * Successful Response
   */
  200: ChangeRequestV1;
};

export type PostApiV1ChangeRequestsResponse =
  PostApiV1ChangeRequestsResponses[keyof PostApiV1ChangeRequestsResponses];

export type GetApiV1FullChangeRequestsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Kb Id
     */
    kb_id?: number | null;
    /**
     * From Branch
     */
    from_branch?: string | null;
    /**
     * To Branch
     */
    to_branch?: string | null;
    /**
     * Created By
     */
    created_by?: number | null;
    /**
     * Assignee Any
     */
    assignee_any?: Array<number> | null;
    /**
     * Status Kind
     */
    status_kind?: Array<ChangeRequestStatusKindV1> | null;
    /**
     * Article Id Any
     */
    article_id_any?: Array<number> | null;
    /**
     * Article Id All
     */
    article_id_all?: Array<number> | null;
    /**
     * Article Tag Any
     */
    article_tag_any?: Array<string> | null;
    /**
     * Article Tag All
     */
    article_tag_all?: Array<string> | null;
    /**
     * Tag Any
     */
    tag_any?: Array<string> | null;
    /**
     * Tag All
     */
    tag_all?: Array<string> | null;
    visibility?: VisibilityV1;
    /**
     * Query
     */
    query?: string | null;
    /**
     * Sort By
     */
    sort_by?: Array<ChangeRequestFullSortV1> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/full-change-requests";
};

export type GetApiV1FullChangeRequestsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullChangeRequestsError =
  GetApiV1FullChangeRequestsErrors[keyof GetApiV1FullChangeRequestsErrors];

export type GetApiV1FullChangeRequestsResponses = {
  /**
   * Successful Response
   */
  200: PageV1ChangeRequestFullV1;
};

export type GetApiV1FullChangeRequestsResponse =
  GetApiV1FullChangeRequestsResponses[keyof GetApiV1FullChangeRequestsResponses];

export type DeleteApiV1ChangeRequestsByChangeRequestIdData = {
  body?: never;
  path: {
    /**
     * Change Request Id
     */
    change_request_id: number;
  };
  query?: never;
  url: "/api/v1/change-requests/{change_request_id}";
};

export type DeleteApiV1ChangeRequestsByChangeRequestIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ChangeRequestsByChangeRequestIdError =
  DeleteApiV1ChangeRequestsByChangeRequestIdErrors[keyof DeleteApiV1ChangeRequestsByChangeRequestIdErrors];

export type DeleteApiV1ChangeRequestsByChangeRequestIdResponses = {
  /**
   * Successful Response
   */
  200: ChangeRequestV1;
};

export type DeleteApiV1ChangeRequestsByChangeRequestIdResponse =
  DeleteApiV1ChangeRequestsByChangeRequestIdResponses[keyof DeleteApiV1ChangeRequestsByChangeRequestIdResponses];

export type GetApiV1ChangeRequestsByChangeRequestIdData = {
  body?: never;
  path: {
    /**
     * Change Request Id
     */
    change_request_id: number;
  };
  query?: never;
  url: "/api/v1/change-requests/{change_request_id}";
};

export type GetApiV1ChangeRequestsByChangeRequestIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ChangeRequestsByChangeRequestIdError =
  GetApiV1ChangeRequestsByChangeRequestIdErrors[keyof GetApiV1ChangeRequestsByChangeRequestIdErrors];

export type GetApiV1ChangeRequestsByChangeRequestIdResponses = {
  /**
   * Successful Response
   */
  200: ChangeRequestFullV1;
};

export type GetApiV1ChangeRequestsByChangeRequestIdResponse =
  GetApiV1ChangeRequestsByChangeRequestIdResponses[keyof GetApiV1ChangeRequestsByChangeRequestIdResponses];

export type PatchApiV1ChangeRequestsByChangeRequestIdData = {
  body: UpdateChangeRequestParamsV1;
  path: {
    /**
     * Change Request Id
     */
    change_request_id: number;
  };
  query?: never;
  url: "/api/v1/change-requests/{change_request_id}";
};

export type PatchApiV1ChangeRequestsByChangeRequestIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ChangeRequestsByChangeRequestIdError =
  PatchApiV1ChangeRequestsByChangeRequestIdErrors[keyof PatchApiV1ChangeRequestsByChangeRequestIdErrors];

export type PatchApiV1ChangeRequestsByChangeRequestIdResponses = {
  /**
   * Successful Response
   */
  200: ChangeRequestV1;
};

export type PatchApiV1ChangeRequestsByChangeRequestIdResponse =
  PatchApiV1ChangeRequestsByChangeRequestIdResponses[keyof PatchApiV1ChangeRequestsByChangeRequestIdResponses];

export type PostApiV1ChangeRequestsByChangeRequestIdRestoreData = {
  body?: never;
  path: {
    /**
     * Change Request Id
     */
    change_request_id: number;
  };
  query?: never;
  url: "/api/v1/change-requests/{change_request_id}/restore";
};

export type PostApiV1ChangeRequestsByChangeRequestIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ChangeRequestsByChangeRequestIdRestoreError =
  PostApiV1ChangeRequestsByChangeRequestIdRestoreErrors[keyof PostApiV1ChangeRequestsByChangeRequestIdRestoreErrors];

export type PostApiV1ChangeRequestsByChangeRequestIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: ChangeRequestV1;
};

export type PostApiV1ChangeRequestsByChangeRequestIdRestoreResponse =
  PostApiV1ChangeRequestsByChangeRequestIdRestoreResponses[keyof PostApiV1ChangeRequestsByChangeRequestIdRestoreResponses];

export type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesData = {
  body?: never;
  path: {
    /**
     * Change Request Id
     */
    change_request_id: number;
  };
  query?: {
    /**
     * Org Id
     */
    org_id?: number | null;
  };
  url: "/api/v1/change-requests/{change_request_id}/possible-assignees";
};

export type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesError =
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesErrors[keyof GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesErrors];

export type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponses =
  {
    /**
     * Successful Response
     */
    200: GetChangeRequestPossibleAssigneesResponseV1;
  };

export type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponse =
  GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponses[keyof GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponses];

export type GetApiV1FullCommentsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
    /**
     * User Id
     */
    user_id?: number | null;
    /**
     * External User Id
     */
    external_user_id?: string | null;
  };
  url: "/api/v1/full-comments";
};

export type GetApiV1FullCommentsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullCommentsError =
  GetApiV1FullCommentsErrors[keyof GetApiV1FullCommentsErrors];

export type GetApiV1FullCommentsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CommentFullV1;
};

export type GetApiV1FullCommentsResponse =
  GetApiV1FullCommentsResponses[keyof GetApiV1FullCommentsResponses];

export type DeleteApiV1CommentsByCommentIdData = {
  body?: never;
  path: {
    /**
     * Comment Id
     */
    comment_id: number;
  };
  query?: never;
  url: "/api/v1/comments/{comment_id}";
};

export type DeleteApiV1CommentsByCommentIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1CommentsByCommentIdError =
  DeleteApiV1CommentsByCommentIdErrors[keyof DeleteApiV1CommentsByCommentIdErrors];

export type DeleteApiV1CommentsByCommentIdResponses = {
  /**
   * Successful Response
   */
  200: CommentV1;
};

export type DeleteApiV1CommentsByCommentIdResponse =
  DeleteApiV1CommentsByCommentIdResponses[keyof DeleteApiV1CommentsByCommentIdResponses];

export type GetApiV1CommentsByCommentIdData = {
  body?: never;
  path: {
    /**
     * Comment Id
     */
    comment_id: number;
  };
  query?: never;
  url: "/api/v1/comments/{comment_id}";
};

export type GetApiV1CommentsByCommentIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CommentsByCommentIdError =
  GetApiV1CommentsByCommentIdErrors[keyof GetApiV1CommentsByCommentIdErrors];

export type GetApiV1CommentsByCommentIdResponses = {
  /**
   * Successful Response
   */
  200: CommentFullV1;
};

export type GetApiV1CommentsByCommentIdResponse =
  GetApiV1CommentsByCommentIdResponses[keyof GetApiV1CommentsByCommentIdResponses];

export type PatchApiV1CommentsByCommentIdData = {
  body: UpdateCommentParamsV1;
  path: {
    /**
     * Comment Id
     */
    comment_id: number;
  };
  query?: never;
  url: "/api/v1/comments/{comment_id}";
};

export type PatchApiV1CommentsByCommentIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1CommentsByCommentIdError =
  PatchApiV1CommentsByCommentIdErrors[keyof PatchApiV1CommentsByCommentIdErrors];

export type PatchApiV1CommentsByCommentIdResponses = {
  /**
   * Successful Response
   */
  200: CommentV1;
};

export type PatchApiV1CommentsByCommentIdResponse =
  PatchApiV1CommentsByCommentIdResponses[keyof PatchApiV1CommentsByCommentIdResponses];

export type PostApiV1CommentsByCommentIdRestoreData = {
  body?: never;
  path: {
    /**
     * Comment Id
     */
    comment_id: number;
  };
  query?: never;
  url: "/api/v1/comments/{comment_id}/restore";
};

export type PostApiV1CommentsByCommentIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1CommentsByCommentIdRestoreError =
  PostApiV1CommentsByCommentIdRestoreErrors[keyof PostApiV1CommentsByCommentIdRestoreErrors];

export type PostApiV1CommentsByCommentIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: CommentV1;
};

export type PostApiV1CommentsByCommentIdRestoreResponse =
  PostApiV1CommentsByCommentIdRestoreResponses[keyof PostApiV1CommentsByCommentIdRestoreResponses];

export type GetApiConfluenceV1TenantsByTenantIdActionsSpacesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/confluence/v1/tenants/{tenant_id}/actions/spaces";
};

export type GetApiConfluenceV1TenantsByTenantIdActionsSpacesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiConfluenceV1TenantsByTenantIdActionsSpacesError =
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesErrors[keyof GetApiConfluenceV1TenantsByTenantIdActionsSpacesErrors];

export type GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1ConfluenceSpaceV1;
};

export type GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponse =
  GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponses[keyof GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponses];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Space Id
     */
    space_id?: string | null;
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages";
};

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesError =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesErrors[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesErrors];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1ConfluencePageV1;
};

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesResponse =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesResponses[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesResponses];

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesData = {
  body: CreateConfluencePageParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages";
};

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesError =
  PostApiConfluenceV1TenantsByTenantIdActionsPagesErrors[keyof PostApiConfluenceV1TenantsByTenantIdActionsPagesErrors];

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesResponses = {
  /**
   * Successful Response
   */
  200: ConfluencePageV1;
};

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesResponse =
  PostApiConfluenceV1TenantsByTenantIdActionsPagesResponses[keyof PostApiConfluenceV1TenantsByTenantIdActionsPagesResponses];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Page Id
       */
      page_id: string;
    };
    query?: never;
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/content";
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentError =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentErrors[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentErrors];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponses =
  {
    /**
     * Successful Response
     */
    200: ConfluencePageContentV1;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponse =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponses[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponses];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Page Id
       */
      page_id: string;
    };
    query?: {
      /**
       * Cursor
       */
      cursor?: string | null;
    };
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/comments";
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses =
  {
    /**
     * Successful Response
     */
    200: CursorPageV1ConfluenceCommentV1;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses];

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData =
  {
    body: AddConfluenceCommentParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Page Id
       */
      page_id: string;
    };
    query?: never;
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/comments";
  };

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError =
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors[keyof PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors];

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses =
  {
    /**
     * Successful Response
     */
    200: ConfluenceCommentV1;
  };

export type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse =
  PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses[keyof PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Page Id
       */
      page_id: string;
    };
    query?: {
      /**
       * Cursor
       */
      cursor?: string | null;
    };
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/labels";
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsError =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsErrors[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsErrors];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponses =
  {
    /**
     * Successful Response
     */
    200: CursorPageV1ConfluenceLabelV1;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponse =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponses[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponses];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Page Id
       */
      page_id: string;
    };
    query?: {
      /**
       * Cursor
       */
      cursor?: string | null;
    };
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}/attachments";
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsError =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsErrors[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsErrors];

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponses =
  {
    /**
     * Successful Response
     */
    200: CursorPageV1ConfluenceAttachmentV1;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponse =
  GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponses[keyof GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponses];

export type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Attachment Id
       */
      attachment_id: string;
    };
    query?: never;
    url: "/api/confluence/v1/tenants/{tenant_id}/actions/attachments/{attachment_id}/content";
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentError =
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentErrors[keyof GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentErrors];

export type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponses =
  {
    /**
     * Successful Response
     */
    200: ConfluenceAttachmentContentV1;
  };

export type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponse =
  GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponses[keyof GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponses];

export type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdData = {
  body: UpdateConfluencePageParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Page Id
     */
    page_id: string;
  };
  query?: never;
  url: "/api/confluence/v1/tenants/{tenant_id}/actions/pages/{page_id}";
};

export type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdError =
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdErrors[keyof PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdErrors];

export type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponses =
  {
    /**
     * Successful Response
     */
    200: ConfluencePageV1;
  };

export type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponse =
  PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponses[keyof PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponses];

export type GetApiConfluenceV1OauthScopesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/confluence/v1/oauth-scopes";
};

export type GetApiConfluenceV1OauthScopesResponses = {
  /**
   * Successful Response
   */
  200: ConfluenceOauthScopesResponseV1;
};

export type GetApiConfluenceV1OauthScopesResponse =
  GetApiConfluenceV1OauthScopesResponses[keyof GetApiConfluenceV1OauthScopesResponses];

export type GetApiConfluenceV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/confluence/v1/tenants";
};

export type GetApiConfluenceV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiConfluenceV1TenantsError =
  GetApiConfluenceV1TenantsErrors[keyof GetApiConfluenceV1TenantsErrors];

export type GetApiConfluenceV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1ConfluenceTenantV1;
};

export type GetApiConfluenceV1TenantsResponse =
  GetApiConfluenceV1TenantsResponses[keyof GetApiConfluenceV1TenantsResponses];

export type PostApiConfluenceV1TenantsData = {
  body: CreateConfluenceTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/confluence/v1/tenants";
};

export type PostApiConfluenceV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiConfluenceV1TenantsError =
  PostApiConfluenceV1TenantsErrors[keyof PostApiConfluenceV1TenantsErrors];

export type PostApiConfluenceV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: ConfluenceTenantV1;
};

export type PostApiConfluenceV1TenantsResponse =
  PostApiConfluenceV1TenantsResponses[keyof PostApiConfluenceV1TenantsResponses];

export type DeleteApiConfluenceV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/confluence/v1/tenants/{tenant_id}";
};

export type DeleteApiConfluenceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiConfluenceV1TenantsByTenantIdError =
  DeleteApiConfluenceV1TenantsByTenantIdErrors[keyof DeleteApiConfluenceV1TenantsByTenantIdErrors];

export type DeleteApiConfluenceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ConfluenceTenantV1;
};

export type DeleteApiConfluenceV1TenantsByTenantIdResponse =
  DeleteApiConfluenceV1TenantsByTenantIdResponses[keyof DeleteApiConfluenceV1TenantsByTenantIdResponses];

export type GetApiConfluenceV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/confluence/v1/tenants/{tenant_id}";
};

export type GetApiConfluenceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiConfluenceV1TenantsByTenantIdError =
  GetApiConfluenceV1TenantsByTenantIdErrors[keyof GetApiConfluenceV1TenantsByTenantIdErrors];

export type GetApiConfluenceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ConfluenceTenantFullV1;
};

export type GetApiConfluenceV1TenantsByTenantIdResponse =
  GetApiConfluenceV1TenantsByTenantIdResponses[keyof GetApiConfluenceV1TenantsByTenantIdResponses];

export type PatchApiConfluenceV1TenantsByTenantIdData = {
  body: UpdateConfluenceTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/confluence/v1/tenants/{tenant_id}";
};

export type PatchApiConfluenceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiConfluenceV1TenantsByTenantIdError =
  PatchApiConfluenceV1TenantsByTenantIdErrors[keyof PatchApiConfluenceV1TenantsByTenantIdErrors];

export type PatchApiConfluenceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ConfluenceTenantV1;
};

export type PatchApiConfluenceV1TenantsByTenantIdResponse =
  PatchApiConfluenceV1TenantsByTenantIdResponses[keyof PatchApiConfluenceV1TenantsByTenantIdResponses];

export type PostApiConfluenceV1TenantsByTenantIdConnectData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/confluence/v1/tenants/{tenant_id}/connect";
};

export type PostApiConfluenceV1TenantsByTenantIdConnectErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiConfluenceV1TenantsByTenantIdConnectError =
  PostApiConfluenceV1TenantsByTenantIdConnectErrors[keyof PostApiConfluenceV1TenantsByTenantIdConnectErrors];

export type PostApiConfluenceV1TenantsByTenantIdConnectResponses = {
  /**
   * Successful Response
   */
  200: ConfluenceConnectResponseV1;
};

export type PostApiConfluenceV1TenantsByTenantIdConnectResponse =
  PostApiConfluenceV1TenantsByTenantIdConnectResponses[keyof PostApiConfluenceV1TenantsByTenantIdConnectResponses];

export type PostApiConfluenceV1TenantsByTenantIdCallbackData = {
  body: ConfluenceCallbackPayloadV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/confluence/v1/tenants/{tenant_id}/callback";
};

export type PostApiConfluenceV1TenantsByTenantIdCallbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiConfluenceV1TenantsByTenantIdCallbackError =
  PostApiConfluenceV1TenantsByTenantIdCallbackErrors[keyof PostApiConfluenceV1TenantsByTenantIdCallbackErrors];

export type PostApiConfluenceV1TenantsByTenantIdCallbackResponses = {
  /**
   * Successful Response
   */
  200: ConfluenceTenantV1;
};

export type PostApiConfluenceV1TenantsByTenantIdCallbackResponse =
  PostApiConfluenceV1TenantsByTenantIdCallbackResponses[keyof PostApiConfluenceV1TenantsByTenantIdCallbackResponses];

export type GetApiConfluenceV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/confluence/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiConfluenceV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiConfluenceV1TenantsByTenantIdCheckConnectionError =
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiConfluenceV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: ConfluenceCheckConnectionResponseV1;
};

export type GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponse =
  GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiV1ConversationsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Tags All
     */
    tags_all?: Array<SanitizedStr> | null;
    /**
     * Keys All
     */
    keys_all?: Array<string> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
  };
  url: "/api/v1/conversations";
};

export type GetApiV1ConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ConversationsError =
  GetApiV1ConversationsErrors[keyof GetApiV1ConversationsErrors];

export type GetApiV1ConversationsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ConversationFullV1;
};

export type GetApiV1ConversationsResponse =
  GetApiV1ConversationsResponses[keyof GetApiV1ConversationsResponses];

export type GetApiV1ConversationsGroupByExternalIdData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Offset
     */
    offset?: number;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/v1/conversations/group-by-external-id";
};

export type GetApiV1ConversationsGroupByExternalIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ConversationsGroupByExternalIdError =
  GetApiV1ConversationsGroupByExternalIdErrors[keyof GetApiV1ConversationsGroupByExternalIdErrors];

export type GetApiV1ConversationsGroupByExternalIdResponses = {
  /**
   * Successful Response
   */
  200: PageV2ConversationFullV1;
};

export type GetApiV1ConversationsGroupByExternalIdResponse =
  GetApiV1ConversationsGroupByExternalIdResponses[keyof GetApiV1ConversationsGroupByExternalIdResponses];

export type PutApiV2ConversationsByExternalIdData = {
  body: UpdateConversationPayloadV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v2/conversations/{external_id}";
};

export type PutApiV2ConversationsByExternalIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiV2ConversationsByExternalIdError =
  PutApiV2ConversationsByExternalIdErrors[keyof PutApiV2ConversationsByExternalIdErrors];

export type PutApiV2ConversationsByExternalIdResponses = {
  /**
   * Successful Response
   */
  200: UpdateConversationResponseV1;
};

export type PutApiV2ConversationsByExternalIdResponse =
  PutApiV2ConversationsByExternalIdResponses[keyof PutApiV2ConversationsByExternalIdResponses];

export type PostApiV2ConversationsByExternalIdMessagesData = {
  body: AppendConversationMessagesPayloadV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v2/conversations/{external_id}/messages";
};

export type PostApiV2ConversationsByExternalIdMessagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2ConversationsByExternalIdMessagesError =
  PostApiV2ConversationsByExternalIdMessagesErrors[keyof PostApiV2ConversationsByExternalIdMessagesErrors];

export type PostApiV2ConversationsByExternalIdMessagesResponses = {
  /**
   * Successful Response
   */
  200: ConversationFullV1;
};

export type PostApiV2ConversationsByExternalIdMessagesResponse =
  PostApiV2ConversationsByExternalIdMessagesResponses[keyof PostApiV2ConversationsByExternalIdMessagesResponses];

export type PostApiV2ConversationsByExternalIdStatelessInferenceData = {
  body: CreateStatelessConversationInferenceV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v2/conversations/{external_id}/stateless-inference";
};

export type PostApiV2ConversationsByExternalIdStatelessInferenceErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2ConversationsByExternalIdStatelessInferenceError =
  PostApiV2ConversationsByExternalIdStatelessInferenceErrors[keyof PostApiV2ConversationsByExternalIdStatelessInferenceErrors];

export type PostApiV2ConversationsByExternalIdStatelessInferenceResponses = {
  /**
   * Successful Response
   */
  200: ConversationInferenceResponseV1;
};

export type PostApiV2ConversationsByExternalIdStatelessInferenceResponse =
  PostApiV2ConversationsByExternalIdStatelessInferenceResponses[keyof PostApiV2ConversationsByExternalIdStatelessInferenceResponses];

export type PostApiV2ConversationsByExternalIdStatefulInferenceData = {
  body: StatefulInferencePayloadV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v2/conversations/{external_id}/stateful-inference";
};

export type PostApiV2ConversationsByExternalIdStatefulInferenceErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2ConversationsByExternalIdStatefulInferenceError =
  PostApiV2ConversationsByExternalIdStatefulInferenceErrors[keyof PostApiV2ConversationsByExternalIdStatefulInferenceErrors];

export type PostApiV2ConversationsByExternalIdStatefulInferenceResponses = {
  /**
   * Successful Response
   */
  200: ConversationInferenceResponseV1;
};

export type PostApiV2ConversationsByExternalIdStatefulInferenceResponse =
  PostApiV2ConversationsByExternalIdStatefulInferenceResponses[keyof PostApiV2ConversationsByExternalIdStatefulInferenceResponses];

export type PostApiV2ConversationsByExternalIdFeedbackData = {
  body: ConversationFeedbackV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v2/conversations/{external_id}/feedback";
};

export type PostApiV2ConversationsByExternalIdFeedbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2ConversationsByExternalIdFeedbackError =
  PostApiV2ConversationsByExternalIdFeedbackErrors[keyof PostApiV2ConversationsByExternalIdFeedbackErrors];

export type PostApiV2ConversationsByExternalIdFeedbackResponses = {
  /**
   * Successful Response
   */
  200: CreateConversationFeedbackResponseV2;
};

export type PostApiV2ConversationsByExternalIdFeedbackResponse =
  PostApiV2ConversationsByExternalIdFeedbackResponses[keyof PostApiV2ConversationsByExternalIdFeedbackResponses];

export type GetApiV1DataDumpConversationsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/data-dump-conversations";
};

export type GetApiV1DataDumpConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1DataDumpConversationsError =
  GetApiV1DataDumpConversationsErrors[keyof GetApiV1DataDumpConversationsErrors];

export type GetApiV1DataDumpConversationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1DataDumpConversationV1;
};

export type GetApiV1DataDumpConversationsResponse =
  GetApiV1DataDumpConversationsResponses[keyof GetApiV1DataDumpConversationsResponses];

export type PostApiV1DataDumpConversationsData = {
  body: CreateDataDumpConversationRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/data-dump-conversations";
};

export type PostApiV1DataDumpConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1DataDumpConversationsError =
  PostApiV1DataDumpConversationsErrors[keyof PostApiV1DataDumpConversationsErrors];

export type PostApiV1DataDumpConversationsResponses = {
  /**
   * Successful Response
   */
  200: DataDumpConversationV1;
};

export type PostApiV1DataDumpConversationsResponse =
  PostApiV1DataDumpConversationsResponses[keyof PostApiV1DataDumpConversationsResponses];

export type GetApiV1FullDataDumpConversationsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/full-data-dump-conversations";
};

export type GetApiV1FullDataDumpConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullDataDumpConversationsError =
  GetApiV1FullDataDumpConversationsErrors[keyof GetApiV1FullDataDumpConversationsErrors];

export type GetApiV1FullDataDumpConversationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1DataDumpConversationFullV1;
};

export type GetApiV1FullDataDumpConversationsResponse =
  GetApiV1FullDataDumpConversationsResponses[keyof GetApiV1FullDataDumpConversationsResponses];

export type DeleteApiV1DataDumpConversationsByDataDumpConversationIdData = {
  body?: never;
  path: {
    /**
     * Data Dump Conversation Id
     */
    data_dump_conversation_id: number;
  };
  query?: never;
  url: "/api/v1/data-dump-conversations/{data_dump_conversation_id}";
};

export type DeleteApiV1DataDumpConversationsByDataDumpConversationIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1DataDumpConversationsByDataDumpConversationIdError =
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdErrors[keyof DeleteApiV1DataDumpConversationsByDataDumpConversationIdErrors];

export type DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponses =
  {
    /**
     * Successful Response
     */
    200: DataDumpConversationV1;
  };

export type DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponse =
  DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponses[keyof DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponses];

export type PatchApiV1DataDumpConversationsByDataDumpConversationIdData = {
  body: UpdateDataDumpConversationParamsV1;
  path: {
    /**
     * Data Dump Conversation Id
     */
    data_dump_conversation_id: number;
  };
  query?: never;
  url: "/api/v1/data-dump-conversations/{data_dump_conversation_id}";
};

export type PatchApiV1DataDumpConversationsByDataDumpConversationIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1DataDumpConversationsByDataDumpConversationIdError =
  PatchApiV1DataDumpConversationsByDataDumpConversationIdErrors[keyof PatchApiV1DataDumpConversationsByDataDumpConversationIdErrors];

export type PatchApiV1DataDumpConversationsByDataDumpConversationIdResponses = {
  /**
   * Successful Response
   */
  200: DataDumpConversationV1;
};

export type PatchApiV1DataDumpConversationsByDataDumpConversationIdResponse =
  PatchApiV1DataDumpConversationsByDataDumpConversationIdResponses[keyof PatchApiV1DataDumpConversationsByDataDumpConversationIdResponses];

export type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreData =
  {
    body?: never;
    path: {
      /**
       * Data Dump Conversation Id
       */
      data_dump_conversation_id: number;
    };
    query?: never;
    url: "/api/v1/data-dump-conversations/{data_dump_conversation_id}/restore";
  };

export type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreError =
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreErrors[keyof PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreErrors];

export type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: DataDumpConversationV1;
  };

export type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponse =
  PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponses[keyof PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponses];

export type PatchApiV3DatapointsData = {
  body: UpdateDatapointV2;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * External Id
     */
    external_id: string;
  };
  url: "/api/v3/datapoints";
};

export type PatchApiV3DatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV3DatapointsError =
  PatchApiV3DatapointsErrors[keyof PatchApiV3DatapointsErrors];

export type PatchApiV3DatapointsResponses = {
  /**
   * Successful Response
   */
  200: UpdateDatapointsResponseV3;
};

export type PatchApiV3DatapointsResponse =
  PatchApiV3DatapointsResponses[keyof PatchApiV3DatapointsResponses];

export type PostApiV3DatapointsData = {
  body: CreateDatapointsRequestV3;
  path?: never;
  query?: never;
  url: "/api/v3/datapoints";
};

export type PostApiV3DatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV3DatapointsError =
  PostApiV3DatapointsErrors[keyof PostApiV3DatapointsErrors];

export type PostApiV3DatapointsResponses = {
  /**
   * Successful Response
   */
  200: CreateDatapointsResponseV3;
};

export type PostApiV3DatapointsResponse =
  PostApiV3DatapointsResponses[keyof PostApiV3DatapointsResponses];

export type PostApiV1DatapointsEmbedData = {
  body: EmbedDatapointsRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/datapoints/embed";
};

export type PostApiV1DatapointsEmbedErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1DatapointsEmbedError =
  PostApiV1DatapointsEmbedErrors[keyof PostApiV1DatapointsEmbedErrors];

export type PostApiV1DatapointsEmbedResponses = {
  /**
   * Successful Response
   */
  200: EmbedDatapointsResponseV1;
};

export type PostApiV1DatapointsEmbedResponse =
  PostApiV1DatapointsEmbedResponses[keyof PostApiV1DatapointsEmbedResponses];

export type PostApiV1DatapointsBackfillIndexData = {
  body: BackfillIndexRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/datapoints/backfill-index";
};

export type PostApiV1DatapointsBackfillIndexErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1DatapointsBackfillIndexError =
  PostApiV1DatapointsBackfillIndexErrors[keyof PostApiV1DatapointsBackfillIndexErrors];

export type PostApiV1DatapointsBackfillIndexResponses = {
  /**
   * Successful Response
   */
  200: BackfillIndexResponseV1;
};

export type PostApiV1DatapointsBackfillIndexResponse =
  PostApiV1DatapointsBackfillIndexResponses[keyof PostApiV1DatapointsBackfillIndexResponses];

export type PostApiV1DatapointsSearchData = {
  body: SearchDatapointsRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/datapoints/search";
};

export type PostApiV1DatapointsSearchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1DatapointsSearchError =
  PostApiV1DatapointsSearchErrors[keyof PostApiV1DatapointsSearchErrors];

export type PostApiV1DatapointsSearchResponses = {
  /**
   * Successful Response
   */
  200: SearchDatapointsResponseV1;
};

export type PostApiV1DatapointsSearchResponse =
  PostApiV1DatapointsSearchResponses[keyof PostApiV1DatapointsSearchResponses];

export type PostApiV1DatapointsRegexSearchData = {
  body: RegexSearchDatapointsRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/datapoints/regex-search";
};

export type PostApiV1DatapointsRegexSearchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1DatapointsRegexSearchError =
  PostApiV1DatapointsRegexSearchErrors[keyof PostApiV1DatapointsRegexSearchErrors];

export type PostApiV1DatapointsRegexSearchResponses = {
  /**
   * Successful Response
   */
  200: RegexSearchDatapointsResponseV1;
};

export type PostApiV1DatapointsRegexSearchResponse =
  PostApiV1DatapointsRegexSearchResponses[keyof PostApiV1DatapointsRegexSearchResponses];

export type PostApiV1DatapointEvidenceSearchData = {
  body: SearchDatapointEvidenceRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/datapoint-evidence/search";
};

export type PostApiV1DatapointEvidenceSearchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1DatapointEvidenceSearchError =
  PostApiV1DatapointEvidenceSearchErrors[keyof PostApiV1DatapointEvidenceSearchErrors];

export type PostApiV1DatapointEvidenceSearchResponses = {
  /**
   * Successful Response
   */
  200: SearchDatapointEvidenceResponseV1;
};

export type PostApiV1DatapointEvidenceSearchResponse =
  PostApiV1DatapointEvidenceSearchResponses[keyof PostApiV1DatapointEvidenceSearchResponses];

export type GetApiV3DatapointsByDatapointIdData = {
  body?: never;
  path: {
    /**
     * Datapoint Id
     */
    datapoint_id: number;
  };
  query?: never;
  url: "/api/v3/datapoints/{datapoint_id}";
};

export type GetApiV3DatapointsByDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV3DatapointsByDatapointIdError =
  GetApiV3DatapointsByDatapointIdErrors[keyof GetApiV3DatapointsByDatapointIdErrors];

export type GetApiV3DatapointsByDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: DatapointFullV3;
};

export type GetApiV3DatapointsByDatapointIdResponse =
  GetApiV3DatapointsByDatapointIdResponses[keyof GetApiV3DatapointsByDatapointIdResponses];

export type PatchApiV3DatapointsByDatapointIdData = {
  body: UpdateDatapointV2;
  path: {
    /**
     * Datapoint Id
     */
    datapoint_id: number;
  };
  query?: never;
  url: "/api/v3/datapoints/{datapoint_id}";
};

export type PatchApiV3DatapointsByDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV3DatapointsByDatapointIdError =
  PatchApiV3DatapointsByDatapointIdErrors[keyof PatchApiV3DatapointsByDatapointIdErrors];

export type PatchApiV3DatapointsByDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: DatapointV2;
};

export type PatchApiV3DatapointsByDatapointIdResponse =
  PatchApiV3DatapointsByDatapointIdResponses[keyof PatchApiV3DatapointsByDatapointIdResponses];

export type GetApiV1FullDatapointsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Commit Ids Any
     */
    commit_ids_any?: Array<number> | null;
  };
  url: "/api/v1/full-datapoints";
};

export type GetApiV1FullDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullDatapointsError =
  GetApiV1FullDatapointsErrors[keyof GetApiV1FullDatapointsErrors];

export type GetApiV1FullDatapointsResponses = {
  /**
   * Successful Response
   */
  200: PageV1DatapointFullV3;
};

export type GetApiV1FullDatapointsResponse =
  GetApiV1FullDatapointsResponses[keyof GetApiV1FullDatapointsResponses];

export type GetApiV1DatapointEvidenceData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Commit Ids Any
     */
    commit_ids_any?: Array<number> | null;
    /**
     * Kanonical Datapoint Ids Any
     */
    kanonical_datapoint_ids_any?: Array<number> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/datapoint-evidence";
};

export type GetApiV1DatapointEvidenceErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1DatapointEvidenceError =
  GetApiV1DatapointEvidenceErrors[keyof GetApiV1DatapointEvidenceErrors];

export type GetApiV1DatapointEvidenceResponses = {
  /**
   * Successful Response
   */
  200: PageV1DatapointEvidenceV1;
};

export type GetApiV1DatapointEvidenceResponse =
  GetApiV1DatapointEvidenceResponses[keyof GetApiV1DatapointEvidenceResponses];

export type DeleteApiV2DatapointsByDatapointIdData = {
  body?: never;
  path: {
    /**
     * Datapoint Id
     */
    datapoint_id: number;
  };
  query?: never;
  url: "/api/v2/datapoints/{datapoint_id}";
};

export type DeleteApiV2DatapointsByDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV2DatapointsByDatapointIdError =
  DeleteApiV2DatapointsByDatapointIdErrors[keyof DeleteApiV2DatapointsByDatapointIdErrors];

export type DeleteApiV2DatapointsByDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: DatapointV2;
};

export type DeleteApiV2DatapointsByDatapointIdResponse =
  DeleteApiV2DatapointsByDatapointIdResponses[keyof DeleteApiV2DatapointsByDatapointIdResponses];

export type PostApiV2DatapointsByDatapointIdRestoreData = {
  body?: never;
  path: {
    /**
     * Datapoint Id
     */
    datapoint_id: number;
  };
  query?: never;
  url: "/api/v2/datapoints/{datapoint_id}/restore";
};

export type PostApiV2DatapointsByDatapointIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2DatapointsByDatapointIdRestoreError =
  PostApiV2DatapointsByDatapointIdRestoreErrors[keyof PostApiV2DatapointsByDatapointIdRestoreErrors];

export type PostApiV2DatapointsByDatapointIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: DatapointV2;
};

export type PostApiV2DatapointsByDatapointIdRestoreResponse =
  PostApiV2DatapointsByDatapointIdRestoreResponses[keyof PostApiV2DatapointsByDatapointIdRestoreResponses];

export type PostApiDebugV1OpenfgaWriteTuplesData = {
  body: DebugOpenFgaWriteParamsV1;
  path?: never;
  query?: never;
  url: "/api/debug/v1/openfga/write-tuples";
};

export type PostApiDebugV1OpenfgaWriteTuplesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiDebugV1OpenfgaWriteTuplesError =
  PostApiDebugV1OpenfgaWriteTuplesErrors[keyof PostApiDebugV1OpenfgaWriteTuplesErrors];

export type PostApiDebugV1OpenfgaWriteTuplesResponses = {
  /**
   * Successful Response
   */
  200: DebugOpenFgaWriteResultV1;
};

export type PostApiDebugV1OpenfgaWriteTuplesResponse =
  PostApiDebugV1OpenfgaWriteTuplesResponses[keyof PostApiDebugV1OpenfgaWriteTuplesResponses];

export type PostApiDebugV1OpenfgaReadTuplesData = {
  body: DebugOpenFgaReadParamsV1;
  path?: never;
  query?: never;
  url: "/api/debug/v1/openfga/read-tuples";
};

export type PostApiDebugV1OpenfgaReadTuplesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiDebugV1OpenfgaReadTuplesError =
  PostApiDebugV1OpenfgaReadTuplesErrors[keyof PostApiDebugV1OpenfgaReadTuplesErrors];

export type PostApiDebugV1OpenfgaReadTuplesResponses = {
  /**
   * Successful Response
   */
  200: DebugOpenFgaReadResultV1;
};

export type PostApiDebugV1OpenfgaReadTuplesResponse =
  PostApiDebugV1OpenfgaReadTuplesResponses[keyof PostApiDebugV1OpenfgaReadTuplesResponses];

export type PostApiDebugV1OpenfgaCheckData = {
  body: DebugOpenFgaCheckParamsV1;
  path?: never;
  query?: never;
  url: "/api/debug/v1/openfga/check";
};

export type PostApiDebugV1OpenfgaCheckErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiDebugV1OpenfgaCheckError =
  PostApiDebugV1OpenfgaCheckErrors[keyof PostApiDebugV1OpenfgaCheckErrors];

export type PostApiDebugV1OpenfgaCheckResponses = {
  /**
   * Successful Response
   */
  200: DebugOpenFgaCheckResultV1;
};

export type PostApiDebugV1OpenfgaCheckResponse =
  PostApiDebugV1OpenfgaCheckResponses[keyof PostApiDebugV1OpenfgaCheckResponses];

export type GetApiDebugV1GetPoolStatsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/get-pool-stats";
};

export type GetApiDebugV1GetPoolStatsResponses = {
  /**
   * Response Get Pool Stats V1 Api Debug V1 Get Pool Stats Get
   *
   * Successful Response
   */
  200: {
    [key: string]: number;
  };
};

export type GetApiDebugV1GetPoolStatsResponse =
  GetApiDebugV1GetPoolStatsResponses[keyof GetApiDebugV1GetPoolStatsResponses];

export type GetApiDebugV1ReaderPoolCheckData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/reader-pool-check";
};

export type GetApiDebugV1ReaderPoolCheckResponses = {
  /**
   * Successful Response
   */
  200: DebugReaderPoolCheckV1;
};

export type GetApiDebugV1ReaderPoolCheckResponse =
  GetApiDebugV1ReaderPoolCheckResponses[keyof GetApiDebugV1ReaderPoolCheckResponses];

export type GetApiDebugV1LogErrorData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/log-error";
};

export type GetApiDebugV1LogErrorResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiDebugV1LogSentryAlertData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/log-sentry-alert";
};

export type GetApiDebugV1LogSentryAlertResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiDebugV1Return500Data = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/return-500";
};

export type GetApiDebugV1Return500Responses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiDebugV1KeyErrorData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/key-error";
};

export type GetApiDebugV1KeyErrorResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiDebugV1PrintLogsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/print-logs";
};

export type GetApiDebugV1PrintLogsResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiDebugV1UnwrapErrorData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/unwrap-error";
};

export type GetApiDebugV1UnwrapErrorResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiDebugV1BackgroundTaskErrorData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/background-task-error";
};

export type PostApiDebugV1BackgroundTaskErrorResponses = {
  /**
   * Successful Response
   */
  200: BackgroundTaskErrorResponseV1;
};

export type PostApiDebugV1BackgroundTaskErrorResponse =
  PostApiDebugV1BackgroundTaskErrorResponses[keyof PostApiDebugV1BackgroundTaskErrorResponses];

export type PostApiDebugV1SearchReindexData = {
  body: SearchReindexParamsV1;
  path?: never;
  query?: never;
  url: "/api/debug/v1/search/reindex";
};

export type PostApiDebugV1SearchReindexErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiDebugV1SearchReindexError =
  PostApiDebugV1SearchReindexErrors[keyof PostApiDebugV1SearchReindexErrors];

export type PostApiDebugV1SearchReindexResponses = {
  /**
   * Successful Response
   */
  200: SearchReindexResultV1;
};

export type PostApiDebugV1SearchReindexResponse =
  PostApiDebugV1SearchReindexResponses[keyof PostApiDebugV1SearchReindexResponses];

export type GetApiDebugV1ValkeyPingData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/debug/v1/valkey/ping";
};

export type GetApiDebugV1ValkeyPingResponses = {
  /**
   * Successful Response
   */
  200: ValkeyPingV1;
};

export type GetApiDebugV1ValkeyPingResponse =
  GetApiDebugV1ValkeyPingResponses[keyof GetApiDebugV1ValkeyPingResponses];

export type GetApiDebugV1ValkeyValuesByKeyData = {
  body?: never;
  path: {
    /**
     * Key
     */
    key: string;
  };
  query?: never;
  url: "/api/debug/v1/valkey/values/{key}";
};

export type GetApiDebugV1ValkeyValuesByKeyErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiDebugV1ValkeyValuesByKeyError =
  GetApiDebugV1ValkeyValuesByKeyErrors[keyof GetApiDebugV1ValkeyValuesByKeyErrors];

export type GetApiDebugV1ValkeyValuesByKeyResponses = {
  /**
   * Successful Response
   */
  200: ValkeyValueV1;
};

export type GetApiDebugV1ValkeyValuesByKeyResponse =
  GetApiDebugV1ValkeyValuesByKeyResponses[keyof GetApiDebugV1ValkeyValuesByKeyResponses];

export type PutApiDebugV1ValkeyValuesByKeyData = {
  body: SetValkeyValueParamsV1;
  path: {
    /**
     * Key
     */
    key: string;
  };
  query?: never;
  url: "/api/debug/v1/valkey/values/{key}";
};

export type PutApiDebugV1ValkeyValuesByKeyErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiDebugV1ValkeyValuesByKeyError =
  PutApiDebugV1ValkeyValuesByKeyErrors[keyof PutApiDebugV1ValkeyValuesByKeyErrors];

export type PutApiDebugV1ValkeyValuesByKeyResponses = {
  /**
   * Successful Response
   */
  200: ValkeyValueV1;
};

export type PutApiDebugV1ValkeyValuesByKeyResponse =
  PutApiDebugV1ValkeyValuesByKeyResponses[keyof PutApiDebugV1ValkeyValuesByKeyResponses];

export type GetApiEntraV1TenantsByTenantIdActionsUsersData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Search
     */
    search?: string | null;
    /**
     * Cursor
     */
    cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/entra/v1/tenants/{tenant_id}/actions/users";
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersError =
  GetApiEntraV1TenantsByTenantIdActionsUsersErrors[keyof GetApiEntraV1TenantsByTenantIdActionsUsersErrors];

export type GetApiEntraV1TenantsByTenantIdActionsUsersResponses = {
  /**
   * Successful Response
   */
  200: EntraUserPageV1;
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersResponse =
  GetApiEntraV1TenantsByTenantIdActionsUsersResponses[keyof GetApiEntraV1TenantsByTenantIdActionsUsersResponses];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyData = {
  body?: never;
  path: {
    /**
     * User Key
     */
    user_key: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}";
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyError =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyErrors[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyErrors];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponses = {
  /**
   * Successful Response
   */
  200: EntraUserV1;
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponse =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponses[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponses];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesData = {
  body?: never;
  path: {
    /**
     * User Key
     */
    user_key: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/licenses";
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesError =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesErrors[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesErrors];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponses =
  {
    /**
     * Successful Response
     */
    200: EntraLicenseDetailsV1;
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponse =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponses[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponses];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerData = {
  body?: never;
  path: {
    /**
     * User Key
     */
    user_key: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/manager";
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerError =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerErrors[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerErrors];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponses =
  {
    /**
     * Successful Response
     */
    200: EntraUserManagerV1;
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponse =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponses[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponses];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData =
  {
    body?: never;
    path: {
      /**
       * User Key
       */
      user_key: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: {
      /**
       * Cursor
       */
      cursor?: string | null;
      /**
       * Limit
       */
      limit?: number;
    };
    url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/direct-reports";
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsError =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsErrors[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsErrors];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponses =
  {
    /**
     * Successful Response
     */
    200: EntraUserPageV1;
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponse =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponses[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponses];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData = {
  body?: never;
  path: {
    /**
     * User Key
     */
    user_key: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/groups";
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsError =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsErrors[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsErrors];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponses =
  {
    /**
     * Successful Response
     */
    200: EntraGroupPageV1;
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponse =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponses[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponses];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateData =
  {
    body?: never;
    path: {
      /**
       * User Key
       */
      user_key: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/entra/v1/tenants/{tenant_id}/actions/users/{user_key}/sign-in-state";
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateError =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateErrors[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateErrors];

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponses =
  {
    /**
     * Successful Response
     */
    200: EntraSignInStateV1;
  };

export type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponse =
  GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponses[keyof GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponses];

export type GetApiEntraV1TenantsByTenantIdActionsGroupsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Search
     */
    search?: string | null;
    /**
     * Cursor
     */
    cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/entra/v1/tenants/{tenant_id}/actions/groups";
};

export type GetApiEntraV1TenantsByTenantIdActionsGroupsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdActionsGroupsError =
  GetApiEntraV1TenantsByTenantIdActionsGroupsErrors[keyof GetApiEntraV1TenantsByTenantIdActionsGroupsErrors];

export type GetApiEntraV1TenantsByTenantIdActionsGroupsResponses = {
  /**
   * Successful Response
   */
  200: EntraGroupPageV1;
};

export type GetApiEntraV1TenantsByTenantIdActionsGroupsResponse =
  GetApiEntraV1TenantsByTenantIdActionsGroupsResponses[keyof GetApiEntraV1TenantsByTenantIdActionsGroupsResponses];

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdData = {
  body?: never;
  path: {
    /**
     * Group Id
     */
    group_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/actions/groups/{group_id}";
};

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdError =
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdErrors[keyof GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdErrors];

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponses = {
  /**
   * Successful Response
   */
  200: EntraGroupV1;
};

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponse =
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponses[keyof GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponses];

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData = {
  body?: never;
  path: {
    /**
     * Group Id
     */
    group_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/entra/v1/tenants/{tenant_id}/actions/groups/{group_id}/members";
};

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersError =
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersErrors[keyof GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersErrors];

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponses =
  {
    /**
     * Successful Response
     */
    200: EntraDirectoryObjectPageV1;
  };

export type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponse =
  GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponses[keyof GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponses];

export type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/actions/subscribed-skus";
};

export type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusError =
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusErrors[keyof GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusErrors];

export type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponses = {
  /**
   * Successful Response
   */
  200: EntraSubscribedSkusV1;
};

export type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponse =
  GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponses[keyof GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponses];

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/actions/directory-roles";
};

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesError =
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesErrors[keyof GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesErrors];

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponses = {
  /**
   * Successful Response
   */
  200: EntraDirectoryRolesV1;
};

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponse =
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponses[keyof GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponses];

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData =
  {
    body?: never;
    path: {
      /**
       * Role Id
       */
      role_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: {
      /**
       * Cursor
       */
      cursor?: string | null;
      /**
       * Limit
       */
      limit?: number;
    };
    url: "/api/entra/v1/tenants/{tenant_id}/actions/directory-roles/{role_id}/members";
  };

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersError =
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersErrors[keyof GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersErrors];

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponses =
  {
    /**
     * Successful Response
     */
    200: EntraDirectoryObjectPageV1;
  };

export type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponse =
  GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponses[keyof GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponses];

export type PostApiEntraV1TenantsByTenantIdActionsResolveCallerData = {
  body: ResolveEntraCallerParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/actions/resolve-caller";
};

export type PostApiEntraV1TenantsByTenantIdActionsResolveCallerErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiEntraV1TenantsByTenantIdActionsResolveCallerError =
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerErrors[keyof PostApiEntraV1TenantsByTenantIdActionsResolveCallerErrors];

export type PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponses = {
  /**
   * Successful Response
   */
  200: EntraCallerIdentityV1;
};

export type PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponse =
  PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponses[keyof PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponses];

export type GetApiEntraV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/entra/v1/tenants";
};

export type GetApiEntraV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsError =
  GetApiEntraV1TenantsErrors[keyof GetApiEntraV1TenantsErrors];

export type GetApiEntraV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1EntraTenantV1;
};

export type GetApiEntraV1TenantsResponse =
  GetApiEntraV1TenantsResponses[keyof GetApiEntraV1TenantsResponses];

export type PostApiEntraV1TenantsData = {
  body: CreateEntraTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/entra/v1/tenants";
};

export type PostApiEntraV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiEntraV1TenantsError =
  PostApiEntraV1TenantsErrors[keyof PostApiEntraV1TenantsErrors];

export type PostApiEntraV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: EntraTenantV1;
};

export type PostApiEntraV1TenantsResponse =
  PostApiEntraV1TenantsResponses[keyof PostApiEntraV1TenantsResponses];

export type DeleteApiEntraV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}";
};

export type DeleteApiEntraV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiEntraV1TenantsByTenantIdError =
  DeleteApiEntraV1TenantsByTenantIdErrors[keyof DeleteApiEntraV1TenantsByTenantIdErrors];

export type DeleteApiEntraV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: EntraTenantV1;
};

export type DeleteApiEntraV1TenantsByTenantIdResponse =
  DeleteApiEntraV1TenantsByTenantIdResponses[keyof DeleteApiEntraV1TenantsByTenantIdResponses];

export type GetApiEntraV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}";
};

export type GetApiEntraV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdError =
  GetApiEntraV1TenantsByTenantIdErrors[keyof GetApiEntraV1TenantsByTenantIdErrors];

export type GetApiEntraV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: EntraTenantFullV1;
};

export type GetApiEntraV1TenantsByTenantIdResponse =
  GetApiEntraV1TenantsByTenantIdResponses[keyof GetApiEntraV1TenantsByTenantIdResponses];

export type PatchApiEntraV1TenantsByTenantIdData = {
  body: UpdateEntraTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}";
};

export type PatchApiEntraV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiEntraV1TenantsByTenantIdError =
  PatchApiEntraV1TenantsByTenantIdErrors[keyof PatchApiEntraV1TenantsByTenantIdErrors];

export type PatchApiEntraV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: EntraTenantV1;
};

export type PatchApiEntraV1TenantsByTenantIdResponse =
  PatchApiEntraV1TenantsByTenantIdResponses[keyof PatchApiEntraV1TenantsByTenantIdResponses];

export type GetApiEntraV1FullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/entra/v1/full-tenants";
};

export type GetApiEntraV1FullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1FullTenantsError =
  GetApiEntraV1FullTenantsErrors[keyof GetApiEntraV1FullTenantsErrors];

export type GetApiEntraV1FullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1EntraTenantFullV1;
};

export type GetApiEntraV1FullTenantsResponse =
  GetApiEntraV1FullTenantsResponses[keyof GetApiEntraV1FullTenantsResponses];

export type GetApiEntraV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiEntraV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdCheckConnectionError =
  GetApiEntraV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiEntraV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiEntraV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: EntraCheckConnectionResponseV1;
};

export type GetApiEntraV1TenantsByTenantIdCheckConnectionResponse =
  GetApiEntraV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiEntraV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiEntraV1TenantsByTenantIdPermissionPreflightData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/permission-preflight";
};

export type GetApiEntraV1TenantsByTenantIdPermissionPreflightErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdPermissionPreflightError =
  GetApiEntraV1TenantsByTenantIdPermissionPreflightErrors[keyof GetApiEntraV1TenantsByTenantIdPermissionPreflightErrors];

export type GetApiEntraV1TenantsByTenantIdPermissionPreflightResponses = {
  /**
   * Successful Response
   */
  200: EntraPermissionPreflightV1;
};

export type GetApiEntraV1TenantsByTenantIdPermissionPreflightResponse =
  GetApiEntraV1TenantsByTenantIdPermissionPreflightResponses[keyof GetApiEntraV1TenantsByTenantIdPermissionPreflightResponses];

export type GetApiEntraV1TenantsByTenantIdProposedActionsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions";
};

export type GetApiEntraV1TenantsByTenantIdProposedActionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdProposedActionsError =
  GetApiEntraV1TenantsByTenantIdProposedActionsErrors[keyof GetApiEntraV1TenantsByTenantIdProposedActionsErrors];

export type GetApiEntraV1TenantsByTenantIdProposedActionsResponses = {
  /**
   * Successful Response
   */
  200: PageV1EntraProposedActionV1;
};

export type GetApiEntraV1TenantsByTenantIdProposedActionsResponse =
  GetApiEntraV1TenantsByTenantIdProposedActionsResponses[keyof GetApiEntraV1TenantsByTenantIdProposedActionsResponses];

export type PostApiEntraV1TenantsByTenantIdProposedActionsData = {
  body: CreateEntraProposedActionParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions";
};

export type PostApiEntraV1TenantsByTenantIdProposedActionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiEntraV1TenantsByTenantIdProposedActionsError =
  PostApiEntraV1TenantsByTenantIdProposedActionsErrors[keyof PostApiEntraV1TenantsByTenantIdProposedActionsErrors];

export type PostApiEntraV1TenantsByTenantIdProposedActionsResponses = {
  /**
   * Successful Response
   */
  200: EntraProposedActionV1;
};

export type PostApiEntraV1TenantsByTenantIdProposedActionsResponse =
  PostApiEntraV1TenantsByTenantIdProposedActionsResponses[keyof PostApiEntraV1TenantsByTenantIdProposedActionsResponses];

export type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Action Id
     */
    action_id: number;
  };
  query?: never;
  url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions/{action_id}";
};

export type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdError =
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdErrors[keyof GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdErrors];

export type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponses = {
  /**
   * Successful Response
   */
  200: EntraProposedActionV1;
};

export type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponse =
  GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponses[keyof GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponses];

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Action Id
       */
      action_id: number;
    };
    query?: never;
    url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions/{action_id}/approve";
  };

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveError =
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveErrors[keyof PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveErrors];

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponses =
  {
    /**
     * Successful Response
     */
    200: EntraProposedActionV1;
  };

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponse =
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponses[keyof PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponses];

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectData =
  {
    body: RejectEntraProposedActionParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Action Id
       */
      action_id: number;
    };
    query?: never;
    url: "/api/entra/v1/tenants/{tenant_id}/proposed-actions/{action_id}/reject";
  };

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectError =
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectErrors[keyof PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectErrors];

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponses =
  {
    /**
     * Successful Response
     */
    200: EntraProposedActionV1;
  };

export type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponse =
  PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponses[keyof PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponses];

export type GetApiV1JudgesData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/judges";
};

export type GetApiV1JudgesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1JudgesError =
  GetApiV1JudgesErrors[keyof GetApiV1JudgesErrors];

export type GetApiV1JudgesResponses = {
  /**
   * Successful Response
   */
  200: PageV1EvalJudgeV1;
};

export type GetApiV1JudgesResponse =
  GetApiV1JudgesResponses[keyof GetApiV1JudgesResponses];

export type PostApiV1JudgesData = {
  body: CreateJudgeParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/judges";
};

export type PostApiV1JudgesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1JudgesError =
  PostApiV1JudgesErrors[keyof PostApiV1JudgesErrors];

export type PostApiV1JudgesResponses = {
  /**
   * Successful Response
   */
  200: EvalJudgeV1;
};

export type PostApiV1JudgesResponse =
  PostApiV1JudgesResponses[keyof PostApiV1JudgesResponses];

export type DeleteApiV1JudgesByJudgeIdData = {
  body?: never;
  path: {
    /**
     * Judge Id
     */
    judge_id: number;
  };
  query?: never;
  url: "/api/v1/judges/{judge_id}";
};

export type DeleteApiV1JudgesByJudgeIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1JudgesByJudgeIdError =
  DeleteApiV1JudgesByJudgeIdErrors[keyof DeleteApiV1JudgesByJudgeIdErrors];

export type DeleteApiV1JudgesByJudgeIdResponses = {
  /**
   * Successful Response
   */
  200: EvalJudgeV1;
};

export type DeleteApiV1JudgesByJudgeIdResponse =
  DeleteApiV1JudgesByJudgeIdResponses[keyof DeleteApiV1JudgesByJudgeIdResponses];

export type GetApiV1JudgesByJudgeIdData = {
  body?: never;
  path: {
    /**
     * Judge Id
     */
    judge_id: number;
  };
  query?: never;
  url: "/api/v1/judges/{judge_id}";
};

export type GetApiV1JudgesByJudgeIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1JudgesByJudgeIdError =
  GetApiV1JudgesByJudgeIdErrors[keyof GetApiV1JudgesByJudgeIdErrors];

export type GetApiV1JudgesByJudgeIdResponses = {
  /**
   * Successful Response
   */
  200: EvalJudgeV1;
};

export type GetApiV1JudgesByJudgeIdResponse =
  GetApiV1JudgesByJudgeIdResponses[keyof GetApiV1JudgesByJudgeIdResponses];

export type PatchApiV1JudgesByJudgeIdData = {
  body: UpdateJudgeParamsV1;
  path: {
    /**
     * Judge Id
     */
    judge_id: number;
  };
  query?: never;
  url: "/api/v1/judges/{judge_id}";
};

export type PatchApiV1JudgesByJudgeIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1JudgesByJudgeIdError =
  PatchApiV1JudgesByJudgeIdErrors[keyof PatchApiV1JudgesByJudgeIdErrors];

export type PatchApiV1JudgesByJudgeIdResponses = {
  /**
   * Successful Response
   */
  200: EvalJudgeV1;
};

export type PatchApiV1JudgesByJudgeIdResponse =
  PatchApiV1JudgesByJudgeIdResponses[keyof PatchApiV1JudgesByJudgeIdResponses];

export type PostApiV1JudgesByJudgeIdRestoreData = {
  body?: never;
  path: {
    /**
     * Judge Id
     */
    judge_id: number;
  };
  query?: never;
  url: "/api/v1/judges/{judge_id}/restore";
};

export type PostApiV1JudgesByJudgeIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1JudgesByJudgeIdRestoreError =
  PostApiV1JudgesByJudgeIdRestoreErrors[keyof PostApiV1JudgesByJudgeIdRestoreErrors];

export type PostApiV1JudgesByJudgeIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: EvalJudgeV1;
};

export type PostApiV1JudgesByJudgeIdRestoreResponse =
  PostApiV1JudgesByJudgeIdRestoreResponses[keyof PostApiV1JudgesByJudgeIdRestoreResponses];

export type GetApiV1ExternalInferencesData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Finalized Conversation Id
     */
    finalized_conversation_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/external-inferences";
};

export type GetApiV1ExternalInferencesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ExternalInferencesError =
  GetApiV1ExternalInferencesErrors[keyof GetApiV1ExternalInferencesErrors];

export type GetApiV1ExternalInferencesResponses = {
  /**
   * Successful Response
   */
  200: PageV2ExternalInferenceV1;
};

export type GetApiV1ExternalInferencesResponse =
  GetApiV1ExternalInferencesResponses[keyof GetApiV1ExternalInferencesResponses];

export type PostApiV1ExternalInferencesData = {
  body: CreateExternalInferencesParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/external-inferences";
};

export type PostApiV1ExternalInferencesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ExternalInferencesError =
  PostApiV1ExternalInferencesErrors[keyof PostApiV1ExternalInferencesErrors];

export type PostApiV1ExternalInferencesResponses = {
  /**
   * Successful Response
   */
  200: CreateExternalInferencesResponseV1;
};

export type PostApiV1ExternalInferencesResponse =
  PostApiV1ExternalInferencesResponses[keyof PostApiV1ExternalInferencesResponses];

export type DeleteApiV1ExternalInferencesByInferenceIdData = {
  body?: never;
  path: {
    /**
     * Inference Id
     */
    inference_id: number;
  };
  query?: never;
  url: "/api/v1/external-inferences/{inference_id}";
};

export type DeleteApiV1ExternalInferencesByInferenceIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ExternalInferencesByInferenceIdError =
  DeleteApiV1ExternalInferencesByInferenceIdErrors[keyof DeleteApiV1ExternalInferencesByInferenceIdErrors];

export type DeleteApiV1ExternalInferencesByInferenceIdResponses = {
  /**
   * Successful Response
   */
  200: ExternalInferenceV1;
};

export type DeleteApiV1ExternalInferencesByInferenceIdResponse =
  DeleteApiV1ExternalInferencesByInferenceIdResponses[keyof DeleteApiV1ExternalInferencesByInferenceIdResponses];

export type GetApiV1ExternalInferencesByInferenceIdData = {
  body?: never;
  path: {
    /**
     * Inference Id
     */
    inference_id: number;
  };
  query?: never;
  url: "/api/v1/external-inferences/{inference_id}";
};

export type GetApiV1ExternalInferencesByInferenceIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ExternalInferencesByInferenceIdError =
  GetApiV1ExternalInferencesByInferenceIdErrors[keyof GetApiV1ExternalInferencesByInferenceIdErrors];

export type GetApiV1ExternalInferencesByInferenceIdResponses = {
  /**
   * Successful Response
   */
  200: ExternalInferenceFullV1;
};

export type GetApiV1ExternalInferencesByInferenceIdResponse =
  GetApiV1ExternalInferencesByInferenceIdResponses[keyof GetApiV1ExternalInferencesByInferenceIdResponses];

export type PatchApiV1ExternalInferencesByInferenceIdData = {
  body: UpdateExternalInferenceParamsV1;
  path: {
    /**
     * Inference Id
     */
    inference_id: number;
  };
  query?: never;
  url: "/api/v1/external-inferences/{inference_id}";
};

export type PatchApiV1ExternalInferencesByInferenceIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ExternalInferencesByInferenceIdError =
  PatchApiV1ExternalInferencesByInferenceIdErrors[keyof PatchApiV1ExternalInferencesByInferenceIdErrors];

export type PatchApiV1ExternalInferencesByInferenceIdResponses = {
  /**
   * Successful Response
   */
  200: ExternalInferenceV1;
};

export type PatchApiV1ExternalInferencesByInferenceIdResponse =
  PatchApiV1ExternalInferencesByInferenceIdResponses[keyof PatchApiV1ExternalInferencesByInferenceIdResponses];

export type GetApiV2FinalizedConversationsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v2/finalized-conversations";
};

export type GetApiV2FinalizedConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2FinalizedConversationsError =
  GetApiV2FinalizedConversationsErrors[keyof GetApiV2FinalizedConversationsErrors];

export type GetApiV2FinalizedConversationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1FinalizedConversationV1;
};

export type GetApiV2FinalizedConversationsResponse =
  GetApiV2FinalizedConversationsResponses[keyof GetApiV2FinalizedConversationsResponses];

export type PostApiV2FinalizedConversationsData = {
  body: CreateFinalizedConversationRequestV2;
  path?: never;
  query?: never;
  url: "/api/v2/finalized-conversations";
};

export type PostApiV2FinalizedConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2FinalizedConversationsError =
  PostApiV2FinalizedConversationsErrors[keyof PostApiV2FinalizedConversationsErrors];

export type PostApiV2FinalizedConversationsResponses = {
  /**
   * Successful Response
   */
  200: CreateFinalizedConversationResponseV2;
};

export type PostApiV2FinalizedConversationsResponse =
  PostApiV2FinalizedConversationsResponses[keyof PostApiV2FinalizedConversationsResponses];

export type GetApiV2FullFinalizedConversationsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Commit Ids Any
     */
    commit_ids_any?: Array<number> | null;
    /**
     * Kanonical Datapoint Ids Any
     */
    kanonical_datapoint_ids_any?: Array<number> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v2/full-finalized-conversations";
};

export type GetApiV2FullFinalizedConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2FullFinalizedConversationsError =
  GetApiV2FullFinalizedConversationsErrors[keyof GetApiV2FullFinalizedConversationsErrors];

export type GetApiV2FullFinalizedConversationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1FinalizedConversationFullV2;
};

export type GetApiV2FullFinalizedConversationsResponse =
  GetApiV2FullFinalizedConversationsResponses[keyof GetApiV2FullFinalizedConversationsResponses];

export type GetApiV2FullFinalizedConversationsByFinalizedConversationIdData = {
  body?: never;
  path: {
    /**
     * Finalized Conversation Id
     */
    finalized_conversation_id: number;
  };
  query?: never;
  url: "/api/v2/full-finalized-conversations/{finalized_conversation_id}";
};

export type GetApiV2FullFinalizedConversationsByFinalizedConversationIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV2FullFinalizedConversationsByFinalizedConversationIdError =
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdErrors[keyof GetApiV2FullFinalizedConversationsByFinalizedConversationIdErrors];

export type GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponses =
  {
    /**
     * Successful Response
     */
    200: FinalizedConversationFullV1;
  };

export type GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponse =
  GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponses[keyof GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponses];

export type DeleteApiV1FinalizedConversationsByFinalizedConversationIdData = {
  body?: never;
  path: {
    /**
     * Finalized Conversation Id
     */
    finalized_conversation_id: number;
  };
  query?: never;
  url: "/api/v1/finalized-conversations/{finalized_conversation_id}";
};

export type DeleteApiV1FinalizedConversationsByFinalizedConversationIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1FinalizedConversationsByFinalizedConversationIdError =
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdErrors[keyof DeleteApiV1FinalizedConversationsByFinalizedConversationIdErrors];

export type DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponses =
  {
    /**
     * Successful Response
     */
    200: FinalizedConversationV1;
  };

export type DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponse =
  DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponses[keyof DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponses];

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdData = {
  body: UpdateFinalizedConversationParamsV1;
  path: {
    /**
     * Finalized Conversation Id
     */
    finalized_conversation_id: number;
  };
  query?: never;
  url: "/api/v1/finalized-conversations/{finalized_conversation_id}";
};

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdError =
  PatchApiV1FinalizedConversationsByFinalizedConversationIdErrors[keyof PatchApiV1FinalizedConversationsByFinalizedConversationIdErrors];

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdResponses =
  {
    /**
     * Successful Response
     */
    200: FinalizedConversationV1;
  };

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdResponse =
  PatchApiV1FinalizedConversationsByFinalizedConversationIdResponses[keyof PatchApiV1FinalizedConversationsByFinalizedConversationIdResponses];

export type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreData =
  {
    body?: never;
    path: {
      /**
       * Finalized Conversation Id
       */
      finalized_conversation_id: number;
    };
    query?: never;
    url: "/api/v1/finalized-conversations/{finalized_conversation_id}/restore";
  };

export type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreError =
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreErrors[keyof PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreErrors];

export type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: FinalizedConversationV1;
  };

export type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponse =
  PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponses[keyof PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponses];

export type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesData =
  {
    body: AppendFinalizedConversationMessagesPayloadV1;
    path: {
      /**
       * Finalized Conversation Id
       */
      finalized_conversation_id: number;
    };
    query?: never;
    url: "/api/v1/finalized-conversations/{finalized_conversation_id}/messages";
  };

export type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesError =
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesErrors[keyof PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesErrors];

export type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponses =
  {
    /**
     * Successful Response
     */
    200: FinalizedConversationV1;
  };

export type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponse =
  PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponses[keyof PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponses];

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdData =
  {
    body: UpdateFinalizedConversationMessageParamsV1;
    path: {
      /**
       * Finalized Conversation Id
       */
      finalized_conversation_id: number;
      /**
       * Message Id
       */
      message_id: number;
    };
    query?: never;
    url: "/api/v1/finalized-conversations/{finalized_conversation_id}/messages/{message_id}";
  };

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdError =
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdErrors[keyof PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdErrors];

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponses =
  {
    /**
     * Successful Response
     */
    200: FinalizedConversationMessageV1;
  };

export type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponse =
  PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponses[keyof PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Updated Since
     */
    updated_since?: Date | null;
    /**
     * Page
     */
    page?: number | null;
    /**
     * Per Page
     */
    per_page?: number | null;
  };
  url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets";
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsError =
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceTicketPageV1;
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses];

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsData = {
  body: CreateFreshserviceTicketParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets";
};

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsError =
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors[keyof PostApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors];

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceTicketV1;
};

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse =
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses[keyof PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Ticket Id
       */
      ticket_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}";
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError =
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceTicketV1;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses];

export type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData =
  {
    body: UpdateFreshserviceTicketParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Ticket Id
       */
      ticket_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}";
  };

export type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError =
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors[keyof PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors];

export type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceTicketV1;
  };

export type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse =
  PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses[keyof PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Ticket Id
       */
      ticket_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}/conversations";
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsError =
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceConversationListV1;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponses];

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyData =
  {
    body: FreshserviceReplyToTicketParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Ticket Id
       */
      ticket_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}/reply";
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyError =
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyErrors[keyof PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyErrors];

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceConversationV1;
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponse =
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponses[keyof PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponses];

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesData =
  {
    body: FreshserviceAddNoteToTicketParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Ticket Id
       */
      ticket_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/tickets/{ticket_id}/notes";
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesError =
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesErrors[keyof PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesErrors];

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceConversationV1;
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponse =
  PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponses[keyof PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/categories";
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesError =
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceCategoryListV1;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * Category Id
     */
    category_id: number;
  };
  url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/folders";
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError =
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceFolderListV1;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses];

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData =
  {
    body: CreateFreshserviceFolderParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/folders";
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError =
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors[keyof PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors];

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceFolderV1;
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse =
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses[keyof PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query: {
      /**
       * Folder Id
       */
      folder_id: number;
    };
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/articles";
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError =
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceArticleListV1;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses];

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData =
  {
    body: CreateFreshserviceArticleParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/articles";
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError =
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors[keyof PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors];

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceArticleV1;
  };

export type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse =
  PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses[keyof PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Article Id
       */
      article_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/articles/{article_id}";
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError =
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceArticleV1;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses];

export type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData =
  {
    body: UpdateFreshserviceArticleParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Article Id
       */
      article_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/solutions/articles/{article_id}";
  };

export type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError =
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors[keyof PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors];

export type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceArticleV1;
  };

export type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse =
  PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses[keyof PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Page
     */
    page?: number | null;
    /**
     * Per Page
     */
    per_page?: number | null;
  };
  url: "/api/freshservice/v1/tenants/{tenant_id}/actions/requesters";
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersError =
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsRequestersErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceRequesterPageV1;
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Requester Id
       */
      requester_id: number;
    };
    query?: never;
    url: "/api/freshservice/v1/tenants/{tenant_id}/actions/requesters/{requester_id}";
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdError =
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceRequesterV1;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Page
     */
    page?: number | null;
    /**
     * Per Page
     */
    per_page?: number | null;
  };
  url: "/api/freshservice/v1/tenants/{tenant_id}/actions/agents";
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsError =
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsAgentsErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceAgentPageV1;
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponses];

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Agent Id
     */
    agent_id: number;
  };
  query?: never;
  url: "/api/freshservice/v1/tenants/{tenant_id}/actions/agents/{agent_id}";
};

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdError =
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdErrors[keyof GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdErrors];

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponses =
  {
    /**
     * Successful Response
     */
    200: FreshserviceAgentV1;
  };

export type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponse =
  GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponses[keyof GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponses];

export type GetApiFreshserviceV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/freshservice/v1/tenants";
};

export type GetApiFreshserviceV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiFreshserviceV1TenantsError =
  GetApiFreshserviceV1TenantsErrors[keyof GetApiFreshserviceV1TenantsErrors];

export type GetApiFreshserviceV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV2FreshserviceTenantV1;
};

export type GetApiFreshserviceV1TenantsResponse =
  GetApiFreshserviceV1TenantsResponses[keyof GetApiFreshserviceV1TenantsResponses];

export type PostApiFreshserviceV1TenantsData = {
  body: CreateFreshserviceTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/freshservice/v1/tenants";
};

export type PostApiFreshserviceV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiFreshserviceV1TenantsError =
  PostApiFreshserviceV1TenantsErrors[keyof PostApiFreshserviceV1TenantsErrors];

export type PostApiFreshserviceV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceTenantV1;
};

export type PostApiFreshserviceV1TenantsResponse =
  PostApiFreshserviceV1TenantsResponses[keyof PostApiFreshserviceV1TenantsResponses];

export type GetApiFreshserviceV1FullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/freshservice/v1/full-tenants";
};

export type GetApiFreshserviceV1FullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiFreshserviceV1FullTenantsError =
  GetApiFreshserviceV1FullTenantsErrors[keyof GetApiFreshserviceV1FullTenantsErrors];

export type GetApiFreshserviceV1FullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV2FreshserviceTenantFullV1;
};

export type GetApiFreshserviceV1FullTenantsResponse =
  GetApiFreshserviceV1FullTenantsResponses[keyof GetApiFreshserviceV1FullTenantsResponses];

export type DeleteApiFreshserviceV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/freshservice/v1/tenants/{tenant_id}";
};

export type DeleteApiFreshserviceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiFreshserviceV1TenantsByTenantIdError =
  DeleteApiFreshserviceV1TenantsByTenantIdErrors[keyof DeleteApiFreshserviceV1TenantsByTenantIdErrors];

export type DeleteApiFreshserviceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceTenantV1;
};

export type DeleteApiFreshserviceV1TenantsByTenantIdResponse =
  DeleteApiFreshserviceV1TenantsByTenantIdResponses[keyof DeleteApiFreshserviceV1TenantsByTenantIdResponses];

export type GetApiFreshserviceV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/freshservice/v1/tenants/{tenant_id}";
};

export type GetApiFreshserviceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiFreshserviceV1TenantsByTenantIdError =
  GetApiFreshserviceV1TenantsByTenantIdErrors[keyof GetApiFreshserviceV1TenantsByTenantIdErrors];

export type GetApiFreshserviceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceTenantFullV1;
};

export type GetApiFreshserviceV1TenantsByTenantIdResponse =
  GetApiFreshserviceV1TenantsByTenantIdResponses[keyof GetApiFreshserviceV1TenantsByTenantIdResponses];

export type PatchApiFreshserviceV1TenantsByTenantIdData = {
  body: UpdateFreshserviceTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/freshservice/v1/tenants/{tenant_id}";
};

export type PatchApiFreshserviceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiFreshserviceV1TenantsByTenantIdError =
  PatchApiFreshserviceV1TenantsByTenantIdErrors[keyof PatchApiFreshserviceV1TenantsByTenantIdErrors];

export type PatchApiFreshserviceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceTenantV1;
};

export type PatchApiFreshserviceV1TenantsByTenantIdResponse =
  PatchApiFreshserviceV1TenantsByTenantIdResponses[keyof PatchApiFreshserviceV1TenantsByTenantIdResponses];

export type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/freshservice/v1/tenants/{tenant_id}/provision-webhook";
};

export type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookError =
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookErrors[keyof PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookErrors];

export type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceProvisionWebhookResponseV1;
};

export type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponse =
  PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponses[keyof PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponses];

export type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/freshservice/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionError =
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiFreshserviceV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceCheckConnectionResponseV1;
};

export type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponse =
  GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiV1FrontendConfigData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/frontend-config";
};

export type GetApiV1FrontendConfigResponses = {
  /**
   * Successful Response
   */
  200: FrontendConfigV1;
};

export type GetApiV1FrontendConfigResponse =
  GetApiV1FrontendConfigResponses[keyof GetApiV1FrontendConfigResponses];

export type PostApiHubspotV1ActionsReplyToThreadData = {
  body: HubSpotReplyToThreadParamsV1;
  path?: never;
  query?: never;
  url: "/api/hubspot/v1/actions/reply-to-thread";
};

export type PostApiHubspotV1ActionsReplyToThreadErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiHubspotV1ActionsReplyToThreadError =
  PostApiHubspotV1ActionsReplyToThreadErrors[keyof PostApiHubspotV1ActionsReplyToThreadErrors];

export type PostApiHubspotV1ActionsReplyToThreadResponses = {
  /**
   * Successful Response
   */
  204: void;
};

export type PostApiHubspotV1ActionsReplyToThreadResponse =
  PostApiHubspotV1ActionsReplyToThreadResponses[keyof PostApiHubspotV1ActionsReplyToThreadResponses];

export type PostApiHubspotV1ActionsCreateThreadOnTicketData = {
  body: HubSpotCreateThreadOnTicketParamsV1;
  path?: never;
  query?: never;
  url: "/api/hubspot/v1/actions/create-thread-on-ticket";
};

export type PostApiHubspotV1ActionsCreateThreadOnTicketErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiHubspotV1ActionsCreateThreadOnTicketError =
  PostApiHubspotV1ActionsCreateThreadOnTicketErrors[keyof PostApiHubspotV1ActionsCreateThreadOnTicketErrors];

export type PostApiHubspotV1ActionsCreateThreadOnTicketResponses = {
  /**
   * Successful Response
   */
  204: void;
};

export type PostApiHubspotV1ActionsCreateThreadOnTicketResponse =
  PostApiHubspotV1ActionsCreateThreadOnTicketResponses[keyof PostApiHubspotV1ActionsCreateThreadOnTicketResponses];

export type PostApiHubspotV2TenantsByTenantIdActionsAddNoteData = {
  body: HubSpotAddNoteParamsV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/hubspot/v2/tenants/{tenant_id}/actions/add-note";
};

export type PostApiHubspotV2TenantsByTenantIdActionsAddNoteErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiHubspotV2TenantsByTenantIdActionsAddNoteError =
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteErrors[keyof PostApiHubspotV2TenantsByTenantIdActionsAddNoteErrors];

export type PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponses = {
  /**
   * Successful Response
   */
  200: HubSpotAddNoteResponseV2;
};

export type PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponse =
  PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponses[keyof PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponses];

export type PostApiHubspotV1ActionsUpdateNoteData = {
  body: HubSpotUpdateNoteParamsV1;
  path?: never;
  query?: never;
  url: "/api/hubspot/v1/actions/update-note";
};

export type PostApiHubspotV1ActionsUpdateNoteErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiHubspotV1ActionsUpdateNoteError =
  PostApiHubspotV1ActionsUpdateNoteErrors[keyof PostApiHubspotV1ActionsUpdateNoteErrors];

export type PostApiHubspotV1ActionsUpdateNoteResponses = {
  /**
   * Successful Response
   */
  200: HubSpotNoteV1;
};

export type PostApiHubspotV1ActionsUpdateNoteResponse =
  PostApiHubspotV1ActionsUpdateNoteResponses[keyof PostApiHubspotV1ActionsUpdateNoteResponses];

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerData = {
  body: HubSpotSetTicketOwnerParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/hubspot/v1/tenants/{tenant_id}/actions/set-ticket-owner";
};

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerError =
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerErrors[keyof PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerErrors];

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponses = {
  /**
   * Successful Response
   */
  200: HubSpotTicketV1;
};

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponse =
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponses[keyof PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponses];

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusData = {
  body: HubSpotSetTicketStatusParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/hubspot/v1/tenants/{tenant_id}/actions/set-ticket-status";
};

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusError =
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusErrors[keyof PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusErrors];

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponses = {
  /**
   * Successful Response
   */
  200: HubSpotTicketV1;
};

export type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponse =
  PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponses[keyof PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponses];

export type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesData =
  {
    body: HubSpotUpdateTicketPropertiesParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/hubspot/v1/tenants/{tenant_id}/actions/update-ticket-properties";
  };

export type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesError =
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesErrors[keyof PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesErrors];

export type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponses =
  {
    /**
     * Successful Response
     */
    200: HubSpotTicketV1;
  };

export type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponse =
  PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponses[keyof PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponses];

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * File Id
     */
    file_id: string;
    /**
     * Url
     */
    url?: string | null;
  };
  url: "/api/hubspot/v1/tenants/{tenant_id}/actions/attachment-content";
};

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentError =
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentErrors[keyof GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentErrors];

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponses =
  {
    /**
     * Successful Response
     */
    200: HubSpotGetAttachmentContentResponseV1;
  };

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponse =
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponses[keyof GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponses];

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * File Id
     */
    file_id: string;
  };
  url: "/api/hubspot/v1/tenants/{tenant_id}/actions/attachment-metadata";
};

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataError =
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataErrors[keyof GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataErrors];

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponses =
  {
    /**
     * Successful Response
     */
    200: HubSpotGetAttachmentMetadataResponseV1;
  };

export type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponse =
  GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponses[keyof GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponses];

export type GetApiV1HubspotTenantsByTenantIdTicketsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * After Cursor
     */
    after_cursor?: string | null;
  };
  url: "/api/v1/hubspot/tenants/{tenant_id}/tickets";
};

export type GetApiV1HubspotTenantsByTenantIdTicketsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdTicketsError =
  GetApiV1HubspotTenantsByTenantIdTicketsErrors[keyof GetApiV1HubspotTenantsByTenantIdTicketsErrors];

export type GetApiV1HubspotTenantsByTenantIdTicketsResponses = {
  /**
   * Successful Response
   */
  200: HubSpotTicketPageV1;
};

export type GetApiV1HubspotTenantsByTenantIdTicketsResponse =
  GetApiV1HubspotTenantsByTenantIdTicketsResponses[keyof GetApiV1HubspotTenantsByTenantIdTicketsResponses];

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Ticket Id
     */
    ticket_id: string;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}/tickets/{ticket_id}";
};

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdError =
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdErrors[keyof GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdErrors];

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponses = {
  /**
   * Successful Response
   */
  200: HubSpotTicketFullV1;
};

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponse =
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponses[keyof GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponses];

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Ticket Id
     */
    ticket_id: string;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}/tickets/{ticket_id}/notes";
};

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesError =
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesErrors[keyof GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesErrors];

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponses = {
  /**
   * Successful Response
   */
  200: PageV1HubSpotNoteV1;
};

export type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponse =
  GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponses[keyof GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponses];

export type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Company Id
     */
    company_id: string;
  };
  query?: {
    /**
     * Properties
     */
    properties?: Array<string> | null;
  };
  url: "/api/v1/hubspot/tenants/{tenant_id}/companies/{company_id}";
};

export type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdError =
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdErrors[keyof GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdErrors];

export type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponses = {
  /**
   * Successful Response
   */
  200: HubSpotCompanyFullV1;
};

export type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponse =
  GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponses[keyof GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponses];

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Thread Id
     */
    thread_id: string;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}/threads/{thread_id}";
};

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdError =
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdErrors[keyof GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdErrors];

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponses = {
  /**
   * Successful Response
   */
  200: HubSpotThreadV1;
};

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponse =
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponses[keyof GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponses];

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Thread Id
     */
    thread_id: string;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}/threads/{thread_id}/messages";
};

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesError =
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesErrors[keyof GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesErrors];

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponses =
  {
    /**
     * Successful Response
     */
    200: PageV1HubSpotThreadMessageV1;
  };

export type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponse =
  GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponses[keyof GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponses];

export type GetApiV1HubspotTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/hubspot/tenants";
};

export type GetApiV1HubspotTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsError =
  GetApiV1HubspotTenantsErrors[keyof GetApiV1HubspotTenantsErrors];

export type GetApiV1HubspotTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1HubSpotTenantV1;
};

export type GetApiV1HubspotTenantsResponse =
  GetApiV1HubspotTenantsResponses[keyof GetApiV1HubspotTenantsResponses];

export type PostApiV1HubspotTenantsData = {
  body: CreateHubSpotTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/hubspot/tenants";
};

export type PostApiV1HubspotTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1HubspotTenantsError =
  PostApiV1HubspotTenantsErrors[keyof PostApiV1HubspotTenantsErrors];

export type PostApiV1HubspotTenantsResponses = {
  /**
   * Successful Response
   */
  200: HubSpotTenantV1;
};

export type PostApiV1HubspotTenantsResponse =
  PostApiV1HubspotTenantsResponses[keyof PostApiV1HubspotTenantsResponses];

export type GetApiV1HubspotFullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/hubspot/full-tenants";
};

export type GetApiV1HubspotFullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotFullTenantsError =
  GetApiV1HubspotFullTenantsErrors[keyof GetApiV1HubspotFullTenantsErrors];

export type GetApiV1HubspotFullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1HubSpotTenantFullV1;
};

export type GetApiV1HubspotFullTenantsResponse =
  GetApiV1HubspotFullTenantsResponses[keyof GetApiV1HubspotFullTenantsResponses];

export type DeleteApiV1HubspotTenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}";
};

export type DeleteApiV1HubspotTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1HubspotTenantsByTenantIdError =
  DeleteApiV1HubspotTenantsByTenantIdErrors[keyof DeleteApiV1HubspotTenantsByTenantIdErrors];

export type DeleteApiV1HubspotTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: HubSpotTenantV1;
};

export type DeleteApiV1HubspotTenantsByTenantIdResponse =
  DeleteApiV1HubspotTenantsByTenantIdResponses[keyof DeleteApiV1HubspotTenantsByTenantIdResponses];

export type GetApiV1HubspotTenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}";
};

export type GetApiV1HubspotTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdError =
  GetApiV1HubspotTenantsByTenantIdErrors[keyof GetApiV1HubspotTenantsByTenantIdErrors];

export type GetApiV1HubspotTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: HubSpotTenantFullV1;
};

export type GetApiV1HubspotTenantsByTenantIdResponse =
  GetApiV1HubspotTenantsByTenantIdResponses[keyof GetApiV1HubspotTenantsByTenantIdResponses];

export type PatchApiV1HubspotTenantsByTenantIdData = {
  body: UpdateHubSpotTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}";
};

export type PatchApiV1HubspotTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1HubspotTenantsByTenantIdError =
  PatchApiV1HubspotTenantsByTenantIdErrors[keyof PatchApiV1HubspotTenantsByTenantIdErrors];

export type PatchApiV1HubspotTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: HubSpotTenantV1;
};

export type PatchApiV1HubspotTenantsByTenantIdResponse =
  PatchApiV1HubspotTenantsByTenantIdResponses[keyof PatchApiV1HubspotTenantsByTenantIdResponses];

export type GetApiV1HubspotTenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}/check-connection";
};

export type GetApiV1HubspotTenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdCheckConnectionError =
  GetApiV1HubspotTenantsByTenantIdCheckConnectionErrors[keyof GetApiV1HubspotTenantsByTenantIdCheckConnectionErrors];

export type GetApiV1HubspotTenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: HubSpotCheckConnectionResponseV1;
};

export type GetApiV1HubspotTenantsByTenantIdCheckConnectionResponse =
  GetApiV1HubspotTenantsByTenantIdCheckConnectionResponses[keyof GetApiV1HubspotTenantsByTenantIdCheckConnectionResponses];

export type GetApiV1HubspotTenantsByTenantIdManifestData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/hubspot/tenants/{tenant_id}/manifest";
};

export type GetApiV1HubspotTenantsByTenantIdManifestErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1HubspotTenantsByTenantIdManifestError =
  GetApiV1HubspotTenantsByTenantIdManifestErrors[keyof GetApiV1HubspotTenantsByTenantIdManifestErrors];

export type GetApiV1HubspotTenantsByTenantIdManifestResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiV2FullInferenceConversationInferencesData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Conversation External Id
     */
    conversation_external_id?: string | null;
    /**
     * Workflow Id
     */
    workflow_id?: number | null;
    /**
     * Workflow Run Id
     */
    workflow_run_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v2/full-inference-conversation-inferences";
};

export type GetApiV2FullInferenceConversationInferencesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2FullInferenceConversationInferencesError =
  GetApiV2FullInferenceConversationInferencesErrors[keyof GetApiV2FullInferenceConversationInferencesErrors];

export type GetApiV2FullInferenceConversationInferencesResponses = {
  /**
   * Successful Response
   */
  200: PageV1InferenceConversationInferenceFullV1;
};

export type GetApiV2FullInferenceConversationInferencesResponse =
  GetApiV2FullInferenceConversationInferencesResponses[keyof GetApiV2FullInferenceConversationInferencesResponses];

export type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdData =
  {
    body?: never;
    path: {
      /**
       * Inference Conversation Inference Id
       */
      inference_conversation_inference_id: number;
    };
    query?: never;
    url: "/api/v2/inference-conversation-inferences/{inference_conversation_inference_id}";
  };

export type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdError =
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdErrors[keyof GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdErrors];

export type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponses =
  {
    /**
     * Successful Response
     */
    200: InferenceConversationInferenceFullV1;
  };

export type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponse =
  GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponses[keyof GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponses];

export type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdData =
  {
    body: UpdateInferenceConversationInferenceParamsV1;
    path: {
      /**
       * Inference Conversation Inference Id
       */
      inference_conversation_inference_id: number;
    };
    query?: never;
    url: "/api/v1/inference-conversation-inferences/{inference_conversation_inference_id}";
  };

export type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdError =
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdErrors[keyof PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdErrors];

export type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponses =
  {
    /**
     * Successful Response
     */
    200: InferenceConversationInferenceV1;
  };

export type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponse =
  PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponses[keyof PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponses];

export type DeleteApiV2InferenceConversationsByExternalIdData = {
  body?: never;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query: {
    /**
     * Task Id
     */
    task_id: number;
  };
  url: "/api/v2/inference-conversations/{external_id}";
};

export type DeleteApiV2InferenceConversationsByExternalIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV2InferenceConversationsByExternalIdError =
  DeleteApiV2InferenceConversationsByExternalIdErrors[keyof DeleteApiV2InferenceConversationsByExternalIdErrors];

export type DeleteApiV2InferenceConversationsByExternalIdResponses = {
  /**
   * Successful Response
   */
  200: InferenceConversationV1;
};

export type DeleteApiV2InferenceConversationsByExternalIdResponse =
  DeleteApiV2InferenceConversationsByExternalIdResponses[keyof DeleteApiV2InferenceConversationsByExternalIdResponses];

export type GetApiV2InferenceConversationsByExternalIdData = {
  body?: never;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query: {
    /**
     * Task Id
     */
    task_id: number;
  };
  url: "/api/v2/inference-conversations/{external_id}";
};

export type GetApiV2InferenceConversationsByExternalIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2InferenceConversationsByExternalIdError =
  GetApiV2InferenceConversationsByExternalIdErrors[keyof GetApiV2InferenceConversationsByExternalIdErrors];

export type GetApiV2InferenceConversationsByExternalIdResponses = {
  /**
   * Successful Response
   */
  200: InferenceConversationFullV1;
};

export type GetApiV2InferenceConversationsByExternalIdResponse =
  GetApiV2InferenceConversationsByExternalIdResponses[keyof GetApiV2InferenceConversationsByExternalIdResponses];

export type PutApiV2InferenceConversationsByExternalIdData = {
  body: UpsertInferenceConversationPayloadV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v2/inference-conversations/{external_id}";
};

export type PutApiV2InferenceConversationsByExternalIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiV2InferenceConversationsByExternalIdError =
  PutApiV2InferenceConversationsByExternalIdErrors[keyof PutApiV2InferenceConversationsByExternalIdErrors];

export type PutApiV2InferenceConversationsByExternalIdResponses = {
  /**
   * Successful Response
   */
  200: InferenceConversationV1;
};

export type PutApiV2InferenceConversationsByExternalIdResponse =
  PutApiV2InferenceConversationsByExternalIdResponses[keyof PutApiV2InferenceConversationsByExternalIdResponses];

export type PostApiV2InferenceConversationsByExternalIdMessagesData = {
  body: AppendInferenceConversationMessagesPayloadV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v2/inference-conversations/{external_id}/messages";
};

export type PostApiV2InferenceConversationsByExternalIdMessagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2InferenceConversationsByExternalIdMessagesError =
  PostApiV2InferenceConversationsByExternalIdMessagesErrors[keyof PostApiV2InferenceConversationsByExternalIdMessagesErrors];

export type PostApiV2InferenceConversationsByExternalIdMessagesResponses = {
  /**
   * Successful Response
   */
  200: InferenceConversationV1;
};

export type PostApiV2InferenceConversationsByExternalIdMessagesResponse =
  PostApiV2InferenceConversationsByExternalIdMessagesResponses[keyof PostApiV2InferenceConversationsByExternalIdMessagesResponses];

export type PostApiV2InferenceConversationsByExternalIdStatelessInferenceData =
  {
    body: CreateStatelessInferenceConversationInferencePayloadV1;
    path: {
      /**
       * External Id
       */
      external_id: string;
    };
    query?: never;
    url: "/api/v2/inference-conversations/{external_id}/stateless-inference";
  };

export type PostApiV2InferenceConversationsByExternalIdStatelessInferenceErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV2InferenceConversationsByExternalIdStatelessInferenceError =
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceErrors[keyof PostApiV2InferenceConversationsByExternalIdStatelessInferenceErrors];

export type PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponses =
  {
    /**
     * Successful Response
     */
    200: ConversationInferenceResponseV2;
  };

export type PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponse =
  PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponses[keyof PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponses];

export type PostApiV2InferenceConversationsByExternalIdStatefulInferenceData = {
  body: CreateStatefulInferenceConversationInferencePayloadV1;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v2/inference-conversations/{external_id}/stateful-inference";
};

export type PostApiV2InferenceConversationsByExternalIdStatefulInferenceErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV2InferenceConversationsByExternalIdStatefulInferenceError =
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceErrors[keyof PostApiV2InferenceConversationsByExternalIdStatefulInferenceErrors];

export type PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponses =
  {
    /**
     * Successful Response
     */
    200: ConversationInferenceResponseV2;
  };

export type PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponse =
  PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponses[keyof PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponses];

export type PostApiV1InferenceConversationsByExternalIdRestoreData = {
  body?: never;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query: {
    /**
     * Task Id
     */
    task_id: number;
  };
  url: "/api/v1/inference-conversations/{external_id}/restore";
};

export type PostApiV1InferenceConversationsByExternalIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1InferenceConversationsByExternalIdRestoreError =
  PostApiV1InferenceConversationsByExternalIdRestoreErrors[keyof PostApiV1InferenceConversationsByExternalIdRestoreErrors];

export type PostApiV1InferenceConversationsByExternalIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: InferenceConversationV1;
};

export type PostApiV1InferenceConversationsByExternalIdRestoreResponse =
  PostApiV1InferenceConversationsByExternalIdRestoreResponses[keyof PostApiV1InferenceConversationsByExternalIdRestoreResponses];

export type GetApiV2FullInferenceConversationsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Tags All
     */
    tags_all?: Array<string> | null;
    /**
     * Tags Any
     */
    tags_any?: Array<string> | null;
    /**
     * Tag Keys All
     */
    tag_keys_all?: Array<string> | null;
    /**
     * Tag Keys Any
     */
    tag_keys_any?: Array<string> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v2/full-inference-conversations";
};

export type GetApiV2FullInferenceConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2FullInferenceConversationsError =
  GetApiV2FullInferenceConversationsErrors[keyof GetApiV2FullInferenceConversationsErrors];

export type GetApiV2FullInferenceConversationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1InferenceConversationFullV1;
};

export type GetApiV2FullInferenceConversationsResponse =
  GetApiV2FullInferenceConversationsResponses[keyof GetApiV2FullInferenceConversationsResponses];

export type GetApiV2InferenceConversationsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * External Id
     */
    external_id?: string | null;
    /**
     * Tags All
     */
    tags_all?: Array<string> | null;
    /**
     * Tags Any
     */
    tags_any?: Array<string> | null;
    /**
     * Tag Keys All
     */
    tag_keys_all?: Array<string> | null;
    /**
     * Tag Keys Any
     */
    tag_keys_any?: Array<string> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v2/inference-conversations";
};

export type GetApiV2InferenceConversationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2InferenceConversationsError =
  GetApiV2InferenceConversationsErrors[keyof GetApiV2InferenceConversationsErrors];

export type GetApiV2InferenceConversationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1InferenceConversationV1;
};

export type GetApiV2InferenceConversationsResponse =
  GetApiV2InferenceConversationsResponses[keyof GetApiV2InferenceConversationsResponses];

export type GetApiV1FullInferenceDatapointsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Inference Id
     */
    inference_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/full-inference-datapoints";
};

export type GetApiV1FullInferenceDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullInferenceDatapointsError =
  GetApiV1FullInferenceDatapointsErrors[keyof GetApiV1FullInferenceDatapointsErrors];

export type GetApiV1FullInferenceDatapointsResponses = {
  /**
   * Successful Response
   */
  200: PageV2InferenceDatapointFullV1;
};

export type GetApiV1FullInferenceDatapointsResponse =
  GetApiV1FullInferenceDatapointsResponses[keyof GetApiV1FullInferenceDatapointsResponses];

export type GetApiV1FullInferenceDatapointsByInferenceDatapointIdData = {
  body?: never;
  path: {
    /**
     * Inference Datapoint Id
     */
    inference_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/full-inference-datapoints/{inference_datapoint_id}";
};

export type GetApiV1FullInferenceDatapointsByInferenceDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullInferenceDatapointsByInferenceDatapointIdError =
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdErrors[keyof GetApiV1FullInferenceDatapointsByInferenceDatapointIdErrors];

export type GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: InferenceDatapointFullV1;
};

export type GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponse =
  GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponses[keyof GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponses];

export type PostApiV1FullEvaluatedInferenceDatapointsSearchData = {
  body: SearchFullEvaluatedInferenceDatapointsParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/full-evaluated-inference-datapoints/search";
};

export type PostApiV1FullEvaluatedInferenceDatapointsSearchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1FullEvaluatedInferenceDatapointsSearchError =
  PostApiV1FullEvaluatedInferenceDatapointsSearchErrors[keyof PostApiV1FullEvaluatedInferenceDatapointsSearchErrors];

export type PostApiV1FullEvaluatedInferenceDatapointsSearchResponses = {
  /**
   * Successful Response
   */
  200: PageV2FullEvaluatedInferenceDatapointV1;
};

export type PostApiV1FullEvaluatedInferenceDatapointsSearchResponse =
  PostApiV1FullEvaluatedInferenceDatapointsSearchResponses[keyof PostApiV1FullEvaluatedInferenceDatapointsSearchResponses];

export type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsData =
  {
    body: JudgementFilterOptionsParamsV1;
    path?: never;
    query?: never;
    url: "/api/v1/full-evaluated-inference-datapoints/judgement-filter-options";
  };

export type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsError =
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsErrors[keyof PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsErrors];

export type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponses =
  {
    /**
     * Successful Response
     */
    200: JudgementFilterOptionsResultV1;
  };

export type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponse =
  PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponses[keyof PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponses];

export type GetApiV1EvaluatedInferenceDatapointsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Section Id
     */
    section_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/evaluated-inference-datapoints";
};

export type GetApiV1EvaluatedInferenceDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1EvaluatedInferenceDatapointsError =
  GetApiV1EvaluatedInferenceDatapointsErrors[keyof GetApiV1EvaluatedInferenceDatapointsErrors];

export type GetApiV1EvaluatedInferenceDatapointsResponses = {
  /**
   * Successful Response
   */
  200: PageV2EvaluatedInferenceDatapointV1;
};

export type GetApiV1EvaluatedInferenceDatapointsResponse =
  GetApiV1EvaluatedInferenceDatapointsResponses[keyof GetApiV1EvaluatedInferenceDatapointsResponses];

export type PostApiV2InferenceDatapointsData = {
  body: CreateInferenceDatapointParamsV2;
  path?: never;
  query?: never;
  url: "/api/v2/inference-datapoints";
};

export type PostApiV2InferenceDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2InferenceDatapointsError =
  PostApiV2InferenceDatapointsErrors[keyof PostApiV2InferenceDatapointsErrors];

export type PostApiV2InferenceDatapointsResponses = {
  /**
   * Successful Response
   */
  200: InferenceDatapointV1;
};

export type PostApiV2InferenceDatapointsResponse =
  PostApiV2InferenceDatapointsResponses[keyof PostApiV2InferenceDatapointsResponses];

export type DeleteApiV1InferenceDatapointsByInferenceDatapointIdData = {
  body?: never;
  path: {
    /**
     * Inference Datapoint Id
     */
    inference_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/inference-datapoints/{inference_datapoint_id}";
};

export type DeleteApiV1InferenceDatapointsByInferenceDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1InferenceDatapointsByInferenceDatapointIdError =
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdErrors[keyof DeleteApiV1InferenceDatapointsByInferenceDatapointIdErrors];

export type DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: InferenceDatapointV1;
};

export type DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponse =
  DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponses[keyof DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponses];

export type PatchApiV1InferenceDatapointsByInferenceDatapointIdData = {
  body: UpdateInferenceDatapointParamsV1;
  path: {
    /**
     * Inference Datapoint Id
     */
    inference_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/inference-datapoints/{inference_datapoint_id}";
};

export type PatchApiV1InferenceDatapointsByInferenceDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1InferenceDatapointsByInferenceDatapointIdError =
  PatchApiV1InferenceDatapointsByInferenceDatapointIdErrors[keyof PatchApiV1InferenceDatapointsByInferenceDatapointIdErrors];

export type PatchApiV1InferenceDatapointsByInferenceDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: InferenceDatapointV1;
};

export type PatchApiV1InferenceDatapointsByInferenceDatapointIdResponse =
  PatchApiV1InferenceDatapointsByInferenceDatapointIdResponses[keyof PatchApiV1InferenceDatapointsByInferenceDatapointIdResponses];

export type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreData = {
  body?: never;
  path: {
    /**
     * Inference Datapoint Id
     */
    inference_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/inference-datapoints/{inference_datapoint_id}/restore";
};

export type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreError =
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreErrors[keyof PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreErrors];

export type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: InferenceDatapointV1;
  };

export type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponse =
  PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponses[keyof PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponses];

export type GetApiV1InferenceFeedbackData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Conversation External Id
     */
    conversation_external_id?: string | null;
    /**
     * Offset
     */
    offset?: number;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/v1/inference-feedback";
};

export type GetApiV1InferenceFeedbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1InferenceFeedbackError =
  GetApiV1InferenceFeedbackErrors[keyof GetApiV1InferenceFeedbackErrors];

export type GetApiV1InferenceFeedbackResponses = {
  /**
   * Successful Response
   */
  200: PageV2InferenceFeedbackFullV1;
};

export type GetApiV1InferenceFeedbackResponse =
  GetApiV1InferenceFeedbackResponses[keyof GetApiV1InferenceFeedbackResponses];

export type GetApiV1TasksByTaskIdFeedbackLabelsData = {
  body?: never;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: never;
  url: "/api/v1/tasks/{task_id}/feedback-labels";
};

export type GetApiV1TasksByTaskIdFeedbackLabelsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1TasksByTaskIdFeedbackLabelsError =
  GetApiV1TasksByTaskIdFeedbackLabelsErrors[keyof GetApiV1TasksByTaskIdFeedbackLabelsErrors];

export type GetApiV1TasksByTaskIdFeedbackLabelsResponses = {
  /**
   * Response Get Feedback Labels V1  Api V1 Tasks  Task Id  Feedback Labels Get
   *
   * Successful Response
   */
  200: Array<InferenceFeedbackLabelV1>;
};

export type GetApiV1TasksByTaskIdFeedbackLabelsResponse =
  GetApiV1TasksByTaskIdFeedbackLabelsResponses[keyof GetApiV1TasksByTaskIdFeedbackLabelsResponses];

export type PostApiV1TasksByTaskIdFeedbackLabelsData = {
  body: CreateFeedbackLabelParamsV1;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: never;
  url: "/api/v1/tasks/{task_id}/feedback-labels";
};

export type PostApiV1TasksByTaskIdFeedbackLabelsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1TasksByTaskIdFeedbackLabelsError =
  PostApiV1TasksByTaskIdFeedbackLabelsErrors[keyof PostApiV1TasksByTaskIdFeedbackLabelsErrors];

export type PostApiV1TasksByTaskIdFeedbackLabelsResponses = {
  /**
   * Successful Response
   */
  200: InferenceFeedbackLabelV1;
};

export type PostApiV1TasksByTaskIdFeedbackLabelsResponse =
  PostApiV1TasksByTaskIdFeedbackLabelsResponses[keyof PostApiV1TasksByTaskIdFeedbackLabelsResponses];

export type PostApiV1TasksByTaskIdInferencesFeedbackLabelsData = {
  body: CreateInferenceFeedbackLabelParamsV1;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: never;
  url: "/api/v1/tasks/{task_id}/inferences/feedback-labels";
};

export type PostApiV1TasksByTaskIdInferencesFeedbackLabelsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1TasksByTaskIdInferencesFeedbackLabelsError =
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsErrors[keyof PostApiV1TasksByTaskIdInferencesFeedbackLabelsErrors];

export type PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponses = {
  /**
   * Successful Response
   */
  200: InferenceFeedbackLabelV1;
};

export type PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponse =
  PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponses[keyof PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponses];

export type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackData = {
  body: CreateInferenceFeedbackParamsV1;
  path: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Inference Id
     */
    inference_id: number;
  };
  query?: never;
  url: "/api/v1/tasks/{task_id}/inferences/{inference_id}/feedback";
};

export type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackError =
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackErrors[keyof PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackErrors];

export type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponses = {
  /**
   * Successful Response
   */
  200: InferenceFeedbackV1;
};

export type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponse =
  PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponses[keyof PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponses];

export type PostApiV1IngestionKnowledgeBasesIngestionFilesData = {
  body: CreateKbIngestionFilesParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/ingestion/knowledge-bases/ingestion-files";
};

export type PostApiV1IngestionKnowledgeBasesIngestionFilesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1IngestionKnowledgeBasesIngestionFilesError =
  PostApiV1IngestionKnowledgeBasesIngestionFilesErrors[keyof PostApiV1IngestionKnowledgeBasesIngestionFilesErrors];

export type PostApiV1IngestionKnowledgeBasesIngestionFilesResponses = {
  /**
   * Response Create Kb Ingestion Files V1  Api V1 Ingestion Knowledge Bases Ingestion Files Post
   *
   * Successful Response
   */
  200: Array<IngestionFileV1>;
};

export type PostApiV1IngestionKnowledgeBasesIngestionFilesResponse =
  PostApiV1IngestionKnowledgeBasesIngestionFilesResponses[keyof PostApiV1IngestionKnowledgeBasesIngestionFilesResponses];

export type PostApiV1IngestionSupportIngestionFilesData = {
  body: CreateSupportIngestionFilesParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/ingestion/support/ingestion-files";
};

export type PostApiV1IngestionSupportIngestionFilesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1IngestionSupportIngestionFilesError =
  PostApiV1IngestionSupportIngestionFilesErrors[keyof PostApiV1IngestionSupportIngestionFilesErrors];

export type PostApiV1IngestionSupportIngestionFilesResponses = {
  /**
   * Response Create Support Ingestion Files V1  Api V1 Ingestion Support Ingestion Files Post
   *
   * Successful Response
   */
  200: Array<IngestionFileV1>;
};

export type PostApiV1IngestionSupportIngestionFilesResponse =
  PostApiV1IngestionSupportIngestionFilesResponses[keyof PostApiV1IngestionSupportIngestionFilesResponses];

export type PostApiJiraV2TenantsByTenantIdActionsPostCommentData = {
  body: JiraPostCommentRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/jira/v2/tenants/{tenant_id}/actions/post-comment";
};

export type PostApiJiraV2TenantsByTenantIdActionsPostCommentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiJiraV2TenantsByTenantIdActionsPostCommentError =
  PostApiJiraV2TenantsByTenantIdActionsPostCommentErrors[keyof PostApiJiraV2TenantsByTenantIdActionsPostCommentErrors];

export type PostApiJiraV2TenantsByTenantIdActionsPostCommentResponses = {
  /**
   * Successful Response
   */
  200: JiraPostCommentResponseV2;
};

export type PostApiJiraV2TenantsByTenantIdActionsPostCommentResponse =
  PostApiJiraV2TenantsByTenantIdActionsPostCommentResponses[keyof PostApiJiraV2TenantsByTenantIdActionsPostCommentResponses];

export type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * Attachment Id
     */
    attachment_id: string;
    /**
     * Chunk Index
     */
    chunk_index?: number | null;
    /**
     * Chunk Size
     */
    chunk_size?: number | null;
  };
  url: "/api/jira/v2/tenants/{tenant_id}/actions/attachment-content";
};

export type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentError =
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentErrors[keyof GetApiJiraV2TenantsByTenantIdActionsAttachmentContentErrors];

export type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponses = {
  /**
   * Successful Response
   */
  200: JiraGetAttachmentContentResponseV2;
};

export type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponse =
  GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponses[keyof GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponses];

export type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsData = {
  body: JiraUpdateIssueLabelsRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/jira/v1/tenants/{tenant_id}/actions/update-issue-labels";
};

export type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsError =
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsErrors[keyof PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsErrors];

export type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponses = {
  /**
   * Successful Response
   */
  200: JiraUpdateIssueLabelsResponseV1;
};

export type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponse =
  PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponses[keyof PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponses];

export type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldData = {
  body: JiraSetCustomFieldRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/jira/v1/tenants/{tenant_id}/actions/set-custom-field";
};

export type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldError =
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldErrors[keyof PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldErrors];

export type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponses = {
  /**
   * Successful Response
   */
  200: JiraSetCustomFieldResponseV1;
};

export type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponse =
  PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponses[keyof PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponses];

export type GetApiJiraV1TenantsByTenantIdActionsGetIssueData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * Issue Key
     */
    issue_key: string;
  };
  url: "/api/jira/v1/tenants/{tenant_id}/actions/get-issue";
};

export type GetApiJiraV1TenantsByTenantIdActionsGetIssueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiJiraV1TenantsByTenantIdActionsGetIssueError =
  GetApiJiraV1TenantsByTenantIdActionsGetIssueErrors[keyof GetApiJiraV1TenantsByTenantIdActionsGetIssueErrors];

export type GetApiJiraV1TenantsByTenantIdActionsGetIssueResponses = {
  /**
   * Successful Response
   */
  200: JiraIssueV1;
};

export type GetApiJiraV1TenantsByTenantIdActionsGetIssueResponse =
  GetApiJiraV1TenantsByTenantIdActionsGetIssueResponses[keyof GetApiJiraV1TenantsByTenantIdActionsGetIssueResponses];

export type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * Issue Key
     */
    issue_key: string;
    /**
     * Field Id
     */
    field_id: string;
  };
  url: "/api/jira/v1/tenants/{tenant_id}/actions/get-custom-field-options";
};

export type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsError =
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsErrors[keyof GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsErrors];

export type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponses =
  {
    /**
     * Successful Response
     */
    200: JiraGetCustomFieldOptionsResponseV1;
  };

export type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponse =
  GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponses[keyof GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponses];

export type GetApiJiraV1TenantsByTenantIdActionsGetIssuesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Project Key
     */
    project_key?: string | null;
    /**
     * Status
     */
    status?: string | null;
    /**
     * Assignee
     */
    assignee?: string | null;
    /**
     * Issue Type
     */
    issue_type?: string | null;
    /**
     * Labels
     */
    labels?: Array<string> | null;
    /**
     * Max Results
     */
    max_results?: number | null;
    /**
     * Next Page Token
     */
    next_page_token?: string | null;
  };
  url: "/api/jira/v1/tenants/{tenant_id}/actions/get-issues";
};

export type GetApiJiraV1TenantsByTenantIdActionsGetIssuesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiJiraV1TenantsByTenantIdActionsGetIssuesError =
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesErrors[keyof GetApiJiraV1TenantsByTenantIdActionsGetIssuesErrors];

export type GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponses = {
  /**
   * Successful Response
   */
  200: JiraGetIssuesResponseV1;
};

export type GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponse =
  GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponses[keyof GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponses];

export type GetApiJiraV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/jira/v1/tenants";
};

export type GetApiJiraV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiJiraV1TenantsError =
  GetApiJiraV1TenantsErrors[keyof GetApiJiraV1TenantsErrors];

export type GetApiJiraV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1JiraTenantV1;
};

export type GetApiJiraV1TenantsResponse =
  GetApiJiraV1TenantsResponses[keyof GetApiJiraV1TenantsResponses];

export type PostApiJiraV1TenantsData = {
  body: CreateJiraTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/jira/v1/tenants";
};

export type PostApiJiraV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiJiraV1TenantsError =
  PostApiJiraV1TenantsErrors[keyof PostApiJiraV1TenantsErrors];

export type PostApiJiraV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: JiraTenantV1;
};

export type PostApiJiraV1TenantsResponse =
  PostApiJiraV1TenantsResponses[keyof PostApiJiraV1TenantsResponses];

export type GetApiJiraV1FullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/jira/v1/full-tenants";
};

export type GetApiJiraV1FullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiJiraV1FullTenantsError =
  GetApiJiraV1FullTenantsErrors[keyof GetApiJiraV1FullTenantsErrors];

export type GetApiJiraV1FullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1JiraTenantFullV1;
};

export type GetApiJiraV1FullTenantsResponse =
  GetApiJiraV1FullTenantsResponses[keyof GetApiJiraV1FullTenantsResponses];

export type DeleteApiJiraV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/jira/v1/tenants/{tenant_id}";
};

export type DeleteApiJiraV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiJiraV1TenantsByTenantIdError =
  DeleteApiJiraV1TenantsByTenantIdErrors[keyof DeleteApiJiraV1TenantsByTenantIdErrors];

export type DeleteApiJiraV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: JiraTenantV1;
};

export type DeleteApiJiraV1TenantsByTenantIdResponse =
  DeleteApiJiraV1TenantsByTenantIdResponses[keyof DeleteApiJiraV1TenantsByTenantIdResponses];

export type GetApiJiraV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/jira/v1/tenants/{tenant_id}";
};

export type GetApiJiraV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiJiraV1TenantsByTenantIdError =
  GetApiJiraV1TenantsByTenantIdErrors[keyof GetApiJiraV1TenantsByTenantIdErrors];

export type GetApiJiraV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: JiraTenantFullV1;
};

export type GetApiJiraV1TenantsByTenantIdResponse =
  GetApiJiraV1TenantsByTenantIdResponses[keyof GetApiJiraV1TenantsByTenantIdResponses];

export type PatchApiJiraV1TenantsByTenantIdData = {
  body: UpdateJiraTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/jira/v1/tenants/{tenant_id}";
};

export type PatchApiJiraV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiJiraV1TenantsByTenantIdError =
  PatchApiJiraV1TenantsByTenantIdErrors[keyof PatchApiJiraV1TenantsByTenantIdErrors];

export type PatchApiJiraV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: JiraTenantV1;
};

export type PatchApiJiraV1TenantsByTenantIdResponse =
  PatchApiJiraV1TenantsByTenantIdResponses[keyof PatchApiJiraV1TenantsByTenantIdResponses];

export type GetApiJiraV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/jira/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiJiraV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiJiraV1TenantsByTenantIdCheckConnectionError =
  GetApiJiraV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiJiraV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiJiraV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: JiraCheckConnectionResponseV1;
};

export type GetApiJiraV1TenantsByTenantIdCheckConnectionResponse =
  GetApiJiraV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiJiraV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiV2JudgementsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Judge Id
     */
    judge_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v2/judgements";
};

export type GetApiV2JudgementsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2JudgementsError =
  GetApiV2JudgementsErrors[keyof GetApiV2JudgementsErrors];

export type GetApiV2JudgementsResponses = {
  /**
   * Successful Response
   */
  200: PageV1JudgementFullV2;
};

export type GetApiV2JudgementsResponse =
  GetApiV2JudgementsResponses[keyof GetApiV2JudgementsResponses];

export type PostApiV2JudgementsData = {
  body: CreateJudgementsParamsV2;
  path?: never;
  query?: never;
  url: "/api/v2/judgements";
};

export type PostApiV2JudgementsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2JudgementsError =
  PostApiV2JudgementsErrors[keyof PostApiV2JudgementsErrors];

export type PostApiV2JudgementsResponses = {
  /**
   * Response Create Judgements V2  Api V2 Judgements Post
   *
   * Successful Response
   */
  200: Array<JudgementV2>;
};

export type PostApiV2JudgementsResponse =
  PostApiV2JudgementsResponses[keyof PostApiV2JudgementsResponses];

export type DeleteApiV2JudgementsByJudgementIdData = {
  body?: never;
  path: {
    /**
     * Judgement Id
     */
    judgement_id: number;
  };
  query?: never;
  url: "/api/v2/judgements/{judgement_id}";
};

export type DeleteApiV2JudgementsByJudgementIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV2JudgementsByJudgementIdError =
  DeleteApiV2JudgementsByJudgementIdErrors[keyof DeleteApiV2JudgementsByJudgementIdErrors];

export type DeleteApiV2JudgementsByJudgementIdResponses = {
  /**
   * Successful Response
   */
  200: JudgementV2;
};

export type DeleteApiV2JudgementsByJudgementIdResponse =
  DeleteApiV2JudgementsByJudgementIdResponses[keyof DeleteApiV2JudgementsByJudgementIdResponses];

export type PostApiV3JudgementsData = {
  body: CreateJudgementsParamsV3;
  path?: never;
  query?: never;
  url: "/api/v3/judgements";
};

export type PostApiV3JudgementsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV3JudgementsError =
  PostApiV3JudgementsErrors[keyof PostApiV3JudgementsErrors];

export type PostApiV3JudgementsResponses = {
  /**
   * Successful Response
   */
  200: CreateJudgementsResultV3;
};

export type PostApiV3JudgementsResponse =
  PostApiV3JudgementsResponses[keyof PostApiV3JudgementsResponses];

export type GetApiV3FullJudgementsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Judge Id
     */
    judge_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v3/full-judgements";
};

export type GetApiV3FullJudgementsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV3FullJudgementsError =
  GetApiV3FullJudgementsErrors[keyof GetApiV3FullJudgementsErrors];

export type GetApiV3FullJudgementsResponses = {
  /**
   * Successful Response
   */
  200: PageV1JudgementFullV3;
};

export type GetApiV3FullJudgementsResponse =
  GetApiV3FullJudgementsResponses[keyof GetApiV3FullJudgementsResponses];

export type DeleteApiV3JudgementsByJudgementIdData = {
  body?: never;
  path: {
    /**
     * Judgement Id
     */
    judgement_id: number;
  };
  query?: never;
  url: "/api/v3/judgements/{judgement_id}";
};

export type DeleteApiV3JudgementsByJudgementIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV3JudgementsByJudgementIdError =
  DeleteApiV3JudgementsByJudgementIdErrors[keyof DeleteApiV3JudgementsByJudgementIdErrors];

export type DeleteApiV3JudgementsByJudgementIdResponses = {
  /**
   * Successful Response
   */
  200: JudgementV3;
};

export type DeleteApiV3JudgementsByJudgementIdResponse =
  DeleteApiV3JudgementsByJudgementIdResponses[keyof DeleteApiV3JudgementsByJudgementIdResponses];

export type GetApiV2JudgesData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v2/judges";
};

export type GetApiV2JudgesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2JudgesError =
  GetApiV2JudgesErrors[keyof GetApiV2JudgesErrors];

export type GetApiV2JudgesResponses = {
  /**
   * Successful Response
   */
  200: PageV1JudgeV2;
};

export type GetApiV2JudgesResponse =
  GetApiV2JudgesResponses[keyof GetApiV2JudgesResponses];

export type PostApiV2JudgesData = {
  body: CreateJudgeParamsV2;
  path?: never;
  query?: never;
  url: "/api/v2/judges";
};

export type PostApiV2JudgesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2JudgesError =
  PostApiV2JudgesErrors[keyof PostApiV2JudgesErrors];

export type PostApiV2JudgesResponses = {
  /**
   * Successful Response
   */
  200: JudgeV2;
};

export type PostApiV2JudgesResponse =
  PostApiV2JudgesResponses[keyof PostApiV2JudgesResponses];

export type PostApiV2JudgesBulkData = {
  body: CreateJudgesParamsV2;
  path?: never;
  query?: never;
  url: "/api/v2/judges/bulk";
};

export type PostApiV2JudgesBulkErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2JudgesBulkError =
  PostApiV2JudgesBulkErrors[keyof PostApiV2JudgesBulkErrors];

export type PostApiV2JudgesBulkResponses = {
  /**
   * Response Create Judges V2  Api V2 Judges Bulk Post
   *
   * Successful Response
   */
  200: Array<JudgeV2>;
};

export type PostApiV2JudgesBulkResponse =
  PostApiV2JudgesBulkResponses[keyof PostApiV2JudgesBulkResponses];

export type PostApiV1JudgesSyncData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/judges/sync";
};

export type PostApiV1JudgesSyncResponses = {
  /**
   * Successful Response
   */
  200: SyncJudgesResultV1;
};

export type PostApiV1JudgesSyncResponse =
  PostApiV1JudgesSyncResponses[keyof PostApiV1JudgesSyncResponses];

export type DeleteApiV2JudgesByJudgeIdData = {
  body?: never;
  path: {
    /**
     * Judge Id
     */
    judge_id: number;
  };
  query?: never;
  url: "/api/v2/judges/{judge_id}";
};

export type DeleteApiV2JudgesByJudgeIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV2JudgesByJudgeIdError =
  DeleteApiV2JudgesByJudgeIdErrors[keyof DeleteApiV2JudgesByJudgeIdErrors];

export type DeleteApiV2JudgesByJudgeIdResponses = {
  /**
   * Successful Response
   */
  200: JudgeV2;
};

export type DeleteApiV2JudgesByJudgeIdResponse =
  DeleteApiV2JudgesByJudgeIdResponses[keyof DeleteApiV2JudgesByJudgeIdResponses];

export type GetApiV2JudgesByJudgeIdData = {
  body?: never;
  path: {
    /**
     * Judge Id
     */
    judge_id: number;
  };
  query?: never;
  url: "/api/v2/judges/{judge_id}";
};

export type GetApiV2JudgesByJudgeIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2JudgesByJudgeIdError =
  GetApiV2JudgesByJudgeIdErrors[keyof GetApiV2JudgesByJudgeIdErrors];

export type GetApiV2JudgesByJudgeIdResponses = {
  /**
   * Successful Response
   */
  200: JudgeFullV2;
};

export type GetApiV2JudgesByJudgeIdResponse =
  GetApiV2JudgesByJudgeIdResponses[keyof GetApiV2JudgesByJudgeIdResponses];

export type PatchApiV2JudgesByJudgeIdData = {
  body: PatchJudgeParamsV2;
  path: {
    /**
     * Judge Id
     */
    judge_id: number;
  };
  query?: never;
  url: "/api/v2/judges/{judge_id}";
};

export type PatchApiV2JudgesByJudgeIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV2JudgesByJudgeIdError =
  PatchApiV2JudgesByJudgeIdErrors[keyof PatchApiV2JudgesByJudgeIdErrors];

export type PatchApiV2JudgesByJudgeIdResponses = {
  /**
   * Successful Response
   */
  200: JudgeV2;
};

export type PatchApiV2JudgesByJudgeIdResponse =
  PatchApiV2JudgesByJudgeIdResponses[keyof PatchApiV2JudgesByJudgeIdResponses];

export type GetApiV2KanonicalDatapointsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
    /**
     * Commit Ids Any
     */
    commit_ids_any?: Array<number> | null;
  };
  url: "/api/v2/kanonical-datapoints";
};

export type GetApiV2KanonicalDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2KanonicalDatapointsError =
  GetApiV2KanonicalDatapointsErrors[keyof GetApiV2KanonicalDatapointsErrors];

export type GetApiV2KanonicalDatapointsResponses = {
  /**
   * Successful Response
   */
  200: PageV1KanonicalDatapointFullV2;
};

export type GetApiV2KanonicalDatapointsResponse =
  GetApiV2KanonicalDatapointsResponses[keyof GetApiV2KanonicalDatapointsResponses];

export type PostApiV2KanonicalDatapointsData = {
  body: CreateKanonicalDatapointsRequestV2;
  path?: never;
  query?: never;
  url: "/api/v2/kanonical-datapoints";
};

export type PostApiV2KanonicalDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2KanonicalDatapointsError =
  PostApiV2KanonicalDatapointsErrors[keyof PostApiV2KanonicalDatapointsErrors];

export type PostApiV2KanonicalDatapointsResponses = {
  /**
   * Successful Response
   */
  200: CreateKanonicalDatapointsResponseV2;
};

export type PostApiV2KanonicalDatapointsResponse =
  PostApiV2KanonicalDatapointsResponses[keyof PostApiV2KanonicalDatapointsResponses];

export type GetApiV2KanonicalDatapointsByKanonicalDatapointIdData = {
  body?: never;
  path: {
    /**
     * Kanonical Datapoint Id
     */
    kanonical_datapoint_id: number;
  };
  query?: never;
  url: "/api/v2/kanonical-datapoints/{kanonical_datapoint_id}";
};

export type GetApiV2KanonicalDatapointsByKanonicalDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2KanonicalDatapointsByKanonicalDatapointIdError =
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdErrors[keyof GetApiV2KanonicalDatapointsByKanonicalDatapointIdErrors];

export type GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: KanonicalDatapointFullV2;
};

export type GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponse =
  GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponses[keyof GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponses];

export type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdData = {
  body?: never;
  path: {
    /**
     * Kanonical Datapoint Id
     */
    kanonical_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/kanonical-datapoints/{kanonical_datapoint_id}";
};

export type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdError =
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdErrors[keyof DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdErrors];

export type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: KanonicalDatapointV1;
};

export type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponse =
  DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponses[keyof DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponses];

export type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdData = {
  body: UpdateKanonicalDatapointV1;
  path: {
    /**
     * Kanonical Datapoint Id
     */
    kanonical_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/kanonical-datapoints/{kanonical_datapoint_id}";
};

export type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdError =
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdErrors[keyof PatchApiV1KanonicalDatapointsByKanonicalDatapointIdErrors];

export type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: KanonicalDatapointFullV2;
};

export type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponse =
  PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponses[keyof PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponses];

export type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreData = {
  body?: never;
  path: {
    /**
     * Kanonical Datapoint Id
     */
    kanonical_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/kanonical-datapoints/{kanonical_datapoint_id}/restore";
};

export type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreError =
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreErrors[keyof PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreErrors];

export type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: KanonicalDatapointV1;
  };

export type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponse =
  PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponses[keyof PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponses];

export type PostApiV1ImageAttachmentsUploadUrlData = {
  body: ImageUploadUrlRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/image-attachments/upload-url";
};

export type PostApiV1ImageAttachmentsUploadUrlErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ImageAttachmentsUploadUrlError =
  PostApiV1ImageAttachmentsUploadUrlErrors[keyof PostApiV1ImageAttachmentsUploadUrlErrors];

export type PostApiV1ImageAttachmentsUploadUrlResponses = {
  /**
   * Successful Response
   */
  200: ImageUploadUrlResponseV1;
};

export type PostApiV1ImageAttachmentsUploadUrlResponse =
  PostApiV1ImageAttachmentsUploadUrlResponses[keyof PostApiV1ImageAttachmentsUploadUrlResponses];

export type GetApiV1ImageAttachmentsDownloadByFilePathData = {
  body?: never;
  path: {
    /**
     * File Path
     */
    file_path: string;
  };
  query?: never;
  url: "/api/v1/image-attachments/download/{file_path}";
};

export type GetApiV1ImageAttachmentsDownloadByFilePathErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ImageAttachmentsDownloadByFilePathError =
  GetApiV1ImageAttachmentsDownloadByFilePathErrors[keyof GetApiV1ImageAttachmentsDownloadByFilePathErrors];

export type GetApiV1ImageAttachmentsDownloadByFilePathResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData = {
  body?: never;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/authz/organizations/{org_id}/kb-access-requests";
};

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError =
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors[keyof GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors];

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses = {
  /**
   * Successful Response
   */
  200: PageV2KbAccessRequestFullV1;
};

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse =
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses[keyof GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses];

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData = {
  body: CreateKbAccessRequestParamsV1;
  path: {
    /**
     * Org Id
     */
    org_id: number;
  };
  query?: never;
  url: "/api/v1/authz/organizations/{org_id}/kb-access-requests";
};

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError =
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors[keyof PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors];

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses = {
  /**
   * Successful Response
   */
  200: KbAccessRequestV1;
};

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse =
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses[keyof PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses];

export type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineData =
  {
    body?: never;
    path: {
      /**
       * Org Id
       */
      org_id: number;
      /**
       * Kb Id
       */
      kb_id: number;
    };
    query?: {
      /**
       * Article Id
       */
      article_id?: number | null;
    };
    url: "/api/v1/authz/organizations/{org_id}/knowledge-bases/{kb_id}/kb-access-requests/mine";
  };

export type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineError =
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineErrors[keyof GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineErrors];

export type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponses =
  {
    /**
     * Successful Response
     */
    200: GetMyKbAccessRequestResultV1;
  };

export type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponse =
  GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponses[keyof GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponses];

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsData =
  {
    body?: never;
    path: {
      /**
       * Org Id
       */
      org_id: number;
      /**
       * Request Id
       */
      request_id: number;
    };
    query?: never;
    url: "/api/v1/authz/organizations/{org_id}/kb-access-requests/{request_id}/requester-teams";
  };

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsError =
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsErrors[keyof GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsErrors];

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponses =
  {
    /**
     * Successful Response
     */
    200: GetRequesterTeamsResultV1;
  };

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponse =
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponses[keyof GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponses];

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessData =
  {
    body?: never;
    path: {
      /**
       * Org Id
       */
      org_id: number;
      /**
       * Request Id
       */
      request_id: number;
    };
    query?: never;
    url: "/api/v1/authz/organizations/{org_id}/kb-access-requests/{request_id}/teams-with-access";
  };

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessError =
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessErrors[keyof GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessErrors];

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponses =
  {
    /**
     * Successful Response
     */
    200: GetTeamsWithAccessResultV1;
  };

export type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponse =
  GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponses[keyof GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponses];

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveData =
  {
    body: ResolveKbAccessRequestParamsV1;
    path: {
      /**
       * Org Id
       */
      org_id: number;
      /**
       * Request Id
       */
      request_id: number;
    };
    query?: never;
    url: "/api/v1/authz/organizations/{org_id}/kb-access-requests/{request_id}/resolve";
  };

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveError =
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveErrors[keyof PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveErrors];

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponses =
  {
    /**
     * Successful Response
     */
    200: KbAccessRequestV1;
  };

export type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponse =
  PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponses[keyof PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponses];

export type PostApiV1KbAttachmentsUploadUrlData = {
  body: UploadUrlRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/kb-attachments/upload-url";
};

export type PostApiV1KbAttachmentsUploadUrlErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbAttachmentsUploadUrlError =
  PostApiV1KbAttachmentsUploadUrlErrors[keyof PostApiV1KbAttachmentsUploadUrlErrors];

export type PostApiV1KbAttachmentsUploadUrlResponses = {
  /**
   * Successful Response
   */
  200: UploadUrlResponseV1;
};

export type PostApiV1KbAttachmentsUploadUrlResponse =
  PostApiV1KbAttachmentsUploadUrlResponses[keyof PostApiV1KbAttachmentsUploadUrlResponses];

export type GetApiV1KbAttachmentsDownloadByFilePathData = {
  body?: never;
  path: {
    /**
     * File Path
     */
    file_path: string;
  };
  query?: never;
  url: "/api/v1/kb-attachments/download/{file_path}";
};

export type GetApiV1KbAttachmentsDownloadByFilePathErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbAttachmentsDownloadByFilePathError =
  GetApiV1KbAttachmentsDownloadByFilePathErrors[keyof GetApiV1KbAttachmentsDownloadByFilePathErrors];

export type GetApiV1KbAttachmentsDownloadByFilePathResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiV1FullKbSimulationDatapointsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/full-kb-simulation-datapoints";
};

export type GetApiV1FullKbSimulationDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullKbSimulationDatapointsError =
  GetApiV1FullKbSimulationDatapointsErrors[keyof GetApiV1FullKbSimulationDatapointsErrors];

export type GetApiV1FullKbSimulationDatapointsResponses = {
  /**
   * Successful Response
   */
  200: PageV2SimulationDatapointFullV1;
};

export type GetApiV1FullKbSimulationDatapointsResponse =
  GetApiV1FullKbSimulationDatapointsResponses[keyof GetApiV1FullKbSimulationDatapointsResponses];

export type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdData = {
  body?: never;
  path: {
    /**
     * Simulation Datapoint Id
     */
    simulation_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/full-kb-simulation-datapoints/{simulation_datapoint_id}";
};

export type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdError =
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdErrors[keyof GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdErrors];

export type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponses =
  {
    /**
     * Successful Response
     */
    200: SimulationDatapointFullV1;
  };

export type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponse =
  GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponses[keyof GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponses];

export type GetApiV1KbSimulationDatapointsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/kb-simulation-datapoints";
};

export type GetApiV1KbSimulationDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbSimulationDatapointsError =
  GetApiV1KbSimulationDatapointsErrors[keyof GetApiV1KbSimulationDatapointsErrors];

export type GetApiV1KbSimulationDatapointsResponses = {
  /**
   * Successful Response
   */
  200: PageV2SimulationDatapointV1;
};

export type GetApiV1KbSimulationDatapointsResponse =
  GetApiV1KbSimulationDatapointsResponses[keyof GetApiV1KbSimulationDatapointsResponses];

export type PostApiV1KbSimulationDatapointsData = {
  body: CreateSimulationDatapointParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/kb-simulation-datapoints";
};

export type PostApiV1KbSimulationDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbSimulationDatapointsError =
  PostApiV1KbSimulationDatapointsErrors[keyof PostApiV1KbSimulationDatapointsErrors];

export type PostApiV1KbSimulationDatapointsResponses = {
  /**
   * Successful Response
   */
  200: SimulationDatapointV1;
};

export type PostApiV1KbSimulationDatapointsResponse =
  PostApiV1KbSimulationDatapointsResponses[keyof PostApiV1KbSimulationDatapointsResponses];

export type PostApiV1KbSimulationDatapointsBatchData = {
  body: CreateSimulationDatapointsParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/kb-simulation-datapoints/batch";
};

export type PostApiV1KbSimulationDatapointsBatchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbSimulationDatapointsBatchError =
  PostApiV1KbSimulationDatapointsBatchErrors[keyof PostApiV1KbSimulationDatapointsBatchErrors];

export type PostApiV1KbSimulationDatapointsBatchResponses = {
  /**
   * Successful Response
   */
  200: CreateSimulationDatapointsResultV1;
};

export type PostApiV1KbSimulationDatapointsBatchResponse =
  PostApiV1KbSimulationDatapointsBatchResponses[keyof PostApiV1KbSimulationDatapointsBatchResponses];

export type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdData = {
  body?: never;
  path: {
    /**
     * Simulation Datapoint Id
     */
    simulation_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/kb-simulation-datapoints/{simulation_datapoint_id}";
};

export type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdError =
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdErrors[keyof DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdErrors];

export type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponses =
  {
    /**
     * Successful Response
     */
    200: SimulationDatapointV1;
  };

export type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponse =
  DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponses[keyof DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponses];

export type GetApiV1KbSimulationDatapointsBySimulationDatapointIdData = {
  body?: never;
  path: {
    /**
     * Simulation Datapoint Id
     */
    simulation_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/kb-simulation-datapoints/{simulation_datapoint_id}";
};

export type GetApiV1KbSimulationDatapointsBySimulationDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbSimulationDatapointsBySimulationDatapointIdError =
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdErrors[keyof GetApiV1KbSimulationDatapointsBySimulationDatapointIdErrors];

export type GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: SimulationDatapointV1;
};

export type GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponse =
  GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponses[keyof GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponses];

export type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdData = {
  body: UpdateSimulationDatapointParamsV1;
  path: {
    /**
     * Simulation Datapoint Id
     */
    simulation_datapoint_id: number;
  };
  query?: never;
  url: "/api/v1/kb-simulation-datapoints/{simulation_datapoint_id}";
};

export type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdError =
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdErrors[keyof PatchApiV1KbSimulationDatapointsBySimulationDatapointIdErrors];

export type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponses = {
  /**
   * Successful Response
   */
  200: SimulationDatapointV1;
};

export type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponse =
  PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponses[keyof PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponses];

export type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreData =
  {
    body?: never;
    path: {
      /**
       * Simulation Datapoint Id
       */
      simulation_datapoint_id: number;
    };
    query?: never;
    url: "/api/v1/kb-simulation-datapoints/{simulation_datapoint_id}/restore";
  };

export type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreError =
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreErrors[keyof PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreErrors];

export type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: SimulationDatapointV1;
  };

export type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponse =
  PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponses[keyof PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponses];

export type GetApiV1FullKbSimulationResultsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/full-kb-simulation-results";
};

export type GetApiV1FullKbSimulationResultsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullKbSimulationResultsError =
  GetApiV1FullKbSimulationResultsErrors[keyof GetApiV1FullKbSimulationResultsErrors];

export type GetApiV1FullKbSimulationResultsResponses = {
  /**
   * Successful Response
   */
  200: PageV2SimulationResultFullV1;
};

export type GetApiV1FullKbSimulationResultsResponse =
  GetApiV1FullKbSimulationResultsResponses[keyof GetApiV1FullKbSimulationResultsResponses];

export type GetApiV1FullKbSimulationResultsBySimulationResultIdData = {
  body?: never;
  path: {
    /**
     * Simulation Result Id
     */
    simulation_result_id: number;
  };
  query?: never;
  url: "/api/v1/full-kb-simulation-results/{simulation_result_id}";
};

export type GetApiV1FullKbSimulationResultsBySimulationResultIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullKbSimulationResultsBySimulationResultIdError =
  GetApiV1FullKbSimulationResultsBySimulationResultIdErrors[keyof GetApiV1FullKbSimulationResultsBySimulationResultIdErrors];

export type GetApiV1FullKbSimulationResultsBySimulationResultIdResponses = {
  /**
   * Successful Response
   */
  200: SimulationResultFullV1;
};

export type GetApiV1FullKbSimulationResultsBySimulationResultIdResponse =
  GetApiV1FullKbSimulationResultsBySimulationResultIdResponses[keyof GetApiV1FullKbSimulationResultsBySimulationResultIdResponses];

export type GetApiV1KbSimulationResultsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/kb-simulation-results";
};

export type GetApiV1KbSimulationResultsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbSimulationResultsError =
  GetApiV1KbSimulationResultsErrors[keyof GetApiV1KbSimulationResultsErrors];

export type GetApiV1KbSimulationResultsResponses = {
  /**
   * Successful Response
   */
  200: PageV2SimulationResultV1;
};

export type GetApiV1KbSimulationResultsResponse =
  GetApiV1KbSimulationResultsResponses[keyof GetApiV1KbSimulationResultsResponses];

export type PostApiV1KbSimulationResultsData = {
  body: CreateSimulationResultParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/kb-simulation-results";
};

export type PostApiV1KbSimulationResultsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbSimulationResultsError =
  PostApiV1KbSimulationResultsErrors[keyof PostApiV1KbSimulationResultsErrors];

export type PostApiV1KbSimulationResultsResponses = {
  /**
   * Successful Response
   */
  200: SimulationResultV1;
};

export type PostApiV1KbSimulationResultsResponse =
  PostApiV1KbSimulationResultsResponses[keyof PostApiV1KbSimulationResultsResponses];

export type PostApiV1KbSimulationResultsBatchData = {
  body: CreateSimulationResultsParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/kb-simulation-results/batch";
};

export type PostApiV1KbSimulationResultsBatchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbSimulationResultsBatchError =
  PostApiV1KbSimulationResultsBatchErrors[keyof PostApiV1KbSimulationResultsBatchErrors];

export type PostApiV1KbSimulationResultsBatchResponses = {
  /**
   * Successful Response
   */
  200: CreateSimulationResultsResultV1;
};

export type PostApiV1KbSimulationResultsBatchResponse =
  PostApiV1KbSimulationResultsBatchResponses[keyof PostApiV1KbSimulationResultsBatchResponses];

export type PostApiV1KbSimulationResultJudgementsBatchData = {
  body: CreateSimulationResultJudgementsBatchParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/kb-simulation-result-judgements/batch";
};

export type PostApiV1KbSimulationResultJudgementsBatchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbSimulationResultJudgementsBatchError =
  PostApiV1KbSimulationResultJudgementsBatchErrors[keyof PostApiV1KbSimulationResultJudgementsBatchErrors];

export type PostApiV1KbSimulationResultJudgementsBatchResponses = {
  /**
   * Successful Response
   */
  200: CreateSimulationResultJudgementsBatchResultV1;
};

export type PostApiV1KbSimulationResultJudgementsBatchResponse =
  PostApiV1KbSimulationResultJudgementsBatchResponses[keyof PostApiV1KbSimulationResultJudgementsBatchResponses];

export type GetApiV1FullKbSimulationResultJudgementsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Commit Ids
     */
    commit_ids?: Array<number> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/full-kb-simulation-result-judgements";
};

export type GetApiV1FullKbSimulationResultJudgementsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullKbSimulationResultJudgementsError =
  GetApiV1FullKbSimulationResultJudgementsErrors[keyof GetApiV1FullKbSimulationResultJudgementsErrors];

export type GetApiV1FullKbSimulationResultJudgementsResponses = {
  /**
   * Successful Response
   */
  200: PageV2SimulationResultJudgementFullV1;
};

export type GetApiV1FullKbSimulationResultJudgementsResponse =
  GetApiV1FullKbSimulationResultJudgementsResponses[keyof GetApiV1FullKbSimulationResultJudgementsResponses];

export type GetApiV1FullKbSimulationRunData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Commit Id
     */
    commit_id: number;
    /**
     * After
     */
    after?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/v1/full-kb-simulation-run";
};

export type GetApiV1FullKbSimulationRunErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullKbSimulationRunError =
  GetApiV1FullKbSimulationRunErrors[keyof GetApiV1FullKbSimulationRunErrors];

export type GetApiV1FullKbSimulationRunResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1SimulationRunV1;
};

export type GetApiV1FullKbSimulationRunResponse =
  GetApiV1FullKbSimulationRunResponses[keyof GetApiV1FullKbSimulationRunResponses];

export type GetApiV1FullKbSimulationCompareData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Base Commit Id
     */
    base_commit_id: number;
    /**
     * Compare Commit Id
     */
    compare_commit_id: number;
    /**
     * After
     */
    after?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/v1/full-kb-simulation-compare";
};

export type GetApiV1FullKbSimulationCompareErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullKbSimulationCompareError =
  GetApiV1FullKbSimulationCompareErrors[keyof GetApiV1FullKbSimulationCompareErrors];

export type GetApiV1FullKbSimulationCompareResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1SimulationCompareV1;
};

export type GetApiV1FullKbSimulationCompareResponse =
  GetApiV1FullKbSimulationCompareResponses[keyof GetApiV1FullKbSimulationCompareResponses];

export type DeleteApiV1KbSimulationResultsBySimulationResultIdData = {
  body?: never;
  path: {
    /**
     * Simulation Result Id
     */
    simulation_result_id: number;
  };
  query?: never;
  url: "/api/v1/kb-simulation-results/{simulation_result_id}";
};

export type DeleteApiV1KbSimulationResultsBySimulationResultIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1KbSimulationResultsBySimulationResultIdError =
  DeleteApiV1KbSimulationResultsBySimulationResultIdErrors[keyof DeleteApiV1KbSimulationResultsBySimulationResultIdErrors];

export type DeleteApiV1KbSimulationResultsBySimulationResultIdResponses = {
  /**
   * Successful Response
   */
  200: SimulationResultV1;
};

export type DeleteApiV1KbSimulationResultsBySimulationResultIdResponse =
  DeleteApiV1KbSimulationResultsBySimulationResultIdResponses[keyof DeleteApiV1KbSimulationResultsBySimulationResultIdResponses];

export type GetApiV1KbSimulationResultsBySimulationResultIdData = {
  body?: never;
  path: {
    /**
     * Simulation Result Id
     */
    simulation_result_id: number;
  };
  query?: never;
  url: "/api/v1/kb-simulation-results/{simulation_result_id}";
};

export type GetApiV1KbSimulationResultsBySimulationResultIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbSimulationResultsBySimulationResultIdError =
  GetApiV1KbSimulationResultsBySimulationResultIdErrors[keyof GetApiV1KbSimulationResultsBySimulationResultIdErrors];

export type GetApiV1KbSimulationResultsBySimulationResultIdResponses = {
  /**
   * Successful Response
   */
  200: SimulationResultV1;
};

export type GetApiV1KbSimulationResultsBySimulationResultIdResponse =
  GetApiV1KbSimulationResultsBySimulationResultIdResponses[keyof GetApiV1KbSimulationResultsBySimulationResultIdResponses];

export type PatchApiV1KbSimulationResultsBySimulationResultIdData = {
  body: UpdateSimulationResultParamsV1;
  path: {
    /**
     * Simulation Result Id
     */
    simulation_result_id: number;
  };
  query?: never;
  url: "/api/v1/kb-simulation-results/{simulation_result_id}";
};

export type PatchApiV1KbSimulationResultsBySimulationResultIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1KbSimulationResultsBySimulationResultIdError =
  PatchApiV1KbSimulationResultsBySimulationResultIdErrors[keyof PatchApiV1KbSimulationResultsBySimulationResultIdErrors];

export type PatchApiV1KbSimulationResultsBySimulationResultIdResponses = {
  /**
   * Successful Response
   */
  200: SimulationResultV1;
};

export type PatchApiV1KbSimulationResultsBySimulationResultIdResponse =
  PatchApiV1KbSimulationResultsBySimulationResultIdResponses[keyof PatchApiV1KbSimulationResultsBySimulationResultIdResponses];

export type PostApiV1KbSimulationResultsBySimulationResultIdRestoreData = {
  body?: never;
  path: {
    /**
     * Simulation Result Id
     */
    simulation_result_id: number;
  };
  query?: never;
  url: "/api/v1/kb-simulation-results/{simulation_result_id}/restore";
};

export type PostApiV1KbSimulationResultsBySimulationResultIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbSimulationResultsBySimulationResultIdRestoreError =
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreErrors[keyof PostApiV1KbSimulationResultsBySimulationResultIdRestoreErrors];

export type PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: SimulationResultV1;
};

export type PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponse =
  PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponses[keyof PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponses];

export type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsData = {
  body: CreateSimulationResultJudgementsParamsV1;
  path: {
    /**
     * Simulation Result Id
     */
    simulation_result_id: number;
  };
  query?: never;
  url: "/api/v1/kb-simulation-results/{simulation_result_id}/judgements";
};

export type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsError =
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsErrors[keyof PostApiV1KbSimulationResultsBySimulationResultIdJudgementsErrors];

export type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponses =
  {
    /**
     * Successful Response
     */
    200: CreateSimulationResultJudgementsResultV1;
  };

export type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponse =
  PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponses[keyof PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponses];

export type GetApiV1KbSimulationBranchBreakdownStatsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Repository Id
     */
    repository_id: number;
    branch: NonEmptyStr;
  };
  url: "/api/v1/kb-simulation-branch-breakdown-stats";
};

export type GetApiV1KbSimulationBranchBreakdownStatsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbSimulationBranchBreakdownStatsError =
  GetApiV1KbSimulationBranchBreakdownStatsErrors[keyof GetApiV1KbSimulationBranchBreakdownStatsErrors];

export type GetApiV1KbSimulationBranchBreakdownStatsResponses = {
  /**
   * Successful Response
   */
  200: SimulationBranchBreakdownStatsV1;
};

export type GetApiV1KbSimulationBranchBreakdownStatsResponse =
  GetApiV1KbSimulationBranchBreakdownStatsResponses[keyof GetApiV1KbSimulationBranchBreakdownStatsResponses];

export type GetApiV1KbSimulationCompareSummaryData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Base Commit Id
     */
    base_commit_id: number;
    /**
     * Compare Commit Id
     */
    compare_commit_id: number;
  };
  url: "/api/v1/kb-simulation-compare-summary";
};

export type GetApiV1KbSimulationCompareSummaryErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbSimulationCompareSummaryError =
  GetApiV1KbSimulationCompareSummaryErrors[keyof GetApiV1KbSimulationCompareSummaryErrors];

export type GetApiV1KbSimulationCompareSummaryResponses = {
  /**
   * Successful Response
   */
  200: SimulationCompareSummaryV1;
};

export type GetApiV1KbSimulationCompareSummaryResponse =
  GetApiV1KbSimulationCompareSummaryResponses[keyof GetApiV1KbSimulationCompareSummaryResponses];

export type GetApiV1KbSimulationCommitsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Repository Id
     */
    repository_id: number;
  };
  url: "/api/v1/kb-simulation-commits";
};

export type GetApiV1KbSimulationCommitsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbSimulationCommitsError =
  GetApiV1KbSimulationCommitsErrors[keyof GetApiV1KbSimulationCommitsErrors];

export type GetApiV1KbSimulationCommitsResponses = {
  /**
   * Successful Response
   */
  200: SimulationCommitsV1;
};

export type GetApiV1KbSimulationCommitsResponse =
  GetApiV1KbSimulationCommitsResponses[keyof GetApiV1KbSimulationCommitsResponses];

export type GetApiV1ArticleTagsData = {
  body?: never;
  path?: never;
  query?: {
    ref?: GitCommitishV1Parse;
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Kb Id
     */
    kb_id?: number | null;
    /**
     * Article Id
     */
    article_id?: number | null;
    /**
     * Key
     */
    key?: string | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/article-tags";
};

export type GetApiV1ArticleTagsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ArticleTagsError =
  GetApiV1ArticleTagsErrors[keyof GetApiV1ArticleTagsErrors];

export type GetApiV1ArticleTagsResponses = {
  /**
   * Successful Response
   */
  200: PageV1GetArticleTagsKeyV1;
};

export type GetApiV1ArticleTagsResponse =
  GetApiV1ArticleTagsResponses[keyof GetApiV1ArticleTagsResponses];

export type GetApiV4KbsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v4/kbs";
};

export type GetApiV4KbsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV4KbsError = GetApiV4KbsErrors[keyof GetApiV4KbsErrors];

export type GetApiV4KbsResponses = {
  /**
   * Successful Response
   */
  200: PageV1KnowledgeBaseV2;
};

export type GetApiV4KbsResponse =
  GetApiV4KbsResponses[keyof GetApiV4KbsResponses];

export type GetApiV1FullKbsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/full-kbs";
};

export type GetApiV1FullKbsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullKbsError =
  GetApiV1FullKbsErrors[keyof GetApiV1FullKbsErrors];

export type GetApiV1FullKbsResponses = {
  /**
   * Successful Response
   */
  200: PageV1KnowledgeBaseFullV1;
};

export type GetApiV1FullKbsResponse =
  GetApiV1FullKbsResponses[keyof GetApiV1FullKbsResponses];

export type GetApiV2KbsByKbIdData = {
  body?: never;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v2/kbs/{kb_id}";
};

export type GetApiV2KbsByKbIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2KbsByKbIdError =
  GetApiV2KbsByKbIdErrors[keyof GetApiV2KbsByKbIdErrors];

export type GetApiV2KbsByKbIdResponses = {
  /**
   * Successful Response
   */
  200: KnowledgeBaseV2;
};

export type GetApiV2KbsByKbIdResponse =
  GetApiV2KbsByKbIdResponses[keyof GetApiV2KbsByKbIdResponses];

export type DeleteApiV3KbsByKbIdData = {
  body?: never;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v3/kbs/{kb_id}";
};

export type DeleteApiV3KbsByKbIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV3KbsByKbIdError =
  DeleteApiV3KbsByKbIdErrors[keyof DeleteApiV3KbsByKbIdErrors];

export type DeleteApiV3KbsByKbIdResponses = {
  /**
   * Successful Response
   */
  200: KnowledgeBaseV2;
};

export type DeleteApiV3KbsByKbIdResponse =
  DeleteApiV3KbsByKbIdResponses[keyof DeleteApiV3KbsByKbIdResponses];

export type PatchApiV3KbsByKbIdData = {
  body: PatchKnowledgeBaseParamsV3;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v3/kbs/{kb_id}";
};

export type PatchApiV3KbsByKbIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV3KbsByKbIdError =
  PatchApiV3KbsByKbIdErrors[keyof PatchApiV3KbsByKbIdErrors];

export type PatchApiV3KbsByKbIdResponses = {
  /**
   * Successful Response
   */
  200: KnowledgeBaseV2;
};

export type PatchApiV3KbsByKbIdResponse =
  PatchApiV3KbsByKbIdResponses[keyof PatchApiV3KbsByKbIdResponses];

export type PatchApiV3KbsByKbIdCrReviewSlaData = {
  body: PatchKnowledgeBaseReviewSlaParamsV3;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v3/kbs/{kb_id}/cr-review-sla";
};

export type PatchApiV3KbsByKbIdCrReviewSlaErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV3KbsByKbIdCrReviewSlaError =
  PatchApiV3KbsByKbIdCrReviewSlaErrors[keyof PatchApiV3KbsByKbIdCrReviewSlaErrors];

export type PatchApiV3KbsByKbIdCrReviewSlaResponses = {
  /**
   * Successful Response
   */
  200: KnowledgeBaseV2;
};

export type PatchApiV3KbsByKbIdCrReviewSlaResponse =
  PatchApiV3KbsByKbIdCrReviewSlaResponses[keyof PatchApiV3KbsByKbIdCrReviewSlaResponses];

export type PostApiV3KbsByKbIdRestoreData = {
  body?: never;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v3/kbs/{kb_id}/restore";
};

export type PostApiV3KbsByKbIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV3KbsByKbIdRestoreError =
  PostApiV3KbsByKbIdRestoreErrors[keyof PostApiV3KbsByKbIdRestoreErrors];

export type PostApiV3KbsByKbIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: KnowledgeBaseV2;
};

export type PostApiV3KbsByKbIdRestoreResponse =
  PostApiV3KbsByKbIdRestoreResponses[keyof PostApiV3KbsByKbIdRestoreResponses];

export type PostApiV2KbsByKbIdEmbedData = {
  body?: never;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: {
    ref?: NonEmptyStr;
  };
  url: "/api/v2/kbs/{kb_id}/embed";
};

export type PostApiV2KbsByKbIdEmbedErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2KbsByKbIdEmbedError =
  PostApiV2KbsByKbIdEmbedErrors[keyof PostApiV2KbsByKbIdEmbedErrors];

export type PostApiV2KbsByKbIdEmbedResponses = {
  /**
   * Successful Response
   */
  200: EmbedResponseV2;
};

export type PostApiV2KbsByKbIdEmbedResponse =
  PostApiV2KbsByKbIdEmbedResponses[keyof PostApiV2KbsByKbIdEmbedResponses];

export type GetApiV2KbsByKbIdEmbeddingSummaryData = {
  body?: never;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v2/kbs/{kb_id}/embedding-summary";
};

export type GetApiV2KbsByKbIdEmbeddingSummaryErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2KbsByKbIdEmbeddingSummaryError =
  GetApiV2KbsByKbIdEmbeddingSummaryErrors[keyof GetApiV2KbsByKbIdEmbeddingSummaryErrors];

export type GetApiV2KbsByKbIdEmbeddingSummaryResponses = {
  /**
   * Successful Response
   */
  200: GetEmbeddingSummaryResponseV2;
};

export type GetApiV2KbsByKbIdEmbeddingSummaryResponse =
  GetApiV2KbsByKbIdEmbeddingSummaryResponses[keyof GetApiV2KbsByKbIdEmbeddingSummaryResponses];

export type PostApiV1KbsByKbIdEmbeddingSearchData = {
  body: EmbeddingSearchParamsV1;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v1/kbs/{kb_id}/embedding-search";
};

export type PostApiV1KbsByKbIdEmbeddingSearchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbsByKbIdEmbeddingSearchError =
  PostApiV1KbsByKbIdEmbeddingSearchErrors[keyof PostApiV1KbsByKbIdEmbeddingSearchErrors];

export type PostApiV1KbsByKbIdEmbeddingSearchResponses = {
  /**
   * Successful Response
   */
  200: EmbeddingSearchResponseV1;
};

export type PostApiV1KbsByKbIdEmbeddingSearchResponse =
  PostApiV1KbsByKbIdEmbeddingSearchResponses[keyof PostApiV1KbsByKbIdEmbeddingSearchResponses];

export type PostApiV1KbsByKbIdHybridSearchData = {
  body: HybridSearchParamsV1;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v1/kbs/{kb_id}/hybrid-search";
};

export type PostApiV1KbsByKbIdHybridSearchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbsByKbIdHybridSearchError =
  PostApiV1KbsByKbIdHybridSearchErrors[keyof PostApiV1KbsByKbIdHybridSearchErrors];

export type PostApiV1KbsByKbIdHybridSearchResponses = {
  /**
   * Successful Response
   */
  200: HybridSearchResponseV1;
};

export type PostApiV1KbsByKbIdHybridSearchResponse =
  PostApiV1KbsByKbIdHybridSearchResponses[keyof PostApiV1KbsByKbIdHybridSearchResponses];

export type PostApiV1KbsByKbIdRegexSearchData = {
  body: RegexSearchArticlesParamsV1;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
  };
  query?: never;
  url: "/api/v1/kbs/{kb_id}/regex-search";
};

export type PostApiV1KbsByKbIdRegexSearchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbsByKbIdRegexSearchError =
  PostApiV1KbsByKbIdRegexSearchErrors[keyof PostApiV1KbsByKbIdRegexSearchErrors];

export type PostApiV1KbsByKbIdRegexSearchResponses = {
  /**
   * Successful Response
   */
  200: RegexSearchArticlesResponseV1;
};

export type PostApiV1KbsByKbIdRegexSearchResponse =
  PostApiV1KbsByKbIdRegexSearchResponses[keyof PostApiV1KbsByKbIdRegexSearchResponses];

export type GetApiV1ObjectArticleByObjectArticleIdData = {
  body?: never;
  path: {
    /**
     * Object Article Id
     */
    object_article_id: number;
  };
  query?: never;
  url: "/api/v1/object-article/{object_article_id}";
};

export type GetApiV1ObjectArticleByObjectArticleIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ObjectArticleByObjectArticleIdError =
  GetApiV1ObjectArticleByObjectArticleIdErrors[keyof GetApiV1ObjectArticleByObjectArticleIdErrors];

export type GetApiV1ObjectArticleByObjectArticleIdResponses = {
  /**
   * Successful Response
   */
  200: GetObjectArticleV1ResponseV1;
};

export type GetApiV1ObjectArticleByObjectArticleIdResponse =
  GetApiV1ObjectArticleByObjectArticleIdResponses[keyof GetApiV1ObjectArticleByObjectArticleIdResponses];

export type PatchApiV1KbsByKbIdArticlesByArticleIdData = {
  body: PatchArticleRequestV1;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
    /**
     * Article Id
     */
    article_id: number;
  };
  query?: never;
  url: "/api/v1/kbs/{kb_id}/articles/{article_id}";
};

export type PatchApiV1KbsByKbIdArticlesByArticleIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1KbsByKbIdArticlesByArticleIdError =
  PatchApiV1KbsByKbIdArticlesByArticleIdErrors[keyof PatchApiV1KbsByKbIdArticlesByArticleIdErrors];

export type PatchApiV1KbsByKbIdArticlesByArticleIdResponses = {
  /**
   * Successful Response
   */
  200: ArticleV1;
};

export type PatchApiV1KbsByKbIdArticlesByArticleIdResponse =
  PatchApiV1KbsByKbIdArticlesByArticleIdResponses[keyof PatchApiV1KbsByKbIdArticlesByArticleIdResponses];

export type GetApiV1KbsOwnedData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/kbs/owned";
};

export type GetApiV1KbsOwnedErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1KbsOwnedError =
  GetApiV1KbsOwnedErrors[keyof GetApiV1KbsOwnedErrors];

export type GetApiV1KbsOwnedResponses = {
  /**
   * Successful Response
   */
  200: PageV2KnowledgeBaseV2;
};

export type GetApiV1KbsOwnedResponse =
  GetApiV1KbsOwnedResponses[keyof GetApiV1KbsOwnedResponses];

export type PostApiV1KbsData = {
  body: CreateKnowledgeBaseParamsV2;
  path?: never;
  query?: never;
  url: "/api/v1/kbs";
};

export type PostApiV1KbsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1KbsError = PostApiV1KbsErrors[keyof PostApiV1KbsErrors];

export type PostApiV1KbsResponses = {
  /**
   * Successful Response
   */
  200: KnowledgeBaseV2;
};

export type PostApiV1KbsResponse =
  PostApiV1KbsResponses[keyof PostApiV1KbsResponses];

export type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextData = {
  body: UpdateIndexTextParamsV2;
  path: {
    /**
     * Kb Id
     */
    kb_id: number;
    ref: NonEmptyStr;
    /**
     * Article Id
     */
    article_id: number;
  };
  query?: never;
  url: "/api/v3/kbs/{kb_id}/article/{ref}/{article_id}/index-text";
};

export type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextError =
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextErrors[keyof PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextErrors];

export type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponses = {
  /**
   * Successful Response
   */
  200: IndexTextResponseV2;
};

export type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponse =
  PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponses[keyof PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponses];

export type GetApiV1MachineUsersData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/machine-users";
};

export type GetApiV1MachineUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1MachineUsersError =
  GetApiV1MachineUsersErrors[keyof GetApiV1MachineUsersErrors];

export type GetApiV1MachineUsersResponses = {
  /**
   * Successful Response
   */
  200: PageV1MachineUserV1;
};

export type GetApiV1MachineUsersResponse =
  GetApiV1MachineUsersResponses[keyof GetApiV1MachineUsersResponses];

export type PostApiV1MachineUsersData = {
  body: CreateMachineUserParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/machine-users";
};

export type PostApiV1MachineUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1MachineUsersError =
  PostApiV1MachineUsersErrors[keyof PostApiV1MachineUsersErrors];

export type PostApiV1MachineUsersResponses = {
  /**
   * Successful Response
   */
  200: MachineUserV1;
};

export type PostApiV1MachineUsersResponse =
  PostApiV1MachineUsersResponses[keyof PostApiV1MachineUsersResponses];

export type DeleteApiV1MachineUsersByMachineUserIdData = {
  body?: never;
  path: {
    /**
     * Machine User Id
     */
    machine_user_id: number;
  };
  query?: never;
  url: "/api/v1/machine-users/{machine_user_id}";
};

export type DeleteApiV1MachineUsersByMachineUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1MachineUsersByMachineUserIdError =
  DeleteApiV1MachineUsersByMachineUserIdErrors[keyof DeleteApiV1MachineUsersByMachineUserIdErrors];

export type DeleteApiV1MachineUsersByMachineUserIdResponses = {
  /**
   * Successful Response
   */
  200: MachineUserV1;
};

export type DeleteApiV1MachineUsersByMachineUserIdResponse =
  DeleteApiV1MachineUsersByMachineUserIdResponses[keyof DeleteApiV1MachineUsersByMachineUserIdResponses];

export type GetApiV1MachineUsersByMachineUserIdData = {
  body?: never;
  path: {
    /**
     * Machine User Id
     */
    machine_user_id: number;
  };
  query?: never;
  url: "/api/v1/machine-users/{machine_user_id}";
};

export type GetApiV1MachineUsersByMachineUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1MachineUsersByMachineUserIdError =
  GetApiV1MachineUsersByMachineUserIdErrors[keyof GetApiV1MachineUsersByMachineUserIdErrors];

export type GetApiV1MachineUsersByMachineUserIdResponses = {
  /**
   * Successful Response
   */
  200: MachineUserFullV1;
};

export type GetApiV1MachineUsersByMachineUserIdResponse =
  GetApiV1MachineUsersByMachineUserIdResponses[keyof GetApiV1MachineUsersByMachineUserIdResponses];

export type PatchApiV1MachineUsersByMachineUserIdData = {
  body: UpdateMachineUserParamsV1;
  path: {
    /**
     * Machine User Id
     */
    machine_user_id: number;
  };
  query?: never;
  url: "/api/v1/machine-users/{machine_user_id}";
};

export type PatchApiV1MachineUsersByMachineUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1MachineUsersByMachineUserIdError =
  PatchApiV1MachineUsersByMachineUserIdErrors[keyof PatchApiV1MachineUsersByMachineUserIdErrors];

export type PatchApiV1MachineUsersByMachineUserIdResponses = {
  /**
   * Successful Response
   */
  200: MachineUserV1;
};

export type PatchApiV1MachineUsersByMachineUserIdResponse =
  PatchApiV1MachineUsersByMachineUserIdResponses[keyof PatchApiV1MachineUsersByMachineUserIdResponses];

export type GetApiV1MachineUsersByMachineUserIdApiKeysData = {
  body?: never;
  path: {
    /**
     * Machine User Id
     */
    machine_user_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/machine-users/{machine_user_id}/api-keys";
};

export type GetApiV1MachineUsersByMachineUserIdApiKeysErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1MachineUsersByMachineUserIdApiKeysError =
  GetApiV1MachineUsersByMachineUserIdApiKeysErrors[keyof GetApiV1MachineUsersByMachineUserIdApiKeysErrors];

export type GetApiV1MachineUsersByMachineUserIdApiKeysResponses = {
  /**
   * Successful Response
   */
  200: PageV1ApiKeyV1;
};

export type GetApiV1MachineUsersByMachineUserIdApiKeysResponse =
  GetApiV1MachineUsersByMachineUserIdApiKeysResponses[keyof GetApiV1MachineUsersByMachineUserIdApiKeysResponses];

export type PostApiV1MachineUsersByMachineUserIdApiKeysData = {
  body: CreateMachineUserApiKeyParamsV1;
  path: {
    /**
     * Machine User Id
     */
    machine_user_id: number;
  };
  query?: never;
  url: "/api/v1/machine-users/{machine_user_id}/api-keys";
};

export type PostApiV1MachineUsersByMachineUserIdApiKeysErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1MachineUsersByMachineUserIdApiKeysError =
  PostApiV1MachineUsersByMachineUserIdApiKeysErrors[keyof PostApiV1MachineUsersByMachineUserIdApiKeysErrors];

export type PostApiV1MachineUsersByMachineUserIdApiKeysResponses = {
  /**
   * Successful Response
   */
  200: ApiKeySecretV1;
};

export type PostApiV1MachineUsersByMachineUserIdApiKeysResponse =
  PostApiV1MachineUsersByMachineUserIdApiKeysResponses[keyof PostApiV1MachineUsersByMachineUserIdApiKeysResponses];

export type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdData = {
  body?: never;
  path: {
    /**
     * Machine User Id
     */
    machine_user_id: number;
    /**
     * Api Key Id
     */
    api_key_id: number;
  };
  query?: never;
  url: "/api/v1/machine-users/{machine_user_id}/api-keys/{api_key_id}";
};

export type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdError =
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdErrors[keyof DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdErrors];

export type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponses = {
  /**
   * Successful Response
   */
  200: ApiKeyV1;
};

export type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponse =
  DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponses[keyof DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponses];

export type GetApiV2MetricsVerificationData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Kb Id
     */
    kb_id: number;
    ref?: NonEmptyStr;
    /**
     * Path
     */
    path?: string | null;
    /**
     * Article Tags Any
     */
    article_tags_any?: Array<SanitizedStr> | null;
    /**
     * Article Tags All
     */
    article_tags_all?: Array<SanitizedStr> | null;
  };
  url: "/api/v2/metrics/verification";
};

export type GetApiV2MetricsVerificationErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2MetricsVerificationError =
  GetApiV2MetricsVerificationErrors[keyof GetApiV2MetricsVerificationErrors];

export type GetApiV2MetricsVerificationResponses = {
  /**
   * Successful Response
   */
  200: VerificationMetricsResponseV2;
};

export type GetApiV2MetricsVerificationResponse =
  GetApiV2MetricsVerificationResponses[keyof GetApiV2MetricsVerificationResponses];

export type GetApiV2MetricsChangeCountsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Kb Id
     */
    kb_id: number;
    ref?: NonEmptyStr;
    /**
     * Start Date
     */
    start_date: Date;
    /**
     * End Date
     */
    end_date: Date;
    /**
     * Path
     */
    path?: string | null;
    /**
     * Article Tags Any
     */
    article_tags_any?: Array<SanitizedStr> | null;
    /**
     * Article Tags All
     */
    article_tags_all?: Array<SanitizedStr> | null;
  };
  url: "/api/v2/metrics/change-counts";
};

export type GetApiV2MetricsChangeCountsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2MetricsChangeCountsError =
  GetApiV2MetricsChangeCountsErrors[keyof GetApiV2MetricsChangeCountsErrors];

export type GetApiV2MetricsChangeCountsResponses = {
  /**
   * Successful Response
   */
  200: ChangeCountsResponseV2;
};

export type GetApiV2MetricsChangeCountsResponse =
  GetApiV2MetricsChangeCountsResponses[keyof GetApiV2MetricsChangeCountsResponses];

export type GetApiV2MetricsChangeUsersData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Kb Id
     */
    kb_id: number;
    ref?: NonEmptyStr;
    /**
     * Start Date
     */
    start_date: Date;
    /**
     * End Date
     */
    end_date: Date;
    /**
     * Path
     */
    path?: string | null;
    /**
     * Article Tags Any
     */
    article_tags_any?: Array<SanitizedStr> | null;
    /**
     * Article Tags All
     */
    article_tags_all?: Array<SanitizedStr> | null;
    /**
     * User Ids
     */
    user_ids?: Array<number> | null;
  };
  url: "/api/v2/metrics/change-users";
};

export type GetApiV2MetricsChangeUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2MetricsChangeUsersError =
  GetApiV2MetricsChangeUsersErrors[keyof GetApiV2MetricsChangeUsersErrors];

export type GetApiV2MetricsChangeUsersResponses = {
  /**
   * Successful Response
   */
  200: ChangeUsersResponseV2;
};

export type GetApiV2MetricsChangeUsersResponse =
  GetApiV2MetricsChangeUsersResponses[keyof GetApiV2MetricsChangeUsersResponses];

export type GetApiV1MetricsChildJudgementData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Kb Id
     */
    kb_id: number;
    /**
     * Judge Id
     */
    judge_id: number;
    /**
     * Path
     */
    path?: string | null;
    /**
     * Start Date
     */
    start_date?: Date | null;
    /**
     * End Date
     */
    end_date?: Date | null;
  };
  url: "/api/v1/metrics/child-judgement";
};

export type GetApiV1MetricsChildJudgementErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1MetricsChildJudgementError =
  GetApiV1MetricsChildJudgementErrors[keyof GetApiV1MetricsChildJudgementErrors];

export type GetApiV1MetricsChildJudgementResponses = {
  /**
   * Successful Response
   */
  200: KbChildJudgementMetricsResponseV1;
};

export type GetApiV1MetricsChildJudgementResponse =
  GetApiV1MetricsChildJudgementResponses[keyof GetApiV1MetricsChildJudgementResponses];

export type GetApiV2MetricsTopArticleJudgementData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Kb Id
     */
    kb_id: number;
    /**
     * Judge Id
     */
    judge_id: number;
    order: KbArticleRankOrderV1;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    /**
     * Confidence Weight
     */
    confidence_weight?: number;
    /**
     * Path
     */
    path?: string | null;
    /**
     * Start Date
     */
    start_date?: Date | null;
    /**
     * End Date
     */
    end_date?: Date | null;
  };
  url: "/api/v2/metrics/top-article-judgement";
};

export type GetApiV2MetricsTopArticleJudgementErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2MetricsTopArticleJudgementError =
  GetApiV2MetricsTopArticleJudgementErrors[keyof GetApiV2MetricsTopArticleJudgementErrors];

export type GetApiV2MetricsTopArticleJudgementResponses = {
  /**
   * Successful Response
   */
  200: PageV2KbTopArticleJudgementMetricsV1;
};

export type GetApiV2MetricsTopArticleJudgementResponse =
  GetApiV2MetricsTopArticleJudgementResponses[keyof GetApiV2MetricsTopArticleJudgementResponses];

export type GetApiV1UsersByUserIdNotificationSettingsData = {
  body?: never;
  path: {
    /**
     * User Id
     */
    user_id: number;
  };
  query?: never;
  url: "/api/v1/users/{user_id}/notification-settings";
};

export type GetApiV1UsersByUserIdNotificationSettingsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1UsersByUserIdNotificationSettingsError =
  GetApiV1UsersByUserIdNotificationSettingsErrors[keyof GetApiV1UsersByUserIdNotificationSettingsErrors];

export type GetApiV1UsersByUserIdNotificationSettingsResponses = {
  /**
   * Successful Response
   */
  200: NotificationSettingsV1;
};

export type GetApiV1UsersByUserIdNotificationSettingsResponse =
  GetApiV1UsersByUserIdNotificationSettingsResponses[keyof GetApiV1UsersByUserIdNotificationSettingsResponses];

export type PatchApiV1UsersByUserIdNotificationSettingsData = {
  body: UpdateNotificationSettingsParamsV1;
  path: {
    /**
     * User Id
     */
    user_id: number;
  };
  query?: never;
  url: "/api/v1/users/{user_id}/notification-settings";
};

export type PatchApiV1UsersByUserIdNotificationSettingsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1UsersByUserIdNotificationSettingsError =
  PatchApiV1UsersByUserIdNotificationSettingsErrors[keyof PatchApiV1UsersByUserIdNotificationSettingsErrors];

export type PatchApiV1UsersByUserIdNotificationSettingsResponses = {
  /**
   * Successful Response
   */
  200: NotificationSettingsV1;
};

export type PatchApiV1UsersByUserIdNotificationSettingsResponse =
  PatchApiV1UsersByUserIdNotificationSettingsResponses[keyof PatchApiV1UsersByUserIdNotificationSettingsResponses];

export type GetApiNotionV1TenantsByTenantIdActionsPagesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/notion/v1/tenants/{tenant_id}/actions/pages";
};

export type GetApiNotionV1TenantsByTenantIdActionsPagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiNotionV1TenantsByTenantIdActionsPagesError =
  GetApiNotionV1TenantsByTenantIdActionsPagesErrors[keyof GetApiNotionV1TenantsByTenantIdActionsPagesErrors];

export type GetApiNotionV1TenantsByTenantIdActionsPagesResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1NotionPageV1;
};

export type GetApiNotionV1TenantsByTenantIdActionsPagesResponse =
  GetApiNotionV1TenantsByTenantIdActionsPagesResponses[keyof GetApiNotionV1TenantsByTenantIdActionsPagesResponses];

export type PostApiNotionV1TenantsByTenantIdActionsPagesData = {
  body: CreateNotionPageParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/actions/pages";
};

export type PostApiNotionV1TenantsByTenantIdActionsPagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiNotionV1TenantsByTenantIdActionsPagesError =
  PostApiNotionV1TenantsByTenantIdActionsPagesErrors[keyof PostApiNotionV1TenantsByTenantIdActionsPagesErrors];

export type PostApiNotionV1TenantsByTenantIdActionsPagesResponses = {
  /**
   * Successful Response
   */
  200: NotionPageV1;
};

export type PostApiNotionV1TenantsByTenantIdActionsPagesResponse =
  PostApiNotionV1TenantsByTenantIdActionsPagesResponses[keyof PostApiNotionV1TenantsByTenantIdActionsPagesResponses];

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/notion/v1/tenants/{tenant_id}/actions/databases";
};

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesError =
  GetApiNotionV1TenantsByTenantIdActionsDatabasesErrors[keyof GetApiNotionV1TenantsByTenantIdActionsDatabasesErrors];

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1NotionDatabaseV1;
};

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesResponse =
  GetApiNotionV1TenantsByTenantIdActionsDatabasesResponses[keyof GetApiNotionV1TenantsByTenantIdActionsDatabasesResponses];

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Database Id
     */
    database_id: string;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/actions/databases/{database_id}";
};

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdError =
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdErrors[keyof GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdErrors];

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponses =
  {
    /**
     * Successful Response
     */
    200: NotionDatabaseV1;
  };

export type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponse =
  GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponses[keyof GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponses];

export type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Database Id
       */
      database_id: string;
    };
    query?: {
      /**
       * Cursor
       */
      cursor?: string | null;
    };
    url: "/api/notion/v1/tenants/{tenant_id}/actions/databases/{database_id}/query";
  };

export type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryError =
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryErrors[keyof PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryErrors];

export type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponses =
  {
    /**
     * Successful Response
     */
    200: CursorPageV1NotionPageV1;
  };

export type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponse =
  PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponses[keyof PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponses];

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Page Id
     */
    page_id: string;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}/content";
};

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentError =
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentErrors[keyof GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentErrors];

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponses =
  {
    /**
     * Successful Response
     */
    200: NotionPageContentV1;
  };

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponse =
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponses[keyof GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponses];

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Page Id
     */
    page_id: string;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}/comments";
};

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsError =
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors[keyof GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors];

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses =
  {
    /**
     * Successful Response
     */
    200: CursorPageV1NotionCommentV1;
  };

export type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse =
  GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses[keyof GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses];

export type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksData = {
  body: CreateNotionBlocksParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Page Id
     */
    page_id: string;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}/blocks";
};

export type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksError =
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksErrors[keyof PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksErrors];

export type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponses =
  {
    /**
     * Successful Response
     */
    200: CreateNotionBlocksResponseV1;
  };

export type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponse =
  PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponses[keyof PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponses];

export type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Page Id
     */
    page_id: string;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}";
};

export type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdError =
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors[keyof DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors];

export type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses = {
  /**
   * Successful Response
   */
  200: NotionPageV1;
};

export type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse =
  DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses[keyof DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses];

export type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdData = {
  body: UpdateNotionPageParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Page Id
     */
    page_id: string;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/actions/pages/{page_id}";
};

export type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdError =
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors[keyof PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors];

export type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses = {
  /**
   * Successful Response
   */
  200: NotionPageV1;
};

export type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse =
  PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses[keyof PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses];

export type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Block Id
     */
    block_id: string;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/actions/blocks/{block_id}";
};

export type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError =
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors[keyof DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors];

export type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses =
  {
    /**
     * Successful Response
     */
    200: NotionBlockV1;
  };

export type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse =
  DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses[keyof DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses];

export type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData = {
  body: UpdateNotionBlockParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Block Id
     */
    block_id: string;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/actions/blocks/{block_id}";
};

export type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError =
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors[keyof PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors];

export type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses = {
  /**
   * Successful Response
   */
  200: NotionBlockV1;
};

export type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse =
  PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses[keyof PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses];

export type GetApiNotionV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/notion/v1/tenants";
};

export type GetApiNotionV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiNotionV1TenantsError =
  GetApiNotionV1TenantsErrors[keyof GetApiNotionV1TenantsErrors];

export type GetApiNotionV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1NotionTenantV1;
};

export type GetApiNotionV1TenantsResponse =
  GetApiNotionV1TenantsResponses[keyof GetApiNotionV1TenantsResponses];

export type PostApiNotionV1TenantsData = {
  body: CreateNotionTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/notion/v1/tenants";
};

export type PostApiNotionV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiNotionV1TenantsError =
  PostApiNotionV1TenantsErrors[keyof PostApiNotionV1TenantsErrors];

export type PostApiNotionV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: NotionTenantV1;
};

export type PostApiNotionV1TenantsResponse =
  PostApiNotionV1TenantsResponses[keyof PostApiNotionV1TenantsResponses];

export type DeleteApiNotionV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}";
};

export type DeleteApiNotionV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiNotionV1TenantsByTenantIdError =
  DeleteApiNotionV1TenantsByTenantIdErrors[keyof DeleteApiNotionV1TenantsByTenantIdErrors];

export type DeleteApiNotionV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: NotionTenantV1;
};

export type DeleteApiNotionV1TenantsByTenantIdResponse =
  DeleteApiNotionV1TenantsByTenantIdResponses[keyof DeleteApiNotionV1TenantsByTenantIdResponses];

export type GetApiNotionV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}";
};

export type GetApiNotionV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiNotionV1TenantsByTenantIdError =
  GetApiNotionV1TenantsByTenantIdErrors[keyof GetApiNotionV1TenantsByTenantIdErrors];

export type GetApiNotionV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: NotionTenantFullV1;
};

export type GetApiNotionV1TenantsByTenantIdResponse =
  GetApiNotionV1TenantsByTenantIdResponses[keyof GetApiNotionV1TenantsByTenantIdResponses];

export type PostApiNotionV1TenantsByTenantIdConnectData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/connect";
};

export type PostApiNotionV1TenantsByTenantIdConnectErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiNotionV1TenantsByTenantIdConnectError =
  PostApiNotionV1TenantsByTenantIdConnectErrors[keyof PostApiNotionV1TenantsByTenantIdConnectErrors];

export type PostApiNotionV1TenantsByTenantIdConnectResponses = {
  /**
   * Successful Response
   */
  200: NotionConnectResponseV1;
};

export type PostApiNotionV1TenantsByTenantIdConnectResponse =
  PostApiNotionV1TenantsByTenantIdConnectResponses[keyof PostApiNotionV1TenantsByTenantIdConnectResponses];

export type PostApiNotionV1TenantsByTenantIdCallbackData = {
  body: NotionCallbackPayloadV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/callback";
};

export type PostApiNotionV1TenantsByTenantIdCallbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiNotionV1TenantsByTenantIdCallbackError =
  PostApiNotionV1TenantsByTenantIdCallbackErrors[keyof PostApiNotionV1TenantsByTenantIdCallbackErrors];

export type PostApiNotionV1TenantsByTenantIdCallbackResponses = {
  /**
   * Successful Response
   */
  200: NotionTenantV1;
};

export type PostApiNotionV1TenantsByTenantIdCallbackResponse =
  PostApiNotionV1TenantsByTenantIdCallbackResponses[keyof PostApiNotionV1TenantsByTenantIdCallbackResponses];

export type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/reveal-webhook-token";
};

export type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenError =
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenErrors[keyof PostApiNotionV1TenantsByTenantIdRevealWebhookTokenErrors];

export type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponses = {
  /**
   * Successful Response
   */
  200: NotionWebhookVerificationTokenV1;
};

export type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponse =
  PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponses[keyof PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponses];

export type GetApiNotionV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/notion/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiNotionV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiNotionV1TenantsByTenantIdCheckConnectionError =
  GetApiNotionV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiNotionV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiNotionV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: NotionCheckConnectionResponseV1;
};

export type GetApiNotionV1TenantsByTenantIdCheckConnectionResponse =
  GetApiNotionV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiNotionV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiV1OauthApplicationsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
    /**
     * Provider
     */
    provider?: OAuthApplicationProviderV1 | null;
  };
  url: "/api/v1/oauth-applications";
};

export type GetApiV1OauthApplicationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1OauthApplicationsError =
  GetApiV1OauthApplicationsErrors[keyof GetApiV1OauthApplicationsErrors];

export type GetApiV1OauthApplicationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1OAuthApplicationV1;
};

export type GetApiV1OauthApplicationsResponse =
  GetApiV1OauthApplicationsResponses[keyof GetApiV1OauthApplicationsResponses];

export type PostApiV1OauthApplicationsData = {
  body: CreateOAuthApplicationParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/oauth-applications";
};

export type PostApiV1OauthApplicationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1OauthApplicationsError =
  PostApiV1OauthApplicationsErrors[keyof PostApiV1OauthApplicationsErrors];

export type PostApiV1OauthApplicationsResponses = {
  /**
   * Successful Response
   */
  200: OAuthApplicationSecretV1;
};

export type PostApiV1OauthApplicationsResponse =
  PostApiV1OauthApplicationsResponses[keyof PostApiV1OauthApplicationsResponses];

export type GetApiV1FullOauthApplicationsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/full-oauth-applications";
};

export type GetApiV1FullOauthApplicationsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullOauthApplicationsError =
  GetApiV1FullOauthApplicationsErrors[keyof GetApiV1FullOauthApplicationsErrors];

export type GetApiV1FullOauthApplicationsResponses = {
  /**
   * Successful Response
   */
  200: PageV1OAuthApplicationFullV1;
};

export type GetApiV1FullOauthApplicationsResponse =
  GetApiV1FullOauthApplicationsResponses[keyof GetApiV1FullOauthApplicationsResponses];

export type DeleteApiV1OauthApplicationsByOauthApplicationIdData = {
  body?: never;
  path: {
    /**
     * Oauth Application Id
     */
    oauth_application_id: number;
  };
  query?: never;
  url: "/api/v1/oauth-applications/{oauth_application_id}";
};

export type DeleteApiV1OauthApplicationsByOauthApplicationIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1OauthApplicationsByOauthApplicationIdError =
  DeleteApiV1OauthApplicationsByOauthApplicationIdErrors[keyof DeleteApiV1OauthApplicationsByOauthApplicationIdErrors];

export type DeleteApiV1OauthApplicationsByOauthApplicationIdResponses = {
  /**
   * Successful Response
   */
  200: OAuthApplicationV1;
};

export type DeleteApiV1OauthApplicationsByOauthApplicationIdResponse =
  DeleteApiV1OauthApplicationsByOauthApplicationIdResponses[keyof DeleteApiV1OauthApplicationsByOauthApplicationIdResponses];

export type GetApiV1OauthApplicationsByOauthApplicationIdData = {
  body?: never;
  path: {
    /**
     * Oauth Application Id
     */
    oauth_application_id: number;
  };
  query?: never;
  url: "/api/v1/oauth-applications/{oauth_application_id}";
};

export type GetApiV1OauthApplicationsByOauthApplicationIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1OauthApplicationsByOauthApplicationIdError =
  GetApiV1OauthApplicationsByOauthApplicationIdErrors[keyof GetApiV1OauthApplicationsByOauthApplicationIdErrors];

export type GetApiV1OauthApplicationsByOauthApplicationIdResponses = {
  /**
   * Successful Response
   */
  200: OAuthApplicationFullV1;
};

export type GetApiV1OauthApplicationsByOauthApplicationIdResponse =
  GetApiV1OauthApplicationsByOauthApplicationIdResponses[keyof GetApiV1OauthApplicationsByOauthApplicationIdResponses];

export type PatchApiV1OauthApplicationsByOauthApplicationIdData = {
  body: UpdateOAuthApplicationParamsV1;
  path: {
    /**
     * Oauth Application Id
     */
    oauth_application_id: number;
  };
  query?: never;
  url: "/api/v1/oauth-applications/{oauth_application_id}";
};

export type PatchApiV1OauthApplicationsByOauthApplicationIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1OauthApplicationsByOauthApplicationIdError =
  PatchApiV1OauthApplicationsByOauthApplicationIdErrors[keyof PatchApiV1OauthApplicationsByOauthApplicationIdErrors];

export type PatchApiV1OauthApplicationsByOauthApplicationIdResponses = {
  /**
   * Successful Response
   */
  200: OAuthApplicationV1;
};

export type PatchApiV1OauthApplicationsByOauthApplicationIdResponse =
  PatchApiV1OauthApplicationsByOauthApplicationIdResponses[keyof PatchApiV1OauthApplicationsByOauthApplicationIdResponses];

export type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretData = {
  body?: never;
  path: {
    /**
     * Oauth Application Id
     */
    oauth_application_id: number;
  };
  query?: never;
  url: "/api/v1/oauth-applications/{oauth_application_id}/rotate-secret";
};

export type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretError =
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretErrors[keyof PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretErrors];

export type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponses =
  {
    /**
     * Successful Response
     */
    200: OAuthApplicationSecretV1;
  };

export type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponse =
  PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponses[keyof PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponses];

export type PostApiOutlookV1ActionsCreateDraftData = {
  body: OutlookCreateDraftParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/create-draft";
};

export type PostApiOutlookV1ActionsCreateDraftErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsCreateDraftError =
  PostApiOutlookV1ActionsCreateDraftErrors[keyof PostApiOutlookV1ActionsCreateDraftErrors];

export type PostApiOutlookV1ActionsCreateDraftResponses = {
  /**
   * Successful Response
   */
  200: OutlookComposeResponseV1;
};

export type PostApiOutlookV1ActionsCreateDraftResponse =
  PostApiOutlookV1ActionsCreateDraftResponses[keyof PostApiOutlookV1ActionsCreateDraftResponses];

export type PostApiOutlookV1ActionsReplyEmailData = {
  body: OutlookReplyEmailParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/reply-email";
};

export type PostApiOutlookV1ActionsReplyEmailErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsReplyEmailError =
  PostApiOutlookV1ActionsReplyEmailErrors[keyof PostApiOutlookV1ActionsReplyEmailErrors];

export type PostApiOutlookV1ActionsReplyEmailResponses = {
  /**
   * Successful Response
   */
  200: OutlookComposeResponseV1;
};

export type PostApiOutlookV1ActionsReplyEmailResponse =
  PostApiOutlookV1ActionsReplyEmailResponses[keyof PostApiOutlookV1ActionsReplyEmailResponses];

export type PostApiOutlookV1ActionsForwardEmailData = {
  body: OutlookForwardEmailParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/forward-email";
};

export type PostApiOutlookV1ActionsForwardEmailErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsForwardEmailError =
  PostApiOutlookV1ActionsForwardEmailErrors[keyof PostApiOutlookV1ActionsForwardEmailErrors];

export type PostApiOutlookV1ActionsForwardEmailResponses = {
  /**
   * Successful Response
   */
  200: OutlookComposeResponseV1;
};

export type PostApiOutlookV1ActionsForwardEmailResponse =
  PostApiOutlookV1ActionsForwardEmailResponses[keyof PostApiOutlookV1ActionsForwardEmailResponses];

export type PostApiOutlookV1ActionsSendEmailData = {
  body: OutlookSendEmailParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/send-email";
};

export type PostApiOutlookV1ActionsSendEmailErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsSendEmailError =
  PostApiOutlookV1ActionsSendEmailErrors[keyof PostApiOutlookV1ActionsSendEmailErrors];

export type PostApiOutlookV1ActionsSendEmailResponses = {
  /**
   * Successful Response
   */
  200: OutlookSendEmailResponseV1;
};

export type PostApiOutlookV1ActionsSendEmailResponse =
  PostApiOutlookV1ActionsSendEmailResponses[keyof PostApiOutlookV1ActionsSendEmailResponses];

export type PostApiOutlookV1ActionsSetEmailCategoriesData = {
  body: OutlookSetEmailCategoriesParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/set-email-categories";
};

export type PostApiOutlookV1ActionsSetEmailCategoriesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsSetEmailCategoriesError =
  PostApiOutlookV1ActionsSetEmailCategoriesErrors[keyof PostApiOutlookV1ActionsSetEmailCategoriesErrors];

export type PostApiOutlookV1ActionsSetEmailCategoriesResponses = {
  /**
   * Successful Response
   */
  200: OutlookModifyResponseV1;
};

export type PostApiOutlookV1ActionsSetEmailCategoriesResponse =
  PostApiOutlookV1ActionsSetEmailCategoriesResponses[keyof PostApiOutlookV1ActionsSetEmailCategoriesResponses];

export type PostApiOutlookV1ActionsSetEmailImportanceData = {
  body: OutlookSetEmailImportanceParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/set-email-importance";
};

export type PostApiOutlookV1ActionsSetEmailImportanceErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsSetEmailImportanceError =
  PostApiOutlookV1ActionsSetEmailImportanceErrors[keyof PostApiOutlookV1ActionsSetEmailImportanceErrors];

export type PostApiOutlookV1ActionsSetEmailImportanceResponses = {
  /**
   * Successful Response
   */
  200: OutlookModifyResponseV1;
};

export type PostApiOutlookV1ActionsSetEmailImportanceResponse =
  PostApiOutlookV1ActionsSetEmailImportanceResponses[keyof PostApiOutlookV1ActionsSetEmailImportanceResponses];

export type PostApiOutlookV1ActionsSetEmailFlagData = {
  body: OutlookSetEmailFlagParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/set-email-flag";
};

export type PostApiOutlookV1ActionsSetEmailFlagErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsSetEmailFlagError =
  PostApiOutlookV1ActionsSetEmailFlagErrors[keyof PostApiOutlookV1ActionsSetEmailFlagErrors];

export type PostApiOutlookV1ActionsSetEmailFlagResponses = {
  /**
   * Successful Response
   */
  200: OutlookModifyResponseV1;
};

export type PostApiOutlookV1ActionsSetEmailFlagResponse =
  PostApiOutlookV1ActionsSetEmailFlagResponses[keyof PostApiOutlookV1ActionsSetEmailFlagResponses];

export type PostApiOutlookV1ActionsMarkEmailReadData = {
  body: OutlookMarkEmailReadParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/mark-email-read";
};

export type PostApiOutlookV1ActionsMarkEmailReadErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsMarkEmailReadError =
  PostApiOutlookV1ActionsMarkEmailReadErrors[keyof PostApiOutlookV1ActionsMarkEmailReadErrors];

export type PostApiOutlookV1ActionsMarkEmailReadResponses = {
  /**
   * Successful Response
   */
  200: OutlookModifyResponseV1;
};

export type PostApiOutlookV1ActionsMarkEmailReadResponse =
  PostApiOutlookV1ActionsMarkEmailReadResponses[keyof PostApiOutlookV1ActionsMarkEmailReadResponses];

export type PostApiOutlookV1ActionsMoveEmailData = {
  body: OutlookMoveEmailParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/move-email";
};

export type PostApiOutlookV1ActionsMoveEmailErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsMoveEmailError =
  PostApiOutlookV1ActionsMoveEmailErrors[keyof PostApiOutlookV1ActionsMoveEmailErrors];

export type PostApiOutlookV1ActionsMoveEmailResponses = {
  /**
   * Successful Response
   */
  200: OutlookMoveEmailResponseV1;
};

export type PostApiOutlookV1ActionsMoveEmailResponse =
  PostApiOutlookV1ActionsMoveEmailResponses[keyof PostApiOutlookV1ActionsMoveEmailResponses];

export type PostApiOutlookV1ActionsCopyEmailData = {
  body: OutlookCopyEmailParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/copy-email";
};

export type PostApiOutlookV1ActionsCopyEmailErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsCopyEmailError =
  PostApiOutlookV1ActionsCopyEmailErrors[keyof PostApiOutlookV1ActionsCopyEmailErrors];

export type PostApiOutlookV1ActionsCopyEmailResponses = {
  /**
   * Successful Response
   */
  200: OutlookCopyEmailResponseV1;
};

export type PostApiOutlookV1ActionsCopyEmailResponse =
  PostApiOutlookV1ActionsCopyEmailResponses[keyof PostApiOutlookV1ActionsCopyEmailResponses];

export type PostApiOutlookV1ActionsDeleteEmailData = {
  body: OutlookDeleteEmailParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/delete-email";
};

export type PostApiOutlookV1ActionsDeleteEmailErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsDeleteEmailError =
  PostApiOutlookV1ActionsDeleteEmailErrors[keyof PostApiOutlookV1ActionsDeleteEmailErrors];

export type PostApiOutlookV1ActionsDeleteEmailResponses = {
  /**
   * Successful Response
   */
  200: OutlookDeleteEmailResponseV1;
};

export type PostApiOutlookV1ActionsDeleteEmailResponse =
  PostApiOutlookV1ActionsDeleteEmailResponses[keyof PostApiOutlookV1ActionsDeleteEmailResponses];

export type PostApiOutlookV1ActionsGetEmailAttachmentData = {
  body: OutlookGetEmailAttachmentParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/get-email-attachment";
};

export type PostApiOutlookV1ActionsGetEmailAttachmentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsGetEmailAttachmentError =
  PostApiOutlookV1ActionsGetEmailAttachmentErrors[keyof PostApiOutlookV1ActionsGetEmailAttachmentErrors];

export type PostApiOutlookV1ActionsGetEmailAttachmentResponses = {
  /**
   * Successful Response
   */
  200: OutlookGetEmailAttachmentResponseV1;
};

export type PostApiOutlookV1ActionsGetEmailAttachmentResponse =
  PostApiOutlookV1ActionsGetEmailAttachmentResponses[keyof PostApiOutlookV1ActionsGetEmailAttachmentResponses];

export type PostApiOutlookV1ActionsAddEmailAttachmentData = {
  body: OutlookAddEmailAttachmentParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/add-email-attachment";
};

export type PostApiOutlookV1ActionsAddEmailAttachmentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsAddEmailAttachmentError =
  PostApiOutlookV1ActionsAddEmailAttachmentErrors[keyof PostApiOutlookV1ActionsAddEmailAttachmentErrors];

export type PostApiOutlookV1ActionsAddEmailAttachmentResponses = {
  /**
   * Successful Response
   */
  200: OutlookAddEmailAttachmentResponseV1;
};

export type PostApiOutlookV1ActionsAddEmailAttachmentResponse =
  PostApiOutlookV1ActionsAddEmailAttachmentResponses[keyof PostApiOutlookV1ActionsAddEmailAttachmentResponses];

export type PostApiOutlookV1ActionsRemoveEmailAttachmentData = {
  body: OutlookRemoveEmailAttachmentParamsV1;
  path?: never;
  query?: never;
  url: "/api/outlook/v1/actions/remove-email-attachment";
};

export type PostApiOutlookV1ActionsRemoveEmailAttachmentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV1ActionsRemoveEmailAttachmentError =
  PostApiOutlookV1ActionsRemoveEmailAttachmentErrors[keyof PostApiOutlookV1ActionsRemoveEmailAttachmentErrors];

export type PostApiOutlookV1ActionsRemoveEmailAttachmentResponses = {
  /**
   * Successful Response
   */
  200: OutlookRemoveEmailAttachmentResponseV1;
};

export type PostApiOutlookV1ActionsRemoveEmailAttachmentResponse =
  PostApiOutlookV1ActionsRemoveEmailAttachmentResponses[keyof PostApiOutlookV1ActionsRemoveEmailAttachmentResponses];

export type GetApiOutlookV2SubscriptionsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
    /**
     * User Id
     *
     * Filter by Microsoft user ID
     */
    user_id?: string | null;
  };
  url: "/api/outlook/v2/subscriptions";
};

export type GetApiOutlookV2SubscriptionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiOutlookV2SubscriptionsError =
  GetApiOutlookV2SubscriptionsErrors[keyof GetApiOutlookV2SubscriptionsErrors];

export type GetApiOutlookV2SubscriptionsResponses = {
  /**
   * Successful Response
   */
  200: PageV1OutlookSubscriptionV1;
};

export type GetApiOutlookV2SubscriptionsResponse =
  GetApiOutlookV2SubscriptionsResponses[keyof GetApiOutlookV2SubscriptionsResponses];

export type PostApiOutlookV2SubscriptionsData = {
  body: CreateOutlookSubscriptionsParamsV2;
  path?: never;
  query?: never;
  url: "/api/outlook/v2/subscriptions";
};

export type PostApiOutlookV2SubscriptionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiOutlookV2SubscriptionsError =
  PostApiOutlookV2SubscriptionsErrors[keyof PostApiOutlookV2SubscriptionsErrors];

export type PostApiOutlookV2SubscriptionsResponses = {
  /**
   * Successful Response
   */
  200: CreateOutlookSubscriptionsResponseV2;
};

export type PostApiOutlookV2SubscriptionsResponse =
  PostApiOutlookV2SubscriptionsResponses[keyof PostApiOutlookV2SubscriptionsResponses];

export type DeleteApiOutlookV2SubscriptionsBySubscriptionIdData = {
  body?: never;
  path: {
    /**
     * Subscription Id
     *
     * Microsoft Graph subscription ID
     */
    subscription_id: string;
  };
  query?: never;
  url: "/api/outlook/v2/subscriptions/{subscription_id}";
};

export type DeleteApiOutlookV2SubscriptionsBySubscriptionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiOutlookV2SubscriptionsBySubscriptionIdError =
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdErrors[keyof DeleteApiOutlookV2SubscriptionsBySubscriptionIdErrors];

export type DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponses = {
  /**
   * Successful Response
   */
  200: DeleteSubscriptionResponseV2;
};

export type DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponse =
  DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponses[keyof DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponses];

export type PostApiV1PipelinesExtractDataDumpConversationsInputData = {
  body: ExtractDataDumpConversationsInputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-data-dump-conversations/input";
};

export type PostApiV1PipelinesExtractDataDumpConversationsInputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractDataDumpConversationsInputError =
  PostApiV1PipelinesExtractDataDumpConversationsInputErrors[keyof PostApiV1PipelinesExtractDataDumpConversationsInputErrors];

export type PostApiV1PipelinesExtractDataDumpConversationsInputResponses = {
  /**
   * Successful Response
   */
  200: ExtractDataDumpConversationsInputResponseV1;
};

export type PostApiV1PipelinesExtractDataDumpConversationsInputResponse =
  PostApiV1PipelinesExtractDataDumpConversationsInputResponses[keyof PostApiV1PipelinesExtractDataDumpConversationsInputResponses];

export type PostApiV1PipelinesExtractDataDumpConversationsOutputData = {
  body: ExtractDataDumpConversationsOutputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-data-dump-conversations/output";
};

export type PostApiV1PipelinesExtractDataDumpConversationsOutputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractDataDumpConversationsOutputError =
  PostApiV1PipelinesExtractDataDumpConversationsOutputErrors[keyof PostApiV1PipelinesExtractDataDumpConversationsOutputErrors];

export type PostApiV1PipelinesExtractDataDumpConversationsOutputResponses = {
  /**
   * Successful Response
   */
  200: ExtractDataDumpConversationsOutputResponseV1;
};

export type PostApiV1PipelinesExtractDataDumpConversationsOutputResponse =
  PostApiV1PipelinesExtractDataDumpConversationsOutputResponses[keyof PostApiV1PipelinesExtractDataDumpConversationsOutputResponses];

export type PostApiV1PipelinesExtractDataDumpConversationsEnqueueData = {
  body: ExtractDataDumpConversationsEnqueueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-data-dump-conversations/enqueue";
};

export type PostApiV1PipelinesExtractDataDumpConversationsEnqueueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractDataDumpConversationsEnqueueError =
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueErrors[keyof PostApiV1PipelinesExtractDataDumpConversationsEnqueueErrors];

export type PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponses = {
  /**
   * Successful Response
   */
  200: ExtractDataDumpConversationsEnqueueResponseV1;
};

export type PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponse =
  PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponses[keyof PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponses];

export type PostApiV1PipelinesExtractDataDumpConversationsDequeueData = {
  body: ExtractDataDumpConversationsDequeueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-data-dump-conversations/dequeue";
};

export type PostApiV1PipelinesExtractDataDumpConversationsDequeueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractDataDumpConversationsDequeueError =
  PostApiV1PipelinesExtractDataDumpConversationsDequeueErrors[keyof PostApiV1PipelinesExtractDataDumpConversationsDequeueErrors];

export type PostApiV1PipelinesExtractDataDumpConversationsDequeueResponses = {
  /**
   * Successful Response
   */
  200: ExtractDataDumpConversationsDequeueResponseV1;
};

export type PostApiV1PipelinesExtractDataDumpConversationsDequeueResponse =
  PostApiV1PipelinesExtractDataDumpConversationsDequeueResponses[keyof PostApiV1PipelinesExtractDataDumpConversationsDequeueResponses];

export type PostApiV1PipelinesExtractDatapointsInputData = {
  body: ExtractDatapointsInputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-datapoints/input";
};

export type PostApiV1PipelinesExtractDatapointsInputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractDatapointsInputError =
  PostApiV1PipelinesExtractDatapointsInputErrors[keyof PostApiV1PipelinesExtractDatapointsInputErrors];

export type PostApiV1PipelinesExtractDatapointsInputResponses = {
  /**
   * Successful Response
   */
  200: ExtractDatapointsInputResponseV1;
};

export type PostApiV1PipelinesExtractDatapointsInputResponse =
  PostApiV1PipelinesExtractDatapointsInputResponses[keyof PostApiV1PipelinesExtractDatapointsInputResponses];

export type PostApiV1PipelinesExtractDatapointsOutputData = {
  body: ExtractDatapointsOutputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-datapoints/output";
};

export type PostApiV1PipelinesExtractDatapointsOutputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractDatapointsOutputError =
  PostApiV1PipelinesExtractDatapointsOutputErrors[keyof PostApiV1PipelinesExtractDatapointsOutputErrors];

export type PostApiV1PipelinesExtractDatapointsOutputResponses = {
  /**
   * Successful Response
   */
  200: ExtractDatapointsOutputResponseV1;
};

export type PostApiV1PipelinesExtractDatapointsOutputResponse =
  PostApiV1PipelinesExtractDatapointsOutputResponses[keyof PostApiV1PipelinesExtractDatapointsOutputResponses];

export type PostApiV1PipelinesExtractDatapointsEnqueueData = {
  body: ExtractDatapointsEnqueueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-datapoints/enqueue";
};

export type PostApiV1PipelinesExtractDatapointsEnqueueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractDatapointsEnqueueError =
  PostApiV1PipelinesExtractDatapointsEnqueueErrors[keyof PostApiV1PipelinesExtractDatapointsEnqueueErrors];

export type PostApiV1PipelinesExtractDatapointsEnqueueResponses = {
  /**
   * Successful Response
   */
  200: ExtractDatapointsEnqueueResponseV1;
};

export type PostApiV1PipelinesExtractDatapointsEnqueueResponse =
  PostApiV1PipelinesExtractDatapointsEnqueueResponses[keyof PostApiV1PipelinesExtractDatapointsEnqueueResponses];

export type PostApiV1PipelinesExtractDatapointsDequeueData = {
  body: ExtractDatapointsDequeueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-datapoints/dequeue";
};

export type PostApiV1PipelinesExtractDatapointsDequeueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractDatapointsDequeueError =
  PostApiV1PipelinesExtractDatapointsDequeueErrors[keyof PostApiV1PipelinesExtractDatapointsDequeueErrors];

export type PostApiV1PipelinesExtractDatapointsDequeueResponses = {
  /**
   * Successful Response
   */
  200: ExtractDatapointsDequeueResponseV1;
};

export type PostApiV1PipelinesExtractDatapointsDequeueResponse =
  PostApiV1PipelinesExtractDatapointsDequeueResponses[keyof PostApiV1PipelinesExtractDatapointsDequeueResponses];

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputData = {
  body: ExtractIncomingKnowledgeBasesInputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-incoming-knowledge-bases/input";
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputError =
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputErrors[keyof PostApiV1PipelinesExtractIncomingKnowledgeBasesInputErrors];

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponses = {
  /**
   * Successful Response
   */
  200: ExtractIncomingKnowledgeBasesInputResponseV1;
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponse =
  PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponses[keyof PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponses];

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputData = {
  body: ExtractIncomingKnowledgeBasesOutputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-incoming-knowledge-bases/output";
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputError =
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputErrors[keyof PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputErrors];

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponses = {
  /**
   * Successful Response
   */
  200: ExtractIncomingKnowledgeBasesOutputResponseV1;
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponse =
  PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponses[keyof PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponses];

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueData = {
  body: ExtractIncomingKnowledgeBasesEnqueueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-incoming-knowledge-bases/enqueue";
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueError =
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueErrors[keyof PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueErrors];

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponses = {
  /**
   * Successful Response
   */
  200: ExtractIncomingKnowledgeBasesEnqueueResponseV1;
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponse =
  PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponses[keyof PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponses];

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueData = {
  body: ExtractIncomingKnowledgeBasesDequeueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/extract-incoming-knowledge-bases/dequeue";
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueError =
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueErrors[keyof PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueErrors];

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponses = {
  /**
   * Successful Response
   */
  200: ExtractIncomingKnowledgeBasesDequeueResponseV1;
};

export type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponse =
  PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponses[keyof PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponses];

export type PostApiV1PipelinesFinalizeConversationsInputData = {
  body: FinalizeConversationsInputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/finalize-conversations/input";
};

export type PostApiV1PipelinesFinalizeConversationsInputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesFinalizeConversationsInputError =
  PostApiV1PipelinesFinalizeConversationsInputErrors[keyof PostApiV1PipelinesFinalizeConversationsInputErrors];

export type PostApiV1PipelinesFinalizeConversationsInputResponses = {
  /**
   * Successful Response
   */
  200: FinalizeConversationsInputResponseV1;
};

export type PostApiV1PipelinesFinalizeConversationsInputResponse =
  PostApiV1PipelinesFinalizeConversationsInputResponses[keyof PostApiV1PipelinesFinalizeConversationsInputResponses];

export type PostApiV1PipelinesFinalizeConversationsOutputData = {
  body: FinalizeConversationsOutputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/finalize-conversations/output";
};

export type PostApiV1PipelinesFinalizeConversationsOutputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesFinalizeConversationsOutputError =
  PostApiV1PipelinesFinalizeConversationsOutputErrors[keyof PostApiV1PipelinesFinalizeConversationsOutputErrors];

export type PostApiV1PipelinesFinalizeConversationsOutputResponses = {
  /**
   * Successful Response
   */
  200: FinalizeConversationsOutputResponseV1;
};

export type PostApiV1PipelinesFinalizeConversationsOutputResponse =
  PostApiV1PipelinesFinalizeConversationsOutputResponses[keyof PostApiV1PipelinesFinalizeConversationsOutputResponses];

export type PostApiV1PipelinesFinalizeConversationsEnqueueData = {
  body: FinalizeConversationsEnqueueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/finalize-conversations/enqueue";
};

export type PostApiV1PipelinesFinalizeConversationsEnqueueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesFinalizeConversationsEnqueueError =
  PostApiV1PipelinesFinalizeConversationsEnqueueErrors[keyof PostApiV1PipelinesFinalizeConversationsEnqueueErrors];

export type PostApiV1PipelinesFinalizeConversationsEnqueueResponses = {
  /**
   * Successful Response
   */
  200: FinalizeConversationsEnqueueResponseV1;
};

export type PostApiV1PipelinesFinalizeConversationsEnqueueResponse =
  PostApiV1PipelinesFinalizeConversationsEnqueueResponses[keyof PostApiV1PipelinesFinalizeConversationsEnqueueResponses];

export type PostApiV1PipelinesFinalizeConversationsDequeueData = {
  body: FinalizeConversationsDequeueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/finalize-conversations/dequeue";
};

export type PostApiV1PipelinesFinalizeConversationsDequeueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesFinalizeConversationsDequeueError =
  PostApiV1PipelinesFinalizeConversationsDequeueErrors[keyof PostApiV1PipelinesFinalizeConversationsDequeueErrors];

export type PostApiV1PipelinesFinalizeConversationsDequeueResponses = {
  /**
   * Successful Response
   */
  200: FinalizeConversationsDequeueResponseV1;
};

export type PostApiV1PipelinesFinalizeConversationsDequeueResponse =
  PostApiV1PipelinesFinalizeConversationsDequeueResponses[keyof PostApiV1PipelinesFinalizeConversationsDequeueResponses];

export type PostApiV1PipelinesKanonicalizeDatapointsInputData = {
  body: KanonicalizeDatapointsInputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/kanonicalize-datapoints/input";
};

export type PostApiV1PipelinesKanonicalizeDatapointsInputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesKanonicalizeDatapointsInputError =
  PostApiV1PipelinesKanonicalizeDatapointsInputErrors[keyof PostApiV1PipelinesKanonicalizeDatapointsInputErrors];

export type PostApiV1PipelinesKanonicalizeDatapointsInputResponses = {
  /**
   * Successful Response
   */
  200: KanonicalizeDatapointsInputResponseV1;
};

export type PostApiV1PipelinesKanonicalizeDatapointsInputResponse =
  PostApiV1PipelinesKanonicalizeDatapointsInputResponses[keyof PostApiV1PipelinesKanonicalizeDatapointsInputResponses];

export type PostApiV1PipelinesKanonicalizeDatapointsOutputData = {
  body: KanonicalizeDatapointsOutputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/kanonicalize-datapoints/output";
};

export type PostApiV1PipelinesKanonicalizeDatapointsOutputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesKanonicalizeDatapointsOutputError =
  PostApiV1PipelinesKanonicalizeDatapointsOutputErrors[keyof PostApiV1PipelinesKanonicalizeDatapointsOutputErrors];

export type PostApiV1PipelinesKanonicalizeDatapointsOutputResponses = {
  /**
   * Successful Response
   */
  200: KanonicalizeDatapointsOutputResponseV1;
};

export type PostApiV1PipelinesKanonicalizeDatapointsOutputResponse =
  PostApiV1PipelinesKanonicalizeDatapointsOutputResponses[keyof PostApiV1PipelinesKanonicalizeDatapointsOutputResponses];

export type PostApiV1PipelinesKanonicalizeDatapointsEnqueueData = {
  body: KanonicalizeDatapointsEnqueueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/kanonicalize-datapoints/enqueue";
};

export type PostApiV1PipelinesKanonicalizeDatapointsEnqueueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesKanonicalizeDatapointsEnqueueError =
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueErrors[keyof PostApiV1PipelinesKanonicalizeDatapointsEnqueueErrors];

export type PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponses = {
  /**
   * Successful Response
   */
  200: KanonicalizeDatapointsEnqueueResponseV1;
};

export type PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponse =
  PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponses[keyof PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponses];

export type PostApiV1PipelinesKanonicalizeDatapointsDequeueData = {
  body: KanonicalizeDatapointsDequeueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/kanonicalize-datapoints/dequeue";
};

export type PostApiV1PipelinesKanonicalizeDatapointsDequeueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesKanonicalizeDatapointsDequeueError =
  PostApiV1PipelinesKanonicalizeDatapointsDequeueErrors[keyof PostApiV1PipelinesKanonicalizeDatapointsDequeueErrors];

export type PostApiV1PipelinesKanonicalizeDatapointsDequeueResponses = {
  /**
   * Successful Response
   */
  200: KanonicalizeDatapointsDequeueResponseV1;
};

export type PostApiV1PipelinesKanonicalizeDatapointsDequeueResponse =
  PostApiV1PipelinesKanonicalizeDatapointsDequeueResponses[keyof PostApiV1PipelinesKanonicalizeDatapointsDequeueResponses];

export type PostApiV1PipelinesCreateInferenceDatapointsInputData = {
  body: CreateInferenceDatapointsInputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/create-inference-datapoints/input";
};

export type PostApiV1PipelinesCreateInferenceDatapointsInputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesCreateInferenceDatapointsInputError =
  PostApiV1PipelinesCreateInferenceDatapointsInputErrors[keyof PostApiV1PipelinesCreateInferenceDatapointsInputErrors];

export type PostApiV1PipelinesCreateInferenceDatapointsInputResponses = {
  /**
   * Successful Response
   */
  200: CreateInferenceDatapointsInputResponseV1;
};

export type PostApiV1PipelinesCreateInferenceDatapointsInputResponse =
  PostApiV1PipelinesCreateInferenceDatapointsInputResponses[keyof PostApiV1PipelinesCreateInferenceDatapointsInputResponses];

export type PostApiV1PipelinesCreateInferenceDatapointsOutputData = {
  body: CreateInferenceDatapointsOutputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/create-inference-datapoints/output";
};

export type PostApiV1PipelinesCreateInferenceDatapointsOutputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesCreateInferenceDatapointsOutputError =
  PostApiV1PipelinesCreateInferenceDatapointsOutputErrors[keyof PostApiV1PipelinesCreateInferenceDatapointsOutputErrors];

export type PostApiV1PipelinesCreateInferenceDatapointsOutputResponses = {
  /**
   * Successful Response
   */
  200: CreateInferenceDatapointsOutputResponseV1;
};

export type PostApiV1PipelinesCreateInferenceDatapointsOutputResponse =
  PostApiV1PipelinesCreateInferenceDatapointsOutputResponses[keyof PostApiV1PipelinesCreateInferenceDatapointsOutputResponses];

export type PostApiV1PipelinesCreateInferenceDatapointsEnqueueData = {
  body: CreateInferenceDatapointsEnqueueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/create-inference-datapoints/enqueue";
};

export type PostApiV1PipelinesCreateInferenceDatapointsEnqueueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesCreateInferenceDatapointsEnqueueError =
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueErrors[keyof PostApiV1PipelinesCreateInferenceDatapointsEnqueueErrors];

export type PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponses = {
  /**
   * Successful Response
   */
  200: CreateInferenceDatapointsEnqueueResponseV1;
};

export type PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponse =
  PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponses[keyof PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponses];

export type PostApiV1PipelinesCreateInferenceDatapointsDequeueData = {
  body: CreateInferenceDatapointsDequeueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/create-inference-datapoints/dequeue";
};

export type PostApiV1PipelinesCreateInferenceDatapointsDequeueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesCreateInferenceDatapointsDequeueError =
  PostApiV1PipelinesCreateInferenceDatapointsDequeueErrors[keyof PostApiV1PipelinesCreateInferenceDatapointsDequeueErrors];

export type PostApiV1PipelinesCreateInferenceDatapointsDequeueResponses = {
  /**
   * Successful Response
   */
  200: CreateInferenceDatapointsDequeueResponseV1;
};

export type PostApiV1PipelinesCreateInferenceDatapointsDequeueResponse =
  PostApiV1PipelinesCreateInferenceDatapointsDequeueResponses[keyof PostApiV1PipelinesCreateInferenceDatapointsDequeueResponses];

export type PostApiV1PipelinesCreateProdEvalsInputData = {
  body: CreateProdEvalsInputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/create-prod-evals/input";
};

export type PostApiV1PipelinesCreateProdEvalsInputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesCreateProdEvalsInputError =
  PostApiV1PipelinesCreateProdEvalsInputErrors[keyof PostApiV1PipelinesCreateProdEvalsInputErrors];

export type PostApiV1PipelinesCreateProdEvalsInputResponses = {
  /**
   * Successful Response
   */
  200: CreateProdEvalsInputResponseV1;
};

export type PostApiV1PipelinesCreateProdEvalsInputResponse =
  PostApiV1PipelinesCreateProdEvalsInputResponses[keyof PostApiV1PipelinesCreateProdEvalsInputResponses];

export type PostApiV1PipelinesCreateProdEvalsOutputData = {
  body: CreateProdEvalsOutputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/create-prod-evals/output";
};

export type PostApiV1PipelinesCreateProdEvalsOutputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesCreateProdEvalsOutputError =
  PostApiV1PipelinesCreateProdEvalsOutputErrors[keyof PostApiV1PipelinesCreateProdEvalsOutputErrors];

export type PostApiV1PipelinesCreateProdEvalsOutputResponses = {
  /**
   * Successful Response
   */
  200: CreateProdEvalsOutputResponseV1;
};

export type PostApiV1PipelinesCreateProdEvalsOutputResponse =
  PostApiV1PipelinesCreateProdEvalsOutputResponses[keyof PostApiV1PipelinesCreateProdEvalsOutputResponses];

export type PostApiV1PipelinesCreateProdEvalsEnqueueData = {
  body: CreateProdEvalsEnqueueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/create-prod-evals/enqueue";
};

export type PostApiV1PipelinesCreateProdEvalsEnqueueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesCreateProdEvalsEnqueueError =
  PostApiV1PipelinesCreateProdEvalsEnqueueErrors[keyof PostApiV1PipelinesCreateProdEvalsEnqueueErrors];

export type PostApiV1PipelinesCreateProdEvalsEnqueueResponses = {
  /**
   * Successful Response
   */
  200: CreateProdEvalsEnqueueResponseV1;
};

export type PostApiV1PipelinesCreateProdEvalsEnqueueResponse =
  PostApiV1PipelinesCreateProdEvalsEnqueueResponses[keyof PostApiV1PipelinesCreateProdEvalsEnqueueResponses];

export type PostApiV1PipelinesCreateProdEvalsDequeueData = {
  body: CreateProdEvalsDequeueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/create-prod-evals/dequeue";
};

export type PostApiV1PipelinesCreateProdEvalsDequeueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesCreateProdEvalsDequeueError =
  PostApiV1PipelinesCreateProdEvalsDequeueErrors[keyof PostApiV1PipelinesCreateProdEvalsDequeueErrors];

export type PostApiV1PipelinesCreateProdEvalsDequeueResponses = {
  /**
   * Successful Response
   */
  200: CreateProdEvalsDequeueResponseV1;
};

export type PostApiV1PipelinesCreateProdEvalsDequeueResponse =
  PostApiV1PipelinesCreateProdEvalsDequeueResponses[keyof PostApiV1PipelinesCreateProdEvalsDequeueResponses];

export type PostApiV1PipelinesFinetuneKnowledgeBasesInputData = {
  body: FinetuneKnowledgeBasesInputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/finetune-knowledge-bases/input";
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesInputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesInputError =
  PostApiV1PipelinesFinetuneKnowledgeBasesInputErrors[keyof PostApiV1PipelinesFinetuneKnowledgeBasesInputErrors];

export type PostApiV1PipelinesFinetuneKnowledgeBasesInputResponses = {
  /**
   * Successful Response
   */
  200: FinetuneKnowledgeBasesInputResponseV1;
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesInputResponse =
  PostApiV1PipelinesFinetuneKnowledgeBasesInputResponses[keyof PostApiV1PipelinesFinetuneKnowledgeBasesInputResponses];

export type PostApiV1PipelinesFinetuneKnowledgeBasesOutputData = {
  body: FinetuneKnowledgeBasesOutputRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/finetune-knowledge-bases/output";
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesOutputErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesOutputError =
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputErrors[keyof PostApiV1PipelinesFinetuneKnowledgeBasesOutputErrors];

export type PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponses = {
  /**
   * Successful Response
   */
  200: FinetuneKnowledgeBasesOutputResponseV1;
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponse =
  PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponses[keyof PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponses];

export type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueData = {
  body: FinetuneKnowledgeBasesEnqueueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/finetune-knowledge-bases/enqueue";
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueError =
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueErrors[keyof PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueErrors];

export type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponses = {
  /**
   * Successful Response
   */
  200: FinetuneKnowledgeBasesEnqueueResponseV1;
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponse =
  PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponses[keyof PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponses];

export type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueData = {
  body: FinetuneKnowledgeBasesDequeueRequestV1;
  path?: never;
  query?: never;
  url: "/api/v1/pipelines/finetune-knowledge-bases/dequeue";
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueError =
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueErrors[keyof PostApiV1PipelinesFinetuneKnowledgeBasesDequeueErrors];

export type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponses = {
  /**
   * Successful Response
   */
  200: FinetuneKnowledgeBasesDequeueResponseV1;
};

export type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponse =
  PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponses[keyof PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponses];

export type GetApiPlainV1TenantsByTenantIdActionsThreadsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/plain/v1/tenants/{tenant_id}/actions/threads";
};

export type GetApiPlainV1TenantsByTenantIdActionsThreadsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdActionsThreadsError =
  GetApiPlainV1TenantsByTenantIdActionsThreadsErrors[keyof GetApiPlainV1TenantsByTenantIdActionsThreadsErrors];

export type GetApiPlainV1TenantsByTenantIdActionsThreadsResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1PlainThreadV1;
};

export type GetApiPlainV1TenantsByTenantIdActionsThreadsResponse =
  GetApiPlainV1TenantsByTenantIdActionsThreadsResponses[keyof GetApiPlainV1TenantsByTenantIdActionsThreadsResponses];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsData = {
  body: PlainCreateThreadParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/threads";
};

export type PostApiPlainV1TenantsByTenantIdActionsThreadsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPlainV1TenantsByTenantIdActionsThreadsError =
  PostApiPlainV1TenantsByTenantIdActionsThreadsErrors[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsErrors];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsResponses = {
  /**
   * Successful Response
   */
  200: PlainThreadV1;
};

export type PostApiPlainV1TenantsByTenantIdActionsThreadsResponse =
  PostApiPlainV1TenantsByTenantIdActionsThreadsResponses[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsResponses];

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdData = {
  body?: never;
  path: {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}";
};

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdError =
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdErrors[keyof GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdErrors];

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponses = {
  /**
   * Successful Response
   */
  200: PlainThreadFullV1;
};

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponse =
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponses[keyof GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponses];

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineData =
  {
    body?: never;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: {
      /**
       * After Cursor
       */
      after_cursor?: string | null;
      /**
       * Limit
       */
      limit?: number;
    };
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/timeline";
  };

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineError =
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineErrors[keyof GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineErrors];

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponses =
  {
    /**
     * Successful Response
     */
    200: CursorPageV1PlainTimelineEntryV1;
  };

export type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponse =
  GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponses[keyof GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponses];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoData = {
  body?: never;
  path: {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/todo";
};

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoError =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoErrors[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoErrors];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponse =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponses[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponses];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeData =
  {
    body: PlainSnoozeThreadParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/snooze";
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeError =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeErrors[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeErrors];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponse =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponses[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponses];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneData = {
  body?: never;
  path: {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/done";
};

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneError =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneErrors[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneErrors];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponse =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponses[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponses];

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityData =
  {
    body: PlainChangeThreadPriorityParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/priority";
  };

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityError =
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityErrors[keyof PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityErrors];

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponse =
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponses[keyof PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponses];

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusData =
  {
    body: PlainUpdateThreadAgentStatusParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/agent-status";
  };

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusError =
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusErrors[keyof PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusErrors];

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponse =
  PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponses[keyof PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponses];

export type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData =
  {
    body?: never;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/assignee";
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError =
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors[keyof DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors];

export type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse =
  DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses[keyof DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses];

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData =
  {
    body: PlainAssignThreadParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/assignee";
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError =
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors[keyof PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors];

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse =
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses[keyof PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses];

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfData =
  {
    body?: never;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/assignee/self";
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfError =
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfErrors[keyof PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfErrors];

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponse =
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponses[keyof PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponses];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsData =
  {
    body: PlainAddThreadLabelsParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/labels";
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsError =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsErrors[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsErrors];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponse =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponses[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponses];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteData =
  {
    body: PlainRemoveThreadLabelsParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/labels/delete";
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteError =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteErrors[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteErrors];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponse =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponses[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponses];

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyData =
  {
    body: PlainUpsertThreadFieldParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Key
       */
      key: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/fields/{key}";
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyError =
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyErrors[keyof PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyErrors];

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponses =
  {
    /**
     * Successful Response
     */
    200: PlainThreadV1;
  };

export type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponse =
  PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponses[keyof PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponses];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesData =
  {
    body: PlainSendMessageParamsV1;
    path: {
      /**
       * Thread Id
       */
      thread_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/messages";
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesError =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesErrors[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesErrors];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponses =
  {
    /**
     * Successful Response
     */
    204: void;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponse =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponses[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponses];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesData = {
  body: PlainCreateNoteParamsV1;
  path: {
    /**
     * Thread Id
     */
    thread_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/threads/{thread_id}/notes";
};

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesError =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesErrors[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesErrors];

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponses =
  {
    /**
     * Successful Response
     */
    200: PlainNoteV1;
  };

export type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponse =
  PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponses[keyof PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponses];

export type GetApiPlainV1TenantsByTenantIdActionsCustomersData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/plain/v1/tenants/{tenant_id}/actions/customers";
};

export type GetApiPlainV1TenantsByTenantIdActionsCustomersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdActionsCustomersError =
  GetApiPlainV1TenantsByTenantIdActionsCustomersErrors[keyof GetApiPlainV1TenantsByTenantIdActionsCustomersErrors];

export type GetApiPlainV1TenantsByTenantIdActionsCustomersResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1PlainCustomerV1;
};

export type GetApiPlainV1TenantsByTenantIdActionsCustomersResponse =
  GetApiPlainV1TenantsByTenantIdActionsCustomersResponses[keyof GetApiPlainV1TenantsByTenantIdActionsCustomersResponses];

export type PutApiPlainV1TenantsByTenantIdActionsCustomersData = {
  body: PlainUpsertCustomerParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/customers";
};

export type PutApiPlainV1TenantsByTenantIdActionsCustomersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiPlainV1TenantsByTenantIdActionsCustomersError =
  PutApiPlainV1TenantsByTenantIdActionsCustomersErrors[keyof PutApiPlainV1TenantsByTenantIdActionsCustomersErrors];

export type PutApiPlainV1TenantsByTenantIdActionsCustomersResponses = {
  /**
   * Successful Response
   */
  200: PlainCustomerV1;
};

export type PutApiPlainV1TenantsByTenantIdActionsCustomersResponse =
  PutApiPlainV1TenantsByTenantIdActionsCustomersResponses[keyof PutApiPlainV1TenantsByTenantIdActionsCustomersResponses];

export type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData =
  {
    body?: never;
    path: {
      /**
       * Customer Id
       */
      customer_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}";
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError =
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors[keyof DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors];

export type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses =
  {
    /**
     * Successful Response
     */
    204: void;
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse =
  DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses[keyof DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses];

export type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData = {
  body?: never;
  path: {
    /**
     * Customer Id
     */
    customer_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}";
};

export type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError =
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors[keyof GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors];

export type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses =
  {
    /**
     * Successful Response
     */
    200: PlainCustomerV1;
  };

export type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse =
  GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses[keyof GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses];

export type GetApiPlainV1TenantsByTenantIdActionsCompaniesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/plain/v1/tenants/{tenant_id}/actions/companies";
};

export type GetApiPlainV1TenantsByTenantIdActionsCompaniesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdActionsCompaniesError =
  GetApiPlainV1TenantsByTenantIdActionsCompaniesErrors[keyof GetApiPlainV1TenantsByTenantIdActionsCompaniesErrors];

export type GetApiPlainV1TenantsByTenantIdActionsCompaniesResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1PlainCompanyV1;
};

export type GetApiPlainV1TenantsByTenantIdActionsCompaniesResponse =
  GetApiPlainV1TenantsByTenantIdActionsCompaniesResponses[keyof GetApiPlainV1TenantsByTenantIdActionsCompaniesResponses];

export type PutApiPlainV1TenantsByTenantIdActionsCompaniesData = {
  body: PlainUpsertCompanyParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/companies";
};

export type PutApiPlainV1TenantsByTenantIdActionsCompaniesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiPlainV1TenantsByTenantIdActionsCompaniesError =
  PutApiPlainV1TenantsByTenantIdActionsCompaniesErrors[keyof PutApiPlainV1TenantsByTenantIdActionsCompaniesErrors];

export type PutApiPlainV1TenantsByTenantIdActionsCompaniesResponses = {
  /**
   * Successful Response
   */
  200: PlainCompanyV1;
};

export type PutApiPlainV1TenantsByTenantIdActionsCompaniesResponse =
  PutApiPlainV1TenantsByTenantIdActionsCompaniesResponses[keyof PutApiPlainV1TenantsByTenantIdActionsCompaniesResponses];

export type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyData =
  {
    body: PlainSetCustomerCompanyParamsV1;
    path: {
      /**
       * Customer Id
       */
      customer_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}/company";
  };

export type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyError =
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyErrors[keyof PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyErrors];

export type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponses =
  {
    /**
     * Successful Response
     */
    200: PlainCustomerV1;
  };

export type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponse =
  PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponses[keyof PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponses];

export type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/plain/v1/tenants/{tenant_id}/actions/customer-groups";
};

export type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsError =
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsErrors[keyof GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsErrors];

export type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1PlainCustomerGroupV1;
};

export type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponse =
  GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponses[keyof GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponses];

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsData =
  {
    body: PlainAddCustomerToGroupsParamsV1;
    path: {
      /**
       * Customer Id
       */
      customer_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}/groups";
  };

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsError =
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsErrors[keyof PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsErrors];

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponses =
  {
    /**
     * Successful Response
     */
    204: void;
  };

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponse =
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponses[keyof PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponses];

export type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Limit
     */
    limit?: number;
  };
  url: "/api/plain/v1/tenants/{tenant_id}/actions/plain-tenants";
};

export type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsError =
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors[keyof GetApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors];

export type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1PlainCustomerTenantV1;
};

export type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse =
  GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses[keyof GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses];

export type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsData = {
  body: PlainUpsertPlainTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/actions/plain-tenants";
};

export type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsError =
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors[keyof PutApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors];

export type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses = {
  /**
   * Successful Response
   */
  200: PlainCustomerTenantV1;
};

export type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse =
  PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses[keyof PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses];

export type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdData =
  {
    body?: never;
    path: {
      /**
       * Plain Tenant Id
       */
      plain_tenant_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/plain-tenants/{plain_tenant_id}";
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdError =
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdErrors[keyof DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdErrors];

export type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponses =
  {
    /**
     * Successful Response
     */
    204: void;
  };

export type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponse =
  DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponses[keyof DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponses];

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsData =
  {
    body: PlainAddCustomerToPlainTenantsParamsV1;
    path: {
      /**
       * Customer Id
       */
      customer_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/plain/v1/tenants/{tenant_id}/actions/customers/{customer_id}/plain-tenants";
  };

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsError =
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsErrors[keyof PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsErrors];

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponses =
  {
    /**
     * Successful Response
     */
    200: PlainCustomerV1;
  };

export type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponse =
  PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponses[keyof PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponses];

export type GetApiPlainV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/plain/v1/tenants";
};

export type GetApiPlainV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsError =
  GetApiPlainV1TenantsErrors[keyof GetApiPlainV1TenantsErrors];

export type GetApiPlainV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1PlainTenantV1;
};

export type GetApiPlainV1TenantsResponse =
  GetApiPlainV1TenantsResponses[keyof GetApiPlainV1TenantsResponses];

export type PostApiPlainV1TenantsData = {
  body: CreatePlainTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/plain/v1/tenants";
};

export type PostApiPlainV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPlainV1TenantsError =
  PostApiPlainV1TenantsErrors[keyof PostApiPlainV1TenantsErrors];

export type PostApiPlainV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PlainTenantV1;
};

export type PostApiPlainV1TenantsResponse =
  PostApiPlainV1TenantsResponses[keyof PostApiPlainV1TenantsResponses];

export type GetApiPlainV1FullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/plain/v1/full-tenants";
};

export type GetApiPlainV1FullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1FullTenantsError =
  GetApiPlainV1FullTenantsErrors[keyof GetApiPlainV1FullTenantsErrors];

export type GetApiPlainV1FullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1PlainTenantFullV1;
};

export type GetApiPlainV1FullTenantsResponse =
  GetApiPlainV1FullTenantsResponses[keyof GetApiPlainV1FullTenantsResponses];

export type DeleteApiPlainV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}";
};

export type DeleteApiPlainV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiPlainV1TenantsByTenantIdError =
  DeleteApiPlainV1TenantsByTenantIdErrors[keyof DeleteApiPlainV1TenantsByTenantIdErrors];

export type DeleteApiPlainV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: PlainTenantV1;
};

export type DeleteApiPlainV1TenantsByTenantIdResponse =
  DeleteApiPlainV1TenantsByTenantIdResponses[keyof DeleteApiPlainV1TenantsByTenantIdResponses];

export type GetApiPlainV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}";
};

export type GetApiPlainV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdError =
  GetApiPlainV1TenantsByTenantIdErrors[keyof GetApiPlainV1TenantsByTenantIdErrors];

export type GetApiPlainV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: PlainTenantFullV1;
};

export type GetApiPlainV1TenantsByTenantIdResponse =
  GetApiPlainV1TenantsByTenantIdResponses[keyof GetApiPlainV1TenantsByTenantIdResponses];

export type PatchApiPlainV1TenantsByTenantIdData = {
  body: UpdatePlainTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}";
};

export type PatchApiPlainV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiPlainV1TenantsByTenantIdError =
  PatchApiPlainV1TenantsByTenantIdErrors[keyof PatchApiPlainV1TenantsByTenantIdErrors];

export type PatchApiPlainV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: PlainTenantV1;
};

export type PatchApiPlainV1TenantsByTenantIdResponse =
  PatchApiPlainV1TenantsByTenantIdResponses[keyof PatchApiPlainV1TenantsByTenantIdResponses];

export type GetApiPlainV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/plain/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiPlainV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPlainV1TenantsByTenantIdCheckConnectionError =
  GetApiPlainV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiPlainV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiPlainV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: PlainCheckConnectionResponseV1;
};

export type GetApiPlainV1TenantsByTenantIdCheckConnectionResponse =
  GetApiPlainV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiPlainV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiV1TasksByTaskIdPromptsData = {
  body?: never;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Kind
     */
    kind?: PromptKind | null;
  };
  url: "/api/v1/tasks/{task_id}/prompts";
};

export type GetApiV1TasksByTaskIdPromptsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1TasksByTaskIdPromptsError =
  GetApiV1TasksByTaskIdPromptsErrors[keyof GetApiV1TasksByTaskIdPromptsErrors];

export type GetApiV1TasksByTaskIdPromptsResponses = {
  /**
   * Successful Response
   */
  200: GetPromptsResponseV1;
};

export type GetApiV1TasksByTaskIdPromptsResponse =
  GetApiV1TasksByTaskIdPromptsResponses[keyof GetApiV1TasksByTaskIdPromptsResponses];

export type PostApiV1TasksByTaskIdPromptsData = {
  body: CreatePromptParamsV1;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: never;
  url: "/api/v1/tasks/{task_id}/prompts";
};

export type PostApiV1TasksByTaskIdPromptsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1TasksByTaskIdPromptsError =
  PostApiV1TasksByTaskIdPromptsErrors[keyof PostApiV1TasksByTaskIdPromptsErrors];

export type PostApiV1TasksByTaskIdPromptsResponses = {
  /**
   * Successful Response
   */
  200: PromptV1;
};

export type PostApiV1TasksByTaskIdPromptsResponse =
  PostApiV1TasksByTaskIdPromptsResponses[keyof PostApiV1TasksByTaskIdPromptsResponses];

export type GetApiV1TasksByTaskIdPromptsByPromptIdData = {
  body?: never;
  path: {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Prompt Id
     */
    prompt_id: number;
  };
  query?: never;
  url: "/api/v1/tasks/{task_id}/prompts/{prompt_id}";
};

export type GetApiV1TasksByTaskIdPromptsByPromptIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1TasksByTaskIdPromptsByPromptIdError =
  GetApiV1TasksByTaskIdPromptsByPromptIdErrors[keyof GetApiV1TasksByTaskIdPromptsByPromptIdErrors];

export type GetApiV1TasksByTaskIdPromptsByPromptIdResponses = {
  /**
   * Successful Response
   */
  200: PromptV1;
};

export type GetApiV1TasksByTaskIdPromptsByPromptIdResponse =
  GetApiV1TasksByTaskIdPromptsByPromptIdResponses[keyof GetApiV1TasksByTaskIdPromptsByPromptIdResponses];

export type GetApiV1ReposByRepositoryIdBranchesData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    /**
     * Limit
     */
    limit?: number;
    visibility?: VisibilityV1;
    /**
     * Created By
     */
    created_by?: number | null;
  };
  url: "/api/v1/repos/{repository_id}/branches";
};

export type GetApiV1ReposByRepositoryIdBranchesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdBranchesError =
  GetApiV1ReposByRepositoryIdBranchesErrors[keyof GetApiV1ReposByRepositoryIdBranchesErrors];

export type GetApiV1ReposByRepositoryIdBranchesResponses = {
  /**
   * Successful Response
   */
  200: PageV1GitBranchV2;
};

export type GetApiV1ReposByRepositoryIdBranchesResponse =
  GetApiV1ReposByRepositoryIdBranchesResponses[keyof GetApiV1ReposByRepositoryIdBranchesResponses];

export type PostApiV1ReposByRepositoryIdBranchesData = {
  body: GitBranchCreateParamsV2;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches";
};

export type PostApiV1ReposByRepositoryIdBranchesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ReposByRepositoryIdBranchesError =
  PostApiV1ReposByRepositoryIdBranchesErrors[keyof PostApiV1ReposByRepositoryIdBranchesErrors];

export type PostApiV1ReposByRepositoryIdBranchesResponses = {
  /**
   * Successful Response
   */
  200: GitBranchV2;
};

export type PostApiV1ReposByRepositoryIdBranchesResponse =
  PostApiV1ReposByRepositoryIdBranchesResponses[keyof PostApiV1ReposByRepositoryIdBranchesResponses];

export type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Branch Name
     */
    branch_name: string;
  };
  query: {
    onto_commitish: GitCommitishV1Parse;
  };
  url: "/api/v1/repos/{repository_id}/branches/{branch_name}/rebase-preview";
};

export type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewError =
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewErrors[keyof GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewErrors];

export type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponses =
  {
    /**
     * Successful Response
     */
    200: GitRebasePreviewResultV1;
  };

export type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponse =
  GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponses[keyof GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponses];

export type DeleteApiV1ReposByRepositoryIdBranchesByNameData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Name
     */
    name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{name}";
};

export type DeleteApiV1ReposByRepositoryIdBranchesByNameErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ReposByRepositoryIdBranchesByNameError =
  DeleteApiV1ReposByRepositoryIdBranchesByNameErrors[keyof DeleteApiV1ReposByRepositoryIdBranchesByNameErrors];

export type DeleteApiV1ReposByRepositoryIdBranchesByNameResponses = {
  /**
   * Successful Response
   */
  200: GitBranchV2;
};

export type DeleteApiV1ReposByRepositoryIdBranchesByNameResponse =
  DeleteApiV1ReposByRepositoryIdBranchesByNameResponses[keyof DeleteApiV1ReposByRepositoryIdBranchesByNameResponses];

export type GetApiV1ReposByRepositoryIdBranchesByNameData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Name
     */
    name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{name}";
};

export type GetApiV1ReposByRepositoryIdBranchesByNameErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdBranchesByNameError =
  GetApiV1ReposByRepositoryIdBranchesByNameErrors[keyof GetApiV1ReposByRepositoryIdBranchesByNameErrors];

export type GetApiV1ReposByRepositoryIdBranchesByNameResponses = {
  /**
   * Successful Response
   */
  200: GitBranchV2;
};

export type GetApiV1ReposByRepositoryIdBranchesByNameResponse =
  GetApiV1ReposByRepositoryIdBranchesByNameResponses[keyof GetApiV1ReposByRepositoryIdBranchesByNameResponses];

export type PatchApiV1ReposByRepositoryIdBranchesByNameData = {
  body: GitBranchUpdateParamsV1;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Name
     */
    name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{name}";
};

export type PatchApiV1ReposByRepositoryIdBranchesByNameErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ReposByRepositoryIdBranchesByNameError =
  PatchApiV1ReposByRepositoryIdBranchesByNameErrors[keyof PatchApiV1ReposByRepositoryIdBranchesByNameErrors];

export type PatchApiV1ReposByRepositoryIdBranchesByNameResponses = {
  /**
   * Successful Response
   */
  200: GitBranchV2;
};

export type PatchApiV1ReposByRepositoryIdBranchesByNameResponse =
  PatchApiV1ReposByRepositoryIdBranchesByNameResponses[keyof PatchApiV1ReposByRepositoryIdBranchesByNameResponses];

export type PostApiV1ReposByRepositoryIdBranchesByNameRestoreData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Name
     */
    name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{name}/restore";
};

export type PostApiV1ReposByRepositoryIdBranchesByNameRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ReposByRepositoryIdBranchesByNameRestoreError =
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreErrors[keyof PostApiV1ReposByRepositoryIdBranchesByNameRestoreErrors];

export type PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponses = {
  /**
   * Successful Response
   */
  200: GitBranchV2;
};

export type PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponse =
  PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponses[keyof PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponses];

export type GetApiV1ReposByRepositoryIdCommitsByRefData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    ref: GitCommitishV1Parse;
  };
  query?: {
    /**
     * Article Id
     */
    article_id?: number | null;
    /**
     * Path
     */
    path?: string | null;
    /**
     * Limit
     */
    limit?: number;
    /**
     * Cursor
     */
    cursor?: number | null;
  };
  url: "/api/v1/repos/{repository_id}/commits/{ref}";
};

export type GetApiV1ReposByRepositoryIdCommitsByRefErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdCommitsByRefError =
  GetApiV1ReposByRepositoryIdCommitsByRefErrors[keyof GetApiV1ReposByRepositoryIdCommitsByRefErrors];

export type GetApiV1ReposByRepositoryIdCommitsByRefResponses = {
  /**
   * Successful Response
   */
  200: GitLogV2;
};

export type GetApiV1ReposByRepositoryIdCommitsByRefResponse =
  GetApiV1ReposByRepositoryIdCommitsByRefResponses[keyof GetApiV1ReposByRepositoryIdCommitsByRefResponses];

export type GetApiV1ReposByRepositoryIdCommitByRefData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    ref: GitCommitishV1Parse;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/commit/{ref}";
};

export type GetApiV1ReposByRepositoryIdCommitByRefErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdCommitByRefError =
  GetApiV1ReposByRepositoryIdCommitByRefErrors[keyof GetApiV1ReposByRepositoryIdCommitByRefErrors];

export type GetApiV1ReposByRepositoryIdCommitByRefResponses = {
  /**
   * Successful Response
   */
  200: GitShowV2;
};

export type GetApiV1ReposByRepositoryIdCommitByRefResponse =
  GetApiV1ReposByRepositoryIdCommitByRefResponses[keyof GetApiV1ReposByRepositoryIdCommitByRefResponses];

export type PatchApiV1ReposByRepositoryIdCommitByCommitIdData = {
  body: PatchCommitRequestV1;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Commit Id
     */
    commit_id: number;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/commit/{commit_id}";
};

export type PatchApiV1ReposByRepositoryIdCommitByCommitIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ReposByRepositoryIdCommitByCommitIdError =
  PatchApiV1ReposByRepositoryIdCommitByCommitIdErrors[keyof PatchApiV1ReposByRepositoryIdCommitByCommitIdErrors];

export type PatchApiV1ReposByRepositoryIdCommitByCommitIdResponses = {
  /**
   * Successful Response
   */
  200: GitCommitV2;
};

export type PatchApiV1ReposByRepositoryIdCommitByCommitIdResponse =
  PatchApiV1ReposByRepositoryIdCommitByCommitIdResponses[keyof PatchApiV1ReposByRepositoryIdCommitByCommitIdResponses];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitData = {
  body: GitCommitParamsV2;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Branch Name
     */
    branch_name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{branch_name}/commit";
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitError =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitErrors[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitErrors];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponses = {
  /**
   * Successful Response
   */
  200: GitCommitV2;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponse =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponses[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponses];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendData = {
  body: GitAmendParamsV1;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Branch Name
     */
    branch_name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{branch_name}/amend";
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendError =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendErrors[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendErrors];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponses = {
  /**
   * Successful Response
   */
  200: GitCommitV2;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponse =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponses[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponses];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeData = {
  body: GitMergeV2;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Branch Name
     */
    branch_name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{branch_name}/merge";
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeError =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeErrors[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeErrors];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponses = {
  /**
   * Successful Response
   */
  200: GitBranchV2;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponse =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponses[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponses];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseData = {
  body: GitRebaseV2;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Branch Name
     */
    branch_name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{branch_name}/rebase";
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseErrors = {
  /**
   * Conflict
   */
  409: GitRebaseConflictErrorV1;
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseError =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseErrors[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseErrors];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponses = {
  /**
   * Successful Response
   */
  200: GitBranchV2;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponse =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponses[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponses];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickData = {
  body: GitCherryPickParamsV1;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Branch Name
     */
    branch_name: string;
  };
  query?: never;
  url: "/api/v1/repos/{repository_id}/branches/{branch_name}/cherry-pick";
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickErrors = {
  /**
   * Conflict
   */
  409: GitCherryPickErrorV1;
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickError =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickErrors[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickErrors];

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponses =
  {
    /**
     * Successful Response
     */
    200: GitCommitV2;
  };

export type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponse =
  PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponses[keyof PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponses];

export type GetApiV1ReposByRepositoryIdCompareByBaseheadData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Basehead
     */
    basehead: string;
  };
  query?: {
    /**
     * Context
     */
    context?: number;
  };
  url: "/api/v1/repos/{repository_id}/compare/{basehead}";
};

export type GetApiV1ReposByRepositoryIdCompareByBaseheadErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdCompareByBaseheadError =
  GetApiV1ReposByRepositoryIdCompareByBaseheadErrors[keyof GetApiV1ReposByRepositoryIdCompareByBaseheadErrors];

export type GetApiV1ReposByRepositoryIdCompareByBaseheadResponses = {
  /**
   * Successful Response
   */
  200: GitDiffResponseV2;
};

export type GetApiV1ReposByRepositoryIdCompareByBaseheadResponse =
  GetApiV1ReposByRepositoryIdCompareByBaseheadResponses[keyof GetApiV1ReposByRepositoryIdCompareByBaseheadResponses];

export type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    /**
     * Basehead
     */
    basehead: string;
  };
  query?: {
    /**
     * Context
     */
    context?: number;
  };
  url: "/api/v1/repos/{repository_id}/git-diff-blame/{basehead}";
};

export type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadError =
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadErrors[keyof GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadErrors];

export type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponses = {
  /**
   * Successful Response
   */
  200: GitDiffBlameResponseV1;
};

export type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponse =
  GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponses[keyof GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponses];

export type GetApiV1ReposByRepositoryIdTreeByRefData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    ref: GitCommitishV1Parse;
  };
  query?: {
    /**
     * Article Tags Any
     */
    article_tags_any?: Array<string> | null;
    /**
     * Article Tags All
     */
    article_tags_all?: Array<string> | null;
  };
  url: "/api/v1/repos/{repository_id}/tree/{ref}";
};

export type GetApiV1ReposByRepositoryIdTreeByRefErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdTreeByRefError =
  GetApiV1ReposByRepositoryIdTreeByRefErrors[keyof GetApiV1ReposByRepositoryIdTreeByRefErrors];

export type GetApiV1ReposByRepositoryIdTreeByRefResponses = {
  /**
   * Successful Response
   */
  200: GitLsTreeResponseV2;
};

export type GetApiV1ReposByRepositoryIdTreeByRefResponse =
  GetApiV1ReposByRepositoryIdTreeByRefResponses[keyof GetApiV1ReposByRepositoryIdTreeByRefResponses];

export type GetApiV1ReposByRepositoryIdArticleByRefData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    ref: GitCommitishV1Parse;
  };
  query?: {
    /**
     * Article Id
     */
    article_id?: number | null;
    /**
     * Path
     */
    path?: string | null;
  };
  url: "/api/v1/repos/{repository_id}/article/{ref}";
};

export type GetApiV1ReposByRepositoryIdArticleByRefErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdArticleByRefError =
  GetApiV1ReposByRepositoryIdArticleByRefErrors[keyof GetApiV1ReposByRepositoryIdArticleByRefErrors];

export type GetApiV1ReposByRepositoryIdArticleByRefResponses = {
  /**
   * Successful Response
   */
  200: GitShowArticleV1;
};

export type GetApiV1ReposByRepositoryIdArticleByRefResponse =
  GetApiV1ReposByRepositoryIdArticleByRefResponses[keyof GetApiV1ReposByRepositoryIdArticleByRefResponses];

export type GetApiV1ReposByRepositoryIdBlobByRefData = {
  body?: never;
  path: {
    /**
     * Repository Id
     */
    repository_id: number;
    ref: GitCommitishV1Parse;
  };
  query: {
    /**
     * Path
     */
    path: string;
  };
  url: "/api/v1/repos/{repository_id}/blob/{ref}";
};

export type GetApiV1ReposByRepositoryIdBlobByRefErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ReposByRepositoryIdBlobByRefError =
  GetApiV1ReposByRepositoryIdBlobByRefErrors[keyof GetApiV1ReposByRepositoryIdBlobByRefErrors];

export type GetApiV1ReposByRepositoryIdBlobByRefResponses = {
  /**
   * Successful Response
   */
  200: GitBlobV2;
};

export type GetApiV1ReposByRepositoryIdBlobByRefResponse =
  GetApiV1ReposByRepositoryIdBlobByRefResponses[keyof GetApiV1ReposByRepositoryIdBlobByRefResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesError =
  GetApiSalesforceV1TenantsByTenantIdActionsCasesErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsCasesErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesResponses = {
  /**
   * Successful Response
   */
  200: SalesforceCasePageV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsCasesResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsCasesResponses];

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesData = {
  body: CreateSalesforceCaseParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases";
};

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesError =
  PostApiSalesforceV1TenantsByTenantIdActionsCasesErrors[keyof PostApiSalesforceV1TenantsByTenantIdActionsCasesErrors];

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesResponses = {
  /**
   * Successful Response
   */
  200: SalesforceCaseV1;
};

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesResponse =
  PostApiSalesforceV1TenantsByTenantIdActionsCasesResponses[keyof PostApiSalesforceV1TenantsByTenantIdActionsCasesResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData = {
  body?: never;
  path: {
    /**
     * Case Id
     */
    case_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError =
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses = {
  /**
   * Successful Response
   */
  200: SalesforceCaseV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses];

export type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData = {
  body: UpdateSalesforceCaseParamsV1;
  path: {
    /**
     * Case Id
     */
    case_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}";
};

export type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError =
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors[keyof PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors];

export type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceCaseV1;
  };

export type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse =
  PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses[keyof PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses];

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsData =
  {
    body: CreateSalesforceCaseCommentParamsV1;
    path: {
      /**
       * Case Id
       */
      case_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}/comments";
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsError =
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsErrors[keyof PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsErrors];

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceCaseMessageV1;
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponse =
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponses[keyof PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponses];

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsData =
  {
    body: SendSalesforceCaseEmailParamsV1;
    path: {
      /**
       * Case Id
       */
      case_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}/emails";
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsError =
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsErrors[keyof PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsErrors];

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponses =
  {
    /**
     * Successful Response
     */
    204: void;
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponse =
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponses[keyof PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponses];

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsData =
  {
    body: CreateSalesforceCaseEmailDraftParamsV1;
    path: {
      /**
       * Case Id
       */
      case_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}/email-drafts";
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsError =
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsErrors[keyof PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsErrors];

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceCaseMessageV1;
  };

export type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponse =
  PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponses[keyof PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData =
  {
    body?: never;
    path: {
      /**
       * Case Id
       */
      case_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: {
      /**
       * Limit
       */
      limit?: number;
      /**
       * Cursor
       */
      cursor?: string | null;
    };
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/cases/{case_id}/messages";
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesError =
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceCaseMessagePageV1;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/default-language";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageError =
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceDefaultLanguageV1;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsArticlesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * Language
     */
    language: string;
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/articles";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsArticlesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsArticlesError =
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsArticlesErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponses = {
  /**
   * Successful Response
   */
  200: SalesforceArticlePageV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponses];

export type PostApiSalesforceV1TenantsByTenantIdActionsArticlesData = {
  body: CreateSalesforceArticleParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/articles";
};

export type PostApiSalesforceV1TenantsByTenantIdActionsArticlesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSalesforceV1TenantsByTenantIdActionsArticlesError =
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesErrors[keyof PostApiSalesforceV1TenantsByTenantIdActionsArticlesErrors];

export type PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponses = {
  /**
   * Successful Response
   */
  200: SalesforceArticleV1;
};

export type PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponse =
  PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponses[keyof PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponses];

export type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdData =
  {
    body: UpdateSalesforceArticleParamsV1;
    path: {
      /**
       * Article Id
       */
      article_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/articles/{article_id}";
  };

export type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdError =
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdErrors[keyof PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdErrors];

export type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceArticleV1;
  };

export type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponse =
  PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponses[keyof PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponses];

export type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdData =
  {
    body?: never;
    path: {
      /**
       * Master Id
       */
      master_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/articles/{master_id}";
  };

export type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdError =
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdErrors[keyof DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdErrors];

export type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponses =
  {
    /**
     * Successful Response
     */
    204: void;
  };

export type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponse =
  DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponses[keyof DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/record-types";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesError =
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponses = {
  /**
   * Successful Response
   */
  200: SalesforceRecordTypePageV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdData =
  {
    body?: never;
    path: {
      /**
       * Record Type Id
       */
      record_type_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/record-types/{record_type_id}";
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdError =
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceRecordTypeV1;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/queues";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesError =
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsQueuesErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponses = {
  /**
   * Successful Response
   */
  200: SalesforceQueuePageV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdData = {
  body?: never;
  path: {
    /**
     * Queue Id
     */
    queue_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/queues/{queue_id}";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdError =
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceQueueV1;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
    /**
     * Name
     */
    name?: string | null;
  };
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/users";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersError =
  GetApiSalesforceV1TenantsByTenantIdActionsUsersErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsUsersErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersResponses = {
  /**
   * Successful Response
   */
  200: SalesforceUserPageV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsUsersResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsUsersResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdData = {
  body?: never;
  path: {
    /**
     * User Id
     */
    user_id: string;
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/users/{user_id}";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdError =
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponses = {
  /**
   * Successful Response
   */
  200: SalesforceUserV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/accounts";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsError =
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsAccountsErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponses = {
  /**
   * Successful Response
   */
  200: SalesforceAccountPageV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdData =
  {
    body?: never;
    path: {
      /**
       * Account Id
       */
      account_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/accounts/{account_id}";
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdError =
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceAccountV1;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/contacts";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsError =
  GetApiSalesforceV1TenantsByTenantIdActionsContactsErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsContactsErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsResponses = {
  /**
   * Successful Response
   */
  200: SalesforceContactPageV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsContactsResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsContactsResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdData =
  {
    body?: never;
    path: {
      /**
       * Contact Id
       */
      contact_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/contacts/{contact_id}";
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdError =
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceContactV1;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/salesforce/v1/tenants/{tenant_id}/actions/entitlements";
};

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsError =
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponses = {
  /**
   * Successful Response
   */
  200: SalesforceEntitlementPageV1;
};

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponses];

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdData =
  {
    body?: never;
    path: {
      /**
       * Entitlement Id
       */
      entitlement_id: string;
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/salesforce/v1/tenants/{tenant_id}/actions/entitlements/{entitlement_id}";
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdError =
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdErrors[keyof GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdErrors];

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponses =
  {
    /**
     * Successful Response
     */
    200: SalesforceEntitlementV1;
  };

export type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponse =
  GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponses[keyof GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponses];

export type GetApiSalesforceV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/salesforce/v1/tenants";
};

export type GetApiSalesforceV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsError =
  GetApiSalesforceV1TenantsErrors[keyof GetApiSalesforceV1TenantsErrors];

export type GetApiSalesforceV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1SalesforceTenantV1;
};

export type GetApiSalesforceV1TenantsResponse =
  GetApiSalesforceV1TenantsResponses[keyof GetApiSalesforceV1TenantsResponses];

export type PostApiSalesforceV1TenantsData = {
  body: CreateSalesforceTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/salesforce/v1/tenants";
};

export type PostApiSalesforceV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSalesforceV1TenantsError =
  PostApiSalesforceV1TenantsErrors[keyof PostApiSalesforceV1TenantsErrors];

export type PostApiSalesforceV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: SalesforceTenantV1;
};

export type PostApiSalesforceV1TenantsResponse =
  PostApiSalesforceV1TenantsResponses[keyof PostApiSalesforceV1TenantsResponses];

export type DeleteApiSalesforceV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}";
};

export type DeleteApiSalesforceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiSalesforceV1TenantsByTenantIdError =
  DeleteApiSalesforceV1TenantsByTenantIdErrors[keyof DeleteApiSalesforceV1TenantsByTenantIdErrors];

export type DeleteApiSalesforceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SalesforceTenantV1;
};

export type DeleteApiSalesforceV1TenantsByTenantIdResponse =
  DeleteApiSalesforceV1TenantsByTenantIdResponses[keyof DeleteApiSalesforceV1TenantsByTenantIdResponses];

export type GetApiSalesforceV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}";
};

export type GetApiSalesforceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdError =
  GetApiSalesforceV1TenantsByTenantIdErrors[keyof GetApiSalesforceV1TenantsByTenantIdErrors];

export type GetApiSalesforceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SalesforceTenantFullV1;
};

export type GetApiSalesforceV1TenantsByTenantIdResponse =
  GetApiSalesforceV1TenantsByTenantIdResponses[keyof GetApiSalesforceV1TenantsByTenantIdResponses];

export type PatchApiSalesforceV1TenantsByTenantIdData = {
  body: UpdateSalesforceTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}";
};

export type PatchApiSalesforceV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiSalesforceV1TenantsByTenantIdError =
  PatchApiSalesforceV1TenantsByTenantIdErrors[keyof PatchApiSalesforceV1TenantsByTenantIdErrors];

export type PatchApiSalesforceV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SalesforceTenantV1;
};

export type PatchApiSalesforceV1TenantsByTenantIdResponse =
  PatchApiSalesforceV1TenantsByTenantIdResponses[keyof PatchApiSalesforceV1TenantsByTenantIdResponses];

export type GetApiSalesforceV1FullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/salesforce/v1/full-tenants";
};

export type GetApiSalesforceV1FullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1FullTenantsError =
  GetApiSalesforceV1FullTenantsErrors[keyof GetApiSalesforceV1FullTenantsErrors];

export type GetApiSalesforceV1FullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1SalesforceTenantFullV1;
};

export type GetApiSalesforceV1FullTenantsResponse =
  GetApiSalesforceV1FullTenantsResponses[keyof GetApiSalesforceV1FullTenantsResponses];

export type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/oauth-redirect-uri";
};

export type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriError =
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriErrors[keyof GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriErrors];

export type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponses = {
  /**
   * Successful Response
   */
  200: SalesforceOAuthRedirectUriV1;
};

export type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponse =
  GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponses[keyof GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponses];

export type PostApiSalesforceV1TenantsByTenantIdConnectData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/connect";
};

export type PostApiSalesforceV1TenantsByTenantIdConnectErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSalesforceV1TenantsByTenantIdConnectError =
  PostApiSalesforceV1TenantsByTenantIdConnectErrors[keyof PostApiSalesforceV1TenantsByTenantIdConnectErrors];

export type PostApiSalesforceV1TenantsByTenantIdConnectResponses = {
  /**
   * Successful Response
   */
  200: SalesforceConnectResponseV1;
};

export type PostApiSalesforceV1TenantsByTenantIdConnectResponse =
  PostApiSalesforceV1TenantsByTenantIdConnectResponses[keyof PostApiSalesforceV1TenantsByTenantIdConnectResponses];

export type PostApiSalesforceV1TenantsByTenantIdCallbackData = {
  body: SalesforceCallbackPayloadV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/callback";
};

export type PostApiSalesforceV1TenantsByTenantIdCallbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSalesforceV1TenantsByTenantIdCallbackError =
  PostApiSalesforceV1TenantsByTenantIdCallbackErrors[keyof PostApiSalesforceV1TenantsByTenantIdCallbackErrors];

export type PostApiSalesforceV1TenantsByTenantIdCallbackResponses = {
  /**
   * Successful Response
   */
  200: SalesforceTenantV1;
};

export type PostApiSalesforceV1TenantsByTenantIdCallbackResponse =
  PostApiSalesforceV1TenantsByTenantIdCallbackResponses[keyof PostApiSalesforceV1TenantsByTenantIdCallbackResponses];

export type GetApiSalesforceV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiSalesforceV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdCheckConnectionError =
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiSalesforceV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: SalesforceCheckConnectionResponseV1;
};

export type GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponse =
  GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiSalesforceV1TenantsByTenantIdCheckReadyData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/check-ready";
};

export type GetApiSalesforceV1TenantsByTenantIdCheckReadyErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSalesforceV1TenantsByTenantIdCheckReadyError =
  GetApiSalesforceV1TenantsByTenantIdCheckReadyErrors[keyof GetApiSalesforceV1TenantsByTenantIdCheckReadyErrors];

export type GetApiSalesforceV1TenantsByTenantIdCheckReadyResponses = {
  /**
   * Successful Response
   */
  200: SalesforceCheckReadyResponseV1;
};

export type GetApiSalesforceV1TenantsByTenantIdCheckReadyResponse =
  GetApiSalesforceV1TenantsByTenantIdCheckReadyResponses[keyof GetApiSalesforceV1TenantsByTenantIdCheckReadyResponses];

export type DeleteApiSalesforceV1TenantsByTenantIdIngestClientData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/ingest-client";
};

export type DeleteApiSalesforceV1TenantsByTenantIdIngestClientErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiSalesforceV1TenantsByTenantIdIngestClientError =
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientErrors[keyof DeleteApiSalesforceV1TenantsByTenantIdIngestClientErrors];

export type DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponses = {
  /**
   * Successful Response
   */
  204: void;
};

export type DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponse =
  DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponses[keyof DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponses];

export type PutApiSalesforceV1TenantsByTenantIdIngestClientData = {
  body: UpdateSalesforceIngestClientParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/salesforce/v1/tenants/{tenant_id}/ingest-client";
};

export type PutApiSalesforceV1TenantsByTenantIdIngestClientErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiSalesforceV1TenantsByTenantIdIngestClientError =
  PutApiSalesforceV1TenantsByTenantIdIngestClientErrors[keyof PutApiSalesforceV1TenantsByTenantIdIngestClientErrors];

export type PutApiSalesforceV1TenantsByTenantIdIngestClientResponses = {
  /**
   * Successful Response
   */
  200: SalesforceIngestClientCredentialsV1;
};

export type PutApiSalesforceV1TenantsByTenantIdIngestClientResponse =
  PutApiSalesforceV1TenantsByTenantIdIngestClientResponses[keyof PutApiSalesforceV1TenantsByTenantIdIngestClientResponses];

export type GetApiV1SearchData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Query
     */
    query: string;
    /**
     * Entity Kinds
     */
    entity_kinds: Array<SearchEntityKindV1>;
    /**
     * Repository Ids
     */
    repository_ids?: Array<number> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/search";
};

export type GetApiV1SearchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1SearchError =
  GetApiV1SearchErrors[keyof GetApiV1SearchErrors];

export type GetApiV1SearchResponses = {
  /**
   * Successful Response
   */
  200: PageV1SearchResultV1;
};

export type GetApiV1SearchResponse =
  GetApiV1SearchResponses[keyof GetApiV1SearchResponses];

export type GetApiSecretsVaultV1SecretsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/secrets-vault/v1/secrets";
};

export type GetApiSecretsVaultV1SecretsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSecretsVaultV1SecretsError =
  GetApiSecretsVaultV1SecretsErrors[keyof GetApiSecretsVaultV1SecretsErrors];

export type GetApiSecretsVaultV1SecretsResponses = {
  /**
   * Successful Response
   */
  200: PageV1SecretV1;
};

export type GetApiSecretsVaultV1SecretsResponse =
  GetApiSecretsVaultV1SecretsResponses[keyof GetApiSecretsVaultV1SecretsResponses];

export type PostApiSecretsVaultV1SecretsData = {
  body: CreateSecretParamsV1;
  path?: never;
  query?: never;
  url: "/api/secrets-vault/v1/secrets";
};

export type PostApiSecretsVaultV1SecretsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSecretsVaultV1SecretsError =
  PostApiSecretsVaultV1SecretsErrors[keyof PostApiSecretsVaultV1SecretsErrors];

export type PostApiSecretsVaultV1SecretsResponses = {
  /**
   * Successful Response
   */
  200: SecretV1;
};

export type PostApiSecretsVaultV1SecretsResponse =
  PostApiSecretsVaultV1SecretsResponses[keyof PostApiSecretsVaultV1SecretsResponses];

export type GetApiSecretsVaultV1FullSecretsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/secrets-vault/v1/full-secrets";
};

export type GetApiSecretsVaultV1FullSecretsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSecretsVaultV1FullSecretsError =
  GetApiSecretsVaultV1FullSecretsErrors[keyof GetApiSecretsVaultV1FullSecretsErrors];

export type GetApiSecretsVaultV1FullSecretsResponses = {
  /**
   * Successful Response
   */
  200: PageV1SecretFullV1;
};

export type GetApiSecretsVaultV1FullSecretsResponse =
  GetApiSecretsVaultV1FullSecretsResponses[keyof GetApiSecretsVaultV1FullSecretsResponses];

export type GetApiSecretsVaultV1SecretsValueData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Name
     */
    name: string;
    /**
     * Version
     */
    version?: number | null;
  };
  url: "/api/secrets-vault/v1/secrets/value";
};

export type GetApiSecretsVaultV1SecretsValueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSecretsVaultV1SecretsValueError =
  GetApiSecretsVaultV1SecretsValueErrors[keyof GetApiSecretsVaultV1SecretsValueErrors];

export type GetApiSecretsVaultV1SecretsValueResponses = {
  /**
   * Successful Response
   */
  200: SecretValueV1;
};

export type GetApiSecretsVaultV1SecretsValueResponse =
  GetApiSecretsVaultV1SecretsValueResponses[keyof GetApiSecretsVaultV1SecretsValueResponses];

export type GetApiSecretsVaultV2SecretsValueData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Name
     */
    name: string;
    /**
     * Version
     */
    version?: number | null;
  };
  url: "/api/secrets-vault/v2/secrets/value";
};

export type GetApiSecretsVaultV2SecretsValueErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSecretsVaultV2SecretsValueError =
  GetApiSecretsVaultV2SecretsValueErrors[keyof GetApiSecretsVaultV2SecretsValueErrors];

export type GetApiSecretsVaultV2SecretsValueResponses = {
  /**
   * Successful Response
   */
  200: SecretValueV2;
};

export type GetApiSecretsVaultV2SecretsValueResponse =
  GetApiSecretsVaultV2SecretsValueResponses[keyof GetApiSecretsVaultV2SecretsValueResponses];

export type DeleteApiSecretsVaultV1SecretsBySecretIdData = {
  body?: never;
  path: {
    /**
     * Secret Id
     */
    secret_id: number;
  };
  query?: never;
  url: "/api/secrets-vault/v1/secrets/{secret_id}";
};

export type DeleteApiSecretsVaultV1SecretsBySecretIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiSecretsVaultV1SecretsBySecretIdError =
  DeleteApiSecretsVaultV1SecretsBySecretIdErrors[keyof DeleteApiSecretsVaultV1SecretsBySecretIdErrors];

export type DeleteApiSecretsVaultV1SecretsBySecretIdResponses = {
  /**
   * Successful Response
   */
  200: SecretV1;
};

export type DeleteApiSecretsVaultV1SecretsBySecretIdResponse =
  DeleteApiSecretsVaultV1SecretsBySecretIdResponses[keyof DeleteApiSecretsVaultV1SecretsBySecretIdResponses];

export type GetApiSecretsVaultV1SecretsBySecretIdData = {
  body?: never;
  path: {
    /**
     * Secret Id
     */
    secret_id: number;
  };
  query?: never;
  url: "/api/secrets-vault/v1/secrets/{secret_id}";
};

export type GetApiSecretsVaultV1SecretsBySecretIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSecretsVaultV1SecretsBySecretIdError =
  GetApiSecretsVaultV1SecretsBySecretIdErrors[keyof GetApiSecretsVaultV1SecretsBySecretIdErrors];

export type GetApiSecretsVaultV1SecretsBySecretIdResponses = {
  /**
   * Successful Response
   */
  200: SecretFullV1;
};

export type GetApiSecretsVaultV1SecretsBySecretIdResponse =
  GetApiSecretsVaultV1SecretsBySecretIdResponses[keyof GetApiSecretsVaultV1SecretsBySecretIdResponses];

export type PatchApiSecretsVaultV1SecretsBySecretIdData = {
  body: UpdateSecretParamsV1;
  path: {
    /**
     * Secret Id
     */
    secret_id: number;
  };
  query?: never;
  url: "/api/secrets-vault/v1/secrets/{secret_id}";
};

export type PatchApiSecretsVaultV1SecretsBySecretIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiSecretsVaultV1SecretsBySecretIdError =
  PatchApiSecretsVaultV1SecretsBySecretIdErrors[keyof PatchApiSecretsVaultV1SecretsBySecretIdErrors];

export type PatchApiSecretsVaultV1SecretsBySecretIdResponses = {
  /**
   * Successful Response
   */
  200: SecretV1;
};

export type PatchApiSecretsVaultV1SecretsBySecretIdResponse =
  PatchApiSecretsVaultV1SecretsBySecretIdResponses[keyof PatchApiSecretsVaultV1SecretsBySecretIdResponses];

export type PostApiSecretsVaultV2SecretsData = {
  body: CreateSecretParamsV2;
  path?: never;
  query?: never;
  url: "/api/secrets-vault/v2/secrets";
};

export type PostApiSecretsVaultV2SecretsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSecretsVaultV2SecretsError =
  PostApiSecretsVaultV2SecretsErrors[keyof PostApiSecretsVaultV2SecretsErrors];

export type PostApiSecretsVaultV2SecretsResponses = {
  /**
   * Successful Response
   */
  200: SecretV1;
};

export type PostApiSecretsVaultV2SecretsResponse =
  PostApiSecretsVaultV2SecretsResponses[keyof PostApiSecretsVaultV2SecretsResponses];

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsData = {
  body: AddSecretVersionParamsV1;
  path: {
    /**
     * Secret Id
     */
    secret_id: number;
  };
  query?: never;
  url: "/api/secrets-vault/v1/secrets/{secret_id}/versions";
};

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsError =
  PostApiSecretsVaultV1SecretsBySecretIdVersionsErrors[keyof PostApiSecretsVaultV1SecretsBySecretIdVersionsErrors];

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsResponses = {
  /**
   * Successful Response
   */
  200: SecretVersionV1;
};

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsResponse =
  PostApiSecretsVaultV1SecretsBySecretIdVersionsResponses[keyof PostApiSecretsVaultV1SecretsBySecretIdVersionsResponses];

export type PostApiSecretsVaultV2SecretsBySecretIdVersionsData = {
  body: AddSecretVersionParamsV2;
  path: {
    /**
     * Secret Id
     */
    secret_id: number;
  };
  query?: never;
  url: "/api/secrets-vault/v2/secrets/{secret_id}/versions";
};

export type PostApiSecretsVaultV2SecretsBySecretIdVersionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSecretsVaultV2SecretsBySecretIdVersionsError =
  PostApiSecretsVaultV2SecretsBySecretIdVersionsErrors[keyof PostApiSecretsVaultV2SecretsBySecretIdVersionsErrors];

export type PostApiSecretsVaultV2SecretsBySecretIdVersionsResponses = {
  /**
   * Successful Response
   */
  200: SecretVersionV1;
};

export type PostApiSecretsVaultV2SecretsBySecretIdVersionsResponse =
  PostApiSecretsVaultV2SecretsBySecretIdVersionsResponses[keyof PostApiSecretsVaultV2SecretsBySecretIdVersionsResponses];

export type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData = {
  body?: never;
  path: {
    /**
     * Secret Id
     */
    secret_id: number;
    /**
     * Version Id
     */
    version_id: number;
  };
  query?: never;
  url: "/api/secrets-vault/v1/secrets/{secret_id}/versions/{version_id}";
};

export type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError =
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors[keyof DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors];

export type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses =
  {
    /**
     * Successful Response
     */
    200: SecretVersionV1;
  };

export type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse =
  DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses[keyof DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses];

export type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData = {
  body: UpdateSecretVersionParamsV1;
  path: {
    /**
     * Secret Id
     */
    secret_id: number;
    /**
     * Version Id
     */
    version_id: number;
  };
  query?: never;
  url: "/api/secrets-vault/v1/secrets/{secret_id}/versions/{version_id}";
};

export type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError =
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors[keyof PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors];

export type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses =
  {
    /**
     * Successful Response
     */
    200: SecretVersionV1;
  };

export type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse =
  PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses[keyof PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses];

export type PostApiSecretsVaultV1SecretsBySecretIdRestoreData = {
  body?: never;
  path: {
    /**
     * Secret Id
     */
    secret_id: number;
  };
  query?: never;
  url: "/api/secrets-vault/v1/secrets/{secret_id}/restore";
};

export type PostApiSecretsVaultV1SecretsBySecretIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSecretsVaultV1SecretsBySecretIdRestoreError =
  PostApiSecretsVaultV1SecretsBySecretIdRestoreErrors[keyof PostApiSecretsVaultV1SecretsBySecretIdRestoreErrors];

export type PostApiSecretsVaultV1SecretsBySecretIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: SecretV1;
};

export type PostApiSecretsVaultV1SecretsBySecretIdRestoreResponse =
  PostApiSecretsVaultV1SecretsBySecretIdRestoreResponses[keyof PostApiSecretsVaultV1SecretsBySecretIdRestoreResponses];

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreData =
  {
    body?: never;
    path: {
      /**
       * Secret Id
       */
      secret_id: number;
      /**
       * Version Id
       */
      version_id: number;
    };
    query?: never;
    url: "/api/secrets-vault/v1/secrets/{secret_id}/versions/{version_id}/restore";
  };

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreError =
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreErrors[keyof PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreErrors];

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: SecretVersionV1;
  };

export type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponse =
  PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponses[keyof PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponses];

export type PostApiServiceNowV1ActionsReplyData = {
  body: ServiceNowReplyRequestV1;
  path?: never;
  query?: never;
  url: "/api/service-now/v1/actions/reply";
};

export type PostApiServiceNowV1ActionsReplyErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiServiceNowV1ActionsReplyError =
  PostApiServiceNowV1ActionsReplyErrors[keyof PostApiServiceNowV1ActionsReplyErrors];

export type PostApiServiceNowV1ActionsReplyResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowReplyResponseV1;
};

export type PostApiServiceNowV1ActionsReplyResponse =
  PostApiServiceNowV1ActionsReplyResponses[keyof PostApiServiceNowV1ActionsReplyResponses];

export type PostApiServiceNowV1ActionsChangeIncidentStateData = {
  /**
   * Change an incident's state by stored value or by label. Both forms are checked against the incident state choice list first and an unknown state is a 422 with no write. When the integration account is refused the choice list (sys_choice), the write proceeds unvalidated and ServiceNow's own handling applies; the stored value is then the caller's responsibility.
   */
  body: ServiceNowChangeIncidentStateRequestV1;
  path?: never;
  query?: never;
  url: "/api/service-now/v1/actions/change-incident-state";
};

export type PostApiServiceNowV1ActionsChangeIncidentStateErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiServiceNowV1ActionsChangeIncidentStateError =
  PostApiServiceNowV1ActionsChangeIncidentStateErrors[keyof PostApiServiceNowV1ActionsChangeIncidentStateErrors];

export type PostApiServiceNowV1ActionsChangeIncidentStateResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowChangeIncidentStateResponseV1;
};

export type PostApiServiceNowV1ActionsChangeIncidentStateResponse =
  PostApiServiceNowV1ActionsChangeIncidentStateResponses[keyof PostApiServiceNowV1ActionsChangeIncidentStateResponses];

export type PostApiServiceNowV1ActionsChangeAssignmentGroupData = {
  body: ServiceNowChangeAssignmentGroupRequestV1;
  path?: never;
  query?: never;
  url: "/api/service-now/v1/actions/change-assignment-group";
};

export type PostApiServiceNowV1ActionsChangeAssignmentGroupErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiServiceNowV1ActionsChangeAssignmentGroupError =
  PostApiServiceNowV1ActionsChangeAssignmentGroupErrors[keyof PostApiServiceNowV1ActionsChangeAssignmentGroupErrors];

export type PostApiServiceNowV1ActionsChangeAssignmentGroupResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowChangeAssignmentGroupResponseV1;
};

export type PostApiServiceNowV1ActionsChangeAssignmentGroupResponse =
  PostApiServiceNowV1ActionsChangeAssignmentGroupResponses[keyof PostApiServiceNowV1ActionsChangeAssignmentGroupResponses];

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestData =
  {
    body: ServiceNowCreateCatalogRequestV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/v1/service-now/tenants/{tenant_id}/actions/create-catalog-request";
  };

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestError =
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestErrors[keyof PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestErrors];

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowCreateCatalogRequestResultV1;
  };

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponse =
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponses[keyof PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerData =
  {
    /**
     * Submit a ServiceNow record producer (sc_cat_item_producer) with its variable answers. Unlike ordering a catalog item, this creates the producer's target record, for example an incident, and returns that record's table, sys_id and number. Reference qualifiers, UI policies and client scripts of the producer's form are not evaluated here; supply values the employee confirmed. Writes to ServiceNow and is not idempotent: repeating the call performs the side effect again. The platform never retries it, so after a timeout or an unclear outcome read the record back before calling again.
     */
    body: ServiceNowSubmitRecordProducerV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/submit-record-producer";
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerError =
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowSubmitRecordProducerResultV1;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideData =
  {
    /**
     * Evaluate a ServiceNow order guide (sc_cat_item_guide) against its guide variable answers through ServiceNow's submit_guide. The result is selected (the catalog items its rules select, each with its quantity and the item variables ServiceNow reports, cascaded values included; an empty list means the answers selected nothing) or foreign_cart_items (the integration account's cart already holds items, so the guide was not evaluated and the cart is left untouched). ServiceNow keeps guide state on that shared cart, so evaluations, checkouts and cart emptying for one account run one at a time; 409 means the lock is busy and 503 that the lock store is unavailable, and in both cases nothing was sent. Retried only when ServiceNow rate-limits it.
     */
    body: ServiceNowEvaluateOrderGuideV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/evaluate-order-guide";
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideError =
  PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowEvaluateOrderGuideResultV1;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideData =
  {
    /**
     * Order a ServiceNow order guide as one request. Two-step guides are refused with 422 before anything is sent. Under the account's cart lock (409 when it is busy, 503 when its lock store is unavailable; nothing is sent in either case) the platform checks the integration account's cart is empty, evaluates the guide again with guide_variables, stops with selection_changed (nothing ordered) unless ServiceNow still selects exactly the listed items, writes requested_for_sys_id to the cart, then calls checkout_guide with every item's answers. When the guide leaves the items in the cart instead of ordering them, the cart is checked to hold exactly this package and submitted with submit_order; anything else there makes the outcome uncertain and nothing is submitted. foreign_cart_items means the cart held other items before anything was sent. Never retried. The result is request_created (request number, sys_id, the requested_for read back and whether it matches), selection_changed, foreign_cart_items or uncertain (a write was sent and its outcome is unknown: read requests and the cart before calling again). A 4xx means ServiceNow refused and nothing was ordered; any other error status or a lost response must be treated as uncertain.
     */
    body: ServiceNowCheckoutOrderGuideV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/checkout-order-guide";
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideError =
  PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowCheckoutOrderGuideResultV1;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartData = {
  body: ServiceNowEmptyCartRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/service-now/v1/tenants/{tenant_id}/actions/empty-cart";
};

export type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartError =
  PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartResponses = {
  /**
   * Successful Response
   */
  204: void;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartResponses];

export type GetApiServiceNowV1TenantsByTenantIdActionsCartData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/service-now/v1/tenants/{tenant_id}/actions/cart";
};

export type GetApiServiceNowV1TenantsByTenantIdActionsCartErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiServiceNowV1TenantsByTenantIdActionsCartError =
  GetApiServiceNowV1TenantsByTenantIdActionsCartErrors[keyof GetApiServiceNowV1TenantsByTenantIdActionsCartErrors];

export type GetApiServiceNowV1TenantsByTenantIdActionsCartResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowCartV1;
};

export type GetApiServiceNowV1TenantsByTenantIdActionsCartResponse =
  GetApiServiceNowV1TenantsByTenantIdActionsCartResponses[keyof GetApiServiceNowV1TenantsByTenantIdActionsCartResponses];

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentData = {
  body: ServiceNowCreateIncidentV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/actions/create-incident";
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentError =
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentErrors[keyof PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentErrors];

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowCreateIncidentResultV1;
  };

export type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponse =
  PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponses[keyof PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponses];

export type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentData = {
  body: ServiceNowAddAttachmentRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/actions/add-attachment";
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentError =
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentErrors[keyof PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentErrors];

export type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowAddAttachmentResponseV1;
  };

export type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponse =
  PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponses[keyof PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponses];

export type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagData = {
  body: ServiceNowAttachTagRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/actions/attach-tag";
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagError =
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagErrors[keyof PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagErrors];

export type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowAttachTagResponseV1;
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponse =
  PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponses[keyof PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponses];

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateData =
  {
    body: ServiceNowChangeRequestItemStateRequestV2;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/v2/service-now/tenants/{tenant_id}/actions/change-request-item-state";
  };

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateError =
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateErrors[keyof PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateErrors];

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowChangeRequestItemStateResponseV2;
  };

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponse =
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponses[keyof PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponses];

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateData = {
  body: ServiceNowChangeTaskStateRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v2/service-now/tenants/{tenant_id}/actions/change-task-state";
};

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateError =
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateErrors[keyof PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateErrors];

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowChangeTaskStateResponseV2;
  };

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponse =
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponses[keyof PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponses];

export type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateData =
  {
    body: ServiceNowChangeApprovalStateRequestV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/v1/service-now/tenants/{tenant_id}/actions/change-approval-state";
  };

export type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateError =
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateErrors[keyof PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateErrors];

export type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowChangeApprovalStateResponseV1;
  };

export type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponse =
  PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponses[keyof PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponses];

export type PostApiV1ServiceNowTenantsByTenantIdActionsReplyData = {
  body: ServiceNowReplyTenantNestedRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/actions/reply";
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsReplyErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsReplyError =
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyErrors[keyof PostApiV1ServiceNowTenantsByTenantIdActionsReplyErrors];

export type PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowReplyResponseV1;
};

export type PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponse =
  PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponses[keyof PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponses];

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateData =
  {
    body: ServiceNowChangeRequestStateRequestV2;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/v2/service-now/tenants/{tenant_id}/actions/change-request-state";
  };

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateError =
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateErrors[keyof PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateErrors];

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowChangeRequestStateResponseV2;
  };

export type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponse =
  PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponses[keyof PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponses];

export type GetApiV1ServiceNowTenantsByTenantIdArticlesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    /**
     * Knowledge Base Sys Id
     */
    knowledge_base_sys_id?: string | null;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/articles";
};

export type GetApiV1ServiceNowTenantsByTenantIdArticlesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdArticlesError =
  GetApiV1ServiceNowTenantsByTenantIdArticlesErrors[keyof GetApiV1ServiceNowTenantsByTenantIdArticlesErrors];

export type GetApiV1ServiceNowTenantsByTenantIdArticlesResponses = {
  /**
   * Successful Response
   */
  200: PageV2ServiceNowKbArticleV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdArticlesResponse =
  GetApiV1ServiceNowTenantsByTenantIdArticlesResponses[keyof GetApiV1ServiceNowTenantsByTenantIdArticlesResponses];

export type PostApiV1ServiceNowTenantsByTenantIdArticlesData = {
  body: CreateServiceNowArticleV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/articles";
};

export type PostApiV1ServiceNowTenantsByTenantIdArticlesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdArticlesError =
  PostApiV1ServiceNowTenantsByTenantIdArticlesErrors[keyof PostApiV1ServiceNowTenantsByTenantIdArticlesErrors];

export type PostApiV1ServiceNowTenantsByTenantIdArticlesResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowKbArticleV1;
};

export type PostApiV1ServiceNowTenantsByTenantIdArticlesResponse =
  PostApiV1ServiceNowTenantsByTenantIdArticlesResponses[keyof PostApiV1ServiceNowTenantsByTenantIdArticlesResponses];

export type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Sys Id
     */
    sys_id: string;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/articles/{sys_id}";
};

export type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError =
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors[keyof GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors];

export type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowKbArticleFullV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse =
  GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses[keyof GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses];

export type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData = {
  body: UpdateServiceNowArticleV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Sys Id
     */
    sys_id: string;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/articles/{sys_id}";
};

export type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError =
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors[keyof PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors];

export type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowKbArticleV1;
};

export type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse =
  PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses[keyof PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses];

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    /**
     * Include Inactive
     */
    include_inactive?: boolean;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/knowledge-bases";
};

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError =
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors[keyof GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors];

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses = {
  /**
   * Successful Response
   */
  200: PageV2ServiceNowKbKnowledgeBaseV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse =
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses[keyof GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses];

export type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData = {
  body: CreateServiceNowKnowledgeBaseV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/knowledge-bases";
};

export type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError =
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors[keyof PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors];

export type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowKbKnowledgeBaseV1;
};

export type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse =
  PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses[keyof PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses];

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Sys Id
     */
    sys_id: string;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/knowledge-bases/{sys_id}";
};

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError =
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors[keyof GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors];

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowKbKnowledgeBaseV1;
  };

export type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse =
  GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses[keyof GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses];

export type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData = {
  body: UpdateServiceNowKnowledgeBaseV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Sys Id
     */
    sys_id: string;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/knowledge-bases/{sys_id}";
};

export type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError =
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors[keyof PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors];

export type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowKbKnowledgeBaseV1;
  };

export type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse =
  PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses[keyof PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses];

export type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/incidents/state-choices";
};

export type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesError =
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesErrors[keyof GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesErrors];

export type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowIncidentStateChoicesV1;
  };

export type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponse =
  GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponses[keyof GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponses];

export type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/assignment-groups";
};

export type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsError =
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsErrors[keyof GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsErrors];

export type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ServiceNowUserGroupV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponse =
  GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponses[keyof GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponses];

export type GetApiV1ServiceNowTenantsByTenantIdUsersData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    email: NonEmptyStr;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/users";
};

export type GetApiV1ServiceNowTenantsByTenantIdUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdUsersError =
  GetApiV1ServiceNowTenantsByTenantIdUsersErrors[keyof GetApiV1ServiceNowTenantsByTenantIdUsersErrors];

export type GetApiV1ServiceNowTenantsByTenantIdUsersResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowUsersV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdUsersResponse =
  GetApiV1ServiceNowTenantsByTenantIdUsersResponses[keyof GetApiV1ServiceNowTenantsByTenantIdUsersResponses];

export type GetApiV1ServiceNowTenantsByTenantIdTagsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/tags";
};

export type GetApiV1ServiceNowTenantsByTenantIdTagsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdTagsError =
  GetApiV1ServiceNowTenantsByTenantIdTagsErrors[keyof GetApiV1ServiceNowTenantsByTenantIdTagsErrors];

export type GetApiV1ServiceNowTenantsByTenantIdTagsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ServiceNowTagV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdTagsResponse =
  GetApiV1ServiceNowTenantsByTenantIdTagsResponses[keyof GetApiV1ServiceNowTenantsByTenantIdTagsResponses];

export type PostApiV1ServiceNowTenantsByTenantIdTagsData = {
  body: ServiceNowCreateTagV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/tags";
};

export type PostApiV1ServiceNowTenantsByTenantIdTagsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdTagsError =
  PostApiV1ServiceNowTenantsByTenantIdTagsErrors[keyof PostApiV1ServiceNowTenantsByTenantIdTagsErrors];

export type PostApiV1ServiceNowTenantsByTenantIdTagsResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowTagV1;
};

export type PostApiV1ServiceNowTenantsByTenantIdTagsResponse =
  PostApiV1ServiceNowTenantsByTenantIdTagsResponses[keyof PostApiV1ServiceNowTenantsByTenantIdTagsResponses];

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Sys Id
     */
    sys_id: string;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/request-items/{sys_id}";
};

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdError =
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdErrors[keyof GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdErrors];

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowRequestItemFullV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponse =
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponses[keyof GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponses];

export type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Request Sys Id
       */
      request_sys_id: string;
    };
    query?: {
      /**
       * Offset
       */
      offset?: number;
      limit?: LimitFilterV1;
    };
    url: "/api/v1/service-now/tenants/{tenant_id}/requests/{request_sys_id}/request-items";
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsError =
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsErrors[keyof GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsErrors];

export type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponses =
  {
    /**
     * Successful Response
     */
    200: PageV2ServiceNowRequestItemV1;
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponse =
  GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponses[keyof GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponses];

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Request Item Sys Id
       */
      request_item_sys_id: string;
    };
    query?: {
      /**
       * Offset
       */
      offset?: number;
      limit?: LimitFilterV1;
    };
    url: "/api/v1/service-now/tenants/{tenant_id}/request-items/{request_item_sys_id}/tasks";
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksError =
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksErrors[keyof GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksErrors];

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponses =
  {
    /**
     * Successful Response
     */
    200: PageV2ServiceNowTaskV1;
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponse =
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponses[keyof GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponses];

export type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Ticket Sys Id
       */
      ticket_sys_id: string;
    };
    query?: {
      /**
       * Offset
       */
      offset?: number;
      limit?: LimitFilterV1;
    };
    url: "/api/v1/service-now/tenants/{tenant_id}/tickets/{ticket_sys_id}/attachments";
  };

export type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsError =
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsErrors[keyof GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsErrors];

export type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponses =
  {
    /**
     * Successful Response
     */
    200: PageV2ServiceNowAttachmentV1;
  };

export type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponse =
  GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponses[keyof GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponses];

export type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Attachment Sys Id
       */
      attachment_sys_id: string;
    };
    query?: never;
    url: "/api/v1/service-now/tenants/{tenant_id}/attachments/{attachment_sys_id}/content";
  };

export type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentError =
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentErrors[keyof GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentErrors];

export type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowGetAttachmentContentResponseV1;
  };

export type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponse =
  GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponses[keyof GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponses];

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Request Item Sys Id
       */
      request_item_sys_id: string;
    };
    query?: {
      /**
       * Offset
       */
      offset?: number;
      limit?: LimitFilterV1;
    };
    url: "/api/v1/service-now/tenants/{tenant_id}/request-items/{request_item_sys_id}/approvals";
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsError =
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsErrors[keyof GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsErrors];

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponses =
  {
    /**
     * Successful Response
     */
    200: PageV2ServiceNowApprovalV1;
  };

export type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponse =
  GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponses[keyof GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponses];

export type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/approvals/state-choices";
};

export type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesError =
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesErrors[keyof GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesErrors];

export type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowApprovalStateChoicesV1;
  };

export type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponse =
  GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponses[keyof GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponses];

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/catalog-items";
};

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsError =
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsErrors[keyof GetApiV1ServiceNowTenantsByTenantIdCatalogItemsErrors];

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ServiceNowCatalogItemV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponse =
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponses[keyof GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponses];

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Sys Id
     */
    sys_id: string;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/catalog-items/{sys_id}";
};

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdError =
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdErrors[keyof GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdErrors];

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowCatalogItemFullV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponse =
  GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponses[keyof GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponses];

export type GetApiV1ServiceNowTenantsByTenantIdTicketsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    ticket_type: ServiceNowTicketTypeV1;
    /**
     * Updated After
     */
    updated_after: Date;
    /**
     * Requester Sys Id
     */
    requester_sys_id?: NonEmptyStr | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/tickets";
};

export type GetApiV1ServiceNowTenantsByTenantIdTicketsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdTicketsError =
  GetApiV1ServiceNowTenantsByTenantIdTicketsErrors[keyof GetApiV1ServiceNowTenantsByTenantIdTicketsErrors];

export type GetApiV1ServiceNowTenantsByTenantIdTicketsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ServiceNowTicketV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdTicketsResponse =
  GetApiV1ServiceNowTenantsByTenantIdTicketsResponses[keyof GetApiV1ServiceNowTenantsByTenantIdTicketsResponses];

export type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Sys Id
     */
    sys_id: string;
  };
  query: {
    ticket_type: ServiceNowTicketTypeV1;
  };
  url: "/api/v1/service-now/tenants/{tenant_id}/tickets/{sys_id}";
};

export type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdError =
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdErrors[keyof GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdErrors];

export type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowTicketFullV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponse =
  GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponses[keyof GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponses];

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query: {
      /**
       * Catalog Item Id
       */
      catalog_item_id: string;
      /**
       * Variable Id
       */
      variable_id: string;
      /**
       * Configuration Fingerprint
       *
       * Fingerprint returned by get_catalog_variable_lookup_metadata_v1 for this tenant, item, and variable. A changed configuration returns 409 before querying values; refresh metadata and retry. This validates configuration, not a snapshot of matching records.
       */
      configuration_fingerprint: string;
      /**
       * Query
       *
       * Search text of at most 200 characters containing non-whitespace text, without caret, newline, or javascript: in any letter case. Literal text is matched with ServiceNow LIKE against search_fields from lookup metadata. Codes are searchable only when the variable's metadata includes their column. Use exact_value to revalidate a selected submission value against the same static qualifier. An empty page means no match within those fields and the integration account's readable records, not that a business code does not exist. Results do not impersonate an employee.
       */
      query: string;
      match?: ServiceNowCatalogValueMatchV1;
      /**
       * Offset
       *
       * Zero-based offset; defaults to 0. Add the returned item count to offset to continue until offset reaches total. Offsets beyond total are rejected; offset equal to total is an empty terminal page.
       */
      offset?: number;
      /**
       * Maximum matching values to return; defaults to 20. Pass all for the complete remaining result. No caller-facing maximum; upstream reads use bounded pages. Continue with offset plus the returned item count until total is reached.
       */
      limit?: LimitFilterV1;
      /**
       * Answers
       *
       * Current answers for the variables named in lookup metadata dependencies, one entry per variable formatted as variable_name=value. Required only when dependencies is non-empty: the variable's scripted qualifier is a template over those answers and is rendered to a static encoded query before values are read. Entries for other variables are ignored; a missing dependency or a value containing caret or newline characters is rejected before any read.
       */
      answers?: Array<string> | null;
    };
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/catalog-variable-values";
  };

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesErrors =
  {
    /**
     * Conflict
     */
    409: ServiceNowCatalogVariableValuesConflictV1;
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesError =
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesErrors[keyof GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesErrors];

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponses =
  {
    /**
     * Successful Response
     */
    200: PageV2ServiceNowCatalogVariableValueV1;
  };

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponse =
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponses[keyof GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponses];

export type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * The user's id (the sys_user record id), as returned by user resolution. Returns the profile attributes catalog forms default from: manager, department, location, cost centre and company as reference value/display pairs (null when the record has none), plus name, email, user name, title and active flag. Read only; uses the integration's permissions, so a reference the integration cannot read comes back with an empty display.
     */
    user_id: NonEmptyStr09aF32;
  };
  url: "/api/service-now/v1/tenants/{tenant_id}/actions/user-profile";
};

export type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileError =
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileErrors[keyof GetApiServiceNowV1TenantsByTenantIdActionsUserProfileErrors];

export type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowUserProfileV1;
};

export type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponse =
  GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponses[keyof GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponses];

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query: {
      /**
       * Catalog Item Id
       */
      catalog_item_id: string;
      /**
       * Variable Id
       */
      variable_id: string;
    };
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/catalog-variable-lookup-metadata";
  };

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataError =
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataErrors[keyof GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataErrors];

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowCatalogVariableLookupMetadataV1;
  };

export type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponse =
  GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponses[keyof GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsData = {
  /**
   * Read a page of records from any table the integration account can read, filtered by typed conditions (column, operator, value, join), optional free-text keywords and a sort order. Scripted values are rejected before any read. Records come back as sys_id plus each requested column's stored value and display value. Reads only; a POST because the query is structured.
   */
  body: ServiceNowSearchRecordsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/service-now/v1/tenants/{tenant_id}/actions/search-records";
};

export type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsError =
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponses =
  {
    /**
     * Successful Response
     */
    200: PageV2ServiceNowRecordV1;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsRecordsData = {
  /**
   * Insert one record into any table the integration account may write, with the given field values. Set input_display_values to supply display values (a user's name, a choice label) instead of stored values; the flag applies to every field in the call. Script values are rejected. Returns the created record with every column ServiceNow echoes back, as stored value plus display value. Writes to ServiceNow and is not idempotent: repeating the call performs the side effect again. The platform never retries it, so after a timeout or an unclear outcome read the record back before calling again.
   */
  body: ServiceNowCreateRecordV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/service-now/v1/tenants/{tenant_id}/actions/records";
};

export type PostApiServiceNowV1TenantsByTenantIdActionsRecordsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsRecordsError =
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsRecordsErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowRecordV1;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponses];

export type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdData =
  {
    /**
     * Update the given fields of one record in any table the integration account may write; untouched fields keep their values. Journal fields such as comments and work_notes append. Set input_display_values to supply display values for every field in the call. Script values are rejected. Returns the updated record as stored value plus display value per column. Writes to ServiceNow and is not idempotent: repeating the call performs the side effect again. The platform never retries it, so after a timeout or an unclear outcome read the record back before calling again.
     */
    body: ServiceNowUpdateRecordV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Record Id
       */
      record_id: string;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/records/{record_id}";
  };

export type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdError =
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdErrors[keyof PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdErrors];

export type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowRecordV1;
  };

export type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponse =
  PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponses[keyof PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsData = {
  /**
   * Count the records matching a typed query in any table the integration account can read, optionally grouped by one or more columns. The total is ServiceNow's ungrouped count; groups_complete says whether the returned groups add up to it. Reads only; a POST because the query is structured.
   */
  body: ServiceNowAggregateRecordsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/service-now/v1/tenants/{tenant_id}/actions/aggregate-records";
};

export type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsError =
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowAggregateV1;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesData = {
  /**
   * Create a change request through the Change Management API, which applies the change model and, for a standard change, the published template. kind is standard (template_id required; list templates with the records read on std_change_producer_version, active=true), normal or emergency. fields are stored values for change_request columns such as short_description, description, assignment_group, cmdb_ci, start_date and end_date; script values are refused. Returns the created change with every column ServiceNow echoes, as stored value plus display value. Writes to ServiceNow and is not idempotent: repeating the call performs the side effect again. The platform never retries it, so after a timeout or an unclear outcome read the record back before calling again.
   */
  body: ServiceNowCreateChangeV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/service-now/v1/tenants/{tenant_id}/actions/changes";
};

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesError =
  PostApiServiceNowV1TenantsByTenantIdActionsChangesErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsChangesErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowRecordV1;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsChangesResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsChangesResponses];

export type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdData =
  {
    /**
     * Update a change request through the Change Management API, which enforces the change model: a state value the model does not allow from the current state is refused by ServiceNow with its own error rather than stored. Use it for state moves (assess, authorize, schedule, implement, review, close), schedule dates, risk and impact, and close notes. Returns the updated change as stored value plus display value per column. Writes to ServiceNow and is not idempotent: repeating the call performs the side effect again. The platform never retries it, so after a timeout or an unclear outcome read the record back before calling again.
     */
    body: ServiceNowUpdateChangeV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Change Id
       */
      change_id: string;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/changes/{change_id}";
  };

export type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdError =
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdErrors[keyof PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdErrors];

export type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowRecordV1;
  };

export type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponse =
  PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponses[keyof PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksData =
  {
    /**
     * Create a change task under an existing change request, with stored values for change_task columns such as short_description, description, assignment_group, change_task_type, planned_start_date and planned_end_date. Existing tasks are read with the records read on change_task (change_request=<change id>). Returns the created task as stored value plus display value per column. Writes to ServiceNow and is not idempotent: repeating the call performs the side effect again. The platform never retries it, so after a timeout or an unclear outcome read the record back before calling again.
     */
    body: ServiceNowCreateChangeTaskV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Change Id
       */
      change_id: string;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/changes/{change_id}/tasks";
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksError =
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowRecordV1;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsBatchData = {
  /**
   * Run up to 50 record operations in one ServiceNow round trip through the Batch API. Each item is a read (same table, query, fields, offset and limit rules as the records read), a create or an update (same rules as the records write), identified by a caller-chosen unique id. Items are validated up front and the whole batch is refused on the first invalid item; once sent, each item succeeds or fails independently and the result carries its status code, its records as stored value plus display value, and an error message when ServiceNow refused it. Not transactional and never retried.
   */
  body: ServiceNowBatchRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/service-now/v1/tenants/{tenant_id}/actions/batch";
};

export type PostApiServiceNowV1TenantsByTenantIdActionsBatchErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsBatchError =
  PostApiServiceNowV1TenantsByTenantIdActionsBatchErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsBatchErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsBatchResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowBatchResultV1;
};

export type PostApiServiceNowV1TenantsByTenantIdActionsBatchResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsBatchResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsBatchResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentData =
  {
    /**
     * Upload a base64-encoded file for a catalog attachment variable before the item is ordered, the way Employee Center does: the file is stored against the catalog cart-item staging table under the caller's item_guid. Put the returned attachment_sys_id in the attachment variable's value and pass the same item_guid on create-catalog-request. Writes to ServiceNow and is not idempotent: repeating the call stages another copy. Retried only when ServiceNow rate-limits it before applying it. A file that is never ordered can be removed with delete-staged-catalog-attachment.
     */
    body: ServiceNowStageCatalogAttachmentRequestV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/stage-catalog-attachment";
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentError =
  PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowStagedCatalogAttachmentV1;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentData =
  {
    body: ServiceNowDeleteStagedCatalogAttachmentRequestV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/delete-staged-catalog-attachment";
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentError =
  PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentResponses =
  {
    /**
     * Successful Response
     */
    204: void;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentResponses];

export type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentData =
  {
    /**
     * Attach a base64-encoded file to one record in any table the integration account may write, named by table and sys_id (for example sc_task or kb_knowledge). add-attachment remains the route for incidents, requests and request items by ticket type. Writes to ServiceNow and is not idempotent: repeating the call attaches the file again. The platform never retries it.
     */
    body: ServiceNowAddRecordAttachmentRequestV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/service-now/v1/tenants/{tenant_id}/actions/add-record-attachment";
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentError =
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentErrors[keyof PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentErrors];

export type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponses =
  {
    /**
     * Successful Response
     */
    200: ServiceNowAddAttachmentResponseV1;
  };

export type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponse =
  PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponses[keyof PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponses];

export type GetApiV1ServiceNowTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/service-now/tenants";
};

export type GetApiV1ServiceNowTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsError =
  GetApiV1ServiceNowTenantsErrors[keyof GetApiV1ServiceNowTenantsErrors];

export type GetApiV1ServiceNowTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ServiceNowTenantV1;
};

export type GetApiV1ServiceNowTenantsResponse =
  GetApiV1ServiceNowTenantsResponses[keyof GetApiV1ServiceNowTenantsResponses];

export type PostApiV1ServiceNowTenantsData = {
  body: ServiceNowCreateTenantV1;
  path?: never;
  query?: never;
  url: "/api/v1/service-now/tenants";
};

export type PostApiV1ServiceNowTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsError =
  PostApiV1ServiceNowTenantsErrors[keyof PostApiV1ServiceNowTenantsErrors];

export type PostApiV1ServiceNowTenantsResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowTenantFullV1;
};

export type PostApiV1ServiceNowTenantsResponse =
  PostApiV1ServiceNowTenantsResponses[keyof PostApiV1ServiceNowTenantsResponses];

export type DeleteApiV1ServiceNowTenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}";
};

export type DeleteApiV1ServiceNowTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ServiceNowTenantsByTenantIdError =
  DeleteApiV1ServiceNowTenantsByTenantIdErrors[keyof DeleteApiV1ServiceNowTenantsByTenantIdErrors];

export type DeleteApiV1ServiceNowTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowTenantV1;
};

export type DeleteApiV1ServiceNowTenantsByTenantIdResponse =
  DeleteApiV1ServiceNowTenantsByTenantIdResponses[keyof DeleteApiV1ServiceNowTenantsByTenantIdResponses];

export type GetApiV1ServiceNowTenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}";
};

export type GetApiV1ServiceNowTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ServiceNowTenantsByTenantIdError =
  GetApiV1ServiceNowTenantsByTenantIdErrors[keyof GetApiV1ServiceNowTenantsByTenantIdErrors];

export type GetApiV1ServiceNowTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowTenantFullV1;
};

export type GetApiV1ServiceNowTenantsByTenantIdResponse =
  GetApiV1ServiceNowTenantsByTenantIdResponses[keyof GetApiV1ServiceNowTenantsByTenantIdResponses];

export type PatchApiV1ServiceNowTenantsByTenantIdData = {
  body: UpdateTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}";
};

export type PatchApiV1ServiceNowTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ServiceNowTenantsByTenantIdError =
  PatchApiV1ServiceNowTenantsByTenantIdErrors[keyof PatchApiV1ServiceNowTenantsByTenantIdErrors];

export type PatchApiV1ServiceNowTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowTenantV1;
};

export type PatchApiV1ServiceNowTenantsByTenantIdResponse =
  PatchApiV1ServiceNowTenantsByTenantIdResponses[keyof PatchApiV1ServiceNowTenantsByTenantIdResponses];

export type PostApiV1ServiceNowTenantsByTenantIdRestoreData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/restore";
};

export type PostApiV1ServiceNowTenantsByTenantIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdRestoreError =
  PostApiV1ServiceNowTenantsByTenantIdRestoreErrors[keyof PostApiV1ServiceNowTenantsByTenantIdRestoreErrors];

export type PostApiV1ServiceNowTenantsByTenantIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowTenantV1;
};

export type PostApiV1ServiceNowTenantsByTenantIdRestoreResponse =
  PostApiV1ServiceNowTenantsByTenantIdRestoreResponses[keyof PostApiV1ServiceNowTenantsByTenantIdRestoreResponses];

export type PostApiV1ServiceNowTenantsByTenantIdSetupData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/service-now/tenants/{tenant_id}/setup";
};

export type PostApiV1ServiceNowTenantsByTenantIdSetupErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ServiceNowTenantsByTenantIdSetupError =
  PostApiV1ServiceNowTenantsByTenantIdSetupErrors[keyof PostApiV1ServiceNowTenantsByTenantIdSetupErrors];

export type PostApiV1ServiceNowTenantsByTenantIdSetupResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowSetupTenantResponseV1;
};

export type PostApiV1ServiceNowTenantsByTenantIdSetupResponse =
  PostApiV1ServiceNowTenantsByTenantIdSetupResponses[keyof PostApiV1ServiceNowTenantsByTenantIdSetupResponses];

export type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Site Id
       */
      site_id: string;
    };
    query?: {
      /**
       * Cursor
       */
      cursor?: string | null;
    };
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/sites/{site_id}/drives";
  };

export type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesError =
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesErrors[keyof GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesErrors];

export type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponses =
  {
    /**
     * Successful Response
     */
    200: CursorPageV1SharepointDriveV1;
  };

export type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponse =
  GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponses[keyof GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponses];

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Drive Id
       */
      drive_id: string;
      /**
       * Item Id
       */
      item_id: string;
    };
    query?: {
      /**
       * Cursor
       */
      cursor?: string | null;
    };
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}/children";
  };

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenError =
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenErrors[keyof GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenErrors];

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponses =
  {
    /**
     * Successful Response
     */
    200: CursorPageV1SharepointDriveItemV1;
  };

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponse =
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponses[keyof GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponses];

export type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Drive Id
       */
      drive_id: string;
      /**
       * Item Id
       */
      item_id: string;
    };
    query?: never;
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}";
  };

export type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError =
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors[keyof DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors];

export type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses =
  {
    /**
     * Successful Response
     */
    200: SharepointWriteReceiptV1;
  };

export type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse =
  DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses[keyof DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses];

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Drive Id
       */
      drive_id: string;
      /**
       * Item Id
       */
      item_id: string;
    };
    query?: never;
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}";
  };

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError =
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors[keyof GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors];

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses =
  {
    /**
     * Successful Response
     */
    200: SharepointDriveItemV1;
  };

export type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse =
  GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses[keyof GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses];

export type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData =
  {
    body: UpdateSharepointItemParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Drive Id
       */
      drive_id: string;
      /**
       * Item Id
       */
      item_id: string;
    };
    query?: never;
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}";
  };

export type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError =
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors[keyof PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors];

export type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses =
  {
    /**
     * Successful Response
     */
    200: SharepointWriteReceiptV1;
  };

export type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse =
  PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses[keyof PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses];

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Drive Id
       */
      drive_id: string;
      /**
       * Item Id
       */
      item_id: string;
    };
    query?: never;
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}/download-url";
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlError =
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlErrors[keyof PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlErrors];

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponses =
  {
    /**
     * Successful Response
     */
    200: SharepointDownloadUrlV1;
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponse =
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponses[keyof PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponses];

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Drive Id
       */
      drive_id: string;
      /**
       * Item Id
       */
      item_id: string;
    };
    query?: never;
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{item_id}/upload-session";
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionError =
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionErrors[keyof PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionErrors];

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponses =
  {
    /**
     * Successful Response
     */
    200: SharepointUploadSessionV1;
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponse =
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponses[keyof PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponses];

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionData =
  {
    body: CreateSharepointItemUploadSessionParamsV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Drive Id
       */
      drive_id: string;
      /**
       * Folder Id
       */
      folder_id: string;
    };
    query?: never;
    url: "/api/sharepoint/v1/tenants/{tenant_id}/actions/drives/{drive_id}/items/{folder_id}/children/upload-session";
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionError =
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionErrors[keyof PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionErrors];

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponses =
  {
    /**
     * Successful Response
     */
    200: SharepointUploadSessionV1;
  };

export type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponse =
  PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponses[keyof PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponses];

export type GetApiSharepointV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/sharepoint/v1/tenants";
};

export type GetApiSharepointV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSharepointV1TenantsError =
  GetApiSharepointV1TenantsErrors[keyof GetApiSharepointV1TenantsErrors];

export type GetApiSharepointV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1SharepointTenantV1;
};

export type GetApiSharepointV1TenantsResponse =
  GetApiSharepointV1TenantsResponses[keyof GetApiSharepointV1TenantsResponses];

export type PostApiSharepointV1TenantsData = {
  body: CreateSharepointTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/sharepoint/v1/tenants";
};

export type PostApiSharepointV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSharepointV1TenantsError =
  PostApiSharepointV1TenantsErrors[keyof PostApiSharepointV1TenantsErrors];

export type PostApiSharepointV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: SharepointTenantV1;
};

export type PostApiSharepointV1TenantsResponse =
  PostApiSharepointV1TenantsResponses[keyof PostApiSharepointV1TenantsResponses];

export type GetApiSharepointV1FullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/sharepoint/v1/full-tenants";
};

export type GetApiSharepointV1FullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSharepointV1FullTenantsError =
  GetApiSharepointV1FullTenantsErrors[keyof GetApiSharepointV1FullTenantsErrors];

export type GetApiSharepointV1FullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1SharepointTenantFullV1;
};

export type GetApiSharepointV1FullTenantsResponse =
  GetApiSharepointV1FullTenantsResponses[keyof GetApiSharepointV1FullTenantsResponses];

export type DeleteApiSharepointV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}";
};

export type DeleteApiSharepointV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiSharepointV1TenantsByTenantIdError =
  DeleteApiSharepointV1TenantsByTenantIdErrors[keyof DeleteApiSharepointV1TenantsByTenantIdErrors];

export type DeleteApiSharepointV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SharepointTenantV1;
};

export type DeleteApiSharepointV1TenantsByTenantIdResponse =
  DeleteApiSharepointV1TenantsByTenantIdResponses[keyof DeleteApiSharepointV1TenantsByTenantIdResponses];

export type GetApiSharepointV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}";
};

export type GetApiSharepointV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSharepointV1TenantsByTenantIdError =
  GetApiSharepointV1TenantsByTenantIdErrors[keyof GetApiSharepointV1TenantsByTenantIdErrors];

export type GetApiSharepointV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SharepointTenantFullV1;
};

export type GetApiSharepointV1TenantsByTenantIdResponse =
  GetApiSharepointV1TenantsByTenantIdResponses[keyof GetApiSharepointV1TenantsByTenantIdResponses];

export type PatchApiSharepointV1TenantsByTenantIdData = {
  body: PatchSharepointTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}";
};

export type PatchApiSharepointV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiSharepointV1TenantsByTenantIdError =
  PatchApiSharepointV1TenantsByTenantIdErrors[keyof PatchApiSharepointV1TenantsByTenantIdErrors];

export type PatchApiSharepointV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SharepointTenantV1;
};

export type PatchApiSharepointV1TenantsByTenantIdResponse =
  PatchApiSharepointV1TenantsByTenantIdResponses[keyof PatchApiSharepointV1TenantsByTenantIdResponses];

export type PostApiSharepointV1TenantsByTenantIdConnectData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/connect";
};

export type PostApiSharepointV1TenantsByTenantIdConnectErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSharepointV1TenantsByTenantIdConnectError =
  PostApiSharepointV1TenantsByTenantIdConnectErrors[keyof PostApiSharepointV1TenantsByTenantIdConnectErrors];

export type PostApiSharepointV1TenantsByTenantIdConnectResponses = {
  /**
   * Successful Response
   */
  200: SharepointConnectResponseV1;
};

export type PostApiSharepointV1TenantsByTenantIdConnectResponse =
  PostApiSharepointV1TenantsByTenantIdConnectResponses[keyof PostApiSharepointV1TenantsByTenantIdConnectResponses];

export type PostApiSharepointV1TenantsByTenantIdCallbackData = {
  body: SharepointCallbackParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/callback";
};

export type PostApiSharepointV1TenantsByTenantIdCallbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSharepointV1TenantsByTenantIdCallbackError =
  PostApiSharepointV1TenantsByTenantIdCallbackErrors[keyof PostApiSharepointV1TenantsByTenantIdCallbackErrors];

export type PostApiSharepointV1TenantsByTenantIdCallbackResponses = {
  /**
   * Successful Response
   */
  200: SharepointTenantV1;
};

export type PostApiSharepointV1TenantsByTenantIdCallbackResponse =
  PostApiSharepointV1TenantsByTenantIdCallbackResponses[keyof PostApiSharepointV1TenantsByTenantIdCallbackResponses];

export type GetApiSharepointV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiSharepointV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSharepointV1TenantsByTenantIdCheckConnectionError =
  GetApiSharepointV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiSharepointV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiSharepointV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: SharepointCheckConnectionResultV1;
};

export type GetApiSharepointV1TenantsByTenantIdCheckConnectionResponse =
  GetApiSharepointV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiSharepointV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiSharepointV1TenantsByTenantIdCheckAccessData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/check-access";
};

export type GetApiSharepointV1TenantsByTenantIdCheckAccessErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSharepointV1TenantsByTenantIdCheckAccessError =
  GetApiSharepointV1TenantsByTenantIdCheckAccessErrors[keyof GetApiSharepointV1TenantsByTenantIdCheckAccessErrors];

export type GetApiSharepointV1TenantsByTenantIdCheckAccessResponses = {
  /**
   * Successful Response
   */
  200: SharepointCheckAccessResultV1;
};

export type GetApiSharepointV1TenantsByTenantIdCheckAccessResponse =
  GetApiSharepointV1TenantsByTenantIdCheckAccessResponses[keyof GetApiSharepointV1TenantsByTenantIdCheckAccessResponses];

export type GetApiSharepointV1TenantsByTenantIdAdminAccessData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/admin-access";
};

export type GetApiSharepointV1TenantsByTenantIdAdminAccessErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSharepointV1TenantsByTenantIdAdminAccessError =
  GetApiSharepointV1TenantsByTenantIdAdminAccessErrors[keyof GetApiSharepointV1TenantsByTenantIdAdminAccessErrors];

export type GetApiSharepointV1TenantsByTenantIdAdminAccessResponses = {
  /**
   * Successful Response
   */
  200: SharepointAdminAccessResultV1;
};

export type GetApiSharepointV1TenantsByTenantIdAdminAccessResponse =
  GetApiSharepointV1TenantsByTenantIdAdminAccessResponses[keyof GetApiSharepointV1TenantsByTenantIdAdminAccessResponses];

export type GetApiSharepointV1TenantsByTenantIdSitesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/sites";
};

export type GetApiSharepointV1TenantsByTenantIdSitesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSharepointV1TenantsByTenantIdSitesError =
  GetApiSharepointV1TenantsByTenantIdSitesErrors[keyof GetApiSharepointV1TenantsByTenantIdSitesErrors];

export type GetApiSharepointV1TenantsByTenantIdSitesResponses = {
  /**
   * Successful Response
   */
  200: SharepointSitesResultV1;
};

export type GetApiSharepointV1TenantsByTenantIdSitesResponse =
  GetApiSharepointV1TenantsByTenantIdSitesResponses[keyof GetApiSharepointV1TenantsByTenantIdSitesResponses];

export type PostApiSharepointV1TenantsByTenantIdSitesData = {
  body: CreateSharepointSiteParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/sites";
};

export type PostApiSharepointV1TenantsByTenantIdSitesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSharepointV1TenantsByTenantIdSitesError =
  PostApiSharepointV1TenantsByTenantIdSitesErrors[keyof PostApiSharepointV1TenantsByTenantIdSitesErrors];

export type PostApiSharepointV1TenantsByTenantIdSitesResponses = {
  /**
   * Successful Response
   */
  200: SharepointGrantedSiteV1;
};

export type PostApiSharepointV1TenantsByTenantIdSitesResponse =
  PostApiSharepointV1TenantsByTenantIdSitesResponses[keyof PostApiSharepointV1TenantsByTenantIdSitesResponses];

export type PostApiSharepointV1TenantsByTenantIdSitesGrantData = {
  body: GrantSharepointSiteParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/sites/grant";
};

export type PostApiSharepointV1TenantsByTenantIdSitesGrantErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSharepointV1TenantsByTenantIdSitesGrantError =
  PostApiSharepointV1TenantsByTenantIdSitesGrantErrors[keyof PostApiSharepointV1TenantsByTenantIdSitesGrantErrors];

export type PostApiSharepointV1TenantsByTenantIdSitesGrantResponses = {
  /**
   * Successful Response
   */
  200: SharepointGrantedSiteV1;
};

export type PostApiSharepointV1TenantsByTenantIdSitesGrantResponse =
  PostApiSharepointV1TenantsByTenantIdSitesGrantResponses[keyof PostApiSharepointV1TenantsByTenantIdSitesGrantResponses];

export type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Site Id
     */
    site_id: string;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/sites/{site_id}";
};

export type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdError =
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdErrors[keyof DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdErrors];

export type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponses = {
  /**
   * Successful Response
   */
  200: SharepointGrantedSiteV1;
};

export type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponse =
  DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponses[keyof DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponses];

export type GetApiSharepointV1TenantsByTenantIdFolderScopesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/folder-scopes";
};

export type GetApiSharepointV1TenantsByTenantIdFolderScopesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSharepointV1TenantsByTenantIdFolderScopesError =
  GetApiSharepointV1TenantsByTenantIdFolderScopesErrors[keyof GetApiSharepointV1TenantsByTenantIdFolderScopesErrors];

export type GetApiSharepointV1TenantsByTenantIdFolderScopesResponses = {
  /**
   * Successful Response
   */
  200: SharepointFolderScopesResultV1;
};

export type GetApiSharepointV1TenantsByTenantIdFolderScopesResponse =
  GetApiSharepointV1TenantsByTenantIdFolderScopesResponses[keyof GetApiSharepointV1TenantsByTenantIdFolderScopesResponses];

export type PostApiSharepointV1TenantsByTenantIdFolderScopesData = {
  body: CreateSharepointFolderScopeParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/sharepoint/v1/tenants/{tenant_id}/folder-scopes";
};

export type PostApiSharepointV1TenantsByTenantIdFolderScopesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSharepointV1TenantsByTenantIdFolderScopesError =
  PostApiSharepointV1TenantsByTenantIdFolderScopesErrors[keyof PostApiSharepointV1TenantsByTenantIdFolderScopesErrors];

export type PostApiSharepointV1TenantsByTenantIdFolderScopesResponses = {
  /**
   * Successful Response
   */
  200: SharepointFolderScopeV1;
};

export type PostApiSharepointV1TenantsByTenantIdFolderScopesResponse =
  PostApiSharepointV1TenantsByTenantIdFolderScopesResponses[keyof PostApiSharepointV1TenantsByTenantIdFolderScopesResponses];

export type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Folder Scope Id
       */
      folder_scope_id: number;
    };
    query?: never;
    url: "/api/sharepoint/v1/tenants/{tenant_id}/folder-scopes/{folder_scope_id}";
  };

export type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdError =
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdErrors[keyof DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdErrors];

export type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponses =
  {
    /**
     * Successful Response
     */
    200: SharepointFolderScopeV1;
  };

export type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponse =
  DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponses[keyof DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponses];

export type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageData = {
  body: SlackPostChatMessageRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/post-chat-message";
};

export type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageError =
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageErrors[keyof PostApiSlackV2TenantsByTenantIdActionsPostChatMessageErrors];

export type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponses = {
  /**
   * Successful Response
   */
  200: SlackPostChatMessageResponseV2;
};

export type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponse =
  PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponses[keyof PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponses];

export type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageData = {
  body: SlackUpdateChatMessageRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/update-chat-message";
};

export type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageError =
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageErrors[keyof PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageErrors];

export type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponses = {
  /**
   * Successful Response
   */
  200: SlackUpdateChatMessageResponseV2;
};

export type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponse =
  PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponses[keyof PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponses];

export type PostApiSlackV2TenantsByTenantIdActionsAddReactionData = {
  body: SlackAddReactionRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/add-reaction";
};

export type PostApiSlackV2TenantsByTenantIdActionsAddReactionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV2TenantsByTenantIdActionsAddReactionError =
  PostApiSlackV2TenantsByTenantIdActionsAddReactionErrors[keyof PostApiSlackV2TenantsByTenantIdActionsAddReactionErrors];

export type PostApiSlackV2TenantsByTenantIdActionsAddReactionResponses = {
  /**
   * Successful Response
   */
  200: SlackAddReactionResponseV2;
};

export type PostApiSlackV2TenantsByTenantIdActionsAddReactionResponse =
  PostApiSlackV2TenantsByTenantIdActionsAddReactionResponses[keyof PostApiSlackV2TenantsByTenantIdActionsAddReactionResponses];

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicData = {
  body: SlackSetChannelTopicRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/set-channel-topic";
};

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicError =
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicErrors[keyof PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicErrors];

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponses = {
  /**
   * Successful Response
   */
  200: SlackSetChannelTopicResponseV2;
};

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponse =
  PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponses[keyof PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponses];

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionData = {
  body: SlackSetChannelDescriptionRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/set-channel-description";
};

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionError =
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionErrors[keyof PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionErrors];

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponses =
  {
    /**
     * Successful Response
     */
    200: SlackSetChannelDescriptionResponseV2;
  };

export type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponse =
  PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponses[keyof PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponses];

export type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusData = {
  body: SlackSetAssistantStatusRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/set-assistant-status";
};

export type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusError =
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusErrors[keyof PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusErrors];

export type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponses =
  {
    /**
     * Successful Response
     */
    200: SlackSetAssistantStatusResponseV2;
  };

export type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponse =
  PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponses[keyof PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponses];

export type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsData = {
  body: SlackSetSuggestedPromptsRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/set-suggested-prompts";
};

export type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsError =
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsErrors[keyof PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsErrors];

export type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponses =
  {
    /**
     * Successful Response
     */
    200: SlackSetSuggestedPromptsResponseV1;
  };

export type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponse =
  PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponses[keyof PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponses];

export type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleData = {
  body: SlackSetAssistantTitleRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/set-assistant-title";
};

export type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleError =
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleErrors[keyof PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleErrors];

export type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponses = {
  /**
   * Successful Response
   */
  200: SlackSetAssistantTitleResponseV1;
};

export type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponse =
  PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponses[keyof PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponses];

export type PostApiSlackV1TenantsByTenantIdActionsViewsOpenData = {
  body: SlackOpenViewRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/views/open";
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsOpenErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsOpenError =
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenErrors[keyof PostApiSlackV1TenantsByTenantIdActionsViewsOpenErrors];

export type PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponses = {
  /**
   * Successful Response
   */
  200: SlackOpenViewResponseV1;
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponse =
  PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponses[keyof PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponses];

export type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateData = {
  body: SlackUpdateViewRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/views/update";
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateError =
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateErrors[keyof PostApiSlackV1TenantsByTenantIdActionsViewsUpdateErrors];

export type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponses = {
  /**
   * Successful Response
   */
  200: SlackUpdateViewResponseV1;
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponse =
  PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponses[keyof PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponses];

export type PostApiSlackV1TenantsByTenantIdActionsViewsPushData = {
  body: SlackPushViewRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/views/push";
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsPushErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsPushError =
  PostApiSlackV1TenantsByTenantIdActionsViewsPushErrors[keyof PostApiSlackV1TenantsByTenantIdActionsViewsPushErrors];

export type PostApiSlackV1TenantsByTenantIdActionsViewsPushResponses = {
  /**
   * Successful Response
   */
  200: SlackPushViewResponseV1;
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsPushResponse =
  PostApiSlackV1TenantsByTenantIdActionsViewsPushResponses[keyof PostApiSlackV1TenantsByTenantIdActionsViewsPushResponses];

export type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeData = {
  body: SlackPublishHomeViewRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/views/publish-home";
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeError =
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeErrors[keyof PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeErrors];

export type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponses = {
  /**
   * Successful Response
   */
  200: SlackPublishHomeViewResponseV1;
};

export type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponse =
  PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponses[keyof PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponses];

export type PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * File Id
     */
    file_id: string;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/files/{file_id}/download";
};

export type PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadError =
  PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadErrors[keyof PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadErrors];

export type PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadResponses =
  {
    /**
     * Successful Response
     */
    200: unknown;
  };

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadData = {
  body: BodySlackUploadFilesV2ApiSlackV2TenantsTenantIdActionsFilesUploadPost;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/files/upload";
};

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadError =
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadErrors[keyof PostApiSlackV2TenantsByTenantIdActionsFilesUploadErrors];

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponses = {
  /**
   * Successful Response
   */
  200: SlackUploadFilesResponseV2;
};

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponse =
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponses[keyof PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponses];

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentData = {
  body: SlackUploadContentRequestV2;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/files/upload-content";
};

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentError =
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentErrors[keyof PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentErrors];

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponses =
  {
    /**
     * Successful Response
     */
    200: SlackUploadFilesResponseV2;
  };

export type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponse =
  PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponses[keyof PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponses];

export type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * User Id
     */
    user_id: string;
  };
  query?: never;
  url: "/api/slack/v2/tenants/{tenant_id}/actions/users/{user_id}";
};

export type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdError =
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdErrors[keyof GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdErrors];

export type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponses = {
  /**
   * Successful Response
   */
  200: SlackGetUserInfoResponseV2;
};

export type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponse =
  GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponses[keyof GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponses];

export type GetApiSlackV2TenantsByTenantIdActionsUsersData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Cursor
     */
    cursor?: string | null;
  };
  url: "/api/slack/v2/tenants/{tenant_id}/actions/users";
};

export type GetApiSlackV2TenantsByTenantIdActionsUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSlackV2TenantsByTenantIdActionsUsersError =
  GetApiSlackV2TenantsByTenantIdActionsUsersErrors[keyof GetApiSlackV2TenantsByTenantIdActionsUsersErrors];

export type GetApiSlackV2TenantsByTenantIdActionsUsersResponses = {
  /**
   * Successful Response
   */
  200: SlackListUsersResponseV2;
};

export type GetApiSlackV2TenantsByTenantIdActionsUsersResponse =
  GetApiSlackV2TenantsByTenantIdActionsUsersResponses[keyof GetApiSlackV2TenantsByTenantIdActionsUsersResponses];

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Channel
       */
      channel: string;
    };
    query?: {
      /**
       * Limit
       */
      limit?: number;
      /**
       * Before Ts
       */
      before_ts?: string | null;
    };
    url: "/api/slack/v2/tenants/{tenant_id}/actions/channels/{channel}/messages";
  };

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesError =
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesErrors[keyof GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesErrors];

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponses =
  {
    /**
     * Successful Response
     */
    200: SlackGetChannelMessagesResponseV2;
  };

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponse =
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponses[keyof GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponses];

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Channel
       */
      channel: string;
      /**
       * Ts
       */
      ts: string;
    };
    query?: never;
    url: "/api/slack/v2/tenants/{tenant_id}/actions/channels/{channel}/messages/{ts}/reactions";
  };

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsError =
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsErrors[keyof GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsErrors];

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponses =
  {
    /**
     * Successful Response
     */
    200: SlackGetReactionsResponseV2;
  };

export type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponse =
  GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponses[keyof GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponses];

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/user-groups";
};

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsError =
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsErrors[keyof GetApiSlackV1TenantsByTenantIdActionsUserGroupsErrors];

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponses = {
  /**
   * Successful Response
   */
  200: SlackGetUserGroupsResponseV1;
};

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponse =
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponses[keyof GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponses];

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Usergroup Id
       */
      usergroup_id: string;
    };
    query?: never;
    url: "/api/slack/v1/tenants/{tenant_id}/actions/user-groups/{usergroup_id}/users";
  };

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersError =
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersErrors[keyof GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersErrors];

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponses =
  {
    /**
     * Successful Response
     */
    200: SlackGetUserGroupUsersResponseV1;
  };

export type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponse =
  GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponses[keyof GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponses];

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersData = {
  body: SlackUpdateUserGroupUsersRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/update-user-group-users";
};

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersError =
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersErrors[keyof PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersErrors];

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponses =
  {
    /**
     * Successful Response
     */
    200: SlackUserGroupV1;
  };

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponse =
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponses[keyof PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponses];

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupData = {
  body: SlackUpdateUserGroupRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/actions/update-user-group";
};

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupError =
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupErrors[keyof PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupErrors];

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponses = {
  /**
   * Successful Response
   */
  200: SlackUserGroupV1;
};

export type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponse =
  PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponses[keyof PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponses];

export type GetApiSlackV1OauthScopesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/slack/v1/oauth-scopes";
};

export type GetApiSlackV1OauthScopesResponses = {
  /**
   * Successful Response
   */
  200: SlackOauthScopesResponseV1;
};

export type GetApiSlackV1OauthScopesResponse =
  GetApiSlackV1OauthScopesResponses[keyof GetApiSlackV1OauthScopesResponses];

export type GetApiSlackV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/slack/v1/tenants";
};

export type GetApiSlackV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSlackV1TenantsError =
  GetApiSlackV1TenantsErrors[keyof GetApiSlackV1TenantsErrors];

export type GetApiSlackV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1SlackTenantV1;
};

export type GetApiSlackV1TenantsResponse =
  GetApiSlackV1TenantsResponses[keyof GetApiSlackV1TenantsResponses];

export type PostApiSlackV1TenantsData = {
  body: CreateSlackTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/slack/v1/tenants";
};

export type PostApiSlackV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsError =
  PostApiSlackV1TenantsErrors[keyof PostApiSlackV1TenantsErrors];

export type PostApiSlackV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: SlackTenantV1;
};

export type PostApiSlackV1TenantsResponse =
  PostApiSlackV1TenantsResponses[keyof PostApiSlackV1TenantsResponses];

export type GetApiSlackV1FullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/slack/v1/full-tenants";
};

export type GetApiSlackV1FullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSlackV1FullTenantsError =
  GetApiSlackV1FullTenantsErrors[keyof GetApiSlackV1FullTenantsErrors];

export type GetApiSlackV1FullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1SlackTenantFullV1;
};

export type GetApiSlackV1FullTenantsResponse =
  GetApiSlackV1FullTenantsResponses[keyof GetApiSlackV1FullTenantsResponses];

export type DeleteApiSlackV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}";
};

export type DeleteApiSlackV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiSlackV1TenantsByTenantIdError =
  DeleteApiSlackV1TenantsByTenantIdErrors[keyof DeleteApiSlackV1TenantsByTenantIdErrors];

export type DeleteApiSlackV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SlackTenantV1;
};

export type DeleteApiSlackV1TenantsByTenantIdResponse =
  DeleteApiSlackV1TenantsByTenantIdResponses[keyof DeleteApiSlackV1TenantsByTenantIdResponses];

export type GetApiSlackV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}";
};

export type GetApiSlackV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSlackV1TenantsByTenantIdError =
  GetApiSlackV1TenantsByTenantIdErrors[keyof GetApiSlackV1TenantsByTenantIdErrors];

export type GetApiSlackV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SlackTenantFullV1;
};

export type GetApiSlackV1TenantsByTenantIdResponse =
  GetApiSlackV1TenantsByTenantIdResponses[keyof GetApiSlackV1TenantsByTenantIdResponses];

export type PatchApiSlackV1TenantsByTenantIdData = {
  body: UpdateSlackTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}";
};

export type PatchApiSlackV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiSlackV1TenantsByTenantIdError =
  PatchApiSlackV1TenantsByTenantIdErrors[keyof PatchApiSlackV1TenantsByTenantIdErrors];

export type PatchApiSlackV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SlackTenantV1;
};

export type PatchApiSlackV1TenantsByTenantIdResponse =
  PatchApiSlackV1TenantsByTenantIdResponses[keyof PatchApiSlackV1TenantsByTenantIdResponses];

export type GetApiSlackV1TenantsByTenantIdManifestData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/manifest";
};

export type GetApiSlackV1TenantsByTenantIdManifestErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSlackV1TenantsByTenantIdManifestError =
  GetApiSlackV1TenantsByTenantIdManifestErrors[keyof GetApiSlackV1TenantsByTenantIdManifestErrors];

export type GetApiSlackV1TenantsByTenantIdManifestResponses = {
  /**
   * Successful Response
   */
  200: SlackAppManifestV1;
};

export type GetApiSlackV1TenantsByTenantIdManifestResponse =
  GetApiSlackV1TenantsByTenantIdManifestResponses[keyof GetApiSlackV1TenantsByTenantIdManifestResponses];

export type PostApiSlackV1TenantsByTenantIdConnectData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/connect";
};

export type PostApiSlackV1TenantsByTenantIdConnectErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdConnectError =
  PostApiSlackV1TenantsByTenantIdConnectErrors[keyof PostApiSlackV1TenantsByTenantIdConnectErrors];

export type PostApiSlackV1TenantsByTenantIdConnectResponses = {
  /**
   * Successful Response
   */
  200: SlackConnectResponseV1;
};

export type PostApiSlackV1TenantsByTenantIdConnectResponse =
  PostApiSlackV1TenantsByTenantIdConnectResponses[keyof PostApiSlackV1TenantsByTenantIdConnectResponses];

export type PostApiSlackV1TenantsByTenantIdCallbackData = {
  body: SlackCallbackPayloadV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/callback";
};

export type PostApiSlackV1TenantsByTenantIdCallbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiSlackV1TenantsByTenantIdCallbackError =
  PostApiSlackV1TenantsByTenantIdCallbackErrors[keyof PostApiSlackV1TenantsByTenantIdCallbackErrors];

export type PostApiSlackV1TenantsByTenantIdCallbackResponses = {
  /**
   * Successful Response
   */
  200: SlackTenantV1;
};

export type PostApiSlackV1TenantsByTenantIdCallbackResponse =
  PostApiSlackV1TenantsByTenantIdCallbackResponses[keyof PostApiSlackV1TenantsByTenantIdCallbackResponses];

export type GetApiSlackV1TenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/slack/v1/tenants/{tenant_id}/check-connection";
};

export type GetApiSlackV1TenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiSlackV1TenantsByTenantIdCheckConnectionError =
  GetApiSlackV1TenantsByTenantIdCheckConnectionErrors[keyof GetApiSlackV1TenantsByTenantIdCheckConnectionErrors];

export type GetApiSlackV1TenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: SlackCheckConnectionResponseV1;
};

export type GetApiSlackV1TenantsByTenantIdCheckConnectionResponse =
  GetApiSlackV1TenantsByTenantIdCheckConnectionResponses[keyof GetApiSlackV1TenantsByTenantIdCheckConnectionResponses];

export type GetApiV2TasksData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v2/tasks";
};

export type GetApiV2TasksErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2TasksError = GetApiV2TasksErrors[keyof GetApiV2TasksErrors];

export type GetApiV2TasksResponses = {
  /**
   * Successful Response
   */
  200: PageV1TaskV2;
};

export type GetApiV2TasksResponse =
  GetApiV2TasksResponses[keyof GetApiV2TasksResponses];

export type PostApiV2TasksData = {
  body: CreateTaskParamsV2;
  path?: never;
  query?: never;
  url: "/api/v2/tasks";
};

export type PostApiV2TasksErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2TasksError =
  PostApiV2TasksErrors[keyof PostApiV2TasksErrors];

export type PostApiV2TasksResponses = {
  /**
   * Successful Response
   */
  200: TaskV2;
};

export type PostApiV2TasksResponse =
  PostApiV2TasksResponses[keyof PostApiV2TasksResponses];

export type DeleteApiV2TasksByTaskIdData = {
  body?: never;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: never;
  url: "/api/v2/tasks/{task_id}";
};

export type DeleteApiV2TasksByTaskIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV2TasksByTaskIdError =
  DeleteApiV2TasksByTaskIdErrors[keyof DeleteApiV2TasksByTaskIdErrors];

export type DeleteApiV2TasksByTaskIdResponses = {
  /**
   * Successful Response
   */
  200: TaskV2;
};

export type DeleteApiV2TasksByTaskIdResponse =
  DeleteApiV2TasksByTaskIdResponses[keyof DeleteApiV2TasksByTaskIdResponses];

export type GetApiV2TasksByTaskIdData = {
  body?: never;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: never;
  url: "/api/v2/tasks/{task_id}";
};

export type GetApiV2TasksByTaskIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV2TasksByTaskIdError =
  GetApiV2TasksByTaskIdErrors[keyof GetApiV2TasksByTaskIdErrors];

export type GetApiV2TasksByTaskIdResponses = {
  /**
   * Successful Response
   */
  200: TaskFullV2;
};

export type GetApiV2TasksByTaskIdResponse =
  GetApiV2TasksByTaskIdResponses[keyof GetApiV2TasksByTaskIdResponses];

export type PatchApiV2TasksByTaskIdData = {
  body: UpdateTaskParamsV2;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: never;
  url: "/api/v2/tasks/{task_id}";
};

export type PatchApiV2TasksByTaskIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV2TasksByTaskIdError =
  PatchApiV2TasksByTaskIdErrors[keyof PatchApiV2TasksByTaskIdErrors];

export type PatchApiV2TasksByTaskIdResponses = {
  /**
   * Successful Response
   */
  200: TaskV2;
};

export type PatchApiV2TasksByTaskIdResponse =
  PatchApiV2TasksByTaskIdResponses[keyof PatchApiV2TasksByTaskIdResponses];

export type PostApiV2TasksByTaskIdRestoreData = {
  body?: never;
  path: {
    /**
     * Task Id
     */
    task_id: number;
  };
  query?: never;
  url: "/api/v2/tasks/{task_id}/restore";
};

export type PostApiV2TasksByTaskIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV2TasksByTaskIdRestoreError =
  PostApiV2TasksByTaskIdRestoreErrors[keyof PostApiV2TasksByTaskIdRestoreErrors];

export type PostApiV2TasksByTaskIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: TaskV2;
};

export type PostApiV2TasksByTaskIdRestoreResponse =
  PostApiV2TasksByTaskIdRestoreResponses[keyof PostApiV2TasksByTaskIdRestoreResponses];

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostData = {
  body: TeamsPostMessageRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}/actions/messages/post";
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostError =
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsMessagesPostErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponses = {
  /**
   * Successful Response
   */
  200: TeamsPostMessageResponseV1;
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponse =
  PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponses[keyof PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponses];

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateData = {
  body: TeamsUpdateMessageRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}/actions/messages/update";
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateError =
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponses = {
  /**
   * Successful Response
   */
  200: TeamsUpdateMessageResponseV1;
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponse =
  PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponses[keyof PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponses];

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteData = {
  body: TeamsDeleteMessageRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}/actions/messages/delete";
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteError =
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponses = {
  /**
   * Successful Response
   */
  200: TeamsDeleteMessageResponseV1;
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponse =
  PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponses[keyof PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponses];

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveData = {
  body: TeamsSendProactiveMessageRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}/actions/messages/send-proactive";
};

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveError =
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponses =
  {
    /**
     * Successful Response
     */
    200: TeamsSendProactiveMessageResponseV1;
  };

export type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponse =
  PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponses[keyof PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponses];

export type PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadData = {
  body: TeamsDownloadFileRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}/actions/files/download";
};

export type PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadError =
  PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetData =
  {
    body: TeamsGetConversationMemberRequestV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/teams/v1/tenants/{tenant_id}/actions/conversations/members/get";
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetError =
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponses =
  {
    /**
     * Successful Response
     */
    200: TeamsGetConversationMemberResponseV1;
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponse =
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponses[keyof PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponses];

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListData =
  {
    body: TeamsListConversationMembersRequestV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/teams/v1/tenants/{tenant_id}/actions/conversations/members/list";
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListError =
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponses =
  {
    /**
     * Successful Response
     */
    200: TeamsListConversationMembersResponseV1;
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponse =
  PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponses[keyof PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponses];

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListData =
  {
    body: TeamsListConversationActivitiesRequestV1;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/teams/v1/tenants/{tenant_id}/actions/conversations/activities/list";
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListError =
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponses =
  {
    /**
     * Successful Response
     */
    200: TeamsListConversationActivitiesResponseV1;
  };

export type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponse =
  PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponses[keyof PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponses];

export type GetApiTeamsV1TenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/teams/v1/tenants";
};

export type GetApiTeamsV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiTeamsV1TenantsError =
  GetApiTeamsV1TenantsErrors[keyof GetApiTeamsV1TenantsErrors];

export type GetApiTeamsV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1TeamsTenantV1;
};

export type GetApiTeamsV1TenantsResponse =
  GetApiTeamsV1TenantsResponses[keyof GetApiTeamsV1TenantsResponses];

export type PostApiTeamsV1TenantsData = {
  body: CreateTeamsTenantParamsV1;
  path?: never;
  query?: never;
  url: "/api/teams/v1/tenants";
};

export type PostApiTeamsV1TenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiTeamsV1TenantsError =
  PostApiTeamsV1TenantsErrors[keyof PostApiTeamsV1TenantsErrors];

export type PostApiTeamsV1TenantsResponses = {
  /**
   * Successful Response
   */
  200: TeamsTenantV1;
};

export type PostApiTeamsV1TenantsResponse =
  PostApiTeamsV1TenantsResponses[keyof PostApiTeamsV1TenantsResponses];

export type GetApiTeamsV1FullTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/teams/v1/full-tenants";
};

export type GetApiTeamsV1FullTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiTeamsV1FullTenantsError =
  GetApiTeamsV1FullTenantsErrors[keyof GetApiTeamsV1FullTenantsErrors];

export type GetApiTeamsV1FullTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV1TeamsTenantFullV1;
};

export type GetApiTeamsV1FullTenantsResponse =
  GetApiTeamsV1FullTenantsResponses[keyof GetApiTeamsV1FullTenantsResponses];

export type DeleteApiTeamsV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}";
};

export type DeleteApiTeamsV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiTeamsV1TenantsByTenantIdError =
  DeleteApiTeamsV1TenantsByTenantIdErrors[keyof DeleteApiTeamsV1TenantsByTenantIdErrors];

export type DeleteApiTeamsV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: TeamsTenantV1;
};

export type DeleteApiTeamsV1TenantsByTenantIdResponse =
  DeleteApiTeamsV1TenantsByTenantIdResponses[keyof DeleteApiTeamsV1TenantsByTenantIdResponses];

export type GetApiTeamsV1TenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}";
};

export type GetApiTeamsV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiTeamsV1TenantsByTenantIdError =
  GetApiTeamsV1TenantsByTenantIdErrors[keyof GetApiTeamsV1TenantsByTenantIdErrors];

export type GetApiTeamsV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: TeamsTenantFullV1;
};

export type GetApiTeamsV1TenantsByTenantIdResponse =
  GetApiTeamsV1TenantsByTenantIdResponses[keyof GetApiTeamsV1TenantsByTenantIdResponses];

export type PatchApiTeamsV1TenantsByTenantIdData = {
  body: UpdateTeamsTenantParamsV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}";
};

export type PatchApiTeamsV1TenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiTeamsV1TenantsByTenantIdError =
  PatchApiTeamsV1TenantsByTenantIdErrors[keyof PatchApiTeamsV1TenantsByTenantIdErrors];

export type PatchApiTeamsV1TenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: TeamsTenantV1;
};

export type PatchApiTeamsV1TenantsByTenantIdResponse =
  PatchApiTeamsV1TenantsByTenantIdResponses[keyof PatchApiTeamsV1TenantsByTenantIdResponses];

export type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}/actions/check-connection";
};

export type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionError =
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionErrors[keyof PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionErrors];

export type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: TeamsCheckConnectionResponseV1;
};

export type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponse =
  PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponses[keyof PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponses];

export type GetApiTeamsV1TenantsByTenantIdIconsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    kind: TeamsIconKindV1;
  };
  url: "/api/teams/v1/tenants/{tenant_id}/icons";
};

export type GetApiTeamsV1TenantsByTenantIdIconsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiTeamsV1TenantsByTenantIdIconsError =
  GetApiTeamsV1TenantsByTenantIdIconsErrors[keyof GetApiTeamsV1TenantsByTenantIdIconsErrors];

export type GetApiTeamsV1TenantsByTenantIdIconsResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiTeamsV1TenantsByTenantIdIconsData = {
  body: BodyTeamsUploadIconV1ApiTeamsV1TenantsTenantIdIconsPost;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    kind: TeamsIconKindV1;
  };
  url: "/api/teams/v1/tenants/{tenant_id}/icons";
};

export type PostApiTeamsV1TenantsByTenantIdIconsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiTeamsV1TenantsByTenantIdIconsError =
  PostApiTeamsV1TenantsByTenantIdIconsErrors[keyof PostApiTeamsV1TenantsByTenantIdIconsErrors];

export type PostApiTeamsV1TenantsByTenantIdIconsResponses = {
  /**
   * Successful Response
   */
  204: void;
};

export type PostApiTeamsV1TenantsByTenantIdIconsResponse =
  PostApiTeamsV1TenantsByTenantIdIconsResponses[keyof PostApiTeamsV1TenantsByTenantIdIconsResponses];

export type GetApiTeamsV1TenantsByTenantIdManifestData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/teams/v1/tenants/{tenant_id}/manifest";
};

export type GetApiTeamsV1TenantsByTenantIdManifestErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiTeamsV1TenantsByTenantIdManifestError =
  GetApiTeamsV1TenantsByTenantIdManifestErrors[keyof GetApiTeamsV1TenantsByTenantIdManifestErrors];

export type GetApiTeamsV1TenantsByTenantIdManifestResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiTeamsV1TenantsByTenantIdInstallsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/teams/v1/tenants/{tenant_id}/installs";
};

export type GetApiTeamsV1TenantsByTenantIdInstallsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiTeamsV1TenantsByTenantIdInstallsError =
  GetApiTeamsV1TenantsByTenantIdInstallsErrors[keyof GetApiTeamsV1TenantsByTenantIdInstallsErrors];

export type GetApiTeamsV1TenantsByTenantIdInstallsResponses = {
  /**
   * Successful Response
   */
  200: PageV1TeamsEndCustomerInstallV1;
};

export type GetApiTeamsV1TenantsByTenantIdInstallsResponse =
  GetApiTeamsV1TenantsByTenantIdInstallsResponses[keyof GetApiTeamsV1TenantsByTenantIdInstallsResponses];

export type GetApiV1UsageStatsAgentsData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Organization Id
     */
    organization_id: number;
    /**
     * Start Date
     */
    start_date: Date;
    /**
     * End Date
     */
    end_date: Date;
    /**
     * Agent Keys
     */
    agent_keys?: Array<string> | null;
    /**
     * User Ids
     */
    user_ids?: Array<number> | null;
  };
  url: "/api/v1/usage-stats/agents";
};

export type GetApiV1UsageStatsAgentsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1UsageStatsAgentsError =
  GetApiV1UsageStatsAgentsErrors[keyof GetApiV1UsageStatsAgentsErrors];

export type GetApiV1UsageStatsAgentsResponses = {
  /**
   * Successful Response
   */
  200: AgentUsageStatsResponseV1;
};

export type GetApiV1UsageStatsAgentsResponse =
  GetApiV1UsageStatsAgentsResponses[keyof GetApiV1UsageStatsAgentsResponses];

export type GetApiV1UsersData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
    /**
     * User Ids
     */
    user_ids?: Array<number> | null;
    /**
     * External Ids
     */
    external_ids?: Array<string> | null;
  };
  url: "/api/v1/users";
};

export type GetApiV1UsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1UsersError = GetApiV1UsersErrors[keyof GetApiV1UsersErrors];

export type GetApiV1UsersResponses = {
  /**
   * Successful Response
   */
  200: PageV1UserFullV1;
};

export type GetApiV1UsersResponse =
  GetApiV1UsersResponses[keyof GetApiV1UsersResponses];

export type GetApiV1UsersMeData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/users/me";
};

export type GetApiV1UsersMeResponses = {
  /**
   * Successful Response
   */
  200: UserFullV1;
};

export type GetApiV1UsersMeResponse =
  GetApiV1UsersMeResponses[keyof GetApiV1UsersMeResponses];

export type PatchApiV1UsersMeData = {
  body: UpdateCurrentUserParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/users/me";
};

export type PatchApiV1UsersMeErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1UsersMeError =
  PatchApiV1UsersMeErrors[keyof PatchApiV1UsersMeErrors];

export type PatchApiV1UsersMeResponses = {
  /**
   * Successful Response
   */
  200: UserV1;
};

export type PatchApiV1UsersMeResponse =
  PatchApiV1UsersMeResponses[keyof PatchApiV1UsersMeResponses];

export type DeleteApiV1UsersByUserIdData = {
  body?: never;
  path: {
    /**
     * User Id
     */
    user_id: number;
  };
  query?: never;
  url: "/api/v1/users/{user_id}";
};

export type DeleteApiV1UsersByUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1UsersByUserIdError =
  DeleteApiV1UsersByUserIdErrors[keyof DeleteApiV1UsersByUserIdErrors];

export type DeleteApiV1UsersByUserIdResponses = {
  /**
   * Successful Response
   */
  200: UserFullV1;
};

export type DeleteApiV1UsersByUserIdResponse =
  DeleteApiV1UsersByUserIdResponses[keyof DeleteApiV1UsersByUserIdResponses];

export type GetApiV1UsersByUserIdData = {
  body?: never;
  path: {
    /**
     * User Id
     */
    user_id: number;
  };
  query?: never;
  url: "/api/v1/users/{user_id}";
};

export type GetApiV1UsersByUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1UsersByUserIdError =
  GetApiV1UsersByUserIdErrors[keyof GetApiV1UsersByUserIdErrors];

export type GetApiV1UsersByUserIdResponses = {
  /**
   * Successful Response
   */
  200: UserFullV1;
};

export type GetApiV1UsersByUserIdResponse =
  GetApiV1UsersByUserIdResponses[keyof GetApiV1UsersByUserIdResponses];

export type PostApiV1UsersBotData = {
  body: CreateBotUserParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/users/bot";
};

export type PostApiV1UsersBotErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1UsersBotError =
  PostApiV1UsersBotErrors[keyof PostApiV1UsersBotErrors];

export type PostApiV1UsersBotResponses = {
  /**
   * Successful Response
   */
  200: UserFullV1;
};

export type PostApiV1UsersBotResponse =
  PostApiV1UsersBotResponses[keyof PostApiV1UsersBotResponses];

export type PutApiV1UsersExternalByExternalIdData = {
  body?: never;
  path: {
    /**
     * External Id
     */
    external_id: string;
  };
  query?: never;
  url: "/api/v1/users/external/{external_id}";
};

export type PutApiV1UsersExternalByExternalIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiV1UsersExternalByExternalIdError =
  PutApiV1UsersExternalByExternalIdErrors[keyof PutApiV1UsersExternalByExternalIdErrors];

export type PutApiV1UsersExternalByExternalIdResponses = {
  /**
   * Successful Response
   */
  200: UserV1;
};

export type PutApiV1UsersExternalByExternalIdResponse =
  PutApiV1UsersExternalByExternalIdResponses[keyof PutApiV1UsersExternalByExternalIdResponses];

export type PostApiV1UsersByUserIdRestoreData = {
  body?: never;
  path: {
    /**
     * User Id
     */
    user_id: number;
  };
  query?: never;
  url: "/api/v1/users/{user_id}/restore";
};

export type PostApiV1UsersByUserIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1UsersByUserIdRestoreError =
  PostApiV1UsersByUserIdRestoreErrors[keyof PostApiV1UsersByUserIdRestoreErrors];

export type PostApiV1UsersByUserIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: UserFullV1;
};

export type PostApiV1UsersByUserIdRestoreResponse =
  PostApiV1UsersByUserIdRestoreResponses[keyof PostApiV1UsersByUserIdRestoreResponses];

export type PostApiV1WorkClaimsData = {
  body: CreateWorkClaimParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/work-claims";
};

export type PostApiV1WorkClaimsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1WorkClaimsError =
  PostApiV1WorkClaimsErrors[keyof PostApiV1WorkClaimsErrors];

export type PostApiV1WorkClaimsResponses = {
  /**
   * Successful Response
   */
  200: CreateWorkClaimResponseV1;
};

export type PostApiV1WorkClaimsResponse =
  PostApiV1WorkClaimsResponses[keyof PostApiV1WorkClaimsResponses];

export type PostApiV1WorkClaimsByClaimIdCompleteData = {
  body?: never;
  path: {
    /**
     * Claim Id
     */
    claim_id: number;
  };
  query?: never;
  url: "/api/v1/work-claims/{claim_id}/complete";
};

export type PostApiV1WorkClaimsByClaimIdCompleteErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1WorkClaimsByClaimIdCompleteError =
  PostApiV1WorkClaimsByClaimIdCompleteErrors[keyof PostApiV1WorkClaimsByClaimIdCompleteErrors];

export type PostApiV1WorkClaimsByClaimIdCompleteResponses = {
  /**
   * Successful Response
   */
  200: WorkClaimV1;
};

export type PostApiV1WorkClaimsByClaimIdCompleteResponse =
  PostApiV1WorkClaimsByClaimIdCompleteResponses[keyof PostApiV1WorkClaimsByClaimIdCompleteResponses];

export type DeleteApiV1WorkClaimsByClaimIdData = {
  body?: never;
  path: {
    /**
     * Claim Id
     */
    claim_id: number;
  };
  query?: never;
  url: "/api/v1/work-claims/{claim_id}";
};

export type DeleteApiV1WorkClaimsByClaimIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1WorkClaimsByClaimIdError =
  DeleteApiV1WorkClaimsByClaimIdErrors[keyof DeleteApiV1WorkClaimsByClaimIdErrors];

export type DeleteApiV1WorkClaimsByClaimIdResponses = {
  /**
   * Successful Response
   */
  200: WorkClaimV1;
};

export type DeleteApiV1WorkClaimsByClaimIdResponse =
  DeleteApiV1WorkClaimsByClaimIdResponses[keyof DeleteApiV1WorkClaimsByClaimIdResponses];

export type PostApiV1WorkEventsData = {
  body: CreateWorkEventParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/work-events";
};

export type PostApiV1WorkEventsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1WorkEventsError =
  PostApiV1WorkEventsErrors[keyof PostApiV1WorkEventsErrors];

export type PostApiV1WorkEventsResponses = {
  /**
   * Successful Response
   */
  200: WorkEventV1;
};

export type PostApiV1WorkEventsResponse =
  PostApiV1WorkEventsResponses[keyof PostApiV1WorkEventsResponses];

export type GetApiV1WorkEventsByEventIdData = {
  body?: never;
  path: {
    /**
     * Event Id
     */
    event_id: number;
  };
  query?: never;
  url: "/api/v1/work-events/{event_id}";
};

export type GetApiV1WorkEventsByEventIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1WorkEventsByEventIdError =
  GetApiV1WorkEventsByEventIdErrors[keyof GetApiV1WorkEventsByEventIdErrors];

export type GetApiV1WorkEventsByEventIdResponses = {
  /**
   * Successful Response
   */
  200: WorkEventFullV1;
};

export type GetApiV1WorkEventsByEventIdResponse =
  GetApiV1WorkEventsByEventIdResponses[keyof GetApiV1WorkEventsByEventIdResponses];

export type GetApiV1FullWorkEventsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Stream Id
     */
    stream_id?: string | null;
    /**
     * Repo Id
     */
    repo_id?: number | null;
    /**
     * Git Object Id
     */
    git_object_id?: number | null;
    /**
     * After
     */
    after?: string | null;
    limit?: LimitV1;
  };
  url: "/api/v1/full-work-events";
};

export type GetApiV1FullWorkEventsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullWorkEventsError =
  GetApiV1FullWorkEventsErrors[keyof GetApiV1FullWorkEventsErrors];

export type GetApiV1FullWorkEventsResponses = {
  /**
   * Successful Response
   */
  200: CursorPageV1WorkEventFullV1;
};

export type GetApiV1FullWorkEventsResponse =
  GetApiV1FullWorkEventsResponses[keyof GetApiV1FullWorkEventsResponses];

export type GetApiV1WorkflowsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/workflows";
};

export type GetApiV1WorkflowsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1WorkflowsError =
  GetApiV1WorkflowsErrors[keyof GetApiV1WorkflowsErrors];

export type GetApiV1WorkflowsResponses = {
  /**
   * Successful Response
   */
  200: PageV1WorkflowV1;
};

export type GetApiV1WorkflowsResponse =
  GetApiV1WorkflowsResponses[keyof GetApiV1WorkflowsResponses];

export type GetApiV1FullWorkflowRunsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Workflow Id
     */
    workflow_id?: Array<number> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/full-workflow-runs";
};

export type GetApiV1FullWorkflowRunsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1FullWorkflowRunsError =
  GetApiV1FullWorkflowRunsErrors[keyof GetApiV1FullWorkflowRunsErrors];

export type GetApiV1FullWorkflowRunsResponses = {
  /**
   * Successful Response
   */
  200: PageV1WorkflowRunFullV1;
};

export type GetApiV1FullWorkflowRunsResponse =
  GetApiV1FullWorkflowRunsResponses[keyof GetApiV1FullWorkflowRunsResponses];

export type GetApiV1WorkflowRunsByWorkflowRunIdData = {
  body?: never;
  path: {
    /**
     * Workflow Run Id
     */
    workflow_run_id: number;
  };
  query?: never;
  url: "/api/v1/workflow-runs/{workflow_run_id}";
};

export type GetApiV1WorkflowRunsByWorkflowRunIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1WorkflowRunsByWorkflowRunIdError =
  GetApiV1WorkflowRunsByWorkflowRunIdErrors[keyof GetApiV1WorkflowRunsByWorkflowRunIdErrors];

export type GetApiV1WorkflowRunsByWorkflowRunIdResponses = {
  /**
   * Successful Response
   */
  200: WorkflowRunFullV1;
};

export type GetApiV1WorkflowRunsByWorkflowRunIdResponse =
  GetApiV1WorkflowRunsByWorkflowRunIdResponses[keyof GetApiV1WorkflowRunsByWorkflowRunIdResponses];

export type PatchApiV1WorkflowRunsByWorkflowRunIdData = {
  body: UpdateWorkflowRunRequestV1;
  path: {
    /**
     * Workflow Run Id
     */
    workflow_run_id: number;
  };
  query?: never;
  url: "/api/v1/workflow-runs/{workflow_run_id}";
};

export type PatchApiV1WorkflowRunsByWorkflowRunIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1WorkflowRunsByWorkflowRunIdError =
  PatchApiV1WorkflowRunsByWorkflowRunIdErrors[keyof PatchApiV1WorkflowRunsByWorkflowRunIdErrors];

export type PatchApiV1WorkflowRunsByWorkflowRunIdResponses = {
  /**
   * Successful Response
   */
  200: UpdateWorkflowRunResponseV1;
};

export type PatchApiV1WorkflowRunsByWorkflowRunIdResponse =
  PatchApiV1WorkflowRunsByWorkflowRunIdResponses[keyof PatchApiV1WorkflowRunsByWorkflowRunIdResponses];

export type GetApiV1WorkflowAnalyticsEventsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Workflow Run Id
     */
    workflow_run_id?: number | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/workflow-analytics-events";
};

export type GetApiV1WorkflowAnalyticsEventsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1WorkflowAnalyticsEventsError =
  GetApiV1WorkflowAnalyticsEventsErrors[keyof GetApiV1WorkflowAnalyticsEventsErrors];

export type GetApiV1WorkflowAnalyticsEventsResponses = {
  /**
   * Successful Response
   */
  200: PageV1WorkflowAnalyticsEventV1;
};

export type GetApiV1WorkflowAnalyticsEventsResponse =
  GetApiV1WorkflowAnalyticsEventsResponses[keyof GetApiV1WorkflowAnalyticsEventsResponses];

export type PostApiV1WorkflowAnalyticsEventsData = {
  body: CreateWorkflowAnalyticsEventRequestV1;
  headers: {
    /**
     * X-Edra-Workflow-Id
     */
    "X-Edra-Workflow-Id": number;
  };
  path?: never;
  query?: never;
  url: "/api/v1/workflow-analytics-events";
};

export type PostApiV1WorkflowAnalyticsEventsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1WorkflowAnalyticsEventsError =
  PostApiV1WorkflowAnalyticsEventsErrors[keyof PostApiV1WorkflowAnalyticsEventsErrors];

export type PostApiV1WorkflowAnalyticsEventsResponses = {
  /**
   * Successful Response
   */
  200: CreateWorkflowAnalyticsEventResponseV1;
};

export type PostApiV1WorkflowAnalyticsEventsResponse =
  PostApiV1WorkflowAnalyticsEventsResponses[keyof PostApiV1WorkflowAnalyticsEventsResponses];

export type GetApiV1WorkspacesData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/workspaces";
};

export type GetApiV1WorkspacesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1WorkspacesError =
  GetApiV1WorkspacesErrors[keyof GetApiV1WorkspacesErrors];

export type GetApiV1WorkspacesResponses = {
  /**
   * Successful Response
   */
  200: PageV2WorkspaceV1;
};

export type GetApiV1WorkspacesResponse =
  GetApiV1WorkspacesResponses[keyof GetApiV1WorkspacesResponses];

export type PostApiV1WorkspacesData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/workspaces";
};

export type PostApiV1WorkspacesResponses = {
  /**
   * Successful Response
   */
  200: WorkspaceV1;
};

export type PostApiV1WorkspacesResponse =
  PostApiV1WorkspacesResponses[keyof PostApiV1WorkspacesResponses];

export type DeleteApiV1WorkspacesByWorkspaceIdData = {
  body?: never;
  path: {
    /**
     * Workspace Id
     */
    workspace_id: number;
  };
  query?: never;
  url: "/api/v1/workspaces/{workspace_id}";
};

export type DeleteApiV1WorkspacesByWorkspaceIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1WorkspacesByWorkspaceIdError =
  DeleteApiV1WorkspacesByWorkspaceIdErrors[keyof DeleteApiV1WorkspacesByWorkspaceIdErrors];

export type DeleteApiV1WorkspacesByWorkspaceIdResponses = {
  /**
   * Successful Response
   */
  200: WorkspaceV1;
};

export type DeleteApiV1WorkspacesByWorkspaceIdResponse =
  DeleteApiV1WorkspacesByWorkspaceIdResponses[keyof DeleteApiV1WorkspacesByWorkspaceIdResponses];

export type GetApiV1WorkspacesByWorkspaceIdData = {
  body?: never;
  path: {
    /**
     * Workspace Id
     */
    workspace_id: number;
  };
  query?: never;
  url: "/api/v1/workspaces/{workspace_id}";
};

export type GetApiV1WorkspacesByWorkspaceIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1WorkspacesByWorkspaceIdError =
  GetApiV1WorkspacesByWorkspaceIdErrors[keyof GetApiV1WorkspacesByWorkspaceIdErrors];

export type GetApiV1WorkspacesByWorkspaceIdResponses = {
  /**
   * Successful Response
   */
  200: WorkspaceV1;
};

export type GetApiV1WorkspacesByWorkspaceIdResponse =
  GetApiV1WorkspacesByWorkspaceIdResponses[keyof GetApiV1WorkspacesByWorkspaceIdResponses];

export type PostApiV1WorkspacesByWorkspaceIdRestoreData = {
  body?: never;
  path: {
    /**
     * Workspace Id
     */
    workspace_id: number;
  };
  query?: never;
  url: "/api/v1/workspaces/{workspace_id}/restore";
};

export type PostApiV1WorkspacesByWorkspaceIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1WorkspacesByWorkspaceIdRestoreError =
  PostApiV1WorkspacesByWorkspaceIdRestoreErrors[keyof PostApiV1WorkspacesByWorkspaceIdRestoreErrors];

export type PostApiV1WorkspacesByWorkspaceIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: WorkspaceV1;
};

export type PostApiV1WorkspacesByWorkspaceIdRestoreResponse =
  PostApiV1WorkspacesByWorkspaceIdRestoreResponses[keyof PostApiV1WorkspacesByWorkspaceIdRestoreResponses];

export type PostApiZendeskV1ActionsReplyToTicketData = {
  body: ZendeskReplyToTicketRequestV1;
  path?: never;
  query?: never;
  url: "/api/zendesk/v1/actions/reply-to-ticket";
};

export type PostApiZendeskV1ActionsReplyToTicketErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiZendeskV1ActionsReplyToTicketError =
  PostApiZendeskV1ActionsReplyToTicketErrors[keyof PostApiZendeskV1ActionsReplyToTicketErrors];

export type PostApiZendeskV1ActionsReplyToTicketResponses = {
  /**
   * Successful Response
   */
  200: ZendeskReplyToTicketResponseV1;
};

export type PostApiZendeskV1ActionsReplyToTicketResponse =
  PostApiZendeskV1ActionsReplyToTicketResponses[keyof PostApiZendeskV1ActionsReplyToTicketResponses];

export type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsData = {
  body: ZendeskUpdateTicketTagsRequestV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/zendesk/v1/tenants/{tenant_id}/actions/update-ticket-tags";
};

export type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsError =
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsErrors[keyof PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsErrors];

export type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponses =
  {
    /**
     * Successful Response
     */
    200: ZendeskUpdateTicketTagsResponseV1;
  };

export type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponse =
  PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponses[keyof PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponses];

export type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Attachment Id
       */
      attachment_id: number;
    };
    query?: never;
    url: "/api/zendesk/v1/tenants/{tenant_id}/actions/ticket-attachment-content/{attachment_id}";
  };

export type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdError =
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdErrors[keyof GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdErrors];

export type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponses =
  {
    /**
     * Successful Response
     */
    200: ZendeskGetTicketAttachmentContentResponseV1;
  };

export type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponse =
  GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponses[keyof GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponses];

export type GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Attachment Id
       */
      attachment_id: number;
    };
    query?: never;
    url: "/api/zendesk/v1/tenants/{tenant_id}/actions/download-ticket-attachment/{attachment_id}";
  };

export type GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdError =
  GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdErrors[keyof GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdErrors];

export type GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdResponses =
  {
    /**
     * Successful Response
     */
    200: unknown;
  };

export type GetApiZendeskV1TenantsByTenantIdActionsSectionsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Per Page
     */
    per_page?: number;
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Before Cursor
     */
    before_cursor?: string | null;
    /**
     * Locale
     */
    locale?: string | null;
  };
  url: "/api/zendesk/v1/tenants/{tenant_id}/actions/sections";
};

export type GetApiZendeskV1TenantsByTenantIdActionsSectionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiZendeskV1TenantsByTenantIdActionsSectionsError =
  GetApiZendeskV1TenantsByTenantIdActionsSectionsErrors[keyof GetApiZendeskV1TenantsByTenantIdActionsSectionsErrors];

export type GetApiZendeskV1TenantsByTenantIdActionsSectionsResponses = {
  /**
   * Successful Response
   */
  200: ZendeskSectionPageV1;
};

export type GetApiZendeskV1TenantsByTenantIdActionsSectionsResponse =
  GetApiZendeskV1TenantsByTenantIdActionsSectionsResponses[keyof GetApiZendeskV1TenantsByTenantIdActionsSectionsResponses];

export type GetApiZendeskV1TenantsByTenantIdActionsCategoriesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Per Page
     */
    per_page?: number;
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Before Cursor
     */
    before_cursor?: string | null;
    /**
     * Locale
     */
    locale?: string | null;
  };
  url: "/api/zendesk/v1/tenants/{tenant_id}/actions/categories";
};

export type GetApiZendeskV1TenantsByTenantIdActionsCategoriesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiZendeskV1TenantsByTenantIdActionsCategoriesError =
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesErrors[keyof GetApiZendeskV1TenantsByTenantIdActionsCategoriesErrors];

export type GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponses = {
  /**
   * Successful Response
   */
  200: ZendeskCategoryPageV1;
};

export type GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponse =
  GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponses[keyof GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponses];

export type GetApiV1ZendeskTenantsByTenantIdTicketsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Limit
     */
    limit?: number;
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Sort By
     */
    sort_by?: ZendeskTicketSortV1 | null;
  };
  url: "/api/v1/zendesk/tenants/{tenant_id}/tickets";
};

export type GetApiV1ZendeskTenantsByTenantIdTicketsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ZendeskTenantsByTenantIdTicketsError =
  GetApiV1ZendeskTenantsByTenantIdTicketsErrors[keyof GetApiV1ZendeskTenantsByTenantIdTicketsErrors];

export type GetApiV1ZendeskTenantsByTenantIdTicketsResponses = {
  /**
   * Successful Response
   */
  200: ZendeskTicketPageV1;
};

export type GetApiV1ZendeskTenantsByTenantIdTicketsResponse =
  GetApiV1ZendeskTenantsByTenantIdTicketsResponses[keyof GetApiV1ZendeskTenantsByTenantIdTicketsResponses];

export type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * Query
     */
    query: string;
    /**
     * Limit
     */
    limit?: number;
    /**
     * After Cursor
     */
    after_cursor?: string | null;
  };
  url: "/api/zendesk/v1/tenants/{tenant_id}/actions/search-tickets";
};

export type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsError =
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsErrors[keyof GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsErrors];

export type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponses = {
  /**
   * Successful Response
   */
  200: ZendeskTicketSearchPageV1;
};

export type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponse =
  GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponses[keyof GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponses];

export type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * Ticket Id
     */
    ticket_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}/tickets/{ticket_id}";
};

export type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdError =
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdErrors[keyof GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdErrors];

export type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponses = {
  /**
   * Successful Response
   */
  200: ZendeskTicketFullV1;
};

export type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponse =
  GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponses[keyof GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponses];

export type GetApiV1ZendeskTenantsByTenantIdUsersData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query: {
    /**
     * Ids
     */
    ids: Array<string>;
  };
  url: "/api/v1/zendesk/tenants/{tenant_id}/users";
};

export type GetApiV1ZendeskTenantsByTenantIdUsersErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ZendeskTenantsByTenantIdUsersError =
  GetApiV1ZendeskTenantsByTenantIdUsersErrors[keyof GetApiV1ZendeskTenantsByTenantIdUsersErrors];

export type GetApiV1ZendeskTenantsByTenantIdUsersResponses = {
  /**
   * Successful Response
   */
  200: ZendeskUserListV1;
};

export type GetApiV1ZendeskTenantsByTenantIdUsersResponse =
  GetApiV1ZendeskTenantsByTenantIdUsersResponses[keyof GetApiV1ZendeskTenantsByTenantIdUsersResponses];

export type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
    /**
     * User Id
     */
    user_id: string;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}/users/{user_id}";
};

export type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdError =
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdErrors[keyof GetApiV1ZendeskTenantsByTenantIdUsersByUserIdErrors];

export type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponses = {
  /**
   * Successful Response
   */
  200: ZendeskUserV1;
};

export type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponse =
  GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponses[keyof GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponses];

export type GetApiV1ZendeskTenantsByTenantIdArticlesData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Per Page
     */
    per_page?: number;
    /**
     * After Cursor
     */
    after_cursor?: string | null;
    /**
     * Before Cursor
     */
    before_cursor?: string | null;
    /**
     * Locale
     */
    locale?: string | null;
    /**
     * Brand Id
     */
    brand_id?: number | null;
  };
  url: "/api/v1/zendesk/tenants/{tenant_id}/articles";
};

export type GetApiV1ZendeskTenantsByTenantIdArticlesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ZendeskTenantsByTenantIdArticlesError =
  GetApiV1ZendeskTenantsByTenantIdArticlesErrors[keyof GetApiV1ZendeskTenantsByTenantIdArticlesErrors];

export type GetApiV1ZendeskTenantsByTenantIdArticlesResponses = {
  /**
   * Successful Response
   */
  200: ZendeskArticlePageV1;
};

export type GetApiV1ZendeskTenantsByTenantIdArticlesResponse =
  GetApiV1ZendeskTenantsByTenantIdArticlesResponses[keyof GetApiV1ZendeskTenantsByTenantIdArticlesResponses];

export type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Article Id
       */
      article_id: number;
    };
    query?: never;
    url: "/api/v1/zendesk/tenants/{tenant_id}/articles/{article_id}/attachments";
  };

export type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsError =
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsErrors[keyof GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsErrors];

export type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponses =
  {
    /**
     * Successful Response
     */
    200: ZendeskArticleAttachmentListV1;
  };

export type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponse =
  GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponses[keyof GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponses];

export type GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
      /**
       * Attachment Id
       */
      attachment_id: number;
    };
    query?: never;
    url: "/api/v1/zendesk/tenants/{tenant_id}/article-attachments/{attachment_id}/content";
  };

export type GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentError =
  GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentErrors[keyof GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentErrors];

export type GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentResponses =
  {
    /**
     * Successful Response
     */
    200: unknown;
  };

export type GetApiV1ZendeskTenantsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitFilterV1;
    visibility?: VisibilityFilterV1;
  };
  url: "/api/v1/zendesk/tenants";
};

export type GetApiV1ZendeskTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ZendeskTenantsError =
  GetApiV1ZendeskTenantsErrors[keyof GetApiV1ZendeskTenantsErrors];

export type GetApiV1ZendeskTenantsResponses = {
  /**
   * Successful Response
   */
  200: PageV2ZendeskTenantV1;
};

export type GetApiV1ZendeskTenantsResponse =
  GetApiV1ZendeskTenantsResponses[keyof GetApiV1ZendeskTenantsResponses];

export type PostApiV1ZendeskTenantsData = {
  body: ZendeskCreateTenantV1;
  path?: never;
  query?: never;
  url: "/api/v1/zendesk/tenants";
};

export type PostApiV1ZendeskTenantsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ZendeskTenantsError =
  PostApiV1ZendeskTenantsErrors[keyof PostApiV1ZendeskTenantsErrors];

export type PostApiV1ZendeskTenantsResponses = {
  /**
   * Successful Response
   */
  200: ZendeskTenantV1;
};

export type PostApiV1ZendeskTenantsResponse =
  PostApiV1ZendeskTenantsResponses[keyof PostApiV1ZendeskTenantsResponses];

export type GetApiV1ZendeskOauthRedirectUriData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/v1/zendesk/oauth-redirect-uri";
};

export type GetApiV1ZendeskOauthRedirectUriResponses = {
  /**
   * Successful Response
   */
  200: ZendeskOAuthRedirectUriV1;
};

export type GetApiV1ZendeskOauthRedirectUriResponse =
  GetApiV1ZendeskOauthRedirectUriResponses[keyof GetApiV1ZendeskOauthRedirectUriResponses];

export type DeleteApiV1ZendeskTenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}";
};

export type DeleteApiV1ZendeskTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ZendeskTenantsByTenantIdError =
  DeleteApiV1ZendeskTenantsByTenantIdErrors[keyof DeleteApiV1ZendeskTenantsByTenantIdErrors];

export type DeleteApiV1ZendeskTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ZendeskTenantV1;
};

export type DeleteApiV1ZendeskTenantsByTenantIdResponse =
  DeleteApiV1ZendeskTenantsByTenantIdResponses[keyof DeleteApiV1ZendeskTenantsByTenantIdResponses];

export type GetApiV1ZendeskTenantsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}";
};

export type GetApiV1ZendeskTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ZendeskTenantsByTenantIdError =
  GetApiV1ZendeskTenantsByTenantIdErrors[keyof GetApiV1ZendeskTenantsByTenantIdErrors];

export type GetApiV1ZendeskTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ZendeskTenantFullV1;
};

export type GetApiV1ZendeskTenantsByTenantIdResponse =
  GetApiV1ZendeskTenantsByTenantIdResponses[keyof GetApiV1ZendeskTenantsByTenantIdResponses];

export type PatchApiV1ZendeskTenantsByTenantIdData = {
  body: ZendeskPatchTenantV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}";
};

export type PatchApiV1ZendeskTenantsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1ZendeskTenantsByTenantIdError =
  PatchApiV1ZendeskTenantsByTenantIdErrors[keyof PatchApiV1ZendeskTenantsByTenantIdErrors];

export type PatchApiV1ZendeskTenantsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ZendeskTenantV1;
};

export type PatchApiV1ZendeskTenantsByTenantIdResponse =
  PatchApiV1ZendeskTenantsByTenantIdResponses[keyof PatchApiV1ZendeskTenantsByTenantIdResponses];

export type PostApiV1ZendeskTenantsByTenantIdConnectData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}/connect";
};

export type PostApiV1ZendeskTenantsByTenantIdConnectErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ZendeskTenantsByTenantIdConnectError =
  PostApiV1ZendeskTenantsByTenantIdConnectErrors[keyof PostApiV1ZendeskTenantsByTenantIdConnectErrors];

export type PostApiV1ZendeskTenantsByTenantIdConnectResponses = {
  /**
   * Successful Response
   */
  200: ZendeskConnectResponseV1;
};

export type PostApiV1ZendeskTenantsByTenantIdConnectResponse =
  PostApiV1ZendeskTenantsByTenantIdConnectResponses[keyof PostApiV1ZendeskTenantsByTenantIdConnectResponses];

export type PostApiV1ZendeskTenantsByTenantIdCallbackData = {
  body: ZendeskCallbackPayloadV1;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}/callback";
};

export type PostApiV1ZendeskTenantsByTenantIdCallbackErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ZendeskTenantsByTenantIdCallbackError =
  PostApiV1ZendeskTenantsByTenantIdCallbackErrors[keyof PostApiV1ZendeskTenantsByTenantIdCallbackErrors];

export type PostApiV1ZendeskTenantsByTenantIdCallbackResponses = {
  /**
   * Successful Response
   */
  200: ZendeskTenantV1;
};

export type PostApiV1ZendeskTenantsByTenantIdCallbackResponse =
  PostApiV1ZendeskTenantsByTenantIdCallbackResponses[keyof PostApiV1ZendeskTenantsByTenantIdCallbackResponses];

export type GetApiV1ZendeskTenantsByTenantIdCheckConnectionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}/check-connection";
};

export type GetApiV1ZendeskTenantsByTenantIdCheckConnectionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1ZendeskTenantsByTenantIdCheckConnectionError =
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionErrors[keyof GetApiV1ZendeskTenantsByTenantIdCheckConnectionErrors];

export type GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponses = {
  /**
   * Successful Response
   */
  200: ZendeskCheckConnectionResponseV1;
};

export type GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponse =
  GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponses[keyof GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponses];

export type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}/webhooks/provision";
};

export type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionError =
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors[keyof DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors];

export type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses = {
  /**
   * Successful Response
   */
  204: void;
};

export type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse =
  DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses[keyof DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses];

export type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/v1/zendesk/tenants/{tenant_id}/webhooks/provision";
};

export type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionError =
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors[keyof PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors];

export type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses = {
  /**
   * Successful Response
   */
  200: ZendeskWebhookProvisionResponseV1;
};

export type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse =
  PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses[keyof PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses];

export type GetApiV1CalibrationFeedbackInferenceDatapointsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Tags All
     */
    tags_all?: Array<string> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/calibration-feedback/inference-datapoints";
};

export type GetApiV1CalibrationFeedbackInferenceDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackInferenceDatapointsError =
  GetApiV1CalibrationFeedbackInferenceDatapointsErrors[keyof GetApiV1CalibrationFeedbackInferenceDatapointsErrors];

export type GetApiV1CalibrationFeedbackInferenceDatapointsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackInferenceDatapointV1;
};

export type GetApiV1CalibrationFeedbackInferenceDatapointsResponse =
  GetApiV1CalibrationFeedbackInferenceDatapointsResponses[keyof GetApiV1CalibrationFeedbackInferenceDatapointsResponses];

export type PostApiV1CalibrationFeedbackInferenceDatapointsData = {
  body: CreateCalibrationFeedbackInferenceDatapointsParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/calibration-feedback/inference-datapoints";
};

export type PostApiV1CalibrationFeedbackInferenceDatapointsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1CalibrationFeedbackInferenceDatapointsError =
  PostApiV1CalibrationFeedbackInferenceDatapointsErrors[keyof PostApiV1CalibrationFeedbackInferenceDatapointsErrors];

export type PostApiV1CalibrationFeedbackInferenceDatapointsResponses = {
  /**
   * Successful Response
   */
  200: CreateCalibrationFeedbackInferenceDatapointsResultV1;
};

export type PostApiV1CalibrationFeedbackInferenceDatapointsResponse =
  PostApiV1CalibrationFeedbackInferenceDatapointsResponses[keyof PostApiV1CalibrationFeedbackInferenceDatapointsResponses];

export type GetApiV1CalibrationFeedbackInferenceDatapointsTagsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/calibration-feedback/inference-datapoints/tags";
};

export type GetApiV1CalibrationFeedbackInferenceDatapointsTagsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackInferenceDatapointsTagsError =
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsErrors[keyof GetApiV1CalibrationFeedbackInferenceDatapointsTagsErrors];

export type GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackTagKeyV1;
};

export type GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponse =
  GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponses[keyof GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponses];

export type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData =
  {
    body?: never;
    path: {
      /**
       * Inference Datapoint Id
       */
      inference_datapoint_id: number;
    };
    query?: never;
    url: "/api/v1/calibration-feedback/inference-datapoints/{inference_datapoint_id}";
  };

export type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError =
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors[keyof DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors];

export type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses =
  {
    /**
     * Successful Response
     */
    200: CalibrationFeedbackInferenceDatapointV1;
  };

export type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse =
  DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses[keyof DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses];

export type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData =
  {
    body?: never;
    path: {
      /**
       * Inference Datapoint Id
       */
      inference_datapoint_id: number;
    };
    query?: never;
    url: "/api/v1/calibration-feedback/inference-datapoints/{inference_datapoint_id}";
  };

export type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError =
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors[keyof GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors];

export type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses =
  {
    /**
     * Successful Response
     */
    200: CalibrationFeedbackInferenceDatapointFullV1;
  };

export type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse =
  GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses[keyof GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses];

export type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreData =
  {
    body?: never;
    path: {
      /**
       * Inference Datapoint Id
       */
      inference_datapoint_id: number;
    };
    query?: never;
    url: "/api/v1/calibration-feedback/inference-datapoints/{inference_datapoint_id}/restore";
  };

export type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreError =
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreErrors[keyof PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreErrors];

export type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: CalibrationFeedbackInferenceDatapointV1;
  };

export type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponse =
  PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponses[keyof PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponses];

export type GetApiV1CalibrationFeedbackDimensionsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/calibration-feedback/dimensions";
};

export type GetApiV1CalibrationFeedbackDimensionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackDimensionsError =
  GetApiV1CalibrationFeedbackDimensionsErrors[keyof GetApiV1CalibrationFeedbackDimensionsErrors];

export type GetApiV1CalibrationFeedbackDimensionsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackDimensionV1;
};

export type GetApiV1CalibrationFeedbackDimensionsResponse =
  GetApiV1CalibrationFeedbackDimensionsResponses[keyof GetApiV1CalibrationFeedbackDimensionsResponses];

export type PostApiV1CalibrationFeedbackDimensionsData = {
  body: CreateCalibrationFeedbackDimensionParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/calibration-feedback/dimensions";
};

export type PostApiV1CalibrationFeedbackDimensionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1CalibrationFeedbackDimensionsError =
  PostApiV1CalibrationFeedbackDimensionsErrors[keyof PostApiV1CalibrationFeedbackDimensionsErrors];

export type PostApiV1CalibrationFeedbackDimensionsResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackDimensionV1;
};

export type PostApiV1CalibrationFeedbackDimensionsResponse =
  PostApiV1CalibrationFeedbackDimensionsResponses[keyof PostApiV1CalibrationFeedbackDimensionsResponses];

export type GetApiV1CalibrationFeedbackFullDimensionsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/calibration-feedback/full-dimensions";
};

export type GetApiV1CalibrationFeedbackFullDimensionsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackFullDimensionsError =
  GetApiV1CalibrationFeedbackFullDimensionsErrors[keyof GetApiV1CalibrationFeedbackFullDimensionsErrors];

export type GetApiV1CalibrationFeedbackFullDimensionsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackDimensionFullV1;
};

export type GetApiV1CalibrationFeedbackFullDimensionsResponse =
  GetApiV1CalibrationFeedbackFullDimensionsResponses[keyof GetApiV1CalibrationFeedbackFullDimensionsResponses];

export type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdData = {
  body?: never;
  path: {
    /**
     * Dimension Id
     */
    dimension_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/dimensions/{dimension_id}";
};

export type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdError =
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdErrors[keyof DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdErrors];

export type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackDimensionV1;
};

export type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponse =
  DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponses[keyof DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponses];

export type GetApiV1CalibrationFeedbackDimensionsByDimensionIdData = {
  body?: never;
  path: {
    /**
     * Dimension Id
     */
    dimension_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/dimensions/{dimension_id}";
};

export type GetApiV1CalibrationFeedbackDimensionsByDimensionIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackDimensionsByDimensionIdError =
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdErrors[keyof GetApiV1CalibrationFeedbackDimensionsByDimensionIdErrors];

export type GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackDimensionFullV1;
};

export type GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponse =
  GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponses[keyof GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponses];

export type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreData = {
  body?: never;
  path: {
    /**
     * Dimension Id
     */
    dimension_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/dimensions/{dimension_id}/restore";
};

export type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreError =
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreErrors[keyof PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreErrors];

export type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: CalibrationFeedbackDimensionV1;
  };

export type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponse =
  PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponses[keyof PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponses];

export type GetApiV1CalibrationFeedbackQueueItemsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Status
     */
    status?: CalibrationFeedbackQueueItemStatusV1 | null;
    /**
     * Has My Verdict
     */
    has_my_verdict?: boolean | null;
    /**
     * Tags All
     */
    tags_all?: Array<string> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/calibration-feedback/queue-items";
};

export type GetApiV1CalibrationFeedbackQueueItemsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackQueueItemsError =
  GetApiV1CalibrationFeedbackQueueItemsErrors[keyof GetApiV1CalibrationFeedbackQueueItemsErrors];

export type GetApiV1CalibrationFeedbackQueueItemsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackQueueItemV1;
};

export type GetApiV1CalibrationFeedbackQueueItemsResponse =
  GetApiV1CalibrationFeedbackQueueItemsResponses[keyof GetApiV1CalibrationFeedbackQueueItemsResponses];

export type PostApiV1CalibrationFeedbackQueueItemsData = {
  body: CreateCalibrationFeedbackQueueItemsParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/calibration-feedback/queue-items";
};

export type PostApiV1CalibrationFeedbackQueueItemsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1CalibrationFeedbackQueueItemsError =
  PostApiV1CalibrationFeedbackQueueItemsErrors[keyof PostApiV1CalibrationFeedbackQueueItemsErrors];

export type PostApiV1CalibrationFeedbackQueueItemsResponses = {
  /**
   * Successful Response
   */
  200: CreateCalibrationFeedbackQueueItemsResultV1;
};

export type PostApiV1CalibrationFeedbackQueueItemsResponse =
  PostApiV1CalibrationFeedbackQueueItemsResponses[keyof PostApiV1CalibrationFeedbackQueueItemsResponses];

export type GetApiV1CalibrationFeedbackFullQueueItemsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Status
     */
    status?: CalibrationFeedbackQueueItemStatusV1 | null;
    /**
     * Has My Verdict
     */
    has_my_verdict?: boolean | null;
    /**
     * Tags All
     */
    tags_all?: Array<string> | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/calibration-feedback/full-queue-items";
};

export type GetApiV1CalibrationFeedbackFullQueueItemsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackFullQueueItemsError =
  GetApiV1CalibrationFeedbackFullQueueItemsErrors[keyof GetApiV1CalibrationFeedbackFullQueueItemsErrors];

export type GetApiV1CalibrationFeedbackFullQueueItemsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackQueueItemFullV1;
};

export type GetApiV1CalibrationFeedbackFullQueueItemsResponse =
  GetApiV1CalibrationFeedbackFullQueueItemsResponses[keyof GetApiV1CalibrationFeedbackFullQueueItemsResponses];

export type GetApiV1CalibrationFeedbackQueueItemsTagsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Status
     */
    status?: CalibrationFeedbackQueueItemStatusV1 | null;
    /**
     * Has My Verdict
     */
    has_my_verdict?: boolean | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
  };
  url: "/api/v1/calibration-feedback/queue-items/tags";
};

export type GetApiV1CalibrationFeedbackQueueItemsTagsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackQueueItemsTagsError =
  GetApiV1CalibrationFeedbackQueueItemsTagsErrors[keyof GetApiV1CalibrationFeedbackQueueItemsTagsErrors];

export type GetApiV1CalibrationFeedbackQueueItemsTagsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackTagKeyV1;
};

export type GetApiV1CalibrationFeedbackQueueItemsTagsResponse =
  GetApiV1CalibrationFeedbackQueueItemsTagsResponses[keyof GetApiV1CalibrationFeedbackQueueItemsTagsResponses];

export type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdData = {
  body?: never;
  path: {
    /**
     * Queue Item Id
     */
    queue_item_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/queue-items/{queue_item_id}";
};

export type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdError =
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors[keyof DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors];

export type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackQueueItemV1;
};

export type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse =
  DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses[keyof DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses];

export type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdData = {
  body?: never;
  path: {
    /**
     * Queue Item Id
     */
    queue_item_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/queue-items/{queue_item_id}";
};

export type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdError =
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors[keyof GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors];

export type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackQueueItemFullV1;
};

export type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse =
  GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses[keyof GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses];

export type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreData = {
  body?: never;
  path: {
    /**
     * Queue Item Id
     */
    queue_item_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/queue-items/{queue_item_id}/restore";
};

export type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreError =
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreErrors[keyof PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreErrors];

export type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponses =
  {
    /**
     * Successful Response
     */
    200: CalibrationFeedbackQueueItemV1;
  };

export type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponse =
  PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponses[keyof PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponses];

export type GetApiV1CalibrationFeedbackVerdictsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Inference Datapoint Id
     */
    inference_datapoint_id?: number | null;
    /**
     * Created By User Id
     */
    created_by_user_id?: number | null;
    /**
     * Dimension Id
     */
    dimension_id?: number | null;
    /**
     * Tags All
     */
    tags_all?: Array<string> | null;
    /**
     * Created At Start Inclusive
     */
    created_at_start_inclusive?: Date | null;
    /**
     * Created At End Exclusive
     */
    created_at_end_exclusive?: Date | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/calibration-feedback/verdicts";
};

export type GetApiV1CalibrationFeedbackVerdictsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackVerdictsError =
  GetApiV1CalibrationFeedbackVerdictsErrors[keyof GetApiV1CalibrationFeedbackVerdictsErrors];

export type GetApiV1CalibrationFeedbackVerdictsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackVerdictV1;
};

export type GetApiV1CalibrationFeedbackVerdictsResponse =
  GetApiV1CalibrationFeedbackVerdictsResponses[keyof GetApiV1CalibrationFeedbackVerdictsResponses];

export type PostApiV1CalibrationFeedbackVerdictsData = {
  body: CreateCalibrationFeedbackVerdictParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/calibration-feedback/verdicts";
};

export type PostApiV1CalibrationFeedbackVerdictsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1CalibrationFeedbackVerdictsError =
  PostApiV1CalibrationFeedbackVerdictsErrors[keyof PostApiV1CalibrationFeedbackVerdictsErrors];

export type PostApiV1CalibrationFeedbackVerdictsResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackVerdictV1;
};

export type PostApiV1CalibrationFeedbackVerdictsResponse =
  PostApiV1CalibrationFeedbackVerdictsResponses[keyof PostApiV1CalibrationFeedbackVerdictsResponses];

export type GetApiV1CalibrationFeedbackFullVerdictsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Inference Datapoint Id
     */
    inference_datapoint_id?: number | null;
    /**
     * Created By User Id
     */
    created_by_user_id?: number | null;
    /**
     * Dimension Id
     */
    dimension_id?: number | null;
    /**
     * Tags All
     */
    tags_all?: Array<string> | null;
    /**
     * Created At Start Inclusive
     */
    created_at_start_inclusive?: Date | null;
    /**
     * Created At End Exclusive
     */
    created_at_end_exclusive?: Date | null;
    /**
     * Offset
     */
    offset?: number;
    limit?: LimitV1;
    visibility?: VisibilityV1;
  };
  url: "/api/v1/calibration-feedback/full-verdicts";
};

export type GetApiV1CalibrationFeedbackFullVerdictsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackFullVerdictsError =
  GetApiV1CalibrationFeedbackFullVerdictsErrors[keyof GetApiV1CalibrationFeedbackFullVerdictsErrors];

export type GetApiV1CalibrationFeedbackFullVerdictsResponses = {
  /**
   * Successful Response
   */
  200: PageV1CalibrationFeedbackVerdictFullV1;
};

export type GetApiV1CalibrationFeedbackFullVerdictsResponse =
  GetApiV1CalibrationFeedbackFullVerdictsResponses[keyof GetApiV1CalibrationFeedbackFullVerdictsResponses];

export type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdData = {
  body?: never;
  path: {
    /**
     * Verdict Id
     */
    verdict_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/verdicts/{verdict_id}";
};

export type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdError =
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdErrors[keyof DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdErrors];

export type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackVerdictV1;
};

export type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponse =
  DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponses[keyof DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponses];

export type GetApiV1CalibrationFeedbackVerdictsByVerdictIdData = {
  body?: never;
  path: {
    /**
     * Verdict Id
     */
    verdict_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/verdicts/{verdict_id}";
};

export type GetApiV1CalibrationFeedbackVerdictsByVerdictIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1CalibrationFeedbackVerdictsByVerdictIdError =
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdErrors[keyof GetApiV1CalibrationFeedbackVerdictsByVerdictIdErrors];

export type GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackVerdictFullV1;
};

export type GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponse =
  GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponses[keyof GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponses];

export type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdData = {
  body: UpdateCalibrationFeedbackVerdictParamsV1;
  path: {
    /**
     * Verdict Id
     */
    verdict_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/verdicts/{verdict_id}";
};

export type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdError =
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdErrors[keyof PatchApiV1CalibrationFeedbackVerdictsByVerdictIdErrors];

export type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackVerdictV1;
};

export type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponse =
  PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponses[keyof PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponses];

export type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreData = {
  body?: never;
  path: {
    /**
     * Verdict Id
     */
    verdict_id: number;
  };
  query?: never;
  url: "/api/v1/calibration-feedback/verdicts/{verdict_id}/restore";
};

export type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreError =
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreErrors[keyof PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreErrors];

export type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponses = {
  /**
   * Successful Response
   */
  200: CalibrationFeedbackVerdictV1;
};

export type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponse =
  PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponses[keyof PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponses];

export type DeleteApiV1SesameEdraAccessData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Email
     */
    email?: string | null;
  };
  url: "/api/v1/sesame/edra-access";
};

export type DeleteApiV1SesameEdraAccessErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type DeleteApiV1SesameEdraAccessError =
  DeleteApiV1SesameEdraAccessErrors[keyof DeleteApiV1SesameEdraAccessErrors];

export type DeleteApiV1SesameEdraAccessResponses = {
  /**
   * Successful Response
   */
  200: EdraAccessRemovalV1;
};

export type DeleteApiV1SesameEdraAccessResponse =
  DeleteApiV1SesameEdraAccessResponses[keyof DeleteApiV1SesameEdraAccessResponses];

export type GetApiV1SesameEdraAccessData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Email
     */
    email?: string | null;
  };
  url: "/api/v1/sesame/edra-access";
};

export type GetApiV1SesameEdraAccessErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiV1SesameEdraAccessError =
  GetApiV1SesameEdraAccessErrors[keyof GetApiV1SesameEdraAccessErrors];

export type GetApiV1SesameEdraAccessResponses = {
  /**
   * Successful Response
   */
  200: EdraAccessV1;
};

export type GetApiV1SesameEdraAccessResponse =
  GetApiV1SesameEdraAccessResponses[keyof GetApiV1SesameEdraAccessResponses];

export type PatchApiV1SesameEdraAccessData = {
  body: EdraAccessRoleParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/sesame/edra-access";
};

export type PatchApiV1SesameEdraAccessErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PatchApiV1SesameEdraAccessError =
  PatchApiV1SesameEdraAccessErrors[keyof PatchApiV1SesameEdraAccessErrors];

export type PatchApiV1SesameEdraAccessResponses = {
  /**
   * Successful Response
   */
  200: EdraAccessRoleChangeV1;
};

export type PatchApiV1SesameEdraAccessResponse =
  PatchApiV1SesameEdraAccessResponses[keyof PatchApiV1SesameEdraAccessResponses];

export type PostApiV1SesameEdraAccessData = {
  body: EdraAccessRoleParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/sesame/edra-access";
};

export type PostApiV1SesameEdraAccessErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiV1SesameEdraAccessError =
  PostApiV1SesameEdraAccessErrors[keyof PostApiV1SesameEdraAccessErrors];

export type PostApiV1SesameEdraAccessResponses = {
  /**
   * Successful Response
   */
  200: EdraAccessGrantV1;
};

export type PostApiV1SesameEdraAccessResponse =
  PostApiV1SesameEdraAccessResponses[keyof PostApiV1SesameEdraAccessResponses];

export type PutApiV1SesameOrgMembershipsData = {
  body: SetOrgMembershipParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/sesame/org-memberships";
};

export type PutApiV1SesameOrgMembershipsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiV1SesameOrgMembershipsError =
  PutApiV1SesameOrgMembershipsErrors[keyof PutApiV1SesameOrgMembershipsErrors];

export type PutApiV1SesameOrgMembershipsResponses = {
  /**
   * Successful Response
   */
  200: OrgMembershipChangeV1;
};

export type PutApiV1SesameOrgMembershipsResponse =
  PutApiV1SesameOrgMembershipsResponses[keyof PutApiV1SesameOrgMembershipsResponses];

export type PutApiV1SesameOrgMemberRolesData = {
  body: SetOrgMemberRoleParamsV1;
  path?: never;
  query?: never;
  url: "/api/v1/sesame/org-member-roles";
};

export type PutApiV1SesameOrgMemberRolesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PutApiV1SesameOrgMemberRolesError =
  PutApiV1SesameOrgMemberRolesErrors[keyof PutApiV1SesameOrgMemberRolesErrors];

export type PutApiV1SesameOrgMemberRolesResponses = {
  /**
   * Successful Response
   */
  200: OrgMemberRoleChangeV1;
};

export type PutApiV1SesameOrgMemberRolesResponse =
  PutApiV1SesameOrgMemberRolesResponses[keyof PutApiV1SesameOrgMemberRolesResponses];

export type GetApiPublicV1AgentA2aByAgentKeyAgentData = {
  body?: never;
  headers?: {
    /**
     * A2A-Version
     */
    "A2A-Version"?: string | null;
  };
  path: {
    /**
     * Agent Key
     */
    agent_key: string;
  };
  query?: never;
  url: "/api/public/v1/agent-a2a/{agent_key}/agent";
};

export type GetApiPublicV1AgentA2aByAgentKeyAgentErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPublicV1AgentA2aByAgentKeyAgentError =
  GetApiPublicV1AgentA2aByAgentKeyAgentErrors[keyof GetApiPublicV1AgentA2aByAgentKeyAgentErrors];

export type GetApiPublicV1AgentA2aByAgentKeyAgentResponses = {
  /**
   * Response Get A2A Agent Card V1  Api Public V1 Agent A2A  Agent Key  Agent Get
   *
   * Successful Response
   */
  200: A2aAgentCardV1 | A2aLegacyAgentCardV1;
};

export type GetApiPublicV1AgentA2aByAgentKeyAgentResponse =
  GetApiPublicV1AgentA2aByAgentKeyAgentResponses[keyof GetApiPublicV1AgentA2aByAgentKeyAgentResponses];

export type PostApiPublicFreshserviceV1WebhooksByTenantIdData = {
  body?: never;
  headers: {
    /**
     * X-Edra-Webhook-Token
     */
    "X-Edra-Webhook-Token": string;
  };
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/freshservice/v1/webhooks/{tenant_id}";
};

export type PostApiPublicFreshserviceV1WebhooksByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicFreshserviceV1WebhooksByTenantIdError =
  PostApiPublicFreshserviceV1WebhooksByTenantIdErrors[keyof PostApiPublicFreshserviceV1WebhooksByTenantIdErrors];

export type PostApiPublicFreshserviceV1WebhooksByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: FreshserviceWebhookResponseV1;
};

export type PostApiPublicFreshserviceV1WebhooksByTenantIdResponse =
  PostApiPublicFreshserviceV1WebhooksByTenantIdResponses[keyof PostApiPublicFreshserviceV1WebhooksByTenantIdResponses];

export type PostApiPublicHubspotV1EventsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/hubspot/v1/events/{tenant_id}";
};

export type PostApiPublicHubspotV1EventsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicHubspotV1EventsByTenantIdError =
  PostApiPublicHubspotV1EventsByTenantIdErrors[keyof PostApiPublicHubspotV1EventsByTenantIdErrors];

export type PostApiPublicHubspotV1EventsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: HubSpotIngestResponseV1;
};

export type PostApiPublicHubspotV1EventsByTenantIdResponse =
  PostApiPublicHubspotV1EventsByTenantIdResponses[keyof PostApiPublicHubspotV1EventsByTenantIdResponses];

export type PostApiPublicSharepointV1NotificationsByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Validationtoken
     */
    validationToken?: string | null;
  };
  url: "/api/public/sharepoint/v1/notifications/{tenant_id}";
};

export type PostApiPublicSharepointV1NotificationsByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicSharepointV1NotificationsByTenantIdError =
  PostApiPublicSharepointV1NotificationsByTenantIdErrors[keyof PostApiPublicSharepointV1NotificationsByTenantIdErrors];

export type PostApiPublicSharepointV1NotificationsByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiPublicSharepointV1LifecycleByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: {
    /**
     * Validationtoken
     */
    validationToken?: string | null;
  };
  url: "/api/public/sharepoint/v1/lifecycle/{tenant_id}";
};

export type PostApiPublicSharepointV1LifecycleByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicSharepointV1LifecycleByTenantIdError =
  PostApiPublicSharepointV1LifecycleByTenantIdErrors[keyof PostApiPublicSharepointV1LifecycleByTenantIdErrors];

export type PostApiPublicSharepointV1LifecycleByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiPublicJiraV1EventsData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/public/jira/v1/events";
};

export type PostApiPublicJiraV1EventsResponses = {
  /**
   * Successful Response
   */
  200: JiraHandleWebhookEventResponseV1;
};

export type PostApiPublicJiraV1EventsResponse =
  PostApiPublicJiraV1EventsResponses[keyof PostApiPublicJiraV1EventsResponses];

export type PostApiPublicNotionV1WebhooksIngestByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/notion/v1/webhooks/ingest/{tenant_id}";
};

export type PostApiPublicNotionV1WebhooksIngestByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicNotionV1WebhooksIngestByTenantIdError =
  PostApiPublicNotionV1WebhooksIngestByTenantIdErrors[keyof PostApiPublicNotionV1WebhooksIngestByTenantIdErrors];

export type PostApiPublicNotionV1WebhooksIngestByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: NotionIngestResponseV1;
};

export type PostApiPublicNotionV1WebhooksIngestByTenantIdResponse =
  PostApiPublicNotionV1WebhooksIngestByTenantIdResponses[keyof PostApiPublicNotionV1WebhooksIngestByTenantIdResponses];

export type GetApiPublicOauthV1WellKnownOauthAuthorizationServerData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/public/oauth/v1/.well-known/oauth-authorization-server";
};

export type GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponses = {
  /**
   * Successful Response
   */
  200: OAuthAuthorizationServerMetadataV1;
};

export type GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponse =
  GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponses[keyof GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponses];

export type GetApiPublicOauthV1WellKnownOpenidConfigurationData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/public/oauth/v1/.well-known/openid-configuration";
};

export type GetApiPublicOauthV1WellKnownOpenidConfigurationResponses = {
  /**
   * Successful Response
   */
  200: OAuthAuthorizationServerMetadataV1;
};

export type GetApiPublicOauthV1WellKnownOpenidConfigurationResponse =
  GetApiPublicOauthV1WellKnownOpenidConfigurationResponses[keyof GetApiPublicOauthV1WellKnownOpenidConfigurationResponses];

export type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyData =
  {
    body?: never;
    path: {
      /**
       * Toolset Key
       */
      toolset_key: string;
    };
    query?: never;
    url: "/api/public/oauth/v1/.well-known/oauth-protected-resource/mcp/{toolset_key}";
  };

export type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyError =
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyErrors[keyof GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyErrors];

export type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponses =
  {
    /**
     * Successful Response
     */
    200: OAuthProtectedResourceMetadataV1;
  };

export type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponse =
  GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponses[keyof GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponses];

export type GetApiPublicOauthV1AuthorizeData = {
  body?: never;
  path?: never;
  query: {
    /**
     * Client Id
     */
    client_id: string;
  };
  url: "/api/public/oauth/v1/authorize";
};

export type GetApiPublicOauthV1AuthorizeErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPublicOauthV1AuthorizeError =
  GetApiPublicOauthV1AuthorizeErrors[keyof GetApiPublicOauthV1AuthorizeErrors];

export type GetApiPublicOauthV1AuthorizeResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiPublicOauthV1TokenData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/api/public/oauth/v1/token";
};

export type PostApiPublicOauthV1TokenResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationData =
  {
    body?: never;
    path: {
      /**
       * Oauth Application Id
       */
      oauth_application_id: number;
    };
    query?: never;
    url: "/api/public/oauth/v1/{oauth_application_id}/.well-known/openid-configuration";
  };

export type GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationError =
  GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationErrors[keyof GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationErrors];

export type GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationResponses =
  {
    /**
     * Successful Response
     */
    200: unknown;
  };

export type GetApiPublicOauthV1ByOauthApplicationIdAuthorizeData = {
  body?: never;
  path: {
    /**
     * Oauth Application Id
     */
    oauth_application_id: number;
  };
  query?: never;
  url: "/api/public/oauth/v1/{oauth_application_id}/authorize";
};

export type GetApiPublicOauthV1ByOauthApplicationIdAuthorizeErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPublicOauthV1ByOauthApplicationIdAuthorizeError =
  GetApiPublicOauthV1ByOauthApplicationIdAuthorizeErrors[keyof GetApiPublicOauthV1ByOauthApplicationIdAuthorizeErrors];

export type GetApiPublicOauthV1ByOauthApplicationIdAuthorizeResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiPublicOauthV1ByOauthApplicationIdTokenData = {
  body?: never;
  path: {
    /**
     * Oauth Application Id
     */
    oauth_application_id: number;
  };
  query?: never;
  url: "/api/public/oauth/v1/{oauth_application_id}/token";
};

export type PostApiPublicOauthV1ByOauthApplicationIdTokenErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicOauthV1ByOauthApplicationIdTokenError =
  PostApiPublicOauthV1ByOauthApplicationIdTokenErrors[keyof PostApiPublicOauthV1ByOauthApplicationIdTokenErrors];

export type PostApiPublicOauthV1ByOauthApplicationIdTokenResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type GetApiPublicOauthV1ByOauthApplicationIdUserinfoData = {
  body?: never;
  path: {
    /**
     * Oauth Application Id
     */
    oauth_application_id: number;
  };
  query?: never;
  url: "/api/public/oauth/v1/{oauth_application_id}/userinfo";
};

export type GetApiPublicOauthV1ByOauthApplicationIdUserinfoErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPublicOauthV1ByOauthApplicationIdUserinfoError =
  GetApiPublicOauthV1ByOauthApplicationIdUserinfoErrors[keyof GetApiPublicOauthV1ByOauthApplicationIdUserinfoErrors];

export type GetApiPublicOauthV1ByOauthApplicationIdUserinfoResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiPublicOauthV1ByOauthApplicationIdIntrospectData = {
  body?: never;
  path: {
    /**
     * Oauth Application Id
     */
    oauth_application_id: number;
  };
  query?: never;
  url: "/api/public/oauth/v1/{oauth_application_id}/introspect";
};

export type PostApiPublicOauthV1ByOauthApplicationIdIntrospectErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicOauthV1ByOauthApplicationIdIntrospectError =
  PostApiPublicOauthV1ByOauthApplicationIdIntrospectErrors[keyof PostApiPublicOauthV1ByOauthApplicationIdIntrospectErrors];

export type PostApiPublicOauthV1ByOauthApplicationIdIntrospectResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiPublicOutlookV2SubscriptionsEventsData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Validationtoken
     */
    validationToken?: string | null;
  };
  url: "/api/public/outlook/v2/subscriptions/events";
};

export type PostApiPublicOutlookV2SubscriptionsEventsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicOutlookV2SubscriptionsEventsError =
  PostApiPublicOutlookV2SubscriptionsEventsErrors[keyof PostApiPublicOutlookV2SubscriptionsEventsErrors];

export type PostApiPublicOutlookV2SubscriptionsEventsResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiPublicOutlookV2SubscriptionsLifecycleData = {
  body?: never;
  path?: never;
  query?: {
    /**
     * Validationtoken
     */
    validationToken?: string | null;
  };
  url: "/api/public/outlook/v2/subscriptions/lifecycle";
};

export type PostApiPublicOutlookV2SubscriptionsLifecycleErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicOutlookV2SubscriptionsLifecycleError =
  PostApiPublicOutlookV2SubscriptionsLifecycleErrors[keyof PostApiPublicOutlookV2SubscriptionsLifecycleErrors];

export type PostApiPublicOutlookV2SubscriptionsLifecycleResponses = {
  /**
   * Successful Response
   */
  200: unknown;
};

export type PostApiPublicPlainV1WebhooksIngestByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/plain/v1/webhooks/ingest/{tenant_id}";
};

export type PostApiPublicPlainV1WebhooksIngestByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicPlainV1WebhooksIngestByTenantIdError =
  PostApiPublicPlainV1WebhooksIngestByTenantIdErrors[keyof PostApiPublicPlainV1WebhooksIngestByTenantIdErrors];

export type PostApiPublicPlainV1WebhooksIngestByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: PlainIngestResponseV1;
};

export type PostApiPublicPlainV1WebhooksIngestByTenantIdResponse =
  PostApiPublicPlainV1WebhooksIngestByTenantIdResponses[keyof PostApiPublicPlainV1WebhooksIngestByTenantIdResponses];

export type PostApiPublicV1SalesforceOauthTokenByTenantIdData = {
  body: BodySalesforceOauthTokenV1ApiPublicV1SalesforceOauthTokenTenantIdPost;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/v1/salesforce/oauth/token/{tenant_id}";
};

export type PostApiPublicV1SalesforceOauthTokenByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicV1SalesforceOauthTokenByTenantIdError =
  PostApiPublicV1SalesforceOauthTokenByTenantIdErrors[keyof PostApiPublicV1SalesforceOauthTokenByTenantIdErrors];

export type PostApiPublicV1SalesforceOauthTokenByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SalesforceOAuthTokenResponseV1;
};

export type PostApiPublicV1SalesforceOauthTokenByTenantIdResponse =
  PostApiPublicV1SalesforceOauthTokenByTenantIdResponses[keyof PostApiPublicV1SalesforceOauthTokenByTenantIdResponses];

export type PostApiPublicV1SalesforceWebhooksIngestByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/v1/salesforce/webhooks/ingest/{tenant_id}";
};

export type PostApiPublicV1SalesforceWebhooksIngestByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicV1SalesforceWebhooksIngestByTenantIdError =
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdErrors[keyof PostApiPublicV1SalesforceWebhooksIngestByTenantIdErrors];

export type PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: SalesforceIngestAckV1;
};

export type PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponse =
  PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponses[keyof PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponses];

export type PostApiPublicServiceNowV1WebhooksData = {
  body?: never;
  headers: {
    /**
     * X-Tenant-Id
     */
    "x-tenant-id": number;
    /**
     * X-Timestamp
     */
    "x-timestamp": string;
    /**
     * X-Signature
     */
    "x-signature": string;
    /**
     * X-Delivery-Id
     */
    "x-delivery-id": string;
  };
  path?: never;
  query?: never;
  url: "/api/public/service-now/v1/webhooks";
};

export type PostApiPublicServiceNowV1WebhooksErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicServiceNowV1WebhooksError =
  PostApiPublicServiceNowV1WebhooksErrors[keyof PostApiPublicServiceNowV1WebhooksErrors];

export type PostApiPublicServiceNowV1WebhooksResponses = {
  /**
   * Successful Response
   */
  200: ServiceNowWebhookResponseV1;
};

export type PostApiPublicServiceNowV1WebhooksResponse =
  PostApiPublicServiceNowV1WebhooksResponses[keyof PostApiPublicServiceNowV1WebhooksResponses];

export type PostApiPublicSlackV2TenantsByTenantIdEventsData = {
  body?: never;
  headers: {
    /**
     * X Slack Request Timestamp
     */
    "x-slack-request-timestamp": string;
    /**
     * X Slack Signature
     */
    "x-slack-signature": string;
  };
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/slack/v2/tenants/{tenant_id}/events";
};

export type PostApiPublicSlackV2TenantsByTenantIdEventsErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicSlackV2TenantsByTenantIdEventsError =
  PostApiPublicSlackV2TenantsByTenantIdEventsErrors[keyof PostApiPublicSlackV2TenantsByTenantIdEventsErrors];

export type PostApiPublicSlackV2TenantsByTenantIdEventsResponses = {
  /**
   * Successful Response
   */
  200: SlackReceiveEventResponseV2;
};

export type PostApiPublicSlackV2TenantsByTenantIdEventsResponse =
  PostApiPublicSlackV2TenantsByTenantIdEventsResponses[keyof PostApiPublicSlackV2TenantsByTenantIdEventsResponses];

export type PostApiPublicSlackV2TenantsByTenantIdInteractivityData = {
  body?: never;
  headers: {
    /**
     * X Slack Request Timestamp
     */
    "x-slack-request-timestamp": string;
    /**
     * X Slack Signature
     */
    "x-slack-signature": string;
  };
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/slack/v2/tenants/{tenant_id}/interactivity";
};

export type PostApiPublicSlackV2TenantsByTenantIdInteractivityErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicSlackV2TenantsByTenantIdInteractivityError =
  PostApiPublicSlackV2TenantsByTenantIdInteractivityErrors[keyof PostApiPublicSlackV2TenantsByTenantIdInteractivityErrors];

export type PostApiPublicSlackV2TenantsByTenantIdInteractivityResponses = {
  /**
   * Successful Response
   */
  200: SlackReceiveInteractivityAckResponseV2;
};

export type PostApiPublicSlackV2TenantsByTenantIdInteractivityResponse =
  PostApiPublicSlackV2TenantsByTenantIdInteractivityResponses[keyof PostApiPublicSlackV2TenantsByTenantIdInteractivityResponses];

export type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesData = {
  body?: never;
  headers?: {
    /**
     * Authorization
     */
    authorization?: string | null;
  };
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/v1/teams/tenants/{tenant_id}/webhooks/messages";
};

export type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesError =
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesErrors[keyof PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesErrors];

export type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponses = {
  /**
   * Successful Response
   */
  200: TeamsReceiveMessageResponseV1;
};

export type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponse =
  PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponses[keyof PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponses];

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationData =
  {
    body?: never;
    path: {
      /**
       * Tenant Id
       */
      tenant_id: number;
    };
    query?: never;
    url: "/api/public/teams/v1/tenants/{tenant_id}/.well-known/openid-configuration";
  };

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationErrors =
  {
    /**
     * Validation Error
     */
    422: HttpValidationError;
  };

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationError =
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationErrors[keyof GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationErrors];

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponses =
  {
    /**
     * Successful Response
     */
    200: TeamsOpenIdConfigurationV1;
  };

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponse =
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponses[keyof GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponses];

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/teams/v1/tenants/{tenant_id}/.well-known/jwks.json";
};

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonError =
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonErrors[keyof GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonErrors];

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponses = {
  /**
   * Successful Response
   */
  200: TeamsJwksV1;
};

export type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponse =
  GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponses[keyof GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponses];

export type PostApiPublicV1ZendeskWebhooksIngestByTenantIdData = {
  body?: never;
  path: {
    /**
     * Tenant Id
     */
    tenant_id: number;
  };
  query?: never;
  url: "/api/public/v1/zendesk/webhooks/ingest/{tenant_id}";
};

export type PostApiPublicV1ZendeskWebhooksIngestByTenantIdErrors = {
  /**
   * Validation Error
   */
  422: HttpValidationError;
};

export type PostApiPublicV1ZendeskWebhooksIngestByTenantIdError =
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdErrors[keyof PostApiPublicV1ZendeskWebhooksIngestByTenantIdErrors];

export type PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponses = {
  /**
   * Successful Response
   */
  200: ZendeskIngestResponseV1;
};

export type PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponse =
  PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponses[keyof PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponses];

export type GetPublicHealthData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/public/health";
};

export type GetPublicHealthResponses = {
  /**
   * Response Health Public Health Get
   *
   * Successful Response
   */
  200: "OK";
};

export type GetPublicHealthResponse =
  GetPublicHealthResponses[keyof GetPublicHealthResponses];

export type GetEdraPbOpenapiJsonData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/edra-pb-openapi.json";
};

export type GetEdraPbOpenapiJsonResponses = {
  /**
   * Response Get Edra Pb Openapi  Edra Pb Openapi Json Get
   *
   * Successful Response
   */
  200: {
    [key: string]: JsonOutput;
  };
};

export type GetEdraPbOpenapiJsonResponse =
  GetEdraPbOpenapiJsonResponses[keyof GetEdraPbOpenapiJsonResponses];

export type GetSdkOpenapiJsonData = {
  body?: never;
  path?: never;
  query?: never;
  url: "/sdk-openapi.json";
};

export type GetSdkOpenapiJsonResponses = {
  /**
   * Response Get Sdk Openapi  Sdk Openapi Json Get
   *
   * Successful Response
   */
  200: {
    [key: string]: JsonOutput;
  };
};

export type GetSdkOpenapiJsonResponse =
  GetSdkOpenapiJsonResponses[keyof GetSdkOpenapiJsonResponses];
